webpackJsonp([1],{

/***/ "+9YK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-video-player/src/player.vue

//
//
//
//
//
//

window.videojs = __webpack_require__("Dia2");
videojs = videojs.default || videojs;
/* harmony default export */ var player = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    },
    start: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    playsinline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    customEventName: {
      type: String,
      default: function _default() {
        return 'statechanged';
      }
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    initialize: function initialize() {

      // init
      var self = this;
      this.player = null;

      // videojs options
      var videoOptions = assign_default()({
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5'],
        plugins: {}
      }, this.options);

      // check sources
      /*
      if (!videoOptions.sources || !videoOptions.sources.length) {
        console.warn('Missing required option: "sources".')
        return false
      }
      */

      // ios fullscreen
      var playsinline = this.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      // emit event
      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(self.customEventName, values);
        }
      };

      // videoOptions
      // console.log(videoOptions)

      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.player = videojs(this.$el.children[0], videoOptions, function () {

        // player readied
        var _this = this;
        self.$emit('ready', self.player);

        // events
        var events = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
        for (var i = 0; i < events.length; i++) {
          (function (event) {
            _this.on(event, function () {
              emitPlayerState(event, true);
            });
          })(events[i]);
        }

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-video-player/src/player.vue

//
//
//
//
//
//

window.videojs = __webpack_require__("Dia2");
videojs = videojs.default || videojs;
/* harmony default export */ var src_player = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    },
    start: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    playsinline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    customEventName: {
      type: String,
      default: function _default() {
        return 'statechanged';
      }
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    initialize: function initialize() {

      // init
      var self = this;
      this.player = null;

      // videojs options
      var videoOptions = assign_default()({
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5'],
        plugins: {}
      }, this.options);

      // check sources
      /*
      if (!videoOptions.sources || !videoOptions.sources.length) {
        console.warn('Missing required option: "sources".')
        return false
      }
      */

      // ios fullscreen
      var playsinline = this.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      // emit event
      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(self.customEventName, values);
        }
      };

      // videoOptions
      // console.log(videoOptions)

      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.player = videojs(this.$el.children[0], videoOptions, function () {

        // player readied
        var _this = this;
        self.$emit('ready', self.player);

        // events
        var events = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
        for (var i = 0; i < events.length; i++) {
          (function (event) {
            _this.on(event, function () {
              emitPlayerState(event, true);
            });
          })(events[i]);
        }

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7f503b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-video-player/src/player.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('video',{staticClass:"video-js"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vue_video_player_src_player = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-video-player/src/player.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_player,
  vue_video_player_src_player,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var node_modules_vue_video_player_src_player = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+vEQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABoUlEQVRYhd2X4XHDIAyFM0JGYAQ2KCNkA3uDZIN4hGyQbtCOkBG8QbpBvMHXHyYXWQEM2P7R6s53ySGenh4CwW73Fw1wQAOcxdcAduugV+BB2h7ez6wV2HjAGrsC+6VZ64x74OTHrPez/n/nx7Ui5UsDtAroBrgC4ppIW5q5tK44gxHnUqwE45pL2fOZh/FaRSJdE8Dn0sxnMC8pRyn9bY3gAvtHYJscpi7iY4GmgsBhVgVg8A59AqjzPvdSIkKFe2jQ5qy9IEApEaWw0YNSIldAIJtIMoYCriEwS4Rpkbcp4OhezSAQDvBOoNtKgeiRrQgc9ODSGpjtFUxPRacH5S6InlYBAiVNKr4LvEN8n74TyA4s5qbPGabd6xDxMVT0dyX/KeZkhFNUhYrge14ddiDVEZUK15UIfAvMLoet7FznhcFl4fXJ7MUkKwqmSgmfyJfAGIKVnwBwisSd/KbTMr1VDTWF+1RCLge87v1H4EN8R8Lvhr4o8wCJPePeHyizwc+rfxcoIobxPaCv29qe74Z1AifIOMb+0fnfbtOg/9Z+ATM0R0488ywuAAAAAElFTkSuQmCC"

/***/ }),

/***/ "/4VV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/I+n":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT7mgLvov5vnkINAM3g8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0i5ZCE5Zyw5Yy66aaW6aG1LeavlOi1m+ivpuaDhe+8iOavlOi1m+mihOWRiu+8iS0tY29weS0zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUzLjAwMDAwMCwgLTcwNi4wMDAwMDApIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDU3Ni4wMDAwMDApIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIwLjUiPgogICAgICAgICAgICA8ZyBpZD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAuMDAwMDAwLCAxMjYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0i6aaW5Y+RIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNiI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0xNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMzLjAwMDAwMCwgNC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMC42Nzc0NjExLDMuMTc4NDA3MTMgTDEwLjY3NzQ2MTEsMi45MTI2MDE0MiBDMTAuNjI4MDA0LDIuOTEyMTExMDMgMTAuNTcwOTU5OSwyLjkxMTY2MjY4IDEwLjUwNjM2NjYsMi45MTEyNTczNiBDMTAuMjI3Mjg5OSwyLjkwOTUwNjE4IDkuODA4MjAzODMsMi45MDg1NjE1MSA5LjI0OTI5NjcsMi45MDg0MjUyNyBDOC4xMzA4NjQ2OCwyLjkwODE1MjY0IDYuNDUyOTgxMDYsMi45MTExMTY4MyA0LjIxNTc0MDA3LDIuOTE3MzE4MDYgQzQuMDM0NDY3NCwyLjkxNzgyMDUxIDMuODg3NzgyNzgsMy4wNjQ5MTIyOCAzLjg4Nzc4Mjc4LDMuMjQ2MTg4MDcgTDMuODg3NzA0MjYsMTEuMzM5MzUxNyBDMy44ODc3MDQyNiwxMS41MDk4Mzk0IDQuMDE3NTg2NywxMS42NTA2NzUgNC4xODQ4MzQ2LDExLjY2Njc2OTEgTDQuMTg0ODM0Niw0LjA5NzM2NDM0IEM0LjE4NDgzNDYsMy41OTE0MjYzOSA0LjU5MDc5NjU4LDMuMTc4NDA3MTMgNS4wOTU1MjYyOCwzLjE3ODQwNzEzIEwxMC42Nzc0NjExLDMuMTc4NDA3MTMgWiBNNC4xODQ4MzQ2LDEyLjgxNzg2NDUgTDMuNjYwNjkxNjgsMTIuODIxNTkyOSBDMy4xNTU5OTcyNCwxMi44MjE1OTI5IDIuNzUsMTIuNDA4NTUzNCAyLjc1LDExLjkwMjYzNzcgTDIuNzUsMi42Njg5NTUyMSBDMi43NSwyLjE2MzAzOTUxIDMuMTU1OTk3MjQsMS43NSAzLjY2MDY5MTY4LDEuNzUgTDEwLjkwNDQ3MzcsMS43NSBDMTEuNDA5MTY4MiwxLjc1IDExLjgxNTE2NTQsMi4xNjMwMzk1MSAxMS44MTUxNjU0LDIuNjY4OTU1MjEgTDExLjgxNTE2NTQsMy4xNzg0MDcxMyBMMTIuNTg5MzA4MywzLjE3ODQwNzEzIEwxMi41ODkzMDgzLDMuMjEzNDA3NjkgQzEyLjk3MTYwNjksMy4zMjMxNzkzMSAxMy4yNSwzLjY3ODQyOTI1IDEzLjI1LDQuMDk3MzY0MzQgTDEzLjI1LDEzLjMzMTA5OTIgQzEzLjI1LDEzLjgzNjk3NzggMTIuODQzOTgzOCwxNC4yNSAxMi4zMzkzMDgzLDE0LjI1IEw1LjA5NTUyNjI4LDE0LjI1IEM0LjU5MDgxNTg4LDE0LjI1IDQuMTg0ODM0NiwxMy44MzY5OTkzIDQuMTg0ODM0NiwxMy4zMzEwOTkyIEw0LjE4NDgzNDYsMTIuODE3ODY0NSBaIE05LjQwODA3MTQzLDcuNTY5MzA5MDYgTDkuNDA4MDcxNDMsNy4zOTM5NTUwOCBMOS4yNzg2NzU0NSw3LjU4MTQzMDI1IEw5LjMxMDg0MjMsNy42MDM4NDA0NCBDOS4zNDI4Njc5MSw3LjU5MjE0MTcxIDkuMzc1Mjc2ODcsNy41ODA2MzE1NSA5LjQwODA3MTQzLDcuNTY5MzA5MDYgWiBNMTAuMzEyMDU1MSw3LjMyNDMxMzM2IEMxMC4zMTkyNTQ1LDcuMzIyODA1OTMgMTAuMzI2NDY3NCw3LjMyMTMwNDUyIDEwLjMzMzY5MzksNy4zMTk4MDkxMyBMMTAuNDM5NDA1NSw3LjE3NzY0MzQzIEwxMC4zMzMyMTU2LDcuMDk5OTQ1ODEgQzEwLjMxNjkwNSw3LjEwMjk2NjkzIDEwLjMwMDY0OTgsNy4xMDYwMTk5NCAxMC4yODQ0NTAzLDcuMTA5MTA0ODkgTDEwLjMxMjA1NTEsNy4zMjQzMTMzNiBaIE04LjkwODA3MTQzLDguMDMwNDIwMzQgTDguOTA4MDcxNDMsNy4yMjE0MDQyNiBMOS4wNjk0MDUzNiw3LjE2MDIwNjY1IEM5LjQ4MzE0MTYzLDcuMDAzMjY3MTIgOS45NTIyNjI3MSw2Ljg3ODA1MzE4IDEwLjQ4MTM0Niw2Ljc4MTg0NzE3IEwxMC43NDA1MjQ1LDYuNzM0NzE5MzYgTDEwLjg0MTMzNzIsNy41MjA2NjI5MyBMMTAuNjAzNjQ1Miw3LjU2MDExMTA1IEMxMC4wOTA4MTczLDcuNjQ1MjIxNjEgOS42MzY2MTc3NSw3Ljc2MTMzODcgOS4yNDQ2ODc1OSw3LjkwNjA5NDM3IEw4LjkwODA3MTQzLDguMDMwNDIwMzQgWiBNOS4zODc2MjQ3OCwxMC4xMjA1Mjc5IEw4LjY3NjQ4NTA3LDkuODU2OTg3OTIgTDguODE3MTQ4LDkuNjAyNjAzMTUgQzkuMDM2NDY3MDEsOS4yMDU5NzExNyA5LjIzNzE1MTk0LDguODY5MzkwMzEgOS40MTk3MjA5NCw4LjU5MjQ1NjIzIEM5LjM0MDkxMDksOC42MTgzMzQ4MyA5LjI2MjA3NzQ1LDguNjQ1NzYwNTYgOS4xODMyMTk2NCw4LjY3NDczNDU2IEw4Ljg0Nyw4Ljc5ODI2ODY1IEw4Ljg0Nyw3Ljk5ODU3NTQ0IEw5LjAxMjYxOTUyLDcuOTM5MTkwMzcgQzkuNDk0NjQ1OTIsNy43NjYzNTM0MiA5Ljk1MDY1MjIxLDcuNjUwODMxIDEwLjM4NzI0NjgsNy41OTI3NTAwOSBMMTAuNTk2MjM2NCw3LjU2NDk0Nzg2IEwxMC44MDU4MzQ3LDguMjM4MTI4MzcgTDEwLjYwNTM4ODIsOC4zMjk1NTM3NSBDMTAuNTgwOTA2Niw4LjM0MDcxOTk4IDEwLjU1NjQ3MzcsOC4zNTcxODI4MyAxMC41NDA4NTg4LDguMzcwNTM3MiBDMTAuNDU4NDUzNSw4LjQ1MDAzNDA3IDEwLjM2MzI2Nyw4LjU2NDI4OTggMTAuMjU2Mjc4Niw4LjcxMjY2OTY0IEMxMC4zMTUxMzUyLDguNzA0OTY2NjIgMTAuMzgwMDQ4NSw4LjY5NjUyNDY0IDEwLjQ1Mjg0ODYsOC42ODcwODk0NiBMMTAuNDUzMjI0Nyw4LjY4NzA0MDQzIEwxMC42NjU1MTEzLDguNjU5NTI3MSBMMTAuODYxMzUxOCw5LjMzMTgxMTY1IEwxMC42NzM0NjE3LDkuNDI0NjUxNDYgQzEwLjY2MjE4ODEsOS40MzAyMjE5NyAxMC42NDk2MDY2LDkuNDQxMTc1MjEgMTAuNjM5Njc4OSw5LjQ1Mjk5MDMyIEMxMC40MDUwNjYxLDkuODAwNzY5MTggMTAuMTk4MDMzMiwxMC4yMDMxNzYxIDEwLjAyMjEyLDEwLjY1NTE2OTYgTDkuOTMyNzY4NiwxMC44ODQ3NTAxIEw5LjE3MjgzMTg3LDEwLjYwMTc2NiBMOS4yNzkzMjQ1MiwxMC4zNTkzMzg2IEM5LjMxNTQ0NjcxLDEwLjI3NzEwNzUgOS4zNTE1Mzg3OSwxMC4xOTc1MTE1IDkuMzg3NjI0NzgsMTAuMTIwNTI3OSBaIE04LjY5NjM1NzE0LDEwLjI3OTM2NjggTDguNzIzOTgwNjcsMTAuMjc5MzY2OCBMOC44MzUxNjg5MSwxMC4xNjgxNzg2IEw4LjcyMzk4MDY3LDEwLjA1Njk5MDQgTDguNjk2MzU3MTQsMTAuMDU2OTkwNCBMOC42OTYzNTcxNCwxMC4yNzkzNjY4IFogTTguMDYwNDI4NTcsMTAuMDU2OTkwNCBMNy44NTM1NzE0MywxMC4wNTY5OTA0IEw3Ljg1MzU3MTQzLDEwLjI3OTM2NjggTDguMDYwNDI4NTcsMTAuMjc5MzY2OCBMOC4wNjA0Mjg1NywxMC4wNTY5OTA0IFogTTcuMjI5ODU3MTQsMTAuMDU2OTkwNCBMNy4yMDIyMzM2MSwxMC4wNTY5OTA0IEw3LjA5MTA0NTM4LDEwLjE2ODE3ODYgTDcuMjAyMjMzNjEsMTAuMjc5MzY2OCBMNy4yMjk4NTcxNCwxMC4yNzkzNjY4IEw3LjIyOTg1NzE0LDEwLjA1Njk5MDQgWiBNOC4wNjA0Mjg1Nyw3LjMxODA0OTIgTDguMDYwNDI4NTcsNy4wOTk2OTYyNiBMNy44NTM1NzE0Myw3LjA5OTY5NjI2IEw3Ljg1MzU3MTQzLDcuMzE4MDQ5MiBMOC4wNjA0Mjg1Nyw3LjMxODA0OTIgWiBNNy4xMjQsNy4wOTk2OTYyNiBMNy4wOTIzNTI5NCw3LjA5OTY5NjI2IEw2Ljk4MzE3NjQ3LDcuMjA4ODcyNzMgTDcuMDkyMzUyOTQsNy4zMTgwNDkyIEw3LjEyNCw3LjMxODA0OTIgTDcuMTI0LDcuMDk5Njk2MjYgWiBNOC44MTAzNTcxNCw3LjMxODA0OTIgTDguODQyMDA0Miw3LjMxODA0OTIgTDguOTUxMTgwNjcsNy4yMDg4NzI3MyBMOC44NDIwMDQyLDcuMDk5Njk2MjYgTDguODEwMzU3MTQsNy4wOTk2OTYyNiBMOC44MTAzNTcxNCw3LjMxODA0OTIgWiBNOC4zNTM1NzE0Myw5Ljc3OTM2Njg0IEw5LjE5NjM1NzE0LDkuNzc5MzY2ODQgTDkuMTk2MzU3MTQsMTAuNTU2OTkwNCBMNi43Mjk4NTcxNCwxMC41NTY5OTA0IEw2LjcyOTg1NzE0LDkuNzc5MzY2ODQgTDcuNTYwNDI4NTcsOS43NzkzNjY4NCBMNy41NjA0Mjg1Nyw3LjU5OTY5NjI2IEw2LjYyNCw3LjU5OTY5NjI2IEw2LjYyNCw2LjgxODA0OTIgTDkuMzEwMzU3MTQsNi44MTgwNDkyIEw5LjMxMDM1NzE0LDcuNTk5Njk2MjYgTDguMzUzNTcxNDMsNy41OTk2OTYyNiBMOC4zNTM1NzE0Myw5Ljc3OTM2Njg0IFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC4wMDAwMDAsIDguMDAwMDAwKSBzY2FsZSgtMSwgLTEpIHRyYW5zbGF0ZSgtOC4wMDAwMDAsIC04LjAwMDAwMCkgIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "/tlY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "/w0U":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1JB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "33d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5mmK":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "5p9W":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+54Ot6Zeo6LWb5LqL5YiH5o2iLeW3pjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSLlhazlhbHpppbpobUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00My4wMDAwMDAsIC01MTEuMDAwMDAwKSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0i54Ot6Zeo6LWb5LqLIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNDQyLjAwMDAwMCkiIHN0cm9rZT0iIzk5OTk5OSIgc3Ryb2tlLXdpZHRoPSIxLjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQ1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ0LjAwMDAwMCwgMjAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSLng63pl6jotZvkuovliIfmjaIt5bemIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjAwMDAwMCwgMTEuMDAwMDAwKSBzY2FsZSgtMSwgMSkgcm90YXRlKC0xODAuMDAwMDAwKSB0cmFuc2xhdGUoLTMuMDAwMDAwLCAtMTEuMDAwMDAwKSAiIHBvaW50cz0iNiAxNyAwIDExIDYgNSI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "6qhd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vjs-custom-skin > .video-js {\n  width: 100%;\n  font-family: \"PingFang SC\",\"Helvetica Neue\",\"Hiragino Sans GB\",\"Segoe UI\",\"Microsoft YaHei\",\"\\5FAE\\8F6F\\96C5\\9ED1\",sans-serif;\n}\n\n.vjs-custom-skin > .video-js .vjs-menu-button-inline.vjs-slider-active,.vjs-custom-skin > .video-js .vjs-menu-button-inline:focus,.vjs-custom-skin > .video-js .vjs-menu-button-inline:hover,.video-js.vjs-no-flex .vjs-menu-button-inline {\n  width: 10em\n}\n\n.vjs-custom-skin > .video-js .vjs-controls-disabled .vjs-big-play-button {\n  display: none!important\n}\n\n.vjs-custom-skin > .video-js .vjs-control {\n  width: 3em\n}\n\n.vjs-custom-skin > .video-js .vjs-control.vjs-live-control{\n  width: auto;\n  padding-left: .5em;\n  letter-spacing: .1em;\n}\n\n.vjs-custom-skin > .video-js .vjs-menu-button-inline:before {\n  width: 1.5em\n}\n\n.vjs-menu-button-inline .vjs-menu {\n  left: 3em\n}\n\n.vjs-paused.vjs-has-started.vjs-custom-skin > .video-js .vjs-big-play-button,.video-js.vjs-ended .vjs-big-play-button,.video-js.vjs-paused .vjs-big-play-button {\n  display: block\n}\n\n.vjs-custom-skin > .video-js .vjs-load-progress div,.vjs-seeking .vjs-big-play-button,.vjs-waiting .vjs-big-play-button {\n  display: none!important\n}\n\n.vjs-custom-skin > .video-js .vjs-mouse-display:after,.vjs-custom-skin > .video-js .vjs-play-progress:after {\n  padding: 0 .4em .3em\n}\n\n.video-js.vjs-ended .vjs-loading-spinner {\n  display: none;\n}\n\n.video-js.vjs-ended .vjs-big-play-button {\n  display: block !important;\n}\n\n.video-js.vjs-ended .vjs-big-play-button,.video-js.vjs-paused .vjs-big-play-button,.vjs-paused.vjs-has-started.vjs-custom-skin > .video-js .vjs-big-play-button {\n  display: block\n}\n\n.vjs-custom-skin > .video-js .vjs-big-play-button {\n  top: 50%;\n  left: 50%;\n  margin-left: -1.5em;\n  margin-top: -1em\n}\n\n.vjs-custom-skin > .video-js .vjs-big-play-button {\n  background-color: rgba(0,0,0,0.45);\n  font-size: 3.5em;\n   /*border-radius: 50%;*/\n  height: 2em !important;\n  line-height: 2em !important;\n  margin-top: -1em !important\n}\n\n.video-js:hover .vjs-big-play-button,.vjs-custom-skin > .video-js .vjs-big-play-button:focus,.vjs-custom-skin > .video-js .vjs-big-play-button:active {\n  background-color: rgba(36,131,213,0.9)\n}\n\n.vjs-custom-skin > .video-js .vjs-loading-spinner {\n  border-color: rgba(36,131,213,0.8)\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar2 {\n  background-color: #000000\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar {\n   /*background-color: rgba(0,0,0,0.3) !important;*/\n  color: #ffffff;\n  font-size: 14px\n}\n\n.vjs-custom-skin > .video-js .vjs-play-progress,.vjs-custom-skin > .video-js  .vjs-volume-level {\n  background-color: #2483d5\n}\n\n.vjs-custom-skin > .video-js .vjs-play-progress:before {\n  top: -0.3em;\n}\n\n.vjs-custom-skin > .video-js .vjs-progress-control:hover .vjs-progress-holder {\n  font-size: 1.3em;\n}\n\n.vjs-menu-button-popup.vjs-volume-menu-button-vertical .vjs-menu {\n  left: 0em;\n}\n\n.vjs-custom-skin > .video-js .vjs-menu li {\n  padding: 0;\n  line-height: 2em;\n  font-size: 1.1em;\n  font-family: \"PingFang SC\",\"Helvetica Neue\",\"Hiragino Sans GB\",\"Segoe UI\",\"Microsoft YaHei\",\"\\5FAE\\8F6F\\96C5\\9ED1\",sans-serif;\n}\n\n.vjs-custom-skin > .video-js .vjs-time-tooltip,\n.vjs-custom-skin > .video-js .vjs-mouse-display:after, \n.vjs-custom-skin > .video-js .vjs-play-progress:after {\n  border-radius: 0;\n  font-size: 1em;\n  padding: 0;\n  width: 3em;\n  height: 1.5em;\n  line-height: 1.5em;\n  top: -3em;\n}\n\n.vjs-custom-skin > .video-js .vjs-menu-button-popup .vjs-menu {\n  width: 5em;\n  left: -1em;\n}\n\n.vjs-custom-skin > .video-js .vjs-menu-button-popup.vjs-volume-menu-button-vertical .vjs-menu {\n  left: 0;\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-resolution-button .vjs-menu {\n   /*order: 4;*/\n}\n\n /*排序顺序*/\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-play-control {\n  order: 0;\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control {\n  min-width: 1em;\n  padding: 0;\n  margin: 0 .1em;\n  text-align: center;\n  display: block;\n  order: 1;\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-playback-rate .vjs-playback-rate-value{\n  font-size: 1.2em;\n  line-height: 2.4;\n}\n\n.vjs-custom-skin > .video-js .vjs-progress-control.vjs-control {\n  order: 2;\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-volume-menu-button {\n  order: 3;\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-resolution-button {\n  order: 4;\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-resolution-button .vjs-resolution-button-label {\n  display: block;\n  line-height: 3em;\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-playback-rate {\n  order: 5;\n}\n\n.vjs-custom-skin > .video-js .vjs-control-bar .vjs-fullscreen-control {\n  order: 6;\n}\n", ""]);

// exports


/***/ }),

/***/ "6tqH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "8coM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Ping-Fang-SC-Regular.d979e7e.ttf";

/***/ }),

/***/ "8fWD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+54Ot6Zeo6LWb5LqL5YiH5o2iLeWPszwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSLlhazlhbHpppbpobUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjUuMDAwMDAwLCAtNTExLjAwMDAwMCkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9IueDremXqOi1m+S6iyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQ0Mi4wMDAwMDApIiBzdHJva2U9IiM5OTk5OTkiIHN0cm9rZS13aWR0aD0iMS4yIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCA0NS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC02IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NC4wMDAwMDAsIDIwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0i54Ot6Zeo6LWb5LqL5YiH5o2iLeWPsyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjg1LjAwMDAwMCwgMTEuMDAwMDAwKSByb3RhdGUoLTE4MC4wMDAwMDApIHRyYW5zbGF0ZSgtMjg1LjAwMDAwMCwgLTExLjAwMDAwMCkgIiBwb2ludHM9IjI4OCAxNyAyODIgMTEgMjg4IDUiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "9lt8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9uKV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AepO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AkLj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+UGF0aCA0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IuWQhOWcsOWMuummlumhtSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM1My4wMDAwMDAsIC00ODMuMDAwMDAwKSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0i6L+R5pyf6LWb5LqLIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNDY4LjAwMDAwMCkiIHN0cm9rZT0iIzk5OTk5OSIgc3Ryb2tlLXdpZHRoPSIxLjIiPgogICAgICAgICAgICA8ZyBpZD0idGl0bGXov5HmnJ/otZvkuosiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI5My4wMDAwMDAsIDEyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aC00IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NC4wMDAwMDAsIDEwLjAwMDAwMCkgcm90YXRlKC0xODAuMDAwMDAwKSB0cmFuc2xhdGUoLTY0LjAwMDAwMCwgLTEwLjAwMDAwMCkgIiBwb2ludHM9IjY3IDE2IDYxIDEwIDY3IDQiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "B9dR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("lvdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bo1r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bta1":
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),

/***/ "CMiz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dy88":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DyGf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "F/hE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("MBIH");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./font.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./font.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "F8MD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/PingFang-SC-Semibold.e9ad33e.otf";

/***/ }),

/***/ "FlER":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/goal.5f243e0.svg";

/***/ }),

/***/ "FoU3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GQND":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/advertisement.3e4c535.png";

/***/ }),

/***/ "HL9a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4Oj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "JJGD":
/***/ (function(module, exports) {

module.exports = Zepto;

/***/ }),

/***/ "JRsF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.6827e6b.gif";

/***/ }),

/***/ "JaZq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMnB4IiBoZWlnaHQ9IjE1cHgiIHZpZXdCb3g9IjAgMCAyIDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+UmVjdGFuZ2xlIENvcHkgMjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSLlhazlhbHpppbpobUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNS4wMDAwMDAsIC0zMDAuMDAwMDAwKSI+CiAgICAgICAgPGcgaWQ9IueDremXqOi1m+WMuiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDI4NS4wMDAwMDApIiBmaWxsPSIjRkYyNzUzIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5LTIiIHg9IjE1IiB5PSIxNSIgd2lkdGg9IjIiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "KQmM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "KXse":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABOklEQVRYhe2WwW2DQBBFKcElUII7sDuwOzAlpINQgjuADqADbwnpwL78P9JeNh2Qy640goWEeMFSwkhzAmYeoz9/N8u22EKFtXYPoCJ5WyIBVNba/Whzkt0aKSLHAQDJ1r/QkjyLyDF1qh4mBvA5SpcoPERHsosBjI9nA5jXpBCR91idxQFEpNBq76/c4gAkjQYAUK4KAKCc2vdZAH6cTc9Emu8ASb4FL+k/+zGALzLlZMWcyfwG4EzSAChFJPcf5ySvCmTwh8kApoooiLtzbrc6gHNuF2wbQBVpkovIxXvBITlAlg3U3gA4icglItqO5D34QdI1JFlPCNV4yIeum9wH/Kq23oAMyWsQrZ4WgI9wxP/9w+gZgJdfSMJ16eZVfUiZAE5qS8wA4OWXUgVRK1Wnznr0Wr7Fv40v1BPXGSr/GEEAAAAASUVORK5CYII="

/***/ }),

/***/ "Kukd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6qhd");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./custom-theme.css", function() {
			var newContent = require("!!../../css-loader/index.js!./custom-theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "LQgg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LWON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M5Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MBIH":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n@font-face {\n  font-family: 'Arial-Black';\n\n  src:  url(" + escape(__webpack_require__("oE0z")) + ") format('TrueType');\n}\n\n@font-face {\n  font-family: 'BigJohn';\n\n  src:  url(" + escape(__webpack_require__("wKp8")) + ") format('OpenType');\n}\n\n@font-face {\n  font-family: 'PingFangSC-Regular';\n\n  src:  url(" + escape(__webpack_require__("8coM")) + ") format('TrueType');\n}\n\n@font-face {\n  font-family: 'PingFangSC-Semibold';\n\n  src:  url(" + escape(__webpack_require__("F8MD")) + ") format('OpenType');\n}\n\n@font-face {\n  font-family: 'PingFangSC-Medium';\n\n  src:  url(" + escape(__webpack_require__("VNhC")) + ") format('TrueType');\n}\n", ""]);

// exports


/***/ }),

/***/ "MVr3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0xMy41NDE3NjIxLDcuODExOTE0MDEgTDExLjkxODY0MzIsOC45OTg0NDcyOSBDMTEuMzA5MDMwOCw5LjQ0Njc5MDQ5IDEwLjMwOTIzOSwxMC4xNzcwOTk1IDkuNjk4OTQwNzcsMTAuNjIxOTQgTDguMDc1ODIxOTQsMTEuODA5MzQ5IEM3LjQ2NDgzODA0LDEyLjI1NTk0MDggNi45NjYzMTM1OCwxMS44OTA3ODYzIDYuOTY2MzEzNTgsMTAuOTk3NjAyNiBMNi45NjYzMTM1OCw5LjUwODk2MzA4IEwwLjI3MDE3NjkzNiw5LjUwODk2MzA4IEMwLjEyMTM3MzkwMSw5LjUwODk2MzA4IC01LjE4ODgwOTM4ZS0wOSw5LjM1NzQ3MjEyIC01LjE4ODgwOTM4ZS0wOSw5LjE2NzQ1MTY2IEwtNS4xODg4MDkzOGUtMDksNC44MzIwMDc5IEMtNS4xODg4MDkzOGUtMDksNC42NDM3Mzg3OCAwLjEyMTM3MzkwMSw0LjQ5MDQ5NjQ4IDAuMjcwMTc2OTM2LDQuNDkwNDk2NDggTDYuOTY2MzEzNTgsNC40OTA0OTY0OCBMNi45NjYzMTM1OCwzLjAwMTg1Njk0IEM2Ljk2NjMxMzU4LDIuMTA5NTQ4ODggNy40NjQ4MzgwNCwxLjc0NDM5NDM2IDguMDc1ODIxOTQsMi4xOTAxMTA1NSBMOS42OTg5NDA3NywzLjM3NzUxOTUgQzEwLjMwOTIzOSwzLjgyNDExMTM2IDExLjMwOTAzMDgsNC41NTQ0MjA0MSAxMS45MTg2NDMyLDUuMDAwMTM2NiBMMTMuNTQxNzYyMSw2LjE4ODQyMTI0IEMxNC4xNTI3NDYsNi42MzUwMTMxIDE0LjE1Mjc0Niw3LjM2NTMyMjE0IDEzLjU0MTc2MjEsNy44MTE5MTQwMSBaIiBpZD0iYXJyb3ciIGZpbGw9IiNGRTI3NTQiIGZpbGwtcnVsZT0ibm9uemVybyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4wMDAwMDAsIDcuMDAwMDAwKSByb3RhdGUoOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTcuMDAwMDAwLCAtNy4wMDAwMDApICI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "Mjwm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pk-miss.79d70fb.svg";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/configInfo.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


var configInfo_configInfo = {
    routerBase: '/laurelsmobile/',
    Laurels_URL: "https://league.sportdata.cn/laurels",
    //Laurels_URL:"http://127.0.0.1:8080/laurels"
    orgCode: '',
    orgName: '',
    isAdvertisementShow: false
};

/* harmony default export */ var src_configInfo = (configInfo_configInfo);
// EXTERNAL MODULE: external "jWeixin"
var external__jWeixin_ = __webpack_require__("ebTe");
var external__jWeixin__default = /*#__PURE__*/__webpack_require__.n(external__jWeixin_);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/js/common/api.js



var _serviceModule;



var urlPrefix = src_configInfo.Laurels_URL;

var serviceModule = (_serviceModule = {
  getWechatShareInfo: function getWechatShareInfo() {
    return {
      url: urlPrefix + '/wechat/sharewithfriend',
      method: 'post'
    };
  },
  getImgAsset: function getImgAsset(assetId) {
    return {
      url: urlPrefix + '/resource/img?img=' + assetId,
      method: 'get'
    };
  },
  getLeagueBasic: function getLeagueBasic(leagueId) {
    return {
      url: urlPrefix + '/leagueinfo/basic/' + leagueId,
      method: 'get'
    };
  },
  getLeagueMatches: function getLeagueMatches(leagueId, offset, length, finish) {
    return {
      url: urlPrefix + '/leagueinfo/matches/' + leagueId + '?offset=' + offset + '&length=' + length + '&finish=' + finish,
      method: 'get'
    };
  },
  getRoundMatches: function getRoundMatches(leagueId, roundId, offset, length) {
    return {
      url: urlPrefix + '/leagueinfo/matches/' + leagueId + '/' + roundId + '?offset=' + offset + '&length=' + length,
      method: 'get'
    };
  },
  getLeagueShooters: function getLeagueShooters(leagueId, offset, length) {
    return {
      url: urlPrefix + '/leagueinfo/shooters/' + leagueId + '?offset=' + offset + '&length=' + length,
      method: 'get'
    };
  },
  getHotLeagues: function getHotLeagues() {
    return {
      url: urlPrefix + '/api/v1/publicIndex/listHotLeague',
      method: 'get'
    };
  },
  getLeagueMatchesAssets: function getLeagueMatchesAssets(leagueId, offset, length) {
    return {
      url: urlPrefix + '/leagueinfo/matches_assets/' + leagueId + '?offset=' + offset + '&length=' + length,
      method: 'get'
    };
  },
  getLeagueByOrgCodeAndName: function getLeagueByOrgCodeAndName(orgCode) {
    return {
      url: urlPrefix + '/api/v1/league/getLeagueByOrgCodeAndName/' + orgCode,
      method: 'get'
    };
  },
  getAllHotRegion: function getAllHotRegion() {
    return {
      url: urlPrefix + '/api/v1/hotRegion/getAllHotRegion',
      method: 'get'
    };
  },
  getLeagueTeams: function getLeagueTeams(leagueId) {
    return {
      url: urlPrefix + '/api/v1/leagueTeam/' + leagueId,
      method: 'get'
    };
  },
  getIndex: function getIndex(regionCode) {
    return {
      url: urlPrefix + '/api/v1/index/' + regionCode,
      method: 'get'
    };
  },
  getIndexLeague: function getIndexLeague(leagueId) {
    return {
      url: urlPrefix + '/api/v1/index/league/' + leagueId,
      method: 'get'
    };
  },
  getHotAreaLeagueCount: function getHotAreaLeagueCount(regionCode) {
    return {
      url: urlPrefix + '/api/v1/publicIndex/getHotAreaLeagueCount/' + regionCode,
      method: 'get'
    };
  },
  getLeagueCountIndex: function getLeagueCountIndex(regionCode) {
    return {
      url: urlPrefix + '/api/v1/publicIndex/getLeagueCountIndex/' + regionCode,
      method: 'get'
    };
  },
  geoLatLngToCityInfo: function geoLatLngToCityInfo() {
    return {
      url: urlPrefix + '/baidu/geoLatLngToCityInfo',
      method: 'post'
    };
  },
  getLeagueTable: function getLeagueTable(leagueId) {
    return {
      url: urlPrefix + '/leagueinfo/' + leagueId + '/table',
      method: 'get'
    };
  }
}, defineProperty_default()(_serviceModule, 'getImgAsset', function getImgAsset(assetId) {
  return {
    url: urlPrefix + '/resource/img?img=' + assetId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLeagueBasic', function getLeagueBasic(leagueId) {
  return {
    url: urlPrefix + '/leagueinfo/basic/' + leagueId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLeagueMatches', function getLeagueMatches(leagueId, offset, length, finish) {
  return {
    url: urlPrefix + '/leagueinfo/matches/' + leagueId + '?offset=' + offset + '&length=' + length + '&finish=' + finish,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLeagueShooters', function getLeagueShooters(leagueId, offset, length) {
  return {
    url: urlPrefix + '/leagueinfo/shooters/' + leagueId + '?offset=' + offset + '&length=' + length,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLeagueMatchesAssets', function getLeagueMatchesAssets(leagueId, offset, length) {
  return {
    url: urlPrefix + '/leagueinfo/matches_assets/' + leagueId + '?offset=' + offset + '&length=' + length,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLeagueByOrgCodeAndName', function getLeagueByOrgCodeAndName(orgCode) {
  return {
    url: urlPrefix + '/api/v1/league/getLeagueByOrgCodeAndName/' + orgCode,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getAllHotRegion', function getAllHotRegion() {
  return {
    url: urlPrefix + '/api/v1/hotRegion/getAllHotRegion',
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLeagueTeams', function getLeagueTeams(leagueId) {
  return {
    url: urlPrefix + '/api/v1/leagueTeam/' + leagueId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getIndex', function getIndex(regionCode) {
  return {
    url: urlPrefix + '/api/v1/index/' + regionCode,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLeagueTable', function getLeagueTable(leagueId) {
  return {
    url: urlPrefix + '/leagueinfo/' + leagueId + '/table',
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLeagueData', function getLeagueData(leagueId) {
  return {
    url: urlPrefix + '/leagueinfo/data/' + leagueId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getImgAssetById', function getImgAssetById(assetId) {
  return {
    url: urlPrefix + '/hagkFile/show?assetId=' + assetId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getMatchInfoById', function getMatchInfoById(matchId) {
  return {
    url: urlPrefix + '/match/getMatchInfoById/' + matchId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getRosterMatchInfo', function getRosterMatchInfo(matchId, homeTeamId, visitTeamId) {
  return {
    url: urlPrefix + '/match/getRosterMatchInfo/' + matchId + '/' + homeTeamId + '/' + visitTeamId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getLineUpByMatchIdAndTeamId', function getLineUpByMatchIdAndTeamId(matchId, teamId) {
  return {
    url: urlPrefix + '/match/getLineUpByMatchIdAndTeamId/' + matchId + '/' + teamId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getSubstitutionByMatchIdAndTeamId', function getSubstitutionByMatchIdAndTeamId(matchId, teamId) {
  return {
    url: urlPrefix + '/match/getSubstitutionByMatchIdAndTeamId/' + matchId + '/' + teamId,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getMatchAssetsByMatchId', function getMatchAssetsByMatchId(matchId, type) {
  return {
    url: urlPrefix + '/match/getMatchAssetByMatchId/' + matchId + '?type=' + type,
    method: 'get'
  };
}), defineProperty_default()(_serviceModule, 'getMatchList', function getMatchList(orgCode, leagueId, offset, length) {
  if (leagueId) {
    return {
      url: urlPrefix + '/api/v1/match/list/' + orgCode + '?leagueId=' + leagueId + '&offset=' + offset + '&length=' + length,
      method: 'get'
    };
  } else {
    return {
      url: urlPrefix + '/api/v1/match/list/' + orgCode + '?offset=' + offset + '&length=' + length,
      method: 'get'
    };
  }
}), defineProperty_default()(_serviceModule, 'getLeagueList', function getLeagueList(orgCode) {
  return {
    url: urlPrefix + '/api/v1/league/list/' + orgCode,
    method: 'get'
  };
}), _serviceModule);

var ApiSetting = extends_default()({}, serviceModule);

/* harmony default export */ var api = (ApiSetting);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/base64-js/index.js
var base64_js = __webpack_require__("EKta");
var base64_js_default = /*#__PURE__*/__webpack_require__.n(base64_js);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/state.js
// state.js
var test = "testMsg";
// CONCATENATED MODULE: ./src/store/index.js
// index.js




vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var appStore = new vuex_esm["a" /* default */].Store({
    state: {
        arrangeTab: "league-1",
        leagueBasicInfo: {},
        eventHub: null,
        landingUrl: null
    },
    getters: {
        getArrangeTab: function getArrangeTab(state) {
            return state.arrangeTab;
        },
        getLeagueBasicInfo: function getLeagueBasicInfo(state) {
            return state.leagueBasicInfo;
        },
        getEventHub: function getEventHub(state) {
            return state.eventHub;
        },
        getLandingUrl: function getLandingUrl(state) {
            return state.landingUrl;
        }
    },
    mutations: {
        updateArrangeTab: function updateArrangeTab(state, payload) {
            state.arrangeTab = payload;
        },
        updateLeagueBasicInfo: function updateLeagueBasicInfo(state, payload) {
            state.leagueBasicInfo = payload;
        },
        updateEventHub: function updateEventHub(state, payload) {
            state.eventHub = payload;
        },
        updateLandingUrl: function updateLandingUrl(state, payload) {
            state.landingUrl = payload;
        }
    },
    actions: {}
});
/* harmony default export */ var store = (appStore);
// CONCATENATED MODULE: ./src/js/common/http.js











function str2ByteArr(str) {
    var bytes = new Array();
    var len, c;
    len = str.length;
    for (var i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if (c >= 0x010000 && c <= 0x10FFFF) {
            bytes.push(c >> 18 & 0x07 | 0xF0);
            bytes.push(c >> 12 & 0x3F | 0x80);
            bytes.push(c >> 6 & 0x3F | 0x80);
            bytes.push(c & 0x3F | 0x80);
        } else if (c >= 0x000800 && c <= 0x00FFFF) {
            bytes.push(c >> 12 & 0x0F | 0xE0);
            bytes.push(c >> 6 & 0x3F | 0x80);
            bytes.push(c & 0x3F | 0x80);
        } else if (c >= 0x000080 && c <= 0x0007FF) {
            bytes.push(c >> 6 & 0x1F | 0xC0);
            bytes.push(c & 0x3F | 0x80);
        } else {
            bytes.push(c & 0xFF);
        }
    }
    return bytes;
}

axios_default.a.interceptors.request.use(function (config) {
    //store.commit('UPDATE_LOADING',true) //显示loading
    return config;
}, function (error) {
    return promise_default.a.reject(error);
});

axios_default.a.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return promise_default.a.resolve(error.response);
});

function errorState(response, resolve, reject) {
    reject(response);
    //store.commit('UPDATE_LOADING',false)  //隐藏loading
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        reject(response);
        return response;
        // 如果不需要除了data之外的数据，可以直接 return response.data
    } else {
        alert("网络异常");
    }
}

function successState(res, resolve, reject) {
    //store.commit('UPDATE_LOADING',false) //隐藏loading
    //统一判断后端返回的错误码
    resolve(res.data);
}
var http_httpServer = function httpServer(opts, data, header) {
    var Public = {//公共参数
        //'srAppid': ""
    };
    var httpDefaultOpts = { //http默认配置
        method: opts.method,
        baseURL: opts.url,
        url: "",
        timeout: 10000,
        params: assign_default()(Public, data),
        //data:qs.stringify(Object.assign(Public, data)),
        data: data,
        headers: opts.method == 'get' ? {
            // 'Authorization': 'Basic ' +   Base64.fromByteArray(str2ByteArr("HagkCloudAdmin:Cl0ud@2o17"))
            // 'X-Requested-With': 'XMLHttpRequest',
            // "Accept": "application/json",
            // "Content-Type": "application/json; charset=UTF-8"
        } : header ? header : {
            //'X-Requested-With': 'XMLHttpRequest',
            //'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Content-Type': 'application/json; charset=UTF-8'
        },
        transformRequest: [function (data) {
            // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
            return stringify_default()(data);
            // if(opts.method=='post' && header && header['Content-Type'] && header['Content-Type'].indexOf('application/json') >= 0) {
            //     return JSON.stringify(data);
            // }
            // return qs.stringify(Object.assign(Public, data));
        }],
        paramsSerializer: function paramsSerializer(params) {
            return lib_default.a.stringify(params, { arrayFormat: 'brackets' });
        }
    };

    if (opts.method == 'get') {
        delete httpDefaultOpts.data;
    } else {
        delete httpDefaultOpts.params;
    }

    var promise = new promise_default.a(function (resolve, reject) {
        axios_default()(httpDefaultOpts).then(function (res) {
            successState(res, resolve, reject);
        }).catch(function (response) {
            errorState(response, resolve, reject);
        });
    });
    return promise;
};

/* harmony default export */ var http = (http_httpServer);
// CONCATENATED MODULE: ./src/js/common/utils.js
/**
 * Created by zhangdong on 2018/1/5.
 */





// 微信分享配置
var utils_wxShareConfig = function wxShareConfig(_ref, success, fail, toShareUrl) {
    var title = _ref.title,
        desc = _ref.desc,
        link = _ref.link,
        imgUrl = _ref.imgUrl;

    var obj = { 'url': link
        // console.log("wxShareConfig " + link)
    };http(api.getWechatShareInfo(), obj).then(function (res) {
        if (res.status == true) {
            external__jWeixin__default.a.config({
                debug: false,
                appId: res.result.appId,
                timestamp: res.result.timestamp,
                nonceStr: res.result.nonceStr,
                signature: res.result.signature,
                jsApiList: ['showMenuItems', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            });

            var shareLink = toShareUrl ? toShareUrl : link;
            external__jWeixin__default.a.ready(function () {
                // “分享给朋友”
                external__jWeixin__default.a.onMenuShareAppMessage({
                    title: title,
                    desc: desc,
                    link: shareLink,
                    imgUrl: imgUrl,
                    success: success,
                    fail: fail
                });
                // “分享到朋友圈”
                external__jWeixin__default.a.onMenuShareTimeline({
                    title: title,
                    link: shareLink,
                    imgUrl: imgUrl,
                    success: success,
                    fail: fail
                });

                // 分享到QQ
                external__jWeixin__default.a.onMenuShareQQ({
                    title: title,
                    desc: desc,
                    link: shareLink,
                    imgUrl: imgUrl,
                    success: success,
                    fail: fail
                });
                // 分享到腾讯微博
                external__jWeixin__default.a.onMenuShareWeibo({
                    title: title,
                    desc: desc,
                    link: shareLink,
                    imgUrl: imgUrl,
                    success: success,
                    fail: fail
                });
                // 分享到QQ空间
                external__jWeixin__default.a.onMenuShareQZone({
                    title: title,
                    desc: desc,
                    link: shareLink,
                    imgUrl: imgUrl,
                    success: success,
                    fail: fail
                });

                external__jWeixin__default.a.showMenuItems({
                    menuList: ["menuItem:copyUrl", 'menuItem:share:appMessage', 'menuItem:share:timeline', "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", 'menuItem:share:QZone', "menuItem:profile"],
                    success: function success() {
                        console.log('yes');
                    },
                    fail: function fail(res) {
                        console.log('no');
                    }
                });
            });
        }
    }, function (error) {});
};
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/live_player.vue
//
//
//
//
//

var cyberObj = __webpack_require__("eqZL");
var cyberplayer = cyberObj.cyberplayer;

/* harmony default export */ var live_player = ({
    data: function data() {
        return {
            player: {},
            websocket: {}
        };
    },

    mounted: function mounted() {
        var url = this.$route.query.url;
        this.previewVideo(url);
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        //            if (this.websocket && typeof this.websocket.close == 'function') {
        //                this.websocket.close()
        //            }
        next(true);
    },

    methods: {
        startLiveWS: function startLiveWS(url, ak, thumbnail, sid) {
            //                var vcomp = this
            //                this.websocket = new WebSocket(Constant.api_web_socket + sid)
            //                this.websocket.onopen = function (evnt) {
            //                    console.log("websocket: on open")
            //                    vcomp.previewVideo(url, ak, thumbnail)
            //                };
            //                this.websocket.onmessage = function (evnt) {
            //                    console.log("websocket: on message")
            //                    alert(evnt.data)
            //                };
            //                this.websocket.onerror = function (evnt) {
            //                    console.log("websocket: on error")
            //                    vcomp.previewVideo(url, ak, thumbnail)
            //                };
            //                this.websocket.onclose = function (evnt) {
            //                    console.log("websocket: on close")
            //                }
        },
        previewVideo: function previewVideo(url, ak, thumbnail) {
            if (ak) {
                this.player = cyberplayer("player_container").setup({
                    width: document.body.clientWidth,
                    height: document.body.clientHeight,
                    stretching: "none",
                    file: url,
                    image: thumbnail,
                    hls: { reconnecttime: 5 },
                    autostart: true,
                    repeat: false,
                    volume: 100,
                    controls: 'over',
                    ak: ak
                });
            } else {
                this.player = cyberplayer("player_container").setup({
                    width: document.body.clientWidth,
                    height: document.body.clientHeight,
                    stretching: "uniform",
                    file: url,
                    type: 'mp4',
                    autostart: true,
                    repeat: false,
                    volume: 100,
                    controls: true,
                    ak: '3e1307fe48cd4adc91b87c58409758e8'
                });
            }

            this.player.on('setupError', function () {
                alert('视频播放失败，请稍后再试。');
            });
            this.player.on('error', function () {
                alert('视频播放失败，请稍后再试。');
            });

            this.player.onLiveStop(function () {
                alert("直播已结束，谢谢观看");
            });
            this.player.onNoLiveStream(function () {
                alert("直播已结束，谢谢观看");
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/live_player.vue
//
//
//
//
//

var live_player_cyberObj = __webpack_require__("eqZL");
var live_player_cyberplayer = live_player_cyberObj.cyberplayer;

/* harmony default export */ var views_live_player = ({
    data: function data() {
        return {
            player: {},
            websocket: {}
        };
    },

    mounted: function mounted() {
        var url = this.$route.query.url;
        this.previewVideo(url);
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        //            if (this.websocket && typeof this.websocket.close == 'function') {
        //                this.websocket.close()
        //            }
        next(true);
    },

    methods: {
        startLiveWS: function startLiveWS(url, ak, thumbnail, sid) {
            //                var vcomp = this
            //                this.websocket = new WebSocket(Constant.api_web_socket + sid)
            //                this.websocket.onopen = function (evnt) {
            //                    console.log("websocket: on open")
            //                    vcomp.previewVideo(url, ak, thumbnail)
            //                };
            //                this.websocket.onmessage = function (evnt) {
            //                    console.log("websocket: on message")
            //                    alert(evnt.data)
            //                };
            //                this.websocket.onerror = function (evnt) {
            //                    console.log("websocket: on error")
            //                    vcomp.previewVideo(url, ak, thumbnail)
            //                };
            //                this.websocket.onclose = function (evnt) {
            //                    console.log("websocket: on close")
            //                }
        },
        previewVideo: function previewVideo(url, ak, thumbnail) {
            if (ak) {
                this.player = live_player_cyberplayer("player_container").setup({
                    width: document.body.clientWidth,
                    height: document.body.clientHeight,
                    stretching: "none",
                    file: url,
                    image: thumbnail,
                    hls: { reconnecttime: 5 },
                    autostart: true,
                    repeat: false,
                    volume: 100,
                    controls: 'over',
                    ak: ak
                });
            } else {
                this.player = live_player_cyberplayer("player_container").setup({
                    width: document.body.clientWidth,
                    height: document.body.clientHeight,
                    stretching: "uniform",
                    file: url,
                    type: 'mp4',
                    autostart: true,
                    repeat: false,
                    volume: 100,
                    controls: true,
                    ak: '3e1307fe48cd4adc91b87c58409758e8'
                });
            }

            this.player.on('setupError', function () {
                alert('视频播放失败，请稍后再试。');
            });
            this.player.on('error', function () {
                alert('视频播放失败，请稍后再试。');
            });

            this.player.onLiveStop(function () {
                alert("直播已结束，谢谢观看");
            });
            this.player.onNoLiveStream(function () {
                alert("直播已结束，谢谢观看");
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392b678a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/live_player.vue
var live_player_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"broadcast_player"}},[_c('div',{attrs:{"id":"player_container"}})])}]
var esExports = { render: live_player_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_live_player = (esExports);
// CONCATENATED MODULE: ./src/views/live_player.vue
function injectStyle (ssrContext) {
  __webpack_require__("6tqH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-392b678a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  views_live_player,
  selectortype_template_index_0_src_views_live_player,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_live_player = (Component.exports);

// EXTERNAL MODULE: external "Zepto"
var external__Zepto_ = __webpack_require__("JJGD");
var external__Zepto__default = /*#__PURE__*/__webpack_require__.n(external__Zepto_);

// CONCATENATED MODULE: ./src/js/common/resize.js
/**
 * Created by wuchao on 2018/3/2.
 */
function resizeBaseDiv() {
  var height = window.innerHeight;
  $(".weui-tab__panel").css("padding-bottom", "0");
  $(".weui-tab__panel").css("overflow", "hidden");
  $(".weui-tab").parent().css("height", height);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/welcome.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var welcome = ({
  data: function data() {
    return {
      indexContentHeight: 0
    };
  },
  mounted: function mounted() {
    this.indexContentHeight = $(window).height();
    this.baiduGeoLocation();
    this.$nextTick(function () {
      resizeBaseDiv();
    });
  },
  methods: {
    baiduGeoLocation: function baiduGeoLocation() {
      var geolocation = new BMap.Geolocation();
      var self = this;
      // 开启SDK辅助定位
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var obj = { 'lat': r.point.lat, 'lng': r.point.lng };
          self.hagkHttp(self.hagkApi.geoLatLngToCityInfo(), obj).then(function (res) {
            if (res.status) {
              var resultObj = res.result;
              var code = "1" + resultObj.adCode;
              var reginCode = code;
              var regionName = resultObj.city + resultObj.district;
              self.getLeagueCountIndex(regionName, reginCode);
            } else {
              console.log("获取当前位置失败");
            }
          }, function (err) {
            console.log(err);
          });
        } else {
          console.log('failed' + this.getStatus());
        }
      });
    },
    getLeagueCountIndex: function getLeagueCountIndex(regionName, regionCode) {
      var self = this;
      this.hagkHttp(this.hagkApi.getLeagueCountIndex(regionCode), {}).then(function (res) {
        if (res.status) {
          var result = res.result;
          var orgName = result.orgName;
          var orgCode = result.orgCode;
          var leagueCount = result.leagueCount;
          if (result.orgCode == regionCode) {
            //if locatied place has league,location name is baidulocatied place name
            orgName = regionName;
          }
          if (leagueCount > 0) {
            self.$router.replace({ path: 'index_region', query: { regionCode: orgCode, regionName: orgName } });
          } else {
            self.$router.replace({ path: 'public_index', query: { regionName: orgName, regionCode: orgCode } });
          }
        } else {
          console.log("获取联赛数量异常");
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/welcome.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var views_welcome = ({
  data: function data() {
    return {
      indexContentHeight: 0
    };
  },
  mounted: function mounted() {
    this.indexContentHeight = $(window).height();
    this.baiduGeoLocation();
    this.$nextTick(function () {
      resizeBaseDiv();
    });
  },
  methods: {
    baiduGeoLocation: function baiduGeoLocation() {
      var geolocation = new BMap.Geolocation();
      var self = this;
      // 开启SDK辅助定位
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var obj = { 'lat': r.point.lat, 'lng': r.point.lng };
          self.hagkHttp(self.hagkApi.geoLatLngToCityInfo(), obj).then(function (res) {
            if (res.status) {
              var resultObj = res.result;
              var code = "1" + resultObj.adCode;
              var reginCode = code;
              var regionName = resultObj.city + resultObj.district;
              self.getLeagueCountIndex(regionName, reginCode);
            } else {
              console.log("获取当前位置失败");
            }
          }, function (err) {
            console.log(err);
          });
        } else {
          console.log('failed' + this.getStatus());
        }
      });
    },
    getLeagueCountIndex: function getLeagueCountIndex(regionName, regionCode) {
      var self = this;
      this.hagkHttp(this.hagkApi.getLeagueCountIndex(regionCode), {}).then(function (res) {
        if (res.status) {
          var result = res.result;
          var orgName = result.orgName;
          var orgCode = result.orgCode;
          var leagueCount = result.leagueCount;
          if (result.orgCode == regionCode) {
            //if locatied place has league,location name is baidulocatied place name
            orgName = regionName;
          }
          if (leagueCount > 0) {
            self.$router.replace({ path: 'index_region', query: { regionCode: orgCode, regionName: orgName } });
          } else {
            self.$router.replace({ path: 'public_index', query: { regionName: orgName, regionCode: orgCode } });
          }
        } else {
          console.log("获取联赛数量异常");
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2daeb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/welcome.vue
var welcome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"loader",style:({height: _vm.indexContentHeight + 'px'}),attrs:{"data-title":"智能赛事"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"loading_title"},[_vm._v("努力加载中...")])])}
var welcome_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"align":"center"}},[_c('img',{staticStyle:{"width":"80px","height":"80px","margin-top":"120px"},attrs:{"src":__webpack_require__("JRsF")}})])}]
var welcome_esExports = { render: welcome_render, staticRenderFns: welcome_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_welcome = (welcome_esExports);
// CONCATENATED MODULE: ./src/views/welcome.vue
function welcome_injectStyle (ssrContext) {
  __webpack_require__("dVp8")
}
var welcome_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var welcome___vue_template_functional__ = false
/* styles */
var welcome___vue_styles__ = welcome_injectStyle
/* scopeId */
var welcome___vue_scopeId__ = "data-v-0f2daeb4"
/* moduleIdentifier (server only) */
var welcome___vue_module_identifier__ = null
var welcome_Component = welcome_normalizeComponent(
  views_welcome,
  selectortype_template_index_0_src_views_welcome,
  welcome___vue_template_functional__,
  welcome___vue_styles__,
  welcome___vue_scopeId__,
  welcome___vue_module_identifier__
)

/* harmony default export */ var src_views_welcome = (welcome_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dfa359e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/view-box/index.vue
var view_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"weui-tab__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var view_box_staticRenderFns = []
var view_box_esExports = { render: view_box_render, staticRenderFns: view_box_staticRenderFns }
/* harmony default export */ var src_components_view_box = (view_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/view-box/index.vue
function view_box_injectStyle (ssrContext) {
  __webpack_require__("b8LD")
}
var view_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var view_box___vue_template_functional__ = false
/* styles */
var view_box___vue_styles__ = view_box_injectStyle
/* scopeId */
var view_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var view_box___vue_module_identifier__ = null
var view_box_Component = view_box_normalizeComponent(
  components_view_box,
  src_components_view_box,
  view_box___vue_template_functional__,
  view_box___vue_styles__,
  view_box___vue_scopeId__,
  view_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_view_box = (view_box_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main.vue








/* harmony default export */ var main = ({
  ready: function ready() {},

  computed: {},
  mounted: function mounted() {},
  data: function data() {
    return {
      defaultShareImg: 'url(' + __webpack_require__("7Otq") + ')',
      isIndex: true
    };
  },

  components: {
    ViewBox: vux_src_components_view_box
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/main.vue








/* harmony default export */ var selectortype_script_index_0_src_main = ({
  ready: function ready() {},

  computed: {},
  mounted: function mounted() {},
  data: function data() {
    return {
      defaultShareImg: 'url(' + __webpack_require__("7Otq") + ')',
      isIndex: true
    };
  },

  components: {
    ViewBox: vux_src_components_view_box
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52d54b7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main.vue
var main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('view-box',[_c('router-view',{attrs:{"transition":"fade","transition-mode":"out-in","keep-alive":""}})],1)],1)}
var main_staticRenderFns = []
var main_esExports = { render: main_render, staticRenderFns: main_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_main = (main_esExports);
// CONCATENATED MODULE: ./src/main.vue
function main_injectStyle (ssrContext) {
  __webpack_require__("33d8")
}
var main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var main___vue_template_functional__ = false
/* styles */
var main___vue_styles__ = main_injectStyle
/* scopeId */
var main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var main___vue_module_identifier__ = null
var main_Component = main_normalizeComponent(
  selectortype_script_index_0_src_main,
  selectortype_template_index_0_src_main,
  main___vue_template_functional__,
  main___vue_styles__,
  main___vue_scopeId__,
  main___vue_module_identifier__
)

/* harmony default export */ var src_main = (main_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f37d428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var flexbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var flexbox_staticRenderFns = []
var flexbox_esExports = { render: flexbox_render, staticRenderFns: flexbox_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (flexbox_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function flexbox_injectStyle (ssrContext) {
  __webpack_require__("M5Ib")
}
var flexbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flexbox___vue_template_functional__ = false
/* styles */
var flexbox___vue_styles__ = flexbox_injectStyle
/* scopeId */
var flexbox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox___vue_module_identifier__ = null
var flexbox_Component = flexbox_normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  flexbox___vue_template_functional__,
  flexbox___vue_styles__,
  flexbox___vue_scopeId__,
  flexbox___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = (flexbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e3872a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var flexbox_item_staticRenderFns = []
var flexbox_item_esExports = { render: flexbox_item_render, staticRenderFns: flexbox_item_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (flexbox_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flexbox_item___vue_template_functional__ = false
/* styles */
var flexbox_item___vue_styles__ = null
/* scopeId */
var flexbox_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox_item___vue_module_identifier__ = null
var flexbox_item_Component = flexbox_item_normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  flexbox_item___vue_template_functional__,
  flexbox_item___vue_styles__,
  flexbox_item___vue_scopeId__,
  flexbox_item___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = (flexbox_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e44a500","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("kAA/")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b138ba8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("cJYu")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f54f49b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039300f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("9lt8")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c3c9c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ac43c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
var button_tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-button-group"},[_vm._t("default")],2)}
var button_tab_staticRenderFns = []
var button_tab_esExports = { render: button_tab_render, staticRenderFns: button_tab_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab = (button_tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab.vue
function button_tab_injectStyle (ssrContext) {
  __webpack_require__("P7KP")
}
var button_tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab___vue_template_functional__ = false
/* styles */
var button_tab___vue_styles__ = button_tab_injectStyle
/* scopeId */
var button_tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab___vue_module_identifier__ = null
var button_tab_Component = button_tab_normalizeComponent(
  button_tab_button_tab,
  components_button_tab_button_tab,
  button_tab___vue_template_functional__,
  button_tab___vue_styles__,
  button_tab___vue_scopeId__,
  button_tab___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab = (button_tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350dcdc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-button-tab-item",class:_vm.classes,style:(_vm.style),attrs:{"href":"javascript:"},on:{"click":_vm.onItemClick}},[_vm._t("default")],2)}
var button_tab_item_staticRenderFns = []
var button_tab_item_esExports = { render: button_tab_item_render, staticRenderFns: button_tab_item_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab_item = (button_tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab_item___vue_template_functional__ = false
/* styles */
var button_tab_item___vue_styles__ = null
/* scopeId */
var button_tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab_item___vue_module_identifier__ = null
var button_tab_item_Component = button_tab_item_normalizeComponent(
  button_tab_button_tab_item,
  components_button_tab_button_tab_item,
  button_tab_item___vue_template_functional__,
  button_tab_item___vue_styles__,
  button_tab_item___vue_scopeId__,
  button_tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab_item = (button_tab_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var node_modules_object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(node_modules_object_assign);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/xscroll.js
var xscroll = __webpack_require__("WTNC");
var xscroll_default = /*#__PURE__*/__webpack_require__.n(xscroll);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pulldown.js
var pulldown = __webpack_require__("ypEt");
var pulldown_default = /*#__PURE__*/__webpack_require__.n(pulldown);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pullup.js
var pullup = __webpack_require__("qbvd");
var pullup_default = /*#__PURE__*/__webpack_require__.n(pullup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7769fa5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/scroller/index.vue
var scroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var scroller_staticRenderFns = []
var scroller_esExports = { render: scroller_render, staticRenderFns: scroller_staticRenderFns }
/* harmony default export */ var src_components_scroller = (scroller_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/scroller/index.vue
function scroller_injectStyle (ssrContext) {
  __webpack_require__("CMiz")
}
var scroller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scroller___vue_template_functional__ = false
/* styles */
var scroller___vue_styles__ = scroller_injectStyle
/* scopeId */
var scroller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroller___vue_module_identifier__ = null
var scroller_Component = scroller_normalizeComponent(
  components_scroller,
  src_components_scroller,
  scroller___vue_template_functional__,
  scroller___vue_styles__,
  scroller___vue_scopeId__,
  scroller___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_scroller = (scroller_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263730af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/divider/index.vue
var divider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vux-divider"},[_vm._t("default")],2)}
var divider_staticRenderFns = []
var divider_esExports = { render: divider_render, staticRenderFns: divider_staticRenderFns }
/* harmony default export */ var src_components_divider = (divider_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/divider/index.vue
function divider_injectStyle (ssrContext) {
  __webpack_require__("LWON")
}
var divider_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var divider___vue_template_functional__ = false
/* styles */
var divider___vue_styles__ = divider_injectStyle
/* scopeId */
var divider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var divider___vue_module_identifier__ = null
var divider_Component = divider_normalizeComponent(
  components_divider,
  src_components_divider,
  divider___vue_template_functional__,
  divider___vue_styles__,
  divider___vue_scopeId__,
  divider___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_divider = (divider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7829af00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("WZDK")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347cf7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("uWE6")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/spinner/spinner.js
var spinner = __webpack_require__("P7QF");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/spinner/index.vue
//
//
//
//


var types = ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral'];

/* harmony default export */ var components_spinner = ({
  name: 'spinner',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      Object(spinner["a" /* default */])(_this.$el, _this.type, _this.size);
    });
  },

  props: {
    type: {
      type: String,
      default: 'ios'
    },
    size: String
  },
  computed: {
    styles: function styles() {
      if (typeof this.size !== 'undefined' && this.size !== '28px') {
        return {
          width: this.size,
          height: this.size
        };
      }
    },
    className: function className() {
      var rs = {};
      for (var i = 0; i < types.length; i++) {
        rs['vux-spinner-' + types[i]] = this.type === types[i];
      }
      return rs;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/spinner/index.vue
//
//
//
//


var spinner_types = ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral'];

/* harmony default export */ var src_components_spinner = ({
  name: 'spinner',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      Object(spinner["a" /* default */])(_this.$el, _this.type, _this.size);
    });
  },

  props: {
    type: {
      type: String,
      default: 'ios'
    },
    size: String
  },
  computed: {
    styles: function styles() {
      if (typeof this.size !== 'undefined' && this.size !== '28px') {
        return {
          width: this.size,
          height: this.size
        };
      }
    },
    className: function className() {
      var rs = {};
      for (var i = 0; i < spinner_types.length; i++) {
        rs['vux-spinner-' + spinner_types[i]] = this.type === spinner_types[i];
      }
      return rs;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-030008d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/spinner/index.vue
var spinner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-spinner",class:_vm.className,style:(_vm.styles)})}
var spinner_staticRenderFns = []
var spinner_esExports = { render: spinner_render, staticRenderFns: spinner_staticRenderFns }
/* harmony default export */ var vux_src_components_spinner = (spinner_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/spinner/index.vue
function spinner_injectStyle (ssrContext) {
  __webpack_require__("jFSQ")
}
var spinner_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var spinner___vue_template_functional__ = false
/* styles */
var spinner___vue_styles__ = spinner_injectStyle
/* scopeId */
var spinner___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var spinner___vue_module_identifier__ = null
var spinner_Component = spinner_normalizeComponent(
  src_components_spinner,
  vux_src_components_spinner,
  spinner___vue_template_functional__,
  spinner___vue_styles__,
  spinner___vue_scopeId__,
  spinner___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_spinner = (spinner_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["a" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["a" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b3faf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/card/index.vue
var card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header && _vm.header.title)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header.title)},on:{"click":function($event){return _vm.$emit('on-click-header')}}}):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_c('div',{staticClass:"vux-card-content"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title)?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":"javascript:"},on:{"click":_vm.onClickFooter}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()]),_vm._v(" "),_vm._t("footer")],2)}
var card_staticRenderFns = []
var card_esExports = { render: card_render, staticRenderFns: card_staticRenderFns }
/* harmony default export */ var src_components_card = (card_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/card/index.vue
function card_injectStyle (ssrContext) {
  __webpack_require__("/4VV")
}
var card_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var card___vue_template_functional__ = false
/* styles */
var card___vue_styles__ = card_injectStyle
/* scopeId */
var card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var card___vue_module_identifier__ = null
var card_Component = card_normalizeComponent(
  components_card,
  src_components_card,
  card___vue_template_functional__,
  card___vue_styles__,
  card___vue_scopeId__,
  card___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_card = (card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("QlJb")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/matchSimple.vue




/* harmony default export */ var matchSimple = ({
  props: {
    matchInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    toMatchLive: function toMatchLive() {
      this.$router.push({
        path: '/match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId,
          currentTab: 'matchLiveTab'
        }
      });
    },
    viewMatch: function viewMatch() {
      this.$router.push({
        path: '/match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId,
          currentTab: 'matchScoresTab'
        }
      });
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      this.score = this.genScore();
    },
    genScore: function genScore() {
      var score = '';
      if (this.objInfo && this.objInfo.result) {
        var matchObj = this.objInfo.result;
        var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";

        score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
        score += "-";
        score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
      } else {

        score = "VS";
      }
      return score;
    }
  },
  data: function data() {
    return {
      score: "",
      objInfo: {}
    };
  },

  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/matchSimple.vue




/* harmony default export */ var league_matchSimple = ({
  props: {
    matchInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    toMatchLive: function toMatchLive() {
      this.$router.push({
        path: '/match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId,
          currentTab: 'matchLiveTab'
        }
      });
    },
    viewMatch: function viewMatch() {
      this.$router.push({
        path: '/match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId,
          currentTab: 'matchScoresTab'
        }
      });
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      this.score = this.genScore();
    },
    genScore: function genScore() {
      var score = '';
      if (this.objInfo && this.objInfo.result) {
        var matchObj = this.objInfo.result;
        var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";

        score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
        score += "-";
        score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
      } else {

        score = "VS";
      }
      return score;
    }
  },
  data: function data() {
    return {
      score: "",
      objInfo: {}
    };
  },

  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c761a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/matchSimple.vue
var matchSimple_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5px 10px"}},[_c('div',{staticStyle:{"display":"inline-block","justify-content":"center","width":"100%"}},[_c('flexbox',{attrs:{"gutter":0,"justify":"center"}},[_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"right","font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","letter-spacing":"0"},on:{"click":_vm.viewMatch}},[_vm._v("\n                    "+_vm._s(this.objInfo.homeTeamName)+"\n                ")])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/5}},[_c('div',{staticStyle:{"text-align":"center","font-family":"Arial-Black","font-size":"18px","color":"#FE2754","letter-spacing":"0"},on:{"click":_vm.toMatchLive}},[_vm._v("\n                    "+_vm._s(this.score)+"\n                ")]),_vm._v(" "),(_vm.objInfo.liveUrl && _vm.objInfo.liveUrl!='')?[_c('div',{staticStyle:{"text-align":"center","font-family":"Arial-Black","font-size":"14px","color":"#FE2754","letter-spacing":"0"},on:{"click":_vm.toMatchLive}},[_c('span',[_vm._v("回放")])])]:_vm._e()],2),_vm._v(" "),_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"left","font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","letter-spacing":"0"},on:{"click":_vm.viewMatch}},[_vm._v("\n                    "+_vm._s(this.objInfo.vistingTeamName)+"\n                ")])])],1)],1)])}
var matchSimple_staticRenderFns = []
var matchSimple_esExports = { render: matchSimple_render, staticRenderFns: matchSimple_staticRenderFns }
/* harmony default export */ var components_league_matchSimple = (matchSimple_esExports);
// CONCATENATED MODULE: ./src/components/league/matchSimple.vue
var matchSimple_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchSimple___vue_template_functional__ = false
/* styles */
var matchSimple___vue_styles__ = null
/* scopeId */
var matchSimple___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var matchSimple___vue_module_identifier__ = null
var matchSimple_Component = matchSimple_normalizeComponent(
  league_matchSimple,
  components_league_matchSimple,
  matchSimple___vue_template_functional__,
  matchSimple___vue_styles__,
  matchSimple___vue_scopeId__,
  matchSimple___vue_module_identifier__
)

/* harmony default export */ var src_components_league_matchSimple = (matchSimple_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/roundCard.vue









/* harmony default export */ var roundCard = ({
  props: {
    roundInfo: Object,
    leagueId: '',
    leagueBasicInfo: {}
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button,
    MatchSimple: src_components_league_matchSimple
  },
  mounted: function mounted() {

    this.reload();
  },

  methods: {
    reload: function reload() {
      this.title = this.genTitle();
      this.groups = this.roundInfo.groups;
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "小组赛第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    genTitle: function genTitle() {
      var title = this.getRoundName(this.roundInfo.type, this.roundInfo.number, this.roundInfo.title);

      return title;
    },
    viewRoundDetail: function viewRoundDetail() {

      this.$router.push({ path: "/round_report", query: { roundTitle: this.title, leagueTitle: this.leagueBasicInfo.title, leagueId: this.leagueId, roundId: this.roundInfo.id } });
    }
  },
  data: function data() {
    return {
      title: " ",
      groups: []
    };
  },

  watch: {
    roundInfo: function roundInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/roundCard.vue









/* harmony default export */ var league_roundCard = ({
  props: {
    roundInfo: Object,
    leagueId: '',
    leagueBasicInfo: {}
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button,
    MatchSimple: src_components_league_matchSimple
  },
  mounted: function mounted() {

    this.reload();
  },

  methods: {
    reload: function reload() {
      this.title = this.genTitle();
      this.groups = this.roundInfo.groups;
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "小组赛第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    genTitle: function genTitle() {
      var title = this.getRoundName(this.roundInfo.type, this.roundInfo.number, this.roundInfo.title);

      return title;
    },
    viewRoundDetail: function viewRoundDetail() {

      this.$router.push({ path: "/round_report", query: { roundTitle: this.title, leagueTitle: this.leagueBasicInfo.title, leagueId: this.leagueId, roundId: this.roundInfo.id } });
    }
  },
  data: function data() {
    return {
      title: " ",
      groups: []
    };
  },

  watch: {
    roundInfo: function roundInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14041386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/roundCard.vue
var roundCard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('img',{staticStyle:{"display":"inline-block","width":"16px","height":"16px"},attrs:{"src":__webpack_require__("fTZF")}}),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","font-family":"PingFangSC-Medium","font-size":"16px","color":"#333333","letter-spacing":"0"}},[_vm._v(_vm._s(this.title))])]),_vm._v(" "),_vm._l((this.groups),function(groupObj){return _c('div',[_c('div',{staticStyle:{"margin-top":"10px","font-family":"PingFangSC-Regular","font-size":"12px","color":"#999999","letter-spacing":"0"}},[_vm._v("\n            "+_vm._s(groupObj.cupGroupName?(groupObj.cupGroupName + "组"):"-")+"\n        ")]),_vm._v(" "),_vm._l((groupObj.matches),function(matchObj){return _c('div',[_c('MatchSimple',{attrs:{"matchInfo":matchObj}})],1)})],2)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"league-more",on:{"click":_vm.viewRoundDetail}},[_vm._v("本轮赛况")]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px","margin-right":"10px","background":"#F3F3F3","height":"1px","margin-top":"10px"}})],2)}
var roundCard_staticRenderFns = []
var roundCard_esExports = { render: roundCard_render, staticRenderFns: roundCard_staticRenderFns }
/* harmony default export */ var components_league_roundCard = (roundCard_esExports);
// CONCATENATED MODULE: ./src/components/league/roundCard.vue
function roundCard_injectStyle (ssrContext) {
  __webpack_require__("XzI9")
}
var roundCard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var roundCard___vue_template_functional__ = false
/* styles */
var roundCard___vue_styles__ = roundCard_injectStyle
/* scopeId */
var roundCard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var roundCard___vue_module_identifier__ = null
var roundCard_Component = roundCard_normalizeComponent(
  league_roundCard,
  components_league_roundCard,
  roundCard___vue_template_functional__,
  roundCard___vue_styles__,
  roundCard___vue_scopeId__,
  roundCard___vue_module_identifier__
)

/* harmony default export */ var src_components_league_roundCard = (roundCard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/matchSimpleUnstart.vue




/* harmony default export */ var matchSimpleUnstart = ({
  props: {
    matchInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    toMatchLive: function toMatchLive() {
      this.$router.push({
        path: '/match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId,
          currentTab: 'matchLiveTab'
        }
      });
    },
    viewMatch: function viewMatch() {
      this.$router.push({
        path: '/match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId,
          currentTab: 'matchScoresTab'
        }
      });
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      console.log(this.objInfo, '---------this.objInfo---------');
      this.objInfo.startTime = this.formatTime(this.matchInfo.startDate);
      this.title = this.genTitle();
      this.score = this.genScore();
    },
    genTitle: function genTitle() {
      var group = "";
      if (this.matchInfo && this.matchInfo.cupGroupName) {
        group = this.matchInfo.cupGroupName + "组";
      }
      var number = "";

      if (this.matchInfo && this.matchInfo.round) {
        number = this.getRoundName(this.matchInfo.round.type, this.matchInfo.round.number, this.matchInfo.round.title);
      }

      return group + (number != "" ? " " + number : "");
    },
    genScore: function genScore() {
      return "VS";
    },
    formatTime: function formatTime(time) {
      if (!time) return '';

      var date = new Date(parseInt(time));
      var hours = date.getHours();
      var minutes = date.getMinutes();
      if (hours >= 0 && hours <= 9) {
        hours = '0' + hours;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes;
      }
      return hours + ':' + minutes;
    }
  },
  data: function data() {
    return {
      title: "",
      score: "",
      objInfo: {}
    };
  },

  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/matchSimpleUnstart.vue




/* harmony default export */ var league_matchSimpleUnstart = ({
  props: {
    matchInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    toMatchLive: function toMatchLive() {
      this.$router.push({
        path: '/match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId,
          currentTab: 'matchLiveTab'
        }
      });
    },
    viewMatch: function viewMatch() {
      this.$router.push({
        path: '/match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId,
          currentTab: 'matchScoresTab'
        }
      });
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      console.log(this.objInfo, '---------this.objInfo---------');
      this.objInfo.startTime = this.formatTime(this.matchInfo.startDate);
      this.title = this.genTitle();
      this.score = this.genScore();
    },
    genTitle: function genTitle() {
      var group = "";
      if (this.matchInfo && this.matchInfo.cupGroupName) {
        group = this.matchInfo.cupGroupName + "组";
      }
      var number = "";

      if (this.matchInfo && this.matchInfo.round) {
        number = this.getRoundName(this.matchInfo.round.type, this.matchInfo.round.number, this.matchInfo.round.title);
      }

      return group + (number != "" ? " " + number : "");
    },
    genScore: function genScore() {
      return "VS";
    },
    formatTime: function formatTime(time) {
      if (!time) return '';

      var date = new Date(parseInt(time));
      var hours = date.getHours();
      var minutes = date.getMinutes();
      if (hours >= 0 && hours <= 9) {
        hours = '0' + hours;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes;
      }
      return hours + ':' + minutes;
    }
  },
  data: function data() {
    return {
      title: "",
      score: "",
      objInfo: {}
    };
  },

  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607f52b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/matchSimpleUnstart.vue
var matchSimpleUnstart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5px 10px"}},[_c('div',{staticStyle:{"margin-top":"10px","font-family":"PingFangSC-Regular","font-size":"12px","color":"#999999","letter-spacing":"0"}},[_vm._v("\n        "+_vm._s(this.title)+"\n        "),(this.objInfo.startDate)?_c('span',[_vm._v("（"+_vm._s(this.objInfo.startTime)+"）")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","justify-content":"center","width":"100%"}},[_c('flexbox',{attrs:{"gutter":0,"justify":"center"}},[_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"right","font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","letter-spacing":"0"},on:{"click":_vm.viewMatch}},[_vm._v(_vm._s(this.objInfo.homeTeamName))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/5}},[_c('div',{staticStyle:{"text-align":"center","font-family":"Arial-Black","font-size":"18px","color":"#299AFE","letter-spacing":"0"},on:{"click":_vm.toMatchLive}},[_vm._v(_vm._s(this.score))]),_vm._v(" "),(_vm.objInfo.liveUrl && _vm.objInfo.liveUrl!='')?[_c('div',{staticStyle:{"text-align":"center","font-family":"Arial-Black","font-size":"14px","color":"#FE2754","letter-spacing":"0"},on:{"click":_vm.toMatchLive}},[_c('span',[_vm._v("看直播")])])]:_vm._e()],2),_vm._v(" "),_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"left","font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","letter-spacing":"0"},on:{"click":_vm.viewMatch}},[_vm._v(_vm._s(this.objInfo.vistingTeamName))])])],1)],1)])}
var matchSimpleUnstart_staticRenderFns = []
var matchSimpleUnstart_esExports = { render: matchSimpleUnstart_render, staticRenderFns: matchSimpleUnstart_staticRenderFns }
/* harmony default export */ var components_league_matchSimpleUnstart = (matchSimpleUnstart_esExports);
// CONCATENATED MODULE: ./src/components/league/matchSimpleUnstart.vue
var matchSimpleUnstart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchSimpleUnstart___vue_template_functional__ = false
/* styles */
var matchSimpleUnstart___vue_styles__ = null
/* scopeId */
var matchSimpleUnstart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var matchSimpleUnstart___vue_module_identifier__ = null
var matchSimpleUnstart_Component = matchSimpleUnstart_normalizeComponent(
  league_matchSimpleUnstart,
  components_league_matchSimpleUnstart,
  matchSimpleUnstart___vue_template_functional__,
  matchSimpleUnstart___vue_styles__,
  matchSimpleUnstart___vue_scopeId__,
  matchSimpleUnstart___vue_module_identifier__
)

/* harmony default export */ var src_components_league_matchSimpleUnstart = (matchSimpleUnstart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/roundCardUnstart.vue









/* harmony default export */ var roundCardUnstart = ({
  props: {
    dayInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button,
    MatchSimpleUnstart: src_components_league_matchSimpleUnstart
  },
  mounted: function mounted() {

    this.reload();
  },

  methods: {
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    reload: function reload() {
      this.title = this.genTitle();
      this.matches = this.dayInfo.matches;
    },
    genTitle: function genTitle() {
      var chnNumChar = ["一", "二", "三", "四", "五", "六", "日"];
      var date = "";
      if (this.dayInfo.date) {
        date = this.dayInfo.date;
      }
      var weekday = "";
      if (this.dayInfo.weekday && this.dayInfo.weekday >= 1 && this.dayInfo.weekday <= 7) {
        weekday = " 周" + chnNumChar[this.dayInfo.weekday - 1];
      }
      return date + weekday;
    },
    viewRoundDetail: function viewRoundDetail() {
      alert(this.genTitle());
    }
  },
  data: function data() {
    return {
      title: " ",
      matches: []
    };
  },

  watch: {
    dayInfo: function dayInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/roundCardUnstart.vue









/* harmony default export */ var league_roundCardUnstart = ({
  props: {
    dayInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button,
    MatchSimpleUnstart: src_components_league_matchSimpleUnstart
  },
  mounted: function mounted() {

    this.reload();
  },

  methods: {
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    reload: function reload() {
      this.title = this.genTitle();
      this.matches = this.dayInfo.matches;
    },
    genTitle: function genTitle() {
      var chnNumChar = ["一", "二", "三", "四", "五", "六", "日"];
      var date = "";
      if (this.dayInfo.date) {
        date = this.dayInfo.date;
      }
      var weekday = "";
      if (this.dayInfo.weekday && this.dayInfo.weekday >= 1 && this.dayInfo.weekday <= 7) {
        weekday = " 周" + chnNumChar[this.dayInfo.weekday - 1];
      }
      return date + weekday;
    },
    viewRoundDetail: function viewRoundDetail() {
      alert(this.genTitle());
    }
  },
  data: function data() {
    return {
      title: " ",
      matches: []
    };
  },

  watch: {
    dayInfo: function dayInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a90387e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/roundCardUnstart.vue
var roundCardUnstart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('img',{staticStyle:{"display":"inline-block","width":"16px","height":"16px"},attrs:{"src":__webpack_require__("epEz")}}),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","font-family":"PingFangSC-Medium","font-size":"16px","color":"#333333","letter-spacing":"0"}},[_vm._v(_vm._s(this.title))])]),_vm._v(" "),_vm._l((this.matches),function(matchObj){return _c('div',[_c('MatchSimpleUnstart',{attrs:{"matchInfo":matchObj}})],1)}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px","margin-right":"10px","background":"#F3F3F3","height":"1px","margin-top":"10px"}})],2)}
var roundCardUnstart_staticRenderFns = []
var roundCardUnstart_esExports = { render: roundCardUnstart_render, staticRenderFns: roundCardUnstart_staticRenderFns }
/* harmony default export */ var components_league_roundCardUnstart = (roundCardUnstart_esExports);
// CONCATENATED MODULE: ./src/components/league/roundCardUnstart.vue
function roundCardUnstart_injectStyle (ssrContext) {
  __webpack_require__("pnX2")
}
var roundCardUnstart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var roundCardUnstart___vue_template_functional__ = false
/* styles */
var roundCardUnstart___vue_styles__ = roundCardUnstart_injectStyle
/* scopeId */
var roundCardUnstart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var roundCardUnstart___vue_module_identifier__ = null
var roundCardUnstart_Component = roundCardUnstart_normalizeComponent(
  league_roundCardUnstart,
  components_league_roundCardUnstart,
  roundCardUnstart___vue_template_functional__,
  roundCardUnstart___vue_styles__,
  roundCardUnstart___vue_scopeId__,
  roundCardUnstart___vue_module_identifier__
)

/* harmony default export */ var src_components_league_roundCardUnstart = (roundCardUnstart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueOngoing_arrange.vue


















/* harmony default export */ var leagueOngoing_arrange = ({
  props: {},
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    RoundCardUnstart: src_components_league_roundCardUnstart,
    RoundCard: src_components_league_roundCard
  },
  mounted: function mounted() {
    var _this = this;

    if (this.eventHub) {
      this.eventHub.$on('loadMoreArrange', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabArrange', function () {
        _this.refreshTab();
      });
    }

    this.currentTab = this.$store.getters.getArrangeTab;
    this.nodataTxt = "";
    this.roundsInfo = [];
    this.initTab();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-赛况分享',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    handlerMatchFinish: function handlerMatchFinish() {
      this.currentTab = 'league-1';
      this.$store.commit('updateArrangeTab', 'league-1');
      this.initTab1();
      external__Zepto__default()('#matchFinished').show();
      external__Zepto__default()('#matchUnstart').hide();
    },
    handlerMatchUnstart: function handlerMatchUnstart() {
      this.currentTab = 'league-2';
      this.$store.commit('updateArrangeTab', 'league-2');
      this.initTab1();
      external__Zepto__default()('#matchFinished').hide();
      external__Zepto__default()('#matchUnstart').show();
    },
    loadData: function loadData(id, start, length, type, successCall, afterCall) {
      this.hagkHttp(this.hagkApi.getLeagueMatches(id, start, length, type), {}).then(function (res) {
        if (res.status == true) {
          successCall(res.result);
        }
        afterCall();
      }, function (error) {
        afterCall();
      });
    },
    initTab: function initTab() {
      this.eventHub.$emit("setTabIndex", "leagueArrange");
      this.initWxShareConfig();
      if (this.currentTab == "league-1") {
        external__Zepto__default()('#matchFinishTab').triggerFastClick();
      } else {
        external__Zepto__default()('#matchUnstartTab').triggerFastClick();
      }
    },
    initTab1: function initTab1() {
      var _this2 = this;

      console.log("init " + this.currentTab);
      this.nodataTxt = "";
      var leagueId = parseInt(this.leagueId);
      if (this.currentTab == 'league-1') {
        if (this.roundsInfo.length == 0) {
          console.log("加载中...");
          this.$vux.loading.show({
            text: '加载中...'
          });
          this.loadData(leagueId, 0, 3, "true", this.initRoundFinishInfo, function () {
            console.log("取消加载中...");
            _this2.$vux.loading.hide();
          });
        }
      } else if (this.currentTab == 'league-2') {
        if (this.roundsUnstartInfo.length == 0) {
          this.$vux.loading.show({
            text: '加载中...'
          });
          this.loadData(leagueId, 0, 3, "false", this.initRoundUnstartInfo, function () {
            _this2.$vux.loading.hide();
          });
        }
      }
    },
    refreshTab: function refreshTab() {
      var _this3 = this;

      console.log("refreshTab" + this.currentTab);
      this.nodataTxt = "";
      var leagueId = parseInt(this.leagueId);
      if (this.currentTab == 'league-1') {
        this.loadData(leagueId, 0, 3, "true", this.initRoundFinishInfo, function () {
          _this3.eventHub.$emit("enablerefreshTab");
        });
      } else if (this.currentTab == 'league-2') {
        this.loadData(leagueId, 0, 3, "false", this.initRoundUnstartInfo, function () {
          _this3.eventHub.$emit("enablerefreshTab");
        });
      }
    },
    loadMore: function loadMore() {
      var _this4 = this;

      console.log("loadMore" + this.currentTab);
      this.nodataTxt = "";
      var leagueId = parseInt(this.leagueId);
      if (this.currentTab == 'league-1') {
        this.loadData(leagueId, this.roundStart, 3, "true", this.loadMoreRoundFinishInfo, function () {
          _this4.eventHub.$emit("enableloadMore");
        });
      } else if (this.currentTab == 'league-2') {
        this.loadData(leagueId, this.roundUnstartStart, 3, "false", this.loadMoreRoundUnstartInfo, function () {
          _this4.eventHub.$emit("enableloadMore");
        });
      }
    },
    initRoundFinishInfo: function initRoundFinishInfo(data) {
      if (data && data.length > 0) {
        this.roundStart = data.length;
        this.roundsInfo = data;
      } else {
        this.roundStart = 0;
        this.roundsInfo = [];
        this.nodataTxt = "暂无数据";
      }
    },
    loadMoreRoundFinishInfo: function loadMoreRoundFinishInfo(data) {
      if (data && data.length > 0) {
        this.roundStart += data.length;
        for (var i = 0; i < data.length; i++) {
          this.roundsInfo.push(data[i]);
        }
      } else {
        this.nodataTxt = "暂无数据";
      }
      return;
    },
    initRoundUnstartInfo: function initRoundUnstartInfo(data) {
      if (data && data.length > 0) {
        this.roundUnstartStart = data.length;
        this.roundsUnstartInfo = data;
      } else {
        this.roundUnstartStart = 0;
        this.roundsUnstartInfo = [];
        this.nodataTxt = "暂无数据";
      }
    },
    loadMoreRoundUnstartInfo: function loadMoreRoundUnstartInfo(data) {
      var offset = this.roundUnstartStart;
      if (data && data.length > 0) {
        this.roundUnstartStart += data.length;
        for (var i = 0; i < data.length; i++) {
          this.roundsUnstartInfo.push(data[i]);
        }
      } else {
        this.nodataTxt = "暂无数据";
      }
      return;
    }
  },
  data: function data() {
    var loadingTab = ['league-1', 'league-2'];
    return {
      currentPage: null,
      nodataTxt: "",
      roundStart: 0,
      roundsInfo: [],
      roundUnstartStart: 0,
      roundsUnstartInfo: [],
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueOngoing_arrange.vue


















/* harmony default export */ var views_leagueOngoing_arrange = ({
  props: {},
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    RoundCardUnstart: src_components_league_roundCardUnstart,
    RoundCard: src_components_league_roundCard
  },
  mounted: function mounted() {
    var _this = this;

    if (this.eventHub) {
      this.eventHub.$on('loadMoreArrange', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabArrange', function () {
        _this.refreshTab();
      });
    }

    this.currentTab = this.$store.getters.getArrangeTab;
    this.nodataTxt = "";
    this.roundsInfo = [];
    this.initTab();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-赛况分享',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    handlerMatchFinish: function handlerMatchFinish() {
      this.currentTab = 'league-1';
      this.$store.commit('updateArrangeTab', 'league-1');
      this.initTab1();
      external__Zepto__default()('#matchFinished').show();
      external__Zepto__default()('#matchUnstart').hide();
    },
    handlerMatchUnstart: function handlerMatchUnstart() {
      this.currentTab = 'league-2';
      this.$store.commit('updateArrangeTab', 'league-2');
      this.initTab1();
      external__Zepto__default()('#matchFinished').hide();
      external__Zepto__default()('#matchUnstart').show();
    },
    loadData: function loadData(id, start, length, type, successCall, afterCall) {
      this.hagkHttp(this.hagkApi.getLeagueMatches(id, start, length, type), {}).then(function (res) {
        if (res.status == true) {
          successCall(res.result);
        }
        afterCall();
      }, function (error) {
        afterCall();
      });
    },
    initTab: function initTab() {
      this.eventHub.$emit("setTabIndex", "leagueArrange");
      this.initWxShareConfig();
      if (this.currentTab == "league-1") {
        external__Zepto__default()('#matchFinishTab').triggerFastClick();
      } else {
        external__Zepto__default()('#matchUnstartTab').triggerFastClick();
      }
    },
    initTab1: function initTab1() {
      var _this2 = this;

      console.log("init " + this.currentTab);
      this.nodataTxt = "";
      var leagueId = parseInt(this.leagueId);
      if (this.currentTab == 'league-1') {
        if (this.roundsInfo.length == 0) {
          console.log("加载中...");
          this.$vux.loading.show({
            text: '加载中...'
          });
          this.loadData(leagueId, 0, 3, "true", this.initRoundFinishInfo, function () {
            console.log("取消加载中...");
            _this2.$vux.loading.hide();
          });
        }
      } else if (this.currentTab == 'league-2') {
        if (this.roundsUnstartInfo.length == 0) {
          this.$vux.loading.show({
            text: '加载中...'
          });
          this.loadData(leagueId, 0, 3, "false", this.initRoundUnstartInfo, function () {
            _this2.$vux.loading.hide();
          });
        }
      }
    },
    refreshTab: function refreshTab() {
      var _this3 = this;

      console.log("refreshTab" + this.currentTab);
      this.nodataTxt = "";
      var leagueId = parseInt(this.leagueId);
      if (this.currentTab == 'league-1') {
        this.loadData(leagueId, 0, 3, "true", this.initRoundFinishInfo, function () {
          _this3.eventHub.$emit("enablerefreshTab");
        });
      } else if (this.currentTab == 'league-2') {
        this.loadData(leagueId, 0, 3, "false", this.initRoundUnstartInfo, function () {
          _this3.eventHub.$emit("enablerefreshTab");
        });
      }
    },
    loadMore: function loadMore() {
      var _this4 = this;

      console.log("loadMore" + this.currentTab);
      this.nodataTxt = "";
      var leagueId = parseInt(this.leagueId);
      if (this.currentTab == 'league-1') {
        this.loadData(leagueId, this.roundStart, 3, "true", this.loadMoreRoundFinishInfo, function () {
          _this4.eventHub.$emit("enableloadMore");
        });
      } else if (this.currentTab == 'league-2') {
        this.loadData(leagueId, this.roundUnstartStart, 3, "false", this.loadMoreRoundUnstartInfo, function () {
          _this4.eventHub.$emit("enableloadMore");
        });
      }
    },
    initRoundFinishInfo: function initRoundFinishInfo(data) {
      if (data && data.length > 0) {
        this.roundStart = data.length;
        this.roundsInfo = data;
      } else {
        this.roundStart = 0;
        this.roundsInfo = [];
        this.nodataTxt = "暂无数据";
      }
    },
    loadMoreRoundFinishInfo: function loadMoreRoundFinishInfo(data) {
      if (data && data.length > 0) {
        this.roundStart += data.length;
        for (var i = 0; i < data.length; i++) {
          this.roundsInfo.push(data[i]);
        }
      } else {
        this.nodataTxt = "暂无数据";
      }
      return;
    },
    initRoundUnstartInfo: function initRoundUnstartInfo(data) {
      if (data && data.length > 0) {
        this.roundUnstartStart = data.length;
        this.roundsUnstartInfo = data;
      } else {
        this.roundUnstartStart = 0;
        this.roundsUnstartInfo = [];
        this.nodataTxt = "暂无数据";
      }
    },
    loadMoreRoundUnstartInfo: function loadMoreRoundUnstartInfo(data) {
      var offset = this.roundUnstartStart;
      if (data && data.length > 0) {
        this.roundUnstartStart += data.length;
        for (var i = 0; i < data.length; i++) {
          this.roundsUnstartInfo.push(data[i]);
        }
      } else {
        this.nodataTxt = "暂无数据";
      }
      return;
    }
  },
  data: function data() {
    var loadingTab = ['league-1', 'league-2'];
    return {
      currentPage: null,
      nodataTxt: "",
      roundStart: 0,
      roundsInfo: [],
      roundUnstartStart: 0,
      roundsUnstartInfo: [],
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673b6b86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/leagueOngoing_arrange.vue
var leagueOngoing_arrange_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin":"20px auto","width":"50%","border":"solid #F3F3F3 4px"}},[_c('button-tab',{staticStyle:{"background":"#F3F3F3","border-radius":"2px"}},[_c('button-tab-item',{attrs:{"id":"matchFinishTab"},on:{"on-item-click":_vm.handlerMatchFinish}},[_vm._v("\n                已结束\n            ")]),_vm._v(" "),_c('button-tab-item',{attrs:{"id":"matchUnstartTab"},on:{"on-item-click":_vm.handlerMatchUnstart}},[_vm._v("未开始\n            ")])],1)],1),_vm._v(" "),_c('div',[_c('div',{attrs:{"id":"matchFinished"}},[_c('div',{staticClass:"box2"},[(this.roundsInfo&&this.roundsInfo.length>0)?_c('div',_vm._l((this.roundsInfo),function(round){return _c('p',[_c('RoundCard',{attrs:{"leagueBasicInfo":_vm.leagueBasicInfo,"leagueId":_vm.leagueId,"roundInfo":round}})],1)}),0):_c('div',{staticStyle:{"margin":"0 auto","width":"100%","text-align":"center","margin-top":"100px","font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v("\n                    暂无数据\n                ")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"matchUnstart"}},[_c('div',{staticClass:"box2"},[(this.roundsUnstartInfo&&this.roundsUnstartInfo.length>0)?_c('div',_vm._l((this.roundsUnstartInfo),function(round){return _c('p',[_c('RoundCardUnstart',{attrs:{"dayInfo":round}})],1)}),0):_c('div',{staticStyle:{"margin":"0 auto","width":"100%","text-align":"center","margin-top":"100px","font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v("\n                    "+_vm._s(this.nodataTxt)+"\n                ")])])])])])}
var leagueOngoing_arrange_staticRenderFns = []
var leagueOngoing_arrange_esExports = { render: leagueOngoing_arrange_render, staticRenderFns: leagueOngoing_arrange_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_leagueOngoing_arrange = (leagueOngoing_arrange_esExports);
// CONCATENATED MODULE: ./src/views/leagueOngoing_arrange.vue
function leagueOngoing_arrange_injectStyle (ssrContext) {
  __webpack_require__("Bo1r")
  __webpack_require__("Q1vY")
}
var leagueOngoing_arrange_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leagueOngoing_arrange___vue_template_functional__ = false
/* styles */
var leagueOngoing_arrange___vue_styles__ = leagueOngoing_arrange_injectStyle
/* scopeId */
var leagueOngoing_arrange___vue_scopeId__ = "data-v-673b6b86"
/* moduleIdentifier (server only) */
var leagueOngoing_arrange___vue_module_identifier__ = null
var leagueOngoing_arrange_Component = leagueOngoing_arrange_normalizeComponent(
  views_leagueOngoing_arrange,
  selectortype_template_index_0_src_views_leagueOngoing_arrange,
  leagueOngoing_arrange___vue_template_functional__,
  leagueOngoing_arrange___vue_styles__,
  leagueOngoing_arrange___vue_scopeId__,
  leagueOngoing_arrange___vue_module_identifier__
)

/* harmony default export */ var src_views_leagueOngoing_arrange = (leagueOngoing_arrange_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueOngoingJifen.vue
















/* harmony default export */ var leagueOngoingJifen = ({
  props: {},
  data: function data() {
    return {
      currentPage: null,
      nodataTxt: "",
      league: {},
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.eventHub) {
      this.eventHub.$on('loadMoreJifen', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabJifen', function () {
        _this.refreshTab();
      });
    }
    this.initTab();
  },

  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    RoundCard: src_components_league_roundCard
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-积分分享',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    initTab: function initTab() {
      var _this2 = this;

      this.eventHub.$emit("setTabIndex", "leagueTable");

      this.initWxShareConfig();
      var leagueId = parseInt(this.leagueId);
      if ((!this.league.scoreBoard || this.league.scoreBoard.length < 1) && (!this.league.groups || this.league.groups.length < 1)) {
        this.$vux.loading.show({
          text: '加载中...'
        });

        this.loadData(leagueId, function () {
          _this2.$vux.loading.hide();
        });
      }
    },
    loadData: function loadData(leageID, afterCall) {
      var _this3 = this;

      this.nodataTxt = "";
      this.hagkHttp(this.hagkApi.getLeagueTable(leageID), {}).then(function (res) {
        if (res.status == true) {
          _this3.league = res.result;
          if (res.result && res.result.scoreBoard != null && res.result.scoreBoard.length == 0) {
            _this3.nodataTxt = "暂无数据";
          }
        }
      }, function (error) {
        console.log(error);
      });
      afterCall();
    },
    refreshTab: function refreshTab() {
      var _this4 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, function () {
        _this4.eventHub.$emit("enablerefreshTab");
      });
    },
    loadMore: function loadMore() {
      this.eventHub.$emit("enableloadMore");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueOngoingJifen.vue
















/* harmony default export */ var views_leagueOngoingJifen = ({
  props: {},
  data: function data() {
    return {
      currentPage: null,
      nodataTxt: "",
      league: {},
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.eventHub) {
      this.eventHub.$on('loadMoreJifen', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabJifen', function () {
        _this.refreshTab();
      });
    }
    this.initTab();
  },

  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    RoundCard: src_components_league_roundCard
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-积分分享',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    initTab: function initTab() {
      var _this2 = this;

      this.eventHub.$emit("setTabIndex", "leagueTable");

      this.initWxShareConfig();
      var leagueId = parseInt(this.leagueId);
      if ((!this.league.scoreBoard || this.league.scoreBoard.length < 1) && (!this.league.groups || this.league.groups.length < 1)) {
        this.$vux.loading.show({
          text: '加载中...'
        });

        this.loadData(leagueId, function () {
          _this2.$vux.loading.hide();
        });
      }
    },
    loadData: function loadData(leageID, afterCall) {
      var _this3 = this;

      this.nodataTxt = "";
      this.hagkHttp(this.hagkApi.getLeagueTable(leageID), {}).then(function (res) {
        if (res.status == true) {
          _this3.league = res.result;
          if (res.result && res.result.scoreBoard != null && res.result.scoreBoard.length == 0) {
            _this3.nodataTxt = "暂无数据";
          }
        }
      }, function (error) {
        console.log(error);
      });
      afterCall();
    },
    refreshTab: function refreshTab() {
      var _this4 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, function () {
        _this4.eventHub.$emit("enablerefreshTab");
      });
    },
    loadMore: function loadMore() {
      this.eventHub.$emit("enableloadMore");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6a5515e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/leagueOngoingJifen.vue
var leagueOngoingJifen_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"league-shoot"},[(_vm.league.scoreBoard && _vm.league.scoreBoard.length > 0)?[_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.league.scoreBoard),function(scoreBoard,index){return [(index ==  0)?[_c('tr',[_c('td',{staticClass:"rank_1_number"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(scoreBoard.teamName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.wonMatchNum)+"/"+_vm._s(scoreBoard.drawnMatchNum)+"/"+_vm._s(scoreBoard.lostMatchNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.goal)+"/"+_vm._s(scoreBoard.loss))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.points))])])]:[_c('tr',[_c('td',{staticClass:"rank_greater_1_number"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(scoreBoard.teamName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.wonMatchNum)+"/"+_vm._s(scoreBoard.drawnMatchNum)+"/"+_vm._s(scoreBoard.lostMatchNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.goal)+"/"+_vm._s(scoreBoard.loss))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.points))])])]]})],2)]:_vm._e(),_vm._v(" "),(_vm.league.groups && _vm.league.groups.length > 0)?[_vm._l((_vm.league.groups),function(group,index){return [_c('div',{staticClass:"code"},[_vm._v(_vm._s(group.cupGroupName)+"组")]),_vm._v(" "),_c('table',[_vm._m(1,true),_vm._v(" "),_vm._l((group.scoreBoard),function(scoreBoard,index){return [(index ==  0)?[_c('tr',[_c('td',{staticClass:"rank_1_number"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(scoreBoard.teamName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.wonMatchNum)+"/"+_vm._s(scoreBoard.drawnMatchNum)+"/"+_vm._s(scoreBoard.lostMatchNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.goal)+"/"+_vm._s(scoreBoard.loss))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.points))])])]:[_c('tr',[_c('td',{staticClass:"rank_greater_1_number"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(scoreBoard.teamName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.wonMatchNum)+"/"+_vm._s(scoreBoard.drawnMatchNum)+"/"+_vm._s(scoreBoard.lostMatchNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.goal)+"/"+_vm._s(scoreBoard.loss))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.points))])])]]})],2)]})]:_vm._e(),_vm._v(" "),((!_vm.league.scoreBoard || _vm.league.scoreBoard.length < 1) && (!_vm.league.groups || _vm.league.groups.length < 1))?[_c('div',{staticStyle:{"margin":"0 auto","width":"100%","text-align":"center","margin-top":"100px","font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(this.nodataTxt))])]:_vm._e()],2)}
var leagueOngoingJifen_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v("排名")]),_vm._v(" "),_c('th',{attrs:{"width":"45%"}},[_vm._v("球队")]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v("胜/平/负")]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v("进/失")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("积分")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v("排名")]),_vm._v(" "),_c('th',{attrs:{"width":"45%"}},[_vm._v("球队")]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v("胜/平/负")]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v("进/失")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("积分")])])}]
var leagueOngoingJifen_esExports = { render: leagueOngoingJifen_render, staticRenderFns: leagueOngoingJifen_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_leagueOngoingJifen = (leagueOngoingJifen_esExports);
// CONCATENATED MODULE: ./src/views/leagueOngoingJifen.vue
function leagueOngoingJifen_injectStyle (ssrContext) {
  __webpack_require__("uJDh")
}
var leagueOngoingJifen_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leagueOngoingJifen___vue_template_functional__ = false
/* styles */
var leagueOngoingJifen___vue_styles__ = leagueOngoingJifen_injectStyle
/* scopeId */
var leagueOngoingJifen___vue_scopeId__ = "data-v-a6a5515e"
/* moduleIdentifier (server only) */
var leagueOngoingJifen___vue_module_identifier__ = null
var leagueOngoingJifen_Component = leagueOngoingJifen_normalizeComponent(
  views_leagueOngoingJifen,
  selectortype_template_index_0_src_views_leagueOngoingJifen,
  leagueOngoingJifen___vue_template_functional__,
  leagueOngoingJifen___vue_styles__,
  leagueOngoingJifen___vue_scopeId__,
  leagueOngoingJifen___vue_module_identifier__
)

/* harmony default export */ var src_views_leagueOngoingJifen = (leagueOngoingJifen_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-avatar/dist/vue-avatar.min.js
var vue_avatar_min = __webpack_require__("Y50r");
var vue_avatar_min_default = /*#__PURE__*/__webpack_require__.n(vue_avatar_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/momentThumb.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var momentThumb = ({
    props: {
        asset: Object
    },
    components: {},
    mounted: function mounted() {
        var width = $(this.$refs.curr).width();
        var height = $(this.$refs.curr).height();

        if (width === height) {
            $(this.$refs.videoTag).attr('style', 'width: 60%;height: 60%;position: absolute;top: 20%; left: 20%;');
        } else if (height > width) {
            var heightTag = parseInt(60 * width / height);
            var topPos = parseInt((100 - heightTag) / 2);
            $(this.$refs.videoTag).attr('style', 'width: 60%;height: ' + heightTag + '%;position: absolute;top: ' + topPos + '%; left: 20%;');
        } else if (height < width) {
            var widthTag = parseInt(60 * height / width);
            var leftPos = parseInt((100 - widthTag) / 2);
            $(this.$refs.videoTag).attr('style', 'width: ' + widthTag + '%;height:60%;position: absolute;top: 20%; left: ' + leftPos + '%;');
        }
    },

    methods: {},
    data: function data() {
        return {
            defaultImg: 'this.src="' + __webpack_require__("KXse") + '"',
            videoTag: __webpack_require__("+vEQ")
        };
    },

    watch: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/momentThumb.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var league_momentThumb = ({
    props: {
        asset: Object
    },
    components: {},
    mounted: function mounted() {
        var width = $(this.$refs.curr).width();
        var height = $(this.$refs.curr).height();

        if (width === height) {
            $(this.$refs.videoTag).attr('style', 'width: 60%;height: 60%;position: absolute;top: 20%; left: 20%;');
        } else if (height > width) {
            var heightTag = parseInt(60 * width / height);
            var topPos = parseInt((100 - heightTag) / 2);
            $(this.$refs.videoTag).attr('style', 'width: 60%;height: ' + heightTag + '%;position: absolute;top: ' + topPos + '%; left: 20%;');
        } else if (height < width) {
            var widthTag = parseInt(60 * height / width);
            var leftPos = parseInt((100 - widthTag) / 2);
            $(this.$refs.videoTag).attr('style', 'width: ' + widthTag + '%;height:60%;position: absolute;top: 20%; left: ' + leftPos + '%;');
        }
    },

    methods: {},
    data: function data() {
        return {
            defaultImg: 'this.src="' + __webpack_require__("KXse") + '"',
            videoTag: __webpack_require__("+vEQ")
        };
    },

    watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a4151b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/momentThumb.vue
var momentThumb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"curr"},[(this.asset.type=='video')?[_c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","position":"absolute","top":"0","left":"0"},attrs:{"src":this.asset.thumbnail_url,"onerror":_vm.defaultImg}}),_vm._v(" "),_c('img',{ref:"videoTag",staticStyle:{"width":"60%","height":"30%","position":"absolute","top":"35%","left":"20%"},attrs:{"src":this.videoTag}})])]:[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":this.asset.thumbnail_url,"onerror":_vm.defaultImg}})]],2)}
var momentThumb_staticRenderFns = []
var momentThumb_esExports = { render: momentThumb_render, staticRenderFns: momentThumb_staticRenderFns }
/* harmony default export */ var components_league_momentThumb = (momentThumb_esExports);
// CONCATENATED MODULE: ./src/components/league/momentThumb.vue
function momentThumb_injectStyle (ssrContext) {
  __webpack_require__("v58/")
}
var momentThumb_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var momentThumb___vue_template_functional__ = false
/* styles */
var momentThumb___vue_styles__ = momentThumb_injectStyle
/* scopeId */
var momentThumb___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var momentThumb___vue_module_identifier__ = null
var momentThumb_Component = momentThumb_normalizeComponent(
  league_momentThumb,
  components_league_momentThumb,
  momentThumb___vue_template_functional__,
  momentThumb___vue_styles__,
  momentThumb___vue_scopeId__,
  momentThumb___vue_module_identifier__
)

/* harmony default export */ var src_components_league_momentThumb = (momentThumb_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/momentsCard.vue









/* harmony default export */ var momentsCard = ({
  props: {
    matchMoments: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    MomentThumb: src_components_league_momentThumb
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    timeStamp2HtmlString: function timeStamp2HtmlString(time) {
      var datetime = new Date();
      datetime.setTime(time);
      var year = datetime.getFullYear();
      var month = datetime.getMonth() + 1;
      var date = datetime.getDate();
      var hour = datetime.getHours();
      var minute = datetime.getMinutes();
      var second = datetime.getSeconds();
      var mseconds = datetime.getMilliseconds();

      var tmp = '<div>' + '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + date + ' ' + '</div>' + '<div style="display:inline-block;">' + '<div style="font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' + year + '</div>' + '<div style="font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' + month + "月" + '</div>' + '</div>' + '</div>';
      var tmpThisYear = '<div>' + '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + date + ' ' + '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' + month + "月" + '</div>' + '</div>';
      var tmpToday = '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + "今天" + '</div>';
      var tmpLast = '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + "昨天" + '</div>';
      var tmpFuture = '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + "明天" + '</div>';

      var d = new Date(year, month - 1, date);
      var nowDate = new Date();
      var lastDate = new Date(nowDate);
      lastDate.setTime(nowDate.getTime() - 24 * 60 * 60 * 1000);
      var futureDate = new Date(nowDate);
      futureDate.setTime(nowDate.getTime() + 24 * 60 * 60 * 1000);

      if (d.toDateString() == nowDate.toDateString()) {
        return tmpToday;
      } else if (d.toDateString() == lastDate.toDateString()) {
        return tmpLast;
      } else if (d.toDateString() == futureDate.toDateString()) {
        return tmpFuture;
      } else if (nowDate.getYear() == d.getYear()) {
        return tmpThisYear;
      } else {
        return tmp;
      }
    },
    getLeagueAssetUrl: function getLeagueAssetUrl(assetId) {
      return this.hagkApi.getImgAssetById(assetId).url;
    },
    viewDetail: function viewDetail() {
      if (this.matchMoments && this.matchMoments.id) {
        this.$router.push({
          path: '/moment_list',
          query: {
            matchId: this.matchMoments.id
          }
        });
      }
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    reload: function reload() {
      this.date = this.timeStamp2HtmlString(this.matchMoments.startDate);
      this.roundName = " xx";
      this.assets = [];
      if (this.matchMoments && this.matchMoments.assetList) {
        for (var i = 0; i < this.matchMoments.assetList.length; i++) {
          var data = {};
          data.url = this.getLeagueAssetUrl(this.matchMoments.assetList[i].assetId);
          data.thumbnail_url = this.getLeagueAssetUrl(this.matchMoments.assetList[i].thumbnailId);
          data.type = this.matchMoments.assetList[i].type;
          this.assets.push(data);
        }
      }
      this.homeTeamName = this.matchMoments.homeTeamName;
      this.vistingTeamName = this.matchMoments.vistingTeamName;
      this.roundName = this.getRoundName(this.matchMoments.round.type, this.matchMoments.round.number, this.matchMoments.round.title);

      var matchObj = this.matchMoments.result;
      var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";
      var homePKGoal = 0;
      var visitorPKGoal = 0;
      if (matchObj != undefined && matchObj != null) {
        if (matchObj.homePkScore != null && matchObj.homePkScore != undefined) {
          homePKGoal = matchObj.homePkScore;
        }
        if (matchObj.visitorPkScore != null && matchObj.visitorPkScore != undefined) {
          visitorPKGoal = matchObj.visitorPkScore;
        }
      }

      this.homeTeamScore = matchObj != undefined && matchObj != null ? matchObj.goalFor + matchObj.homeExScore + homePKGoal : "";
      this.vistingTeamScore = matchObj != undefined && matchObj != null ? matchObj.goalAgainst + matchObj.visitorExScore + visitorPKGoal : "";
    }
  },
  data: function data() {
    return {
      date: "今天",
      roundName: "",
      homeTeamName: "A",
      vistingTeamName: "B",
      homeTeamScore: "2",
      vistingTeamScore: "3",
      assets: [],
      defaultImg: 'this.src="' + __webpack_require__("KXse") + '"',
      videoTag: __webpack_require__("+vEQ")
    };
  },

  watch: {
    matchMoments: function matchMoments(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/momentsCard.vue









/* harmony default export */ var league_momentsCard = ({
  props: {
    matchMoments: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    MomentThumb: src_components_league_momentThumb
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    timeStamp2HtmlString: function timeStamp2HtmlString(time) {
      var datetime = new Date();
      datetime.setTime(time);
      var year = datetime.getFullYear();
      var month = datetime.getMonth() + 1;
      var date = datetime.getDate();
      var hour = datetime.getHours();
      var minute = datetime.getMinutes();
      var second = datetime.getSeconds();
      var mseconds = datetime.getMilliseconds();

      var tmp = '<div>' + '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + date + ' ' + '</div>' + '<div style="display:inline-block;">' + '<div style="font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' + year + '</div>' + '<div style="font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' + month + "月" + '</div>' + '</div>' + '</div>';
      var tmpThisYear = '<div>' + '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + date + ' ' + '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' + month + "月" + '</div>' + '</div>';
      var tmpToday = '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + "今天" + '</div>';
      var tmpLast = '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + "昨天" + '</div>';
      var tmpFuture = '<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' + "明天" + '</div>';

      var d = new Date(year, month - 1, date);
      var nowDate = new Date();
      var lastDate = new Date(nowDate);
      lastDate.setTime(nowDate.getTime() - 24 * 60 * 60 * 1000);
      var futureDate = new Date(nowDate);
      futureDate.setTime(nowDate.getTime() + 24 * 60 * 60 * 1000);

      if (d.toDateString() == nowDate.toDateString()) {
        return tmpToday;
      } else if (d.toDateString() == lastDate.toDateString()) {
        return tmpLast;
      } else if (d.toDateString() == futureDate.toDateString()) {
        return tmpFuture;
      } else if (nowDate.getYear() == d.getYear()) {
        return tmpThisYear;
      } else {
        return tmp;
      }
    },
    getLeagueAssetUrl: function getLeagueAssetUrl(assetId) {
      return this.hagkApi.getImgAssetById(assetId).url;
    },
    viewDetail: function viewDetail() {
      if (this.matchMoments && this.matchMoments.id) {
        this.$router.push({
          path: '/moment_list',
          query: {
            matchId: this.matchMoments.id
          }
        });
      }
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    reload: function reload() {
      this.date = this.timeStamp2HtmlString(this.matchMoments.startDate);
      this.roundName = " xx";
      this.assets = [];
      if (this.matchMoments && this.matchMoments.assetList) {
        for (var i = 0; i < this.matchMoments.assetList.length; i++) {
          var data = {};
          data.url = this.getLeagueAssetUrl(this.matchMoments.assetList[i].assetId);
          data.thumbnail_url = this.getLeagueAssetUrl(this.matchMoments.assetList[i].thumbnailId);
          data.type = this.matchMoments.assetList[i].type;
          this.assets.push(data);
        }
      }
      this.homeTeamName = this.matchMoments.homeTeamName;
      this.vistingTeamName = this.matchMoments.vistingTeamName;
      this.roundName = this.getRoundName(this.matchMoments.round.type, this.matchMoments.round.number, this.matchMoments.round.title);

      var matchObj = this.matchMoments.result;
      var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";
      var homePKGoal = 0;
      var visitorPKGoal = 0;
      if (matchObj != undefined && matchObj != null) {
        if (matchObj.homePkScore != null && matchObj.homePkScore != undefined) {
          homePKGoal = matchObj.homePkScore;
        }
        if (matchObj.visitorPkScore != null && matchObj.visitorPkScore != undefined) {
          visitorPKGoal = matchObj.visitorPkScore;
        }
      }

      this.homeTeamScore = matchObj != undefined && matchObj != null ? matchObj.goalFor + matchObj.homeExScore + homePKGoal : "";
      this.vistingTeamScore = matchObj != undefined && matchObj != null ? matchObj.goalAgainst + matchObj.visitorExScore + visitorPKGoal : "";
    }
  },
  data: function data() {
    return {
      date: "今天",
      roundName: "",
      homeTeamName: "A",
      vistingTeamName: "B",
      homeTeamScore: "2",
      vistingTeamScore: "3",
      assets: [],
      defaultImg: 'this.src="' + __webpack_require__("KXse") + '"',
      videoTag: __webpack_require__("+vEQ")
    };
  },

  watch: {
    matchMoments: function matchMoments(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c4e9109","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/momentsCard.vue
var momentsCard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","margin":"10px 10px 10px 10px","height":"70px"},on:{"click":this.viewDetail}},[_c('flexbox',{attrs:{"justify":"center","align":"center"}},[_c('flexbox-item',{attrs:{"span":1/8,"align":"center"}},[_c('div',{domProps:{"innerHTML":_vm._s(this.date)}})]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"padding":"0"},attrs:{"span":1/4,"align":"center"}},[(this.assets.length==1)?_c('div',{staticStyle:{"position":"relative","width":"70px","height":"70px"}},[_c('MomentThumb',{staticStyle:{"position":"absolute","top":"3px","left":"3px","width":"64px","height":"64px"},attrs:{"asset":this.assets[0]}})],1):_vm._e(),_vm._v(" "),(this.assets.length==2)?_c('div',{staticStyle:{"position":"relative","width":"70px","height":"70px"}},[_c('MomentThumb',{staticStyle:{"position":"absolute","top":"3px","left":"3px","width":"31px","height":"64px"},attrs:{"asset":this.assets[0]}}),_vm._v(" "),_c('MomentThumb',{staticStyle:{"position":"absolute","top":"3px","left":"36px","width":"31px","height":"64px"},attrs:{"asset":this.assets[1]}})],1):_vm._e(),_vm._v(" "),(this.assets.length==3)?_c('div',{staticStyle:{"position":"relative","width":"70px","height":"70px"}},[_c('MomentThumb',{staticStyle:{"position":"absolute","top":"3px","left":"3px","width":"31px","height":"64px"},attrs:{"asset":this.assets[0]}}),_vm._v(" "),_c('MomentThumb',{staticStyle:{"position":"absolute","top":"3px","left":"36px","width":"31px","height":"31px"},attrs:{"asset":this.assets[1]}}),_vm._v(" "),_c('MomentThumb',{staticStyle:{"position":"absolute","top":"36px","left":"36px","width":"31px","height":"31px"},attrs:{"asset":this.assets[2]}})],1):_vm._e(),_vm._v(" "),(this.assets.length>=4)?_c('div',{staticStyle:{"position":"relative","width":"70px","height":"70px"}},[_c('MomentThumb',{staticStyle:{"position":"absolute","top":"3px","left":"3px","width":"31px","height":"31px"},attrs:{"asset":this.assets[0]}}),_vm._v(" "),_c('MomentThumb',{staticStyle:{"position":"absolute","top":"3px","left":"36px","width":"31px","height":"31px"},attrs:{"asset":this.assets[1]}}),_vm._v(" "),_c('MomentThumb',{staticStyle:{"position":"absolute","top":"36px","left":"3px","width":"31px","height":"31px"},attrs:{"asset":this.assets[2]}}),_vm._v(" "),_c('MomentThumb',{staticStyle:{"position":"absolute","top":"36px","left":"36px","width":"31px","height":"31px"},attrs:{"asset":this.assets[3]}})],1):_vm._e()]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticStyle:{"width":"100%","height":"26px"}},[_c('flexbox',{attrs:{"justify":"center","align":"center"}},[_c('flexbox-item',{attrs:{"span":9}},[_c('div',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis","height":"20px","line-height":"20px","font-family":"PingFangSC-Medium","font-size":"12px","color":"#333333","letter-spacing":"0"}},[_vm._v("\n                            "+_vm._s(this.homeTeamName)+"\n                        ")])]),_vm._v(" "),_c('flexbox-item',{attrs:{"align":"right"}},[_c('div',{staticStyle:{"height":"26px","line-height":"26px","font-family":"Arial-Black","font-size":"18px","color":"#FE2754","letter-spacing":"0"}},[_vm._v("\n                            "+_vm._s(this.homeTeamScore)+"\n                        ")])])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"26px"}},[_c('flexbox',{attrs:{"justify":"center","align":"center"}},[_c('flexbox-item',{attrs:{"span":9}},[_c('div',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis","height":"20px","line-height":"20px","font-family":"PingFangSC-Medium","font-size":"12px","color":"#333333","letter-spacing":"0"}},[_vm._v("\n                            "+_vm._s(this.vistingTeamName)+"\n                        ")])]),_vm._v(" "),_c('flexbox-item',{attrs:{"align":"right"}},[_c('div',{staticStyle:{"height":"26px","line-height":"26px","font-family":"Arial-Black","font-size":"18px","color":"#FE2754","letter-spacing":"0"}},[_vm._v("\n                            "+_vm._s(this.vistingTeamScore)+"\n                        ")])])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"12px"}},[_c('div',{staticStyle:{"position":"relative","height":"12px","line-height":"12px"}},[_c('img',{staticStyle:{"position":"absolute","top":"2px","width":"8px","height":"8px"},attrs:{"src":__webpack_require__("XdJ7")}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"10px","height":"100%","font-family":"PingFangSC-Regular","font-size":"8px","color":"#999999","letter-spacing":"0"}},[_vm._v("\n                        "+_vm._s(this.roundName)+"\n                    ")])])])])],1)],1)}
var momentsCard_staticRenderFns = []
var momentsCard_esExports = { render: momentsCard_render, staticRenderFns: momentsCard_staticRenderFns }
/* harmony default export */ var components_league_momentsCard = (momentsCard_esExports);
// CONCATENATED MODULE: ./src/components/league/momentsCard.vue
function momentsCard_injectStyle (ssrContext) {
  __webpack_require__("ZRSg")
}
var momentsCard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var momentsCard___vue_template_functional__ = false
/* styles */
var momentsCard___vue_styles__ = momentsCard_injectStyle
/* scopeId */
var momentsCard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var momentsCard___vue_module_identifier__ = null
var momentsCard_Component = momentsCard_normalizeComponent(
  league_momentsCard,
  components_league_momentsCard,
  momentsCard___vue_template_functional__,
  momentsCard___vue_styles__,
  momentsCard___vue_scopeId__,
  momentsCard___vue_module_identifier__
)

/* harmony default export */ var src_components_league_momentsCard = (momentsCard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueShooters.vue




















/* harmony default export */ var leagueShooters = ({
  props: {},
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Avatar: vue_avatar_min_default.a,
    MomentsCard: src_components_league_momentsCard
  },
  mounted: function mounted() {
    var _this = this;

    if (this.eventHub) {
      this.eventHub.$on('loadMoreShooters', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabShooters', function () {
        _this.refreshTab();
      });
    }
    this.initTab();

    this.shooterInfo = [];
    var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-射手榜',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    getShooterAvatarUrl: function getShooterAvatarUrl(avatarId) {
      return this.hagkApi.getImgAsset(avatarId).url + '.jpg';
    },
    initShooters: function initShooters(data) {
      if (data && data.length > 0) {
        this.shooterStart = data.length;
        for (var i = 0; i < data.length; i++) {
          data[i].avatarUrl = this.getShooterAvatarUrl(data[i].avatarId);
          data[i].useDefault = true;
        }
        this.shooterInfo = data;
      } else {
        this.shooterStart = 0;
        this.shooterInfo = [];
        this.nodataTxt = "暂无数据";
      }
    },
    loadMoreshooterInfo: function loadMoreshooterInfo(data) {
      if (data && data.length > 0) {
        this.shooterStart += data.length;
        for (var i = 0; i < data.length; i++) {
          data[i].avatarUrl = this.getShooterAvatarUrl(data[i].avatarId);
          this.shooterInfo.push(data[i]);
        }
      } else {
        this.nodataTxt = "暂无数据";
      }
      return;
    },
    loadData: function loadData(id, start, length, type, successCall, afterCall) {
      var _this2 = this;

      this.nodataTxt = "";
      this.hagkHttp(this.hagkApi.getLeagueShooters(id, start, length), {}).then(function (res) {
        if (res.status == true) {
          successCall(res.result);
          if (res.result && res.result.length == 0) {
            _this2.nodataTxt = "暂无数据";
          }
        }
        afterCall();
      }, function (error) {
        afterCall();
      });
    },
    initTab: function initTab() {
      var _this3 = this;

      this.eventHub.$emit("setTabIndex", "shooterList");
      this.initWxShareConfig();
      var leagueId = parseInt(this.leagueId);
      if (this.shooterInfo.length == 0) {
        this.$vux.loading.show({
          text: '加载中...'
        });
        this.loadData(leagueId, 0, 10, "reserved", this.initShooters, function () {
          _this3.$vux.loading.hide();
        });
      }
    },
    refreshTab: function refreshTab() {
      var _this4 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, 0, 10, "reserved", this.initShooters, function () {
        _this4.eventHub.$emit("enablerefreshTab");
      });
    },
    loadMore: function loadMore() {
      var _this5 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, this.shooterStart, 10, "reserved", this.loadMoreshooterInfo, function () {
        _this5.eventHub.$emit("enableloadMore");
      });
    }
  },
  data: function data() {
    return {
      currentPage: null,
      nodataTxt: "",
      defaultImageUrl: __webpack_require__("zQrT"),
      defaultImg: 'this.src="' + __webpack_require__("zQrT") + '"',
      shooterStart: 0,
      shooterInfo: [],
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueShooters.vue




















/* harmony default export */ var views_leagueShooters = ({
  props: {},
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Avatar: vue_avatar_min_default.a,
    MomentsCard: src_components_league_momentsCard
  },
  mounted: function mounted() {
    var _this = this;

    if (this.eventHub) {
      this.eventHub.$on('loadMoreShooters', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabShooters', function () {
        _this.refreshTab();
      });
    }
    this.initTab();

    this.shooterInfo = [];
    var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-射手榜',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    getShooterAvatarUrl: function getShooterAvatarUrl(avatarId) {
      return this.hagkApi.getImgAsset(avatarId).url + '.jpg';
    },
    initShooters: function initShooters(data) {
      if (data && data.length > 0) {
        this.shooterStart = data.length;
        for (var i = 0; i < data.length; i++) {
          data[i].avatarUrl = this.getShooterAvatarUrl(data[i].avatarId);
          data[i].useDefault = true;
        }
        this.shooterInfo = data;
      } else {
        this.shooterStart = 0;
        this.shooterInfo = [];
        this.nodataTxt = "暂无数据";
      }
    },
    loadMoreshooterInfo: function loadMoreshooterInfo(data) {
      if (data && data.length > 0) {
        this.shooterStart += data.length;
        for (var i = 0; i < data.length; i++) {
          data[i].avatarUrl = this.getShooterAvatarUrl(data[i].avatarId);
          this.shooterInfo.push(data[i]);
        }
      } else {
        this.nodataTxt = "暂无数据";
      }
      return;
    },
    loadData: function loadData(id, start, length, type, successCall, afterCall) {
      var _this2 = this;

      this.nodataTxt = "";
      this.hagkHttp(this.hagkApi.getLeagueShooters(id, start, length), {}).then(function (res) {
        if (res.status == true) {
          successCall(res.result);
          if (res.result && res.result.length == 0) {
            _this2.nodataTxt = "暂无数据";
          }
        }
        afterCall();
      }, function (error) {
        afterCall();
      });
    },
    initTab: function initTab() {
      var _this3 = this;

      this.eventHub.$emit("setTabIndex", "shooterList");
      this.initWxShareConfig();
      var leagueId = parseInt(this.leagueId);
      if (this.shooterInfo.length == 0) {
        this.$vux.loading.show({
          text: '加载中...'
        });
        this.loadData(leagueId, 0, 10, "reserved", this.initShooters, function () {
          _this3.$vux.loading.hide();
        });
      }
    },
    refreshTab: function refreshTab() {
      var _this4 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, 0, 10, "reserved", this.initShooters, function () {
        _this4.eventHub.$emit("enablerefreshTab");
      });
    },
    loadMore: function loadMore() {
      var _this5 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, this.shooterStart, 10, "reserved", this.loadMoreshooterInfo, function () {
        _this5.eventHub.$emit("enableloadMore");
      });
    }
  },
  data: function data() {
    return {
      currentPage: null,
      nodataTxt: "",
      defaultImageUrl: __webpack_require__("zQrT"),
      defaultImg: 'this.src="' + __webpack_require__("zQrT") + '"',
      shooterStart: 0,
      shooterInfo: [],
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449718da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/leagueShooters.vue
var leagueShooters_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box2"},[(this.shooterInfo&&this.shooterInfo.length>0)?_c('div',{staticClass:"league-shoot",staticStyle:{"margin-top":"10px"}},[_c('table',[_vm._m(0),_vm._v(" "),_vm._l((this.shooterInfo),function(shooterBoard,index){return [_c('tr',[_c('td',{staticClass:"index"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[(shooterBoard.useDefault)?_c('img',{staticStyle:{"border-radius":"50%"},attrs:{"src":shooterBoard.avatarUrl,"width":"30px","height":"30px"},on:{"error":function($event){shooterBoard.useDefault=false}}}):_vm._e(),_vm._v(" "),(!shooterBoard.useDefault)?_c('avatar',{attrs:{"username":shooterBoard.playerName,"size":30,"rounded":true,"lighten":100}}):_vm._e()],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"0"},attrs:{"nowrap":"nowrap"}},[_vm._v(_vm._s(shooterBoard.playerName))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(shooterBoard.teamName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(shooterBoard.goals))])])]})],2)]):_c('div',{staticStyle:{"margin":"0 auto","width":"100%","text-align":"center","margin-top":"100px","font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v("\n            "+_vm._s(this.nodataTxt)+"\n        ")])])])}
var leagueShooters_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("排名")]),_vm._v(" "),_c('th',{attrs:{"width":"28%","colspan":"2"}},[_vm._v("球员")]),_vm._v(" "),_c('th',[_vm._v("球队")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("进球")])])}]
var leagueShooters_esExports = { render: leagueShooters_render, staticRenderFns: leagueShooters_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_leagueShooters = (leagueShooters_esExports);
// CONCATENATED MODULE: ./src/views/leagueShooters.vue
function leagueShooters_injectStyle (ssrContext) {
  __webpack_require__("HL9a")
}
var leagueShooters_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leagueShooters___vue_template_functional__ = false
/* styles */
var leagueShooters___vue_styles__ = leagueShooters_injectStyle
/* scopeId */
var leagueShooters___vue_scopeId__ = "data-v-449718da"
/* moduleIdentifier (server only) */
var leagueShooters___vue_module_identifier__ = null
var leagueShooters_Component = leagueShooters_normalizeComponent(
  views_leagueShooters,
  selectortype_template_index_0_src_views_leagueShooters,
  leagueShooters___vue_template_functional__,
  leagueShooters___vue_styles__,
  leagueShooters___vue_scopeId__,
  leagueShooters___vue_module_identifier__
)

/* harmony default export */ var src_views_leagueShooters = (leagueShooters_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueMoments.vue
















/* harmony default export */ var leagueMoments = ({
  props: {},
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    MomentsCard: src_components_league_momentsCard
  },
  mounted: function mounted() {
    var _this = this;

    this.momentsInfo = [];
    if (this.eventHub) {
      this.eventHub.$on('loadMoreMoments', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabMoments', function () {
        _this.refreshTab();
      });
    }
    this.initTab();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-精彩瞬间',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    initMoments: function initMoments(data) {
      if (data && data.length > 0) {
        this.momentsStart = data.length;
        this.momentsInfo = data;
        console.log(this.momentsInfo, '---------------');
      } else {
        this.momentsStart = 0;
        this.momentsInfo = [];
        this.nodataTxt = "暂无数据";
      }
    },
    loadMoreMomentsInfo: function loadMoreMomentsInfo(data) {
      if (data && data.length > 0) {
        this.momentsStart += data.length;
        for (var i = 0; i < data.length; i++) {
          this.momentsInfo.push(data[i]);
        }
      } else {
        this.nodataTxt = "暂无数据";
      }
      return;
    },
    loadData: function loadData(id, start, length, type, successCall, afterCall) {

      this.hagkHttp(this.hagkApi.getLeagueMatchesAssets(id, start, length), {}).then(function (res) {
        if (res.status == true) {
          successCall(res.result);
        }
        afterCall();
      }, function (error) {
        afterCall();
      });
    },
    initTab: function initTab() {
      var _this2 = this;

      this.eventHub.$emit("setTabIndex", "leagueMoments");
      this.initWxShareConfig();
      var leagueId = parseInt(this.leagueId);
      if (this.momentsInfo.length == 0) {
        this.$vux.loading.show({
          text: '加载中...'
        });
        this.loadData(leagueId, 0, 5, "reserved", this.initMoments, function () {
          _this2.$vux.loading.hide();
        });
      }
    },
    refreshTab: function refreshTab() {
      var _this3 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, 0, 5, "reserved", this.initMoments, function () {
        _this3.eventHub.$emit("enablerefreshTab");
      });
    },
    loadMore: function loadMore() {
      var _this4 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, this.momentsStart, 5, "reserved", this.loadMoreMomentsInfo, function () {
        _this4.eventHub.$emit("enableloadMore");
      });
    }
  },
  data: function data() {
    return {
      currentPage: null,
      nodataTxt: "暂无数据",
      momentsStart: 0,
      momentsInfo: [],
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo,
      currentOrgCode: src_configInfo.orgCode
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueMoments.vue
















/* harmony default export */ var views_leagueMoments = ({
  props: {},
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    MomentsCard: src_components_league_momentsCard
  },
  mounted: function mounted() {
    var _this = this;

    this.momentsInfo = [];
    if (this.eventHub) {
      this.eventHub.$on('loadMoreMoments', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabMoments', function () {
        _this.refreshTab();
      });
    }
    this.initTab();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-精彩瞬间',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    initMoments: function initMoments(data) {
      if (data && data.length > 0) {
        this.momentsStart = data.length;
        this.momentsInfo = data;
        console.log(this.momentsInfo, '---------------');
      } else {
        this.momentsStart = 0;
        this.momentsInfo = [];
        this.nodataTxt = "暂无数据";
      }
    },
    loadMoreMomentsInfo: function loadMoreMomentsInfo(data) {
      if (data && data.length > 0) {
        this.momentsStart += data.length;
        for (var i = 0; i < data.length; i++) {
          this.momentsInfo.push(data[i]);
        }
      } else {
        this.nodataTxt = "暂无数据";
      }
      return;
    },
    loadData: function loadData(id, start, length, type, successCall, afterCall) {

      this.hagkHttp(this.hagkApi.getLeagueMatchesAssets(id, start, length), {}).then(function (res) {
        if (res.status == true) {
          successCall(res.result);
        }
        afterCall();
      }, function (error) {
        afterCall();
      });
    },
    initTab: function initTab() {
      var _this2 = this;

      this.eventHub.$emit("setTabIndex", "leagueMoments");
      this.initWxShareConfig();
      var leagueId = parseInt(this.leagueId);
      if (this.momentsInfo.length == 0) {
        this.$vux.loading.show({
          text: '加载中...'
        });
        this.loadData(leagueId, 0, 5, "reserved", this.initMoments, function () {
          _this2.$vux.loading.hide();
        });
      }
    },
    refreshTab: function refreshTab() {
      var _this3 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, 0, 5, "reserved", this.initMoments, function () {
        _this3.eventHub.$emit("enablerefreshTab");
      });
    },
    loadMore: function loadMore() {
      var _this4 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, this.momentsStart, 5, "reserved", this.loadMoreMomentsInfo, function () {
        _this4.eventHub.$emit("enableloadMore");
      });
    }
  },
  data: function data() {
    return {
      currentPage: null,
      nodataTxt: "暂无数据",
      momentsStart: 0,
      momentsInfo: [],
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo,
      currentOrgCode: src_configInfo.orgCode
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bde5222","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/leagueMoments.vue
var leagueMoments_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box2"},[(this.currentOrgCode !== '13702' && this.momentsInfo&&this.momentsInfo.length>0)?_c('div',{staticStyle:{"margin-top":"40px"}},[_vm._l((this.momentsInfo),function(matchMoments){return [_c('MomentsCard',{attrs:{"matchMoments":matchMoments}})]})],2):_c('div',{staticStyle:{"margin":"0 auto","width":"100%","text-align":"center","margin-top":"100px"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(this.nodataTxt))])])])])}
var leagueMoments_staticRenderFns = []
var leagueMoments_esExports = { render: leagueMoments_render, staticRenderFns: leagueMoments_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_leagueMoments = (leagueMoments_esExports);
// CONCATENATED MODULE: ./src/views/leagueMoments.vue
function leagueMoments_injectStyle (ssrContext) {
  __webpack_require__("Dy88")
  __webpack_require__("Yshg")
}
var leagueMoments_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leagueMoments___vue_template_functional__ = false
/* styles */
var leagueMoments___vue_styles__ = leagueMoments_injectStyle
/* scopeId */
var leagueMoments___vue_scopeId__ = "data-v-4bde5222"
/* moduleIdentifier (server only) */
var leagueMoments___vue_module_identifier__ = null
var leagueMoments_Component = leagueMoments_normalizeComponent(
  views_leagueMoments,
  selectortype_template_index_0_src_views_leagueMoments,
  leagueMoments___vue_template_functional__,
  leagueMoments___vue_styles__,
  leagueMoments___vue_scopeId__,
  leagueMoments___vue_module_identifier__
)

/* harmony default export */ var src_views_leagueMoments = (leagueMoments_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueData.vue















/* harmony default export */ var leagueData = ({
  props: {},
  data: function data() {
    return {
      currentPage: null,
      league: {},
      bestTeamNameLength: 10,
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.eventHub) {
      this.eventHub.$on('loadMoreData', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabData', function () {
        _this.refreshTab();
      });
    }
    this.initTab();

    this.$nextTick(function () {
      var width = document.body.clientWidth;
      if (width < 360) {
        _this.bestTeamNameLength = 10;
      } else {
        _this.bestTeamNameLength = 15;
      }
    });
  },

  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-战术数据',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    initTab: function initTab() {
      var _this2 = this;

      this.eventHub.$emit("setTabIndex", "leagueData");
      this.initWxShareConfig();
      var leagueId = parseInt(this.leagueId);
      if (!this.league.statistic) {
        this.$vux.loading.show({
          text: '加载中...'
        });
        this.loadData(leagueId, function () {
          _this2.$vux.loading.hide();
        });
      }
    },
    loadData: function loadData(leageId, afterCall) {
      var _this3 = this;

      this.hagkHttp(this.hagkApi.getLeagueData(leageId), {}).then(function (res) {
        if (res.status == true) {
          _this3.league = res.result;
          if (res.result) {
            _this3.getBest();
          }
        }
      }, function (error) {
        console.log(error);
      });
      afterCall();
    },
    refreshTab: function refreshTab() {
      var _this4 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, function () {
        _this4.eventHub.$emit("enablerefreshTab");
      });
    },
    loadMore: function loadMore() {
      this.eventHub.$emit("enableloadMore");
    },

    getBest: function getBest() {
      var scoreBoard = [];
      if (this.league.scoreBoard) {
        scoreBoard = this.league.scoreBoard;
      }
      var bestGoalFor;
      var bestGoalAgainst;
      var maxAvgGoal = 0;
      var minAvgLoss = 9999;
      for (var i = 0; i < scoreBoard.length; i++) {
        if (0 == scoreBoard[i].matchNum) {
          continue;
        }

        var tempAvgGoal = (scoreBoard[i].goal / scoreBoard[i].matchNum).toFixed(2);
        if (tempAvgGoal > maxAvgGoal) {
          maxAvgGoal = tempAvgGoal;
          bestGoalFor = scoreBoard[i];
        }

        var tempAvgLoss = (scoreBoard[i].loss / scoreBoard[i].matchNum).toFixed(2);
        if (tempAvgLoss < minAvgLoss) {
          minAvgLoss = tempAvgLoss;
          bestGoalAgainst = scoreBoard[i];
        }
      }
      if (maxAvgGoal > 0) {
        this.league.bestGoalFor = bestGoalFor;
      }
      if (minAvgLoss < 9999) {
        this.league.bestGoalAgainst = bestGoalAgainst;
      }
    }
  },
  filters: {
    subfilter: function subfilter(value, sublength) {
      if (!value) return '';
      value = value.toString();
      if (value.length > sublength) {
        return value.substr(0, sublength) + "...";
      }
      return value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueData.vue















/* harmony default export */ var views_leagueData = ({
  props: {},
  data: function data() {
    return {
      currentPage: null,
      league: {},
      bestTeamNameLength: 10,
      leagueId: this.$route.query.leagueId,
      eventHub: this.$store.getters.getEventHub,
      leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.eventHub) {
      this.eventHub.$on('loadMoreData', function () {
        _this.loadMore();
      });
      this.eventHub.$on('refreshTabData', function () {
        _this.refreshTab();
      });
    }
    this.initTab();

    this.$nextTick(function () {
      var width = document.body.clientWidth;
      if (width < 360) {
        _this.bestTeamNameLength = 10;
      } else {
        _this.bestTeamNameLength = 15;
      }
    });
  },

  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.currentPage) {}
    next();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      this.currentPage = window.location.href;
      var fullPath = window.location.href;

      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      if (this.leagueBasicInfo.league_logo) {
        shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
      }
      console.log(fullPath);

      utils_wxShareConfig({
        title: this.leagueBasicInfo.title + '-战术数据',
        desc: "来自未来足球赛事系统",
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {
        console.log("share success");
      }, function () {
        console.log("share error");
      });
    },
    initTab: function initTab() {
      var _this2 = this;

      this.eventHub.$emit("setTabIndex", "leagueData");
      this.initWxShareConfig();
      var leagueId = parseInt(this.leagueId);
      if (!this.league.statistic) {
        this.$vux.loading.show({
          text: '加载中...'
        });
        this.loadData(leagueId, function () {
          _this2.$vux.loading.hide();
        });
      }
    },
    loadData: function loadData(leageId, afterCall) {
      var _this3 = this;

      this.hagkHttp(this.hagkApi.getLeagueData(leageId), {}).then(function (res) {
        if (res.status == true) {
          _this3.league = res.result;
          if (res.result) {
            _this3.getBest();
          }
        }
      }, function (error) {
        console.log(error);
      });
      afterCall();
    },
    refreshTab: function refreshTab() {
      var _this4 = this;

      var leagueId = parseInt(this.leagueId);
      this.loadData(leagueId, function () {
        _this4.eventHub.$emit("enablerefreshTab");
      });
    },
    loadMore: function loadMore() {
      this.eventHub.$emit("enableloadMore");
    },

    getBest: function getBest() {
      var scoreBoard = [];
      if (this.league.scoreBoard) {
        scoreBoard = this.league.scoreBoard;
      }
      var bestGoalFor;
      var bestGoalAgainst;
      var maxAvgGoal = 0;
      var minAvgLoss = 9999;
      for (var i = 0; i < scoreBoard.length; i++) {
        if (0 == scoreBoard[i].matchNum) {
          continue;
        }

        var tempAvgGoal = (scoreBoard[i].goal / scoreBoard[i].matchNum).toFixed(2);
        if (tempAvgGoal > maxAvgGoal) {
          maxAvgGoal = tempAvgGoal;
          bestGoalFor = scoreBoard[i];
        }

        var tempAvgLoss = (scoreBoard[i].loss / scoreBoard[i].matchNum).toFixed(2);
        if (tempAvgLoss < minAvgLoss) {
          minAvgLoss = tempAvgLoss;
          bestGoalAgainst = scoreBoard[i];
        }
      }
      if (maxAvgGoal > 0) {
        this.league.bestGoalFor = bestGoalFor;
      }
      if (minAvgLoss < 9999) {
        this.league.bestGoalAgainst = bestGoalAgainst;
      }
    }
  },
  filters: {
    subfilter: function subfilter(value, sublength) {
      if (!value) return '';
      value = value.toString();
      if (value.length > sublength) {
        return value.substr(0, sublength) + "...";
      }
      return value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b26585b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/leagueData.vue
var leagueData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-content"},[(_vm.league.statistic)?_c('div',{staticClass:"league-data"},[_c('div',{staticClass:"sub-data data-up"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.matchNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("比赛场次")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zEvL"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.goalNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("进球数量")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5mmK"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.teamNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("球队数量")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("YAkp"),"height":"20","width":"20"}})])]),_vm._v(" "),_c('div',{staticClass:"sub-data data-middle"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.playerNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("球员数量")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("lbSq"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.redNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("红牌")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zn2l"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.yellowNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("黄牌")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("bkOh"),"height":"20","width":"20"}})])]),_vm._v(" "),_c('div',{staticClass:"sub-data data-middle"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.goalPlayerNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("进球队员数")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("DyGf"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.avgGoal))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("场均进球")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5mmK"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.fastestGoal))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("最快进球")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("/w0U"),"height":"20","width":"20"}})])]),_vm._v(" "),_c('div',{staticClass:"sub-data data-down"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.maxScoreDiff))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("最大分差")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("QhYL"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.avgRed))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("场均红牌")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("dgeV"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.league.statistic.avgYellow))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("场均黄牌")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("qqWH"),"height":"20","width":"20"}})])])]):_vm._e(),_vm._v(" "),(_vm.league.bestGoalFor)?[_c('div',{staticClass:"league-best"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":__webpack_require__("hK2L"),"height":"14","width":"14"}}),_vm._v(" "),_c('span',{staticClass:"key"},[_vm._v("最佳进攻球队")]),_vm._v(" "),_c('span',{staticClass:"team-name",attrs:{"title":_vm.league.bestGoalFor.teamName}},[_vm._v(_vm._s(_vm._f("subfilter")(_vm.league.bestGoalFor.teamName,_vm.bestTeamNameLength)))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"key"},[_vm._v("进球")]),_vm._v(" "),_c('span',{staticClass:"goals"},[_vm._v(_vm._s(_vm.league.bestGoalFor.goal))])])])]:_vm._e(),_vm._v(" "),(_vm.league.bestGoalAgainst)?[_c('div',{staticClass:"league-best"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":__webpack_require__("ZKQ2"),"height":"14","width":"14"}}),_vm._v(" "),_c('span',{staticClass:"key"},[_vm._v("最佳防守球队")]),_vm._v(" "),_c('span',{staticClass:"team-name",attrs:{"title":_vm.league.bestGoalAgainst.teamName}},[_vm._v(_vm._s(_vm._f("subfilter")(_vm.league.bestGoalAgainst.teamName,_vm.bestTeamNameLength)))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"key"},[_vm._v("丢球")]),_vm._v(" "),_c('span',{staticClass:"goals"},[_vm._v(_vm._s(_vm.league.bestGoalAgainst.loss))])])])]:_vm._e()],2)}
var leagueData_staticRenderFns = []
var leagueData_esExports = { render: leagueData_render, staticRenderFns: leagueData_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_leagueData = (leagueData_esExports);
// CONCATENATED MODULE: ./src/views/leagueData.vue
function leagueData_injectStyle (ssrContext) {
  __webpack_require__("nPaY")
}
var leagueData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leagueData___vue_template_functional__ = false
/* styles */
var leagueData___vue_styles__ = leagueData_injectStyle
/* scopeId */
var leagueData___vue_scopeId__ = "data-v-0b26585b"
/* moduleIdentifier (server only) */
var leagueData___vue_module_identifier__ = null
var leagueData_Component = leagueData_normalizeComponent(
  views_leagueData,
  selectortype_template_index_0_src_views_leagueData,
  leagueData___vue_template_functional__,
  leagueData___vue_styles__,
  leagueData___vue_scopeId__,
  leagueData___vue_module_identifier__
)

/* harmony default export */ var src_views_leagueData = (leagueData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LeagueHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var LeagueHeader = ({
    name: 'leagueHeader',
    props: ['leagueBasicInfo'],
    watch: {
        leagueBasicInfo: function leagueBasicInfo() {
            this._reload(this.leagueBasicInfo);
        }
    },
    ready: function ready() {
        $.init();
    },
    data: function data() {
        return {
            league_logo_url: '',
            league_time: "",
            league_status_label: "",
            league_title: "",
            league_logo: "",
            league_status: ""
        };
    },
    mounted: function mounted() {
        this._reload(this.leagueBasicInfo);
    },

    computed: {},
    methods: {
        _reload: function _reload(leagueBasicInfo) {
            // 增加空值容错，避免报错
            if (!leagueBasicInfo) return;

            this.league_title = leagueBasicInfo.title;
            this.league_status = leagueBasicInfo.league_status;

            if ("registering" == leagueBasicInfo.league_status) {
                var buffer = new Array();
                buffer.push("报名时间 ");
                buffer.push(leagueBasicInfo.reg_start_time);
                buffer.push(" - ");
                buffer.push(leagueBasicInfo.reg_end_time);
                this.league_time = buffer.join("");
                this.league_status_label = "报名中";
            }
            if ("registered" == leagueBasicInfo.league_status) {
                var buffer = new Array();
                buffer.push("比赛时间 ");
                buffer.push(leagueBasicInfo.league_start_time);
                this.league_time = buffer.join("");
                this.league_status_label = "待开赛";
            }
            if ("inprogress" == leagueBasicInfo.league_status) {
                var buffer = new Array();
                buffer.push("比赛时间 ");
                buffer.push(leagueBasicInfo.league_start_time);
                this.league_time = buffer.join("");
                this.league_status_label = "比赛中";
            }
            if ("finished" == leagueBasicInfo.league_status) {
                var buffer = new Array();
                buffer.push("比赛时间 ");
                buffer.push(leagueBasicInfo.league_start_time);
                this.league_time = buffer.join("");
                this.league_status_label = "已结束";
            }

            this.league_logo = leagueBasicInfo.league_logo;
            // 容错：避免logo为空时调用方法报错
            if (this.league_logo && this.hagkApi) {
                this.league_logo_url = this.hagkApi.getImgAssetById(this.league_logo).url;
            }
        }
    },
    components: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LeagueHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_LeagueHeader = ({
    name: 'leagueHeader',
    props: ['leagueBasicInfo'],
    watch: {
        leagueBasicInfo: function leagueBasicInfo() {
            this._reload(this.leagueBasicInfo);
        }
    },
    ready: function ready() {
        $.init();
    },
    data: function data() {
        return {
            league_logo_url: '',
            league_time: "",
            league_status_label: "",
            league_title: "",
            league_logo: "",
            league_status: ""
        };
    },
    mounted: function mounted() {
        this._reload(this.leagueBasicInfo);
    },

    computed: {},
    methods: {
        _reload: function _reload(leagueBasicInfo) {
            // 增加空值容错，避免报错
            if (!leagueBasicInfo) return;

            this.league_title = leagueBasicInfo.title;
            this.league_status = leagueBasicInfo.league_status;

            if ("registering" == leagueBasicInfo.league_status) {
                var buffer = new Array();
                buffer.push("报名时间 ");
                buffer.push(leagueBasicInfo.reg_start_time);
                buffer.push(" - ");
                buffer.push(leagueBasicInfo.reg_end_time);
                this.league_time = buffer.join("");
                this.league_status_label = "报名中";
            }
            if ("registered" == leagueBasicInfo.league_status) {
                var buffer = new Array();
                buffer.push("比赛时间 ");
                buffer.push(leagueBasicInfo.league_start_time);
                this.league_time = buffer.join("");
                this.league_status_label = "待开赛";
            }
            if ("inprogress" == leagueBasicInfo.league_status) {
                var buffer = new Array();
                buffer.push("比赛时间 ");
                buffer.push(leagueBasicInfo.league_start_time);
                this.league_time = buffer.join("");
                this.league_status_label = "比赛中";
            }
            if ("finished" == leagueBasicInfo.league_status) {
                var buffer = new Array();
                buffer.push("比赛时间 ");
                buffer.push(leagueBasicInfo.league_start_time);
                this.league_time = buffer.join("");
                this.league_status_label = "已结束";
            }

            this.league_logo = leagueBasicInfo.league_logo;
            // 容错：避免logo为空时调用方法报错
            if (this.league_logo && this.hagkApi) {
                this.league_logo_url = this.hagkApi.getImgAssetById(this.league_logo).url;
            }
        }
    },
    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66586d87","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeagueHeader.vue
var LeagueHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article"},[_c('div',{staticClass:"league_header",class:{'hefei-bg': _vm.league_title === '合肥市城市足球联赛'}},[_c('div',{staticClass:"avatar-profile-placeholder",class:{'hide-content': _vm.league_title === '合肥市城市足球联赛'}},[(_vm.league_logo)?_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":_vm.league_logo_url}})]):_c('div',{staticClass:"avatar-icon"},[_c('img',{attrs:{"src":__webpack_require__("xiEX")}})])]),_vm._v(" "),_c('div',{staticClass:"league_title-placeholder",class:{'hide-content': _vm.league_title === '合肥市城市足球联赛'}},[_vm._v("\n            "+_vm._s(_vm.league_title)+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"5px"}},[_c('img',{staticStyle:{"display":"inline-block","width":"14px","height":"14px","margin-bottom":"2px"},attrs:{"src":__webpack_require__("WcVR")}}),_vm._v(" "),_c('div',{staticClass:"league_time"},[_vm._v(_vm._s(_vm.league_time))])]),_vm._v(" "),_c('div',{staticClass:"league_status",class:'league_status_' + _vm.league_status},[_vm._v(_vm._s(_vm.league_status_label))])])])}
var LeagueHeader_staticRenderFns = []
var LeagueHeader_esExports = { render: LeagueHeader_render, staticRenderFns: LeagueHeader_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LeagueHeader = (LeagueHeader_esExports);
// CONCATENATED MODULE: ./src/components/LeagueHeader.vue
function LeagueHeader_injectStyle (ssrContext) {
  __webpack_require__("1JB2")
}
var LeagueHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeagueHeader___vue_template_functional__ = false
/* styles */
var LeagueHeader___vue_styles__ = LeagueHeader_injectStyle
/* scopeId */
var LeagueHeader___vue_scopeId__ = "data-v-66586d87"
/* moduleIdentifier (server only) */
var LeagueHeader___vue_module_identifier__ = null
var LeagueHeader_Component = LeagueHeader_normalizeComponent(
  components_LeagueHeader,
  selectortype_template_index_0_src_components_LeagueHeader,
  LeagueHeader___vue_template_functional__,
  LeagueHeader___vue_styles__,
  LeagueHeader___vue_scopeId__,
  LeagueHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_LeagueHeader = (LeagueHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueOngoing.vue



























/* harmony default export */ var leagueOngoing = ({
  props: {
    leagueId: String
  },
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    LeagueHeader: src_components_LeagueHeader,
    LeagueOngoingArrange: src_views_leagueOngoing_arrange,
    LeagueOngoingJifen: src_views_leagueOngoingJifen,
    LeagueShooters: src_views_leagueShooters,
    LeagueMoments: src_views_leagueMoments,
    LeagueData: src_views_leagueData
  },
  destroyed: function destroyed() {},

  computed: {},
  mounted: function mounted() {
    var _this = this;

    document.body.style.backgroundColor = 'transparent';

    if (this.$route.fullPath.indexOf('/league_ongoing/moments') > -1) {
      this.currentTab = "leagueMoments";
    } else if (this.$route.fullPath.indexOf('/league_ongoing/jifen') > -1) {
      this.currentTab = "leagueTable";
    } else if (this.$route.fullPath.indexOf('/league_ongoing/shooters') > -1) {
      this.currentTab = "shooterList";
    } else if (this.$route.fullPath.indexOf('/league_ongoing/data') > -1) {
      this.currentTab = "leagueData";
    } else {
      this.currentTab = "leagueArrange";
    }

    if (this.$route.query.matchStatus) {
      this.matchStatus = this.$route.query.matchStatus;
    } else {
      this.matchStatus = "league-1";
    }
    var that = this;
    this.hagkHttp(this.hagkApi.getLeagueBasic(this.id), {}).then(function (res) {

      if (res.status == true) {
        var leagueBasic = {};
        leagueBasic.title = res.result.name;
        leagueBasic.league_status = res.result.event_status;
        leagueBasic.league_start_time = res.result.start_date;
        leagueBasic.league_logo = res.result.logo;
        _this.leagueBasicInfo = leagueBasic;
        _this.$store.commit('updateLeagueBasicInfo', leagueBasic);
        document.title = _this.leagueBasicInfo.title;

        _this.initPage();
      }
    }, function (error) {});

    this.eventHub.$on('setTabIndex', function (tabName) {
      _this.currentTab = tabName;
      console.log("setTabIndex " + tabName);
    });

    this.eventHub.$on('resetView', function () {
      _this.$nextTick(function () {
        _this.$refs.scroller.reset();
      });
    });

    this.eventHub.$on('enableloadMore', function () {
      setTimeout(function () {
        _this.$refs.scroller.donePullup();
      }, 10);
    });

    this.eventHub.$on('enablerefreshTab', function () {
      _this.$nextTick(function () {
        setTimeout(function () {
          _this.$refs.scroller.donePulldown();
          _this.pullupEnabled && _this.$refs.scroller.enablePullup();
        }, 10);
      });
    });
  },

  methods: {
    handlerLeagueArrange: function handlerLeagueArrange() {
      this.currentTab = 'leagueArrange';
      this.$router.push({
        path: "/league_ongoing/arrange",
        query: { leagueId: this.id }
      });
    },
    handlerLeagueJifen: function handlerLeagueJifen() {
      this.currentTab = 'leagueTable';
      this.$router.push({
        path: "/league_ongoing/jifen",
        query: { leagueId: this.id }
      });
    },
    handlerLeagueShooters: function handlerLeagueShooters() {
      this.currentTab = 'shooterList';
      this.$router.push({
        path: "/league_ongoing/shooters",
        query: { leagueId: this.id }
      });
    },
    handlerLeagueData: function handlerLeagueData() {
      this.currentTab = 'leagueData';
      this.$router.push({
        path: "/league_ongoing/data",
        query: { leagueId: this.id }
      });
    },
    handlerLeagueMoments: function handlerLeagueMoments() {
      this.currentTab = 'leagueMoments';
      this.$router.push({
        path: "/league_ongoing/moments",
        query: { leagueId: this.id }
      });
    },
    initPage: function initPage() {
      if (this.currentTab == 'leagueArrange') {
        external__Zepto__default()('#leagueArrangeTab').triggerFastClick();
      } else if (this.currentTab == 'leagueMoments') {
        external__Zepto__default()('#leagueMomentsTab').triggerFastClick();
      } else if (this.currentTab == 'shooterList') {
        external__Zepto__default()('#leagueShootersTab').triggerFastClick();
      } else if (this.currentTab == 'leagueTable') {
        external__Zepto__default()('#leagueJifenTab').triggerFastClick();
      } else if (this.currentTab == 'leagueData') {
        external__Zepto__default()('#leagueDataTab').triggerFastClick();
      }
    },
    refreshTab: function refreshTab() {
      if (this.currentTab == 'leagueArrange') {
        this.eventHub.$emit("refreshTabArrange");
      } else if (this.currentTab == 'leagueMoments') {
        this.eventHub.$emit("refreshTabMoments");
      } else if (this.currentTab == 'shooterList') {
        this.eventHub.$emit("refreshTabShooters");
      } else if (this.currentTab == 'leagueTable') {
        this.eventHub.$emit("refreshTabJifen");
      } else if (this.currentTab == 'leagueData') {
        this.eventHub.$emit("refreshTabData");
      }
      return;
    },
    loadMore: function loadMore() {
      if (this.currentTab == 'leagueArrange') {
        this.eventHub.$emit("loadMoreArrange");
      } else if (this.currentTab == 'leagueMoments') {
        this.eventHub.$emit("loadMoreMoments");
      } else if (this.currentTab == 'shooterList') {
        this.eventHub.$emit("loadMoreShooters");
      } else if (this.currentTab == 'leagueTable') {
        this.eventHub.$emit("loadMoreJifen");
      } else if (this.currentTab == 'leagueData') {
        this.eventHub.$emit("loadMoreData");
      }
      return;
    }
  },
  data: function data() {
    var tabNames = ["赛程", "积分榜", "射手榜", "数据", "精彩瞬间"];
    var loadingTab = ['leagueArrange', 'leagueTable', ' shooterList', 'leagueData', 'leagueMoments'];
    this.$store.commit('updateEventHub', new vue_esm["a" /* default */]());

    return {
      id: this.$route.query.leagueId,
      show1: false,
      text1: 'Processing',
      currentTab: 'leagueArrange',
      matchStatus: '',
      eventHub: this.$store.getters.getEventHub,
      pulldownConfig: {
        content: '下拉刷新',
        height: 90,
        autoRefresh: false,
        downContent: '下拉刷新',
        upContent: '松开刷新',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pulldown-'
      },
      pullupConfig: {
        content: '上滑加载更多',
        pullUpHeight: 60,
        height: 40,
        autoRefresh: false,
        downContent: '松开加载',
        upContent: '上滑加载更多',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pullup-'
      },
      roundStart: 0,
      roundLength: 5,
      roundsInfo: [],
      roundUnstartStart: 0,
      roundUnstartLength: 5,
      roundsUnstartInfo: [],
      tabNames: tabNames,
      getBarWidth: function getBarWidth(index) {
        if (this.index >= 0) {
          return tabNames[this.index].length * 22 + 'px';
        }
      },
      leaguetimeDiv: {
        marginBottom: '2px',
        width: '14px',
        height: '14px',
        backgroundImage: 'url(' + __webpack_require__("xxCs") + ')',
        backgroundSize: '14px 14px'
      },
      leagueBasicInfo: {},
      pullupEnabled: true,
      status: {
        pullupStatus: 'default',
        pulldownStatus: 'default'
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueOngoing.vue



























/* harmony default export */ var views_leagueOngoing = ({
  props: {
    leagueId: String
  },
  components: {
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Scroller: vux_src_components_scroller,
    Divider: vux_src_components_divider,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Spinner: node_modules_vux_src_components_spinner,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    LeagueHeader: src_components_LeagueHeader,
    LeagueOngoingArrange: src_views_leagueOngoing_arrange,
    LeagueOngoingJifen: src_views_leagueOngoingJifen,
    LeagueShooters: src_views_leagueShooters,
    LeagueMoments: src_views_leagueMoments,
    LeagueData: src_views_leagueData
  },
  destroyed: function destroyed() {},

  computed: {},
  mounted: function mounted() {
    var _this = this;

    document.body.style.backgroundColor = 'transparent';

    if (this.$route.fullPath.indexOf('/league_ongoing/moments') > -1) {
      this.currentTab = "leagueMoments";
    } else if (this.$route.fullPath.indexOf('/league_ongoing/jifen') > -1) {
      this.currentTab = "leagueTable";
    } else if (this.$route.fullPath.indexOf('/league_ongoing/shooters') > -1) {
      this.currentTab = "shooterList";
    } else if (this.$route.fullPath.indexOf('/league_ongoing/data') > -1) {
      this.currentTab = "leagueData";
    } else {
      this.currentTab = "leagueArrange";
    }

    if (this.$route.query.matchStatus) {
      this.matchStatus = this.$route.query.matchStatus;
    } else {
      this.matchStatus = "league-1";
    }
    var that = this;
    this.hagkHttp(this.hagkApi.getLeagueBasic(this.id), {}).then(function (res) {

      if (res.status == true) {
        var leagueBasic = {};
        leagueBasic.title = res.result.name;
        leagueBasic.league_status = res.result.event_status;
        leagueBasic.league_start_time = res.result.start_date;
        leagueBasic.league_logo = res.result.logo;
        _this.leagueBasicInfo = leagueBasic;
        _this.$store.commit('updateLeagueBasicInfo', leagueBasic);
        document.title = _this.leagueBasicInfo.title;

        _this.initPage();
      }
    }, function (error) {});

    this.eventHub.$on('setTabIndex', function (tabName) {
      _this.currentTab = tabName;
      console.log("setTabIndex " + tabName);
    });

    this.eventHub.$on('resetView', function () {
      _this.$nextTick(function () {
        _this.$refs.scroller.reset();
      });
    });

    this.eventHub.$on('enableloadMore', function () {
      setTimeout(function () {
        _this.$refs.scroller.donePullup();
      }, 10);
    });

    this.eventHub.$on('enablerefreshTab', function () {
      _this.$nextTick(function () {
        setTimeout(function () {
          _this.$refs.scroller.donePulldown();
          _this.pullupEnabled && _this.$refs.scroller.enablePullup();
        }, 10);
      });
    });
  },

  methods: {
    handlerLeagueArrange: function handlerLeagueArrange() {
      this.currentTab = 'leagueArrange';
      this.$router.push({
        path: "/league_ongoing/arrange",
        query: { leagueId: this.id }
      });
    },
    handlerLeagueJifen: function handlerLeagueJifen() {
      this.currentTab = 'leagueTable';
      this.$router.push({
        path: "/league_ongoing/jifen",
        query: { leagueId: this.id }
      });
    },
    handlerLeagueShooters: function handlerLeagueShooters() {
      this.currentTab = 'shooterList';
      this.$router.push({
        path: "/league_ongoing/shooters",
        query: { leagueId: this.id }
      });
    },
    handlerLeagueData: function handlerLeagueData() {
      this.currentTab = 'leagueData';
      this.$router.push({
        path: "/league_ongoing/data",
        query: { leagueId: this.id }
      });
    },
    handlerLeagueMoments: function handlerLeagueMoments() {
      this.currentTab = 'leagueMoments';
      this.$router.push({
        path: "/league_ongoing/moments",
        query: { leagueId: this.id }
      });
    },
    initPage: function initPage() {
      if (this.currentTab == 'leagueArrange') {
        external__Zepto__default()('#leagueArrangeTab').triggerFastClick();
      } else if (this.currentTab == 'leagueMoments') {
        external__Zepto__default()('#leagueMomentsTab').triggerFastClick();
      } else if (this.currentTab == 'shooterList') {
        external__Zepto__default()('#leagueShootersTab').triggerFastClick();
      } else if (this.currentTab == 'leagueTable') {
        external__Zepto__default()('#leagueJifenTab').triggerFastClick();
      } else if (this.currentTab == 'leagueData') {
        external__Zepto__default()('#leagueDataTab').triggerFastClick();
      }
    },
    refreshTab: function refreshTab() {
      if (this.currentTab == 'leagueArrange') {
        this.eventHub.$emit("refreshTabArrange");
      } else if (this.currentTab == 'leagueMoments') {
        this.eventHub.$emit("refreshTabMoments");
      } else if (this.currentTab == 'shooterList') {
        this.eventHub.$emit("refreshTabShooters");
      } else if (this.currentTab == 'leagueTable') {
        this.eventHub.$emit("refreshTabJifen");
      } else if (this.currentTab == 'leagueData') {
        this.eventHub.$emit("refreshTabData");
      }
      return;
    },
    loadMore: function loadMore() {
      if (this.currentTab == 'leagueArrange') {
        this.eventHub.$emit("loadMoreArrange");
      } else if (this.currentTab == 'leagueMoments') {
        this.eventHub.$emit("loadMoreMoments");
      } else if (this.currentTab == 'shooterList') {
        this.eventHub.$emit("loadMoreShooters");
      } else if (this.currentTab == 'leagueTable') {
        this.eventHub.$emit("loadMoreJifen");
      } else if (this.currentTab == 'leagueData') {
        this.eventHub.$emit("loadMoreData");
      }
      return;
    }
  },
  data: function data() {
    var tabNames = ["赛程", "积分榜", "射手榜", "数据", "精彩瞬间"];
    var loadingTab = ['leagueArrange', 'leagueTable', ' shooterList', 'leagueData', 'leagueMoments'];
    this.$store.commit('updateEventHub', new vue_esm["a" /* default */]());

    return {
      id: this.$route.query.leagueId,
      show1: false,
      text1: 'Processing',
      currentTab: 'leagueArrange',
      matchStatus: '',
      eventHub: this.$store.getters.getEventHub,
      pulldownConfig: {
        content: '下拉刷新',
        height: 90,
        autoRefresh: false,
        downContent: '下拉刷新',
        upContent: '松开刷新',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pulldown-'
      },
      pullupConfig: {
        content: '上滑加载更多',
        pullUpHeight: 60,
        height: 40,
        autoRefresh: false,
        downContent: '松开加载',
        upContent: '上滑加载更多',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pullup-'
      },
      roundStart: 0,
      roundLength: 5,
      roundsInfo: [],
      roundUnstartStart: 0,
      roundUnstartLength: 5,
      roundsUnstartInfo: [],
      tabNames: tabNames,
      getBarWidth: function getBarWidth(index) {
        if (this.index >= 0) {
          return tabNames[this.index].length * 22 + 'px';
        }
      },
      leaguetimeDiv: {
        marginBottom: '2px',
        width: '14px',
        height: '14px',
        backgroundImage: 'url(' + __webpack_require__("xxCs") + ')',
        backgroundSize: '14px 14px'
      },
      leagueBasicInfo: {},
      pullupEnabled: true,
      status: {
        pullupStatus: 'default',
        pulldownStatus: 'default'
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89d11f94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/leagueOngoing.vue
var leagueOngoing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('scroller',{ref:"scroller",attrs:{"lock-x":"","scrollbar-y":"","use-pullup":"","use-pulldown":"","pulldown-config":this.pulldownConfig,"pullup-config":this.pullupConfig},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refreshTab},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('div',{},[_c('leagueHeader',{attrs:{"id":"headerArea","leagueBasicInfo":this.leagueBasicInfo}}),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#FFFFFF"},attrs:{"id":"clientArea"}},[_c('tab',{attrs:{"line-width":3,"defaultColor":"#999999","active-color":"#333333","bar-active-color":"#FE2754","custom-bar-width":_vm.getBarWidth}},[_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"leagueArrangeTab","selected":this.currentTab=='leagueArrange'},on:{"on-item-click":_vm.handlerLeagueArrange}},[_vm._v("\n                        "+_vm._s(this.tabNames[0])+"\n                    ")]),_vm._v(" "),_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"leagueJifenTab","selected":this.currentTab=='leagueTable'},on:{"on-item-click":_vm.handlerLeagueJifen}},[_vm._v("\n                        "+_vm._s(this.tabNames[1])+"\n                    ")]),_vm._v(" "),_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"leagueShootersTab","selected":this.currentTab=='shooterList'},on:{"on-item-click":_vm.handlerLeagueShooters}},[_vm._v("\n                        "+_vm._s(this.tabNames[2])+"\n                    ")]),_vm._v(" "),_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"leagueDataTab","selected":this.currentTab=='leagueData'},on:{"on-item-click":_vm.handlerLeagueData}},[_vm._v("\n                        "+_vm._s(this.tabNames[3])+"\n                    ")]),_vm._v(" "),_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"leagueMomentsTab","selected":this.currentTab=='leagueMoments'},on:{"on-item-click":_vm.handlerLeagueMoments}},[_vm._v("\n                        "+_vm._s(this.tabNames[4])+"\n                    ")])],1),_vm._v(" "),_c('router-view',{staticStyle:{"background-color":"#FFFFFF","height":"100%"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"xs-plugin-pullup-container xs-plugin-pullup-up",staticStyle:{"position":"absolute","width":"100%","height":"40px","bottom":"-40px","text-align":"center"},attrs:{"slot":"pullup"},slot:"pullup"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.pullupStatus === 'default'),expression:"status.pullupStatus === 'default'"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.pullupStatus === 'down' || _vm.status.pullupStatus === 'up'),expression:"status.pullupStatus === 'down' || status.pullupStatus === 'up'"}],staticClass:"pullup-arrow",class:{'rotate': _vm.status.pullupStatus === 'up'}},[_vm._v("↑")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status.pullupStatus === 'loading'),expression:"status.pullupStatus === 'loading'"}]},[_c('spinner',{attrs:{"type":"ios-small"}}),_vm._v("加载中")],1)])])],1)}
var leagueOngoing_staticRenderFns = []
var leagueOngoing_esExports = { render: leagueOngoing_render, staticRenderFns: leagueOngoing_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_leagueOngoing = (leagueOngoing_esExports);
// CONCATENATED MODULE: ./src/views/leagueOngoing.vue
function leagueOngoing_injectStyle (ssrContext) {
  __webpack_require__("SIJ7")
  __webpack_require__("B9dR")
}
var leagueOngoing_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leagueOngoing___vue_template_functional__ = false
/* styles */
var leagueOngoing___vue_styles__ = leagueOngoing_injectStyle
/* scopeId */
var leagueOngoing___vue_scopeId__ = "data-v-89d11f94"
/* moduleIdentifier (server only) */
var leagueOngoing___vue_module_identifier__ = null
var leagueOngoing_Component = leagueOngoing_normalizeComponent(
  views_leagueOngoing,
  selectortype_template_index_0_src_views_leagueOngoing,
  leagueOngoing___vue_template_functional__,
  leagueOngoing___vue_styles__,
  leagueOngoing___vue_scopeId__,
  leagueOngoing___vue_module_identifier__
)

/* harmony default export */ var src_views_leagueOngoing = (leagueOngoing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/round_report_matchSimple.vue




/* harmony default export */ var round_report_matchSimple = ({
  props: {
    matchInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    viewMatch: function viewMatch() {
      this.$router.push({
        path: 'match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId
        }
      });
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      this.score = this.genScore();
    },
    genScore: function genScore() {
      var score = '';
      if (this.objInfo && this.objInfo.result) {
        var matchObj = this.objInfo.result;
        var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";

        score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
        score += " - ";
        score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
      } else {
        score = "暂无比分";
      }
      return score;
    }
  },
  data: function data() {
    return {
      score: "",
      objInfo: {}
    };
  },

  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/round_report_matchSimple.vue




/* harmony default export */ var league_round_report_matchSimple = ({
  props: {
    matchInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    viewMatch: function viewMatch() {
      this.$router.push({
        path: 'match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId
        }
      });
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      this.score = this.genScore();
    },
    genScore: function genScore() {
      var score = '';
      if (this.objInfo && this.objInfo.result) {
        var matchObj = this.objInfo.result;
        var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";

        score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
        score += " - ";
        score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
      } else {
        score = "暂无比分";
      }
      return score;
    }
  },
  data: function data() {
    return {
      score: "",
      objInfo: {}
    };
  },

  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b02920f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/round_report_matchSimple.vue
var round_report_matchSimple_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0px 10px"}},[_c('div',{staticStyle:{"display":"inline-block","justify-content":"center","width":"100%"},on:{"click":_vm.viewMatch}},[_c('flexbox',{attrs:{"gutter":0,"justify":"center"}},[_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"right","font-family":"FZDBSK--GBK1-0","font-size":"12px","color":"#000000","letter-spacing":"0"}},[_vm._v("\n                    "+_vm._s(this.objInfo.homeTeamName)+"\n                ")])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/5}},[_c('div',{staticStyle:{"text-align":"center","font-family":"Arial-Black","font-size":"18px","color":"#E6224D","letter-spacing":"0"}},[_vm._v("\n                    "+_vm._s(this.score)+"\n                ")])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"left","font-family":"FZDBSK--GBK1-0","font-size":"12px","color":"#000000","letter-spacing":"0"}},[_vm._v("\n                    "+_vm._s(this.objInfo.vistingTeamName)+"\n                ")])])],1)],1)])}
var round_report_matchSimple_staticRenderFns = []
var round_report_matchSimple_esExports = { render: round_report_matchSimple_render, staticRenderFns: round_report_matchSimple_staticRenderFns }
/* harmony default export */ var components_league_round_report_matchSimple = (round_report_matchSimple_esExports);
// CONCATENATED MODULE: ./src/components/league/round_report_matchSimple.vue
function round_report_matchSimple_injectStyle (ssrContext) {
  __webpack_require__("pJng")
}
var round_report_matchSimple_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var round_report_matchSimple___vue_template_functional__ = false
/* styles */
var round_report_matchSimple___vue_styles__ = round_report_matchSimple_injectStyle
/* scopeId */
var round_report_matchSimple___vue_scopeId__ = "data-v-0b02920f"
/* moduleIdentifier (server only) */
var round_report_matchSimple___vue_module_identifier__ = null
var round_report_matchSimple_Component = round_report_matchSimple_normalizeComponent(
  league_round_report_matchSimple,
  components_league_round_report_matchSimple,
  round_report_matchSimple___vue_template_functional__,
  round_report_matchSimple___vue_styles__,
  round_report_matchSimple___vue_scopeId__,
  round_report_matchSimple___vue_module_identifier__
)

/* harmony default export */ var src_components_league_round_report_matchSimple = (round_report_matchSimple_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/round_report_matchSimpleUnstart.vue




/* harmony default export */ var round_report_matchSimpleUnstart = ({
  props: {
    matchInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    viewMatch: function viewMatch() {
      this.$router.push({
        path: 'match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId
        }
      });
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      this.title = this.genTitle();
      this.score = this.genScore();
    },
    genTitle: function genTitle() {
      var group = "";
      if (this.matchInfo && this.matchInfo.cupGroupName) {
        group = this.matchInfo.cupGroupName + "组";
      }
      var number = "";

      if (this.matchInfo && this.matchInfo.round) {
        number = this.getRoundName(this.matchInfo.round.type, this.matchInfo.round.number, this.matchInfo.round.title);
      }

      return group + (number != "" ? " " + number : "");
    },
    genScore: function genScore() {
      return "VS";
    }
  },
  data: function data() {
    return {
      title: "",
      score: "",
      objInfo: {}
    };
  },

  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/round_report_matchSimpleUnstart.vue




/* harmony default export */ var league_round_report_matchSimpleUnstart = ({
  props: {
    matchInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    viewMatch: function viewMatch() {
      this.$router.push({
        path: 'match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId
        }
      });
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      this.title = this.genTitle();
      this.score = this.genScore();
    },
    genTitle: function genTitle() {
      var group = "";
      if (this.matchInfo && this.matchInfo.cupGroupName) {
        group = this.matchInfo.cupGroupName + "组";
      }
      var number = "";

      if (this.matchInfo && this.matchInfo.round) {
        number = this.getRoundName(this.matchInfo.round.type, this.matchInfo.round.number, this.matchInfo.round.title);
      }

      return group + (number != "" ? " " + number : "");
    },
    genScore: function genScore() {
      return "VS";
    }
  },
  data: function data() {
    return {
      title: "",
      score: "",
      objInfo: {}
    };
  },

  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b830f0b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/round_report_matchSimpleUnstart.vue
var round_report_matchSimpleUnstart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0px 10px"}},[_c('div',{staticStyle:{"display":"inline-block","justify-content":"center","width":"100%"},on:{"click":_vm.viewMatch}},[_c('flexbox',{attrs:{"gutter":0,"justify":"center"}},[_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"right","font-family":"FZDBSK--GBK1-0","font-size":"12px","color":"#000000","letter-spacing":"0"}},[_vm._v(_vm._s(this.objInfo.homeTeamName))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/5}},[_c('div',{staticStyle:{"text-align":"center","font-family":"Arial-Black","font-size":"18px","color":"#299AFE","letter-spacing":"0"}},[_vm._v(_vm._s(this.score))])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"left","font-family":"FZDBSK--GBK1-0","font-size":"12px","color":"#000000","letter-spacing":"0"}},[_vm._v(_vm._s(this.objInfo.vistingTeamName))])])],1)],1)])}
var round_report_matchSimpleUnstart_staticRenderFns = []
var round_report_matchSimpleUnstart_esExports = { render: round_report_matchSimpleUnstart_render, staticRenderFns: round_report_matchSimpleUnstart_staticRenderFns }
/* harmony default export */ var components_league_round_report_matchSimpleUnstart = (round_report_matchSimpleUnstart_esExports);
// CONCATENATED MODULE: ./src/components/league/round_report_matchSimpleUnstart.vue
function round_report_matchSimpleUnstart_injectStyle (ssrContext) {
  __webpack_require__("zJQy")
}
var round_report_matchSimpleUnstart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var round_report_matchSimpleUnstart___vue_template_functional__ = false
/* styles */
var round_report_matchSimpleUnstart___vue_styles__ = round_report_matchSimpleUnstart_injectStyle
/* scopeId */
var round_report_matchSimpleUnstart___vue_scopeId__ = "data-v-4b830f0b"
/* moduleIdentifier (server only) */
var round_report_matchSimpleUnstart___vue_module_identifier__ = null
var round_report_matchSimpleUnstart_Component = round_report_matchSimpleUnstart_normalizeComponent(
  league_round_report_matchSimpleUnstart,
  components_league_round_report_matchSimpleUnstart,
  round_report_matchSimpleUnstart___vue_template_functional__,
  round_report_matchSimpleUnstart___vue_styles__,
  round_report_matchSimpleUnstart___vue_scopeId__,
  round_report_matchSimpleUnstart___vue_module_identifier__
)

/* harmony default export */ var src_components_league_round_report_matchSimpleUnstart = (round_report_matchSimpleUnstart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/round_report_roundCard.vue









/* harmony default export */ var round_report_roundCard = ({
  props: {
    roundInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button,
    RoundReportMatchSimple: src_components_league_round_report_matchSimple,
    RoundReportUnStartMatchSimple: src_components_league_round_report_matchSimpleUnstart
  },
  mounted: function mounted() {

    this.reload();
  },

  methods: {
    reload: function reload() {
      this.groups = this.roundInfo.groups;
    }
  },
  data: function data() {
    return {
      title: " ",
      groups: []
    };
  },

  watch: {
    roundInfo: function roundInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/round_report_roundCard.vue









/* harmony default export */ var league_round_report_roundCard = ({
  props: {
    roundInfo: Object
  },
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button,
    RoundReportMatchSimple: src_components_league_round_report_matchSimple,
    RoundReportUnStartMatchSimple: src_components_league_round_report_matchSimpleUnstart
  },
  mounted: function mounted() {

    this.reload();
  },

  methods: {
    reload: function reload() {
      this.groups = this.roundInfo.groups;
    }
  },
  data: function data() {
    return {
      title: " ",
      groups: []
    };
  },

  watch: {
    roundInfo: function roundInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c66b816","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/round_report_roundCard.vue
var round_report_roundCard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},_vm._l((this.groups),function(groupObj){return _c('div',[_c('div',{staticStyle:{"margin-top":"10px","font-family":"PingFangSC-Semibold","font-size":"10px","color":"#2A2A2A","letter-spacing":"0"}},[_vm._v("\n            "+_vm._s(groupObj.cupGroupName?(groupObj.cupGroupName + "组"):"-")+"\n        ")]),_vm._v(" "),_vm._l((groupObj.matches),function(matchObj){return _c('div',[_c('RoundReportMatchSimple',{attrs:{"matchInfo":matchObj}})],1)}),_vm._v(" "),_vm._l((groupObj.unStartedMatches),function(matchObj){return _c('div',[_c('RoundReportUnStartMatchSimple',{attrs:{"matchInfo":matchObj}})],1)}),_vm._v(" "),_c('div',{staticStyle:{"background":"#fff","height":"1px","margin-top":"5px"}})],2)}),0)}
var round_report_roundCard_staticRenderFns = []
var round_report_roundCard_esExports = { render: round_report_roundCard_render, staticRenderFns: round_report_roundCard_staticRenderFns }
/* harmony default export */ var components_league_round_report_roundCard = (round_report_roundCard_esExports);
// CONCATENATED MODULE: ./src/components/league/round_report_roundCard.vue
function round_report_roundCard_injectStyle (ssrContext) {
  __webpack_require__("mBSk")
}
var round_report_roundCard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var round_report_roundCard___vue_template_functional__ = false
/* styles */
var round_report_roundCard___vue_styles__ = round_report_roundCard_injectStyle
/* scopeId */
var round_report_roundCard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var round_report_roundCard___vue_module_identifier__ = null
var round_report_roundCard_Component = round_report_roundCard_normalizeComponent(
  league_round_report_roundCard,
  components_league_round_report_roundCard,
  round_report_roundCard___vue_template_functional__,
  round_report_roundCard___vue_styles__,
  round_report_roundCard___vue_scopeId__,
  round_report_roundCard___vue_module_identifier__
)

/* harmony default export */ var src_components_league_round_report_roundCard = (round_report_roundCard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/round_report.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var round_report = ({
  data: function data() {
    return {
      indexContentHeight: 0,
      roundInfo: {},
      leagueId: this.$route.query.leagueId,
      roundId: this.$route.query.roundId,
      //              leagueBasicInfo:this.$route.query.leagueBasicInfo,
      leagueTitle: this.$route.query.leagueTitle,
      roundTitle: this.$route.query.roundTitle,
      matchCount: 0,
      goalCount: 0,
      yellowCardCount: 0,
      redCardCount: 0,
      goalerCount: 0,
      mostGoalMatches: [],
      mostGoalCount: 0,
      topScorerGoalCount: 0,
      topScorers: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loadData(this.leagueId, this.roundId);
    this.$nextTick(function () {
      var height = window.innerHeight;
      //            var browerHeadHeight = window.screen.height - window.innerHeight;
      _this.indexContentHeight = height;
    });
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      var fullPath = window.location.href;
      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      utils_wxShareConfig({
        title: '赛况简报',
        desc: this.leagueTitle + this.roundTitle,
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {}, function () {});
    },
    loadData: function loadData(leagueId, roundId) {
      var _this2 = this;

      this.hagkHttp(this.hagkApi.getRoundMatches(leagueId, roundId, 0, 0), {}).then(function (res) {
        if (res.status == true) {
          _this2.roundInfo = res.result.roundVO;
          _this2.matchCount = res.result.matchCount;
          _this2.goalCount = res.result.goalCount;
          _this2.yellowCardCount = res.result.yellowCardCount;
          _this2.redCardCount = res.result.redCardCount;
          _this2.goalerCount = res.result.goalerCount;
          _this2.mostGoalMatches = res.result.mostGoalMatches;
          _this2.mostGoalCount = res.result.mostGoalCount;
          if (_this2.mostGoalMatches) {
            for (var i = 0; i < _this2.mostGoalMatches.length; i++) {
              _this2.mostGoalMatches[i].score = _this2.getScore(_this2.mostGoalMatches[i]);
            }
          }
          _this2.topScorerGoalCount = res.result.topScorerGoalCount;
          _this2.topScorers = res.result.topScorers;
        }
        _this2.initWxShareConfig();
      }, function (error) {
        console.log(error);
        window.alert('本轮赛况获取失败！');
      });
    },
    getScore: function getScore(matchVO) {
      var score = '';
      if (matchVO && matchVO.result) {
        var matchObj = matchVO.result;
        var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";
        //score += (matchObj.goalFor + matchObj.homeExScore) + (matchObj.homePkScore ? '(' + matchObj.homePkScore + ')' : defaultPkScore)
        //score += "-"
        //score += (matchObj.goalAgainst + matchObj.visitorExScore) + (matchObj.visitorPkScore ? '(' + matchObj.visitorPkScore + ')' : defaultPkScore)
        score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
        score += "-";
        score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
      } else {
        score = "暂无比分";
      }
      return score;
    }
  },
  components: { RoundReportRoundCard: src_components_league_round_report_roundCard }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/round_report.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var views_round_report = ({
  data: function data() {
    return {
      indexContentHeight: 0,
      roundInfo: {},
      leagueId: this.$route.query.leagueId,
      roundId: this.$route.query.roundId,
      //              leagueBasicInfo:this.$route.query.leagueBasicInfo,
      leagueTitle: this.$route.query.leagueTitle,
      roundTitle: this.$route.query.roundTitle,
      matchCount: 0,
      goalCount: 0,
      yellowCardCount: 0,
      redCardCount: 0,
      goalerCount: 0,
      mostGoalMatches: [],
      mostGoalCount: 0,
      topScorerGoalCount: 0,
      topScorers: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loadData(this.leagueId, this.roundId);
    this.$nextTick(function () {
      var height = window.innerHeight;
      //            var browerHeadHeight = window.screen.height - window.innerHeight;
      _this.indexContentHeight = height;
    });
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      var fullPath = window.location.href;
      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      utils_wxShareConfig({
        title: '赛况简报',
        desc: this.leagueTitle + this.roundTitle,
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {}, function () {});
    },
    loadData: function loadData(leagueId, roundId) {
      var _this2 = this;

      this.hagkHttp(this.hagkApi.getRoundMatches(leagueId, roundId, 0, 0), {}).then(function (res) {
        if (res.status == true) {
          _this2.roundInfo = res.result.roundVO;
          _this2.matchCount = res.result.matchCount;
          _this2.goalCount = res.result.goalCount;
          _this2.yellowCardCount = res.result.yellowCardCount;
          _this2.redCardCount = res.result.redCardCount;
          _this2.goalerCount = res.result.goalerCount;
          _this2.mostGoalMatches = res.result.mostGoalMatches;
          _this2.mostGoalCount = res.result.mostGoalCount;
          if (_this2.mostGoalMatches) {
            for (var i = 0; i < _this2.mostGoalMatches.length; i++) {
              _this2.mostGoalMatches[i].score = _this2.getScore(_this2.mostGoalMatches[i]);
            }
          }
          _this2.topScorerGoalCount = res.result.topScorerGoalCount;
          _this2.topScorers = res.result.topScorers;
        }
        _this2.initWxShareConfig();
      }, function (error) {
        console.log(error);
        window.alert('本轮赛况获取失败！');
      });
    },
    getScore: function getScore(matchVO) {
      var score = '';
      if (matchVO && matchVO.result) {
        var matchObj = matchVO.result;
        var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";
        //score += (matchObj.goalFor + matchObj.homeExScore) + (matchObj.homePkScore ? '(' + matchObj.homePkScore + ')' : defaultPkScore)
        //score += "-"
        //score += (matchObj.goalAgainst + matchObj.visitorExScore) + (matchObj.visitorPkScore ? '(' + matchObj.visitorPkScore + ')' : defaultPkScore)
        score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
        score += "-";
        score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
      } else {
        score = "暂无比分";
      }
      return score;
    }
  },
  components: { RoundReportRoundCard: src_components_league_round_report_roundCard }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32bcd136","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/round_report.vue
var round_report_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"round_report_background",style:({height:_vm.indexContentHeight+'px'})},[_c('div',{staticClass:"round_report_paper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"round_report_title"},[_c('div',{staticClass:"round_report_roundName"},[_vm._v(_vm._s(_vm.leagueTitle))]),_vm._v(" "),_c('div',{staticClass:"round_report_round"},[_vm._v(_vm._s(_vm.roundTitle))])]),_vm._v(" "),_c('div',[_c('RoundReportRoundCard',{attrs:{"roundInfo":_vm.roundInfo}})],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"left_block",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"left_parent"},[_c('div',{staticClass:"left_info"},[_c('div',{staticClass:"font20",staticStyle:{"float":"left","height":"25px"}},[_vm._v(_vm._s(_vm.matchCount))]),_c('div',{staticStyle:{"font-family":"FZDBSK--GBK1-0","font-size":"16px","color":"#000000","line-height":"30px"}},[_vm._v(" 场")])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"same_word"},[_vm._v("本轮比赛场次")])]),_vm._v(" "),_c('div',{staticClass:"right_block",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"left_parent"},[_c('div',{staticClass:"left_info"},[_c('span',{staticClass:"font20",staticStyle:{"float":"left","height":"25px"}},[_vm._v(_vm._s(_vm.goalCount))]),_c('span',{staticStyle:{"font-family":"FZDBSK--GBK1-0","font-size":"16px","color":"#000000","line-height":"30px"}},[_vm._v(" 球")])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"same_word"},[_vm._v("本轮总进球数")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"left_block",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"left_parent"},[_c('div',{staticClass:"left_info"},[_c('span',{staticClass:"font20",staticStyle:{"float":"left","height":"25px"}},[_vm._v(_vm._s(_vm.redCardCount)+"/"+_vm._s(_vm.yellowCardCount))]),_c('span',{staticStyle:{"font-family":"FZDBSK--GBK1-0","font-size":"16px","color":"#000000","line-height":"30px"}},[_vm._v(" 张")])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"same_word"},[_vm._v("本轮红/黄牌数")])]),_vm._v(" "),_c('div',{staticClass:"right_block",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"left_parent"},[_c('div',{staticClass:"left_info"},[_c('span',{staticClass:"font20",staticStyle:{"float":"left","height":"25px"}},[_vm._v(_vm._s(_vm.goalerCount))]),_c('span',{staticStyle:{"font-family":"FZDBSK--GBK1-0","font-size":"16px","color":"#000000","line-height":"30px"}},[_vm._v(" 人")])]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"same_word"},[_vm._v("进球人数")])])]),_vm._v(" "),_c('div',{staticClass:"hole_block",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"left_parent"},[_c('div',{staticClass:"left_info"},[_c('span',{staticClass:"font20",staticStyle:{"float":"left","height":"25px"}},[_vm._v(_vm._s(_vm.topScorerGoalCount))]),_c('span',{staticStyle:{"font-family":"FZDBSK--GBK1-0","font-size":"16px","color":"#000000","line-height":"30px"}},[_vm._v(" 球")])]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"same_word",staticStyle:{"position":"relative"}},[_c('div',[_vm._v("最佳射手进球数")]),_vm._v(" "),_vm._l((_vm.topScorers),function(topScorer){return _c('div',{staticClass:"font10",staticStyle:{"margin-top":"4px"}},[_vm._v("\n        "+_vm._s(topScorer.name)+"\n         "),(topScorer.teamName)?_c('span',[_vm._v("\n         - "+_vm._s(topScorer.teamName)+"\n         ")]):_vm._e()])})],2)]),_vm._v(" "),_c('div',{staticClass:"hole_block",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"left_parent"},[_c('div',{staticClass:"left_info"},[_c('span',{staticClass:"font20",staticStyle:{"float":"left","height":"25px"}},[_vm._v(_vm._s(_vm.mostGoalCount))]),_c('span',{staticStyle:{"font-family":"FZDBSK--GBK1-0","font-size":"16px","color":"#000000","line-height":"30px"}},[_vm._v(" 球")])]),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"same_word",staticStyle:{"position":"relative"}},[_c('div',[_vm._v("进球最多场次")]),_vm._v(" "),_vm._l((_vm.mostGoalMatches),function(matchVO){return _c('div',{staticClass:"font10",staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(matchVO.homeTeamName)+"   "+_vm._s(matchVO.score)+"   "+_vm._s(matchVO.vistingTeamName))])})],2)])])])}
var round_report_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"round_report_head",staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"60px","height":"60px"},attrs:{"src":__webpack_require__("mCmD")}}),_vm._v("\n    赛况简报\n  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"round_report_count"},[_c('div',{staticClass:"round_report_match_count"},[_vm._v("\n       比赛统计\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_icon"},[_c('img',{staticStyle:{"width":"10px","height":"12px","margin-top":"6px"},attrs:{"src":__webpack_require__("vjAb")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_icon"},[_c('img',{staticStyle:{"width":"12px","height":"12px","margin-top":"6px"},attrs:{"src":__webpack_require__("O22B")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_icon"},[_c('img',{staticStyle:{"width":"10px","height":"12px","margin-top":"6px"},attrs:{"src":__webpack_require__("/I+n")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_icon"},[_c('img',{staticStyle:{"width":"9px","height":"12px","margin-top":"6px"},attrs:{"src":__webpack_require__("KQmM")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_icon"},[_c('img',{staticStyle:{"width":"14px","height":"10px","margin-top":"6px"},attrs:{"src":__webpack_require__("s8XF")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_icon"},[_c('img',{staticStyle:{"width":"9.8px","height":"10.5px","margin-top":"6px"},attrs:{"src":__webpack_require__("hoel")}})])}]
var round_report_esExports = { render: round_report_render, staticRenderFns: round_report_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_round_report = (round_report_esExports);
// CONCATENATED MODULE: ./src/views/round_report.vue
function round_report_injectStyle (ssrContext) {
  __webpack_require__("AepO")
}
var round_report_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var round_report___vue_template_functional__ = false
/* styles */
var round_report___vue_styles__ = round_report_injectStyle
/* scopeId */
var round_report___vue_scopeId__ = "data-v-32bcd136"
/* moduleIdentifier (server only) */
var round_report___vue_module_identifier__ = null
var round_report_Component = round_report_normalizeComponent(
  views_round_report,
  selectortype_template_index_0_src_views_round_report,
  round_report___vue_template_functional__,
  round_report___vue_styles__,
  round_report___vue_scopeId__,
  round_report___vue_module_identifier__
)

/* harmony default export */ var src_views_round_report = (round_report_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MatchResultHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MatchResultHeader = ({
	name: 'app',
	created: function created() {
		this.matchId = this.$route.query.matchId;
	},
	data: function data() {
		return {
			homeTeamId: '',
			visitTeamId: '',
			matchId: '',
			homeTeamScore: null,
			visitTeamScore: null,
			homeTeamPKScore: null,
			visitTeamPKScore: null,
			homeTeamName: '',
			visitTeamName: '',
			leagueName: '',
			location: '',
			startDate: '',
			homeTeamTotalScore: 0,
			visitTeamTotalScore: 0
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {}).then(function (res) {
			_this.homeTeamId = res.homeTeamId;
			_this.homeTeamName = res.homeTeamName;
			_this.visitTeamId = res.vistingTeamId;
			_this.visitTeamName = res.vistingTeamName;
			_this.leagueName = res.leagueName;
			_this.location = res.location;
			_this.startDate = res.time;
			if (_this.startDate && _this.startDate.length > 16) _this.startDate = _this.startDate.substring(0, 16);

			if (res.result && res.result != null) {
				if (res.result.goalFor != null) {
					_this.homeTeamScore = 0;
					_this.homeTeamScore += res.result.goalFor;
				}
				if (res.result.homeExScore != null) {
					_this.homeTeamScore = _this.homeTeamScore == null ? 0 : _this.homeTeamScore;
					_this.homeTeamScore += res.result.homeExScore;
				}
				if (res.result.homePkScore != null) {
					_this.homePkScore = 0;
					_this.homeTeamPKScore += res.result.homePkScore;
				}
				if (res.result.goalAgainst != null) {
					_this.visitTeamScore = 0;
					_this.visitTeamScore += res.result.goalAgainst;
				}
				if (res.result.visitorExScore != null) {
					_this.visitTeamScore = _this.visitTeamScore == null ? 0 : _this.visitTeamScore;
					_this.visitTeamScore += res.result.visitorExScore;
				}
				if (res.result.visitorPkScore != null) {
					_this.visitorPkScore = 0;
					_this.visitTeamPKScore += res.result.visitorPkScore;
				}
			}
			_this.homeTeamTotalScore = (_this.homeTeamScore == null ? 0 : _this.homeTeamScore) + (_this.homeTeamPKScore == null ? 0 : _this.homeTeamPKScore);
			_this.visitTeamTotalScore = (_this.visitTeamScore == null ? 0 : _this.visitTeamScore) + (_this.visitTeamPKScore == null ? 0 : _this.visitTeamPKScore);

			if (homeTeamScore == null && visitTeamScore == null && homeTeamPKScore == null && visitTeamPKScore == null) {
				var realPath = window.location.href;
				var fullPath = realPath.substring(0, realPath.indexOf('/match_info')) + '/match_info_share?matchId=' + _this.matchId;
				var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
				var title = _this.leagueName;
				var desc = "主队：" + _this.homeTeamName + '\r\n客队：' + _this.visitTeamName;

				wxShareConfig({
					title: title,
					desc: desc,
					link: realPath,
					imgUrl: shareImg,
					type: 'link',
					dataUrl: ''
				}, function () {}, function () {}, fullPath);
			}
		}, function (error) {
			console.log(error);
			window.alert('比赛信息获取失败！');
		});
	},

	methods: {
		dateFormate: function dateFormate(time) {
			var date = new Date();
			date.setTime(time);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MatchResultHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_MatchResultHeader = ({
	name: 'app',
	created: function created() {
		this.matchId = this.$route.query.matchId;
	},
	data: function data() {
		return {
			homeTeamId: '',
			visitTeamId: '',
			matchId: '',
			homeTeamScore: null,
			visitTeamScore: null,
			homeTeamPKScore: null,
			visitTeamPKScore: null,
			homeTeamName: '',
			visitTeamName: '',
			leagueName: '',
			location: '',
			startDate: '',
			homeTeamTotalScore: 0,
			visitTeamTotalScore: 0
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {}).then(function (res) {
			_this.homeTeamId = res.homeTeamId;
			_this.homeTeamName = res.homeTeamName;
			_this.visitTeamId = res.vistingTeamId;
			_this.visitTeamName = res.vistingTeamName;
			_this.leagueName = res.leagueName;
			_this.location = res.location;
			_this.startDate = res.time;
			if (_this.startDate && _this.startDate.length > 16) _this.startDate = _this.startDate.substring(0, 16);

			if (res.result && res.result != null) {
				if (res.result.goalFor != null) {
					_this.homeTeamScore = 0;
					_this.homeTeamScore += res.result.goalFor;
				}
				if (res.result.homeExScore != null) {
					_this.homeTeamScore = _this.homeTeamScore == null ? 0 : _this.homeTeamScore;
					_this.homeTeamScore += res.result.homeExScore;
				}
				if (res.result.homePkScore != null) {
					_this.homePkScore = 0;
					_this.homeTeamPKScore += res.result.homePkScore;
				}
				if (res.result.goalAgainst != null) {
					_this.visitTeamScore = 0;
					_this.visitTeamScore += res.result.goalAgainst;
				}
				if (res.result.visitorExScore != null) {
					_this.visitTeamScore = _this.visitTeamScore == null ? 0 : _this.visitTeamScore;
					_this.visitTeamScore += res.result.visitorExScore;
				}
				if (res.result.visitorPkScore != null) {
					_this.visitorPkScore = 0;
					_this.visitTeamPKScore += res.result.visitorPkScore;
				}
			}
			_this.homeTeamTotalScore = (_this.homeTeamScore == null ? 0 : _this.homeTeamScore) + (_this.homeTeamPKScore == null ? 0 : _this.homeTeamPKScore);
			_this.visitTeamTotalScore = (_this.visitTeamScore == null ? 0 : _this.visitTeamScore) + (_this.visitTeamPKScore == null ? 0 : _this.visitTeamPKScore);

			if (homeTeamScore == null && visitTeamScore == null && homeTeamPKScore == null && visitTeamPKScore == null) {
				var realPath = window.location.href;
				var fullPath = realPath.substring(0, realPath.indexOf('/match_info')) + '/match_info_share?matchId=' + _this.matchId;
				var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
				var title = _this.leagueName;
				var desc = "主队：" + _this.homeTeamName + '\r\n客队：' + _this.visitTeamName;

				wxShareConfig({
					title: title,
					desc: desc,
					link: realPath,
					imgUrl: shareImg,
					type: 'link',
					dataUrl: ''
				}, function () {}, function () {}, fullPath);
			}
		}, function (error) {
			console.log(error);
			window.alert('比赛信息获取失败！');
		});
	},

	methods: {
		dateFormate: function dateFormate(time) {
			var date = new Date();
			date.setTime(time);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d567deb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MatchResultHeader.vue
var MatchResultHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:{'hefei-bg': _vm.leagueName === '合肥市城市足球联赛'},staticStyle:{"margin-left":"0px","margin-right":"0px"}},[_c('div',[_c('div',{staticStyle:{"text-align":"center","font-family":"PingFangSC-Medium","font-size":"16px","color":"#FFFFFF"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.leagueName)+"\n\t\t")])]),_vm._v(" "),_c('div',{staticClass:"vux-flexbox vux-flex-row",staticStyle:{"height":"100px"}},[_c('div',{staticStyle:{"text-align":"right","width":"35%","font-family":"PingFangSC-Regular","font-size":"14px","color":"#FFFFFF","float":"left","padding-right":"15px","padding-left":"15px"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.homeTeamName)+"\n\t\t")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.homeTeamScore == null && _vm.visitTeamScore == null && _vm.homeTeamPKScore == null && _vm.visitTeamPKScore == null),expression:"homeTeamScore == null && visitTeamScore == null && homeTeamPKScore == null && visitTeamPKScore == null"}],staticStyle:{"text-align":"center","width":"30%","font-family":"Arial-Black","font-size":"30px","color":"#299AFE"}},[_c('b',[_vm._v("VS")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.homeTeamScore != null || _vm.visitTeamScore != null) && ((_vm.visitTeamPKScore == null && _vm.homeTeamPKScore == null) || (_vm.visitTeamPKScore == 0 && _vm.homeTeamPKScore == 0))),expression:"(homeTeamScore != null || visitTeamScore != null) && ((visitTeamPKScore == null && homeTeamPKScore == null) || (visitTeamPKScore == 0 && homeTeamPKScore == 0))"}],staticStyle:{"float":"left","font-family":"Arial-Black","font-size":"36px","color":"#FFFFFF","padding-left":"0px","padding-right":"0px","text-align":"center","width":"30%"}},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.homeTeamScore == null ? 0 : _vm.homeTeamScore))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.visitTeamScore == null ? 0 : _vm.visitTeamScore))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.visitTeamPKScore != null || _vm.homeTeamPKScore != null) && (_vm.visitTeamPKScore != 0 || _vm.homeTeamPKScore != 0)),expression:"(visitTeamPKScore != null || homeTeamPKScore != null) && (visitTeamPKScore != 0 || homeTeamPKScore != 0)"}],staticStyle:{"float":"left","padding-left":"0px","padding-right":"0px","margin-top":"7px","text-align":"center","width":"30%"}},[_c('div',{staticStyle:{"width":"100%","text-align":"center","float":"left","font-family":"Arial-Black","font-size":"36px","color":"#FFFFFF"}},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.homeTeamTotalScore == null ? 0 : _vm.homeTeamTotalScore))])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.visitTeamTotalScore == null ? 0 : _vm.visitTeamTotalScore))])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","text-align":"center","float":"left","font-family":"PingFangSC-Semibold","font-size":"12px","color":"#FFFFFF"}},[_c('span',[_vm._v("(")]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"3px"}},[_vm._v("点球")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.homeTeamPKScore == null ? 0 : _vm.homeTeamPKScore))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.visitTeamPKScore == null ? 0 : _vm.visitTeamPKScore))]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"3px"}},[_vm._v(")")])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","width":"35%","font-family":"PingFangSC-Regular","font-size":"14px","color":"#FFFFFF","float":"left","padding-left":"15px","padding-right":"15px"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.visitTeamName)+"\n\t\t")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","text-align":"center","font-family":"PingFangSC-Regular","font-size":"12px","color":"#D8D8D8","float":"left","width":"100%","position":"absolute","top":"135px"}},[_vm._v("\n\t\t"+_vm._s(_vm.location)+"\n\t")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"0px","font-family":"PingFangSC-Regular","font-size":"12px","color":"#D8D8D8","float":"left","width":"100%","position":"absolute","top":"165px"}},[_vm._v("\n\t\t"+_vm._s(_vm.startDate)+"\n\t")])])}
var MatchResultHeader_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("-")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("-")])])}]
var MatchResultHeader_esExports = { render: MatchResultHeader_render, staticRenderFns: MatchResultHeader_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_MatchResultHeader = (MatchResultHeader_esExports);
// CONCATENATED MODULE: ./src/components/MatchResultHeader.vue
function MatchResultHeader_injectStyle (ssrContext) {
  __webpack_require__("ys0m")
}
var MatchResultHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MatchResultHeader___vue_template_functional__ = false
/* styles */
var MatchResultHeader___vue_styles__ = MatchResultHeader_injectStyle
/* scopeId */
var MatchResultHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MatchResultHeader___vue_module_identifier__ = null
var MatchResultHeader_Component = MatchResultHeader_normalizeComponent(
  components_MatchResultHeader,
  selectortype_template_index_0_src_components_MatchResultHeader,
  MatchResultHeader___vue_template_functional__,
  MatchResultHeader___vue_styles__,
  MatchResultHeader___vue_scopeId__,
  MatchResultHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_MatchResultHeader = (MatchResultHeader_Component.exports);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df9eff9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp vux-previewer",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"pswp__bg"}),_vm._v(" "),_c('div',{staticClass:"pswp__scroll-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pswp__ui pswp__ui--hidden"},[_c('div',{staticClass:"pswp__top-bar"},[_c('div',{staticClass:"pswp__counter"}),_vm._v(" "),_vm._t("button-after"),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--close",attrs:{"title":"Close (Esc)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--share",attrs:{"title":"Share"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--fs",attrs:{"title":"Toggle fullscreen"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--zoom",attrs:{"title":"Zoom in/out"}}),_vm._v(" "),_vm._t("button-before"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--left",attrs:{"title":"Previous (arrow left)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--right",attrs:{"title":"Next (arrow right)"}}),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_vm._t("wrap-after")],2)}
var previewer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__container"},[_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__preloader"},[_c('div',{staticClass:"pswp__preloader__icn"},[_c('div',{staticClass:"pswp__preloader__cut"},[_c('div',{staticClass:"pswp__preloader__donut"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[_c('div',{staticClass:"pswp__share-tooltip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__caption"},[_c('div',{staticClass:"pswp__caption__center"})])}]
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
function previewer_injectStyle (ssrContext) {
  __webpack_require__("xhby")
  __webpack_require__("z/9y")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var x_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var x_dialog_staticRenderFns = []
var x_dialog_esExports = { render: x_dialog_render, staticRenderFns: x_dialog_staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (x_dialog_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function x_dialog_injectStyle (ssrContext) {
  __webpack_require__("7DAO")
}
var x_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_dialog___vue_template_functional__ = false
/* styles */
var x_dialog___vue_styles__ = x_dialog_injectStyle
/* scopeId */
var x_dialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_dialog___vue_module_identifier__ = null
var x_dialog_Component = x_dialog_normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  x_dialog___vue_template_functional__,
  x_dialog___vue_styles__,
  x_dialog___vue_scopeId__,
  x_dialog___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (x_dialog_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/vue-video-player/index.js
var vue_video_player = __webpack_require__("NBiq");
var vue_video_player_default = /*#__PURE__*/__webpack_require__.n(vue_video_player);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchMoments.vue















/* harmony default export */ var matchMoments = ({
  props: {
    eventHub: Object
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Divider: vux_src_components_divider,
    XDialog: vux_src_components_x_dialog,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    XSwitch: vux_src_components_x_switch,
    Previewer: vux_src_components_previewer,
    videoPlayer: vue_video_player["videoPlayer"],
    wx: external__jWeixin__default.a
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
  },
  mounted: function mounted() {

    this.initTab();
  },
  data: function data() {
    return {
      currentOrgCode: src_configInfo.orgCode,
      matchId: '', //352917
      content: '精彩瞬间',
      indexContentHeight: 0,
      assets: [],
      imagelist: [],
      videolist: [],
      defaultImg: 'this.src="' + __webpack_require__("KXse") + '"',
      videoTag: __webpack_require__("yGzZ"),
      showHideOnBlur: false,
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      playerOptions: {

        playbackRates: [0.5, 1.0, 2.0],
        sources: [{
          type: "video/mp4",
          src: ""
        }],

        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      }
    };
  },

  methods: {
    initTab: function initTab() {
      var _this = this;

      this.$nextTick(function () {
        _this.indexContentHeight = document.body.clientHeight;
      });

      this.hagkHttp(this.hagkApi.getMatchAssetsByMatchId(this.matchId, 'moment'), {}).then(function (res) {
        _this.videolist.splice(0, _this.videolist.length);
        _this.imagelist.splice(0, _this.imagelist.length);
        _this.assets.splice(0, _this.assets.length);
        if (res && res.length > 0) {
          for (var i = 0; i < res.length; i++) {
            for (var j = 0; j < res[i].assetList.length; j++) {
              var data = {};
              data.url = _this.hagkApi.getImgAssetById(res[i].assetList[j].assetId).url;
              data.thumbnail_url = _this.hagkApi.getImgAssetById(res[i].assetList[j].thumbnailId).url;
              data.type = res[i].assetList[j].type;
              data.description = res[i].assetList[j].description;
              _this.assets.push(data);
            }
          }

          for (var i = 0; i < _this.assets.length; i++) {
            var data = {};
            if (_this.assets[i].type == "video") {
              data.src = _this.assets[i].thumbnail_url;
              data.actSrc = _this.assets[i].url;
              data.type = "video";
              data.description = _this.assets[i].description;
              _this.videolist.push(data);
            } else {
              data.src = _this.assets[i].url;
              data.actSrc = _this.assets[i].url;
              data.type = _this.assets[i].type;
              data.description = _this.assets[i].description;
              _this.imagelist.push(data);
            }
          }
        }
        _this.changeMomentHeight();
      }, function (error) {});
    },
    player: function player() {
      return this.$refs.videoPlayer.player;
    },
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {},
    onPlayerWaiting: function onPlayerWaiting(player) {},
    onPlayerEnded: function onPlayerEnded(player) {},
    onPlayerPlaying: function onPlayerPlaying(player) {},
    onPlayerLoadeddata: function onPlayerLoadeddata(player) {},
    onPlayerTimeupdate: function onPlayerTimeupdate(player) {},
    onPlayerCanplay: function onPlayerCanplay(player) {},
    onPlayerCanplaythrough: function onPlayerCanplaythrough(player) {},
    playerStateChanged: function playerStateChanged(playerCurrentState) {},
    playerReadied: function playerReadied(player) {
      console.log('the player is readied', player);
    },
    showImage: function showImage(src) {
      var urls = [];
      for (var i = 0; i < this.imagelist.length; i++) {
        urls.push(this.imagelist[i].src);
      }
      external__jWeixin__default.a.previewImage({
        current: src,
        urls: urls
      });
    },
    showVideo: function showVideo(index) {

      if (this.videolist[index].type == "video") {
        this.showHideOnBlur = true;
        this.playerOptions.sources.src = this.videolist[index].actSrc;

        this.player().reset();
        this.player().src({ type: "video/mp4", src: this.videolist[index].actSrc });

        this.player().play();
      }
    },
    changeMomentHeight: function changeMomentHeight() {
      if (this.eventHub) {
        this.eventHub.$emit("resetView");
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchMoments.vue















/* harmony default export */ var views_matchMoments = ({
  props: {
    eventHub: Object
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Divider: vux_src_components_divider,
    XDialog: vux_src_components_x_dialog,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    XSwitch: vux_src_components_x_switch,
    Previewer: vux_src_components_previewer,
    videoPlayer: vue_video_player["videoPlayer"],
    wx: external__jWeixin__default.a
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
  },
  mounted: function mounted() {

    this.initTab();
  },
  data: function data() {
    return {
      currentOrgCode: src_configInfo.orgCode,
      matchId: '', //352917
      content: '精彩瞬间',
      indexContentHeight: 0,
      assets: [],
      imagelist: [],
      videolist: [],
      defaultImg: 'this.src="' + __webpack_require__("KXse") + '"',
      videoTag: __webpack_require__("yGzZ"),
      showHideOnBlur: false,
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      playerOptions: {

        playbackRates: [0.5, 1.0, 2.0],
        sources: [{
          type: "video/mp4",
          src: ""
        }],

        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      }
    };
  },

  methods: {
    initTab: function initTab() {
      var _this = this;

      this.$nextTick(function () {
        _this.indexContentHeight = document.body.clientHeight;
      });

      this.hagkHttp(this.hagkApi.getMatchAssetsByMatchId(this.matchId, 'moment'), {}).then(function (res) {
        _this.videolist.splice(0, _this.videolist.length);
        _this.imagelist.splice(0, _this.imagelist.length);
        _this.assets.splice(0, _this.assets.length);
        if (res && res.length > 0) {
          for (var i = 0; i < res.length; i++) {
            for (var j = 0; j < res[i].assetList.length; j++) {
              var data = {};
              data.url = _this.hagkApi.getImgAssetById(res[i].assetList[j].assetId).url;
              data.thumbnail_url = _this.hagkApi.getImgAssetById(res[i].assetList[j].thumbnailId).url;
              data.type = res[i].assetList[j].type;
              data.description = res[i].assetList[j].description;
              _this.assets.push(data);
            }
          }

          for (var i = 0; i < _this.assets.length; i++) {
            var data = {};
            if (_this.assets[i].type == "video") {
              data.src = _this.assets[i].thumbnail_url;
              data.actSrc = _this.assets[i].url;
              data.type = "video";
              data.description = _this.assets[i].description;
              _this.videolist.push(data);
            } else {
              data.src = _this.assets[i].url;
              data.actSrc = _this.assets[i].url;
              data.type = _this.assets[i].type;
              data.description = _this.assets[i].description;
              _this.imagelist.push(data);
            }
          }
        }
        _this.changeMomentHeight();
      }, function (error) {});
    },
    player: function player() {
      return this.$refs.videoPlayer.player;
    },
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {},
    onPlayerWaiting: function onPlayerWaiting(player) {},
    onPlayerEnded: function onPlayerEnded(player) {},
    onPlayerPlaying: function onPlayerPlaying(player) {},
    onPlayerLoadeddata: function onPlayerLoadeddata(player) {},
    onPlayerTimeupdate: function onPlayerTimeupdate(player) {},
    onPlayerCanplay: function onPlayerCanplay(player) {},
    onPlayerCanplaythrough: function onPlayerCanplaythrough(player) {},
    playerStateChanged: function playerStateChanged(playerCurrentState) {},
    playerReadied: function playerReadied(player) {
      console.log('the player is readied', player);
    },
    showImage: function showImage(src) {
      var urls = [];
      for (var i = 0; i < this.imagelist.length; i++) {
        urls.push(this.imagelist[i].src);
      }
      external__jWeixin__default.a.previewImage({
        current: src,
        urls: urls
      });
    },
    showVideo: function showVideo(index) {

      if (this.videolist[index].type == "video") {
        this.showHideOnBlur = true;
        this.playerOptions.sources.src = this.videolist[index].actSrc;

        this.player().reset();
        this.player().src({ type: "video/mp4", src: this.videolist[index].actSrc });

        this.player().play();
      }
    },
    changeMomentHeight: function changeMomentHeight() {
      if (this.eventHub) {
        this.eventHub.$emit("resetView");
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4647f1c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/matchMoments.vue
var matchMoments_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#FFFFFF","position":"relative"},attrs:{"id":"secondTabItem"}},[(_vm.currentOrgCode !== '13702' && (_vm.imagelist.length > 0 || _vm.videolist.length > 0))?_c('div',{attrs:{"id":"inner_secondTabItem"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"15px","margin-right":"15px"}},[_vm._l((_vm.imagelist),function(item,index){return _c('img',{staticClass:"previewer-demo-img",staticStyle:{"padding":"3px","border-radius":"4px"},attrs:{"src":item.src,"width":"150","height":"100","onerror":_vm.defaultImg},on:{"click":function($event){return _vm.showImage(item.src)}}})}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.imagelist,"options":_vm.options}})],1)],2),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","flex-wrap":"wrap"}},_vm._l((_vm.videolist),function(item,index){return _c('div',{staticStyle:{"position":"relative","width":"150px","margin":"5px 20px"}},[_c('div',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"150px","height":"100px","z-index":"1001"},on:{"click":function($event){return _vm.showVideo(index)}}},[_c('div',{staticStyle:{"position":"absolute","z-index":"1002","top":"25px","left":"50px"}},[_c('img',{staticStyle:{"z-index":"1003","width":"50px","height":"50px"},attrs:{"src":_vm.videoTag}})])]),_vm._v(" "),_c('div',[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":item.src,"width":"150","height":"100"}})]),_vm._v(" "),(item.description && item.description != '')?_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(item.description))]):_vm._e()])}),0)]):_c('div',{staticStyle:{"text-align":"center","margin-top":"100px","height":"100%"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v("暂无精彩瞬间")])]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{staticClass:"dialog-demo",attrs:{"hide-on-blur":"","dialog-style":{ 'max-width': '100%', width: '100%' }},model:{value:(_vm.showHideOnBlur),callback:function ($$v) {_vm.showHideOnBlur=$$v},expression:"showHideOnBlur"}},[_c('div',[_c('div',{staticClass:"player"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",attrs:{"options":_vm.playerOptions,"playsinline":false},on:{"pause":function($event){return _vm.onPlayerPause($event)},"play":function($event){return _vm.onPlayerPlay($event)},"fullscreenchange":function($event){return _vm.onFullscreenChange($event)}}})],1)])])],1)])}
var matchMoments_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"15px","height":"44px","margin-top":"10px"}},[_c('span',{staticClass:"module-icon"}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"18px","color":"#333333"}},[_vm._v("照片")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"15px","height":"44px","margin-top":"20px","margin-bottom":"10px"}},[_c('span',{staticClass:"module-icon"}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"18px","color":"#333333"}},[_vm._v("视频")])])}]
var matchMoments_esExports = { render: matchMoments_render, staticRenderFns: matchMoments_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_matchMoments = (matchMoments_esExports);
// CONCATENATED MODULE: ./src/views/matchMoments.vue
function matchMoments_injectStyle (ssrContext) {
  __webpack_require__("vfw/")
}
var matchMoments_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchMoments___vue_template_functional__ = false
/* styles */
var matchMoments___vue_styles__ = matchMoments_injectStyle
/* scopeId */
var matchMoments___vue_scopeId__ = "data-v-4647f1c8"
/* moduleIdentifier (server only) */
var matchMoments___vue_module_identifier__ = null
var matchMoments_Component = matchMoments_normalizeComponent(
  views_matchMoments,
  selectortype_template_index_0_src_views_matchMoments,
  matchMoments___vue_template_functional__,
  matchMoments___vue_styles__,
  matchMoments___vue_scopeId__,
  matchMoments___vue_module_identifier__
)

/* harmony default export */ var src_views_matchMoments = (matchMoments_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/momentList.vue







/* harmony default export */ var momentList = ({
  computed: {},
  components: {
    matchResultHeader: src_components_MatchResultHeader,
    matchMoments: src_views_matchMoments,
    Scroller: vux_src_components_scroller
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    this.eventHub.$on('resetView', function () {
      _this.$nextTick(function () {
        _this.$refs.scroller.reset();
      });
    });
  },
  data: function data() {
    return {
      eventHub: new vue_esm["a" /* default */]()
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/momentList.vue







/* harmony default export */ var views_momentList = ({
  computed: {},
  components: {
    matchResultHeader: src_components_MatchResultHeader,
    matchMoments: src_views_matchMoments,
    Scroller: vux_src_components_scroller
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    this.eventHub.$on('resetView', function () {
      _this.$nextTick(function () {
        _this.$refs.scroller.reset();
      });
    });
  },
  data: function data() {
    return {
      eventHub: new vue_esm["a" /* default */]()
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fec7926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/momentList.vue
var momentList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('scroller',{ref:"scroller",attrs:{"lock-x":"","scrollbar-y":""}},[_c('div',[_c('div',{staticStyle:{"height":"200px"}},[_c('matchResultHeader')],1),_vm._v(" "),_c('div',[_c('matchMoments',{ref:"matchMomentsTab",attrs:{"eventHub":_vm.eventHub}})],1)])])],1)}
var momentList_staticRenderFns = []
var momentList_esExports = { render: momentList_render, staticRenderFns: momentList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_momentList = (momentList_esExports);
// CONCATENATED MODULE: ./src/views/momentList.vue
var momentList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var momentList___vue_template_functional__ = false
/* styles */
var momentList___vue_styles__ = null
/* scopeId */
var momentList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var momentList___vue_module_identifier__ = null
var momentList_Component = momentList_normalizeComponent(
  views_momentList,
  selectortype_template_index_0_src_views_momentList,
  momentList___vue_template_functional__,
  momentList___vue_styles__,
  momentList___vue_scopeId__,
  momentList___vue_module_identifier__
)

/* harmony default export */ var src_views_momentList = (momentList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/LeagueInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var LeagueInfo = ({
  ready: function ready() {
    external__Zepto__default.a.init();
  },
  data: function data() {
    return {
      leagueBasicInfo: {},
      teams: [],
      team_count: 0,
      indexContentHeight: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    // if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '未开始联赛'])}
    this.id = this.$route.query.leagueId;
    this.hagkHttp(this.hagkApi.getLeagueBasic(this.id), {}).then(function (res) {
      if (res.status == true) {
        if ("inprogress" == res.result.event_status || "finished" == res.result.event_status) {
          _this.$router.replace({ path: "/league_ongoing", query: { leagueId: _this.id } });
        }
        var result = {
          title: res.result.name,
          league_status: res.result.event_status,
          league_start_time: res.result.start_date,
          reg_start_time: res.result.reg_start_date,
          reg_end_time: res.result.reg_end_date,
          league_logo: res.result.logo

        };
        _this.leagueBasicInfo = result;
        document.title = result.title;
      }
      _this.$vux.loading.hide();
    }, function (error) {
      console.log(error);
      _this.$vux.loading.hide();
    });

    this.hagkHttp(this.hagkApi.getLeagueTeams(this.id), {}).then(function (res) {
      if (res.status == true) {
        _this.team_count = res.result.total;
        _this.teams = res.result.rows;
      }
      _this.$vux.loading.hide();
    }, function (error) {
      console.log(error);
      _this.$vux.loading.hide();
    });
    this.$nextTick(function () {
      var height = document.body.clientHeight;
      _this.indexContentHeight = height - 240;
    });
  },

  computed: {
    length: function length() {
      return this.tasks.length;
    }
  },
  methods: {},
  filters: {
    subfilter: function subfilter(value, sublength) {
      if (!value) return '';
      value = value.toString();
      if (value.length > sublength) {
        return value.substr(0, sublength) + "...";
      }
      return value;
    }
  },
  components: { LeagueHeader: src_components_LeagueHeader }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/LeagueInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var views_LeagueInfo = ({
  ready: function ready() {
    external__Zepto__default.a.init();
  },
  data: function data() {
    return {
      leagueBasicInfo: {},
      teams: [],
      team_count: 0,
      indexContentHeight: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    // if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '未开始联赛'])}
    this.id = this.$route.query.leagueId;
    this.hagkHttp(this.hagkApi.getLeagueBasic(this.id), {}).then(function (res) {
      if (res.status == true) {
        if ("inprogress" == res.result.event_status || "finished" == res.result.event_status) {
          _this.$router.replace({ path: "/league_ongoing", query: { leagueId: _this.id } });
        }
        var result = {
          title: res.result.name,
          league_status: res.result.event_status,
          league_start_time: res.result.start_date,
          reg_start_time: res.result.reg_start_date,
          reg_end_time: res.result.reg_end_date,
          league_logo: res.result.logo

        };
        _this.leagueBasicInfo = result;
        document.title = result.title;
      }
      _this.$vux.loading.hide();
    }, function (error) {
      console.log(error);
      _this.$vux.loading.hide();
    });

    this.hagkHttp(this.hagkApi.getLeagueTeams(this.id), {}).then(function (res) {
      if (res.status == true) {
        _this.team_count = res.result.total;
        _this.teams = res.result.rows;
      }
      _this.$vux.loading.hide();
    }, function (error) {
      console.log(error);
      _this.$vux.loading.hide();
    });
    this.$nextTick(function () {
      var height = document.body.clientHeight;
      _this.indexContentHeight = height - 240;
    });
  },

  computed: {
    length: function length() {
      return this.tasks.length;
    }
  },
  methods: {},
  filters: {
    subfilter: function subfilter(value, sublength) {
      if (!value) return '';
      value = value.toString();
      if (value.length > sublength) {
        return value.substr(0, sublength) + "...";
      }
      return value;
    }
  },
  components: { LeagueHeader: src_components_LeagueHeader }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b9b4781","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/LeagueInfo.vue
var LeagueInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article"},[_c('leagueHeader',{attrs:{"leagueBasicInfo":_vm.leagueBasicInfo}}),_vm._v(" "),_c('div',{staticClass:"team_total_info"},[_vm._v("已报名球队 "),_c('span',{staticClass:"team_number"},[_vm._v(_vm._s(_vm.team_count))]),_vm._v(" 支")]),_vm._v(" "),_c('div',{staticClass:"team_list",style:({height: _vm.indexContentHeight + 'px'})},[_vm._l((_vm.teams),function(item,index){return [_c('div',{staticStyle:{"background":"#FFFFFF","margin":"auto"}},[_c('div',{staticStyle:{"height":"51px"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"team_rank"},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"team_name"},[_vm._v(_vm._s(_vm._f("subfilter")(item.name,20)))])])])]),_vm._v(" "),_c('div',{staticStyle:{"background":"#F3F3F3","height":"1px","width":"100%","margin-left":"40px"}})]})],2)],1)}
var LeagueInfo_staticRenderFns = []
var LeagueInfo_esExports = { render: LeagueInfo_render, staticRenderFns: LeagueInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_LeagueInfo = (LeagueInfo_esExports);
// CONCATENATED MODULE: ./src/views/LeagueInfo.vue
function LeagueInfo_injectStyle (ssrContext) {
  __webpack_require__("cyp9")
}
var LeagueInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeagueInfo___vue_template_functional__ = false
/* styles */
var LeagueInfo___vue_styles__ = LeagueInfo_injectStyle
/* scopeId */
var LeagueInfo___vue_scopeId__ = "data-v-5b9b4781"
/* moduleIdentifier (server only) */
var LeagueInfo___vue_module_identifier__ = null
var LeagueInfo_Component = LeagueInfo_normalizeComponent(
  views_LeagueInfo,
  selectortype_template_index_0_src_views_LeagueInfo,
  LeagueInfo___vue_template_functional__,
  LeagueInfo___vue_styles__,
  LeagueInfo___vue_scopeId__,
  LeagueInfo___vue_module_identifier__
)

/* harmony default export */ var src_views_LeagueInfo = (LeagueInfo_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d29452ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":function($event){return _vm.onComposition($event, 'input')},"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":"radio"},domProps:{"checked":_vm._q(_vm.currentValue,null)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":function($event){return _vm.onComposition($event, 'input')},"change":function($event){_vm.currentValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":_vm.type},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){return _vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){return _vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("fFU4")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("5VbK")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/hotArea.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var hotArea = ({
	props: ['titleShow', 'showCount', 'zIndexP', 'selectedArea', 'isShowHotArea'],
	data: function data() {
		return {
			areas: [],
			zIndex: 10010,
			top: 55
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.resetzIndex();
		this.hagkHttp(this.hagkApi.getAllHotRegion(), {}).then(function (res) {
			if (res) {
				_this.areas.splice(0, _this.areas.length);
				for (var i = 0; i < res.length; i++) {
					_this.areas.push(res[i]);
				}
			}
		}, function (error) {
			console.log(error);
			window.alert('热门赛区获取失败！');
		});
	},

	watch: {
		isShowHotArea: function isShowHotArea() {
			if (this.isShowHotArea) {
				if (src_configInfo.isAdvertisementShow) {
					this.top = 55;
				} else {
					this.top = 55;
				}
			}
		}
	},
	methods: {
		resetzIndex: function resetzIndex() {

			if (typeof this.zIndexP != 'undefined') {
				this.zIndex = this.zIndexP;
			}
		},
		changeRegion: function changeRegion(orgCode, orgName) {
			this.$emit('changeRegion', orgCode, orgName);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/hotArea.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var views_hotArea = ({
	props: ['titleShow', 'showCount', 'zIndexP', 'selectedArea', 'isShowHotArea'],
	data: function data() {
		return {
			areas: [],
			zIndex: 10010,
			top: 55
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.resetzIndex();
		this.hagkHttp(this.hagkApi.getAllHotRegion(), {}).then(function (res) {
			if (res) {
				_this.areas.splice(0, _this.areas.length);
				for (var i = 0; i < res.length; i++) {
					_this.areas.push(res[i]);
				}
			}
		}, function (error) {
			console.log(error);
			window.alert('热门赛区获取失败！');
		});
	},

	watch: {
		isShowHotArea: function isShowHotArea() {
			if (this.isShowHotArea) {
				if (src_configInfo.isAdvertisementShow) {
					this.top = 55;
				} else {
					this.top = 55;
				}
			}
		}
	},
	methods: {
		resetzIndex: function resetzIndex() {

			if (typeof this.zIndexP != 'undefined') {
				this.zIndex = this.zIndexP;
			}
		},
		changeRegion: function changeRegion(orgCode, orgName) {
			this.$emit('changeRegion', orgCode, orgName);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e16358f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/hotArea.vue
var hotArea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pop",style:({'background-color':'#FFFFFF', 'padding-bottom':'10px', width:'100%', 'z-index':_vm.zIndex,'top':_vm.top+'px'})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.titleShow),expression:"titleShow"}],staticClass:"row",staticStyle:{"height":"45px"}},[_vm._m(0)]),_vm._v(" "),_vm._l((_vm.areas),function(area,index){return _c('div',[(_vm.showCount == -1 ? true : (index+1) <= _vm.showCount)?_c('div',{staticClass:"col-xs-3",staticStyle:{"height":"30px","text-align":"center","margin-top":"10px"}},[(area.name == _vm.selectedArea)?_c('div',{staticClass:"col-xs-11 col-xs-offset-1",staticStyle:{"border":"1px solid #F3F3F3","height":"30px"},attrs:{"orgCode":area.code,"orgName":area.name},on:{"click":function($event){return _vm.changeRegion(area.code, area.name,$event)}}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"12px","color":"#333333","line-height":"30px"}},[_vm._v(_vm._s(area.name))])]):_c('div',{staticClass:"col-xs-11 col-xs-offset-1",staticStyle:{"border":"1px solid #F3F3F3","height":"30px"},attrs:{"orgCode":area.code,"orgName":area.name},on:{"click":function($event){return _vm.changeRegion(area.code, area.name,$event)}}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"12px","color":"#333333","line-height":"30px"}},[_vm._v(_vm._s(area.name))])])]):_vm._e()])})],2)}
var hotArea_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12",staticStyle:{"margin-top":"10px","margin-bottom":"10px","padding-left":"15px"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"18px","color":"#333333"}},[_c('b',[_vm._v("热门赛区")])])])}]
var hotArea_esExports = { render: hotArea_render, staticRenderFns: hotArea_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_hotArea = (hotArea_esExports);
// CONCATENATED MODULE: ./src/views/hotArea.vue
function hotArea_injectStyle (ssrContext) {
  __webpack_require__("v94h")
}
var hotArea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var hotArea___vue_template_functional__ = false
/* styles */
var hotArea___vue_styles__ = hotArea_injectStyle
/* scopeId */
var hotArea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var hotArea___vue_module_identifier__ = null
var hotArea_Component = hotArea_normalizeComponent(
  views_hotArea,
  selectortype_template_index_0_src_views_hotArea,
  hotArea___vue_template_functional__,
  hotArea___vue_styles__,
  hotArea___vue_scopeId__,
  hotArea___vue_module_identifier__
)

/* harmony default export */ var src_views_hotArea = (hotArea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueList.vue











/* harmony default export */ var leagueList = ({
  name: 'app',
  created: function created() {
    this.orgCode = this.$route.query.orgCode;
    this.orgName = this.$route.query.orgName;
  },
  data: function data() {
    return {
      isShow: false,
      results: [],
      value: '',
      selectSvg: __webpack_require__("ra3e"),
      headSvgUrl: '../assets/logo.png',
      defaultImg: 'this.src="' + __webpack_require__("xiEX") + '"',

      content: [],
      pulldownConfig: {
        downContent: '下拉刷新',
        upContent: '释放后更新',
        loadingContent: 'Loading...'
      },
      pullupConfig: {
        upContent: '上拉加载更多', downContent: '释放后加载'
      },
      status2: {
        pulldownStatus: 'default',
        pullupStatus: 'default'
      },
      currentPage: 1,
      step: 10,
      leagueName: '',
      orgCode: '',
      orgName: '',
      timeclock: __webpack_require__("J4Oj"),
      screenWidth: 0,
      havaData: true
    };
  },
  components: {
    Badge: vux_src_components_badge,
    Icon: vux_src_components_icon,
    Search: vux_src_components_search,
    Scroller: vux_src_components_scroller,
    hotArea: src_views_hotArea,
    Spinner: node_modules_vux_src_components_spinner
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs.scroller.reset();
      _this2.getData();
      _this2.isUsePullup();
    });

    $('.weui-icon-clear').click(function () {
      _this2.$refs.search.setBlur();
      _this2.leagueName = '';
      _this2.getData();
    });
    this.screenWidth = window.innerWidth;
    this.initWxShareConfig();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      var fullPath = window.location.href;
      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      utils_wxShareConfig({
        title: '最新赛事',
        desc: this.orgName + '校园足球最新赛事',
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {}, function () {});
    },
    changeRegion: function changeRegion(orgCode, orgName) {
      this.pop();
      this.orgCode = orgCode;
      this.orgName = orgName;
      this.getData();
    },
    resultClick: function resultClick(item) {
      /*window.alert('you click the result item: ' + JSON.stringify(item))*/
    },
    getResult: function getResult(val) {
      /*this.leagueName = val;
      this.content.splice(0, this.content.length);
      this.getData();*/
    },
    onSubmit: function onSubmit() {
      this.$refs.search.setBlur();
      this.leagueName = this.$refs.search.value;
      this.getData();
    },
    onFocus: function onFocus() {
      /*console.log($('.vux-search-fixed').length);
      $('.vux-search-fixed').css('top', '0px');
      console.log('on focus')*/
    },
    onCancel: function onCancel() {
      this.leagueName = '';
      this.getData();
    },
    pop: function pop() {
      this.isShow = !this.isShow;
      if (this.isShow) {
        this.selectSvg = __webpack_require__("Q1oX");
      } else {
        this.selectSvg = __webpack_require__("ra3e");
      }
    },
    leagueInfo: function leagueInfo(leagueId) {
      src_configInfo.orgCode = this.orgCode;
      src_configInfo.orgName = this.orgName;
      this.$router.push({ path: "/league_info", query: { leagueId: leagueId, orgCode: this.orgCode, orgName: this.orgName } });
    },
    getData: function getData() {
      var _this3 = this;

      var _this = this;
      this.currentPage = 1;
      var start = (this.currentPage - 1) * this.step;
      _this.content.splice(0, _this.content.length);
      this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), { "leagueName": this.leagueName, "start": start, "step": this.step }).then(function (res) {
        if (res) {
          for (var i = 0; i < res.length; i++) {
            res[i].name = _this3.adapterScreenWidth(res[i].name);

            if (res[i].logo) {
              if (res[i].logo != null) {
                res[i].logo = _this3.getLeagueLogoUrl(res[i].logo);
              } else {
                res[i].logo = _this3.defaultImg;
              }
            } else {
              res[i].logo = _this3.defaultImg;
            }
            _this.content.push(res[i]);
          }
        }
        _this.$nextTick(function () {
          _this.$refs.scroller.reset({ top: 0 });
          _this.isUsePullup();
        });

        _this.havaData = !(_this.content.length == 0 && _this.leagueName.length == 0);
      }, function (error) {
        _this.isUsePullup();
        console.log(error);
        alert('数据获取失败！');
      });
    },
    pulldown: function pulldown() {
      var _this4 = this;

      var _this = this;
      var start = (_this.currentPage - 1) * _this.step;
      this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), { "leagueName": this.leagueName, "start": start, "step": this.step }).then(function (res) {
        if (res) {
          _this.content.splice(0, _this.content.length);
          for (var i = 0; i < res.length; i++) {
            res[i].name = _this4.adapterScreenWidth(res[i].name);
            if (res[i].logo) {
              if (res[i].logo != null) {
                res[i].logo = _this4.getLeagueLogoUrl(res[i].logo);
              } else {
                res[i].logo = _this4.defaultImg;
              }
            } else {
              res[i].logo = _this4.defaultImg;
            }
            _this.content.push(res[i]);
          }

          _this.$refs.scroller.donePulldown();
          _this.$nextTick(function () {
            _this.$refs.scroller.reset({ top: 0 });
          });
          _this4.currentPage = 1;
        }
        _this.isUsePullup();
      }, function (error) {
        _this.isUsePullup();
        console.log(error);
        alert('数据获取失败！');
      });
    },
    pullup: function pullup() {
      var _this5 = this;

      var _this = this;
      this.currentPage++;
      var start = (_this.currentPage - 1) * _this.step;
      this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), { "leagueName": this.leagueName, "start": start, "step": this.step }).then(function (res) {
        if (res) {
          if (res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              res[i].name = _this5.adapterScreenWidth(res[i].name);
              if (res[i].logo) {
                if (res[i].logo != null) {
                  res[i].logo = _this5.getLeagueLogoUrl(res[i].logo);
                } else {
                  res[i].logo = _this5.defaultImg;
                }
              } else {
                res[i].logo = _this5.defaultImg;
              }
              _this.content.push(res[i]);
            }
          } else {
            _this5.currentPage--;
          }
        }
        _this.$refs.scroller.donePullup();
        _this.$nextTick(function () {
          _this.$refs.scroller.reset();
          _this.isUsePullup();
        });
      }, function (error) {
        _this.$refs.scroller.donePullup();
        _this.$nextTick(function () {
          _this.$refs.scroller.reset();
          _this.isUsePullup();
        });
        console.log(error);
        alert('数据获取失败！');
      });
    },
    isUsePullup: function isUsePullup() {
      if (this.content.length > 7) this.$refs.scroller.enablePullup();else this.$refs.scroller.disablePullup();
    },
    getLeagueLogoUrl: function getLeagueLogoUrl(assetId) {
      if (assetId) {
        return this.hagkApi.getImgAssetById(assetId).url;
      } else {
        return null;
      }
    },
    cutLeagueName: function cutLeagueName(name, cutLength) {
      if (name.length <= cutLength) {
        return name;
      }
      if (!/^[a-zA-Z\d]/.test(name)) {
        return name.substring(0, cutLength) + "…";
      } else {
        var strLength = 0;
        var charCount = 0;
        for (var index = 0; index < name.length; index++) {
          if (/^[a-zA-Z\d]+$/.test(name[index])) {
            strLength += 0.5;
            charCount++;
          } else {
            strLength++;
          }
        }
        if (strLength <= cutLength) {
          return name;
        } else {
          return name.substring(0, cutLength + charCount / 2) + "…";
        }
      }
    },
    adapterScreenWidth: function adapterScreenWidth(name) {
      if (name) {
        if (this.screenWidth <= 320) {
          name = this.cutLeagueName(name, 13);
        } else if (this.screenWidth <= 375) {
          name = this.cutLeagueName(name, 16);
        } else {
          name = this.cutLeagueName(name, 21);
        }
      }
      return name;
    }
  },
  computed: {
    filterResult: function filterResult() {
      var _this6 = this;

      return this.defaultResult.filter(function (value) {
        return new RegExp(_this6.value, 'i').test(value);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/leagueList.vue











/* harmony default export */ var views_leagueList = ({
  name: 'app',
  created: function created() {
    this.orgCode = this.$route.query.orgCode;
    this.orgName = this.$route.query.orgName;
  },
  data: function data() {
    return {
      isShow: false,
      results: [],
      value: '',
      selectSvg: __webpack_require__("ra3e"),
      headSvgUrl: '../assets/logo.png',
      defaultImg: 'this.src="' + __webpack_require__("xiEX") + '"',

      content: [],
      pulldownConfig: {
        downContent: '下拉刷新',
        upContent: '释放后更新',
        loadingContent: 'Loading...'
      },
      pullupConfig: {
        upContent: '上拉加载更多', downContent: '释放后加载'
      },
      status2: {
        pulldownStatus: 'default',
        pullupStatus: 'default'
      },
      currentPage: 1,
      step: 10,
      leagueName: '',
      orgCode: '',
      orgName: '',
      timeclock: __webpack_require__("J4Oj"),
      screenWidth: 0,
      havaData: true
    };
  },
  components: {
    Badge: vux_src_components_badge,
    Icon: vux_src_components_icon,
    Search: vux_src_components_search,
    Scroller: vux_src_components_scroller,
    hotArea: src_views_hotArea,
    Spinner: node_modules_vux_src_components_spinner
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs.scroller.reset();
      _this2.getData();
      _this2.isUsePullup();
    });

    $('.weui-icon-clear').click(function () {
      _this2.$refs.search.setBlur();
      _this2.leagueName = '';
      _this2.getData();
    });
    this.screenWidth = window.innerWidth;
    this.initWxShareConfig();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      var fullPath = window.location.href;
      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      utils_wxShareConfig({
        title: '最新赛事',
        desc: this.orgName + '校园足球最新赛事',
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {}, function () {});
    },
    changeRegion: function changeRegion(orgCode, orgName) {
      this.pop();
      this.orgCode = orgCode;
      this.orgName = orgName;
      this.getData();
    },
    resultClick: function resultClick(item) {
      /*window.alert('you click the result item: ' + JSON.stringify(item))*/
    },
    getResult: function getResult(val) {
      /*this.leagueName = val;
      this.content.splice(0, this.content.length);
      this.getData();*/
    },
    onSubmit: function onSubmit() {
      this.$refs.search.setBlur();
      this.leagueName = this.$refs.search.value;
      this.getData();
    },
    onFocus: function onFocus() {
      /*console.log($('.vux-search-fixed').length);
      $('.vux-search-fixed').css('top', '0px');
      console.log('on focus')*/
    },
    onCancel: function onCancel() {
      this.leagueName = '';
      this.getData();
    },
    pop: function pop() {
      this.isShow = !this.isShow;
      if (this.isShow) {
        this.selectSvg = __webpack_require__("Q1oX");
      } else {
        this.selectSvg = __webpack_require__("ra3e");
      }
    },
    leagueInfo: function leagueInfo(leagueId) {
      src_configInfo.orgCode = this.orgCode;
      src_configInfo.orgName = this.orgName;
      this.$router.push({ path: "/league_info", query: { leagueId: leagueId, orgCode: this.orgCode, orgName: this.orgName } });
    },
    getData: function getData() {
      var _this3 = this;

      var _this = this;
      this.currentPage = 1;
      var start = (this.currentPage - 1) * this.step;
      _this.content.splice(0, _this.content.length);
      this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), { "leagueName": this.leagueName, "start": start, "step": this.step }).then(function (res) {
        if (res) {
          for (var i = 0; i < res.length; i++) {
            res[i].name = _this3.adapterScreenWidth(res[i].name);

            if (res[i].logo) {
              if (res[i].logo != null) {
                res[i].logo = _this3.getLeagueLogoUrl(res[i].logo);
              } else {
                res[i].logo = _this3.defaultImg;
              }
            } else {
              res[i].logo = _this3.defaultImg;
            }
            _this.content.push(res[i]);
          }
        }
        _this.$nextTick(function () {
          _this.$refs.scroller.reset({ top: 0 });
          _this.isUsePullup();
        });

        _this.havaData = !(_this.content.length == 0 && _this.leagueName.length == 0);
      }, function (error) {
        _this.isUsePullup();
        console.log(error);
        alert('数据获取失败！');
      });
    },
    pulldown: function pulldown() {
      var _this4 = this;

      var _this = this;
      var start = (_this.currentPage - 1) * _this.step;
      this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), { "leagueName": this.leagueName, "start": start, "step": this.step }).then(function (res) {
        if (res) {
          _this.content.splice(0, _this.content.length);
          for (var i = 0; i < res.length; i++) {
            res[i].name = _this4.adapterScreenWidth(res[i].name);
            if (res[i].logo) {
              if (res[i].logo != null) {
                res[i].logo = _this4.getLeagueLogoUrl(res[i].logo);
              } else {
                res[i].logo = _this4.defaultImg;
              }
            } else {
              res[i].logo = _this4.defaultImg;
            }
            _this.content.push(res[i]);
          }

          _this.$refs.scroller.donePulldown();
          _this.$nextTick(function () {
            _this.$refs.scroller.reset({ top: 0 });
          });
          _this4.currentPage = 1;
        }
        _this.isUsePullup();
      }, function (error) {
        _this.isUsePullup();
        console.log(error);
        alert('数据获取失败！');
      });
    },
    pullup: function pullup() {
      var _this5 = this;

      var _this = this;
      this.currentPage++;
      var start = (_this.currentPage - 1) * _this.step;
      this.hagkHttp(this.hagkApi.getLeagueByOrgCodeAndName(this.orgCode), { "leagueName": this.leagueName, "start": start, "step": this.step }).then(function (res) {
        if (res) {
          if (res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              res[i].name = _this5.adapterScreenWidth(res[i].name);
              if (res[i].logo) {
                if (res[i].logo != null) {
                  res[i].logo = _this5.getLeagueLogoUrl(res[i].logo);
                } else {
                  res[i].logo = _this5.defaultImg;
                }
              } else {
                res[i].logo = _this5.defaultImg;
              }
              _this.content.push(res[i]);
            }
          } else {
            _this5.currentPage--;
          }
        }
        _this.$refs.scroller.donePullup();
        _this.$nextTick(function () {
          _this.$refs.scroller.reset();
          _this.isUsePullup();
        });
      }, function (error) {
        _this.$refs.scroller.donePullup();
        _this.$nextTick(function () {
          _this.$refs.scroller.reset();
          _this.isUsePullup();
        });
        console.log(error);
        alert('数据获取失败！');
      });
    },
    isUsePullup: function isUsePullup() {
      if (this.content.length > 7) this.$refs.scroller.enablePullup();else this.$refs.scroller.disablePullup();
    },
    getLeagueLogoUrl: function getLeagueLogoUrl(assetId) {
      if (assetId) {
        return this.hagkApi.getImgAssetById(assetId).url;
      } else {
        return null;
      }
    },
    cutLeagueName: function cutLeagueName(name, cutLength) {
      if (name.length <= cutLength) {
        return name;
      }
      if (!/^[a-zA-Z\d]/.test(name)) {
        return name.substring(0, cutLength) + "…";
      } else {
        var strLength = 0;
        var charCount = 0;
        for (var index = 0; index < name.length; index++) {
          if (/^[a-zA-Z\d]+$/.test(name[index])) {
            strLength += 0.5;
            charCount++;
          } else {
            strLength++;
          }
        }
        if (strLength <= cutLength) {
          return name;
        } else {
          return name.substring(0, cutLength + charCount / 2) + "…";
        }
      }
    },
    adapterScreenWidth: function adapterScreenWidth(name) {
      if (name) {
        if (this.screenWidth <= 320) {
          name = this.cutLeagueName(name, 13);
        } else if (this.screenWidth <= 375) {
          name = this.cutLeagueName(name, 16);
        } else {
          name = this.cutLeagueName(name, 21);
        }
      }
      return name;
    }
  },
  computed: {
    filterResult: function filterResult() {
      var _this6 = this;

      return this.defaultResult.filter(function (value) {
        return new RegExp(_this6.value, 'i').test(value);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f7b36e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/leagueList.vue
var leagueList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":"赛事列表"}},[_c('div',{staticStyle:{"height":"55px"},attrs:{"id":"header"}},[_c('div',{staticClass:"col-xs-8 col-sm-9",staticStyle:{"margin-top":"5px","padding-left":"0px","padding-right":"0px"}},[_c('search',{ref:"search",attrs:{"placeholder":"搜索联赛","cancel-text":" ","results":_vm.results,"position":"absolute","auto-scroll-to-top":"","top":"0px"},on:{"result-click":_vm.resultClick,"on-change":_vm.getResult,"on-focus":_vm.onFocus,"on-cancel":_vm.onCancel,"on-submit":_vm.onSubmit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-sm-3",staticStyle:{"padding-left":"0px","padding-right":"15px","margin-top":"17px"}},[_c('div',{staticClass:"col-xs-10 col-sm-9",staticStyle:{"padding-left":"0px","padding-right":"0px","height":"20px"},on:{"click":function($event){return _vm.pop();}}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Light","color":"#FFFFFF","font-size":"14px","float":"right"}},[_vm._v(_vm._s(_vm.orgName))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 col-sm-2",staticStyle:{"padding-left":"0px","padding-right":"0px","height":"20px","margin-top":"0px"},on:{"click":function($event){return _vm.pop();}}},[_c('img',{staticStyle:{"height":"18px","width":"18px"},attrs:{"src":_vm.selectSvg}})])])]),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"background-color":"#F8F8F8","padding-left":"0px","padding-right":"0px"}},[(!_vm.havaData)?_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_vm._v("该区域没有联赛信息!")]):_vm._e(),_vm._v(" "),(_vm.content.length == 0 && _vm.leagueName.length != 0)?_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_vm._v("未搜索到对应联赛!")]):_vm._e(),_vm._v(" "),_c('scroller',{ref:"scroller",attrs:{"lockX":true,"height":"-55","pulldown-config":_vm.pulldownConfig,"pullup-config":_vm.pullupConfig,"use-pullup":true,"use-pulldown":true},on:{"on-pulldown-loading":_vm.pulldown,"on-pullup-loading":_vm.pullup},model:{value:(_vm.status2),callback:function ($$v) {_vm.status2=$$v},expression:"status2"}},[_c('div',_vm._l((_vm.content),function(obj,index){return _c('div',{staticClass:"row",staticStyle:{"height":"70px","background-color":"#FFFFFF","margin-top":"10px"},on:{"click":function($event){return _vm.leagueInfo(obj.id)}}},[_c('div',{staticClass:"col-xs-3 col-sm-2",staticStyle:{"margin-top":"10px","text-align":"left","padding-left":"20px"}},[_c('img',{staticStyle:{"height":"50px","width":"50px","border-radius":"20px"},attrs:{"src":obj.logo,"onerror":_vm.defaultImg}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-9 col-sm-10",staticStyle:{"margin-top":"12px","margin-left":"-20px"}},[_c('div',{staticClass:"row",staticStyle:{"height":"20px","margin-left":"15px"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","padding-left":"0px","float":"left"}},[_vm._v(_vm._s(obj.name))])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-top":"5px","margin-left":"15px","height":"30px"}},[_c('div',{staticStyle:{"padding-left":"0px","float":"left"}},[(obj.event_status == '2')?_c('span',{staticClass:"vux-badge-registration"},[_vm._v("报名中")]):(obj.event_status == '3')?_c('span',{staticClass:"vux-badge-waiting"},[_vm._v("待开赛")]):(obj.event_status == '1')?_c('span',{staticClass:"vux-badge-gaming"},[_vm._v("比赛中")]):(obj.event_status == '4')?_c('span',{staticClass:"vux-badge-end"},[_vm._v("已结束")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"15px","float":"right"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"12px","color":"#999999"}},[_vm._v(_vm._s(obj.start_date))])])])])])}),0),_vm._v(" "),_c('div',{staticClass:"xs-plugin-pulldown-container xs-plugin-pulldown-down",staticStyle:{"position":"absolute","width":"100%","height":"60px","line-height":"60px","top":"-60px","text-align":"center"},attrs:{"slot":"pulldown"},slot:"pulldown"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pulldownStatus === 'default'),expression:"status2.pulldownStatus === 'default'"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pulldownStatus === 'down' || _vm.status2.pulldownStatus === 'up'),expression:"status2.pulldownStatus === 'down' || status2.pulldownStatus === 'up'"}],staticClass:"pulldown-arrow",class:{'rotate': _vm.status2.pulldownStatus === 'up'}},[_vm._v("↓")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pulldownStatus === 'loading'),expression:"status2.pulldownStatus === 'loading'"}]},[_c('spinner',{attrs:{"type":"ios-small"}})],1)]),_vm._v(" "),_c('div',{staticClass:"xs-plugin-pullup-container xs-plugin-pullup-up",staticStyle:{"position":"absolute","width":"100%","height":"60px","bottom":"-40px","text-align":"center"},attrs:{"slot":"pullup"},slot:"pullup"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pullupStatus === 'default'),expression:"status2.pullupStatus === 'default'"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pullupStatus === 'default' || _vm.status2.pullupStatus === 'up' || _vm.status2.pullupStatus === 'down'),expression:"status2.pullupStatus === 'default' || status2.pullupStatus === 'up' || status2.pullupStatus === 'down'"}],staticClass:"pullup-arrow",class:{'rotate': _vm.status2.pullupStatus === 'down'}},[_vm._v("↑")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pullupStatus === 'loading'),expression:"status2.pullupStatus === 'loading'"}]},[_c('spinner',{attrs:{"type":"ios-small"}})],1)])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}]},[_c('hotArea',{attrs:{"selectedArea":_vm.orgName,"titleShow":true,"top":55,"showCount":-1},on:{"changeRegion":_vm.changeRegion}})],1)])}
var leagueList_staticRenderFns = []
var leagueList_esExports = { render: leagueList_render, staticRenderFns: leagueList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_leagueList = (leagueList_esExports);
// CONCATENATED MODULE: ./src/views/leagueList.vue
function leagueList_injectStyle (ssrContext) {
  __webpack_require__("OEKn")
}
var leagueList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leagueList___vue_template_functional__ = false
/* styles */
var leagueList___vue_styles__ = leagueList_injectStyle
/* scopeId */
var leagueList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var leagueList___vue_module_identifier__ = null
var leagueList_Component = leagueList_normalizeComponent(
  views_leagueList,
  selectortype_template_index_0_src_views_leagueList,
  leagueList___vue_template_functional__,
  leagueList___vue_styles__,
  leagueList___vue_scopeId__,
  leagueList___vue_module_identifier__
)

/* harmony default export */ var src_views_leagueList = (leagueList_Component.exports);

// CONCATENATED MODULE: ./src/js/loader.js



// 打印钩子函数运行的时间
var hookTime = function hookTime(component, hookFnName) {
  var date = new Date();
  var m = date.getMinutes();
  var s = date.getSeconds();
  var ms = date.getMilliseconds();
  console.log(component + ' ' + hookFnName + ' ' + m + '-' + s + '-' + ms);
};

// 加载动画
var loader = {
  show: function show() {
    if (external__Zepto__default()('.ball-beat')[0]) {
      return;
    }
    var modalContainer = document.body;
    external__Zepto__default()(modalContainer).append('<div class="loader-inner ball-beat"><div></div><div></div><div></div></div>');
  },
  hide: function hide() {
    external__Zepto__default()('.ball-beat').remove();
  }
};

// 微信分享配置
var loader_wxShareConfig = function wxShareConfig(_ref, success, fail) {
  var title = _ref.title,
      desc = _ref.desc,
      link = _ref.link,
      imgUrl = _ref.imgUrl;

  console.log('wxShare Config');
  external__jWeixin__default.a.ready(function () {
    // “分享给朋友”
    external__jWeixin__default.a.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    });
    // “分享到朋友圈”
    external__jWeixin__default.a.onMenuShareTimeline({
      title: title,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    });

    // 分享到QQ
    external__jWeixin__default.a.onMenuShareQQ({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    });
    // 分享到腾讯微博
    external__jWeixin__default.a.onMenuShareWeibo({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    });
    // 分享到QQ空间
    external__jWeixin__default.a.onMenuShareQZone({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    });
  });
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/advertisement.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var advertisement = ({
	data: function data() {
		return {
			closeTag: __webpack_require__("mq5u"),
			backgroundImg: __webpack_require__("GQND"),
			isAdvertisementShow: src_configInfo.isAdvertisementShow
		};
	},

	methods: {
		afterClose: function afterClose() {
			src_configInfo.isAdvertisementShow = false;
			this.isAdvertisementShow = src_configInfo.isAdvertisementShow;
			this.$emit('afterClose');
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/advertisement.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var views_advertisement = ({
	data: function data() {
		return {
			closeTag: __webpack_require__("mq5u"),
			backgroundImg: __webpack_require__("GQND"),
			isAdvertisementShow: src_configInfo.isAdvertisementShow
		};
	},

	methods: {
		afterClose: function afterClose() {
			src_configInfo.isAdvertisementShow = false;
			this.isAdvertisementShow = src_configInfo.isAdvertisementShow;
			this.$emit('afterClose');
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e7bfb1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/advertisement.vue
var advertisement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdvertisementShow),expression:"isAdvertisementShow"}],staticStyle:{"width":"100%","height":"55px","opacity":"1","filter":"Alpha(opacity=30)","z-index":"1001"}},[_c('img',{staticStyle:{"width":"100%","height":"55px"},attrs:{"src":_vm.backgroundImg}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","z-index":"1002","right":"3%","top":"14px"},on:{"click":function($event){return _vm.afterClose();}}},[_c('img',{staticStyle:{"z-index":"1003","width":"20px","height":"20px"},attrs:{"src":_vm.closeTag}})])])}
var advertisement_staticRenderFns = []
var advertisement_esExports = { render: advertisement_render, staticRenderFns: advertisement_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_advertisement = (advertisement_esExports);
// CONCATENATED MODULE: ./src/views/advertisement.vue
var advertisement_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var advertisement___vue_template_functional__ = false
/* styles */
var advertisement___vue_styles__ = null
/* scopeId */
var advertisement___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var advertisement___vue_module_identifier__ = null
var advertisement_Component = advertisement_normalizeComponent(
  views_advertisement,
  selectortype_template_index_0_src_views_advertisement,
  advertisement___vue_template_functional__,
  advertisement___vue_styles__,
  advertisement___vue_scopeId__,
  advertisement___vue_module_identifier__
)

/* harmony default export */ var src_views_advertisement = (advertisement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/index_region.vue











/* harmony default export */ var index_region = ({
  data: function data() {
    return {
      regionName: '',
      regionCode: '',
      showHotArea: false,
      showLeagueShoot: false,
      showLeaguePoints: true,
      indexContentHeight: 0,
      latestMatchs: [],
      latestLeagues: [],
      curLeague: {},
      curLeagueIndex: 0,
      loading: true,
      bestTeamNameLength: 10,
      scrollMinWidth: 0
    };
  },

  created: function created() {
    this.regionCode = this.$route.query.regionCode;
    this.regionName = this.$route.query.regionName;
    src_configInfo.orgCode = this.regionCode;
    src_configInfo.orgName = this.regionName;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var height = document.body.clientHeight;
      if (src_configInfo.isAdvertisementShow) {
        _this.indexContentHeight = height - 55;
      } else {
        _this.indexContentHeight = height - 55;
      }
    });
    this.initData();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      var fullPath = window.location.href;
      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      utils_wxShareConfig({
        title: '智能赛事',
        desc: this.regionName + '校园足球赛事最新赛况赛果&赛事大数据',
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {}, function () {});
    },
    initData: function initData() {
      var _this2 = this;

      this.loading = true;
      this.$vux.loading.show();
      this.hagkHttp(this.hagkApi.getIndex(this.regionCode), {}).then(function (res) {
        _this2.showLeagueShoot = false;
        _this2.showLeaguePoints = true;
        _this2.latestMatchs = [];
        _this2.latestLeagues = [];
        _this2.curLeague = {};
        if (res.status == true) {
          var result = res.result;
          _this2.latestMatchs = result.latestMatchs;
          _this2.latestLeagues = result.latestLeagues;
          if (_this2.latestLeagues.length > 0) {
            _this2.curLeague = _this2.latestLeagues[0];
            _this2.getLeagueDetail(_this2.curLeague.id);
          }

          _this2.$nextTick(function () {
            var width = document.body.clientWidth;
            if (width < 360) {
              _this2.bestTeamNameLength = 10;
            } else {
              _this2.bestTeamNameLength = 15;
            }

            if (1 == _this2.latestMatchs.length) {
              _this2.scrollMinWidth = 600;
            } else if (2 == _this2.latestMatchs.length) {
              _this2.scrollMinWidth = 900;
            } else {
              _this2.scrollMinWidth = 1200;
            }
          });
          _this2.initWxShareConfig();
        }
        _this2.loading = false;
        _this2.$vux.loading.hide();
      }, function (error) {
        console.log(error);
        _this2.$vux.loading.hide();
      });
    },
    getLeagueDetail: function getLeagueDetail(leagueId) {
      var _this3 = this;

      this.hagkHttp(this.hagkApi.getIndexLeague(leagueId), {}).then(function (res) {
        if (res.status == true) {
          _this3.curLeague.scoreBoard = res.result.scoreBoard;
          _this3.curLeague.shooterBoard = res.result.shooterBoard;
          _this3.curLeague.groups = res.result.groups;
          _this3.curLeague.statistic = res.result.statistic;
          _this3.getBest();
          _this3.initShooterBoard();
        }
      }, function (error) {
        console.log(error);
      });
    },
    changeLeague: function changeLeague(type) {
      this.showLeagueShoot = false;
      this.showLeaguePoints = true;

      if ('pre' == type) {
        this.curLeagueIndex -= 1;
      }
      if ('next' == type) {
        this.curLeagueIndex += 1;
      }
      if (this.curLeagueIndex < 0) {
        this.curLeagueIndex = this.latestLeagues.length - 1;
      }
      if (this.curLeagueIndex == this.latestLeagues.length) {
        this.curLeagueIndex = 0;
      }
      this.curLeague = this.latestLeagues[this.curLeagueIndex];
      this.getLeagueDetail(this.curLeague.id);
    },
    initShooterBoard: function initShooterBoard() {
      if (this.curLeague.shooterBoard) {
        var shooterBoard = this.curLeague.shooterBoard;
        for (var i = 0; i < shooterBoard.length; i++) {
          shooterBoard[i].avatarUrl = this.getShooterAvatarUrl(shooterBoard[i].avatarId);
          shooterBoard[i].useDefault = true;
        }
        this.curLeague.shooterBoard = shooterBoard;
      }
    },
    getShooterAvatarUrl: function getShooterAvatarUrl(avatarId) {
      return this.hagkApi.getImgAsset(avatarId).url + '.jpg';
    },
    getBest: function getBest() {
      var scoreBoard = [];
      if (this.curLeague.scoreBoard) {
        scoreBoard = this.curLeague.scoreBoard;
      }
      var bestGoalFor;
      var bestGoalAgainst;
      var maxAvgGoal = 0;
      var minAvgLoss = 9999;
      for (var i = 0; i < scoreBoard.length; i++) {
        if (0 == scoreBoard[i].matchNum) {
          continue;
        }

        var tempAvgGoal = (scoreBoard[i].goal / scoreBoard[i].matchNum).toFixed(2);
        if (tempAvgGoal > maxAvgGoal) {
          maxAvgGoal = tempAvgGoal;
          bestGoalFor = scoreBoard[i];
        }

        var tempAvgLoss = (scoreBoard[i].loss / scoreBoard[i].matchNum).toFixed(2);
        if (tempAvgLoss < minAvgLoss) {
          minAvgLoss = tempAvgLoss;
          bestGoalAgainst = scoreBoard[i];
        }
      }
      if (maxAvgGoal > 0) {
        this.curLeague.bestGoalFor = bestGoalFor;
      }
      if (minAvgLoss < 9999) {
        this.curLeague.bestGoalAgainst = bestGoalAgainst;
      }
    },
    changeRegion: function changeRegion(regionCode, regionName) {
      var _this4 = this;

      this.hagkHttp(this.hagkApi.getHotAreaLeagueCount(regionCode), {}).then(function (res) {
        if (res.status) {
          var leagueCount = res.result;
          if (leagueCount > 0) {
            _this4.showHotArea = false;
            if (_this4.regionCode != regionCode) {
              _this4.regionCode = regionCode;
              _this4.regionName = regionName;
              _this4.initData();
            }
          } else {
            _this4.$router.push({ path: 'public_index', query: { regionName: regionName, regionCode: regionCode } });
          }
        } else {
          console.log("获取联赛数量异常");
        }
      }, function (err) {
        console.log(err);
      });
    },
    switchTab: function switchTab(tag) {
      if (tag) {
        return;
      }
      this.showLeagueShoot = !this.showLeagueShoot;
      this.showLeaguePoints = !this.showLeaguePoints;
    },
    toLeagueList: function toLeagueList() {
      this.$router.push({
        path: '/league_list',
        query: {
          orgCode: this.regionCode,
          orgName: this.regionName
        }
      });
    },
    toMatchDetail: function toMatchDetail(matchId, homeTeamId, visitTeamId) {
      this.$router.push({
        path: '/match_info',
        query: {
          matchId: matchId,
          homeTeamId: homeTeamId,
          visitTeamId: visitTeamId
        }
      });
    },
    toLeagueDetail: function toLeagueDetail(leagueId, tabName) {
      this.$router.push({
        path: '/league_ongoing/' + tabName,
        query: {
          leagueId: leagueId
        }
      });
    },
    toMatchList: function toMatchList() {
      this.$router.push({
        path: '/match_list',
        query: {
          regionCode: this.regionCode
        }
      });
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    getMatchCardClass: function getMatchCardClass(leagueNameLength, homeTeamNameLength, vistingTeamNameLength) {
      if (leagueNameLength <= 22 && homeTeamNameLength <= 18 && vistingTeamNameLength <= 18) {
        return "mb20";
      } else {
        return "mb10";
      }
    },
    advClose: function advClose() {
      var height = document.body.clientHeight;
      this.indexContentHeight = height - 55;
    }
  },
  components: {
    Scroller: vux_src_components_scroller,
    Avatar: vue_avatar_min_default.a,
    HotArea: src_views_hotArea,
    advertisement: src_views_advertisement
  },
  filters: {
    subfilter: function subfilter(value, sublength) {
      if (!value) return '';
      value = value.toString();
      if (value.length > sublength) {
        return value.substr(0, sublength) + "...";
      }
      return value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/index_region.vue











/* harmony default export */ var views_index_region = ({
  data: function data() {
    return {
      regionName: '',
      regionCode: '',
      showHotArea: false,
      showLeagueShoot: false,
      showLeaguePoints: true,
      indexContentHeight: 0,
      latestMatchs: [],
      latestLeagues: [],
      curLeague: {},
      curLeagueIndex: 0,
      loading: true,
      bestTeamNameLength: 10,
      scrollMinWidth: 0
    };
  },

  created: function created() {
    this.regionCode = this.$route.query.regionCode;
    this.regionName = this.$route.query.regionName;
    src_configInfo.orgCode = this.regionCode;
    src_configInfo.orgName = this.regionName;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var height = document.body.clientHeight;
      if (src_configInfo.isAdvertisementShow) {
        _this.indexContentHeight = height - 55;
      } else {
        _this.indexContentHeight = height - 55;
      }
    });
    this.initData();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      var fullPath = window.location.href;
      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      utils_wxShareConfig({
        title: '智能赛事',
        desc: this.regionName + '校园足球赛事最新赛况赛果&赛事大数据',
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {}, function () {});
    },
    initData: function initData() {
      var _this2 = this;

      this.loading = true;
      this.$vux.loading.show();
      this.hagkHttp(this.hagkApi.getIndex(this.regionCode), {}).then(function (res) {
        _this2.showLeagueShoot = false;
        _this2.showLeaguePoints = true;
        _this2.latestMatchs = [];
        _this2.latestLeagues = [];
        _this2.curLeague = {};
        if (res.status == true) {
          var result = res.result;
          _this2.latestMatchs = result.latestMatchs;
          _this2.latestLeagues = result.latestLeagues;
          if (_this2.latestLeagues.length > 0) {
            _this2.curLeague = _this2.latestLeagues[0];
            _this2.getLeagueDetail(_this2.curLeague.id);
          }

          _this2.$nextTick(function () {
            var width = document.body.clientWidth;
            if (width < 360) {
              _this2.bestTeamNameLength = 10;
            } else {
              _this2.bestTeamNameLength = 15;
            }

            if (1 == _this2.latestMatchs.length) {
              _this2.scrollMinWidth = 600;
            } else if (2 == _this2.latestMatchs.length) {
              _this2.scrollMinWidth = 900;
            } else {
              _this2.scrollMinWidth = 1200;
            }
          });
          _this2.initWxShareConfig();
        }
        _this2.loading = false;
        _this2.$vux.loading.hide();
      }, function (error) {
        console.log(error);
        _this2.$vux.loading.hide();
      });
    },
    getLeagueDetail: function getLeagueDetail(leagueId) {
      var _this3 = this;

      this.hagkHttp(this.hagkApi.getIndexLeague(leagueId), {}).then(function (res) {
        if (res.status == true) {
          _this3.curLeague.scoreBoard = res.result.scoreBoard;
          _this3.curLeague.shooterBoard = res.result.shooterBoard;
          _this3.curLeague.groups = res.result.groups;
          _this3.curLeague.statistic = res.result.statistic;
          _this3.getBest();
          _this3.initShooterBoard();
        }
      }, function (error) {
        console.log(error);
      });
    },
    changeLeague: function changeLeague(type) {
      this.showLeagueShoot = false;
      this.showLeaguePoints = true;

      if ('pre' == type) {
        this.curLeagueIndex -= 1;
      }
      if ('next' == type) {
        this.curLeagueIndex += 1;
      }
      if (this.curLeagueIndex < 0) {
        this.curLeagueIndex = this.latestLeagues.length - 1;
      }
      if (this.curLeagueIndex == this.latestLeagues.length) {
        this.curLeagueIndex = 0;
      }
      this.curLeague = this.latestLeagues[this.curLeagueIndex];
      this.getLeagueDetail(this.curLeague.id);
    },
    initShooterBoard: function initShooterBoard() {
      if (this.curLeague.shooterBoard) {
        var shooterBoard = this.curLeague.shooterBoard;
        for (var i = 0; i < shooterBoard.length; i++) {
          shooterBoard[i].avatarUrl = this.getShooterAvatarUrl(shooterBoard[i].avatarId);
          shooterBoard[i].useDefault = true;
        }
        this.curLeague.shooterBoard = shooterBoard;
      }
    },
    getShooterAvatarUrl: function getShooterAvatarUrl(avatarId) {
      return this.hagkApi.getImgAsset(avatarId).url + '.jpg';
    },
    getBest: function getBest() {
      var scoreBoard = [];
      if (this.curLeague.scoreBoard) {
        scoreBoard = this.curLeague.scoreBoard;
      }
      var bestGoalFor;
      var bestGoalAgainst;
      var maxAvgGoal = 0;
      var minAvgLoss = 9999;
      for (var i = 0; i < scoreBoard.length; i++) {
        if (0 == scoreBoard[i].matchNum) {
          continue;
        }

        var tempAvgGoal = (scoreBoard[i].goal / scoreBoard[i].matchNum).toFixed(2);
        if (tempAvgGoal > maxAvgGoal) {
          maxAvgGoal = tempAvgGoal;
          bestGoalFor = scoreBoard[i];
        }

        var tempAvgLoss = (scoreBoard[i].loss / scoreBoard[i].matchNum).toFixed(2);
        if (tempAvgLoss < minAvgLoss) {
          minAvgLoss = tempAvgLoss;
          bestGoalAgainst = scoreBoard[i];
        }
      }
      if (maxAvgGoal > 0) {
        this.curLeague.bestGoalFor = bestGoalFor;
      }
      if (minAvgLoss < 9999) {
        this.curLeague.bestGoalAgainst = bestGoalAgainst;
      }
    },
    changeRegion: function changeRegion(regionCode, regionName) {
      var _this4 = this;

      this.hagkHttp(this.hagkApi.getHotAreaLeagueCount(regionCode), {}).then(function (res) {
        if (res.status) {
          var leagueCount = res.result;
          if (leagueCount > 0) {
            _this4.showHotArea = false;
            if (_this4.regionCode != regionCode) {
              _this4.regionCode = regionCode;
              _this4.regionName = regionName;
              _this4.initData();
            }
          } else {
            _this4.$router.push({ path: 'public_index', query: { regionName: regionName, regionCode: regionCode } });
          }
        } else {
          console.log("获取联赛数量异常");
        }
      }, function (err) {
        console.log(err);
      });
    },
    switchTab: function switchTab(tag) {
      if (tag) {
        return;
      }
      this.showLeagueShoot = !this.showLeagueShoot;
      this.showLeaguePoints = !this.showLeaguePoints;
    },
    toLeagueList: function toLeagueList() {
      this.$router.push({
        path: '/league_list',
        query: {
          orgCode: this.regionCode,
          orgName: this.regionName
        }
      });
    },
    toMatchDetail: function toMatchDetail(matchId, homeTeamId, visitTeamId) {
      this.$router.push({
        path: '/match_info',
        query: {
          matchId: matchId,
          homeTeamId: homeTeamId,
          visitTeamId: visitTeamId
        }
      });
    },
    toLeagueDetail: function toLeagueDetail(leagueId, tabName) {
      this.$router.push({
        path: '/league_ongoing/' + tabName,
        query: {
          leagueId: leagueId
        }
      });
    },
    toMatchList: function toMatchList() {
      this.$router.push({
        path: '/match_list',
        query: {
          regionCode: this.regionCode
        }
      });
    },
    getRoundName: function getRoundName(roundType, roundNum, roundTitle) {
      var roundName = "--";

      if (roundType == 'cup_1') {
        roundName = "决赛";
      } else if (roundType == 'cup_2') {
        roundName = "半决赛";
      } else if (roundType == 'cup_4') {
        roundName = "1/4决赛";
      } else if (roundType == 'cup_8') {
        roundName = "1/8决赛";
      } else if (roundType == 'cup_16') {
        roundName = "1/16决赛";
      } else if (roundType == 'cup_32') {
        roundName = "1/32决赛";
      } else if (roundType == 'cup_64') {
        roundName = "1/64决赛";
      } else if (roundType == 'cup_128') {
        roundName = "1/128决赛";
      } else if (roundType == 'cup_team' || roundType == 'league') {
        roundName = "第" + roundNum + "轮";
      } else if (roundType == 'customized_rank_round') {
        roundName = roundTitle;
      } else {
        var arr = roundType.split("_");
        roundName = +arr[3] + "-" + arr[2] + "名排位赛";
      }
      return roundName;
    },
    getMatchCardClass: function getMatchCardClass(leagueNameLength, homeTeamNameLength, vistingTeamNameLength) {
      if (leagueNameLength <= 22 && homeTeamNameLength <= 18 && vistingTeamNameLength <= 18) {
        return "mb20";
      } else {
        return "mb10";
      }
    },
    advClose: function advClose() {
      var height = document.body.clientHeight;
      this.indexContentHeight = height - 55;
    }
  },
  components: {
    Scroller: vux_src_components_scroller,
    Avatar: vue_avatar_min_default.a,
    HotArea: src_views_hotArea,
    advertisement: src_views_advertisement
  },
  filters: {
    subfilter: function subfilter(value, sublength) {
      if (!value) return '';
      value = value.toString();
      if (value.length > sublength) {
        return value.substr(0, sublength) + "...";
      }
      return value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f774e1f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index_region.vue
var index_region_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"data-title":"首页"}},[_c('div',{staticClass:"index-header"},[_c('div',{staticClass:"header-title"},[_vm._v("智能赛事")]),_vm._v(" "),_c('div',{staticClass:"header-region",on:{"click":function($event){_vm.showHotArea=!_vm.showHotArea}}},[_c('span',[_vm._v(_vm._s(_vm.regionName))]),_vm._v(" "),_c('span',{staticClass:"arrow-down"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showHotArea),expression:"!showHotArea"}],attrs:{"src":__webpack_require__("ra3e")}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHotArea),expression:"showHotArea"}],attrs:{"src":__webpack_require__("Q1oX")}})])])]),_vm._v(" "),_c('hot-area',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHotArea),expression:"showHotArea"}],attrs:{"selectedArea":_vm.regionName,"isShowHotArea":_vm.showHotArea,"titleShow":"true","top":"55","showCount":"-1"},on:{"changeRegion":_vm.changeRegion}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"index-content",style:({height: _vm.indexContentHeight + 'px'})},[_c('div',{staticClass:"index-module"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"module-content"},[(_vm.latestMatchs && _vm.latestMatchs.length > 0)?[_c('scroller',{attrs:{"lock-y":"","scrollbar-x":false}},[_c('div',{staticClass:"scroll-box",style:({width: _vm.scrollMinWidth + 'px'})},[_vm._l((_vm.latestMatchs),function(match,index){return [_c('div',{staticClass:"match-card",class:'match-card-bg' + (index + 1),on:{"click":function($event){return _vm.toMatchDetail(match.id, match.homeTeamId, match.vistingTeamId)}}},[_c('div',{staticClass:"match-name",class:_vm.getMatchCardClass(match.leagueName.length, match.homeTeamName.length, match.vistingTeamName.length)},[_vm._v("\n                    "+_vm._s(match.leagueName)+"\n                    "),(match.round)?[_vm._v("("+_vm._s(_vm.getRoundName(match.round.type, match.round.number, match.round.title))+")")]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"match-team-info"},[_c('span',{staticClass:"team-name"},[_vm._v(_vm._s(match.homeTeamName))]),_vm._v(" "),_c('span',{staticClass:"score"},[_vm._v("\n                      "+_vm._s(match.result.goalFor + (match.result.homeExScore ? match.result.homeExScore : 0)  + (match.result.homePkScore ? match.result.homePkScore : 0))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"match-team-info"},[_c('span',{staticClass:"team-name"},[_vm._v(_vm._s(match.vistingTeamName))]),_vm._v(" "),_c('span',{staticClass:"score"},[_vm._v("\n                      "+_vm._s(match.result.goalAgainst + (match.result.visitorExScore ? match.result.visitorExScore : 0) + (match.result.visitorPkScore ? match.result.visitorPkScore : 0))+"\n                      ")])])])]}),_vm._v(" "),_c('div',{staticClass:"match-card-more",on:{"click":function($event){return _vm.toMatchList()}}},[_c('span',[_vm._v("更多比赛")])])],2)])]:[_c('div',{staticClass:"no-data"},[_vm._v("暂无数据")])]],2)]),_vm._v(" "),_c('div',{staticClass:"index-module"},[_c('div',{staticClass:"module-header"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"module-more",on:{"click":_vm.toLeagueList}},[_c('span',[_vm._v("全部赛事")]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"module-content"},[(_vm.curLeague)?[_c('div',{staticClass:"league-title"},[_c('img',{staticStyle:{"margin-right":"10px"},attrs:{"src":__webpack_require__("5p9W")},on:{"click":function($event){return _vm.changeLeague('pre')}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("nUYS")}}),_vm._v(_vm._s(_vm.curLeague.name)+"\n            "),_c('img',{staticStyle:{"margin-left":"10px"},attrs:{"src":__webpack_require__("8fWD")},on:{"click":function($event){return _vm.changeLeague('next')}}})]),_vm._v(" "),_c('div',{staticClass:"league-tab"},[_c('span',{class:{'selected' : _vm.showLeaguePoints},on:{"click":function($event){return _vm.switchTab(_vm.showLeaguePoints)}}},[_vm._v("积分榜")]),_vm._v(" "),_c('span',{class:{'selected' : _vm.showLeagueShoot},on:{"click":function($event){return _vm.switchTab(_vm.showLeagueShoot)}}},[_vm._v("射手榜")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeaguePoints),expression:"showLeaguePoints"}],staticClass:"league-shoot"},[(_vm.curLeague.scoreBoard && _vm.curLeague.scoreBoard.length > 0)?[(_vm.curLeague.groups && _vm.curLeague.groups.length > 0)?[_vm._l((_vm.curLeague.groups),function(group,index){return (index < 2)?[_c('div',{staticClass:"code"},[_vm._v(_vm._s(group.cupGroupName)+"组")]),_vm._v(" "),_c('table',[_vm._m(3,true),_vm._v(" "),_vm._l((group.scoreBoard),function(scoreBoard,index2){return (index2 < 3)?[_c('tr',[_c('td',{staticClass:"index",class:index2 == 0 ? 'no1' : ''},[_vm._v(_vm._s(index2 + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(scoreBoard.teamName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.wonMatchNum)+"/"+_vm._s(scoreBoard.drawnMatchNum)+"/"+_vm._s(scoreBoard.lostMatchNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.goal)+"/"+_vm._s(scoreBoard.loss))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.points))])])]:_vm._e()})],2)]:_vm._e()})]:[_c('table',[_vm._m(4),_vm._v(" "),_vm._l((_vm.curLeague.scoreBoard),function(scoreBoard,index){return (index < 6)?[_c('tr',[_c('td',{staticClass:"index",class:index == 0 ? 'no1' : ''},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(scoreBoard.teamName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.wonMatchNum)+"/"+_vm._s(scoreBoard.drawnMatchNum)+"/"+_vm._s(scoreBoard.lostMatchNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.goal)+"/"+_vm._s(scoreBoard.loss))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(scoreBoard.points))])])]:_vm._e()})],2)],_vm._v(" "),_c('div',{staticClass:"league-more",on:{"click":function($event){return _vm.toLeagueDetail(_vm.curLeague.id, 'jifen')}}},[_vm._v("完全积分榜")])]:[_c('div',{staticClass:"no-data"},[_vm._v("暂无数据")])]],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeagueShoot),expression:"showLeagueShoot"}],staticClass:"league-shoot"},[(_vm.curLeague.shooterBoard && _vm.curLeague.shooterBoard.length > 0)?[_c('table',[_vm._m(5),_vm._v(" "),_vm._l((_vm.curLeague.shooterBoard),function(shooterBoard,index){return [_c('tr',[_c('td',{staticClass:"index"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[(shooterBoard.useDefault)?_c('img',{staticStyle:{"border-radius":"50%"},attrs:{"src":shooterBoard.avatarUrl,"width":"30px","height":"30px"},on:{"error":function($event){shooterBoard.useDefault=false}}}):_vm._e(),_vm._v(" "),(!shooterBoard.useDefault)?_c('avatar',{attrs:{"username":shooterBoard.playerName,"size":30,"rounded":true,"lighten":100}}):_vm._e()],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"0"},attrs:{"nowrap":"nowrap"}},[_vm._v(_vm._s(shooterBoard.playerName))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(shooterBoard.teamName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(shooterBoard.goals))])])]})],2),_vm._v(" "),_c('div',{staticClass:"league-more",on:{"click":function($event){return _vm.toLeagueDetail(_vm.curLeague.id, 'shooters')}}},[_vm._v("完全射手榜")])]:[_c('div',{staticClass:"no-data"},[_vm._v("暂无数据")])]],2)]:[_c('div',{staticClass:"no-data"},[_vm._v("暂无数据")])]],2)]),_vm._v(" "),(_vm.curLeague && _vm.curLeague.statistic)?_c('div',{staticClass:"index-module"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"module-content",staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticClass:"league-data"},[_c('div',{staticClass:"sub-data data-up"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.curLeague.statistic.matchNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("比赛场次")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zEvL"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"center",staticStyle:{"position":"inherit"}},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.curLeague.statistic.goalNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("进球数量")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5mmK"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.curLeague.statistic.teamNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("球队数量")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("YAkp"),"height":"20","width":"20"}})])]),_vm._v(" "),_c('div',{staticClass:"sub-data data-down"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.curLeague.statistic.playerNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("球员数量")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("lbSq"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"center",staticStyle:{"position":"inherit"}},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.curLeague.statistic.redNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("红牌")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zn2l"),"height":"20","width":"20"}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.curLeague.statistic.yellowNum))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("黄牌")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("bkOh"),"height":"20","width":"20"}})])])]),_vm._v(" "),(_vm.curLeague.bestGoalFor)?[_c('div',{staticClass:"league-best"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":__webpack_require__("hK2L"),"height":"14","width":"14"}}),_vm._v(" "),_c('span',{staticClass:"key"},[_vm._v("最佳进攻球队")]),_vm._v(" "),_c('span',{staticClass:"team-name",attrs:{"title":_vm.curLeague.bestGoalFor.teamName}},[_vm._v(_vm._s(_vm._f("subfilter")(_vm.curLeague.bestGoalFor.teamName,_vm.bestTeamNameLength)))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"key"},[_vm._v("进球")]),_vm._v(" "),_c('span',{staticClass:"goals"},[_vm._v(_vm._s(_vm.curLeague.bestGoalFor.goal))])])])]:_vm._e(),_vm._v(" "),(_vm.curLeague.bestGoalAgainst)?[_c('div',{staticClass:"league-best"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":__webpack_require__("ZKQ2"),"height":"14","width":"14"}}),_vm._v(" "),_c('span',{staticClass:"key"},[_vm._v("最佳防守球队")]),_vm._v(" "),_c('span',{staticClass:"team-name",attrs:{"title":_vm.curLeague.bestGoalAgainst.teamName}},[_vm._v(_vm._s(_vm._f("subfilter")(_vm.curLeague.bestGoalAgainst.teamName,_vm.bestTeamNameLength)))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"key"},[_vm._v("丢球")]),_vm._v(" "),_c('span',{staticClass:"goals"},[_vm._v(_vm._s(_vm.curLeague.bestGoalAgainst.loss))])])])]:_vm._e()],2)]):_vm._e()])],1)}
var index_region_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-header"},[_c('span',{staticClass:"module-icon"}),_vm._v(" "),_c('span',{staticClass:"module-name"},[_vm._v("最新比赛")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-title"},[_c('span',{staticClass:"module-icon"}),_vm._v(" "),_c('span',{staticClass:"module-name"},[_vm._v("近期赛事")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"arrow-right"},[_c('img',{attrs:{"src":__webpack_require__("AkLj")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("排名")]),_vm._v(" "),_c('th',[_vm._v("球队")]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v("胜/平/负")]),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("进/失")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("积分")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("排名")]),_vm._v(" "),_c('th',[_vm._v("球队")]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v("胜/平/负")]),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("进/失")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("积分")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("排名")]),_vm._v(" "),_c('th',{attrs:{"width":"28%","colspan":"2"}},[_vm._v("球员")]),_vm._v(" "),_c('th',[_vm._v("球队")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("进球")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-header"},[_c('span',{staticClass:"module-icon"}),_vm._v(" "),_c('span',{staticClass:"module-name"},[_vm._v("赛事数据")])])}]
var index_region_esExports = { render: index_region_render, staticRenderFns: index_region_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_index_region = (index_region_esExports);
// CONCATENATED MODULE: ./src/views/index_region.vue
function index_region_injectStyle (ssrContext) {
  __webpack_require__("tXU6")
}
var index_region_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var index_region___vue_template_functional__ = false
/* styles */
var index_region___vue_styles__ = index_region_injectStyle
/* scopeId */
var index_region___vue_scopeId__ = "data-v-f774e1f6"
/* moduleIdentifier (server only) */
var index_region___vue_module_identifier__ = null
var index_region_Component = index_region_normalizeComponent(
  views_index_region,
  selectortype_template_index_0_src_views_index_region,
  index_region___vue_template_functional__,
  index_region___vue_styles__,
  index_region___vue_scopeId__,
  index_region___vue_module_identifier__
)

/* harmony default export */ var src_views_index_region = (index_region_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/publicindex/head.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var head = ({
  props: ['hasMatch', 'regionName', 'controlHotArea'],
  data: function data() {
    return {
      showHotArea: false
    };
  },

  watch: {
    controlHotArea: function controlHotArea(curVal, oldVal) {
      this.showHotArea = false;
    }
  },
  mounted: function mounted() {
    this.screenScala = document.body.clientWidth / 375;
    this.containerHeight = this.resizePx(this.containerHeight);
    this.infoMarginTop = this.resizePx(this.infoMarginTop);
    this.titleMargintTop = this.resizePx(this.titleMargintTop);
    this.titleMarginLeftRight = this.resizePx(this.titleMarginLeftRight);
  },

  methods: {
    resizePx: function resizePx(px) {
      return px * this.screenScala + 'px';
    },
    changeRegion: function changeRegion(regionCode, regionName) {
      this.$emit('changeRegion', regionCode, regionName);
    }
  },
  components: { HotArea: src_views_hotArea }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/publicindex/head.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var publicindex_head = ({
  props: ['hasMatch', 'regionName', 'controlHotArea'],
  data: function data() {
    return {
      showHotArea: false
    };
  },

  watch: {
    controlHotArea: function controlHotArea(curVal, oldVal) {
      this.showHotArea = false;
    }
  },
  mounted: function mounted() {
    this.screenScala = document.body.clientWidth / 375;
    this.containerHeight = this.resizePx(this.containerHeight);
    this.infoMarginTop = this.resizePx(this.infoMarginTop);
    this.titleMargintTop = this.resizePx(this.titleMargintTop);
    this.titleMarginLeftRight = this.resizePx(this.titleMarginLeftRight);
  },

  methods: {
    resizePx: function resizePx(px) {
      return px * this.screenScala + 'px';
    },
    changeRegion: function changeRegion(regionCode, regionName) {
      this.$emit('changeRegion', regionCode, regionName);
    }
  },
  components: { HotArea: src_views_hotArea }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c5f60e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicindex/head.vue
var head_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base_container",attrs:{"id":"container"}},[_c('div',{staticClass:"league_name"},[_vm._v("\n    智能赛事\n  ")]),_vm._v(" "),_c('div',{staticClass:"area"},[_c('span',{staticStyle:{"margin-right":"4px"},on:{"click":function($event){_vm.showHotArea=!_vm.showHotArea}}},[_vm._v(_vm._s(_vm.regionName))]),_vm._v(" "),_c('span',{staticClass:"arrow-down",on:{"click":function($event){_vm.showHotArea=!_vm.showHotArea}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showHotArea),expression:"!showHotArea"}],attrs:{"src":__webpack_require__("ra3e")}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHotArea),expression:"showHotArea"}],attrs:{"src":__webpack_require__("Q1oX")}})])]),_vm._v(" "),_c('div',{staticClass:"info"},[(!this.hasMatch)?[_vm._v("当前地区暂无比赛")]:_vm._e()],2),_vm._v(" "),_c('hot-area',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHotArea),expression:"showHotArea"}],attrs:{"selectedArea":_vm.regionName,"titleShow":"true","top":"59","isShowHotArea":_vm.showHotArea,"showCount":"-1"},on:{"changeRegion":_vm.changeRegion}})],1)}
var head_staticRenderFns = []
var head_esExports = { render: head_render, staticRenderFns: head_staticRenderFns }
/* harmony default export */ var components_publicindex_head = (head_esExports);
// CONCATENATED MODULE: ./src/components/publicindex/head.vue
function head_injectStyle (ssrContext) {
  __webpack_require__("VyGl")
}
var head_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var head___vue_template_functional__ = false
/* styles */
var head___vue_styles__ = head_injectStyle
/* scopeId */
var head___vue_scopeId__ = "data-v-27c5f60e"
/* moduleIdentifier (server only) */
var head___vue_module_identifier__ = null
var head_Component = head_normalizeComponent(
  publicindex_head,
  components_publicindex_head,
  head___vue_template_functional__,
  head___vue_styles__,
  head___vue_scopeId__,
  head___vue_module_identifier__
)

/* harmony default export */ var src_components_publicindex_head = (head_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/matchSimple_publicIndex.vue




/* harmony default export */ var matchSimple_publicIndex = ({
  props: {
    matchInfo: Object
  },
  data: function data() {
    return {
      score: "",
      objInfo: {},
      scoreStyle: {
        'font-size': '18px',
        color: '#FE2754'
      }
    };
  },

  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.customizeStyle();
    this.reload();
  },

  methods: {
    customizeStyle: function customizeStyle() {
      if (!this.matchInfo.isEnd) {
        this.scoreStyle.color = '#299AFE';
        this.scoreStyle['font-size'] = '24px';
      }
    },
    viewMatch: function viewMatch() {
      this.$router.push({
        path: 'match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId
        }
      });
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      if (!this.matchInfo.isEnd) {
        this.score = "vs";
      } else {
        this.score = this.genScore();
      }
    },
    genScore: function genScore() {
      var score = '';
      if (this.objInfo && this.objInfo.result) {
        var matchObj = this.objInfo.result;
        var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";

        score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
        score += "-";
        score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
      } else {
        score = "暂无比分";
      }
      return score;
    }
  },
  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/league/matchSimple_publicIndex.vue




/* harmony default export */ var league_matchSimple_publicIndex = ({
  props: {
    matchInfo: Object
  },
  data: function data() {
    return {
      score: "",
      objInfo: {},
      scoreStyle: {
        'font-size': '18px',
        color: '#FE2754'
      }
    };
  },

  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  mounted: function mounted() {
    this.customizeStyle();
    this.reload();
  },

  methods: {
    customizeStyle: function customizeStyle() {
      if (!this.matchInfo.isEnd) {
        this.scoreStyle.color = '#299AFE';
        this.scoreStyle['font-size'] = '24px';
      }
    },
    viewMatch: function viewMatch() {
      this.$router.push({
        path: 'match_info', query: {
          matchId: this.matchInfo.id,
          homeTeamId: this.matchInfo.homeTeamId,
          visitTeamId: this.matchInfo.vistingTeamId
        }
      });
    },
    reload: function reload() {
      this.objInfo = this.matchInfo;
      if (!this.matchInfo.isEnd) {
        this.score = "vs";
      } else {
        this.score = this.genScore();
      }
    },
    genScore: function genScore() {
      var score = '';
      if (this.objInfo && this.objInfo.result) {
        var matchObj = this.objInfo.result;
        var defaultPkScore = matchObj.homePkScore || matchObj.visitorPkScore ? "(0)" : "";

        score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
        score += "-";
        score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
      } else {
        score = "暂无比分";
      }
      return score;
    }
  },
  watch: {
    matchInfo: function matchInfo(curVal, oldVal) {
      this.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b63732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/league/matchSimple_publicIndex.vue
var matchSimple_publicIndex_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5px 10px"}},[_c('div',{staticStyle:{"display":"inline-block","justify-content":"center","width":"100%"},on:{"click":_vm.viewMatch}},[_c('flexbox',{attrs:{"gutter":0,"justify":"center"}},[_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"right","font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","letter-spacing":"0"}},[_vm._v("\n                    "+_vm._s(this.objInfo.homeTeamName)+"\n                ")])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/5}},[_c('div',{style:([{'text-align': 'center','font-family': 'Arial-Black','letter-spacing': 0},_vm.scoreStyle])},[_vm._v("\n                    "+_vm._s(this.score)+"\n                ")])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":2/5}},[_c('div',{staticStyle:{"text-align":"left","font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","letter-spacing":"0"}},[_vm._v("\n                    "+_vm._s(this.objInfo.vistingTeamName)+"\n                ")])])],1)],1)])}
var matchSimple_publicIndex_staticRenderFns = []
var matchSimple_publicIndex_esExports = { render: matchSimple_publicIndex_render, staticRenderFns: matchSimple_publicIndex_staticRenderFns }
/* harmony default export */ var components_league_matchSimple_publicIndex = (matchSimple_publicIndex_esExports);
// CONCATENATED MODULE: ./src/components/league/matchSimple_publicIndex.vue
var matchSimple_publicIndex_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchSimple_publicIndex___vue_template_functional__ = false
/* styles */
var matchSimple_publicIndex___vue_styles__ = null
/* scopeId */
var matchSimple_publicIndex___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var matchSimple_publicIndex___vue_module_identifier__ = null
var matchSimple_publicIndex_Component = matchSimple_publicIndex_normalizeComponent(
  league_matchSimple_publicIndex,
  components_league_matchSimple_publicIndex,
  matchSimple_publicIndex___vue_template_functional__,
  matchSimple_publicIndex___vue_styles__,
  matchSimple_publicIndex___vue_scopeId__,
  matchSimple_publicIndex___vue_module_identifier__
)

/* harmony default export */ var src_components_league_matchSimple_publicIndex = (matchSimple_publicIndex_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/publicindex/hot_league.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var hot_league = ({
  data: function data() {
    return {
      leagueInfos: [],
      indexContentHeight: ''
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.$vux.loading.show();
      this.hagkHttp(this.hagkApi.getHotLeagues(), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var leagueInfoVo = res[i];
          var matchs = leagueInfoVo.matches;
          if (matchs) {
            for (var j = 0; j < matchs.length; j++) {
              var match = matchs[j];
              if (match.isEnd) {
                match.dispalyScore = _this.dispalyScore(match.result);
              } else {
                match.score = "vs";
              }
            }
          }
          _this.leagueInfos.push(leagueInfoVo);
        }
      }, function (error) {
        console.log(error);
      });
      this.$vux.loading.hide();
    },

    dispalyScore: function dispalyScore(matchResultVo) {
      var goalFor = matchResultVo.goalFor;
      var goalAgainst = matchResultVo.goalAgainst;
      var homeExScore = matchResultVo.homeExScore;
      var visitorExScore = matchResultVo.visitorExScore;
      var homePkScore = matchResultVo.homePkScore;
      var visitorPkScore = matchResultVo.visitorPkScore;
      var homeds = "";
      var visitords = "";
      var homeScore = goalFor + homeExScore;
      homeds = homeScore + "";
      var visitorScore = goalAgainst + visitorExScore;
      visitords = visitorScore + "";
      if (homePkScore > 0 || visitorPkScore > 0) {
        homeds += "(" + homePkScore + ")";
        visitords += "(" + visitorPkScore + ")";
      }
      return homeds + "-" + visitords;
    },
    toMatchDetail: function toMatchDetail(matchId, homeTeamId, visitTeamId) {
      this.$router.push({
        path: '/match_info',
        query: {
          matchId: matchId,
          homeTeamId: homeTeamId,
          visitTeamId: visitTeamId
        }
      });
    }
  },
  components: {
    matchSimplePublicIndex: src_components_league_matchSimple_publicIndex
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/publicindex/hot_league.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var publicindex_hot_league = ({
  data: function data() {
    return {
      leagueInfos: [],
      indexContentHeight: ''
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.$vux.loading.show();
      this.hagkHttp(this.hagkApi.getHotLeagues(), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var leagueInfoVo = res[i];
          var matchs = leagueInfoVo.matches;
          if (matchs) {
            for (var j = 0; j < matchs.length; j++) {
              var match = matchs[j];
              if (match.isEnd) {
                match.dispalyScore = _this.dispalyScore(match.result);
              } else {
                match.score = "vs";
              }
            }
          }
          _this.leagueInfos.push(leagueInfoVo);
        }
      }, function (error) {
        console.log(error);
      });
      this.$vux.loading.hide();
    },

    dispalyScore: function dispalyScore(matchResultVo) {
      var goalFor = matchResultVo.goalFor;
      var goalAgainst = matchResultVo.goalAgainst;
      var homeExScore = matchResultVo.homeExScore;
      var visitorExScore = matchResultVo.visitorExScore;
      var homePkScore = matchResultVo.homePkScore;
      var visitorPkScore = matchResultVo.visitorPkScore;
      var homeds = "";
      var visitords = "";
      var homeScore = goalFor + homeExScore;
      homeds = homeScore + "";
      var visitorScore = goalAgainst + visitorExScore;
      visitords = visitorScore + "";
      if (homePkScore > 0 || visitorPkScore > 0) {
        homeds += "(" + homePkScore + ")";
        visitords += "(" + visitorPkScore + ")";
      }
      return homeds + "-" + visitords;
    },
    toMatchDetail: function toMatchDetail(matchId, homeTeamId, visitTeamId) {
      this.$router.push({
        path: '/match_info',
        query: {
          matchId: matchId,
          homeTeamId: homeTeamId,
          visitTeamId: visitTeamId
        }
      });
    }
  },
  components: {
    matchSimplePublicIndex: src_components_league_matchSimple_publicIndex
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07d07e30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicindex/hot_league.vue
var hot_league_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baseContainer",attrs:{"id":"baseContainer"}},[_c('div',{staticClass:"hot_league_container"},[_vm._l((_vm.leagueInfos),function(league){return [_c('div',{staticClass:"league_name_row row"},[_c('div',{staticClass:"col-xs-12 league_name"},[_c('img',{staticStyle:{"margin-top":"-5px"},attrs:{"src":__webpack_require__("nUYS")}}),_c('span',{staticClass:"league_name_span"},[_vm._v(_vm._s(league.name))])])]),_vm._v(" "),_vm._l((league.matches),function(match){return [_c('div',{staticStyle:{"text-align":"center","margin-bottom":"15px"}},[_c('matchSimplePublicIndex',{attrs:{"matchInfo":match}})],1)]}),_vm._v(" "),_c('div',{staticClass:"more_league_div"},[_c('router-link',{attrs:{"to":{path:'league_list',query:{orgCode:league.orgCode,orgName:league.orgName}}}},[_c('div',{staticClass:"league-more"},[_vm._v("更多赛况")])])],1)]})],2)])}
var hot_league_staticRenderFns = []
var hot_league_esExports = { render: hot_league_render, staticRenderFns: hot_league_staticRenderFns }
/* harmony default export */ var components_publicindex_hot_league = (hot_league_esExports);
// CONCATENATED MODULE: ./src/components/publicindex/hot_league.vue
function hot_league_injectStyle (ssrContext) {
  __webpack_require__("aMlG")
}
var hot_league_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var hot_league___vue_template_functional__ = false
/* styles */
var hot_league___vue_styles__ = hot_league_injectStyle
/* scopeId */
var hot_league___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var hot_league___vue_module_identifier__ = null
var hot_league_Component = hot_league_normalizeComponent(
  publicindex_hot_league,
  components_publicindex_hot_league,
  hot_league___vue_template_functional__,
  hot_league___vue_styles__,
  hot_league___vue_scopeId__,
  hot_league___vue_module_identifier__
)

/* harmony default export */ var src_components_publicindex_hot_league = (hot_league_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ItemHead.vue
//
//
//
//
//
//
//

/* harmony default export */ var ItemHead = ({
  props: ['title'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {},
  components: {}

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ItemHead.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_ItemHead = ({
  props: ['title'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {},
  components: {}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77fae11e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemHead.vue
var ItemHead_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title_itemhead",staticStyle:{"height":"45px"}},[_c('img',{staticClass:"red_tag",attrs:{"src":__webpack_require__("JaZq")}}),_vm._v(" "),_c('div',{staticClass:"title_itemhead_div",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.title))])])}
var ItemHead_staticRenderFns = []
var ItemHead_esExports = { render: ItemHead_render, staticRenderFns: ItemHead_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_ItemHead = (ItemHead_esExports);
// CONCATENATED MODULE: ./src/components/ItemHead.vue
function ItemHead_injectStyle (ssrContext) {
  __webpack_require__("thfS")
}
var ItemHead_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ItemHead___vue_template_functional__ = false
/* styles */
var ItemHead___vue_styles__ = ItemHead_injectStyle
/* scopeId */
var ItemHead___vue_scopeId__ = "data-v-77fae11e"
/* moduleIdentifier (server only) */
var ItemHead___vue_module_identifier__ = null
var ItemHead_Component = ItemHead_normalizeComponent(
  components_ItemHead,
  selectortype_template_index_0_src_components_ItemHead,
  ItemHead___vue_template_functional__,
  ItemHead___vue_styles__,
  ItemHead___vue_scopeId__,
  ItemHead___vue_module_identifier__
)

/* harmony default export */ var src_components_ItemHead = (ItemHead_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/publicindex/hot_zone.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var hot_zone = ({});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/publicindex/hot_zone.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var publicindex_hot_zone = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd1919ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicindex/hot_zone.vue
var hot_zone_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var hot_zone_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baseContainer container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"area__hotzone_div"},[_vm._v("北京")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"area__hotzone_div"},[_vm._v("北京")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 s",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"area__hotzone_div"},[_vm._v("北京")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 s",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"area__hotzone_div"},[_vm._v("北京")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 s",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"area__hotzone_div"},[_vm._v("北京")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 s",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"area__hotzone_div"},[_vm._v("北京")])])])])}]
var hot_zone_esExports = { render: hot_zone_render, staticRenderFns: hot_zone_staticRenderFns }
/* harmony default export */ var components_publicindex_hot_zone = (hot_zone_esExports);
// CONCATENATED MODULE: ./src/components/publicindex/hot_zone.vue
function hot_zone_injectStyle (ssrContext) {
  __webpack_require__("9uKV")
}
var hot_zone_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var hot_zone___vue_template_functional__ = false
/* styles */
var hot_zone___vue_styles__ = hot_zone_injectStyle
/* scopeId */
var hot_zone___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var hot_zone___vue_module_identifier__ = null
var hot_zone_Component = hot_zone_normalizeComponent(
  publicindex_hot_zone,
  components_publicindex_hot_zone,
  hot_zone___vue_template_functional__,
  hot_zone___vue_styles__,
  hot_zone___vue_scopeId__,
  hot_zone___vue_module_identifier__
)

/* harmony default export */ var src_components_publicindex_hot_zone = (hot_zone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/public_index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var public_index = ({
  data: function data() {
    return {
      indexContentHeight: '',
      regionName: '',
      regionCode: '',
      controlHotArea: false
    };
  },
  mounted: function mounted() {
    // if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '首页无联赛'])}
    this.setOverFlow();
    this.getQueryParams();
    this.initWxShareConfig();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      var fullPath = window.location.href;
      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      utils_wxShareConfig({
        title: '校园足球赛事系统',
        desc: '来自未来足球校园足球大数据智能赛事系统',
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {}, function () {});
    },
    getQueryParams: function getQueryParams() {
      this.regionName = this.$route.query.regionName;
      this.regionCode = this.$route.query.regionCode;
    },
    getData: function getData(regionCode, regionName) {
      var _this = this;

      this.hagkHttp(this.hagkApi.getHotAreaLeagueCount(regionCode), {}).then(function (res) {
        if (res.status) {
          if (res.result > 0) {
            _this.$router.replace({ path: 'index_region', query: { regionCode: regionCode, regionName: regionName } });
          } else {
            _this.regionName = regionName;
            _this.controlHotArea = !_this.controlHotArea;
          }
        } else {
          console.log('获取地区联赛数量失败');
        }
      }, function (err) {
        console.log(err);
      });
      this.hideLoading();
    },

    setOverFlow: function setOverFlow() {
      var height = document.body.clientHeight;
      this.indexContentHeight = height + 'px';
    },
    changeRegion: function changeRegion(regionCode, regionName) {
      this.$vux.loading.show();
      this.getData(regionCode, regionName);
    },
    hideLoading: function hideLoading() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$vux.loading.hide();
      }, 500);
    }
  },
  components: { headPart: src_components_publicindex_head, hotLeague: src_components_publicindex_hot_league, itemHead: src_components_ItemHead, hotZone: src_components_publicindex_hot_zone, hotArea: src_views_hotArea, advertisement: src_views_advertisement }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/public_index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var views_public_index = ({
  data: function data() {
    return {
      indexContentHeight: '',
      regionName: '',
      regionCode: '',
      controlHotArea: false
    };
  },
  mounted: function mounted() {
    // if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '首页无联赛'])}
    this.setOverFlow();
    this.getQueryParams();
    this.initWxShareConfig();
  },

  methods: {
    initWxShareConfig: function initWxShareConfig() {
      var fullPath = window.location.href;
      var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
      utils_wxShareConfig({
        title: '校园足球赛事系统',
        desc: '来自未来足球校园足球大数据智能赛事系统',
        link: fullPath,
        imgUrl: shareImg,
        type: 'link',
        dataUrl: ''
      }, function () {}, function () {});
    },
    getQueryParams: function getQueryParams() {
      this.regionName = this.$route.query.regionName;
      this.regionCode = this.$route.query.regionCode;
    },
    getData: function getData(regionCode, regionName) {
      var _this = this;

      this.hagkHttp(this.hagkApi.getHotAreaLeagueCount(regionCode), {}).then(function (res) {
        if (res.status) {
          if (res.result > 0) {
            _this.$router.replace({ path: 'index_region', query: { regionCode: regionCode, regionName: regionName } });
          } else {
            _this.regionName = regionName;
            _this.controlHotArea = !_this.controlHotArea;
          }
        } else {
          console.log('获取地区联赛数量失败');
        }
      }, function (err) {
        console.log(err);
      });
      this.hideLoading();
    },

    setOverFlow: function setOverFlow() {
      var height = document.body.clientHeight;
      this.indexContentHeight = height + 'px';
    },
    changeRegion: function changeRegion(regionCode, regionName) {
      this.$vux.loading.show();
      this.getData(regionCode, regionName);
    },
    hideLoading: function hideLoading() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$vux.loading.hide();
      }, 500);
    }
  },
  components: { headPart: src_components_publicindex_head, hotLeague: src_components_publicindex_hot_league, itemHead: src_components_ItemHead, hotZone: src_components_publicindex_hot_zone, hotArea: src_views_hotArea, advertisement: src_views_advertisement }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4624e9b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/public_index.vue
var public_index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"public_index_base",style:({height:_vm.indexContentHeight}),attrs:{"data-title":"首页"}},[_c('headPart',{attrs:{"regionName":_vm.regionName,"controlHotArea":_vm.controlHotArea},on:{"changeRegion":_vm.changeRegion}}),_vm._v(" "),_c('div',{staticClass:"blank_div",staticStyle:{"height":"10px"}}),_vm._v(" "),_c('div',{attrs:{"id":"bodyContent"}},[_c('itemHead',{attrs:{"title":"热门赛区"}}),_vm._v(" "),_c('hotArea',{attrs:{"zIndexP":0,"titleShow":false,"showCount":"8"},on:{"changeRegion":_vm.changeRegion}}),_vm._v(" "),_c('div',{staticClass:"blank_div",staticStyle:{"height":"10px"}}),_vm._v(" "),_c('itemHead',{attrs:{"title":"热门赛事"}}),_vm._v(" "),_c('hotLeague')],1)],1)}
var public_index_staticRenderFns = []
var public_index_esExports = { render: public_index_render, staticRenderFns: public_index_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_public_index = (public_index_esExports);
// CONCATENATED MODULE: ./src/views/public_index.vue
function public_index_injectStyle (ssrContext) {
  __webpack_require__("LQgg")
}
var public_index_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var public_index___vue_template_functional__ = false
/* styles */
var public_index___vue_styles__ = public_index_injectStyle
/* scopeId */
var public_index___vue_scopeId__ = "data-v-4624e9b1"
/* moduleIdentifier (server only) */
var public_index___vue_module_identifier__ = null
var public_index_Component = public_index_normalizeComponent(
  views_public_index,
  selectortype_template_index_0_src_views_public_index,
  public_index___vue_template_functional__,
  public_index___vue_styles__,
  public_index___vue_scopeId__,
  public_index___vue_module_identifier__
)

/* harmony default export */ var src_views_public_index = (public_index_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/match/timeLine.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var timeLine = ({
  props: {
    eventHub: Object
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
    this.homeTeamId = this.$route.query.homeTeamId;
    this.visitTeamId = this.$route.query.visitTeamId;
  },
  data: function data() {
    return {
      content: '时间轴',
      matchId: '',
      homeTeamId: '',
      visitTeamId: '',
      timeLineContent: [],
      homeTeamHeader: 'this.src="' + __webpack_require__("lgsr") + '"',
      visitTeamHeader: 'this.src="' + __webpack_require__("/tlY") + '"',
      defaultHeaderImg: __webpack_require__("xiEX"),
      goalSvg: __webpack_require__("FlER"),
      assistSvg: __webpack_require__("UKSC"),
      changeinSvg: __webpack_require__("rZTe"),
      changeoutSvg: __webpack_require__("MVr3"),
      owngoalSvg: __webpack_require__("hWR6"),
      pkgoalSvg: __webpack_require__("Mjwm")
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.hagkHttp(this.hagkApi.getRosterMatchInfo(this.matchId, this.homeTeamId, this.visitTeamId), {}).then(function (res) {
      for (var i = 0; i < res.length; i++) {
        res[i].time = Math.round(res[i].time / 60);
        res[i].inAssetId = _this.getimgUrl(res[i].inAssetId, res[i].registeredTeamId);
        if (res[i].inAssetId.indexOf('../assets/img/homeTeamHeader.svg') != -1 || res[i].inAssetId.indexOf('../assets/img/visitTeamHeader.svg') != -1) {
          res[i].inLoadImgFail = true;
        } else {
          res[i].inLoadImgFail = false;
        }
        res[i].outAssetId = _this.getimgUrl(res[i].outAssetId, res[i].registeredTeamId);
        if (res[i].outAssetId.indexOf('../assets/img/homeTeamHeader.svg') != -1 || res[i].inAssetId.indexOf('../assets/img/visitTeamHeader.svg') != -1) {
          res[i].outLoadImgFail = true;
        } else {
          res[i].outLoadImgFail = false;
        }
        if (res[i].homeName && res[i].homeName.length > 4) res[i].homeName = res[i].homeName.substring(0, 3) + "…";
        if (res[i].visitName && res[i].visitName.length > 4) res[i].visitName = res[i].visitName.substring(0, 3) + "…";
        if (res[i].category == 0) {
          res[i].category_url = _this.goalSvg;
          if (res[i].visitNumber != null) {
            res[i].assist_category_url = _this.assistSvg;
          }
        } else if (res[i].category == 1) {
          res[i].category_url = _this.assistSvg;
        } else if (res[i].category == 2) {
          if (res[i].type == 'red') {
            res[i].category_url = __webpack_require__("gXi2");
          } else if (res[i].type == 'yellow') {
            res[i].category_url = __webpack_require__("ck5t");
          }
        } else if (res[i].category == 3) {
          res[i].in_category_url = _this.changeinSvg;
          res[i].out_category_url = _this.changeoutSvg;
        } else if (res[i].category == 4) {
          // res[i].category_url = this.owngoalSvg;
          res[i].category_url = _this.pkgoalSvg;
        } else if (res[i].category == 5) {
          res[i].category_url = _this.pkgoalSvg;
        }
      }
      _this.timeLineContent = res;
      _this.eventHub.$emit("resetView");
    }, function (error) {
      console.log(error);
      window.alert('比赛信息获取失败！');
    });
  },

  methods: {
    getimgUrl: function getimgUrl(assetId, teamId) {
      if (assetId && assetId != null) {
        return this.hagkApi.getImgAsset(assetId + '.jpg').url;
      } else {
        if (teamId == this.homeTeamId) return '../../assets/img/homeTeamHeader.svg';else if (teamId == this.visitTeamId) return '../../assets/img/visitTeamHeader.svg';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/match/timeLine.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var match_timeLine = ({
  props: {
    eventHub: Object
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
    this.homeTeamId = this.$route.query.homeTeamId;
    this.visitTeamId = this.$route.query.visitTeamId;
  },
  data: function data() {
    return {
      content: '时间轴',
      matchId: '',
      homeTeamId: '',
      visitTeamId: '',
      timeLineContent: [],
      homeTeamHeader: 'this.src="' + __webpack_require__("lgsr") + '"',
      visitTeamHeader: 'this.src="' + __webpack_require__("/tlY") + '"',
      defaultHeaderImg: __webpack_require__("xiEX"),
      goalSvg: __webpack_require__("FlER"),
      assistSvg: __webpack_require__("UKSC"),
      changeinSvg: __webpack_require__("rZTe"),
      changeoutSvg: __webpack_require__("MVr3"),
      owngoalSvg: __webpack_require__("hWR6"),
      pkgoalSvg: __webpack_require__("Mjwm")
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.hagkHttp(this.hagkApi.getRosterMatchInfo(this.matchId, this.homeTeamId, this.visitTeamId), {}).then(function (res) {
      for (var i = 0; i < res.length; i++) {
        res[i].time = Math.round(res[i].time / 60);
        res[i].inAssetId = _this.getimgUrl(res[i].inAssetId, res[i].registeredTeamId);
        if (res[i].inAssetId.indexOf('../assets/img/homeTeamHeader.svg') != -1 || res[i].inAssetId.indexOf('../assets/img/visitTeamHeader.svg') != -1) {
          res[i].inLoadImgFail = true;
        } else {
          res[i].inLoadImgFail = false;
        }
        res[i].outAssetId = _this.getimgUrl(res[i].outAssetId, res[i].registeredTeamId);
        if (res[i].outAssetId.indexOf('../assets/img/homeTeamHeader.svg') != -1 || res[i].inAssetId.indexOf('../assets/img/visitTeamHeader.svg') != -1) {
          res[i].outLoadImgFail = true;
        } else {
          res[i].outLoadImgFail = false;
        }
        if (res[i].homeName && res[i].homeName.length > 4) res[i].homeName = res[i].homeName.substring(0, 3) + "…";
        if (res[i].visitName && res[i].visitName.length > 4) res[i].visitName = res[i].visitName.substring(0, 3) + "…";
        if (res[i].category == 0) {
          res[i].category_url = _this.goalSvg;
          if (res[i].visitNumber != null) {
            res[i].assist_category_url = _this.assistSvg;
          }
        } else if (res[i].category == 1) {
          res[i].category_url = _this.assistSvg;
        } else if (res[i].category == 2) {
          if (res[i].type == 'red') {
            res[i].category_url = __webpack_require__("gXi2");
          } else if (res[i].type == 'yellow') {
            res[i].category_url = __webpack_require__("ck5t");
          }
        } else if (res[i].category == 3) {
          res[i].in_category_url = _this.changeinSvg;
          res[i].out_category_url = _this.changeoutSvg;
        } else if (res[i].category == 4) {
          // res[i].category_url = this.owngoalSvg;
          res[i].category_url = _this.pkgoalSvg;
        } else if (res[i].category == 5) {
          res[i].category_url = _this.pkgoalSvg;
        }
      }
      _this.timeLineContent = res;
      _this.eventHub.$emit("resetView");
    }, function (error) {
      console.log(error);
      window.alert('比赛信息获取失败！');
    });
  },

  methods: {
    getimgUrl: function getimgUrl(assetId, teamId) {
      if (assetId && assetId != null) {
        return this.hagkApi.getImgAsset(assetId + '.jpg').url;
      } else {
        if (teamId == this.homeTeamId) return '../../assets/img/homeTeamHeader.svg';else if (teamId == this.visitTeamId) return '../../assets/img/visitTeamHeader.svg';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d9d790","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/match/timeLine.vue
var timeLine_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#FFFFFF"}},[_c('section',{staticClass:"cd-container",attrs:{"id":"cd-timeline"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.timeLineContent),function(timeLine){return _c('div',{staticClass:"cd-timeline-block"},[_c('div',{staticClass:"cd-timeline-img cd-picture col-xs-2",staticStyle:{"width":"30px","margin-left":"-9px"}},[_c('p',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"12px","color":"#999999","width":"30px","height":"30px","margin-left":"-15px","margin-top":"6px"}},[_vm._v(_vm._s(timeLine.time)+"'")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((timeLine.registeredTeamId == _vm.homeTeamId && timeLine.category != 4) || (timeLine.registeredTeamId == _vm.visitTeamId && timeLine.category == 4)),expression:"(timeLine.registeredTeamId == homeTeamId && timeLine.category != 4) || (timeLine.registeredTeamId == visitTeamId && timeLine.category == 4)"}],staticClass:"cd-timeline-content-left col-xs-5",staticStyle:{"margin-left":"-15px","padding-left":"8px","padding-right":"10px"}},[(timeLine.category != 3 && timeLine.category != 0 && timeLine.category != 4 && timeLine.category != 5)?_c('div',{staticStyle:{"float":"right"}},[(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","border-radius":"16px","border":"1px solid red"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","border-radius":"16px"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.homeNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.homeName))]),_vm._v(" "),_c('img',{staticStyle:{"width":"16px"},attrs:{"src":timeLine.category_url}})]):_vm._e(),_vm._v(" "),(timeLine.category == 3)?_c('div',[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('div',{staticStyle:{"min-height":"30px","padding-bottom":"0px","margin-left":"0px","margin-right":"0px","text-align":"right"}},[(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid red"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.homeNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.homeName))]),_vm._v(" "),_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.in_category_url}})]),_vm._v(" "),_c('div',{staticStyle:{"min-height":"30px","padding-bottom":"0px","margin-left":"0px","margin-right":"0px","text-align":"right"}},[(!timeLine.outLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid red"},attrs:{"src":timeLine.outAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.outLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.outAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.visitNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.visitName))]),_vm._v(" "),_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.out_category_url}})])])]):_vm._e(),_vm._v(" "),(timeLine.category == 0 || timeLine.category == 4 || timeLine.category == 5)?_c('div',[_c('div',{staticStyle:{"float":"right"}},[(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid red"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.homeNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.homeName))]),_vm._v(" "),_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.category_url}})]),_vm._v(" "),(timeLine.visitNumber != null)?_c('div',{staticStyle:{"float":"right"}},[(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid red"},attrs:{"src":timeLine.outAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.outAssetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.visitNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.visitName))]),_vm._v(" "),_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.assist_category_url}})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((timeLine.registeredTeamId == _vm.visitTeamId && timeLine.category != 4) || (timeLine.registeredTeamId == _vm.homeTeamId && timeLine.category == 4)),expression:"(timeLine.registeredTeamId == visitTeamId && timeLine.category != 4) || (timeLine.registeredTeamId == homeTeamId && timeLine.category == 4)"}],staticClass:"cd-timeline-content col-xs-5",staticStyle:{"float":"right","margin-right":"-5px","padding-left":"10px","padding-right":"10px"}},[(timeLine.category != 3 && timeLine.category != 0 && timeLine.category != 4 && timeLine.category != 5)?_c('div',{staticStyle:{"float":"left"}},[_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.category_url}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.homeNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.homeName))]),_vm._v(" "),(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid #299afe"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e()]):_vm._e(),_vm._v(" "),(timeLine.category == 3)?_c('div',[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('div',{staticStyle:{"min-height":"30px","padding-bottom":"0px","margin-left":"0px","margin-right":"0px","text-align":"left"}},[_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.in_category_url}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.homeNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.homeName))]),_vm._v(" "),(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid #299afe"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"min-height":"30px","padding-bottom":"0px","margin-left":"0px","margin-right":"0px","text-align":"left"}},[_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.out_category_url}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.visitNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.visitName))]),_vm._v(" "),(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid #299afe"},attrs:{"src":timeLine.outAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.outAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e()])])]):_vm._e(),_vm._v(" "),(timeLine.category == 0 || timeLine.category == 4 || timeLine.category == 5)?_c('div',[_c('div',{staticStyle:{"float":"left"}},[_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.category_url}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.homeNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.homeName))]),_vm._v(" "),(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid #299afe"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.inAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e()]),_vm._v(" "),(timeLine.visitNumber != null)?_c('div',{staticStyle:{"float":"left"}},[_c('img',{staticStyle:{"width":"16px","height":"16px"},attrs:{"src":timeLine.assist_category_url}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(timeLine.visitNumber)+"号")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(timeLine.visitName))]),_vm._v(" "),(!timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px","border":"1px solid #299afe"},attrs:{"src":timeLine.outAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),(timeLine.inLoadImgFail)?_c('img',{staticStyle:{"width":"16px","height":"16px","border-radius":"16px"},attrs:{"src":timeLine.outAssetId,"onerror":_vm.visitTeamHeader}}):_vm._e()]):_vm._e()]):_vm._e()])])}),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px","padding-right":"15px","height":"40px"}},[_c('div',{staticClass:"row",staticStyle:{"height":"30px","padding-bottom":"10px","padding-top":"10px","border-top":"1px solid #F3F3F3"}},[_c('div',{staticClass:"col-xs-4",staticStyle:{"height":"20px","line-height":"20px"}},[_c('img',{staticStyle:{"padding-bottom":"3px"},attrs:{"src":_vm.goalSvg}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","margin-left":"10px"}},[_vm._v("进球")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4",staticStyle:{"height":"20px","line-height":"20px"}},[_c('img',{staticStyle:{"padding-bottom":"3px"},attrs:{"src":_vm.pkgoalSvg}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","margin-left":"10px"}},[_vm._v("乌龙球")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4",staticStyle:{"height":"20px","line-height":"20px"}},[_c('img',{staticStyle:{"padding-bottom":"3px"},attrs:{"src":_vm.assistSvg}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#333333","margin-left":"10px"}},[_vm._v("助攻")])])])])])}
var timeLine_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-timeline-block row"},[_c('div',{staticClass:"cd-timeline-img cd-picture col-xs-2",staticStyle:{"left":"50%","width":"80px","height":"30px","margin-left":"-40px"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"12px","color":"#999999","left":"10%"}},[_vm._v("比赛开始")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-timeline-block row",staticStyle:{"margin-bottom":"-30px"}},[_c('div',{staticClass:"cd-timeline-img cd-picture col-xs-2",staticStyle:{"left":"50%","width":"80px","height":"30px","margin-left":"-40px"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"12px","color":"#999999","left":"10%"}},[_vm._v("比赛结束")])])])}]
var timeLine_esExports = { render: timeLine_render, staticRenderFns: timeLine_staticRenderFns }
/* harmony default export */ var components_match_timeLine = (timeLine_esExports);
// CONCATENATED MODULE: ./src/components/match/timeLine.vue
function timeLine_injectStyle (ssrContext) {
  __webpack_require__("Y43i")
}
var timeLine_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var timeLine___vue_template_functional__ = false
/* styles */
var timeLine___vue_styles__ = timeLine_injectStyle
/* scopeId */
var timeLine___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var timeLine___vue_module_identifier__ = null
var timeLine_Component = timeLine_normalizeComponent(
  match_timeLine,
  components_match_timeLine,
  timeLine___vue_template_functional__,
  timeLine___vue_styles__,
  timeLine___vue_scopeId__,
  timeLine___vue_module_identifier__
)

/* harmony default export */ var src_components_match_timeLine = (timeLine_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchScores.vue




/* harmony default export */ var matchScores = ({
  props: {
    eventHub: Object
  },
  components: {
    timeLine: src_components_match_timeLine,
    Divider: vux_src_components_divider
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
    this.homeTeamId = this.$route.query.homeTeamId;
    this.visitTeamId = this.$route.query.visitTeamId;
  },
  mounted: function mounted() {

    this.initTab();
  },
  data: function data() {
    return {
      content: '赛况',
      indexContentHeight: 0,
      homelineUpList: [],
      visitlineUpList: [],
      homesubstituteList: [],
      visitsubstituteList: [],
      homeTeamId: '',
      visitTeamId: '',
      homeTeamHeader: 'this.src="' + __webpack_require__("lgsr") + '"',

      visitTeamHeader: 'this.src="' + __webpack_require__("/tlY") + '"',
      totalReq: 0
    };
  },

  methods: {
    onerror: function onerror() {
      window.alert('img error');
    },
    initTab: function initTab() {
      var _this = this;

      this.$nextTick(function () {
        _this.indexContentHeight = document.body.clientHeight - 230;
      }), this.hagkHttp(this.hagkApi.getLineUpByMatchIdAndTeamId(this.matchId, this.homeTeamId), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].assetId = _this.getimgUrl(res[i].assetId, 'homeTeam');
          if (res[i].assetId.indexOf('../assets/img/homeTeamHeader.svg') != -1) {
            res[i].loadImgFail = true;
          } else {
            res[i].loadImgFail = false;
          }
          if (res[i].name && res[i].name.length > 4) res[i].name = res[i].name.substring(0, 4) + "……";
        }
        _this.homelineUpList = res;
        console.log(_this.homelineUpList);
        _this.changeScoreHeight();
        _this.totalReq++;
      }, function (error) {
        _this.totalReq++;
        console.log(error);
        window.alert('主队首发球员信息获取失败！');
      });

      this.hagkHttp(this.hagkApi.getLineUpByMatchIdAndTeamId(this.matchId, this.visitTeamId), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].assetId = _this.getimgUrl(res[i].assetId, 'visitTeam');
          if (res[i].assetId.indexOf('../assets/img/visitTeamHeader.svg') != -1) {
            res[i].loadImgFail = true;
          } else {
            res[i].loadImgFail = false;
          }
          if (res[i].name && res[i].name.length > 4) res[i].name = res[i].name.substring(0, 4) + "……";
        }
        _this.visitlineUpList = res;
        _this.changeScoreHeight();
        _this.totalReq++;
      }, function (error) {
        _this.totalReq++;
        console.log(error);
        window.alert('客队首发球员信息获取失败！');
      });

      this.hagkHttp(this.hagkApi.getSubstitutionByMatchIdAndTeamId(this.matchId, this.homeTeamId), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].assetId = _this.getimgUrl(res[i].assetId, 'homeTeam');
          if (res[i].assetId.indexOf('../assets/img/homeTeamHeader.svg') != -1) {
            res[i].loadImgFail = true;
          } else {
            res[i].loadImgFail = false;
          }
          if (res[i].name && res[i].name.length > 4) res[i].name = res[i].name.substring(0, 4) + "……";
        }
        _this.homesubstituteList = res;
        _this.changeScoreHeight();
        _this.totalReq++;
      }, function (error) {
        _this.totalReq++;
        console.log(error);
        window.alert('主队替换球员信息获取失败！');
      });

      this.hagkHttp(this.hagkApi.getSubstitutionByMatchIdAndTeamId(this.matchId, this.visitTeamId), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].assetId = _this.getimgUrl(res[i].assetId, 'visitTeam');
          if (res[i].assetId.indexOf('../assets/img/visitTeamHeader.svg') != -1) {
            res[i].loadImgFail = true;
          } else {
            res[i].loadImgFail = false;
          }
          console.log(res[i].loadImgFail);
          if (res[i].name && res[i].name.length > 4) res[i].name = res[i].name.substring(0, 4) + "……";
        }
        _this.visitsubstituteList = res;
        _this.changeScoreHeight();
        _this.totalReq++;
      }, function (error) {
        _this.totalReq++;
        console.log(error);
        window.alert('客队替换球员信息获取失败！');
      });
    },
    getimgUrl: function getimgUrl(assetId, teamType) {
      if (assetId && assetId != null) {
        return this.hagkApi.getImgAsset(assetId + '.jpg').url;
      } else {
        if (teamType == 'homeTeam') {
          return "../assets/img/homeTeamHeader.svg";
        } else if (teamType == 'visitTeam') {
          return "../assets/img/visitTeamHeader.svg";
        }
      }
    },
    changeScoreHeight: function changeScoreHeight() {

      this.eventHub.$emit("resetView");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchScores.vue




/* harmony default export */ var views_matchScores = ({
  props: {
    eventHub: Object
  },
  components: {
    timeLine: src_components_match_timeLine,
    Divider: vux_src_components_divider
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
    this.homeTeamId = this.$route.query.homeTeamId;
    this.visitTeamId = this.$route.query.visitTeamId;
  },
  mounted: function mounted() {

    this.initTab();
  },
  data: function data() {
    return {
      content: '赛况',
      indexContentHeight: 0,
      homelineUpList: [],
      visitlineUpList: [],
      homesubstituteList: [],
      visitsubstituteList: [],
      homeTeamId: '',
      visitTeamId: '',
      homeTeamHeader: 'this.src="' + __webpack_require__("lgsr") + '"',

      visitTeamHeader: 'this.src="' + __webpack_require__("/tlY") + '"',
      totalReq: 0
    };
  },

  methods: {
    onerror: function onerror() {
      window.alert('img error');
    },
    initTab: function initTab() {
      var _this = this;

      this.$nextTick(function () {
        _this.indexContentHeight = document.body.clientHeight - 230;
      }), this.hagkHttp(this.hagkApi.getLineUpByMatchIdAndTeamId(this.matchId, this.homeTeamId), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].assetId = _this.getimgUrl(res[i].assetId, 'homeTeam');
          if (res[i].assetId.indexOf('../assets/img/homeTeamHeader.svg') != -1) {
            res[i].loadImgFail = true;
          } else {
            res[i].loadImgFail = false;
          }
          if (res[i].name && res[i].name.length > 4) res[i].name = res[i].name.substring(0, 4) + "……";
        }
        _this.homelineUpList = res;
        console.log(_this.homelineUpList);
        _this.changeScoreHeight();
        _this.totalReq++;
      }, function (error) {
        _this.totalReq++;
        console.log(error);
        window.alert('主队首发球员信息获取失败！');
      });

      this.hagkHttp(this.hagkApi.getLineUpByMatchIdAndTeamId(this.matchId, this.visitTeamId), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].assetId = _this.getimgUrl(res[i].assetId, 'visitTeam');
          if (res[i].assetId.indexOf('../assets/img/visitTeamHeader.svg') != -1) {
            res[i].loadImgFail = true;
          } else {
            res[i].loadImgFail = false;
          }
          if (res[i].name && res[i].name.length > 4) res[i].name = res[i].name.substring(0, 4) + "……";
        }
        _this.visitlineUpList = res;
        _this.changeScoreHeight();
        _this.totalReq++;
      }, function (error) {
        _this.totalReq++;
        console.log(error);
        window.alert('客队首发球员信息获取失败！');
      });

      this.hagkHttp(this.hagkApi.getSubstitutionByMatchIdAndTeamId(this.matchId, this.homeTeamId), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].assetId = _this.getimgUrl(res[i].assetId, 'homeTeam');
          if (res[i].assetId.indexOf('../assets/img/homeTeamHeader.svg') != -1) {
            res[i].loadImgFail = true;
          } else {
            res[i].loadImgFail = false;
          }
          if (res[i].name && res[i].name.length > 4) res[i].name = res[i].name.substring(0, 4) + "……";
        }
        _this.homesubstituteList = res;
        _this.changeScoreHeight();
        _this.totalReq++;
      }, function (error) {
        _this.totalReq++;
        console.log(error);
        window.alert('主队替换球员信息获取失败！');
      });

      this.hagkHttp(this.hagkApi.getSubstitutionByMatchIdAndTeamId(this.matchId, this.visitTeamId), {}).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].assetId = _this.getimgUrl(res[i].assetId, 'visitTeam');
          if (res[i].assetId.indexOf('../assets/img/visitTeamHeader.svg') != -1) {
            res[i].loadImgFail = true;
          } else {
            res[i].loadImgFail = false;
          }
          console.log(res[i].loadImgFail);
          if (res[i].name && res[i].name.length > 4) res[i].name = res[i].name.substring(0, 4) + "……";
        }
        _this.visitsubstituteList = res;
        _this.changeScoreHeight();
        _this.totalReq++;
      }, function (error) {
        _this.totalReq++;
        console.log(error);
        window.alert('客队替换球员信息获取失败！');
      });
    },
    getimgUrl: function getimgUrl(assetId, teamType) {
      if (assetId && assetId != null) {
        return this.hagkApi.getImgAsset(assetId + '.jpg').url;
      } else {
        if (teamType == 'homeTeam') {
          return "../assets/img/homeTeamHeader.svg";
        } else if (teamType == 'visitTeam') {
          return "../assets/img/visitTeamHeader.svg";
        }
      }
    },
    changeScoreHeight: function changeScoreHeight() {

      this.eventHub.$emit("resetView");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcf549ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/matchScores.vue
var matchScores_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"firstTabItem"}},[_c('div',{attrs:{"id":"inner_firstTabItem"}},[_c('div',[_c('timeLine',{attrs:{"eventHub":_vm.eventHub}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-xs-6",staticStyle:{"margin-bottom":"10px","padding-left":"0px","padding-right":"0px"}},_vm._l((_vm.homelineUpList),function(lineUp){return _c('div',{staticClass:"col-xs-12",staticStyle:{"float":"left","margin-bottom":"10px"}},[(!lineUp.loadImgFail)?_c('img',{staticStyle:{"border-radius":"24px","width":"24px","height":"24px","border":"1px solid red"},attrs:{"src":lineUp.assetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),(lineUp.loadImgFail)?_c('img',{staticStyle:{"border-radius":"24px","width":"24px","height":"24px"},attrs:{"src":lineUp.assetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(lineUp.name))]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(lineUp.jersey_number)+"号")])])}),0),_vm._v(" "),_c('div',{staticClass:"col-xs-6",staticStyle:{"margin-bottom":"10px","padding-left":"0px","padding-right":"0px"}},_vm._l((_vm.visitlineUpList),function(lineUp){return _c('div',{staticClass:"col-xs-12",staticStyle:{"float":"left","margin-bottom":"10px"}},[(!lineUp.loadImgFail)?_c('img',{staticStyle:{"border-radius":"24px","width":"24px","height":"24px","border":"1px solid #299afe"},attrs:{"src":lineUp.assetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),(lineUp.loadImgFail)?_c('img',{staticStyle:{"border-radius":"24px","width":"24px","height":"24px"},attrs:{"src":lineUp.assetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(lineUp.name))]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(lineUp.jersey_number)+"号")])])}),0)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","padding-bottom":"100px"}},[_c('div',{staticClass:"col-xs-6",staticStyle:{"margin-bottom":"10px","padding-left":"0px","padding-right":"0px"}},_vm._l((_vm.homesubstituteList),function(substitute){return _c('div',{staticClass:"col-xs-12",staticStyle:{"float":"left","margin-bottom":"10px"}},[(!substitute.loadImgFail)?_c('img',{staticStyle:{"border-radius":"24px","width":"24px","height":"24px","border":"1px solid red"},attrs:{"src":substitute.assetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),(substitute.loadImgFail)?_c('img',{staticStyle:{"border-radius":"24px","width":"24px","height":"24px"},attrs:{"src":substitute.assetId,"onerror":_vm.homeTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(substitute.name))]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(substitute.jersey_number)+"号")])])}),0),_vm._v(" "),_c('div',{staticClass:"col-xs-6",staticStyle:{"margin-bottom":"10px","padding-left":"0px","padding-right":"0px"}},_vm._l((_vm.visitsubstituteList),function(substitute){return _c('div',{staticClass:"col-xs-12",staticStyle:{"float":"left","margin-bottom":"10px"}},[(!substitute.loadImgFail)?_c('img',{staticStyle:{"border-radius":"24px","width":"24px","height":"24px","border":"1px solid #299afe"},attrs:{"src":substitute.assetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),(substitute.loadImgFail)?_c('img',{staticStyle:{"border-radius":"24px","width":"24px","height":"24px"},attrs:{"src":substitute.assetId,"onerror":_vm.visitTeamHeader}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#000000"}},[_vm._v(_vm._s(substitute.name))]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(substitute.jersey_number)+"号")])])}),0)])])])}
var matchScores_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"padding-left":"15px","padding-right":"15px","height":"40px"}},[_c('div',{staticClass:"row",staticStyle:{"text-align":"center","margin-left":"0px","border-top":"1px solid #F3F3F3","padding-top":"10px","height":"40px"}},[_c('span',{staticStyle:{"display":"inline-block","height":"1px","width":"20px","background":"#FE2754","margin-bottom":"5px"}}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","color":"#333333"}},[_vm._v("阵容")]),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","height":"1px","width":"20px","background":"#FE2754","margin-bottom":"5px"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"15px"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v("首发")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"20px","margin-left":"15px"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#999999"}},[_vm._v("替补")])])}]
var matchScores_esExports = { render: matchScores_render, staticRenderFns: matchScores_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_matchScores = (matchScores_esExports);
// CONCATENATED MODULE: ./src/views/matchScores.vue
var matchScores_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchScores___vue_template_functional__ = false
/* styles */
var matchScores___vue_styles__ = null
/* scopeId */
var matchScores___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var matchScores___vue_module_identifier__ = null
var matchScores_Component = matchScores_normalizeComponent(
  views_matchScores,
  selectortype_template_index_0_src_views_matchScores,
  matchScores___vue_template_functional__,
  matchScores___vue_styles__,
  matchScores___vue_scopeId__,
  matchScores___vue_module_identifier__
)

/* harmony default export */ var src_views_matchScores = (matchScores_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchDynamic.vue












/* harmony default export */ var matchDynamic = ({
  props: {
    eventHub: Object
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Divider: vux_src_components_divider,
    XDialog: vux_src_components_x_dialog,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    XSwitch: vux_src_components_x_switch,
    Previewer: vux_src_components_previewer,
    wx: external__jWeixin__default.a
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
  },
  mounted: function mounted() {

    this.initTab();
  },
  data: function data() {
    return {
      matchId: '', //352917
      content: '动态数据',
      indexContentHeight: 0,
      assets: [],
      imagelist: [],
      teamUrl: '',
      defaultImg: 'this.src="' + __webpack_require__("KXse") + '"',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },

  methods: {
    initTab: function initTab() {
      var _this = this;

      this.$nextTick(function () {
        _this.indexContentHeight = document.body.clientHeight;
      });

      this.hagkHttp(this.hagkApi.getMatchAssetsByMatchId(this.matchId, 'dynamic'), {}).then(function (res) {
        _this.imagelist.splice(0, _this.imagelist.length);
        _this.assets.splice(0, _this.assets.length);
        if (res && res.length > 0) {
          for (var i = 0; i < res.length; i++) {
            for (var j = 0; j < res[i].assetList.length; j++) {
              var description = res[i].assetList[j].description;
              if (description && description.startsWith('http')) {
                // 球队数据
                _this.teamUrl = description;
              } else {
                var data = {};
                data.url = _this.hagkApi.getImgAssetById(res[i].assetList[j].assetId).url;
                data.thumbnail_url = _this.hagkApi.getImgAssetById(res[i].assetList[j].thumbnailId).url;
                data.type = res[i].assetList[j].type;
                data.description = res[i].assetList[j].description;
                _this.assets.push(data);
              }
            }
          }

          for (var i = 0; i < _this.assets.length; i++) {
            var data = {};
            data.src = _this.assets[i].url;
            data.actSrc = _this.assets[i].url;
            data.type = _this.assets[i].type;
            data.thumbnail_url = _this.assets[i].thumbnail_url;
            data.description = _this.assets[i].description;
            _this.imagelist.push(data);
          }
        }
        _this.changeMomentHeight();
      }, function (error) {});
    },
    showImage: function showImage(src) {
      var urls = [];
      for (var i = 0; i < this.imagelist.length; i++) {
        urls.push(this.imagelist[i].src);
      }
      external__jWeixin__default.a.previewImage({
        current: src,
        urls: urls
      });
    },
    changeMomentHeight: function changeMomentHeight() {
      if (this.eventHub) {
        this.eventHub.$emit("resetView");
      }
    },

    jump: function jump() {
      window.open(this.teamUrl, '_blank');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchDynamic.vue












/* harmony default export */ var views_matchDynamic = ({
  props: {
    eventHub: Object
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Divider: vux_src_components_divider,
    XDialog: vux_src_components_x_dialog,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    XSwitch: vux_src_components_x_switch,
    Previewer: vux_src_components_previewer,
    wx: external__jWeixin__default.a
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
  },
  mounted: function mounted() {

    this.initTab();
  },
  data: function data() {
    return {
      matchId: '', //352917
      content: '动态数据',
      indexContentHeight: 0,
      assets: [],
      imagelist: [],
      teamUrl: '',
      defaultImg: 'this.src="' + __webpack_require__("KXse") + '"',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },

  methods: {
    initTab: function initTab() {
      var _this = this;

      this.$nextTick(function () {
        _this.indexContentHeight = document.body.clientHeight;
      });

      this.hagkHttp(this.hagkApi.getMatchAssetsByMatchId(this.matchId, 'dynamic'), {}).then(function (res) {
        _this.imagelist.splice(0, _this.imagelist.length);
        _this.assets.splice(0, _this.assets.length);
        if (res && res.length > 0) {
          for (var i = 0; i < res.length; i++) {
            for (var j = 0; j < res[i].assetList.length; j++) {
              var description = res[i].assetList[j].description;
              if (description && description.startsWith('http')) {
                // 球队数据
                _this.teamUrl = description;
              } else {
                var data = {};
                data.url = _this.hagkApi.getImgAssetById(res[i].assetList[j].assetId).url;
                data.thumbnail_url = _this.hagkApi.getImgAssetById(res[i].assetList[j].thumbnailId).url;
                data.type = res[i].assetList[j].type;
                data.description = res[i].assetList[j].description;
                _this.assets.push(data);
              }
            }
          }

          for (var i = 0; i < _this.assets.length; i++) {
            var data = {};
            data.src = _this.assets[i].url;
            data.actSrc = _this.assets[i].url;
            data.type = _this.assets[i].type;
            data.thumbnail_url = _this.assets[i].thumbnail_url;
            data.description = _this.assets[i].description;
            _this.imagelist.push(data);
          }
        }
        _this.changeMomentHeight();
      }, function (error) {});
    },
    showImage: function showImage(src) {
      var urls = [];
      for (var i = 0; i < this.imagelist.length; i++) {
        urls.push(this.imagelist[i].src);
      }
      external__jWeixin__default.a.previewImage({
        current: src,
        urls: urls
      });
    },
    changeMomentHeight: function changeMomentHeight() {
      if (this.eventHub) {
        this.eventHub.$emit("resetView");
      }
    },

    jump: function jump() {
      window.open(this.teamUrl, '_blank');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f42d24a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/matchDynamic.vue
var matchDynamic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#FFFFFF","position":"relative"},attrs:{"id":"secondTabItem"}},[(_vm.imagelist.length > 0)?_c('div',{attrs:{"id":"inner_secondTabItem"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"16px","color":"#999999","margin-left":"20px","margin-bottom":"20px"},on:{"click":function($event){return _vm.jump()}}},[_vm._v("\n      点击此处"),_c('span',{staticStyle:{"color":"red","font-size":"18px"}},[_vm._v("看数据")])])]):_vm._e(),_vm._v(" "),(_vm.imagelist.length > 0)?_c('div',{attrs:{"id":"inner_secondTabItem"}},[_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap","justify-content":"center"}},[_vm._l((_vm.imagelist),function(item,index){return _c('div',{staticStyle:{"margin":"5px 20px"}},[_c('img',{staticClass:"previewer-demo-img",staticStyle:{"padding":"3px","border-radius":"4px"},attrs:{"src":item.thumbnail_url,"width":"150","height":"100","onerror":_vm.defaultImg},on:{"click":function($event){return _vm.showImage(item.src)}}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px","text-align":"center","font-size":"14px"}},[_vm._v(_vm._s(item.description))])])}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.imagelist,"options":_vm.options}})],1)],2)]):_vm._e(),_vm._v(" "),(_vm.imagelist.length == 0)?_c('div',{staticStyle:{"text-align":"center","margin-top":"100px","height":"100%"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v("暂无动态数据")])]):_vm._e()])}
var matchDynamic_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"15px","height":"44px","margin-top":"10px"}},[_c('span',{staticClass:"module-icon"}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"18px","color":"#333333"}},[_vm._v("球队数据")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"15px","height":"44px","margin-top":"10px"}},[_c('span',{staticClass:"module-icon"}),_vm._v(" "),_c('span',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"18px","color":"#333333"}},[_vm._v("队员数据")])])}]
var matchDynamic_esExports = { render: matchDynamic_render, staticRenderFns: matchDynamic_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_matchDynamic = (matchDynamic_esExports);
// CONCATENATED MODULE: ./src/views/matchDynamic.vue
function matchDynamic_injectStyle (ssrContext) {
  __webpack_require__("FoU3")
}
var matchDynamic_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchDynamic___vue_template_functional__ = false
/* styles */
var matchDynamic___vue_styles__ = matchDynamic_injectStyle
/* scopeId */
var matchDynamic___vue_scopeId__ = "data-v-1f42d24a"
/* moduleIdentifier (server only) */
var matchDynamic___vue_module_identifier__ = null
var matchDynamic_Component = matchDynamic_normalizeComponent(
  views_matchDynamic,
  selectortype_template_index_0_src_views_matchDynamic,
  matchDynamic___vue_template_functional__,
  matchDynamic___vue_styles__,
  matchDynamic___vue_scopeId__,
  matchDynamic___vue_module_identifier__
)

/* harmony default export */ var src_views_matchDynamic = (matchDynamic_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchLive.vue









/* harmony default export */ var matchLive = ({
  props: {
    eventHub: Object,
    liveUrl: String,
    isEnd: Boolean
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      matchId: '', //352917
      content: '直播',
      indexContentHeight: 0,
      showHideOnBlur: false,
      url: this.liveUrl,
      matchEnd: this.isEnd
    };
  },

  watch: {
    liveUrl: function liveUrl(val) {
      console.log('==========watch liveUrl==============');
      console.log(val);
      this.url = val;
    },
    isEnd: function isEnd(val) {
      console.log('==========watch isEnd==============');
      console.log(val);
      this.matchEnd = val;
    }
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
  },
  mounted: function mounted() {

    this.initTab();
  },

  methods: {
    initTab: function initTab() {
      var _this = this;

      this.$nextTick(function () {
        _this.indexContentHeight = document.body.clientHeight;
      });
    },

    jump: function jump() {
      window.open(this.url, '_blank');
    }
  },
  components: {
    Divider: vux_src_components_divider,
    XDialog: vux_src_components_x_dialog,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    XSwitch: vux_src_components_x_switch
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchLive.vue









/* harmony default export */ var views_matchLive = ({
  props: {
    eventHub: Object,
    liveUrl: String,
    isEnd: Boolean
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      matchId: '', //352917
      content: '直播',
      indexContentHeight: 0,
      showHideOnBlur: false,
      url: this.liveUrl,
      matchEnd: this.isEnd
    };
  },

  watch: {
    liveUrl: function liveUrl(val) {
      console.log('==========watch liveUrl==============');
      console.log(val);
      this.url = val;
    },
    isEnd: function isEnd(val) {
      console.log('==========watch isEnd==============');
      console.log(val);
      this.matchEnd = val;
    }
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
  },
  mounted: function mounted() {

    this.initTab();
  },

  methods: {
    initTab: function initTab() {
      var _this = this;

      this.$nextTick(function () {
        _this.indexContentHeight = document.body.clientHeight;
      });
    },

    jump: function jump() {
      window.open(this.url, '_blank');
    }
  },
  components: {
    Divider: vux_src_components_divider,
    XDialog: vux_src_components_x_dialog,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    XSwitch: vux_src_components_x_switch
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bc2ab50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/matchLive.vue
var matchLive_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#FFFFFF"},attrs:{"id":"secondTabItem"}},[(_vm.url == null || _vm.url == '')?_c('div',{staticStyle:{"text-align":"center","margin-top":"100px","height":"100%"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v("暂无直播，敬请期待")])]):_vm._e(),_vm._v(" "),(_vm.url != null && _vm.url != '')?_c('div',{staticStyle:{"text-align":"center","margin-top":"150px","height":"100%"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"16px","color":"#999999"},on:{"click":function($event){return _vm.jump()}}},[_vm._v("\n      点击此处\n      "),_c('span',{staticStyle:{"color":"red","font-size":"20px"}},[_vm._v("\n        看"),(!_vm.matchEnd)?[_vm._v("直播")]:_vm._e(),(_vm.matchEnd)?[_vm._v("回放")]:_vm._e()],2)])]):_vm._e()])}
var matchLive_staticRenderFns = []
var matchLive_esExports = { render: matchLive_render, staticRenderFns: matchLive_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_matchLive = (matchLive_esExports);
// CONCATENATED MODULE: ./src/views/matchLive.vue
function matchLive_injectStyle (ssrContext) {
  __webpack_require__("Uuy1")
}
var matchLive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchLive___vue_template_functional__ = false
/* styles */
var matchLive___vue_styles__ = matchLive_injectStyle
/* scopeId */
var matchLive___vue_scopeId__ = "data-v-3bc2ab50"
/* moduleIdentifier (server only) */
var matchLive___vue_module_identifier__ = null
var matchLive_Component = matchLive_normalizeComponent(
  views_matchLive,
  selectortype_template_index_0_src_views_matchLive,
  matchLive___vue_template_functional__,
  matchLive___vue_styles__,
  matchLive___vue_scopeId__,
  matchLive___vue_module_identifier__
)

/* harmony default export */ var src_views_matchLive = (matchLive_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchDynamicData.vue
//
//
//
//
//
//

/* harmony default export */ var matchDynamicData = ({
	props: {
		eventHub: Object
	},
	mounted: function mounted() {
		var _this = this;

		//   if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '赛事动态数据'])}
		this.$nextTick(function () {
			_this.indexContentHeight = document.body.clientHeight - 230;
		});
	},
	data: function data() {
		return {
			content: '暂无动态数据',
			indexContentHeight: 0
		};
	},

	methods: {
		initTab: function initTab() {}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchDynamicData.vue
//
//
//
//
//
//

/* harmony default export */ var views_matchDynamicData = ({
	props: {
		eventHub: Object
	},
	mounted: function mounted() {
		var _this = this;

		//   if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '赛事动态数据'])}
		this.$nextTick(function () {
			_this.indexContentHeight = document.body.clientHeight - 230;
		});
	},
	data: function data() {
		return {
			content: '暂无动态数据',
			indexContentHeight: 0
		};
	},

	methods: {
		initTab: function initTab() {}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233c7d7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/matchDynamicData.vue
var matchDynamicData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"hidden","overflow-y":"auto","background-color":"#FFFFFF","text-align":"center","margin-top":"100px"},style:({height:_vm.indexContentHeight+'px'})},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v(_vm._s(_vm.content))])])}
var matchDynamicData_staticRenderFns = []
var matchDynamicData_esExports = { render: matchDynamicData_render, staticRenderFns: matchDynamicData_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_matchDynamicData = (matchDynamicData_esExports);
// CONCATENATED MODULE: ./src/views/matchDynamicData.vue
var matchDynamicData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchDynamicData___vue_template_functional__ = false
/* styles */
var matchDynamicData___vue_styles__ = null
/* scopeId */
var matchDynamicData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var matchDynamicData___vue_module_identifier__ = null
var matchDynamicData_Component = matchDynamicData_normalizeComponent(
  views_matchDynamicData,
  selectortype_template_index_0_src_views_matchDynamicData,
  matchDynamicData___vue_template_functional__,
  matchDynamicData___vue_styles__,
  matchDynamicData___vue_scopeId__,
  matchDynamicData___vue_module_identifier__
)

/* harmony default export */ var src_views_matchDynamicData = (matchDynamicData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchInfo.vue

















/* harmony default export */ var matchInfo = ({
  name: 'app',
  components: {
    matchResultHeader: src_components_MatchResultHeader,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    matchScores: src_views_matchScores,
    matchMoments: src_views_matchMoments,
    matchDynamic: src_views_matchDynamic,
    matchLive: src_views_matchLive,
    matchDynamicData: src_views_matchDynamicData,
    Scroller: vux_src_components_scroller
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
    if (this.$route.query.currentTab) {
      this.currentTab = this.$route.query.currentTab;
    }
    if (this.$route.query.liveUrl) {
      this.liveUrl = this.$route.query.liveUrl;
    }
  },
  data: function data() {
    return {
      eventHub: new vue_esm["a" /* default */](),
      tabNames: ['赛况', '精彩瞬间', '动态数据', '看直播'],
      currentTab: 'matchScoresTab',
      tabShow: true,
      homeTeamScore: null,
      visitTeamScore: null,
      homeTeamPKScore: null,
      visitTeamPKScore: null,
      beforeStart: __webpack_require__("fzkm"),
      matchId: '',
      info: 'request',
      pullupConfig: {
        content: '',
        pullUpHeight: 60,
        height: 100,
        autoRefresh: true,
        downContent: '',
        upContent: '',
        loadingContent: '',
        clsPrefix: 'xs-plugin-pullup-'
      },
      homeTeamName: '',
      visitTeamName: '',
      leagueName: '',
      liveUrl: '',
      liveStatus: '',
      isEnd: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {}).then(function (res) {
      console.log('================res=================');
      console.log(res);
      _this.liveUrl = res.liveUrl;
      _this.liveStatus = res.liveStatus;
      _this.isEnd = res.isEnd;
      _this.homeTeamName = res.homeTeamName;
      _this.visitTeamName = res.vistingTeamName;
      _this.leagueName = res.leagueName;
      if (res.result && res.result != null) {

        if (res.result.goalFor != null) {
          _this.homeTeamScore = 0;
          _this.homeTeamScore += res.result.goalFor;
        }
        if (res.result.homeExScore != null) {
          _this.homeTeamScore = _this.homeTeamScore == null ? 0 : _this.homeTeamScore;
          _this.homeTeamScore += res.result.homeExScore;
        }
        if (res.result.homePkScore != null) {
          _this.homePkScore = 0;
          _this.homeTeamPKScore += res.result.homePkScore;
        }
        if (res.result.goalAgainst != null) {
          _this.visitTeamScore = 0;
          _this.visitTeamScore += res.result.goalAgainst;
        }
        if (res.result.visitorExScore != null) {
          _this.visitTeamScore = _this.visitTeamScore == null ? 0 : _this.visitTeamScore;
          _this.visitTeamScore += res.result.visitorExScore;
        }
        if (res.result.visitorPkScore != null) {
          _this.visitorPkScore = 0;
          _this.visitTeamPKScore += res.result.visitorPkScore;
        }

        if (_this.homeTeamScore == null && _this.visitTeamScore == null) {
          _this.tabShow = false;
        } else {
          _this.tabShow = true;
        }
      } else {
        _this.tabShow = false;
      }
      if (_this.tabShow) {
        document.title = "比赛结果";
        var fullPath = window.location.href;
        var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
        var title = _this.leagueName;
        var desc = "主队：" + _this.homeTeamName + '\r\n客队：' + _this.visitTeamName;
        var homeTeamTotalScore = _this.homeTeamScore + _this.homeTeamPKScore;
        var visitTeamTotalScore = _this.visitTeamScore + _this.visitTeamPKScore;
        utils_wxShareConfig({
          title: '最新赛果',
          desc: _this.homeTeamName + homeTeamTotalScore + "-" + visitTeamTotalScore + _this.visitTeamName,
          link: fullPath,
          imgUrl: shareImg,
          type: 'link',
          dataUrl: ''
        }, function () {}, function () {});
      } else {
        document.title = "比赛预告";
        var realPath = window.location.href;
        var fullPath = realPath.substring(0, realPath.indexOf('/match_info')) + '/match_info_share?matchId=' + _this.matchId;
        var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
        var title = _this.leagueName;
        var desc = "主队：" + _this.homeTeamName + '\r\n客队：' + _this.visitTeamName;

        utils_wxShareConfig({
          title: title,
          desc: desc,
          link: realPath,
          imgUrl: shareImg,
          type: 'link',
          dataUrl: ''
        }, function () {}, function () {}, fullPath);
      }
    }, function (error) {
      console.log(error);
      window.alert('比赛信息获取失败！');
    });

    this.eventHub.$on('resetView', function () {
      _this.$nextTick(function () {
        _this.$refs.scroller.reset();
      });
    });
  },

  methods: {
    first_handlerMatchScores: function first_handlerMatchScores() {
      this.currentTab = 'matchScoresTab';
      this.$refs.matchScoresTab.initTab();
    },
    first_handlerMatchMoments: function first_handlerMatchMoments() {
      this.currentTab = 'matchMomentsTab';
      this.$refs.matchMomentsTab.initTab();
    },
    first_handlerMatchLive: function first_handlerMatchLive() {
      this.currentTab = 'matchLiveTab';
      this.$refs.matchLiveTab.initTab();
    },
    first_handlerMatchDynamicData: function first_handlerMatchDynamicData() {
      this.currentTab = 'matchDynamicDataTab';
      this.$refs.matchDynamicDataTab.initTab();
    },
    handlerMatchScores: function handlerMatchScores() {
      this.currentTab = 'matchScoresTab';

      this.loadMore();
    },
    handlerMatchMoments: function handlerMatchMoments() {
      this.currentTab = 'matchMomentsTab';

      this.loadMore();
    },
    handlerMatchDynamic: function handlerMatchDynamic() {
      this.currentTab = 'matchDynamicTab';

      this.loadMore();
    },
    handlerMatchLive: function handlerMatchLive() {
      this.currentTab = 'matchLiveTab';

      this.loadMore();
    },
    handlerMatchDynamicData: function handlerMatchDynamicData() {
      this.currentTab = 'matchDynamicDataTab';
    },
    handlerMatchScoresListener: function handlerMatchScoresListener() {

      this.$refs.scroller.reset();
    },
    handlerMatchMomentsListener: function handlerMatchMomentsListener() {

      this.$refs.scroller.reset();
    },
    handlerMatchDynamicListener: function handlerMatchDynamicListener() {

      this.$refs.scroller.reset();
    },
    handlerMatchLiveListener: function handlerMatchLiveListener() {

      this.$refs.scroller.reset();
    },
    loadMore: function loadMore() {},

    jump: function jump() {
      window.open(this.liveUrl, '_blank');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchInfo.vue

















/* harmony default export */ var views_matchInfo = ({
  name: 'app',
  components: {
    matchResultHeader: src_components_MatchResultHeader,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    matchScores: src_views_matchScores,
    matchMoments: src_views_matchMoments,
    matchDynamic: src_views_matchDynamic,
    matchLive: src_views_matchLive,
    matchDynamicData: src_views_matchDynamicData,
    Scroller: vux_src_components_scroller
  },
  created: function created() {
    this.matchId = this.$route.query.matchId;
    if (this.$route.query.currentTab) {
      this.currentTab = this.$route.query.currentTab;
    }
    if (this.$route.query.liveUrl) {
      this.liveUrl = this.$route.query.liveUrl;
    }
  },
  data: function data() {
    return {
      eventHub: new vue_esm["a" /* default */](),
      tabNames: ['赛况', '精彩瞬间', '动态数据', '看直播'],
      currentTab: 'matchScoresTab',
      tabShow: true,
      homeTeamScore: null,
      visitTeamScore: null,
      homeTeamPKScore: null,
      visitTeamPKScore: null,
      beforeStart: __webpack_require__("fzkm"),
      matchId: '',
      info: 'request',
      pullupConfig: {
        content: '',
        pullUpHeight: 60,
        height: 100,
        autoRefresh: true,
        downContent: '',
        upContent: '',
        loadingContent: '',
        clsPrefix: 'xs-plugin-pullup-'
      },
      homeTeamName: '',
      visitTeamName: '',
      leagueName: '',
      liveUrl: '',
      liveStatus: '',
      isEnd: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {}).then(function (res) {
      console.log('================res=================');
      console.log(res);
      _this.liveUrl = res.liveUrl;
      _this.liveStatus = res.liveStatus;
      _this.isEnd = res.isEnd;
      _this.homeTeamName = res.homeTeamName;
      _this.visitTeamName = res.vistingTeamName;
      _this.leagueName = res.leagueName;
      if (res.result && res.result != null) {

        if (res.result.goalFor != null) {
          _this.homeTeamScore = 0;
          _this.homeTeamScore += res.result.goalFor;
        }
        if (res.result.homeExScore != null) {
          _this.homeTeamScore = _this.homeTeamScore == null ? 0 : _this.homeTeamScore;
          _this.homeTeamScore += res.result.homeExScore;
        }
        if (res.result.homePkScore != null) {
          _this.homePkScore = 0;
          _this.homeTeamPKScore += res.result.homePkScore;
        }
        if (res.result.goalAgainst != null) {
          _this.visitTeamScore = 0;
          _this.visitTeamScore += res.result.goalAgainst;
        }
        if (res.result.visitorExScore != null) {
          _this.visitTeamScore = _this.visitTeamScore == null ? 0 : _this.visitTeamScore;
          _this.visitTeamScore += res.result.visitorExScore;
        }
        if (res.result.visitorPkScore != null) {
          _this.visitorPkScore = 0;
          _this.visitTeamPKScore += res.result.visitorPkScore;
        }

        if (_this.homeTeamScore == null && _this.visitTeamScore == null) {
          _this.tabShow = false;
        } else {
          _this.tabShow = true;
        }
      } else {
        _this.tabShow = false;
      }
      if (_this.tabShow) {
        document.title = "比赛结果";
        var fullPath = window.location.href;
        var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
        var title = _this.leagueName;
        var desc = "主队：" + _this.homeTeamName + '\r\n客队：' + _this.visitTeamName;
        var homeTeamTotalScore = _this.homeTeamScore + _this.homeTeamPKScore;
        var visitTeamTotalScore = _this.visitTeamScore + _this.visitTeamPKScore;
        utils_wxShareConfig({
          title: '最新赛果',
          desc: _this.homeTeamName + homeTeamTotalScore + "-" + visitTeamTotalScore + _this.visitTeamName,
          link: fullPath,
          imgUrl: shareImg,
          type: 'link',
          dataUrl: ''
        }, function () {}, function () {});
      } else {
        document.title = "比赛预告";
        var realPath = window.location.href;
        var fullPath = realPath.substring(0, realPath.indexOf('/match_info')) + '/match_info_share?matchId=' + _this.matchId;
        var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
        var title = _this.leagueName;
        var desc = "主队：" + _this.homeTeamName + '\r\n客队：' + _this.visitTeamName;

        utils_wxShareConfig({
          title: title,
          desc: desc,
          link: realPath,
          imgUrl: shareImg,
          type: 'link',
          dataUrl: ''
        }, function () {}, function () {}, fullPath);
      }
    }, function (error) {
      console.log(error);
      window.alert('比赛信息获取失败！');
    });

    this.eventHub.$on('resetView', function () {
      _this.$nextTick(function () {
        _this.$refs.scroller.reset();
      });
    });
  },

  methods: {
    first_handlerMatchScores: function first_handlerMatchScores() {
      this.currentTab = 'matchScoresTab';
      this.$refs.matchScoresTab.initTab();
    },
    first_handlerMatchMoments: function first_handlerMatchMoments() {
      this.currentTab = 'matchMomentsTab';
      this.$refs.matchMomentsTab.initTab();
    },
    first_handlerMatchLive: function first_handlerMatchLive() {
      this.currentTab = 'matchLiveTab';
      this.$refs.matchLiveTab.initTab();
    },
    first_handlerMatchDynamicData: function first_handlerMatchDynamicData() {
      this.currentTab = 'matchDynamicDataTab';
      this.$refs.matchDynamicDataTab.initTab();
    },
    handlerMatchScores: function handlerMatchScores() {
      this.currentTab = 'matchScoresTab';

      this.loadMore();
    },
    handlerMatchMoments: function handlerMatchMoments() {
      this.currentTab = 'matchMomentsTab';

      this.loadMore();
    },
    handlerMatchDynamic: function handlerMatchDynamic() {
      this.currentTab = 'matchDynamicTab';

      this.loadMore();
    },
    handlerMatchLive: function handlerMatchLive() {
      this.currentTab = 'matchLiveTab';

      this.loadMore();
    },
    handlerMatchDynamicData: function handlerMatchDynamicData() {
      this.currentTab = 'matchDynamicDataTab';
    },
    handlerMatchScoresListener: function handlerMatchScoresListener() {

      this.$refs.scroller.reset();
    },
    handlerMatchMomentsListener: function handlerMatchMomentsListener() {

      this.$refs.scroller.reset();
    },
    handlerMatchDynamicListener: function handlerMatchDynamicListener() {

      this.$refs.scroller.reset();
    },
    handlerMatchLiveListener: function handlerMatchLiveListener() {

      this.$refs.scroller.reset();
    },
    loadMore: function loadMore() {},

    jump: function jump() {
      window.open(this.liveUrl, '_blank');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cef86794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/matchInfo.vue
var matchInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('scroller',{ref:"scroller",attrs:{"lock-x":"","scrollbar-y":"","use-pullup":"","pullup-config":this.pullupConfig},on:{"on-pullup-loading":_vm.loadMore}},[_c('div',[_c('div',{staticStyle:{"height":"200px"}},[_c('matchResultHeader')],1),_vm._v(" "),(!_vm.tabShow)?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('div',[_c('img',{attrs:{"src":_vm.beforeStart}})]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px"}},[_c('span',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999"}},[_vm._v("比赛还未开始哦")])]),_vm._v(" "),(_vm.liveUrl != null && _vm.liveUrl != '')?_c('div',{staticStyle:{"text-align":"center","margin-top":"50px","height":"100%"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"16px","color":"#999999"},on:{"click":function($event){return _vm.jump()}}},[_vm._v("\n          点击此处看\n          "),_c('span',{staticStyle:{"color":"red","font-size":"20px"}},[(!_vm.isEnd)?[_vm._v("直播")]:_vm._e(),(_vm.isEnd)?[_vm._v("回放")]:_vm._e()],2)])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.tabShow)?_c('div',[_c('tab',{attrs:{"line-width":3,"defaultColor":"#999999","active-color":"#333333","bar-active-color":"#FE2754"}},[_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"matchScoresTab","selected":this.currentTab=='matchScoresTab'},on:{"on-item-click":_vm.handlerMatchScores}},[_vm._v("\n                            "+_vm._s(this.tabNames[0])+"\n                ")]),_vm._v(" "),_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"matchMomentsTab","selected":this.currentTab=='matchMomentsTab'},on:{"on-item-click":_vm.handlerMatchMoments}},[_vm._v("\n                            "+_vm._s(this.tabNames[1])+"\n                ")]),_vm._v(" "),_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"matchDynamicTab","selected":this.currentTab=='matchDynamicTab'},on:{"on-item-click":_vm.handlerMatchDynamic}},[_vm._v("\n                  "+_vm._s(this.tabNames[2])+"\n                ")]),_vm._v(" "),_c('tab-item',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"16px","letter-spacing":"0"},attrs:{"id":"matchLiveTab","selected":this.currentTab=='matchLiveTab'},on:{"on-item-click":_vm.handlerMatchLive}},[_vm._v("\n                            "+_vm._s(this.tabNames[3])+"\n                ")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab == 'matchScoresTab'),expression:"currentTab == 'matchScoresTab'"}],attrs:{"id":"matchScoresTab"}},[_c('matchScores',{ref:"matchScoresTab",attrs:{"eventHub":_vm.eventHub},on:{"handlerMatchScoresListener":_vm.handlerMatchScoresListener}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab == 'matchMomentsTab'),expression:"currentTab == 'matchMomentsTab'"}],attrs:{"id":"matchMomentsTab"}},[_c('matchMoments',{ref:"matchMomentsTab",attrs:{"eventHub":_vm.eventHub},on:{"handlerMatchMomentsListener":_vm.handlerMatchMomentsListener}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab == 'matchDynamicTab'),expression:"currentTab == 'matchDynamicTab'"}],attrs:{"id":"matchDynamicTab"}},[_c('matchDynamic',{ref:"matchDynamicTab",attrs:{"eventHub":_vm.eventHub},on:{"handlerMatchDynamicListener":_vm.handlerMatchDynamicListener}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab == 'matchLiveTab'),expression:"currentTab == 'matchLiveTab'"}],attrs:{"id":"matchLiveTab"}},[_c('matchLive',{ref:"matchLiveTab",attrs:{"eventHub":_vm.eventHub,"liveUrl":_vm.liveUrl,"isEnd":_vm.isEnd},on:{"handlerMatchLiveListener":_vm.handlerMatchLiveListener}})],1)],1):_vm._e()])])],1)}
var matchInfo_staticRenderFns = []
var matchInfo_esExports = { render: matchInfo_render, staticRenderFns: matchInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_matchInfo = (matchInfo_esExports);
// CONCATENATED MODULE: ./src/views/matchInfo.vue
var matchInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchInfo___vue_template_functional__ = false
/* styles */
var matchInfo___vue_styles__ = null
/* scopeId */
var matchInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var matchInfo___vue_module_identifier__ = null
var matchInfo_Component = matchInfo_normalizeComponent(
  views_matchInfo,
  selectortype_template_index_0_src_views_matchInfo,
  matchInfo___vue_template_functional__,
  matchInfo___vue_styles__,
  matchInfo___vue_scopeId__,
  matchInfo___vue_module_identifier__
)

/* harmony default export */ var src_views_matchInfo = (matchInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LeagueListHead.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LeagueListHead = ({
	props: ['orgCode'],
	data: function data() {
		return {
			leagueId: null,
			leagueName: null,
			showLeagueList: false,
			leagueList: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.hagkHttp(this.hagkApi.getLeagueList(this.orgCode), {}).then(function (res) {
			if (res.status) {
				_this.leagueList = res.result;
			}
		}, function (error) {
			console.log(error);
			window.alert('联赛列表获取失败！');
		});
	},

	methods: {
		changeLeague: function changeLeague(leagueId, leagueName) {
			this.showLeagueList = false;
			this.leagueId = leagueId;
			this.leagueName = leagueName;
			this.$emit('changeLeague', leagueId);
		}
	},
	filters: {
		subfilter: function subfilter(value, sublength) {
			if (!value) return '';
			value = value.toString();
			if (value.length > sublength) {
				return value.substr(0, sublength) + "...";
			}
			return value;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LeagueListHead.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_LeagueListHead = ({
	props: ['orgCode'],
	data: function data() {
		return {
			leagueId: null,
			leagueName: null,
			showLeagueList: false,
			leagueList: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.hagkHttp(this.hagkApi.getLeagueList(this.orgCode), {}).then(function (res) {
			if (res.status) {
				_this.leagueList = res.result;
			}
		}, function (error) {
			console.log(error);
			window.alert('联赛列表获取失败！');
		});
	},

	methods: {
		changeLeague: function changeLeague(leagueId, leagueName) {
			this.showLeagueList = false;
			this.leagueId = leagueId;
			this.leagueName = leagueName;
			this.$emit('changeLeague', leagueId);
		}
	},
	filters: {
		subfilter: function subfilter(value, sublength) {
			if (!value) return '';
			value = value.toString();
			if (value.length > sublength) {
				return value.substr(0, sublength) + "...";
			}
			return value;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475f91c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeagueListHead.vue
var LeagueListHead_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-all"},[_c('div',{staticClass:"match-header"},[_c('div',{staticClass:"header-cont",on:{"click":function($event){_vm.showLeagueList=!_vm.showLeagueList}}},[_c('span',[(_vm.leagueName && _vm.leagueName != '')?[_vm._v(_vm._s(_vm._f("subfilter")(_vm.leagueName,18)))]:[_vm._v("全部赛事")]],2),_vm._v(" "),_c('span',{staticClass:"arrow-icon"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLeagueList),expression:"!showLeagueList"}],attrs:{"src":__webpack_require__("ra3e")}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeagueList),expression:"showLeagueList"}],attrs:{"src":__webpack_require__("Q1oX")}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeagueList),expression:"showLeagueList"}],staticClass:"league-list"},[_c('div',{staticClass:"league-item",on:{"click":function($event){return _vm.changeLeague()}}},[_vm._v("全部赛事")]),_vm._v(" "),_vm._l((_vm.leagueList),function(league,index){return [_c('div',{staticClass:"league-item",on:{"click":function($event){return _vm.changeLeague(league.id, league.name)}}},[_vm._v(_vm._s(league.name))])]})],2)])}
var LeagueListHead_staticRenderFns = []
var LeagueListHead_esExports = { render: LeagueListHead_render, staticRenderFns: LeagueListHead_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LeagueListHead = (LeagueListHead_esExports);
// CONCATENATED MODULE: ./src/components/LeagueListHead.vue
function LeagueListHead_injectStyle (ssrContext) {
  __webpack_require__("hH+7")
}
var LeagueListHead_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeagueListHead___vue_template_functional__ = false
/* styles */
var LeagueListHead___vue_styles__ = LeagueListHead_injectStyle
/* scopeId */
var LeagueListHead___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LeagueListHead___vue_module_identifier__ = null
var LeagueListHead_Component = LeagueListHead_normalizeComponent(
  components_LeagueListHead,
  selectortype_template_index_0_src_components_LeagueListHead,
  LeagueListHead___vue_template_functional__,
  LeagueListHead___vue_styles__,
  LeagueListHead___vue_scopeId__,
  LeagueListHead___vue_module_identifier__
)

/* harmony default export */ var src_components_LeagueListHead = (LeagueListHead_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchList.vue










/* harmony default export */ var matchList = ({
  name: 'app',
  created: function created() {
    this.orgCode = this.$route.query.regionCode;
  },
  data: function data() {
    return {
      leagueId: null,
      leagueName: null,
      showLeagueList: false,
      content: [],
      currentPage: 1,
      step: 5,
      orgCode: '',
      screenWidth: 0,
      loading: true,
      pulldownConfig: {
        downContent: '下拉刷新',
        upContent: '释放后更新',
        loadingContent: 'Loading...'
      },
      pullupConfig: {
        upContent: '上拉加载更多', downContent: '释放后加载'
      },
      status2: {
        pulldownStatus: 'default',
        pullupStatus: 'default'
      }
    };
  },
  components: {
    Badge: vux_src_components_badge,
    Icon: vux_src_components_icon,
    Search: vux_src_components_search,
    Scroller: vux_src_components_scroller,
    Spinner: node_modules_vux_src_components_spinner,
    MatchSimple: src_components_league_matchSimple,
    LeagueListHead: src_components_LeagueListHead
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs.scroller.reset();
      _this2.getData();
      _this2.isUsePullup();
    });
    this.screenWidth = window.innerWidth;
  },

  methods: {
    changeLeague: function changeLeague(leagueId) {
      this.leagueId = leagueId;
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;

      this.loading = true;

      var _this = this;
      this.currentPage = 1;
      var start = (this.currentPage - 1) * this.step;
      _this.content.splice(0, _this.content.length);
      this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {}).then(function (res) {
        if (res.status == true) {
          var data = res.result;
          for (var i = 0; i < data.length; i++) {
            _this.content.push(data[i]);
          }
        }
        _this.$nextTick(function () {
          _this.$refs.scroller.reset({ top: 0 });
          _this.isUsePullup();
        });
        _this3.loading = false;
      }, function (error) {
        _this.isUsePullup();
        console.log(error);
        alert('数据获取失败！');
      });
    },
    pulldown: function pulldown() {
      var _this4 = this;

      var _this = this;
      var start = (_this.currentPage - 1) * _this.step;
      this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {}).then(function (res) {
        if (res.status == true) {
          _this.content.splice(0, _this.content.length);
          if (res.status == true) {
            var data = res.result;
            for (var i = 0; i < data.length; i++) {
              _this.content.push(data[i]);
            }
          }

          _this.$refs.scroller.donePulldown();
          _this.$nextTick(function () {
            _this.$refs.scroller.reset({ top: 0 });
          });
          _this4.currentPage = 1;
        }
        _this.isUsePullup();
      }, function (error) {
        _this.isUsePullup();
        console.log(error);
        alert('数据获取失败！');
      });
    },
    pullup: function pullup() {
      var _this5 = this;

      var _this = this;
      this.currentPage++;
      var start = (_this.currentPage - 1) * _this.step;
      this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {}).then(function (res) {
        if (res.status == true) {
          var data = res.result;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              _this.content.push(data[i]);
            }
          } else {
            _this5.currentPage--;
          }
        }
        _this.$refs.scroller.donePullup();
        _this.$nextTick(function () {
          _this.$refs.scroller.reset();
          _this.isUsePullup();
        });
      }, function (error) {
        _this.$refs.scroller.donePullup();
        _this.$nextTick(function () {
          _this.$refs.scroller.reset();
          _this.isUsePullup();
        });
        console.log(error);
        alert('数据获取失败！');
      });
    },
    isUsePullup: function isUsePullup() {
      if (this.content.length > 4) this.$refs.scroller.enablePullup();else this.$refs.scroller.disablePullup();
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchList.vue










/* harmony default export */ var views_matchList = ({
  name: 'app',
  created: function created() {
    this.orgCode = this.$route.query.regionCode;
  },
  data: function data() {
    return {
      leagueId: null,
      leagueName: null,
      showLeagueList: false,
      content: [],
      currentPage: 1,
      step: 5,
      orgCode: '',
      screenWidth: 0,
      loading: true,
      pulldownConfig: {
        downContent: '下拉刷新',
        upContent: '释放后更新',
        loadingContent: 'Loading...'
      },
      pullupConfig: {
        upContent: '上拉加载更多', downContent: '释放后加载'
      },
      status2: {
        pulldownStatus: 'default',
        pullupStatus: 'default'
      }
    };
  },
  components: {
    Badge: vux_src_components_badge,
    Icon: vux_src_components_icon,
    Search: vux_src_components_search,
    Scroller: vux_src_components_scroller,
    Spinner: node_modules_vux_src_components_spinner,
    MatchSimple: src_components_league_matchSimple,
    LeagueListHead: src_components_LeagueListHead
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs.scroller.reset();
      _this2.getData();
      _this2.isUsePullup();
    });
    this.screenWidth = window.innerWidth;
  },

  methods: {
    changeLeague: function changeLeague(leagueId) {
      this.leagueId = leagueId;
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;

      this.loading = true;

      var _this = this;
      this.currentPage = 1;
      var start = (this.currentPage - 1) * this.step;
      _this.content.splice(0, _this.content.length);
      this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {}).then(function (res) {
        if (res.status == true) {
          var data = res.result;
          for (var i = 0; i < data.length; i++) {
            _this.content.push(data[i]);
          }
        }
        _this.$nextTick(function () {
          _this.$refs.scroller.reset({ top: 0 });
          _this.isUsePullup();
        });
        _this3.loading = false;
      }, function (error) {
        _this.isUsePullup();
        console.log(error);
        alert('数据获取失败！');
      });
    },
    pulldown: function pulldown() {
      var _this4 = this;

      var _this = this;
      var start = (_this.currentPage - 1) * _this.step;
      this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {}).then(function (res) {
        if (res.status == true) {
          _this.content.splice(0, _this.content.length);
          if (res.status == true) {
            var data = res.result;
            for (var i = 0; i < data.length; i++) {
              _this.content.push(data[i]);
            }
          }

          _this.$refs.scroller.donePulldown();
          _this.$nextTick(function () {
            _this.$refs.scroller.reset({ top: 0 });
          });
          _this4.currentPage = 1;
        }
        _this.isUsePullup();
      }, function (error) {
        _this.isUsePullup();
        console.log(error);
        alert('数据获取失败！');
      });
    },
    pullup: function pullup() {
      var _this5 = this;

      var _this = this;
      this.currentPage++;
      var start = (_this.currentPage - 1) * _this.step;
      this.hagkHttp(this.hagkApi.getMatchList(this.orgCode, this.leagueId, start, this.step), {}).then(function (res) {
        if (res.status == true) {
          var data = res.result;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              _this.content.push(data[i]);
            }
          } else {
            _this5.currentPage--;
          }
        }
        _this.$refs.scroller.donePullup();
        _this.$nextTick(function () {
          _this.$refs.scroller.reset();
          _this.isUsePullup();
        });
      }, function (error) {
        _this.$refs.scroller.donePullup();
        _this.$nextTick(function () {
          _this.$refs.scroller.reset();
          _this.isUsePullup();
        });
        console.log(error);
        alert('数据获取失败！');
      });
    },
    isUsePullup: function isUsePullup() {
      if (this.content.length > 4) this.$refs.scroller.enablePullup();else this.$refs.scroller.disablePullup();
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40aa20aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/matchList.vue
var matchList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":"最新赛果"}},[_c('LeagueListHead',{attrs:{"orgCode":_vm.orgCode},on:{"changeLeague":_vm.changeLeague}}),_vm._v(" "),_c('div',{staticClass:"match-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.content.length == 0),expression:"!loading && content.length == 0"}],staticStyle:{"text-align":"center","padding-top":"20px"}},[_vm._v("暂无比赛信息")]),_vm._v(" "),_c('scroller',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.content.length > 0),expression:"!loading && content.length > 0"}],ref:"scroller",attrs:{"lockX":true,"height":"-55","pulldown-config":_vm.pulldownConfig,"pullup-config":_vm.pullupConfig,"use-pullup":true,"use-pulldown":true},on:{"on-pulldown-loading":_vm.pulldown,"on-pullup-loading":_vm.pullup},model:{value:(_vm.status2),callback:function ($$v) {_vm.status2=$$v},expression:"status2"}},[_c('div',[_vm._l((_vm.content),function(item,index){return [_c('div',{staticClass:"match-date"},[_vm._v(_vm._s(item.date))]),_vm._v(" "),_c('div',{staticClass:"match-info"},[_vm._l((item.matches),function(match,index2){return [_c('MatchSimple',{attrs:{"matchInfo":match}})]})],2)]})],2),_vm._v(" "),_c('div',{staticClass:"xs-plugin-pulldown-container xs-plugin-pulldown-down",staticStyle:{"position":"absolute","width":"100%","height":"60px","line-height":"60px","top":"-60px","text-align":"center"},attrs:{"slot":"pulldown"},slot:"pulldown"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pulldownStatus === 'default'),expression:"status2.pulldownStatus === 'default'"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pulldownStatus === 'down' || _vm.status2.pulldownStatus === 'up'),expression:"status2.pulldownStatus === 'down' || status2.pulldownStatus === 'up'"}],staticClass:"pulldown-arrow",class:{'rotate': _vm.status2.pulldownStatus === 'up'}},[_vm._v("↓")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pulldownStatus === 'loading'),expression:"status2.pulldownStatus === 'loading'"}]},[_c('spinner',{attrs:{"type":"ios-small"}})],1)]),_vm._v(" "),_c('div',{staticClass:"xs-plugin-pullup-container xs-plugin-pullup-up",staticStyle:{"position":"absolute","width":"100%","height":"60px","bottom":"-100px","text-align":"center"},attrs:{"slot":"pullup"},slot:"pullup"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pullupStatus === 'default'),expression:"status2.pullupStatus === 'default'"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pullupStatus === 'default' || _vm.status2.pullupStatus === 'up' || _vm.status2.pullupStatus === 'down'),expression:"status2.pullupStatus === 'default' || status2.pullupStatus === 'up' || status2.pullupStatus === 'down'"}],staticClass:"pullup-arrow",class:{'rotate': _vm.status2.pullupStatus === 'down'}},[_vm._v("↑")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.status2.pullupStatus === 'loading'),expression:"status2.pullupStatus === 'loading'"}]},[_c('spinner',{attrs:{"type":"ios-small"}})],1)])])],1)],1)}
var matchList_staticRenderFns = []
var matchList_esExports = { render: matchList_render, staticRenderFns: matchList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_matchList = (matchList_esExports);
// CONCATENATED MODULE: ./src/views/matchList.vue
function matchList_injectStyle (ssrContext) {
  __webpack_require__("ltKL")
}
var matchList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchList___vue_template_functional__ = false
/* styles */
var matchList___vue_styles__ = matchList_injectStyle
/* scopeId */
var matchList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var matchList___vue_module_identifier__ = null
var matchList_Component = matchList_normalizeComponent(
  views_matchList,
  selectortype_template_index_0_src_views_matchList,
  matchList___vue_template_functional__,
  matchList___vue_styles__,
  matchList___vue_scopeId__,
  matchList___vue_module_identifier__
)

/* harmony default export */ var src_views_matchList = (matchList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchInfoShare.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var matchInfoShare = ({
	created: function created() {
		this.matchId = this.$route.query.matchId;
		this.screenHeight = window.innerHeight;
	},
	data: function data() {
		return {
			matchId: '',
			referee: null,
			assistantReferee1: null,
			assistantReferee2: null,
			fourthOfficial: null,
			matchSupervisor: null,
			leagueName: null,
			homeTeamName: null,
			vistingTeamName: null,
			location: null,
			time: null,
			screenHeight: 800,
			backgroundImg: __webpack_require__("hcFw")
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {}).then(function (res) {
			if (res) {
				_this.referee = res.referee;
				_this.assistantReferee1 = res.assistantReferee1;
				_this.assistantReferee2 = res.assistantReferee2;
				_this.fourthOfficial = res.fourthOfficial;
				_this.matchSupervisor = res.matchSupervisor;
				_this.leagueName = res.leagueName;
				_this.homeTeamName = res.homeTeamName;
				_this.vistingTeamName = res.vistingTeamName;
				_this.location = res.location;
				var timeStr = res.time;
				if (res.time != null && res.time.length > 15) {
					var year = res.time.substring(0, 4);
					var month = res.time.substring(5, 7);
					var day = res.time.substring(8, 10);
					var hour = res.time.substring(11, 16);
					_this.time = year + "." + month + "." + day + " " + hour;
				}
			}

			document.title = "比赛预告";
			var realPath = window.location.href;
			/*var fullPath;
   if(realPath.indexOf('from=') == -1){
   	fullPath = realPath + '&from=singlemessage';
   } else {
   	fullPath = realPath;
   }*/
			// var fullPath=realPath.replace("&from=singlemessage","");
			//var fullPath = realPath.substring(0,realPath.indexOf('/match_info'))+'/match_info_share?matchId='+this.matchId;
			var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
			var title = _this.leagueName;
			var desc = "主队：" + _this.homeTeamName + '\r\n客队：' + _this.vistingTeamName;

			utils_wxShareConfig({
				title: title,
				desc: desc,
				link: realPath,
				imgUrl: shareImg,
				type: 'link',
				dataUrl: ''
			}, function () {}, function () {});
		}, function (error) {
			console.log(error);
			window.alert('比赛信息获取失败！');
		});
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/matchInfoShare.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var views_matchInfoShare = ({
	created: function created() {
		this.matchId = this.$route.query.matchId;
		this.screenHeight = window.innerHeight;
	},
	data: function data() {
		return {
			matchId: '',
			referee: null,
			assistantReferee1: null,
			assistantReferee2: null,
			fourthOfficial: null,
			matchSupervisor: null,
			leagueName: null,
			homeTeamName: null,
			vistingTeamName: null,
			location: null,
			time: null,
			screenHeight: 800,
			backgroundImg: __webpack_require__("hcFw")
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {}).then(function (res) {
			if (res) {
				_this.referee = res.referee;
				_this.assistantReferee1 = res.assistantReferee1;
				_this.assistantReferee2 = res.assistantReferee2;
				_this.fourthOfficial = res.fourthOfficial;
				_this.matchSupervisor = res.matchSupervisor;
				_this.leagueName = res.leagueName;
				_this.homeTeamName = res.homeTeamName;
				_this.vistingTeamName = res.vistingTeamName;
				_this.location = res.location;
				var timeStr = res.time;
				if (res.time != null && res.time.length > 15) {
					var year = res.time.substring(0, 4);
					var month = res.time.substring(5, 7);
					var day = res.time.substring(8, 10);
					var hour = res.time.substring(11, 16);
					_this.time = year + "." + month + "." + day + " " + hour;
				}
			}

			document.title = "比赛预告";
			var realPath = window.location.href;
			/*var fullPath;
   if(realPath.indexOf('from=') == -1){
   	fullPath = realPath + '&from=singlemessage';
   } else {
   	fullPath = realPath;
   }*/
			// var fullPath=realPath.replace("&from=singlemessage","");
			//var fullPath = realPath.substring(0,realPath.indexOf('/match_info'))+'/match_info_share?matchId='+this.matchId;
			var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
			var title = _this.leagueName;
			var desc = "主队：" + _this.homeTeamName + '\r\n客队：' + _this.vistingTeamName;

			utils_wxShareConfig({
				title: title,
				desc: desc,
				link: realPath,
				imgUrl: shareImg,
				type: 'link',
				dataUrl: ''
			}, function () {}, function () {});
		}, function (error) {
			console.log(error);
			window.alert('比赛信息获取失败！');
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d538718a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/matchInfoShare.vue
var matchInfoShare_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#333333","width":"100%"},style:({height: _vm.screenHeight+'px'}),attrs:{"id":"share_body"}},[_c('div',{staticClass:"outer",staticStyle:{"height":"100%","margin":"15px 13px 0 13px","position":"fixed","background-repeat":"no-repeat","background-size":"contain"},style:({backgroundImage: 'url('+_vm.backgroundImg+')'})},[_c('div',{staticClass:"center",staticStyle:{"height":"50%","margin":"11px 9px 9px 10px"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"20px","color":"#FFFFFF","text-align":"center","top":"12%","position":"fixed","left":"25px","right":"25px"}},[_vm._v(_vm._s(_vm.leagueName))]),_vm._v(" "),_c('div',{staticClass:"center-inner",staticStyle:{"margin-top":"100px","height":"100px"}},[_c('div',{staticClass:"center-inner",staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#FFFFFF","float":"left","width":"35%","text-align":"right","height":"100%","padding-left":"10px"}},[_c('p',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm.homeTeamName))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"center-inner",staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#FFFFFF","float":"left","width":"35%","text-align":"left","height":"100%","padding-right":"10px"}},[_c('p',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.vistingTeamName))])])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","bottom":"5%","line-height":"20px","margin-left":"21px"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#FFFFFF"}},[_vm._v("地点／Place        "+_vm._s(_vm.location))]),_vm._v(" "),_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#FFFFFF","margin-top":"10px"}},[_vm._v("时间／Time        "+_vm._s(_vm.time))])])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"15px 15px 26px 15px","position":"fixed","top":"60%"},attrs:{"id":"refereeInfo"}},[_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"40px","position":"fixed","left":"30px","right":"30px"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Medium","color":"#FE2754","line-height":"20px","width":"50%","float":"left"}},[_vm._v(_vm._s(_vm.referee == null ? '— —' : _vm.referee))]),_vm._v(" "),_c('div',{staticStyle:{"font-family":"PingFangSC-Medium","color":"#FE2754","line-height":"20px","width":"50%","float":"left"}},[_vm._v(_vm._s(_vm.assistantReferee1 == null ? '— —' : _vm.assistantReferee1))])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"100px","position":"fixed","left":"30px","right":"30px"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Medium","color":"#FE2754","line-height":"20px","width":"50%","float":"left"}},[_vm._v(_vm._s(_vm.assistantReferee2 == null ? '— —' : _vm.assistantReferee2))]),_vm._v(" "),_c('div',{staticStyle:{"font-family":"PingFangSC-Medium","color":"#FE2754","line-height":"20px","width":"50%","float":"left"}},[_vm._v(_vm._s(_vm.fourthOfficial == null ? '— —' : _vm.fourthOfficial))])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"160px","position":"fixed","left":"30px","right":"30px"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Medium","font-size":"14px","color":"#FE2754","line-height":"20px","width":"100%","float":"left"}},[_vm._v(_vm._s(_vm.matchSupervisor == null ? '— —' : _vm.matchSupervisor))])])])])])}
var matchInfoShare_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-inner",staticStyle:{"font-family":"Arial-Black","font-size":"36px","color":"#299AFE","float":"left","width":"30%","text-align":"center","height":"100%"}},[_c('p',[_vm._v("VS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"20px","position":"fixed","left":"30px","right":"30px"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","color":"#999999","line-height":"20px","width":"50%","float":"left"}},[_vm._v("主裁判／Chief Official")]),_vm._v(" "),_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","color":"#999999","line-height":"20px","width":"50%","float":"left"}},[_vm._v("第一助理／First Aid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"80px","position":"fixed","left":"30px","right":"30px"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","color":"#999999","line-height":"20px","width":"50%","float":"left"}},[_vm._v("第二助理／Second Aid")]),_vm._v(" "),_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","color":"#999999","line-height":"20px","width":"50%","float":"left"}},[_vm._v("第四官员／Officer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"140px","position":"fixed","left":"30px","right":"30px"}},[_c('div',{staticStyle:{"font-family":"PingFangSC-Regular","font-size":"14px","color":"#999999","line-height":"20px","width":"100%","float":"left"}},[_vm._v("比赛监督／Competition supervision")])])}]
var matchInfoShare_esExports = { render: matchInfoShare_render, staticRenderFns: matchInfoShare_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_matchInfoShare = (matchInfoShare_esExports);
// CONCATENATED MODULE: ./src/views/matchInfoShare.vue
function matchInfoShare_injectStyle (ssrContext) {
  __webpack_require__("NQdJ")
}
var matchInfoShare_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var matchInfoShare___vue_template_functional__ = false
/* styles */
var matchInfoShare___vue_styles__ = matchInfoShare_injectStyle
/* scopeId */
var matchInfoShare___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var matchInfoShare___vue_module_identifier__ = null
var matchInfoShare_Component = matchInfoShare_normalizeComponent(
  views_matchInfoShare,
  selectortype_template_index_0_src_views_matchInfoShare,
  matchInfoShare___vue_template_functional__,
  matchInfoShare___vue_styles__,
  matchInfoShare___vue_scopeId__,
  matchInfoShare___vue_module_identifier__
)

/* harmony default export */ var src_views_matchInfoShare = (matchInfoShare_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js + 1 modules
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/bus/index.js
var bus = __webpack_require__("Sga9");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/device/index.js
var device = __webpack_require__("M10M");

// CONCATENATED MODULE: ./src/main.js


__webpack_require__("o7Oz");
__webpack_require__("i50b");
__webpack_require__("Kukd");
__webpack_require__("XNnq");
__webpack_require__("F/hE");
__webpack_require__("uPo7");








































vue_esm["a" /* default */].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  }
});

vue_esm["a" /* default */].use(device["a" /* default */]);
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(bus["a" /* default */]);

vue_esm["a" /* default */].prototype.hagkApi = api;
vue_esm["a" /* default */].prototype.hagkHttp = http;

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: '/',
  component: src_views_welcome
}, {
  path: '/welcome',
  component: src_views_welcome
}, {
  path: '/index_region',
  component: src_views_index_region
}, {
  path: '/league_ongoing',
  component: src_views_leagueOngoing,
  children: [{
    path: '/league_ongoing/arrange',
    component: src_views_leagueOngoing_arrange
  }, {
    path: '/league_ongoing/jifen',
    component: src_views_leagueOngoingJifen
  }, {
    path: '/league_ongoing/shooters',
    component: src_views_leagueShooters
  }, {
    path: '/league_ongoing/data',
    component: src_views_leagueData
  }, {
    path: '/league_ongoing/moments',
    component: src_views_leagueMoments
  }]
}, {
  path: '/round_report',
  component: src_views_round_report
}, {
  path: '/moment_list',
  component: src_views_momentList
}, {
  path: '/public_index',
  component: src_views_public_index
}, {
  path: '/home',
  component: src_main
}, {
  path: '/league_info',
  component: src_views_LeagueInfo
}, {
  path: '/live_player',
  component: src_views_live_player
}, {
  path: '/league_list',
  component: src_views_leagueList
}, {
  path: '/match_info',
  component: src_views_matchInfo
}, {
  path: '/match_list',
  component: src_views_matchList
}, {
  path: '/match_info_share',
  component: src_views_matchInfoShare
}, {
  path: '*',
  component: src_views_welcome
}];

var main_router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_configInfo.routerBase,
  routes: routes
});

main_router.beforeEach(function (to, from, next) {
  console.log(from.fullPath);
  console.log(to.fullPath);
  if (from.path == '/league_info') {
    to.query.orgCode = from.query.orgCode;
    to.query.orgName = from.query.orgName;
  }
  if (to.path == '/league_list' && from.path == '/league_ongoing') {
    to.query.orgCode = src_configInfo.orgCode;
    to.query.orgName = src_configInfo.orgName;
  }
  if (to.path == '/index_region' && from.path == '/league_list') {
    to.query.regionCode = src_configInfo.orgCode;
    to.query.regionName = src_configInfo.orgName;
  }
  next();
});

main_router.afterEach(function (to, from, next) {

  var publicShare = true;
  if (to.fullPath.indexOf('public_index') >= 0) {
    publicShare = false;
  } else if (to.fullPath.indexOf('index_region') >= 0) {
    publicShare = false;
  } else if (to.fullPath.indexOf('league_ongoing') >= 0) {
    publicShare = false;
  } else if (to.fullPath.indexOf('match_info') >= 0) {
    publicShare = false;
  } else if (to.fullPath.indexOf('round_report') >= 0) {
    publicShare = false;
  } else if (to.fullPath.indexOf('league_list') >= 0) {
    publicShare = false;
  }
  if (publicShare) {
    console.log("toPath:" + to.fullPath);
    var fullPath = window.location.origin + src_configInfo.routerBase.substr(0, src_configInfo.routerBase.length - 1) + to.fullPath;
    fullPath = fullPath.replace("&from=singlemessage", "");
    var shareImg = window.location.origin + src_configInfo.routerBase + "static/logo.png";
    utils_wxShareConfig({
      title: '赛事系统',
      desc: '来自未来足球赛事系统微信端',
      link: fullPath,
      imgUrl: shareImg,
      type: 'link',
      dataUrl: ''
    }, function () {}, function () {});
  }
});

var FastClick = __webpack_require__("v5o6");
FastClick.attach(document.body);

var notNeed = FastClick.notNeeded(document.body);
external__Zepto__default.a.fn.triggerFastClick = function () {
  console.log("triger 1");
  this.trigger("click");
  if (!notNeed) {
    console.log("triger 2");
    this.trigger("click");
  }
};

vue_esm["a" /* default */].config.productionTip = false;

var app = new vue_esm["a" /* default */]({
  store: store,
  router: main_router,
  created: function created() {

    var fullPath = window.location.href;
    fullPath = fullPath.replace("&from=singlemessage", "");
    fullPath = fullPath.replace("from=singlemessage", "");
    if (window.location.href.indexOf('from=singlemessage') > -1) {
      window.location.href = fullPath;
    } else {
      store.commit('updateLandingUrl', fullPath);
      console.log(this.$route.fullPath);

      if ("/" != this.$route.fullPath) {
        window.history.pushState({ page: "landing" }, null, main_router.base);
        var that = this;
        window.addEventListener("popstate", function (event) {
          if (event.state == null) {
            that.$router.replace("/welcome");
          }
        }, false);
        this.$router.push(this.$route.fullPath);
      }
    }
  },

  methods: {},
  render: function render(h) {
    return h(src_main);
  }
}).$mount('#app-box');

/***/ }),

/***/ "NQdJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O22B":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "OEKn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P7KP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PPGu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";

/***/ }),

/***/ "Q1oX":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTTkxMC4yMjIyMjIgNzk2LjQ0NDQ0NGMtMTcuMDY2NjY3IDAtMzQuMTMzMzMzLTUuNjg4ODg5LTQ1LjUxMTExMS0xNy4wNjY2NjZMNTUxLjgyMjIyMiA0MDkuNmMtMTEuMzc3Nzc4LTUuNjg4ODg5LTE3LjA2NjY2Ny0xMS4zNzc3NzgtMzQuMTMzMzMzLTExLjM3Nzc3OC01LjY4ODg4OSAwLTIyLjc1NTU1NiA1LjY4ODg4OS0yOC40NDQ0NDUgMTEuMzc3Nzc4bC0zMjkuOTU1NTU1IDM2NC4wODg4ODljLTIyLjc1NTU1NiAyMi43NTU1NTYtNTYuODg4ODg5IDIyLjc1NTU1Ni03OS42NDQ0NDUgNS42ODg4ODktMjIuNzU1NTU2LTIyLjc1NTU1Ni0yMi43NTU1NTYtNTYuODg4ODg5LTUuNjg4ODg4LTc5LjY0NDQ0NWwzMjkuOTU1NTU1LTM2NC4wODg4ODljMjguNDQ0NDQ0LTM0LjEzMzMzMyA3My45NTU1NTYtNTEuMiAxMTkuNDY2NjY3LTUxLjJzODUuMzMzMzMzIDIyLjc1NTU1NiAxMTkuNDY2NjY2IDU2Ljg4ODg4OWwzMTIuODg4ODg5IDM2NC4wODg4ODljMjIuNzU1NTU2IDIyLjc1NTU1NiAxNy4wNjY2NjcgNTYuODg4ODg5LTUuNjg4ODg5IDc5LjY0NDQ0NS0xMS4zNzc3NzggNS42ODg4ODktMjguNDQ0NDQ0IDExLjM3Nzc3OC0zOS44MjIyMjIgMTEuMzc3Nzc3eiIgLz48L3N2Zz4="

/***/ }),

/***/ "Q1vY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QhYL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "QlJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SIJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UKSC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Uuy1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VNhC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/PingFang-Medium.45cac8d.ttf";

/***/ }),

/***/ "VyGl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZDK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WcVR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAAAAXNSR0IArs4c6QAABFtJREFUWAm9lz1rVUEQhu9NUhirpNSghYK/ICgkhaSwszDWSWNaxcLfoClEUBD75AeYFFYxJFgoaLRUsBNEERsFC8Eo1+fds3N39nzknFyiA3NnduadmT37fXu9SIPB4L3pY6YgX0rHORjziAi4EWUSQoaWFOi6foZu9Gl4d4gwD8ZJ05PE+ja1er2+GhiVcBU+rnYgGaFl134rgzlV1TvXDSgp4ATycb/fX3COvhxqY1fpVV//OLafDqwsm7Q/eJuMa/APeClzqIFxCy46WbTVT9GU/BMo88jpWD90NOrWt34wCm2kcNMlae77CfU+r0/UgpQNOmZIjVNG1jcZAY4jdgNAYUEp/WR2RcgAbcNX4X01SjGpiW9egBZ6niJKGoFh0JF73kVbY3q1ZJvBZqRvK8gs1vYS37r83mY65hX5oEWNViNQAR38GrOB5u2KVRhRPgpxJFtWRigswHIy7GfhL44/egz2NHs0nsOiGQ9q08GrQD5+tKdkjLTSlAS/1lNIgHzXhAt2AItw6DKyTDsHBpedRC/Bu7B2+3tYO3+6jGtsA7bxQm0kHQj1RIgfI51/lVnEZjOsCluVTBhtQwqQzRxtbdBwClog7T1YlCcrbOG3crJHX3YIKyF2S1Z8JgbNkKh2ygvXoJIoJgvu0FO0tDKDJf9pSWRjNq0uirbz8NQq3PU9Esr8dthuptCRtAuW6PNI4SnohCWaTbZazcZCX5Lt/oh+Y9+4XxuOkcAXsD9GbhsWuy3iJQF3YNG4AbpKYtILQEEhDVW7JogxdgGkG4VE92OyjS7JwE5GfH6oxQrvolPj0fiZ+OzmELyysUNHcFjPBNKKvwNr0+odFm4LpFFjseFXgbQJsCCTSr44BI6iKAGsAmFvIruQsIrpXDw7r3xHSaIhuAff9Pao/0Y+g1/B2l22w06ii8/DF+HKkwjbA/gWT6M/yHaiI1r0thBQA2lBaNLb56lUQjEx1m5CmoFUo37xWA4AfhEpagOuHOKGl8R/Q8BI1b8FDgxG22HTwFHed5Ck4vSXor4mu5ISMtfAhbdVTF57QeQR4SNmwPsRG276cDji1JtgLgbqcTHDHH8qJzqqdsytD7aHzFzsQ0//xvSHZiEW02Kd77zgYtAoItbQ/ayaogX1RSN0LTSLn7sAv7v2P1VjrbuuyDV1yN9lr53zf6m+5qzOCZ0h52J1nSGHJX+WnYlLwOf4RWOX0fjqjU73NT9r2+qNatT4qHEJMpXAhxbcIk9ngbFBjL+T1tQh/QP218HwX3tdgqO0Udc/bdSH4vGOYo9Q1EArR1m4LhdV/HWvovl9h2FeVkd6Oh94StcVarMpJ2zPciun7V8lvLp37P+1gRXc6dSuZkwW5YDLHVGt9vsRkC7YcscwhUei5v3gS5F+CAMLGx6WSE/K3ZojfY7TCNRU+nvOJz6Mrhz1U+Pq+TPEmZtVkmonXIYvwadgnSN2ltjb6CO2p/ATzp9vyM70F6+nCTby1YvtAAAAAElFTkSuQmCC"

/***/ }),

/***/ "XNnq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("sEqb");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./bootstrap.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./bootstrap.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XdJ7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACjUlEQVRoge2ZzZHiMBCFHQIh+DLQuk0GkAFkMM5gyAAyWDJYMvBkgDNg7mqXQoAE1G8PYkCWfxgWDIZyV+kk2X6f1OpuyVH0ykYGY2J8UI7FQxrjgwzGF4mODQaUY6FYdooFHWk7yrGIDQZnxSst2w4Irm5atrUQdeJJS6bYrkjb5T2b+6Z8/xrCPVQUTgbxRf7XgpFBHIKQtsvSQN/nSUt2d6VnLIDYBZ2YFAg7MPOhkUFcXAVMTp2MxOv8alPESGPqopxdlfq1ZMSyIbZ/CwJP/cdVGDJmXsfJ/0P/IkbiXiqbN4P3/xZfsceqAJp8XbFdVfY1AhT6yrMSQhLLRmnZtgFQq/NqgECcYsFLAxxzS46Fv3KnPOBAWgMgjYmfTJoAYoPBSGOqcsz9CQgjXzhBZBCHe+6GAMelTt0s2jVpyVwUsevDMymxmPr3NgNUWRsAtZmxLO4FAYhlf1w5LRkxku4CsF2PNKZK2z9uwzZEIS3bUY7PsCK4GUBsMCBGcsic+yqAY6RhJK4g63gYJZaN8grCqjGdBrgkDzw1AGn5/gm1fulBLMaVJEic65Vd83abmJH4SaYJgAzGlGOhcsyLye98GG1tE/vRQrGk4XFwyJiFx9OXzANPDfBm8O6XHqTt8txJ8GYAiuXr8kTWnGV/YzeNQs4F7Iq0ZCrHvPQxtmuVY37NKa5VgEdYD9ADXGk9QA9wpfUAPcCV9vQA9Ze7DdfrXQLwq+Dgev3Jf3BEURQRy94bkD5GZr0dbj0OpbnsywPK59q0CytBBrEvvu784S6rqn5r/lzgPqAplrR8spPvxn/FNRCdaI3iixB2GeyJxwo/3BGdFV/yP43JkDELr03u1dy3Hxu6W7d/aPp/x2QFhjQAAAAASUVORK5CYII="

/***/ }),

/***/ "XzI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y43i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YAkp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Yshg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZKQ2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ZRSg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZkhM":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".video-js .vjs-big-play-button .vjs-icon-placeholder:before, .vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-modal-dialog, .vjs-modal-dialog .vjs-modal-dialog-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.video-js .vjs-big-play-button .vjs-icon-placeholder:before, .vjs-button > .vjs-icon-placeholder:before {\n  text-align: center; }\n\n@font-face {\n  font-family: VideoJS;\n  src: url(" + escape(__webpack_require__("Bta1")) + "?#iefix) format(\"eot\"); }\n\n@font-face {\n  font-family: VideoJS;\n  src: url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\"), url(data:application/x-font-ttf;charset=utf-8;base64,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) format(\"truetype\");\n  font-weight: normal;\n  font-style: normal; }\n\n.vjs-icon-play, .video-js .vjs-big-play-button .vjs-icon-placeholder:before, .video-js .vjs-play-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-play:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before, .video-js .vjs-play-control .vjs-icon-placeholder:before {\n    content: \"\\F101\"; }\n\n.vjs-icon-play-circle {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-play-circle:before {\n    content: \"\\F102\"; }\n\n.vjs-icon-pause, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-pause:before, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {\n    content: \"\\F103\"; }\n\n.vjs-icon-volume-mute, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-volume-mute:before, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before {\n    content: \"\\F104\"; }\n\n.vjs-icon-volume-low, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-volume-low:before, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before {\n    content: \"\\F105\"; }\n\n.vjs-icon-volume-mid, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-volume-mid:before, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before {\n    content: \"\\F106\"; }\n\n.vjs-icon-volume-high, .video-js .vjs-mute-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-volume-high:before, .video-js .vjs-mute-control .vjs-icon-placeholder:before {\n    content: \"\\F107\"; }\n\n.vjs-icon-fullscreen-enter, .video-js .vjs-fullscreen-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-fullscreen-enter:before, .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {\n    content: \"\\F108\"; }\n\n.vjs-icon-fullscreen-exit, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-fullscreen-exit:before, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before {\n    content: \"\\F109\"; }\n\n.vjs-icon-square {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-square:before {\n    content: \"\\F10A\"; }\n\n.vjs-icon-spinner {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-spinner:before {\n    content: \"\\F10B\"; }\n\n.vjs-icon-subtitles, .video-js .vjs-subtitles-button .vjs-icon-placeholder, .video-js .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-subtitles:before, .video-js .vjs-subtitles-button .vjs-icon-placeholder:before, .video-js .vjs-subs-caps-button .vjs-icon-placeholder:before,\n  .video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n  .video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n  .video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n  .video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before {\n    content: \"\\F10C\"; }\n\n.vjs-icon-captions, .video-js .vjs-captions-button .vjs-icon-placeholder, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-captions:before, .video-js .vjs-captions-button .vjs-icon-placeholder:before, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n  .video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before {\n    content: \"\\F10D\"; }\n\n.vjs-icon-chapters, .video-js .vjs-chapters-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-chapters:before, .video-js .vjs-chapters-button .vjs-icon-placeholder:before {\n    content: \"\\F10E\"; }\n\n.vjs-icon-share {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-share:before {\n    content: \"\\F10F\"; }\n\n.vjs-icon-cog {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-cog:before {\n    content: \"\\F110\"; }\n\n.vjs-icon-circle, .video-js .vjs-play-progress, .video-js .vjs-volume-level {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-circle:before, .video-js .vjs-play-progress:before, .video-js .vjs-volume-level:before {\n    content: \"\\F111\"; }\n\n.vjs-icon-circle-outline {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-circle-outline:before {\n    content: \"\\F112\"; }\n\n.vjs-icon-circle-inner-circle {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-circle-inner-circle:before {\n    content: \"\\F113\"; }\n\n.vjs-icon-hd {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-hd:before {\n    content: \"\\F114\"; }\n\n.vjs-icon-cancel, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-cancel:before, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before {\n    content: \"\\F115\"; }\n\n.vjs-icon-replay, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-replay:before, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before {\n    content: \"\\F116\"; }\n\n.vjs-icon-facebook {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-facebook:before {\n    content: \"\\F117\"; }\n\n.vjs-icon-gplus {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-gplus:before {\n    content: \"\\F118\"; }\n\n.vjs-icon-linkedin {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-linkedin:before {\n    content: \"\\F119\"; }\n\n.vjs-icon-twitter {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-twitter:before {\n    content: \"\\F11A\"; }\n\n.vjs-icon-tumblr {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-tumblr:before {\n    content: \"\\F11B\"; }\n\n.vjs-icon-pinterest {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-pinterest:before {\n    content: \"\\F11C\"; }\n\n.vjs-icon-audio-description, .video-js .vjs-descriptions-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-audio-description:before, .video-js .vjs-descriptions-button .vjs-icon-placeholder:before {\n    content: \"\\F11D\"; }\n\n.vjs-icon-audio, .video-js .vjs-audio-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-audio:before, .video-js .vjs-audio-button .vjs-icon-placeholder:before {\n    content: \"\\F11E\"; }\n\n.vjs-icon-next-item {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-next-item:before {\n    content: \"\\F11F\"; }\n\n.vjs-icon-previous-item {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal; }\n  .vjs-icon-previous-item:before {\n    content: \"\\F120\"; }\n\n.video-js {\n  display: block;\n  vertical-align: top;\n  box-sizing: border-box;\n  color: #fff;\n  background-color: #000;\n  position: relative;\n  padding: 0;\n  font-size: 10px;\n  line-height: 1;\n  font-weight: normal;\n  font-style: normal;\n  font-family: Arial, Helvetica, sans-serif;\n  word-break: initial; }\n  .video-js:-moz-full-screen {\n    position: absolute; }\n  .video-js:-webkit-full-screen {\n    width: 100% !important;\n    height: 100% !important; }\n\n.video-js[tabindex=\"-1\"] {\n  outline: none; }\n\n.video-js *,\n.video-js *:before,\n.video-js *:after {\n  box-sizing: inherit; }\n\n.video-js ul {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  list-style-position: outside;\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  margin-bottom: 0; }\n\n.video-js.vjs-fluid,\n.video-js.vjs-16-9,\n.video-js.vjs-4-3 {\n  width: 100%;\n  max-width: 100%;\n  height: 0; }\n\n.video-js.vjs-16-9 {\n  padding-top: 56.25%; }\n\n.video-js.vjs-4-3 {\n  padding-top: 75%; }\n\n.video-js.vjs-fill {\n  width: 100%;\n  height: 100%; }\n\n.video-js .vjs-tech {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\nbody.vjs-full-window {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n  overflow-y: auto; }\n\n.vjs-full-window .video-js.vjs-fullscreen {\n  position: fixed;\n  overflow: hidden;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0; }\n\n.video-js.vjs-fullscreen {\n  width: 100% !important;\n  height: 100% !important;\n  padding-top: 0 !important; }\n\n.video-js.vjs-fullscreen.vjs-user-inactive {\n  cursor: none; }\n\n.vjs-hidden {\n  display: none !important; }\n\n.vjs-disabled {\n  opacity: 0.5;\n  cursor: default; }\n\n.video-js .vjs-offscreen {\n  height: 1px;\n  left: -9999px;\n  position: absolute;\n  top: 0;\n  width: 1px; }\n\n.vjs-lock-showing {\n  display: block !important;\n  opacity: 1;\n  visibility: visible; }\n\n.vjs-no-js {\n  padding: 20px;\n  color: #fff;\n  background-color: #000;\n  font-size: 18px;\n  font-family: Arial, Helvetica, sans-serif;\n  text-align: center;\n  width: 300px;\n  height: 150px;\n  margin: 0px auto; }\n\n.vjs-no-js a,\n.vjs-no-js a:visited {\n  color: #66A8CC; }\n\n.video-js .vjs-big-play-button {\n  font-size: 3em;\n  line-height: 1.5em;\n  height: 1.5em;\n  width: 3em;\n  display: block;\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  padding: 0;\n  cursor: pointer;\n  opacity: 1;\n  border: 0.06666em solid #fff;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n  -webkit-border-radius: 0.3em;\n  -moz-border-radius: 0.3em;\n  border-radius: 0.3em;\n  -webkit-transition: all 0.4s;\n  -moz-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  -o-transition: all 0.4s;\n  transition: all 0.4s; }\n\n.vjs-big-play-centered .vjs-big-play-button {\n  top: 50%;\n  left: 50%;\n  margin-top: -0.75em;\n  margin-left: -1.5em; }\n\n.video-js:hover .vjs-big-play-button,\n.video-js .vjs-big-play-button:focus {\n  border-color: #fff;\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5);\n  -webkit-transition: all 0s;\n  -moz-transition: all 0s;\n  -ms-transition: all 0s;\n  -o-transition: all 0s;\n  transition: all 0s; }\n\n.vjs-controls-disabled .vjs-big-play-button,\n.vjs-has-started .vjs-big-play-button,\n.vjs-using-native-controls .vjs-big-play-button,\n.vjs-error .vjs-big-play-button {\n  display: none; }\n\n.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause .vjs-big-play-button {\n  display: block; }\n\n.video-js button {\n  background: none;\n  border: none;\n  color: inherit;\n  display: inline-block;\n  overflow: visible;\n  font-size: inherit;\n  line-height: inherit;\n  text-transform: none;\n  text-decoration: none;\n  transition: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none; }\n\n.vjs-control .vjs-button {\n  width: 100%;\n  height: 100%; }\n\n.video-js .vjs-control.vjs-close-button {\n  cursor: pointer;\n  height: 3em;\n  position: absolute;\n  right: 0;\n  top: 0.5em;\n  z-index: 2; }\n\n.video-js .vjs-modal-dialog {\n  background: rgba(0, 0, 0, 0.8);\n  background: -webkit-linear-gradient(-90deg, rgba(0, 0, 0, 0.8), rgba(255, 255, 255, 0));\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(255, 255, 255, 0));\n  overflow: auto;\n  box-sizing: content-box; }\n\n.video-js .vjs-modal-dialog > * {\n  box-sizing: border-box; }\n\n.vjs-modal-dialog .vjs-modal-dialog-content {\n  font-size: 1.2em;\n  line-height: 1.5;\n  padding: 20px 24px;\n  z-index: 1; }\n\n.vjs-menu-button {\n  cursor: pointer; }\n\n.vjs-menu-button.vjs-disabled {\n  cursor: default; }\n\n.vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu {\n  display: none; }\n\n.vjs-menu .vjs-menu-content {\n  display: block;\n  padding: 0;\n  margin: 0;\n  font-family: Arial, Helvetica, sans-serif;\n  overflow: auto;\n  box-sizing: content-box; }\n\n.vjs-menu .vjs-menu-content > * {\n  box-sizing: border-box; }\n\n.vjs-scrubbing .vjs-menu-button:hover .vjs-menu {\n  display: none; }\n\n.vjs-menu li {\n  list-style: none;\n  margin: 0;\n  padding: 0.2em 0;\n  line-height: 1.4em;\n  font-size: 1.2em;\n  text-align: center;\n  text-transform: lowercase; }\n\n.vjs-menu li.vjs-menu-item:focus,\n.vjs-menu li.vjs-menu-item:hover {\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5); }\n\n.vjs-menu li.vjs-selected,\n.vjs-menu li.vjs-selected:focus,\n.vjs-menu li.vjs-selected:hover {\n  background-color: #fff;\n  color: #2B333F; }\n\n.vjs-menu li.vjs-menu-title {\n  text-align: center;\n  text-transform: uppercase;\n  font-size: 1em;\n  line-height: 2em;\n  padding: 0;\n  margin: 0 0 0.3em 0;\n  font-weight: bold;\n  cursor: default; }\n\n.vjs-menu-button-popup .vjs-menu {\n  display: none;\n  position: absolute;\n  bottom: 0;\n  width: 10em;\n  left: -3em;\n  height: 0em;\n  margin-bottom: 1.5em;\n  border-top-color: rgba(43, 51, 63, 0.7); }\n\n.vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n  position: absolute;\n  width: 100%;\n  bottom: 1.5em;\n  max-height: 15em; }\n\n.vjs-workinghover .vjs-menu-button-popup:hover .vjs-menu,\n.vjs-menu-button-popup .vjs-menu.vjs-lock-showing {\n  display: block; }\n\n.video-js .vjs-menu-button-inline {\n  -webkit-transition: all 0.4s;\n  -moz-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  -o-transition: all 0.4s;\n  transition: all 0.4s;\n  overflow: hidden; }\n\n.video-js .vjs-menu-button-inline:before {\n  width: 2.222222222em; }\n\n.video-js .vjs-menu-button-inline:hover,\n.video-js .vjs-menu-button-inline:focus,\n.video-js .vjs-menu-button-inline.vjs-slider-active,\n.video-js.vjs-no-flex .vjs-menu-button-inline {\n  width: 12em; }\n\n.vjs-menu-button-inline .vjs-menu {\n  opacity: 0;\n  height: 100%;\n  width: auto;\n  position: absolute;\n  left: 4em;\n  top: 0;\n  padding: 0;\n  margin: 0;\n  -webkit-transition: all 0.4s;\n  -moz-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  -o-transition: all 0.4s;\n  transition: all 0.4s; }\n\n.vjs-menu-button-inline:hover .vjs-menu,\n.vjs-menu-button-inline:focus .vjs-menu,\n.vjs-menu-button-inline.vjs-slider-active .vjs-menu {\n  display: block;\n  opacity: 1; }\n\n.vjs-no-flex .vjs-menu-button-inline .vjs-menu {\n  display: block;\n  opacity: 1;\n  position: relative;\n  width: auto; }\n\n.vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu,\n.vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu,\n.vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu {\n  width: auto; }\n\n.vjs-menu-button-inline .vjs-menu-content {\n  width: auto;\n  height: 100%;\n  margin: 0;\n  overflow: hidden; }\n\n.video-js .vjs-control-bar {\n  display: none;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3.0em;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7); }\n\n.vjs-has-started .vjs-control-bar {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  visibility: visible;\n  opacity: 1;\n  -webkit-transition: visibility 0.1s, opacity 0.1s;\n  -moz-transition: visibility 0.1s, opacity 0.1s;\n  -ms-transition: visibility 0.1s, opacity 0.1s;\n  -o-transition: visibility 0.1s, opacity 0.1s;\n  transition: visibility 0.1s, opacity 0.1s; }\n\n.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {\n  visibility: visible;\n  opacity: 0;\n  -webkit-transition: visibility 1s, opacity 1s;\n  -moz-transition: visibility 1s, opacity 1s;\n  -ms-transition: visibility 1s, opacity 1s;\n  -o-transition: visibility 1s, opacity 1s;\n  transition: visibility 1s, opacity 1s; }\n\n.vjs-controls-disabled .vjs-control-bar,\n.vjs-using-native-controls .vjs-control-bar,\n.vjs-error .vjs-control-bar {\n  display: none !important; }\n\n.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {\n  opacity: 1;\n  visibility: visible; }\n\n.vjs-has-started.vjs-no-flex .vjs-control-bar {\n  display: table; }\n\n.video-js .vjs-control {\n  position: relative;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 4em;\n  -webkit-box-flex: none;\n  -moz-box-flex: none;\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none; }\n\n.vjs-button > .vjs-icon-placeholder:before {\n  font-size: 1.8em;\n  line-height: 1.67; }\n\n.video-js .vjs-control:focus:before,\n.video-js .vjs-control:hover:before,\n.video-js .vjs-control:focus {\n  text-shadow: 0em 0em 1em white; }\n\n.video-js .vjs-control-text {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.vjs-no-flex .vjs-control {\n  display: table-cell;\n  vertical-align: middle; }\n\n.video-js .vjs-custom-control-spacer {\n  display: none; }\n\n.video-js .vjs-progress-control {\n  cursor: pointer;\n  -webkit-box-flex: auto;\n  -moz-box-flex: auto;\n  -webkit-flex: auto;\n  -ms-flex: auto;\n  flex: auto;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  min-width: 4em;\n  touch-action: none; }\n\n.video-js .vjs-progress-control.disabled {\n  cursor: default; }\n\n.vjs-live .vjs-progress-control {\n  display: none; }\n\n.vjs-no-flex .vjs-progress-control {\n  width: auto; }\n\n.video-js .vjs-progress-holder {\n  -webkit-box-flex: auto;\n  -moz-box-flex: auto;\n  -webkit-flex: auto;\n  -ms-flex: auto;\n  flex: auto;\n  -webkit-transition: all 0.2s;\n  -moz-transition: all 0.2s;\n  -ms-transition: all 0.2s;\n  -o-transition: all 0.2s;\n  transition: all 0.2s;\n  height: 0.3em; }\n\n.video-js .vjs-progress-control .vjs-progress-holder {\n  margin: 0 10px; }\n\n.video-js .vjs-progress-control:hover .vjs-progress-holder {\n  font-size: 1.666666666666666666em; }\n\n.video-js .vjs-progress-control:hover .vjs-progress-holder.disabled {\n  font-size: 1em; }\n\n.video-js .vjs-progress-holder .vjs-play-progress,\n.video-js .vjs-progress-holder .vjs-load-progress,\n.video-js .vjs-progress-holder .vjs-load-progress div {\n  position: absolute;\n  display: block;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  width: 0;\n  left: 0;\n  top: 0; }\n\n.video-js .vjs-play-progress {\n  background-color: #fff; }\n  .video-js .vjs-play-progress:before {\n    font-size: 0.9em;\n    position: absolute;\n    right: -0.5em;\n    top: -0.333333333333333em;\n    z-index: 1; }\n\n.video-js .vjs-load-progress {\n  background: #bfc7d3;\n  background: rgba(115, 133, 159, 0.5); }\n\n.video-js .vjs-load-progress div {\n  background: white;\n  background: rgba(115, 133, 159, 0.75); }\n\n.video-js .vjs-time-tooltip {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.8);\n  -webkit-border-radius: 0.3em;\n  -moz-border-radius: 0.3em;\n  border-radius: 0.3em;\n  color: #000;\n  float: right;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  padding: 6px 8px 8px 8px;\n  pointer-events: none;\n  position: absolute;\n  top: -3.4em;\n  visibility: hidden;\n  z-index: 1; }\n\n.video-js .vjs-progress-holder:focus .vjs-time-tooltip {\n  display: none; }\n\n.video-js .vjs-progress-control:hover .vjs-time-tooltip,\n.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip {\n  display: block;\n  font-size: 0.6em;\n  visibility: visible; }\n\n.video-js .vjs-progress-control.disabled:hover .vjs-time-tooltip {\n  font-size: 1em; }\n\n.video-js .vjs-progress-control .vjs-mouse-display {\n  display: none;\n  position: absolute;\n  width: 1px;\n  height: 100%;\n  background-color: #000;\n  z-index: 1; }\n\n.vjs-no-flex .vjs-progress-control .vjs-mouse-display {\n  z-index: 0; }\n\n.video-js .vjs-progress-control:hover .vjs-mouse-display {\n  display: block; }\n\n.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display {\n  visibility: hidden;\n  opacity: 0;\n  -webkit-transition: visibility 1s, opacity 1s;\n  -moz-transition: visibility 1s, opacity 1s;\n  -ms-transition: visibility 1s, opacity 1s;\n  -o-transition: visibility 1s, opacity 1s;\n  transition: visibility 1s, opacity 1s; }\n\n.video-js.vjs-user-inactive.vjs-no-flex .vjs-progress-control .vjs-mouse-display {\n  display: none; }\n\n.vjs-mouse-display .vjs-time-tooltip {\n  color: #fff;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.8); }\n\n.video-js .vjs-slider {\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n  margin: 0 0.45em 0 0.45em;\n  /* iOS Safari */\n  -webkit-touch-callout: none;\n  /* Safari */\n  -webkit-user-select: none;\n  /* Konqueror HTML */\n  -khtml-user-select: none;\n  /* Firefox */\n  -moz-user-select: none;\n  /* Internet Explorer/Edge */\n  -ms-user-select: none;\n  /* Non-prefixed version, currently supported by Chrome and Opera */\n  user-select: none;\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5); }\n\n.video-js .vjs-slider.disabled {\n  cursor: default; }\n\n.video-js .vjs-slider:focus {\n  text-shadow: 0em 0em 1em white;\n  -webkit-box-shadow: 0 0 1em #fff;\n  -moz-box-shadow: 0 0 1em #fff;\n  box-shadow: 0 0 1em #fff; }\n\n.video-js .vjs-mute-control {\n  cursor: pointer;\n  -webkit-box-flex: none;\n  -moz-box-flex: none;\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding-left: 2em;\n  padding-right: 2em;\n  padding-bottom: 3em; }\n\n.video-js .vjs-volume-control {\n  cursor: pointer;\n  margin-right: 1em;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.video-js .vjs-volume-control.vjs-volume-horizontal {\n  width: 5em; }\n\n.video-js .vjs-volume-panel .vjs-volume-control {\n  visibility: visible;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n  margin-left: -1px; }\n\n.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\"; }\n  .vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,\n  .vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical .vjs-volume-level {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\"; }\n\n.video-js .vjs-volume-panel {\n  -webkit-transition: width 1s;\n  -moz-transition: width 1s;\n  -ms-transition: width 1s;\n  -o-transition: width 1s;\n  transition: width 1s; }\n  .video-js .vjs-volume-panel:hover .vjs-volume-control,\n  .video-js .vjs-volume-panel:active .vjs-volume-control,\n  .video-js .vjs-volume-panel:focus .vjs-volume-control,\n  .video-js .vjs-volume-panel .vjs-volume-control:hover,\n  .video-js .vjs-volume-panel .vjs-volume-control:active,\n  .video-js .vjs-volume-panel .vjs-mute-control:hover ~ .vjs-volume-control,\n  .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active {\n    visibility: visible;\n    opacity: 1;\n    position: relative;\n    -webkit-transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;\n    -moz-transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;\n    -ms-transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;\n    -o-transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;\n    transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s; }\n    .video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-horizontal,\n    .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,\n    .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal,\n    .video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-horizontal,\n    .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,\n    .video-js .vjs-volume-panel .vjs-mute-control:hover ~ .vjs-volume-control.vjs-volume-horizontal,\n    .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal {\n      width: 5em;\n      height: 3em; }\n    .video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-vertical,\n    .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical,\n    .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical,\n    .video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-vertical,\n    .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical,\n    .video-js .vjs-volume-panel .vjs-mute-control:hover ~ .vjs-volume-control.vjs-volume-vertical,\n    .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical {\n      -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\"; }\n      .video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,\n      .video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-vertical .vjs-volume-level,\n      .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,\n      .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical .vjs-volume-level,\n      .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,\n      .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical .vjs-volume-level,\n      .video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-vertical .vjs-volume-bar,\n      .video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-vertical .vjs-volume-level,\n      .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical .vjs-volume-bar,\n      .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical .vjs-volume-level,\n      .video-js .vjs-volume-panel .vjs-mute-control:hover ~ .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,\n      .video-js .vjs-volume-panel .vjs-mute-control:hover ~ .vjs-volume-control.vjs-volume-vertical .vjs-volume-level,\n      .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical .vjs-volume-bar,\n      .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical .vjs-volume-level {\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\"; }\n  .video-js .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active {\n    width: 9em;\n    -webkit-transition: width 0.1s;\n    -moz-transition: width 0.1s;\n    -ms-transition: width 0.1s;\n    -o-transition: width 0.1s;\n    transition: width 0.1s; }\n  .video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-mute-toggle-only {\n    width: 4em; }\n\n.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {\n  height: 8em;\n  width: 3em;\n  left: -3.5em;\n  -webkit-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;\n  -moz-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;\n  -ms-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;\n  -o-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;\n  transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s; }\n\n.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {\n  -webkit-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;\n  -moz-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;\n  -ms-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;\n  -o-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;\n  transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s; }\n\n.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {\n  width: 5em;\n  height: 3em;\n  visibility: visible;\n  opacity: 1;\n  position: relative;\n  -webkit-transition: none;\n  -moz-transition: none;\n  -ms-transition: none;\n  -o-transition: none;\n  transition: none; }\n\n.video-js.vjs-no-flex .vjs-volume-control.vjs-volume-vertical,\n.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {\n  position: absolute;\n  bottom: 3em;\n  left: 0.5em; }\n\n.video-js .vjs-volume-panel {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.video-js .vjs-volume-bar {\n  margin: 1.35em 0.45em; }\n\n.vjs-volume-bar.vjs-slider-horizontal {\n  width: 5em;\n  height: 0.3em; }\n\n.vjs-volume-bar.vjs-slider-vertical {\n  width: 0.3em;\n  height: 5em;\n  margin: 1.35em auto; }\n\n.video-js .vjs-volume-level {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background-color: #fff; }\n  .video-js .vjs-volume-level:before {\n    position: absolute;\n    font-size: 0.9em; }\n\n.vjs-slider-vertical .vjs-volume-level {\n  width: 0.3em; }\n  .vjs-slider-vertical .vjs-volume-level:before {\n    top: -0.5em;\n    left: -0.3em; }\n\n.vjs-slider-horizontal .vjs-volume-level {\n  height: 0.3em; }\n  .vjs-slider-horizontal .vjs-volume-level:before {\n    top: -0.3em;\n    right: -0.5em; }\n\n.video-js .vjs-volume-panel.vjs-volume-panel-vertical {\n  width: 4em; }\n\n.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level {\n  height: 100%; }\n\n.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level {\n  width: 100%; }\n\n.video-js .vjs-volume-vertical {\n  width: 3em;\n  height: 8em;\n  bottom: 8em;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7); }\n\n.video-js .vjs-volume-horizontal .vjs-menu {\n  left: -2em; }\n\n.vjs-poster {\n  display: inline-block;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  background-size: contain;\n  background-color: #000000;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%; }\n\n.vjs-poster img {\n  display: block;\n  vertical-align: middle;\n  margin: 0 auto;\n  max-height: 100%;\n  padding: 0;\n  width: 100%; }\n\n.vjs-has-started .vjs-poster {\n  display: none; }\n\n.vjs-audio.vjs-has-started .vjs-poster {\n  display: block; }\n\n.vjs-using-native-controls .vjs-poster {\n  display: none; }\n\n.video-js .vjs-live-control {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-flex: auto;\n  -moz-box-flex: auto;\n  -webkit-flex: auto;\n  -ms-flex: auto;\n  flex: auto;\n  font-size: 1em;\n  line-height: 3em; }\n\n.vjs-no-flex .vjs-live-control {\n  display: table-cell;\n  width: auto;\n  text-align: left; }\n\n.video-js .vjs-time-control {\n  -webkit-box-flex: none;\n  -moz-box-flex: none;\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n  font-size: 1em;\n  line-height: 3em;\n  min-width: 2em;\n  width: auto;\n  padding-left: 1em;\n  padding-right: 1em; }\n\n.vjs-live .vjs-time-control {\n  display: none; }\n\n.video-js .vjs-current-time,\n.vjs-no-flex .vjs-current-time {\n  display: none; }\n\n.vjs-no-flex .vjs-remaining-time.vjs-time-control.vjs-control {\n  width: 0px !important;\n  white-space: nowrap; }\n\n.video-js .vjs-duration,\n.vjs-no-flex .vjs-duration {\n  display: none; }\n\n.vjs-time-divider {\n  display: none;\n  line-height: 3em; }\n\n.vjs-live .vjs-time-divider {\n  display: none; }\n\n.video-js .vjs-play-control .vjs-icon-placeholder {\n  cursor: pointer;\n  -webkit-box-flex: none;\n  -moz-box-flex: none;\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none; }\n\n.vjs-text-track-display {\n  position: absolute;\n  bottom: 3em;\n  left: 0;\n  right: 0;\n  top: 0;\n  pointer-events: none; }\n\n.video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display {\n  bottom: 1em; }\n\n.video-js .vjs-text-track {\n  font-size: 1.4em;\n  text-align: center;\n  margin-bottom: 0.1em;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.5); }\n\n.vjs-subtitles {\n  color: #fff; }\n\n.vjs-captions {\n  color: #fc6; }\n\n.vjs-tt-cue {\n  display: block; }\n\nvideo::-webkit-media-text-track-display {\n  -moz-transform: translateY(-3em);\n  -ms-transform: translateY(-3em);\n  -o-transform: translateY(-3em);\n  -webkit-transform: translateY(-3em);\n  transform: translateY(-3em); }\n\n.video-js.vjs-user-inactive.vjs-playing video::-webkit-media-text-track-display {\n  -moz-transform: translateY(-1.5em);\n  -ms-transform: translateY(-1.5em);\n  -o-transform: translateY(-1.5em);\n  -webkit-transform: translateY(-1.5em);\n  transform: translateY(-1.5em); }\n\n.video-js .vjs-fullscreen-control {\n  cursor: pointer;\n  -webkit-box-flex: none;\n  -moz-box-flex: none;\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none; }\n\n.vjs-playback-rate > .vjs-menu-button,\n.vjs-playback-rate .vjs-playback-rate-value {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.vjs-playback-rate .vjs-playback-rate-value {\n  pointer-events: none;\n  font-size: 1.5em;\n  line-height: 2;\n  text-align: center; }\n\n.vjs-playback-rate .vjs-menu {\n  width: 4em;\n  left: 0em; }\n\n.vjs-error .vjs-error-display .vjs-modal-dialog-content {\n  font-size: 1.4em;\n  text-align: center; }\n\n.vjs-error .vjs-error-display:before {\n  color: #fff;\n  content: 'X';\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 4em;\n  left: 0;\n  line-height: 1;\n  margin-top: -0.5em;\n  position: absolute;\n  text-shadow: 0.05em 0.05em 0.1em #000;\n  text-align: center;\n  top: 50%;\n  vertical-align: middle;\n  width: 100%; }\n\n.vjs-loading-spinner {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -25px 0 0 -25px;\n  opacity: 0.85;\n  text-align: left;\n  border: 6px solid rgba(43, 51, 63, 0.7);\n  box-sizing: border-box;\n  background-clip: padding-box;\n  width: 50px;\n  height: 50px;\n  border-radius: 25px;\n  visibility: hidden; }\n\n.vjs-seeking .vjs-loading-spinner,\n.vjs-waiting .vjs-loading-spinner {\n  display: block;\n  animation: 0s linear 0.3s forwards vjs-spinner-show; }\n\n.vjs-loading-spinner:before,\n.vjs-loading-spinner:after {\n  content: \"\";\n  position: absolute;\n  margin: -6px;\n  box-sizing: inherit;\n  width: inherit;\n  height: inherit;\n  border-radius: inherit;\n  opacity: 1;\n  border: inherit;\n  border-color: transparent;\n  border-top-color: white; }\n\n.vjs-seeking .vjs-loading-spinner:before,\n.vjs-seeking .vjs-loading-spinner:after,\n.vjs-waiting .vjs-loading-spinner:before,\n.vjs-waiting .vjs-loading-spinner:after {\n  -webkit-animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, vjs-spinner-fade 1.1s linear infinite;\n  animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, vjs-spinner-fade 1.1s linear infinite; }\n\n.vjs-seeking .vjs-loading-spinner:before,\n.vjs-waiting .vjs-loading-spinner:before {\n  border-top-color: white; }\n\n.vjs-seeking .vjs-loading-spinner:after,\n.vjs-waiting .vjs-loading-spinner:after {\n  border-top-color: white;\n  -webkit-animation-delay: 0.44s;\n  animation-delay: 0.44s; }\n\n@keyframes vjs-spinner-show {\n  to {\n    visibility: visible; } }\n\n@-webkit-keyframes vjs-spinner-show {\n  to {\n    visibility: visible; } }\n\n@keyframes vjs-spinner-spin {\n  100% {\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes vjs-spinner-spin {\n  100% {\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes vjs-spinner-fade {\n  0% {\n    border-top-color: #73859f; }\n  20% {\n    border-top-color: #73859f; }\n  35% {\n    border-top-color: white; }\n  60% {\n    border-top-color: #73859f; }\n  100% {\n    border-top-color: #73859f; } }\n\n@-webkit-keyframes vjs-spinner-fade {\n  0% {\n    border-top-color: #73859f; }\n  20% {\n    border-top-color: #73859f; }\n  35% {\n    border-top-color: white; }\n  60% {\n    border-top-color: #73859f; }\n  100% {\n    border-top-color: #73859f; } }\n\n.vjs-chapters-button .vjs-menu ul {\n  width: 24em; }\n\n.video-js .vjs-subs-caps-button + .vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {\n  vertical-align: middle;\n  display: inline-block;\n  margin-bottom: -0.1em; }\n\n.video-js .vjs-subs-caps-button + .vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before {\n  font-family: VideoJS;\n  content: \"\\F10D\";\n  font-size: 1.5em;\n  line-height: inherit; }\n\n.video-js .vjs-audio-button + .vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder {\n  vertical-align: middle;\n  display: inline-block;\n  margin-bottom: -0.1em; }\n\n.video-js .vjs-audio-button + .vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before {\n  font-family: VideoJS;\n  content: \" \\F11D\";\n  font-size: 1.5em;\n  line-height: inherit; }\n\n.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-custom-control-spacer {\n  -webkit-box-flex: auto;\n  -moz-box-flex: auto;\n  -webkit-flex: auto;\n  -ms-flex: auto;\n  flex: auto;\n  display: block; }\n\n.video-js.vjs-layout-tiny:not(.vjs-fullscreen).vjs-no-flex .vjs-custom-control-spacer {\n  width: auto; }\n\n.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-current-time, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-time-divider, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-duration, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-remaining-time,\n.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-playback-rate, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-progress-control,\n.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-mute-control, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-volume-control, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-volume-panel,\n.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-chapters-button, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-descriptions-button, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-captions-button,\n.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-subtitles-button, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-subs-caps-button, .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-audio-button {\n  display: none; }\n\n.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-current-time, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-time-divider, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-duration, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-remaining-time,\n.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-playback-rate,\n.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-mute-control, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-volume-control, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-volume-panel,\n.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-chapters-button, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-descriptions-button, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-captions-button,\n.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-subtitles-button, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-subs-caps-button, .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-audio-button {\n  display: none; }\n\n.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-current-time, .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-time-divider, .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-duration, .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-remaining-time,\n.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-playback-rate,\n.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-mute-control, .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-volume-control, .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-volume-panel,\n.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-chapters-button, .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-descriptions-button, .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-captions-button,\n.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-subtitles-button, .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-audio-button {\n  display: none; }\n\n.vjs-modal-dialog.vjs-text-track-settings {\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.75);\n  color: #fff;\n  height: 70%; }\n\n.vjs-text-track-settings .vjs-modal-dialog-content {\n  display: table; }\n\n.vjs-text-track-settings .vjs-track-settings-colors,\n.vjs-text-track-settings .vjs-track-settings-font,\n.vjs-text-track-settings .vjs-track-settings-controls {\n  display: table-cell; }\n\n.vjs-text-track-settings .vjs-track-settings-controls {\n  text-align: right;\n  vertical-align: bottom; }\n\n@supports (display: grid) {\n  .vjs-text-track-settings .vjs-modal-dialog-content {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr auto; }\n  .vjs-text-track-settings .vjs-track-settings-colors {\n    display: block;\n    grid-column: 1;\n    grid-row: 1; }\n  .vjs-text-track-settings .vjs-track-settings-font {\n    grid-column: 2;\n    grid-row: 1; }\n  .vjs-text-track-settings .vjs-track-settings-controls {\n    grid-column: 2;\n    grid-row: 2; } }\n\n.vjs-track-setting > select {\n  margin-right: 5px; }\n\n.vjs-text-track-settings fieldset {\n  margin: 5px;\n  padding: 3px;\n  border: none; }\n\n.vjs-text-track-settings fieldset span {\n  display: inline-block; }\n\n.vjs-text-track-settings legend {\n  color: #fff;\n  margin: 0 0 5px 0; }\n\n.vjs-text-track-settings .vjs-label {\n  position: absolute;\n  clip: rect(1px 1px 1px 1px);\n  clip: rect(1px, 1px, 1px, 1px);\n  display: block;\n  margin: 0 0 5px 0;\n  padding: 0;\n  border: 0;\n  height: 1px;\n  width: 1px;\n  overflow: hidden; }\n\n.vjs-track-settings-controls button:focus,\n.vjs-track-settings-controls button:active {\n  outline-style: solid;\n  outline-width: medium;\n  background-image: linear-gradient(0deg, #fff 88%, #73859f 100%); }\n\n.vjs-track-settings-controls button:hover {\n  color: rgba(43, 51, 63, 0.75); }\n\n.vjs-track-settings-controls button {\n  background-color: #fff;\n  background-image: linear-gradient(-180deg, #fff 88%, #73859f 100%);\n  color: #2B333F;\n  cursor: pointer;\n  border-radius: 2px; }\n\n.vjs-track-settings-controls .vjs-default-button {\n  margin-right: 1em; }\n\n@media print {\n  .video-js > *:not(.vjs-tech):not(.vjs-poster) {\n    visibility: hidden; } }\n\n.vjs-resize-manager {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  z-index: -1000; }\n\n.js-focus-visible .video-js *:focus:not(.focus-visible) {\n  outline: none; }\n\n.video-js *:focus:not(:focus-visible) {\n  outline: none; }\n\n@media \\0screen {\n  .vjs-user-inactive.vjs-playing .vjs-control-bar :before {\n    content: \"\";\n  }\n}\n\n@media \\0screen {\n  .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {\n    visibility: hidden;\n  }\n}\n", ""]);

// exports


/***/ }),

/***/ "aMlG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b8LD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bkOh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "breY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.8988968.svg";

/***/ }),

/***/ "cJYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ck5t":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTIgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjEgKDQ3MjUwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT7pu4TniYxpY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IuWQhOWcsOWMuummlumhtS3mr5TotZvor6bmg4XvvIjmr5TotZvnu5PmnpzvvIkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzAuMDAwMDAwLCAtNzA3LjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJHcm91cC01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMzIwLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0i6buE54mMIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzAuMDAwMDAwLCAzODcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTE0IiBmaWxsPSIjRkVFRDE2IiB4PSIwIiB5PSIwIiB3aWR0aD0iMTIiIGhlaWdodD0iMTQiIHJ4PSIyIj48L3JlY3Q+CiAgICAgICAgICAgICAgICA8dGV4dCBpZD0i6buEIiBmb250LWZhbWlseT0iUGluZ0ZhbmdTQy1TZW1pYm9sZCwgUGluZ0ZhbmcgU0MiIGZvbnQtc2l6ZT0iOCIgZm9udC13ZWlnaHQ9IjUwMCIgZmlsbD0iI0ZGRkZGRiI+CiAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjIiIHk9IjEwIj7pu4Q8L3RzcGFuPgogICAgICAgICAgICAgICAgPC90ZXh0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "cyp9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dVp8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dgeV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ebTe":
/***/ (function(module, exports) {

module.exports = jWeixin;

/***/ }),

/***/ "epEz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "eqZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);




!function (a, b) {
    "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(exports)) && "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(module)) ? module.exports = b() : "function" == typeof define && __webpack_require__("nErl") ? define([], b) : "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(exports)) ? exports.cyberplayer = b() : a.cyberplayer = b();
}(this, function () {
    return function (a) {
        function b(d) {
            if (c[d]) return c[d].exports;
            var e = c[d] = { exports: {}, id: d, loaded: !1 };
            return a[d].call(e.exports, e, e.exports, b), e.loaded = !0, e.exports;
        }
        var c = {};
        return b.m = a, b.c = c, b.p = "", b(0);
    }([function (a, b, c) {
        c(25), c(24), c(26), a.exports = c(95);
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            var a = {},
                b = Array.prototype,
                c = Object.prototype,
                d = Function.prototype,
                e = b.slice,
                f = b.concat,
                g = c.toString,
                h = c.hasOwnProperty,
                i = b.map,
                j = b.reduce,
                k = b.forEach,
                l = b.filter,
                m = b.every,
                n = b.some,
                o = b.indexOf,
                p = Array.isArray,
                q = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default.a,
                r = d.bind,
                s = function s(a) {
                return a instanceof s ? a : this instanceof s ? void 0 : new s(a);
            },
                t = s.each = s.forEach = function (b, c, d) {
                if (null == b) return b;
                if (k && b.forEach === k) b.forEach(c, d);else if (b.length === +b.length) {
                    for (var e = 0, f = b.length; e < f; e++) {
                        if (c.call(d, b[e], e, b) === a) return;
                    }
                } else for (var g = s.keys(b), e = 0, f = g.length; e < f; e++) {
                    if (c.call(d, b[g[e]], g[e], b) === a) return;
                }return b;
            };
            s.map = s.collect = function (a, b, c) {
                var d = [];
                return null == a ? d : i && a.map === i ? a.map(b, c) : (t(a, function (a, e, f) {
                    d.push(b.call(c, a, e, f));
                }), d);
            };
            var u = "Reduce of empty array with no initial value";
            s.reduce = s.foldl = s.inject = function (a, b, c, d) {
                var e = arguments.length > 2;
                if (null == a && (a = []), j && a.reduce === j) return d && (b = s.bind(b, d)), e ? a.reduce(b, c) : a.reduce(b);
                if (t(a, function (a, f, g) {
                    e ? c = b.call(d, c, a, f, g) : (c = a, e = !0);
                }), !e) throw new TypeError(u);
                return c;
            }, s.find = s.detect = function (a, b, c) {
                var d;
                return v(a, function (a, e, f) {
                    if (b.call(c, a, e, f)) return d = a, !0;
                }), d;
            }, s.filter = s.select = function (a, b, c) {
                var d = [];
                return null == a ? d : l && a.filter === l ? a.filter(b, c) : (t(a, function (a, e, f) {
                    b.call(c, a, e, f) && d.push(a);
                }), d);
            }, s.reject = function (a, b, c) {
                return s.filter(a, function (a, d, e) {
                    return !b.call(c, a, d, e);
                }, c);
            }, s.compact = function (a) {
                return s.filter(a, s.identity);
            }, s.every = s.all = function (b, c, d) {
                c || (c = s.identity);
                var e = !0;
                return null == b ? e : m && b.every === m ? b.every(c, d) : (t(b, function (b, f, g) {
                    if (!(e = e && c.call(d, b, f, g))) return a;
                }), !!e);
            };
            var v = s.some = s.any = function (b, c, d) {
                c || (c = s.identity);
                var e = !1;
                return null == b ? e : n && b.some === n ? b.some(c, d) : (t(b, function (b, f, g) {
                    if (e || (e = c.call(d, b, f, g))) return a;
                }), !!e);
            };
            s.size = function (a) {
                return null == a ? 0 : a.length === +a.length ? a.length : s.keys(a).length;
            }, s.last = function (a, b, c) {
                if (null != a) return null == b || c ? a[a.length - 1] : e.call(a, Math.max(a.length - b, 0));
            }, s.after = function (a, b) {
                return function () {
                    if (--a < 1) return b.apply(this, arguments);
                };
            }, s.before = function (a, b) {
                var c;
                return function () {
                    return --a > 0 && (c = b.apply(this, arguments)), a <= 1 && (b = null), c;
                };
            };
            var w = function w(a) {
                return null == a ? s.identity : s.isFunction(a) ? a : s.property(a);
            },
                x = function x(a) {
                return function (b, c, d) {
                    var e = {};
                    return c = w(c), t(b, function (f, g) {
                        var h = c.call(d, f, g, b);
                        a(e, h, f);
                    }), e;
                };
            };
            s.groupBy = x(function (a, b, c) {
                s.has(a, b) ? a[b].push(c) : a[b] = [c];
            }), s.indexBy = x(function (a, b, c) {
                a[b] = c;
            }), s.sortedIndex = function (a, b, c, d) {
                c = w(c);
                for (var e = c.call(d, b), f = 0, g = a.length; f < g;) {
                    var h = f + g >>> 1;
                    c.call(d, a[h]) < e ? f = h + 1 : g = h;
                }
                return f;
            };
            var v = s.some = s.any = function (b, c, d) {
                c || (c = s.identity);
                var e = !1;
                return null == b ? e : n && b.some === n ? b.some(c, d) : (t(b, function (b, f, g) {
                    if (e || (e = c.call(d, b, f, g))) return a;
                }), !!e);
            };
            s.contains = s.include = function (a, b) {
                return null != a && (a.length !== +a.length && (a = s.values(a)), s.indexOf(a, b) >= 0);
            }, s.pluck = function (a, b) {
                return s.map(a, s.property(b));
            }, s.where = function (a, b) {
                return s.filter(a, s.matches(b));
            }, s.findWhere = function (a, b) {
                return s.find(a, s.matches(b));
            }, s.max = function (a, b, c) {
                if (!b && s.isArray(a) && a[0] === +a[0] && a.length < 65535) return Math.max.apply(Math, a);
                var d = -(1 / 0),
                    e = -(1 / 0);
                return t(a, function (a, f, g) {
                    var h = b ? b.call(c, a, f, g) : a;
                    h > e && (d = a, e = h);
                }), d;
            }, s.difference = function (a) {
                var c = f.apply(b, e.call(arguments, 1));
                return s.filter(a, function (a) {
                    return !s.contains(c, a);
                });
            }, s.without = function (a) {
                return s.difference(a, e.call(arguments, 1));
            }, s.indexOf = function (a, b, c) {
                if (null == a) return -1;
                var d = 0,
                    e = a.length;
                if (c) {
                    if ("number" != typeof c) return d = s.sortedIndex(a, b), a[d] === b ? d : -1;
                    d = c < 0 ? Math.max(0, e + c) : c;
                }
                if (o && a.indexOf === o) return a.indexOf(b, c);
                for (; d < e; d++) {
                    if (a[d] === b) return d;
                }return -1;
            };
            var y = function y() {};
            s.bind = function (a, b) {
                var c, _d;
                if (r && a.bind === r) return r.apply(a, e.call(arguments, 1));
                if (!s.isFunction(a)) throw new TypeError();
                return c = e.call(arguments, 2), _d = function d() {
                    if (!(this instanceof _d)) return a.apply(b, c.concat(e.call(arguments)));
                    y.prototype = a.prototype;
                    var f = new y();
                    y.prototype = null;
                    var g = a.apply(f, c.concat(e.call(arguments)));
                    return Object(g) === g ? g : f;
                };
            }, s.partial = function (a) {
                var b = e.call(arguments, 1);
                return function () {
                    for (var c = 0, d = b.slice(), e = 0, f = d.length; e < f; e++) {
                        d[e] === s && (d[e] = arguments[c++]);
                    }for (; c < arguments.length;) {
                        d.push(arguments[c++]);
                    }return a.apply(this, d);
                };
            }, s.once = s.partial(s.before, 2), s.memoize = function (a, b) {
                var c = {};
                return b || (b = s.identity), function () {
                    var d = b.apply(this, arguments);
                    return s.has(c, d) ? c[d] : c[d] = a.apply(this, arguments);
                };
            }, s.delay = function (a, b) {
                var c = e.call(arguments, 2);
                return setTimeout(function () {
                    return a.apply(null, c);
                }, b);
            }, s.defer = function (a) {
                return s.delay.apply(s, [a, 1].concat(e.call(arguments, 1)));
            }, s.throttle = function (a, b, c) {
                var d,
                    e,
                    f,
                    g = null,
                    h = 0;
                c || (c = {});
                var i = function i() {
                    h = c.leading === !1 ? 0 : s.now(), g = null, f = a.apply(d, e), d = e = null;
                };
                return function () {
                    var j = s.now();
                    h || c.leading !== !1 || (h = j);
                    var k = b - (j - h);
                    return d = this, e = arguments, k <= 0 ? (clearTimeout(g), g = null, h = j, f = a.apply(d, e), d = e = null) : g || c.trailing === !1 || (g = setTimeout(i, k)), f;
                };
            }, s.keys = function (a) {
                if (!s.isObject(a)) return [];
                if (q) return q(a);
                var b = [];
                for (var c in a) {
                    s.has(a, c) && b.push(c);
                }return b;
            }, s.invert = function (a) {
                for (var b = {}, c = s.keys(a), d = 0, e = c.length; d < e; d++) {
                    b[a[c[d]]] = c[d];
                }return b;
            }, s.defaults = function (a) {
                return t(e.call(arguments, 1), function (b) {
                    if (b) for (var c in b) {
                        void 0 === a[c] && (a[c] = b[c]);
                    }
                }), a;
            }, s.extend = function (a) {
                return t(e.call(arguments, 1), function (b) {
                    if (b) for (var c in b) {
                        a[c] = b[c];
                    }
                }), a;
            }, s.pick = function (a) {
                var c = {},
                    d = f.apply(b, e.call(arguments, 1));
                return t(d, function (b) {
                    b in a && (c[b] = a[b]);
                }), c;
            }, s.omit = function (a) {
                var c = {},
                    d = f.apply(b, e.call(arguments, 1));
                for (var g in a) {
                    s.contains(d, g) || (c[g] = a[g]);
                }return c;
            }, s.clone = function (a) {
                return s.isObject(a) ? s.isArray(a) ? a.slice() : s.extend({}, a) : a;
            }, s.isArray = p || function (a) {
                return "[object Array]" == g.call(a);
            }, s.isObject = function (a) {
                return a === Object(a);
            }, t(["Arguments", "Function", "String", "Number", "Date", "RegExp"], function (a) {
                s["is" + a] = function (b) {
                    return g.call(b) == "[object " + a + "]";
                };
            }), s.isArguments(arguments) || (s.isArguments = function (a) {
                return !(!a || !s.has(a, "callee"));
            }), s.isFunction = function (a) {
                return "function" == typeof a;
            }, s.isFinite = function (a) {
                return isFinite(a) && !isNaN(parseFloat(a));
            }, s.isNaN = function (a) {
                return s.isNumber(a) && a != +a;
            }, s.isBoolean = function (a) {
                return a === !0 || a === !1 || "[object Boolean]" == g.call(a);
            }, s.isNull = function (a) {
                return null === a;
            }, s.isUndefined = function (a) {
                return void 0 === a;
            }, s.has = function (a, b) {
                return h.call(a, b);
            }, s.identity = function (a) {
                return a;
            }, s.constant = function (a) {
                return function () {
                    return a;
                };
            }, s.property = function (a) {
                return function (b) {
                    return b[a];
                };
            }, s.propertyOf = function (a) {
                return null == a ? function () {} : function (b) {
                    return a[b];
                };
            }, s.matches = function (a) {
                return function (b) {
                    if (b === a) return !0;
                    for (var c in a) {
                        if (a[c] !== b[c]) return !1;
                    }return !0;
                };
            }, s.now = Date.now || function () {
                return new Date().getTime();
            }, s.result = function (a, b) {
                if (null != a) {
                    var c = a[b];
                    return s.isFunction(c) ? c.call(a) : c;
                }
            };
            var z = 0;
            return s.uniqueId = function (a) {
                var b = ++z + "";
                return a ? a + b : b;
            }, s;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(5), c(1), c(46), c(30), c(16), c(31), c(48), c(45), c(33), c(109), c(112), c(110)], e = function (a, b, c, d, e, f, g, h, i, j, k, l) {
            var m = {};
            return m.log = function () {
                window.console && ("object" == __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(console.log) ? console.log(Array.prototype.slice.call(arguments, 0)) : console.log.apply(console, arguments));
            }, m.between = function (a, b, c) {
                return Math.max(Math.min(a, c), b);
            }, m.foreach = function (a, b) {
                var c, d;
                for (c in a) {
                    "function" === m.typeOf(a.hasOwnProperty) ? a.hasOwnProperty(c) && (d = a[c], b(c, d)) : (d = a[c], b(c, d));
                }
            }, m.indexOf = b.indexOf, m.noop = function () {}, m.seconds = a.seconds, m.prefix = a.prefix, m.suffix = a.suffix, b.extend(m, f, g, i, c, h, d, e, j, k, l), m;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1)], e = function (a) {
            var b = [],
                c = b.slice,
                d = { on: function on(a, b, c) {
                    if (!f(this, "on", a, [b, c]) || !b) return this;
                    this._events || (this._events = {});
                    var d = this._events[a] || (this._events[a] = []);
                    return d.push({ callback: b, context: c }), this;
                }, once: function once(b, c, d) {
                    if (!f(this, "once", b, [c, d]) || !c) return this;
                    var e = this,
                        g = a.once(function () {
                        e.off(b, g), c.apply(this, arguments);
                    });
                    return g._callback = c, this.on(b, g, d);
                }, off: function off(b, c, d) {
                    var e, g, h, i, j, k, l, m;
                    if (!this._events || !f(this, "off", b, [c, d])) return this;
                    if (!b && !c && !d) return this._events = void 0, this;
                    for (i = b ? [b] : a.keys(this._events), j = 0, k = i.length; j < k; j++) {
                        if (b = i[j], h = this._events[b]) {
                            if (this._events[b] = e = [], c || d) for (l = 0, m = h.length; l < m; l++) {
                                g = h[l], (c && c !== g.callback && c !== g.callback._callback || d && d !== g.context) && e.push(g);
                            }e.length || delete this._events[b];
                        }
                    }return this;
                }, trigger: function trigger(a) {
                    if (!this._events) return this;
                    var b = c.call(arguments, 1);
                    if (!f(this, "trigger", a, b)) return this;
                    var d = this._events[a],
                        e = this._events.all;
                    return d && g(d, b, this), e && g(e, arguments, this), this;
                }, triggerSafe: function triggerSafe(a) {
                    if (!this._events) return this;
                    var b = c.call(arguments, 1);
                    if (!f(this, "trigger", a, b)) return this;
                    var d = this._events[a],
                        e = this._events.all;
                    return d && h(d, b, this), e && h(e, arguments, this), this;
                } },
                e = /\s+/,
                f = function f(a, b, c, d) {
                if (!c) return !0;
                if ("object" == (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(c))) {
                    for (var f in c) {
                        a[b].apply(a, [f, c[f]].concat(d));
                    }return !1;
                }
                if (e.test(c)) {
                    for (var g = c.split(e), h = 0, i = g.length; h < i; h++) {
                        a[b].apply(a, [g[h]].concat(d));
                    }return !1;
                }
                return !0;
            },
                g = function g(a, b, c) {
                var d,
                    e = -1,
                    f = a.length,
                    g = b[0],
                    h = b[1],
                    i = b[2];
                switch (b.length) {
                    case 0:
                        for (; ++e < f;) {
                            (d = a[e]).callback.call(d.context || c);
                        }return;
                    case 1:
                        for (; ++e < f;) {
                            (d = a[e]).callback.call(d.context || c, g);
                        }return;
                    case 2:
                        for (; ++e < f;) {
                            (d = a[e]).callback.call(d.context || c, g, h);
                        }return;
                    case 3:
                        for (; ++e < f;) {
                            (d = a[e]).callback.call(d.context || c, g, h, i);
                        }return;
                    default:
                        for (; ++e < f;) {
                            (d = a[e]).callback.apply(d.context || c, b);
                        }return;}
            },
                h = function h(a, b, c) {
                for (var d, e = -1, f = a.length; ++e < f;) {
                    try {
                        (d = a[e]).callback.apply(d.context || c, b);
                    } catch (g) {}
                }
            };
            return d;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            var a = { DRAG: "drag", DRAG_START: "dragStart", DRAG_END: "dragEnd", CLICK: "click", DOUBLE_CLICK: "doubleClick", TAP: "tap", DOUBLE_TAP: "doubleTap", OVER: "over", MOVE: "move", OUT: "out" },
                b = { COMPLETE: "complete", ERROR: "error", JWPLAYER_AD_CLICK: "adClick", JWPLAYER_AD_COMPANIONS: "adCompanions", JWPLAYER_AD_COMPLETE: "adComplete", JWPLAYER_AD_ERROR: "adError", JWPLAYER_AD_IMPRESSION: "adImpression", JWPLAYER_AD_META: "adMeta", JWPLAYER_AD_PAUSE: "adPause", JWPLAYER_AD_PLAY: "adPlay", JWPLAYER_AD_SKIPPED: "adSkipped", JWPLAYER_AD_TIME: "adTime", JWPLAYER_CAST_AD_CHANGED: "castAdChanged", JWPLAYER_MEDIA_COMPLETE: "complete", JWPLAYER_READY: "ready", JWPLAYER_MEDIA_SEEK: "seek", JWPLAYER_MEDIA_BEFOREPLAY: "beforePlay", JWPLAYER_MEDIA_BEFORECOMPLETE: "beforeComplete", JWPLAYER_MEDIA_BUFFER_FULL: "bufferFull", JWPLAYER_DISPLAY_CLICK: "displayClick", JWPLAYER_PLAYLIST_COMPLETE: "playlistComplete", JWPLAYER_CAST_SESSION: "cast", JWPLAYER_MEDIA_ERROR: "mediaError", JWPLAYER_MEDIA_FIRST_FRAME: "firstFrame", JWPLAYER_MEDIA_PLAY_ATTEMPT: "playAttempt", JWPLAYER_MEDIA_LOADED: "loaded", JWPLAYER_MEDIA_SEEKED: "seeked", JWPLAYER_SETUP_ERROR: "setupError", JWPLAYER_ERROR: "error", JWPLAYER_PLAYER_STATE: "state", JWPLAYER_CAST_AVAILABLE: "castAvailable", JWPLAYER_MEDIA_BUFFER: "bufferChange", JWPLAYER_MEDIA_TIME: "time", JWPLAYER_MEDIA_TYPE: "mediaType", JWPLAYER_MEDIA_VOLUME: "volume", JWPLAYER_MEDIA_MUTE: "mute", JWPLAYER_MEDIA_META: "meta", JWPLAYER_MEDIA_LEVELS: "levels", JWPLAYER_MEDIA_LEVEL_CHANGED: "levelsChanged", JWPLAYER_CONTROLS: "controls", JWPLAYER_FULLSCREEN: "fullscreen", JWPLAYER_RESIZE: "resize", JWPLAYER_PLAYLIST_ITEM: "playlistItem", JWPLAYER_PLAYLIST_LOADED: "playlist", JWPLAYER_AUDIO_TRACKS: "audioTracks", JWPLAYER_AUDIO_TRACK_CHANGED: "audioTrackChanged", JWPLAYER_CONNECTING: "connecting", JWPLAYER_CONNECT_FAILD: "connectFaild", JWPLAYER_NO_LIVE_STREAM: "noLiveStream", JWPLAYER_ALIVE: "alive", JWPLAYER_LIVE_STOP: "liveStop", JWPLAYER_LOGO_CLICK: "logoClick", JWPLAYER_CAPTIONS_LIST: "captionsList", JWPLAYER_CAPTIONS_CHANGED: "captionsChanged", JWPLAYER_PROVIDER_CHANGED: "providerChanged", JWPLAYER_PROVIDER_FIRST_FRAME: "providerFirstFrame", JWPLAYER_USER_ACTION: "userAction", JWPLAYER_PROVIDER_CLICK: "providerClick", JWPLAYER_VIEW_TAB_FOCUS: "tabFocus", JWPLAYER_CONTROLBAR_DRAGGING: "scrubbing", JWPLAYER_INSTREAM_CLICK: "instreamClick", JWPLAYER_CUEPOINT: "cuepoint", JWPLAYER_SEEK_FORWARD_FORBIDDEN: "seekForwardForbidden" };
            return b.touchEvents = a, b;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1)], e = function (a) {
            function b(a) {
                return !!/[\(,]format=m3u8-/i.test(a) && "m3u8";
            }
            var c = function c(a) {
                return a.replace(/^\s+|\s+$/g, "");
            },
                d = function d(a, b, c) {
                for (a = "" + a, c = c || "0"; a.length < b;) {
                    a = c + a;
                }return a;
            },
                e = function e(a, b) {
                for (var c = 0; c < a.attributes.length; c++) {
                    if (a.attributes[c].name && a.attributes[c].name.toLowerCase() === b.toLowerCase()) return a.attributes[c].value.toString();
                }return "";
            },
                f = function f(a) {
                if (!a || "rtmp" === a.substr(0, 4)) return "";
                var c = b(a);
                return c ? c : (a = a.split("?")[0].split("#")[0], a.lastIndexOf(".") > -1 ? a.substr(a.lastIndexOf(".") + 1, a.length).toLowerCase() : void 0);
            },
                g = function g(a) {
                var b = parseInt(a / 3600),
                    c = parseInt(a / 60) % 60,
                    e = a % 60;
                return d(b, 2) + ":" + d(c, 2) + ":" + d(e.toFixed(3), 6);
            },
                h = function h(b) {
                if (a.isNumber(b)) return b;
                b = b.replace(",", ".");
                var c = b.split(":"),
                    d = 0;
                return "s" === b.slice(-1) ? d = parseFloat(b) : "m" === b.slice(-1) ? d = 60 * parseFloat(b) : "h" === b.slice(-1) ? d = 3600 * parseFloat(b) : c.length > 1 ? (d = parseFloat(c[c.length - 1]), d += 60 * parseFloat(c[c.length - 2]), 3 === c.length && (d += 3600 * parseFloat(c[c.length - 3]))) : d = parseFloat(b), d;
            },
                i = function i(b, c) {
                return a.map(b, function (a) {
                    return c + a;
                });
            },
                j = function j(b, c) {
                return a.map(b, function (a) {
                    return a + c;
                });
            };
            return { trim: c, pad: d, xmlAttribute: e, extension: f, hms: g, seconds: h, suffix: j, prefix: i };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            return { BUFFERING: "buffering", IDLE: "idle", COMPLETE: "complete", PAUSED: "paused", PLAYING: "playing", ERROR: "error", LOADING: "loading", STALLED: "stalled" };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(3), c(4), c(1), c(2)], e = function (a, b, c, d) {
            function e(a, b) {
                return (/touch/.test(a.type) ? (a.originalEvent || a).changedTouches[0]["page" + b] : a["page" + b]
                );
            }

            function f(a) {
                var b = a || window.event;
                return !!(d.isPoorIE() || a instanceof MouseEvent) && ("which" in b ? 3 === b.which : "button" in b && 2 === b.button);
            }

            function g(a, b, c) {
                var e;
                return e = !d.isPoorIE() && b instanceof MouseEvent || !b.touches && !b.changedTouches ? b : b.touches && b.touches.length ? b.touches[0] : b.changedTouches[0], { type: a, target: b.target, currentTarget: c, pageX: e.pageX, pageY: e.pageY };
            }

            function h(a) {
                (d.isPoorIE() || a instanceof MouseEvent || a instanceof window.TouchEvent) && (a.preventManipulation && a.preventManipulation(), a.cancelable && a.preventDefault && a.preventDefault());
            }
            var i = !c.isUndefined(window.PointerEvent),
                j = !i && d.isMobile(),
                k = !i && !j,
                l = d.isFF() && d.isOSX(),
                m = function m(a, j) {
                function m(a) {
                    (k || i && "touch" !== a.pointerType) && s(b.touchEvents.OVER, a);
                }

                function n(a) {
                    (k || i && "touch" !== a.pointerType) && s(b.touchEvents.MOVE, a);
                }

                function o(c) {
                    (k || i && "touch" !== c.pointerType && !a.contains(document.elementFromPoint(c.x, c.y))) && s(b.touchEvents.OUT, c);
                }

                function p(b) {
                    t = b.target, x = e(b, "X"), y = e(b, "Y"), f(b) || (i ? b.isPrimary && (j.preventScrolling && (u = b.pointerId, a.setPointerCapture(u)), d.addEventListener(a, "pointermove", q), d.addEventListener(a, "pointercancel", r), d.addEventListener(a, "pointerup", r)) : k && (d.addEventListener(document, "mousemove", q), l && "object" === b.target.nodeName.toLowerCase() ? d.addEventListener(a, "click", r) : d.addEventListener(document, "mouseup", r)), t && (d.addEventListener(t, "touchmove", q), d.addEventListener(t, "touchcancel", r), d.addEventListener(t, "touchend", r)));
                }

                function q(a) {
                    var c = b.touchEvents,
                        d = 6;
                    if (w) s(c.DRAG, a);else {
                        var f = e(a, "X"),
                            g = e(a, "Y"),
                            i = f - x,
                            k = g - y;
                        i * i + k * k > d * d && (s(c.DRAG_START, a), w = !0, s(c.DRAG, a));
                    }
                    j.preventScrolling && h(a);
                }

                function r(c) {
                    var e = b.touchEvents;
                    i ? (j.preventScrolling && a.releasePointerCapture(u), d.removeEventListener(a, "pointermove", q), d.removeEventListener(a, "pointercancel", r), d.removeEventListener(a, "pointerup", r)) : k && (d.removeEventListener(document, "mousemove", q), d.removeEventListener(document, "mouseup", r)), t && (d.removeEventListener(t, "touchmove", q), d.removeEventListener(t, "touchcancel", r), d.removeEventListener(t, "touchend", r)), w ? s(e.DRAG_END, c) : j.directSelect && c.target !== a || c.type.indexOf("cancel") !== -1 || (i && c instanceof window.PointerEvent ? "touch" === c.pointerType ? s(e.TAP, c) : s(e.CLICK, c) : k ? s(e.CLICK, c) : (s(e.TAP, c), h(c))), t = null, w = !1;
                }

                function s(a, d) {
                    var e;
                    if (j.enableDoubleTap && (a === b.touchEvents.CLICK || a === b.touchEvents.TAP)) if (c.now() - z < A) {
                        var f = a === b.touchEvents.CLICK ? b.touchEvents.DOUBLE_CLICK : b.touchEvents.DOUBLE_TAP;
                        e = g(f, d, v), B.trigger(f, e), z = 0;
                    } else z = c.now();
                    e = g(a, d, v), B.trigger(a, e);
                }
                var t,
                    u,
                    v = a,
                    w = !1,
                    x = 0,
                    y = 0,
                    z = 0,
                    A = 300;
                j = j || {}, i ? (d.addEventListener(a, "pointerdown", p), j.useHover && (d.addEventListener(a, "pointerover", m), d.addEventListener(a, "pointerout", o)), j.useMove && d.addEventListener(a, "pointermove", n)) : k && (d.addEventListener(a, "mousedown", p), j.useHover && (d.addEventListener(a, "mouseover", m), d.addEventListener(a, "mouseout", o)), j.useMove && d.addEventListener(a, "mousemove", n)), d.addEventListener(a, "touchstart", p);
                var B = this;
                return this.triggerEvent = s, this.destroy = function () {
                    d.removeEventListener(a, "touchstart", p), d.removeEventListener(a, "mousedown", p), t && (d.removeEventListener(t, "touchmove", q), d.removeEventListener(t, "touchcancel", r), d.removeEventListener(t, "touchend", r)), i && (j.preventScrolling && a.releasePointerCapture(u), d.removeEventListener(a, "pointerover", m), d.removeEventListener(a, "pointerdown", p), d.removeEventListener(a, "pointermove", q), d.removeEventListener(a, "pointermove", n), d.removeEventListener(a, "pointercancel", r), d.removeEventListener(a, "pointerout", o), d.removeEventListener(a, "pointerup", r)), d.removeEventListener(a, "click", r), d.removeEventListener(a, "mouseover", m), d.removeEventListener(a, "mousemove", n), d.removeEventListener(a, "mouseout", o), d.removeEventListener(document, "mousemove", q), d.removeEventListener(document, "mouseup", r);
                }, this;
            };
            return c.extend(m.prototype, a), m;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    },, function (a, b, c) {
        a.exports = c(62)["default"];
    }, function (a, b) {
        "use strict";

        function c(a) {
            return k[a];
        }

        function d(a) {
            for (var b = 1; b < arguments.length; b++) {
                for (var c in arguments[b]) {
                    Object.prototype.hasOwnProperty.call(arguments[b], c) && (a[c] = arguments[b][c]);
                }
            }return a;
        }

        function e(a, b) {
            for (var c = 0, d = a.length; c < d; c++) {
                if (a[c] === b) return c;
            }return -1;
        }

        function f(a) {
            if ("string" != typeof a) {
                if (a && a.toHTML) return a.toHTML();
                if (null == a) return "";
                if (!a) return a + "";
                a = "" + a;
            }
            return m.test(a) ? a.replace(l, c) : a;
        }

        function g(a) {
            return !a && 0 !== a || !(!p(a) || 0 !== a.length);
        }

        function h(a) {
            var b = d({}, a);
            return b._parent = a, b;
        }

        function i(a, b) {
            return a.path = b, a;
        }

        function j(a, b) {
            return (a ? a + "." : "") + b;
        }
        b.__esModule = !0, b.extend = d, b.indexOf = e, b.escapeExpression = f, b.isEmpty = g, b.createFrame = h, b.blockParams = i, b.appendContextPath = j;
        var k = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;", "=": "&#x3D;" },
            l = /[&<>"'`=]/g,
            m = /[&<>"'`=]/,
            n = Object.prototype.toString;
        b.toString = n;
        var o = function o(a) {
            return "function" == typeof a;
        };
        o(/x/) && (b.isFunction = o = function o(a) {
            return "function" == typeof a && "[object Function]" === n.call(a);
        }), b.isFunction = o;
        var p = Array.isArray || function (a) {
            return !(!a || "object" != (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a))) && "[object Array]" === n.call(a);
        };
        b.isArray = p;
    },, function (a, b) {
        "use strict";

        function c(a, b) {
            var e = b && b.loc,
                f = void 0,
                g = void 0;
            e && (f = e.start.line, g = e.start.column, a += " - " + f + ":" + g);
            for (var h = Error.prototype.constructor.call(this, a), i = 0; i < d.length; i++) {
                this[d[i]] = h[d[i]];
            }Error.captureStackTrace && Error.captureStackTrace(this, c), e && (this.lineNumber = f, this.column = g);
        }
        b.__esModule = !0;
        var d = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
        c.prototype = new Error(), b["default"] = c, a.exports = b["default"];
    }, function (a, b, c) {
        var d, e;
        d = [c(5)], e = function (a) {
            return { localName: function localName(a) {
                    return a ? a.localName ? a.localName : a.baseName ? a.baseName : "" : "";
                }, textContent: function textContent(b) {
                    return b ? b.textContent ? a.trim(b.textContent) : b.text ? a.trim(b.text) : "" : "";
                }, getChildNode: function getChildNode(a, b) {
                    return a.childNodes[b];
                }, numChildren: function numChildren(a) {
                    return a.childNodes ? a.childNodes.length : 0;
                } };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(27), c(44), c(105), c(1)], e = function (a, b, d, e) {
            function f(a) {
                this.providers = b.slice(), this.config = a || {}, this.reorderProviders();
            }
            return f.registerProvider = function (c) {
                var f = c.getName().name;
                if (!d[f]) {
                    if (!e.find(b, e.matches({ name: f }))) {
                        if (!e.isFunction(c.supports)) throw { message: "Tried to register a provider with an invalid object" };
                        b.unshift({ name: f, supports: c.supports });
                    }
                    var g = function g() {};
                    g.prototype = a, c.prototype = new g(), d[f] = c;
                }
            }, f.load = function (a) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(e.map(a, function (a) {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (b) {
                        switch (a.name) {
                            case "html5":
                                !function (a) {
                                    b(c(29));
                                }(c);
                                break;
                            case "flash":
                                !function (a) {
                                    b(c(28));
                                }(c);
                                break;
                            default:
                                b();}
                    }).then(function (a) {
                        a && f.registerProvider(a);
                    });
                }));
            }, e.extend(f.prototype, { reorderProviders: function reorderProviders() {
                    if ("flash" === this.config.primary) {
                        var a = e.indexOf(this.providers, e.findWhere(this.providers, { name: "flash" })),
                            b = this.providers.splice(a, 1)[0],
                            c = e.indexOf(this.providers, e.findWhere(this.providers, { name: "html5" }));
                        this.providers.splice(c, 0, b);
                    }
                }, providerSupports: function providerSupports(a, b) {
                    return a.supports(b);
                }, required: function required(a, b) {
                    return a = a.slice(), e.compact(e.map(this.providers, function (c) {
                        for (var d = !1, e = a.length; e--;) {
                            var f = a[e],
                                g = c.supports(f.sources[0], b);
                            g && a.splice(e, 1), d = d || g;
                        }
                        if (d) return c;
                    }));
                }, choose: function choose(a) {
                    a = e.isObject(a) ? a : {};
                    for (var b = this.providers.length, c = 0; c < b; c++) {
                        var f = this.providers[c];
                        if (this.providerSupports(f, a)) {
                            var g = b - c - 1;
                            return { priority: g, name: f.name, type: a.type, provider: d[f.name] };
                        }
                    }
                    return null;
                } }), f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            return { repo: "https://bce.bdstatic.com/jwplayer/", SkinsIncluded: ["seven"], SkinsLoadable: ["beelden", "bekle", "five", "glow", "roundster", "six", "stormtrooper", "vapor"], dvrSeekLimit: -25 };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(5), c(37)], e = function (a, b) {
            function c(a) {
                a = a.split("-");
                for (var b = 1; b < a.length; b++) {
                    a[b] = a[b].charAt(0).toUpperCase() + a[b].slice(1);
                }return a.join("");
            }

            function d(b, c, d) {
                if ("" === c || void 0 === c || null === c) return "";
                var e = d ? " !important" : "";
                return "string" == typeof c && isNaN(c) ? /png|gif|jpe?g/i.test(c) && c.indexOf("url") < 0 ? "url(" + c + ")" : c + e : 0 === c || "z-index" === b || "opacity" === b ? "" + c + e : /color/i.test(b) ? "#" + a.pad(c.toString(16).replace(/^0x/i, ""), 6) + e : Math.ceil(c) + "px" + e;
            }
            var e = function e(a, c, d) {
                d = d || "all-players";
                var e = "";
                if ("object" == (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(c))) {
                    var g = document.createElement("div");
                    f(g, c), e = "{" + g.style.cssText + "}";
                } else "string" == typeof c && (e = c);
                b.style([[a, a + e]], d);
            },
                f = function f(a, b) {
                if (void 0 !== a && null !== a) {
                    void 0 === a.length && (a = [a]);
                    var e,
                        f = {};
                    for (e in b) {
                        f[e] = d(e, b[e]);
                    }for (var g = 0; g < a.length; g++) {
                        var h,
                            i = a[g];
                        if (void 0 !== i && null !== i) for (e in f) {
                            h = c(e), i.style[h] !== f[e] && (i.style[h] = f[e]);
                        }
                    }
                }
            },
                g = function g(a, b) {
                f(a, { transform: b, webkitTransform: b, msTransform: b, mozTransform: b, oTransform: b });
            },
                h = function h(a, b) {
                f(a, { animation: b, webkitAnimation: b, msAnimation: b, mozAnimation: b, oAnimation: b });
            },
                i = function i(a, b) {
                var c = "rgb";
                a ? (a = String(a).replace("#", ""), 3 === a.length && (a = a.charAt(0) + a.charAt(0) + a.charAt(1) + a.charAt(1) + a.charAt(2) + a.charAt(2))) : a = "000000";
                var d = [parseInt(a.substr(0, 2), 16), parseInt(a.substr(2, 2), 16), parseInt(a.substr(4, 2), 16)];
                return void 0 !== b && 100 !== b && (c += "a", d.push(b / 100)), c + "(" + d.join(",") + ")";
            };
            return { css: e, style: f, clearCss: b.clear, transform: g, animation: h, hexToRgba: i };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            return "2.1.5";
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(47), c(2)], e = function (a, b) {
            var c = a.extend({ constructor: function constructor(a) {
                    this.el = document.createElement("div"), this.el.className = "jw-icon jw-icon-tooltip " + a + " jw-button-color jw-reset jw-hidden", this.container = document.createElement("div"), this.container.className = "jw-overlay jw-reset", this.openClass = "jw-open", this.componentType = "tooltip", this.el.appendChild(this.container);
                }, addContent: function addContent(a) {
                    this.content && this.removeContent(), this.content = a, this.container.appendChild(a);
                }, removeContent: function removeContent() {
                    this.content && (this.container.removeChild(this.content), this.content = null);
                }, hasContent: function hasContent() {
                    return !!this.content;
                }, element: function element() {
                    return this.el;
                }, openTooltip: function openTooltip(a) {
                    this.trigger("open-" + this.componentType, a, { isOpen: !0 }), this.isOpen = !0, b.toggleClass(this.el, this.openClass, this.isOpen);
                }, closeTooltip: function closeTooltip(a) {
                    this.trigger("close-" + this.componentType, a, { isOpen: !1 }), this.isOpen = !1, b.toggleClass(this.el, this.openClass, this.isOpen);
                }, toggleOpenState: function toggleOpenState(a) {
                    this.isOpen ? this.closeTooltip(a) : this.openTooltip(a);
                } });
            return c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(5)], e = function (a) {
            var b = {},
                c = b.pluginPathType = { ABSOLUTE: 0, RELATIVE: 1, CDN: 2 };
            return b.getPluginPathType = function (b) {
                if ("string" == typeof b) {
                    b = b.split("?")[0];
                    var d = b.indexOf("://");
                    if (d > 0) return c.ABSOLUTE;
                    var e = b.indexOf("/"),
                        f = a.extension(b);
                    return !(d < 0 && e < 0) || f && isNaN(f) ? c.RELATIVE : c.CDN;
                }
            }, b.getPluginName = function (a) {
                return a.replace(/^(.*\/)?([^-]*)-?.*\.(swf|js)$/, "$2");
            }, b.getPluginVersion = function (a) {
                return a.replace(/[^-]*-?([^\.]*).*$/, "$1");
            }, b;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(14), c(39), c(93), c(1), c(3), c(111), c(4), c(6)], e = function (a, b, c, d, e, f, g, h, i) {
            var j = function j() {
                function g(a, b) {
                    var c = e.extend({}, b, { type: a });
                    switch (a) {
                        case "flashThrottle":
                            var d = "resume" !== b.state;
                            this.set("flashThrottle", d), this.set("flashBlocked", d);
                            break;
                        case "flashBlocked":
                            return void this.set("flashBlocked", !0);
                        case "flashUnblocked":
                            return void this.set("flashBlocked", !1);
                        case "volume":
                        case "mute":
                            return void this.set(a, b[a]);
                        case h.JWPLAYER_MEDIA_TYPE:
                            return void (this.mediaModel.get("mediaType") !== b.mediaType && (this.mediaModel.set("mediaType", b.mediaType), this.mediaController.trigger(a, c)));
                        case h.JWPLAYER_PLAYER_STATE:
                            return void this.mediaModel.set("state", b.newstate);
                        case h.JWPLAYER_MEDIA_BUFFER:
                            this.set("buffer", b.bufferPercent);
                        case h.JWPLAYER_MEDIA_META:
                            var f = b.duration;
                            e.isNumber(f) && (this.mediaModel.set("duration", f), this.set("duration", f));
                            break;
                        case h.JWPLAYER_MEDIA_BUFFER_FULL:
                            this.mediaModel.get("playAttempt") ? this.playVideo() : this.mediaModel.on("change:playAttempt", function () {
                                this.playVideo();
                            }, this);
                            break;
                        case h.JWPLAYER_MEDIA_TIME:
                            this.mediaModel.set("position", b.position), this.set("position", b.position), e.isNumber(b.duration) && (this.mediaModel.set("duration", b.duration), this.set("duration", b.duration), b.duration > 0 && this.recordMediaPosition(b.position, b.duration));
                            break;
                        case h.JWPLAYER_PROVIDER_CHANGED:
                            this.set("provider", l.getName());
                            break;
                        case h.JWPLAYER_MEDIA_LEVELS:
                            this.setQualityLevel(b.currentQuality, b.levels), this.mediaModel.set("levels", b.levels);
                            break;
                        case h.JWPLAYER_MEDIA_LEVEL_CHANGED:
                            this.setQualityLevel(b.currentQuality, b.levels), this.persistQualityLevel(b.currentQuality, b.levels);
                            break;
                        case h.JWPLAYER_AUDIO_TRACKS:
                            this.setCurrentAudioTrack(b.currentTrack, b.tracks), this.mediaModel.set("audioTracks", b.tracks);
                            break;
                        case h.JWPLAYER_AUDIO_TRACK_CHANGED:
                            this.setCurrentAudioTrack(b.currentTrack, b.tracks);
                            break;
                        case h.JWPLAYER_CONNECTING:
                            this.trigger("connecting");
                            break;
                        case h.JWPLAYER_CONNECT_FAILD:
                            this.trigger("connectFaild");
                            break;
                        case h.JWPLAYER_ALIVE:
                            this.trigger("alive");
                            break;
                        case h.JWPLAYER_NO_LIVE_STREAM:
                            this.trigger("noLiveStream");
                            break;
                        case h.JWPLAYER_LIVE_STOP:
                            this.trigger("liveStop");
                            break;
                        case "stop":
                            this.set("duration", 0);
                            break;
                        case "subtitlesTrackChanged":
                            this.setVideoSubtitleTrack(b.currentTrack, b.tracks);
                            break;
                        case "visualQuality":
                            var g = e.extend({}, b);
                            this.mediaModel.set("visualQuality", g);}
                    this.mediaController.trigger(a, c);
                }
                var j,
                    l,
                    m,
                    n,
                    o = this,
                    p = a.noop;
                this.mediaController = e.extend({}, f), this.mediaModel = new k(), d.model(this), this.set("mediaModel", this.mediaModel), this.setup = function (b) {
                    return n = new c(), e.extend(this.attributes, b, { item: 0, state: i.IDLE, flashBlocked: !1, fullscreen: !1, compactUI: !1, scrubbing: !1, duration: 0, position: 0, buffer: 0 }), a.isMobile() && !b.mobileSdk && this.set("autostart", !1), this.updateProviders(), this;
                }, this.getConfiguration = function () {
                    return e.omit(this.clone(), ["mediaModel"]);
                }, this.updateProviders = function () {
                    j = new b(this.getConfiguration());
                }, this.recordMediaPosition = function (a, b) {
                    var c = m && m.sources && m.sources[0];
                    c && c.file && !isNaN(a) && !isNaN(b) && b > 0 && isFinite(b) !== !1 && e.each(m.sources, function (c) {
                        a < b && a > 2 ? n.setItem("filePostion." + c.file, a) : b === a && n.clearItem("filePostion." + c.file);
                    });
                }, this.getLastPosition = function (b) {
                    var c = 0;
                    return b && "array" === a.typeOf(b.sources) && b.sources.length > 0 && n.getItem("filePostion." + b.sources[0].file) && (c = n.getItem("filePostion." + b.sources[0].file)), c;
                }, this.setQualityLevel = function (a, b) {
                    a > -1 && b.length > 1 && this.mediaModel.set("currentLevel", parseInt(a));
                }, this.setCurrentQuality = function (a) {
                    l.setCurrentQuality(a);
                }, this.persistQualityLevel = function (a, b) {
                    var c = b[a] || {},
                        d = c.label;
                    this.set("qualityLabel", d);
                }, this.setCurrentAudioTrack = function (a, b) {
                    a > -1 && b.length > 0 && a < b.length && this.mediaModel.set("currentAudioTrack", parseInt(a));
                }, this.onMediaContainer = function () {
                    var a = this.get("mediaContainer");
                    p.setContainer(a);
                }, this.changeVideoProvider = function (a) {
                    var b = function b() {
                        this.setVolume(this.get("volume"));
                    };
                    if (this.off("change:mediaContainer", this.onMediaContainer), l && (l.off(null, null, this), l.getContainer() && l.remove()), !a) return l = p = a, void this.set("provider", void 0);
                    p = new a(o.get("id"), o.getConfiguration());
                    var c = this.get("mediaContainer");
                    c ? p.setContainer(c) : this.once("change:mediaContainer", this.onMediaContainer), this.once("change:provider", b, this), this.set("provider", p.getName()), p.getName().name.indexOf("flash") === -1 && (this.set("flashThrottle", void 0), this.set("flashBlocked", !1)), l = p, l.volume(o.get("volume")), l.mute(o.get("mute")), l.on("all", g, this);
                }, this.destroy = function () {
                    l && (l.off(null, null, this), l.destroy());
                }, this.getVideo = function () {
                    return l;
                }, this.setFullscreen = function (a) {
                    a = !!a, a !== o.get("fullscreen") && o.set("fullscreen", a);
                }, this.chooseProvider = function (a) {
                    return j.choose(a).provider;
                }, this.setActiveItem = function (a) {
                    this.mediaModel.off(), this.mediaModel = new k(), this.set("mediaModel", this.mediaModel), this.set("position", a.starttime || 0), this.set("duration", a.duration || 0), this.setProvider(a);
                }, this.setProvider = function (a) {
                    var b = a && a.sources && a.sources[0];
                    if (void 0 !== b) {
                        m = a;
                        var c = this.chooseProvider(b);
                        c && p instanceof c || o.changeVideoProvider(c), p && (p.init && p.init(a), this.trigger("itemReady", a));
                    }
                }, this.getCurrentItem = function () {
                    return m;
                }, this.getProviders = function () {
                    return j;
                }, this.resetProvider = function () {
                    p = null;
                }, this.setVolume = function (a) {
                    a = Math.round(a), a = l && "html5" === l.getName().name ? Math.min(a, 100) : Math.min(a, 500), o.set("volume", a), l && l.volume(a);
                    var b = 0 === a;
                    b !== o.get("mute") && o.setMute(b);
                }, this.enableGPU = function () {
                    l.enableGPU();
                }, this.disableGPU = function () {
                    l.disableGPU();
                }, this.setToken = function (a) {
                    var b = [];"string" == typeof arguments[0] && "string" == typeof arguments[1] && (b[0] = { file: arguments[0], tokenText: arguments[1] }, a = b), l.setToken(a);
                }, this.setMute = function (b) {
                    if (a.exists(b) || (b = !this.get("mute")), this.set("mute", b), l && l.mute(b), !b) {
                        var c = Math.max(10, this.get("volume"));
                        this.setVolume(c);
                    }
                }, this.loadVideo = function (a) {
                    if (!a) {
                        var b = this.get("item");
                        a = this.get("playlist")[b];
                    }
                    a.starttime || (this.get("playlist").length > 1 ? a.starttime = this.getLastPosition(a) : a.starttime = this.get("starttime") || this.getLastPosition(a)), this.set("position", a.starttime || 0), this.set("duration", a.duration || 0), this.mediaModel.set("playAttempt", !0), this.mediaController.trigger(h.JWPLAYER_MEDIA_PLAY_ATTEMPT, { playReason: this.get("playReason") }), l.load(a);
                }, this.stopVideo = function () {
                    l && l.stop();
                }, this.playVideo = function () {
                    l.play();
                }, this.persistCaptionsTrack = function () {
                    var a = this.get("captionsTrack");
                    a ? this.set("captionLabel", a.label) : this.set("captionLabel", "Off");
                }, this.setVideoSubtitleTrack = function (a, b) {
                    this.set("captionsIndex", a), a && b && a <= b.length && b[a - 1].data && this.set("captionsTrack", b[a - 1]), l && l.setSubtitlesTrack && l.setSubtitlesTrack(a);
                }, this.persistVideoSubtitleTrack = function (a) {
                    this.setVideoSubtitleTrack(a), this.persistCaptionsTrack();
                };
            },
                k = j.MediaModel = function () {
                this.set("state", i.IDLE);
            };
            return e.extend(j.prototype, g), e.extend(k.prototype, g), j;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(6)], e = function (a) {
            function b(b) {
                return b === a.COMPLETE || b === a.ERROR ? a.IDLE : b;
            }
            return function (a, c, d) {
                if (c = b(c), d = b(d), c !== d) {
                    var e = c.replace(/(?:ing|d)$/, ""),
                        f = { type: e, newstate: c, oldstate: d, reason: a.mediaModel.get("state") };"play" === e && (f.playReason = a.get("playReason")), this.trigger(e, f);
                }
            };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(5)], e = function (a, b) {
            function c(a) {
                var b = {},
                    c = a.split("\r\n");
                1 === c.length && (c = a.split("\n"));
                var e = 1;
                if (c[0].indexOf(" --> ") > 0 && (e = 0), c.length > e + 1 && c[e + 1]) {
                    var f = c[e],
                        g = f.indexOf(" --> ");
                    g > 0 && (b.begin = d(f.substr(0, g)), b.end = d(f.substr(g + 5)), b.text = c.slice(e + 1).join("<br/>"));
                }
                return b;
            }
            var d = a.seconds;
            return function (a) {
                var d = [];
                a = b.trim(a);
                var e = a.split("\r\n\r\n");
                1 === e.length && (e = a.split("\n\n"));
                for (var f = 0; f < e.length; f++) {
                    if ("WEBVTT" !== e[f]) {
                        var g = c(e[f]);
                        g.text && d.push(g);
                    }
                }return d;
            };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(102), c(104), c(43), c(19)], e = function (a, b, c, d) {
            var e = {},
                f = {},
                g = function g(c, d) {
                return f[c] = new a(new b(e), d), f[c];
            },
                h = function h(a, b, f, g) {
                var h = d.getPluginName(a);
                e[h] || (e[h] = new c(a)), e[h].registerPlugin(a, b, f, g);
            };
            return { loadPlugins: g, registerPlugin: h };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            function a(a) {
                this.message = a;
            }
            var b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            a.prototype = new Error(), a.prototype.name = "InvalidCharacterError", window.btoa || (window.btoa = function (c) {
                for (var d, e, f = String(c), g = 0, h = b, i = ""; f.charAt(0 | g) || (h = "=", g % 1); i += h.charAt(63 & d >> 8 - g % 1 * 8)) {
                    if (e = f.charCodeAt(g += .75), e > 255) throw new a("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
                    d = d << 8 | e;
                }
                return i;
            }), window.atob || (window.atob = function (c) {
                var d = String(c).replace(/=+$/, "");
                if (d.length % 4 == 1) throw new a("'atob' failed: The string to be decoded is not correctly encoded.");
                for (var e, f, g = 0, h = 0, i = ""; f = d.charAt(h++); ~f && (e = g % 4 ? 64 * e + f : f, g++ % 4) ? i += String.fromCharCode(255 & e >> (-2 * g & 6)) : 0) {
                    f = b.indexOf(f);
                }return i;
            });
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (e, t, n) {
        var i, o;
        i = [], o = function () {
            "object" != (typeof JSON === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(JSON)) && (JSON = {}), function () {
                "use strict";

                function e(a) {
                    return a < 10 ? "0" + a : a;
                }

                function t(a) {
                    return o.lastIndex = 0, o.test(a) ? '"' + a.replace(o, function (a) {
                        var b = s[a];
                        return "string" == typeof b ? b : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                    }) + '"' : '"' + a + '"';
                }

                function n(b, c) {
                    var d,
                        e,
                        f,
                        g,
                        h,
                        i = r,
                        j = c[b];
                    switch (j && "object" == (typeof j === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(j)) && "function" == typeof j.toJSON && (j = j.toJSON(b)), "function" == typeof l && (j = l.call(c, b, j)), typeof j === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(j)) {
                        case "string":
                            return t(j);
                        case "number":
                            return isFinite(j) ? String(j) : "null";
                        case "boolean":
                        case "null":
                            return String(j);
                        case "object":
                            if (!j) return "null";
                            if (r += a, h = [], "[object Array]" === Object.prototype.toString.apply(j)) {
                                for (g = j.length, d = 0; d < g; d += 1) {
                                    h[d] = n(d, j) || "null";
                                }return f = 0 === h.length ? "[]" : r ? "[\n" + r + h.join(",\n" + r) + "\n" + i + "]" : "[" + h.join(",") + "]", r = i, f;
                            }
                            if (l && "object" == (typeof l === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(l))) for (g = l.length, d = 0; d < g; d += 1) {
                                "string" == typeof l[d] && (e = l[d], f = n(e, j), f && h.push(t(e) + (r ? ": " : ":") + f));
                            } else for (e in j) {
                                Object.prototype.hasOwnProperty.call(j, e) && (f = n(e, j), f && h.push(t(e) + (r ? ": " : ":") + f));
                            }return f = 0 === h.length ? "{}" : r ? "{\n" + r + h.join(",\n" + r) + "\n" + i + "}" : "{" + h.join(",") + "}", r = i, f;}
                }"function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function () {
                    return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + e(this.getUTCMonth() + 1) + "-" + e(this.getUTCDate()) + "T" + e(this.getUTCHours()) + ":" + e(this.getUTCMinutes()) + ":" + e(this.getUTCSeconds()) + "Z" : null;
                }, String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function () {
                    return this.valueOf();
                });
                var i, o, r, a, s, l;"function" != typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a && (o = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, s = { "\b": "\\b", "\t": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", '"': '\\"', "\\": "\\\\" }, JSON.stringify = function (b, c, d) {
                    var e;
                    if (r = "", a = "", "number" == typeof d) for (e = 0; e < d; e += 1) {
                        a += " ";
                    } else "string" == typeof d && (a = d);
                    if (l = c, c && "function" != typeof c && ("object" != (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(c)) || "number" != typeof c.length)) throw new Error("JSON.stringify");
                    return n("", { "": b });
                }), "function" != typeof JSON.parse && (i = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, JSON.parse = function (e, t) {
                    function n(a, b) {
                        var c,
                            d,
                            e = a[b];
                        if (e && "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(e))) for (c in e) {
                            Object.prototype.hasOwnProperty.call(e, c) && (d = n(e, c), void 0 !== d ? e[c] = d : delete e[c]);
                        }return t.call(a, b, e);
                    }
                    var o;
                    if (e = String(e), i.lastIndex = 0, i.test(e) && (e = e.replace(i, function (a) {
                        return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                    })), /^[\],:{}\s]*$/.test(e.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) return o = eval("(" + e + ")"), "function" == typeof t ? n({ "": o }, "") : o;
                    throw new SyntaxError("JSON.parse");
                });
            }(), window.JSON || (window.JSON = JSON);
        }.apply(t, i), !(void 0 !== o && (e.exports = o));
    }, function (a, b, c) {
        var d, e;
        d = [c(1)], e = function (a) {
            function b(a, b) {
                return function () {
                    a.apply(b, arguments);
                };
            }

            function c(a) {
                if ("object" != __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this)) throw new TypeError("Promises must be constructed via new");
                if ("function" != typeof a) throw new TypeError("not a function");
                this._state = null, this._value = null, this._deferreds = [], i(a, b(e, this), b(f, this));
            }

            function d(a) {
                var b = this;
                return null === this._state ? void this._deferreds.push(a) : void j(function () {
                    var c = b._state ? a.onFulfilled : a.onRejected;
                    if (null === c) return void (b._state ? a.resolve : a.reject)(b._value);
                    var d;
                    try {
                        d = c(b._value);
                    } catch (e) {
                        return void a.reject(e);
                    }
                    a.resolve(d);
                });
            }

            function e(a) {
                try {
                    if (a === this) throw new TypeError("A promise cannot be resolved with itself.");
                    if (a && ("object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a)) || "function" == typeof a)) {
                        var c = a.then;
                        if ("function" == typeof c) return void i(b(c, a), b(e, this), b(f, this));
                    }
                    this._state = !0, this._value = a, g.call(this);
                } catch (d) {
                    f.call(this, d);
                }
            }

            function f(a) {
                this._state = !1, this._value = a, g.call(this);
            }

            function g() {
                for (var a = 0, b = this._deferreds.length; a < b; a++) {
                    d.call(this, this._deferreds[a]);
                }this._deferreds = null;
            }

            function h(a, b, c, d) {
                this.onFulfilled = "function" == typeof a ? a : null, this.onRejected = "function" == typeof b ? b : null, this.resolve = c, this.reject = d;
            }

            function i(a, b, c) {
                var d = !1;
                try {
                    a(function (a) {
                        d || (d = !0, b(a));
                    }, function (a) {
                        d || (d = !0, c(a));
                    });
                } catch (e) {
                    if (d) return;
                    d = !0, c(e);
                }
            }
            var j = a.defer,
                k = Array.isArray || function (a) {
                return "[object Array]" === Object.prototype.toString.call(a);
            };
            c.prototype["catch"] = function (a) {
                return this.then(null, a);
            }, c.prototype.then = function (a, b) {
                var e = this;
                return new c(function (c, f) {
                    d.call(e, new h(a, b, c, f));
                });
            }, c.all = function () {
                var a = Array.prototype.slice.call(1 === arguments.length && k(arguments[0]) ? arguments[0] : arguments);
                return new c(function (b, c) {
                    function d(f, g) {
                        try {
                            if (g && ("object" == (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(g)) || "function" == typeof g)) {
                                var h = g.then;
                                if ("function" == typeof h) return void h.call(g, function (a) {
                                    d(f, a);
                                }, c);
                            }
                            a[f] = g, 0 === --e && b(a);
                        } catch (i) {
                            c(i);
                        }
                    }
                    if (0 === a.length) return b([]);
                    for (var e = a.length, f = 0; f < a.length; f++) {
                        d(f, a[f]);
                    }
                });
            }, c.resolve = function (a) {
                return a && "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a)) && a.constructor === c ? a : new c(function (b) {
                    b(a);
                });
            }, c.reject = function (a) {
                return new c(function (b, c) {
                    c(a);
                });
            }, c.race = function (a) {
                return new c(function (b, c) {
                    for (var d = 0, e = a.length; d < e; d++) {
                        a[d].then(b, c);
                    }
                });
            }, c._setImmediateFn = function (a) {
                j = a;
            }, window.Promise || (window.Promise = c);
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(4), c(6), c(1)], e = function (a, b, c, d) {
            var e = a.noop,
                f = d.constant(!1),
                g = { supports: f, play: e, load: e, stop: e, volume: e, mute: e, seek: e, resize: e, remove: e, destroy: e, setVisibility: e, setFullscreen: f, getFullscreen: e, getContainer: e, setContainer: f, getName: e, getQualityLevels: e, getCurrentQuality: e, setCurrentQuality: e, getAudioTracks: e, getCurrentAudioTrack: e, setCurrentAudioTrack: e, checkComplete: e, setControls: e, attachMedia: e, detachMedia: e, setState: function setState(a) {
                    var d = this.state || c.IDLE;
                    this.state = a, a !== d && this.trigger(b.JWPLAYER_PLAYER_STATE, { newstate: a });
                }, sendMediaType: function sendMediaType(a) {
                    var c = a[0].type,
                        d = "oga" === c || "aac" === c || "mp3" === c || "mpeg" === c || "vorbis" === c;
                    this.trigger(b.JWPLAYER_MEDIA_TYPE, { mediaType: d ? "audio" : "video" });
                } };
            return g;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(1), c(4), c(6), c(107), c(27), c(3)], e = function (a, b, c, d, e, f, g) {
            function h(a) {
                return a + "_swf_" + k++;
            }

            function i(b) {
                var c = document.createElement("a");
                c.href = b.flashplayer;
                var d = c.hostname === window.location.host;
                return a.isChrome() && !d;
            }

            function j(j, k) {
                function l(a) {
                    if (H) for (var b = 0; b < a.length; b++) {
                        var c = a[b];
                        if (c.bitrate) {
                            var d = Math.round(c.bitrate / 1e3);
                            c.label = m(d);
                        }
                    }
                }

                function m(a) {
                    var b = H[a];
                    if (!b) {
                        for (var c = 1 / 0, d = H.bitrates.length; d--;) {
                            var e = Math.abs(H.bitrates[d] - a);
                            if (e > c) break;
                            c = e;
                        }
                        b = H.labels[H.bitrates[d + 1]], H[a] = b;
                    }
                    return b;
                }

                function n() {
                    var a = k.hlslabels;
                    if (!a) return null;
                    var b = {},
                        c = [];
                    for (var d in a) {
                        var e = parseFloat(d);
                        if (!isNaN(e)) {
                            var f = Math.round(e);
                            b[f] = a[d], c.push(f);
                        }
                    }
                    return 0 === c.length ? null : (c.sort(function (a, b) {
                        return a - b;
                    }), { labels: b, bitrates: c });
                }

                function o() {
                    v = setTimeout(function () {
                        g.trigger.call(E, "flashBlocked");
                    }, 4e3), s.once("embedded", function () {
                        q(), g.trigger.call(E, "flashUnblocked");
                    }, E);
                }

                function p() {
                    q(), o();
                }

                function q() {
                    clearTimeout(v), a.removeEventListener(window, "focus", p, !1);
                }
                var r,
                    s,
                    t,
                    u = null,
                    v = -1,
                    w = !1,
                    x = -1,
                    y = null,
                    z = -1,
                    A = null,
                    B = !0,
                    C = !1,
                    D = null,
                    E = this,
                    F = function F() {
                    return s && s.__ready;
                },
                    G = function G() {
                    s && s.triggerFlash.apply(s, arguments);
                },
                    H = n();
                b.extend(this, g, { init: function init(a) {
                        a.preload && "none" !== a.preload && !k.autostart && (u = a);
                    }, load: function load(a) {
                        u = a, w = !1, this.setState(d.LOADING), G("load", a), a.sources.length && "hls" !== a.sources[0].type && this.sendMediaType(a.sources);
                    }, play: function play() {
                        G("play");
                    }, pause: function pause() {
                        G("pause"), this.setState(d.PAUSED);
                    }, stop: function stop() {
                        G("stop"), x = -1, u = null, D = null, this.setState(d.IDLE), this.trigger("stop");
                    }, seek: function seek(a) {
                        G("seek", a);
                    }, volume: function volume(a) {
                        if (b.isNumber(a)) {
                            var c = Math.min(Math.max(0, a), 100);
                            F() && G("volume", c);
                        }
                    }, enableGPU: function enableGPU() {
                        G("enableGPU");
                    }, disableGPU: function disableGPU() {
                        G("disableGPU");
                    }, setToken: function setToken(a) {
                        G("setToken", a);
                    }, mute: function mute(a) {
                        F() && G("mute", a);
                    }, setState: function setState() {
                        return f.setState.apply(this, arguments);
                    }, checkComplete: function checkComplete() {
                        return w;
                    }, attachMedia: function attachMedia() {
                        B = !0, w && (this.setState(d.COMPLETE), this.trigger(c.JWPLAYER_MEDIA_COMPLETE), w = !1);
                    }, detachMedia: function detachMedia() {
                        return B = !1, null;
                    }, getSwfObject: function getSwfObject(a) {
                        var b = a.getElementsByTagName("object")[0];
                        return b ? (b.off(null, null, this), b) : e.embed(k.flashplayer, a, h(j), k.wmode, k.playlistItem);
                    }, getContainer: function getContainer() {
                        return r;
                    }, setContainer: function setContainer(e) {
                        if (r !== e) {
                            r = e, s = this.getSwfObject(e), document.hasFocus() ? o() : a.addEventListener(window, "focus", p, !1), s.once("ready", function () {
                                q(), s.once("pluginsLoaded", function () {
                                    s.queueCommands = !1, G("setupCommandQueue", s.__commandQueue), s.__commandQueue = [];
                                });
                                var a = b.extend({}, k),
                                    d = s.triggerFlash("setup", a);
                                d === s ? s.__ready = !0 : this.trigger(c.JWPLAYER_MEDIA_ERROR, d), u && G("init", u);
                            }, this);
                            var f = [c.JWPLAYER_MEDIA_META, c.JWPLAYER_MEDIA_ERROR, c.JWPLAYER_MEDIA_SEEK, c.JWPLAYER_MEDIA_SEEKED, "subtitlesTracks", "subtitlesTrackChanged", "subtitlesTrackData", "mediaType"],
                                h = [c.JWPLAYER_MEDIA_BUFFER, c.JWPLAYER_MEDIA_TIME],
                                j = [c.JWPLAYER_MEDIA_BUFFER_FULL];
                            s.on(c.JWPLAYER_MEDIA_LEVELS, function (a) {
                                l(a.levels), x = a.currentQuality, y = a.levels, this.trigger(a.type, a);
                            }, this), s.on(c.JWPLAYER_MEDIA_LEVEL_CHANGED, function (a) {
                                l(a.levels), x = a.currentQuality, y = a.levels, this.trigger(a.type, a);
                            }, this), s.on(c.JWPLAYER_AUDIO_TRACKS, function (a) {
                                z = a.currentTrack, A = a.tracks, this.trigger(a.type, a);
                            }, this), s.on(c.JWPLAYER_AUDIO_TRACK_CHANGED, function (a) {
                                z = a.currentTrack, A = a.tracks, this.trigger(a.type, a);
                            }, this), s.on(c.JWPLAYER_PLAYER_STATE, function (a) {
                                var b = a.newstate;
                                b !== d.IDLE && this.setState(b);
                            }, this), s.on(h.join(" "), function (a) {
                                "Infinity" === a.duration && (a.duration = 1 / 0), this.trigger(a.type, a);
                            }, this), s.on(f.join(" "), function (a) {
                                this.trigger(a.type, a);
                            }, this), s.on(j.join(" "), function (a) {
                                this.trigger(a.type);
                            }, this), s.on(c.JWPLAYER_CONNECTING, function (a) {
                                g.trigger.call(E, "connecting", a);
                            }, this), s.on(c.JWPLAYER_CONNECT_FAILD, function (a) {
                                g.trigger.call(E, "connectFaild", a), g.trigger.call(E, c.JWPLAYER_MEDIA_ERROR, { message: "连接已断开，请稍后重试" });
                            }, this), s.on(c.JWPLAYER_ALIVE, function (a) {
                                g.trigger.call(E, "alive", a);
                            }, this), s.on(c.JWPLAYER_NO_LIVE_STREAM, function (a) {
                                g.trigger.call(E, "noLiveStream", a);
                            }, this), s.on(c.JWPLAYER_LIVE_STOP, function (a) {
                                g.trigger.call(E, "liveStop", a);
                            }, this), s.on(c.JWPLAYER_CUEPOINT, function (a) {
                                g.trigger.call(E, a.name, a.args);
                            }, this), s.on(c.JWPLAYER_MEDIA_BEFORECOMPLETE, function (a) {
                                w = !0, this.trigger(a.type), B === !0 && (w = !1);
                            }, this), s.on(c.JWPLAYER_MEDIA_COMPLETE, function (a) {
                                w || (this.setState(d.COMPLETE), this.trigger(a.type));
                            }, this), s.on("visualQuality", function (a) {
                                a.reason = a.reason || "api", this.trigger("visualQuality", a), this.trigger(c.JWPLAYER_PROVIDER_FIRST_FRAME, {});
                            }, this), s.on(c.JWPLAYER_PROVIDER_CHANGED, function (a) {
                                t = a.message, this.trigger(c.JWPLAYER_PROVIDER_CHANGED, a);
                            }, this), s.on(c.JWPLAYER_ERROR, function (b) {
                                a.log("Error playing media: %o %s", b.code, b.message, b), this.trigger(c.JWPLAYER_MEDIA_ERROR, b);
                            }, this), i(k) && s.on("throttle", function (a) {
                                q(), "resume" === a.state ? g.trigger.call(E, "flashThrottle", a) : v = setTimeout(function () {
                                    g.trigger.call(E, "flashThrottle", a);
                                }, 250);
                            }, this);
                        }
                    }, remove: function remove() {
                        x = -1, y = null, e.remove(s);
                    }, setVisibility: function setVisibility(a) {
                        a = !!a, r.style.opacity = a ? 1 : 0;
                    }, resize: function resize(a, b, c) {
                        c && G("stretch", c);
                    }, setControls: function setControls(a) {
                        G("setControls", a);
                    }, setFullscreen: function setFullscreen(a) {
                        C = a, G("fullscreen", a);
                    }, getFullScreen: function getFullScreen() {
                        return C;
                    }, setCurrentQuality: function setCurrentQuality(a) {
                        G("setCurrentQuality", a);
                    }, getCurrentQuality: function getCurrentQuality() {
                        return x;
                    }, setSubtitlesTrack: function setSubtitlesTrack(a) {
                        G("setSubtitlesTrack", a);
                    }, getName: function getName() {
                        return t ? { name: "flash_" + t } : { name: "flash" };
                    }, getQualityLevels: function getQualityLevels() {
                        return y || u.sources;
                    }, getAudioTracks: function getAudioTracks() {
                        return A;
                    }, getCurrentAudioTrack: function getCurrentAudioTrack() {
                        return z;
                    }, setCurrentAudioTrack: function setCurrentAudioTrack(a) {
                        G("setCurrentAudioTrack", a);
                    }, destroy: function destroy() {
                        q(), this.remove(), s && (s.off(), s = null), r = null, u = null, this.off();
                    } }), this.trigger = function (a, b) {
                    if (B) return g.trigger.call(this, a, b);
                };
            }
            var k = 0,
                l = function l() {};
            return l.prototype = f, j.prototype = new l(), j.getName = function () {
                return { name: "flash" };
            }, j;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(16), c(2), c(30), c(1), c(4), c(6), c(27), c(3), c(106)], e = function (a, b, c, d, e, f, g, h, i) {
            function j(a, c) {
                b.foreach(a, function (a, d) {
                    b.addEventListener(c, a, d, !1);
                });
            }

            function k(a, c) {
                b.foreach(a, function (a, d) {
                    b.removeEventListener(c, a, d, !1);
                });
            }

            function l(a) {
                if ("hls" === a.type) if (a.androidhls !== !1) {
                    var c = b.isAndroidNative;
                    if (c(2) || c(3) || c("4.0")) return !1;
                    if (b.isAndroid()) return !0;
                } else if (b.isAndroid()) return !1;
                return null;
            }

            function m(m, x) {
                function y() {
                    xa && (ha(Ja.audioTracks), ra.setTextTracks(Ja.textTracks), Ja.setAttribute("jw-loaded", "data"));
                }

                function z() {
                    xa && Ja.setAttribute("jw-loaded", "started");
                }

                function A(a) {
                    ra.trigger("click", a);
                }

                function B() {
                    xa && !za && (I(H()), F(aa(), oa, na));
                }

                function C() {
                    xa && F(aa(), oa, na);
                }

                function D() {
                    n(va), ta = !0, xa && (ra.state === f.STALLED ? ra.setState(f.PLAYING) : ra.state === f.PLAYING && (va = setTimeout(_, o)), za && Ja.duration === 1 / 0 && 0 === Ja.currentTime || (I(H()), G(Ja.currentTime), F(aa(), oa, na), ra.state === f.PLAYING && (ra.trigger(e.JWPLAYER_MEDIA_TIME, { position: oa, duration: na }), E())));
                }

                function E() {
                    var a = Ha.level;
                    if (a.width !== Ja.videoWidth || a.height !== Ja.videoHeight) {
                        if (a.width = Ja.videoWidth, a.height = Ja.videoHeight, la(), !a.width || !a.height) return;
                        Ha.reason = Ha.reason || "auto", Ha.mode = "hls" === qa[ya].type ? "auto" : "manual", Ha.bitrate = 0, a.index = ya, a.label = qa[ya].label, ra.trigger("visualQuality", Ha), Ha.reason = "";
                    }
                }

                function F(a, b, c) {
                    a === wa && c === na || (wa = a, ra.trigger(e.JWPLAYER_MEDIA_BUFFER, { bufferPercent: 100 * a, position: b, duration: c }));
                }

                function G(a) {
                    na < 0 && (a = -(Y() - a)), oa = a;
                }

                function H() {
                    var a = Ja.duration,
                        b = Y();
                    if (a === 1 / 0 && b) {
                        var c = b - Ja.seekable.start(0);
                        c !== 1 / 0 && c > 120 && (a = -c);
                    }
                    return a;
                }

                function I(a) {
                    na = a, ua && a && a !== 1 / 0 && ra.seek(ua);
                }

                function J() {
                    var a = H();
                    za && a === 1 / 0 && (a = 0), ra.trigger(e.JWPLAYER_MEDIA_META, { duration: a, height: Ja.videoHeight, width: Ja.videoWidth, metadata: { duration: a, height: Ja.videoHeight, width: Ja.videoWidth } }), I(a);
                }

                function K() {
                    xa && (ta = !0, za || la(), M());
                }

                function L() {
                    xa && (Ja.muted && (Ja.muted = !1, Ja.muted = !0), Ja.setAttribute("jw-loaded", "meta"), J());
                }

                function M() {
                    pa || (pa = !0, ra.trigger(e.JWPLAYER_MEDIA_BUFFER_FULL));
                }

                function N() {
                    ra.setState(f.PLAYING), Ja.hasAttribute("jw-played") || Ja.setAttribute("jw-played", ""), ra.trigger(e.JWPLAYER_PROVIDER_FIRST_FRAME, {});
                }

                function O() {
                    ra.state !== f.COMPLETE && Ja.currentTime !== Ja.duration && ra.setState(f.PAUSED);
                }

                function P() {
                    za || Ja.paused || Ja.ended || ra.state !== f.LOADING && ra.state !== f.ERROR && (ra.seeking || ra.setState(f.STALLED));
                }

                function Q() {
                    xa && (b.log("Error playing media: %o %s", Ja.error, Ja.src), ra.trigger(e.JWPLAYER_MEDIA_ERROR, { message: "Error loading media: File could not be played", code: "111" }));
                }

                function R(a) {
                    var c;
                    return "array" === b.typeOf(a) && a.length > 0 && (c = d.map(a, function (a, b) {
                        return { label: a.label || b };
                    })), c;
                }

                function S(a) {
                    qa = a, ya = T(a);
                    var b = R(a);
                    b && ra.trigger(e.JWPLAYER_MEDIA_LEVELS, { levels: b, currentQuality: ya });
                }

                function T(a) {
                    var b = Math.max(0, ya),
                        c = x.qualityLabel;
                    if (a) for (var d = 0; d < a.length; d++) {
                        if (a[d]["default"] && (b = d), c && a[d].label === c) return d;
                    }return Ha.reason = "initial choice", Ha.level = {}, b;
                }

                function U(a, c) {
                    ua = 0, n(va);
                    var d = document.createElement("source");
                    d.src = qa[ya].file;
                    var e = Ja.src !== d.src,
                        g = Ja.getAttribute("jw-loaded"),
                        h = Ja.hasAttribute("jw-played");
                    e || "none" === g || "started" === g ? (na = c, V(qa[ya]), ra.setupSideloadedTracks(Ga), Ja.load()) : (0 === a && Ja.currentTime > 0 && (ua = -1, ra.seek(a)), Ja.play()), oa = Ja.currentTime, r && !h && (M(), Ja.paused || ra.state === f.PLAYING || ra.setState(f.LOADING)), b.isIOS() && ra.getFullScreen() && (Ja.controls = !0), a > 0 && ra.seek(a);
                }

                function V(a) {
                    Da = null, Ea = -1, Fa = -1, Ha.reason || (Ha.reason = "initial choice", Ha.level = {}), ta = !1, pa = !1, za = l(a), a.preload && a.preload !== Ja.getAttribute("preload") && Ja.setAttribute("preload", a.preload);
                    var b = document.createElement("source");
                    b.src = a.file;
                    var c = Ja.src !== b.src;
                    c && (Ja.setAttribute("jw-loaded", "none"), Ja.src = a.file);
                }

                function W() {
                    Ja && (ra.disableTextTrack(), Ja.removeAttribute("crossorigin"), Ja.removeAttribute("preload"), Ja.removeAttribute("src"), Ja.removeAttribute("jw-loaded"), Ja.removeAttribute("jw-played"), c.emptyElement(Ja), ya = -1, Ga = null, !q && "load" in Ja && Ja.load());
                }

                function X() {
                    for (var a = Ja.seekable ? Ja.seekable.length : 0, b = 1 / 0; a--;) {
                        b = Math.min(b, Ja.seekable.start(a));
                    }return b;
                }

                function Y() {
                    for (var a = Ja.seekable ? Ja.seekable.length : 0, b = 0; a--;) {
                        b = Math.max(b, Ja.seekable.end(a));
                    }return b;
                }

                function Z() {
                    ra.seeking = !1, ra.trigger(e.JWPLAYER_MEDIA_SEEKED);
                }

                function $() {
                    ra.trigger("volume", { volume: Math.round(100 * Ja.volume) }), ra.trigger("mute", { mute: Ja.muted });
                }

                function _() {
                    Ja.currentTime === oa && P();
                }

                function aa() {
                    var a = Ja.buffered,
                        c = Ja.duration;
                    return !a || 0 === a.length || c <= 0 || c === 1 / 0 ? 0 : b.between(a.end(a.length - 1) / c, 0, 1);
                }

                function ba() {
                    if (xa && ra.state !== f.IDLE && ra.state !== f.COMPLETE) {
                        if (n(va), ya = -1, Ba = !0, ra.trigger(e.JWPLAYER_MEDIA_BEFORECOMPLETE), !xa) return;
                        ca();
                    }
                }

                function ca() {
                    n(va), ra.setState(f.COMPLETE), Ba = !1, ra.trigger(e.JWPLAYER_MEDIA_COMPLETE);
                }

                function da(a) {
                    Ca = !0, ga(a), b.isIOS() && (Ja.controls = !1);
                }

                function ea() {
                    for (var a = -1, b = 0; b < Ja.audioTracks.length; b++) {
                        if (Ja.audioTracks[b].enabled) {
                            a = b;
                            break;
                        }
                    }ia(a);
                }

                function fa(a) {
                    Ca = !1, ga(a), b.isIOS() && (Ja.controls = !1);
                }

                function ga(a) {
                    ra.trigger("fullscreenchange", { target: a.target, jwstate: Ca });
                }

                function ha(a) {
                    if (Da = null, a) {
                        if (a.length) {
                            for (var b = 0; b < a.length; b++) {
                                if (a[b].enabled) {
                                    Ea = b;
                                    break;
                                }
                            }Ea === -1 && (Ea = 0, a[Ea].enabled = !0), Da = d.map(a, function (a) {
                                var b = { name: a.label || a.language, language: a.language };
                                return b;
                            });
                        }
                        ra.addTracksListener(a, "change", ea), Da && ra.trigger("audioTracks", { currentTrack: Ea, tracks: Da });
                    }
                }

                function ia(a) {
                    Ja && Ja.audioTracks && Da && a > -1 && a < Ja.audioTracks.length && a !== Ea && (Ja.audioTracks[Ea].enabled = !1, Ea = a, Ja.audioTracks[Ea].enabled = !0, ra.trigger("audioTrackChanged", { currentTrack: Ea, tracks: Da }));
                }

                function ja() {
                    return Da || [];
                }

                function ka() {
                    return Ea;
                }

                function la() {
                    if ("hls" === qa[0].type) {
                        var a = "video";
                        0 === Ja.videoHeight && (a = "audio"), ra.trigger("mediaType", { mediaType: a });
                    }
                }
                this.state = f.IDLE, this.seeking = !1, d.extend(this, h, i), this.trigger = function (a, b) {
                    if (xa) return h.trigger.call(this, a, b);
                }, this.setState = function (a) {
                    if (xa) return g.setState.call(this, a);
                };
                var ma,
                    na,
                    oa,
                    pa,
                    qa,
                    ra = this,
                    sa = { click: A, durationchange: B, ended: ba, error: Q, loadstart: z, loadeddata: y, loadedmetadata: L, canplay: K, playing: N, progress: C, pause: O, seeked: Z, timeupdate: D, volumechange: $, webkitbeginfullscreen: da, webkitendfullscreen: fa },
                    ta = !1,
                    ua = 0,
                    va = -1,
                    wa = -1,
                    xa = !0,
                    ya = -1,
                    za = null,
                    Aa = !!x.sdkplatform,
                    Ba = !1,
                    Ca = !1,
                    Da = null,
                    Ea = -1,
                    Fa = -1,
                    Ga = null,
                    Ha = { level: {} },
                    Ia = document.getElementById(m),
                    Ja = Ia ? Ia.querySelector("video") : void 0;
                Ja = Ja || document.createElement("video"), Ja.className = "jw-video jw-reset", this.isSDK = Aa, this.itemTracks = Ga, this.video = Ja, d.isObject(x.cast) && x.cast.appid && Ja.setAttribute("disableRemotePlayback", ""), j(sa, Ja), u || (Ja.controls = !0, Ja.controls = !1), Ja.setAttribute("x-webkit-airplay", "true"), Ja.setAttribute("webkit-playsinline", "true"), Ja.setAttribute("x5-video-player-type", "h5"), Ja.setAttribute("playsinline", ""), this.stop = function () {
                    n(va), xa && (W(), b.isIETrident() && Ja.pause(), this.setState(f.IDLE));
                }, this.destroy = function () {
                    k(sa, Ja), this.removeTracksListener(Ja.audioTracks, "change", ea), this.removeTracksListener(Ja.textTracks, "change", ra.textTrackChangeHandler), this.remove(), this.off();
                }, this.init = function (a) {
                    xa && (Ga = null, qa = a.sources, ya = T(a.sources), a.sources.length && "hls" !== a.sources[0].type && this.sendMediaType(a.sources), oa = a.starttime || 0, na = a.duration || 0, Ha.reason = "", V(qa[ya]), this.setupSideloadedTracks(a.tracks), Ga = this.itemTracks);
                }, this.load = function (a) {
                    xa && (S(a.sources), a.sources.length && "hls" !== a.sources[0].type && this.sendMediaType(a.sources), r && !Ja.hasAttribute("jw-played") || ra.setState(f.LOADING), U(a.starttime || 0, a.duration || 0));
                }, this.play = function () {
                    return ra.seeking ? (ra.setState(f.LOADING), void ra.once(e.JWPLAYER_MEDIA_SEEKED, ra.play)) : void Ja.play();
                }, this.pause = function () {
                    n(va), Ja.pause(), this.setState(f.PAUSED);
                }, this.seek = function (a) {
                    if (xa) if (a < 0 && (a += X() + Y()), 0 === ua && this.trigger(e.JWPLAYER_MEDIA_SEEK, { position: Ja.currentTime, offset: a }), ta || (ta = !!Y()), ta) {
                        ua = 0;
                        try {
                            ra.seeking = !0, Ja.currentTime = a;
                        } catch (b) {
                            ra.seeking = !1, ua = a;
                        }
                    } else ua = a, s && Ja.paused && Ja.play();
                }, this.volume = function (a) {
                    a = b.between(a / 100, 0, 1), Ja.volume = a;
                }, this.enableGPU = function () {
                    throw "只有使用Flash播放才支持开启GPU";
                }, this.disableGPU = function () {
                    throw "只有使用Flash播放才支持开启GPU";
                }, this.mute = function (a) {
                    Ja.muted = !!a;
                }, this.checkComplete = function () {
                    return Ba;
                }, this.detachMedia = function () {
                    return n(va), this.disableTextTrack(), xa = !1, Ja;
                }, this.attachMedia = function () {
                    xa = !0, ta = !1, this.seeking = !1, Ja.loop = !1, Ba && ca();
                }, this.setContainer = function (a) {
                    ma = a, a.appendChild(Ja);
                }, this.getContainer = function () {
                    return ma;
                }, this.remove = function () {
                    W(), n(va), ma === Ja.parentNode && ma.removeChild(Ja);
                }, this.setVisibility = function (b) {
                    b = !!b, b || t ? a.style(ma, { visibility: "visible", opacity: 1 }) : a.style(ma, { visibility: "", opacity: 0 });
                }, this.resize = function (b, c, d) {
                    if (!(b && c && Ja.videoWidth && Ja.videoHeight)) return !1;
                    var e = { objectFit: "" };
                    if ("uniform" === d) {
                        var f = b / c,
                            g = Ja.videoWidth / Ja.videoHeight;
                        Math.abs(f - g) < .09 && (e.objectFit = "fill", d = "exactfit");
                    }
                    var h = p || t || u || v;
                    if (h) {
                        var i = -Math.floor(Ja.videoWidth / 2 + 1),
                            j = -Math.floor(Ja.videoHeight / 2 + 1),
                            k = Math.ceil(100 * b / Ja.videoWidth) / 100,
                            l = Math.ceil(100 * c / Ja.videoHeight) / 100;"none" === d ? k = l = 1 : "fill" === d ? k = l = Math.max(k, l) : "uniform" === d && (k = l = Math.min(k, l)), e.width = Ja.videoWidth, e.height = Ja.videoHeight, e.top = e.left = "50%", e.margin = 0, a.transform(Ja, "translate(" + i + "px, " + j + "px) scale(" + k.toFixed(2) + ", " + l.toFixed(2) + ")");
                    }
                    return a.style(Ja, e), !1;
                }, this.setFullscreen = function (a) {
                    if (a = !!a) {
                        var c = b.tryCatch(function () {
                            var a = Ja.webkitEnterFullscreen || Ja.webkitEnterFullScreen;
                            a && a.apply(Ja);
                        });
                        return !(c instanceof b.Error) && ra.getFullScreen();
                    }
                    var d = Ja.webkitExitFullscreen || Ja.webkitExitFullScreen;
                    return d && d.apply(Ja), a;
                }, ra.getFullScreen = function () {
                    return Ca || !!Ja.webkitDisplayingFullscreen;
                }, this.setCurrentQuality = function (a) {
                    if (ya !== a && a >= 0 && qa && qa.length > a) {
                        ya = a, Ha.reason = "api", Ha.level = {}, this.trigger(e.JWPLAYER_MEDIA_LEVEL_CHANGED, { currentQuality: a, levels: R(qa) }), x.qualityLabel = qa[a].label;
                        var b = Ja.currentTime || 0,
                            c = Ja.duration || 0;
                        c <= 0 && (c = na), ra.setState(f.LOADING), U(b, c);
                    }
                }, this.getCurrentQuality = function () {
                    return ya;
                }, this.getQualityLevels = function () {
                    return R(qa);
                }, this.getName = function () {
                    return { name: w };
                }, this.setCurrentAudioTrack = ia, this.getAudioTracks = ja, this.getCurrentAudioTrack = ka;
            }
            var n = window.clearTimeout,
                o = 256,
                p = b.isIE(),
                q = b.isMSIE(),
                r = b.isMobile(),
                s = b.isFF(),
                t = b.isAndroidNative(),
                u = b.isIOS(7),
                v = b.isIOS(8),
                w = "html5",
                x = function x() {};
            return x.prototype = g, m.prototype = new x(), m.getName = function () {
                return { name: "html5" };
            }, m;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(5), c(1), c(108)], e = function (a, b, c) {
            var d = {};
            d.createElement = function (a) {
                var b = document.createElement("div");
                return b.innerHTML = a, b.firstChild;
            }, d.styleDimension = function (a) {
                return a + (a.toString().indexOf("%") > 0 ? "" : "px");
            };
            var e = function e(a) {
                return b.isString(a.className) ? a.className.split(" ") : [];
            },
                f = function f(b, c) {
                c = a.trim(c), b.className !== c && (b.className = c);
            };
            return d.classList = function (a) {
                return a.classList ? a.classList : e(a);
            }, d.hasClass = c.hasClass, d.addClass = function (a, c) {
                var d = e(a),
                    g = b.isArray(c) ? c : c.split(" ");
                b.each(g, function (a) {
                    b.contains(d, a) || d.push(a);
                }), f(a, d.join(" "));
            }, d.removeClass = function (a, c) {
                var d = e(a),
                    g = b.isArray(c) ? c : c.split(" ");
                f(a, b.difference(d, g).join(" "));
            }, d.replaceClass = function (a, b, c) {
                var d = a.className || "";
                b.test(d) ? d = d.replace(b, c) : c && (d += " " + c), f(a, d);
            }, d.toggleClass = function (a, c, e) {
                var f = d.hasClass(a, c);
                e = b.isBoolean(e) ? e : !f, e !== f && (e ? d.addClass(a, c) : d.removeClass(a, c));
            }, d.emptyElement = function (a) {
                for (; a.firstChild;) {
                    a.removeChild(a.firstChild);
                }
            }, d.addStyleSheet = function (a) {
                var b = document.createElement("link");
                b.rel = "stylesheet", b.href = a, document.getElementsByTagName("head")[0].appendChild(b);
            }, d.empty = function (a) {
                if (a) for (; a.childElementCount > 0;) {
                    a.removeChild(a.children[0]);
                }
            }, d.bounds = function (a) {
                var b = { left: 0, right: 0, width: 0, height: 0, top: 0, bottom: 0 };
                if (!a || !document.body.contains(a)) return b;
                var c = a.getBoundingClientRect(a),
                    d = window.pageYOffset,
                    e = window.pageXOffset;
                return c.width || c.height || c.left || c.top ? (b.left = c.left + e, b.right = c.right + e, b.top = c.top + d, b.bottom = c.bottom + d, b.width = c.right - c.left, b.height = c.bottom - c.top, b) : b;
            }, d;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(33)], e = function (a, b) {
            function c(a) {
                return (/^(?:(?:https?|file)\:)?\/\//.test(a)
                );
            }

            function d(b) {
                return a.some(b, function (a) {
                    return "parsererror" === a.nodeName;
                });
            }
            var e = {};
            return e.getAbsolutePath = function (a, d) {
                if (b.exists(d) || (d = document.location.href), b.exists(a)) {
                    if (c(a)) return a;
                    var e,
                        f = d.substring(0, d.indexOf("://") + 3),
                        g = d.substring(f.length, d.indexOf("/", f.length + 1));
                    if (0 === a.indexOf("/")) e = a.split("/");else {
                        var h = d.split("?")[0];
                        h = h.substring(f.length + g.length + 1, h.lastIndexOf("/")), e = h.split("/").concat(a.split("/"));
                    }
                    for (var i = [], j = 0; j < e.length; j++) {
                        e[j] && b.exists(e[j]) && "." !== e[j] && (".." === e[j] ? i.pop() : i.push(e[j]));
                    }return f + g + "/" + i.join("/");
                }
            }, e.getScriptPath = a.memoize(function (a) {
                for (var b = document.getElementsByTagName("script"), c = 0; c < b.length; c++) {
                    var d = b[c].src;
                    if (d && d.indexOf(a) >= 0) return d.substr(0, d.indexOf(a));
                }
                return "";
            }), e.parseXML = function (a) {
                var b = null;
                try {
                    "DOMParser" in window ? (b = new window.DOMParser().parseFromString(a, "text/xml"), (d(b.childNodes) || b.childNodes && d(b.childNodes[0].childNodes)) && (b = null)) : (b = new window.ActiveXObject("Microsoft.XMLDOM"), b.async = "false", b.loadXML(a));
                } catch (c) {}
                return b;
            }, e.serialize = function (a) {
                if (void 0 === a) return null;
                if ("string" == typeof a && a.length < 6) {
                    var b = a.toLowerCase();
                    if ("true" === b) return !0;
                    if ("false" === b) return !1;
                    if (!isNaN(Number(a)) && !isNaN(parseFloat(a))) return Number(a);
                }
                return a;
            }, e.parseDimension = function (a) {
                return "string" == typeof a ? "" === a ? 0 : a.lastIndexOf("%") > -1 ? a : parseInt(a.replace("px", ""), 10) : a;
            }, e.timeFormat = function (a, b) {
                if (a <= 0 && !b) return "00:00";
                var c = a < 0 ? "-" : "";
                a = Math.abs(a);
                var d = Math.floor(a / 3600),
                    e = Math.floor((a - 3600 * d) / 60),
                    f = Math.floor(a % 60);
                return c + (d ? d + ":" : "") + (e < 10 ? "0" : "") + e + ":" + (f < 10 ? "0" : "") + f;
            }, e.adaptiveType = function (a) {
                if (0 !== a) {
                    var b = -120;
                    if (a <= b) return "DVR";
                    if (a < 0 || a === 1 / 0) return "LIVE";
                }
                return "VOD";
            }, e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(4), c(3), c(1)], e = function (a, b, c) {
            var d = {},
                e = { NEW: 0, LOADING: 1, ERROR: 2, COMPLETE: 3 },
                f = function f(_f, g) {
                function h(b) {
                    k = e.ERROR, j.trigger(a.ERROR, b);
                }

                function i(b) {
                    k = e.COMPLETE, j.trigger(a.COMPLETE, b);
                }
                var j = c.extend(this, b),
                    k = e.NEW;
                this.addEventListener = this.on, this.removeEventListener = this.off, this.makeStyleLink = function (a) {
                    var b = document.createElement("link");
                    return b.type = "text/css", b.rel = "stylesheet", b.href = a, b;
                }, this.makeScriptTag = function (a) {
                    var b = document.createElement("script");
                    return b.src = a, b;
                }, this.makeTag = g ? this.makeStyleLink : this.makeScriptTag, this.load = function () {
                    if (k === e.NEW) {
                        var b = d[_f];
                        if (b && (k = b.getStatus(), k < 2)) return b.on(a.ERROR, h), void b.on(a.COMPLETE, i);
                        var c = document.getElementsByTagName("head")[0] || document.documentElement,
                            j = this.makeTag(_f),
                            l = !1;
                        j.onload = j.onreadystatechange = function (a) {
                            l || this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (l = !0, i(a), j.onload = j.onreadystatechange = null, c && j.parentNode && !g && c.removeChild(j));
                        }, j.onerror = h, c.insertBefore(j, c.firstChild), k = e.LOADING, d[_f] = this;
                    }
                }, this.getStatus = function () {
                    return k;
                };
            };
            return f.loaderstatus = e, f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(5)], e = function (a, b) {
            var c = {};
            return c.exists = function (a) {
                switch (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a)) {
                    case "string":
                        return a.length > 0;
                    case "object":
                        return null !== a;
                    case "undefined":
                        return !1;}
                return !0;
            }, c.isHTTPS = function () {
                return 0 === window.location.href.indexOf("https");
            }, c.isRtmp = function (a, b) {
                return 0 === a.indexOf("rtmp") || "rtmp" === b;
            }, c.isHls = function (a, c) {
                return "m3u8" === b.extension(a) || "hls" === b.extension(a) || "hls" === c;
            }, c.isMutipleHls = function (b) {
                if (a.isArray(b) && b.length > 1) {
                    var d = 0;
                    if (a.each(b, function (a) {
                        c.isHls(a.file, a.type) && d++;
                    }), d === b.length) return !0;
                }
                return !1;
            }, c.typeOf = function (b) {
                if (null === b) return "null";
                var c = typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(b);
                return "object" === c && a.isArray(b) ? "array" : c;
            }, c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(47), c(7), c(61), c(2)], e = function (a, b, c, d) {
            var e = a.extend({
                constructor: function constructor(a, b) {
                    this.className = a + " jw-background-color jw-reset", this.orientation = b, this.dragStartListener = this.dragStart.bind(this), this.dragMoveListener = this.dragMove.bind(this), this.dragEndListener = this.dragEnd.bind(this), this.tapListener = this.tap.bind(this), this.setup();
                },
                setup: function setup() {
                    var a = { "default": this["default"], className: this.className, orientation: "jw-slider-" + this.orientation };
                    this.el = d.createElement(c(a)), this.elementRail = d.getElementsByClassName("jw-slider-container", this.el)[0], this.elementBuffer = d.getElementsByClassName("jw-buffer", this.el)[0], this.elementProgress = d.getElementsByClassName("jw-progress", this.el)[0], this.elementThumb = d.getElementsByClassName("jw-knob", this.el)[0], this.userInteract = new b(this.element(), { preventScrolling: !0 }), this.userInteract.on("dragStart", this.dragStartListener), this.userInteract.on("drag", this.dragMoveListener), this.userInteract.on("dragEnd", this.dragEndListener), this.userInteract.on("tap click", this.tapListener);
                },
                dragStart: function dragStart() {
                    this.trigger("dragStart"), this.railBounds = d.bounds(this.elementRail);
                },
                dragEnd: function dragEnd(a) {
                    this.dragMove(a), this.trigger("dragEnd");
                },
                dragMove: function dragMove(a) {
                    var b,
                        c,
                        e = this.railBounds = this.railBounds ? this.railBounds : d.bounds(this.elementRail);"horizontal" === this.orientation ? (b = a.pageX, c = b < e.left ? 0 : b > e.right ? 100 : 100 * d.between((b - e.left) / e.width, 0, 1)) : (b = a.pageY, c = b >= e.bottom ? 0 : b <= e.top ? 100 : 100 * d.between((e.height - (b - e.top)) / e.height, 0, 1));
                    var f = this.limit(c);
                    return this.render(f), "drag" === a.type && d.hasClass(a.currentTarget, "jw-slider-time") || this.update(f), !1;
                },
                tap: function tap(a) {
                    this.railBounds = d.bounds(this.elementRail), this.dragMove(a);
                },
                limit: function limit(a) {
                    return a;
                },
                update: function update(a) {
                    this.trigger("update", {
                        percentage: a
                    });
                },
                render: function render(a) {
                    a = Math.max(0, Math.min(a, 100)), "horizontal" === this.orientation ? (this.elementThumb.style.left = a + "%", this.elementProgress.style.width = a + "%") : (this.elementThumb.style.bottom = a + "%", this.elementProgress.style.height = a + "%");
                },
                updateBuffer: function updateBuffer(a) {
                    a && (this.elementBuffer.style.width = a + "%");
                },
                element: function element() {
                    return this.el;
                }
            });
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        "use strict";

        function d(a) {
            return a && a.__esModule ? a : { "default": a };
        }

        function e(a, b, c) {
            this.helpers = a || {}, this.partials = b || {}, this.decorators = c || {}, i.registerDefaultHelpers(this), j.registerDefaultDecorators(this);
        }
        b.__esModule = !0, b.HandlebarsEnvironment = e;
        var f = c(10),
            g = c(12),
            h = d(g),
            i = c(65),
            j = c(63),
            k = c(73),
            l = d(k),
            m = "4.0.5";
        b.VERSION = m;
        var n = 7;
        b.COMPILER_REVISION = n;
        var o = { 1: "<= 1.0.rc.2", 2: "== 1.0.0-rc.3", 3: "== 1.0.0-rc.4", 4: "== 1.x.x", 5: "== 2.0.0-alpha.x", 6: ">= 2.0.0-beta.1", 7: ">= 4.0.0" };
        b.REVISION_CHANGES = o;
        var p = "[object Object]";
        e.prototype = { constructor: e, logger: l["default"], log: l["default"].log, registerHelper: function registerHelper(a, b) {
                if (f.toString.call(a) === p) {
                    if (b) throw new h["default"]("Arg not supported with multiple helpers");
                    f.extend(this.helpers, a);
                } else this.helpers[a] = b;
            }, unregisterHelper: function unregisterHelper(a) {
                delete this.helpers[a];
            }, registerPartial: function registerPartial(a, b) {
                if (f.toString.call(a) === p) f.extend(this.partials, a);else {
                    if ("undefined" == typeof b) throw new h["default"]('Attempting to register a partial called "' + a + '" as undefined');
                    this.partials[a] = b;
                }
            }, unregisterPartial: function unregisterPartial(a) {
                delete this.partials[a];
            }, registerDecorator: function registerDecorator(a, b) {
                if (f.toString.call(a) === p) {
                    if (b) throw new h["default"]("Arg not supported with multiple decorators");
                    f.extend(this.decorators, a);
                } else this.decorators[a] = b;
            }, unregisterDecorator: function unregisterDecorator(a) {
                delete this.decorators[a];
            } };
        var q = l["default"].log;
        b.log = q, b.createFrame = f.createFrame, b.logger = l["default"];
    },, function (a, b, c) {
        var d;
        d = function (a, b, c) {
            function d(a, b) {
                f(b, g(a));
            }

            function e(a) {
                var b = l[a];
                if (b) {
                    for (var c = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(b), d = 0; d < c.length; d += 1) {
                        for (var e = b[c[d]], f = 0; f < e.parts.length; f += 1) {
                            e.parts[f]();
                        }
                    }delete l[a];
                }
            }

            function f(a, b) {
                for (var c = 0; c < b.length; c++) {
                    var d = b[c],
                        e = (l[a] || {})[d.id];
                    if (e) {
                        for (var f = 0; f < e.parts.length; f++) {
                            e.parts[f](d.parts[f]);
                        }for (; f < d.parts.length; f++) {
                            e.parts.push(j(a, d.parts[f]));
                        }
                    } else {
                        for (var g = [], f = 0; f < d.parts.length; f++) {
                            g.push(j(a, d.parts[f]));
                        }l[a] = l[a] || {}, l[a][d.id] = { id: d.id, parts: g };
                    }
                }
            }

            function g(a) {
                for (var b = [], c = {}, d = 0; d < a.length; d++) {
                    var e = a[d],
                        f = e[0],
                        g = e[1],
                        h = e[2],
                        i = { css: g, media: h };
                    c[f] ? c[f].parts.push(i) : b.push(c[f] = { id: f, parts: [i] });
                }
                return b;
            }

            function h(a) {
                o().appendChild(a);
            }

            function i(a) {
                var b = document.createElement("style");
                return b.type = "text/css", b.setAttribute("data-jwplayer-id", a), h(b), b;
            }

            function j(a, b) {
                var c,
                    d,
                    e,
                    f = m[a];
                f || (f = m[a] = { element: i(a), counter: 0 });
                var g = f.counter++;
                return c = f.element, d = k.bind(null, c, g, !1), e = k.bind(null, c, g, !0), d(b), function (a) {
                    if (a) {
                        if (a.css === b.css && a.media === b.media) return;
                        d(b = a);
                    } else e();
                };
            }

            function k(a, b, c, d) {
                var e = c ? "" : d.css;
                if (a.styleSheet) a.styleSheet.cssText = p(b, e);else {
                    var f = document.createTextNode(e),
                        g = a.childNodes;
                    g[b] && a.removeChild(g[b]), g.length ? a.insertBefore(f, g[b]) : a.appendChild(f);
                }
            }
            var l = {},
                m = {},
                n = function n(a) {
                var b;
                return function () {
                    return "undefined" == typeof b && (b = a.apply(this, arguments)), b;
                };
            },
                o = n(function () {
                return document.head || document.getElementsByTagName("head")[0];
            });
            c.exports = { style: d, clear: e };
            var p = function () {
                var a = [];
                return function (b, c) {
                    return a[b] = c, a.filter(Boolean).join("\n");
                };
            }();
        }.call(b, c, b, a), !(void 0 !== d && (a.exports = d));
    }, function (a, b, c) {
        var d, e;
        d = [c(82), c(1), c(14), c(44), c(23)], e = function (a, b, c, d, e) {
            var f = [],
                g = 0,
                h = function h(b) {
                var c, d;
                return b ? "string" == typeof b ? (c = i(b), c || (d = document.getElementById(b))) : "number" == typeof b ? c = f[b] : b.nodeType && (d = b, c = i(d.id)) : c = f[0], c ? c : d ? j(new a(d, k)) : { registerPlugin: e.registerPlugin };
            },
                i = function i(a) {
                for (var b = 0; b < f.length; b++) {
                    if (f[b].id === a) return f[b];
                }return null;
            },
                j = function j(a) {
                return g++, a.uniqueId = g, f.push(a), a;
            },
                k = function k(a) {
                for (var b = f.length; b--;) {
                    if (f[b].uniqueId === a.uniqueId) {
                        f.splice(b, 1);
                        break;
                    }
                }
            },
                l = { selectPlayer: h, registerProvider: c.registerProvider, availableProviders: d, registerPlugin: e.registerPlugin };
            return h.api = l, l;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(2)], e = function (a, b) {
            function c(a) {
                var b = "baiducyberplayer." + a;
                return b.toString();
            }

            function d() {
                return a.reduce(this.persistItems, function (a, d) {
                    var e = k[c(d)];
                    return e && (a[d] = b.serialize(e)), a;
                }, {});
            }

            function e(a, b) {
                try {
                    k[c(a)] = b;
                } catch (d) {}
            }

            function f(a) {
                return k[c(a)];
            }

            function g(a) {
                return k.removeItem(c(a));
            }

            function h() {
                a.each(this.persistItems, function (a) {
                    k.removeItem(c(a));
                });
            }

            function i() {
                this.persistItems = ["volume", "mute", "captionLabel", "qualityLabel"];
            }

            function j(b) {
                a.each(this.persistItems, function (a) {
                    b.on("change:" + a, function (b, c) {
                        e(a, c);
                    });
                });
            }
            var k = { getItem: b.noop, setItem: b.noop, removeItem: b.noop };
            try {
                k = window.localStorage;
            } catch (l) {}
            return a.extend(i.prototype, { getAllItems: d, track: j, clear: h, setItem: e, getItem: f, clearItem: g }), i;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(42), c(101)], e = function (a, b, c) {
            var d = { sources: [], tracks: [] },
                e = function e(_e) {
                _e = _e || {}, a.isArray(_e.tracks) || delete _e.tracks;
                var f = a.extend({}, d, _e);
                a.isObject(f.sources) && !a.isArray(f.sources) && (f.sources = [b(f.sources)]), a.isArray(f.sources) && 0 !== f.sources.length || (_e.levels ? f.sources = _e.levels : f.sources = [b(_e)]);
                for (var g = 0; g < f.sources.length; g++) {
                    var h = f.sources[g];
                    if (h) {
                        var i = h["default"];
                        i ? h["default"] = "true" === i.toString() : h["default"] = !1, f.sources[g].label || (f.sources[g].label = g.toString()), f.sources[g] = b(f.sources[g]);
                    }
                }
                return f.sources = a.compact(f.sources), a.isArray(f.tracks) || (f.tracks = []), a.isArray(f.captions) && (f.tracks = f.tracks.concat(f.captions), delete f.captions), f.tracks = a.compact(a.map(f.tracks, c)), f;
            };
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(13), c(99), c(2), c(4), c(3), c(1)], e = function (a, b, c, d, e, f) {
            var g = function g() {
                function g(e) {
                    var g = c.tryCatch(function () {
                        var c,
                            g = e.responseXML ? e.responseXML.childNodes : null,
                            h = "";
                        if (g) {
                            for (var k = 0; k < g.length && (h = g[k], 8 === h.nodeType); k++) {}"xml" === a.localName(h) && (h = h.nextSibling), "rss" === a.localName(h) && (c = { playlist: b.parse(h) });
                        }
                        if (!c) try {
                            var l = JSON.parse(e.responseText);
                            if (f.isArray(l)) c = { playlist: l };else {
                                if (!f.isArray(l.playlist)) throw null;
                                c = l;
                            }
                        } catch (m) {
                            return void i("Not a valid RSS/JSON feed");
                        }
                        j.trigger(d.JWPLAYER_PLAYLIST_LOADED, c);
                    });
                    g instanceof c.Error && i();
                }

                function h(a) {
                    i("Playlist load error: " + a);
                }

                function i(a) {
                    j.trigger(d.JWPLAYER_ERROR, { message: a ? a : "Error loading file" });
                }
                var j = f.extend(this, e);
                this.load = function (a) {
                    c.ajax(a, g, h);
                }, this.destroy = function () {
                    this.off();
                };
            };
            return g;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(5), c(1)], e = function (a, b, c) {
            var d = { "default": !1 },
                e = function e(_e2) {
                if (_e2 && _e2.file) {
                    a.isRtmp(_e2.file) && a.isMobile() && _e2.fallbackfile && a.isHls(_e2.fallbackfile) && (_e2.file = _e2.fallbackfile);
                    var f = c.extend({}, d, _e2);
                    f.file = b.trim("" + f.file), f.file = decodeURI(f.file), f.file = f.file.replace("%3F", "?"), f.file = f.file.replace("%3D", "=");
                    var g = /^[^\/]+\/(?:x-)?([^\/]+)$/;
                    if (a.isRtmp(f.file) ? f.type = "rtmp" : g.test(f.type) ? f.type = f.type.replace(g, "$1") : f.type || (f.type = b.extension(f.file)), f.type) {
                        switch (f.type) {
                            case "m3u8":
                            case "vnd.apple.mpegurl":
                                f.type = "hls";
                                break;
                            case "dash+xml":
                                f.type = "dash";
                                break;
                            case "smil":
                                f.type = "rtmp";
                                break;
                            case "m4a":
                                f.type = "aac";}
                        return c.each(f, function (a, b) {
                            "" === a && delete f[b];
                        }), f;
                    }
                }
            };
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(19), c(4), c(3), c(32), c(1)], e = function (a, b, c, d, e, f) {
            var g = { FLASH: 0, JAVASCRIPT: 1, HYBRID: 2 },
                h = function h(_h) {
                function i() {
                    switch (b.getPluginPathType(_h)) {
                        case b.pluginPathType.ABSOLUTE:
                            return _h;
                        case b.pluginPathType.RELATIVE:
                            return a.getAbsolutePath(_h, window.location.href);}
                }

                function j() {
                    f.defer(function () {
                        q = e.loaderstatus.COMPLETE, p.trigger(c.COMPLETE);
                    });
                }

                function k() {
                    q = e.loaderstatus.ERROR, p.trigger(c.ERROR, { url: _h });
                }
                var l,
                    m,
                    n,
                    o,
                    p = f.extend(this, d),
                    q = e.loaderstatus.NEW;
                this.load = function () {
                    if (q === e.loaderstatus.NEW) {
                        if (_h.lastIndexOf(".swf") > 0) return l = _h, q = e.loaderstatus.COMPLETE, void p.trigger(c.COMPLETE);
                        if (b.getPluginPathType(_h) === b.pluginPathType.CDN) return q = e.loaderstatus.COMPLETE, void p.trigger(c.COMPLETE);
                        q = e.loaderstatus.LOADING;
                        var a = new e(i());
                        a.on(c.COMPLETE, j), a.on(c.ERROR, k), a.load();
                    }
                }, this.registerPlugin = function (a, b, d, f) {
                    o && (clearTimeout(o), o = void 0), n = b, d && f ? (l = f, m = d) : "string" == typeof d ? l = d : "function" == typeof d ? m = d : d || f || (l = a), q = e.loaderstatus.COMPLETE, p.trigger(c.COMPLETE);
                }, this.getStatus = function () {
                    return q;
                }, this.getPluginName = function () {
                    return b.getPluginName(_h);
                }, this.getFlashPath = function () {
                    if (l) switch (b.getPluginPathType(l)) {
                        case b.pluginPathType.ABSOLUTE:
                            return l;
                        case b.pluginPathType.RELATIVE:
                            return _h.lastIndexOf(".swf") > 0 ? a.getAbsolutePath(l, window.location.href) : a.getAbsolutePath(l, i());}
                    return null;
                }, this.getJS = function () {
                    return m;
                }, this.getTarget = function () {
                    return n;
                }, this.getPluginmode = function () {
                    return void 0 !== (typeof l === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(l)) && void 0 !== (typeof m === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(m)) ? g.HYBRID : void 0 !== (typeof l === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(l)) ? g.FLASH : void 0 !== (typeof m === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(m)) ? g.JAVASCRIPT : void 0;
                }, this.getNewInstance = function (a, b, c) {
                    return new m(a, b, c);
                }, this.getURL = function () {
                    return _h;
                };
            };
            return h;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(1), c(113)], e = function (a, b, c) {
            function d(b) {
                if ("hls" === b.type) if (b.androidhls !== !1) {
                    var c = a.isAndroidNative;
                    if (c(2) || c(3) || c("4.0")) return !1;
                    if (a.isAndroid()) return !0;
                } else if (a.isAndroid()) return !1;
                return null;
            }
            var e = [{ name: "html5", supports: function supports(b) {
                    var e = { aac: "audio/mp4", mp4: "video/mp4", f4v: "video/mp4", m4v: "video/mp4", mov: "video/mp4", mp3: "audio/mpeg", mpeg: "audio/mpeg", ogv: "video/ogg", ogg: "video/ogg", oga: "video/ogg", vorbis: "video/ogg", webm: "video/webm", f4a: "video/aac", m3u8: "application/vnd.apple.mpegurl", m3u: "application/vnd.apple.mpegurl", hls: "application/vnd.apple.mpegurl" },
                        f = b.file,
                        g = b.type,
                        h = d(b);
                    if (null !== h) return h;
                    if (a.isRtmp(f, g)) return !1;
                    if (!e[g]) return !1;
                    if (a.isEdge() && a.isHls(f, g)) return !1;
                    if (a.isPoorIE()) return !1;
                    if (c.canPlayType) {
                        var i = c.canPlayType(e[g]);
                        return !!i;
                    }
                    return !1;
                } }, { name: "flash", supports: function supports(c) {
                    var d = { flv: "video", f4v: "video", mov: "video", m4a: "video", m4v: "video", mp4: "video", aac: "video", f4a: "video", mp3: "sound", mpeg: "sound", smil: "rtmp", m3u8: "hls", hls: "hls" },
                        e = b.keys(d);
                    if (!a.isFlashSupported()) return !1;
                    var f = c.file,
                        g = c.type;
                    return !!a.isRtmp(f, g) || b.contains(e, g);
                } }];
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(31)], e = function (a, b) {
            function c(a) {
                a.onload = null, a.onprogress = null, a.onreadystatechange = null, a.onerror = null, "abort" in a && a.abort();
            }

            function d(b, d) {
                return function (e) {
                    var f = e.currentTarget || d.xhr;
                    if (clearTimeout(d.timeoutId), d.retryWithoutCredentials && d.xhr.withCredentials) {
                        c(f);
                        var g = a.extend({}, d, { xhr: null, withCredentials: !1, retryWithoutCredentials: !1 });
                        return void l(g);
                    }
                    d.onerror(b, d.url, f);
                };
            }

            function e(a) {
                return function (b) {
                    var c = b.currentTarget || a.xhr;
                    if (4 === c.readyState) {
                        if (clearTimeout(a.timeoutId), c.status >= 400) {
                            var d;
                            return d = 404 === c.status ? "File not found" : "" + c.status + "(" + c.statusText + ")", a.onerror(d, a.url, c);
                        }
                        if (200 === c.status) return f(a)(b);
                    }
                };
            }

            function f(a) {
                return function (c) {
                    var d = c.currentTarget || a.xhr;
                    if (clearTimeout(a.timeoutId), a.responseType) {
                        if ("json" === a.responseType) return g(d, a);
                    } else {
                        var e,
                            f = d.responseXML;
                        if (f) try {
                            e = f.firstChild;
                        } catch (i) {}
                        if (f && e) return h(d, f, a);
                        if (j && d.responseText && !f && (f = b.parseXML(d.responseText), f && f.firstChild)) return h(d, f, a);
                        if (a.requireValidXML) return void a.onerror("Invalid XML", a.url, d);
                    }
                    a.oncomplete(d);
                };
            }

            function g(b, c) {
                if (!b.response || a.isString(b.response) && '"' !== b.responseText.substr(1)) try {
                    b = a.extend({}, b, { response: JSON.parse(b.responseText) });
                } catch (d) {
                    return void c.onerror("Invalid JSON", c.url, b);
                }
                return c.oncomplete(b);
            }

            function h(b, c, d) {
                var e = c.documentElement;
                return d.requireValidXML && ("parsererror" === e.nodeName || e.getElementsByTagName("parsererror").length) ? void d.onerror("Invalid XML", d.url, b) : (b.responseXML || (b = a.extend({}, b, { responseXML: c })), d.oncomplete(b));
            }
            var i = function i() {},
                j = !1,
                k = function k(a) {
                var b = document.createElement("a"),
                    c = document.createElement("a");
                b.href = location.href;
                try {
                    return c.href = a, c.href = c.href, b.protocol + "//" + b.host != c.protocol + "//" + c.host;
                } catch (d) {}
                return !0;
            },
                l = function l(b, g, h, _l) {
                a.isObject(b) && (_l = b, b = _l.url);
                var m,
                    n = a.extend({ xhr: null, url: b, withCredentials: !1, retryWithoutCredentials: !1, timeout: 6e4, timeoutId: -1, oncomplete: g || i, onerror: h || i, mimeType: _l && !_l.responseType ? "text/xml" : "", requireValidXML: !1, responseType: _l && _l.plainText ? "text" : "" }, _l);
                if ("XDomainRequest" in window && k(b)) m = n.xhr = new window.XDomainRequest(), m.onload = f(n), m.ontimeout = m.onprogress = i, j = !0;else {
                    if (!("XMLHttpRequest" in window)) return void n.onerror("", b);
                    m = n.xhr = new window.XMLHttpRequest(), m.onreadystatechange = e(n);
                }
                var o = d("Error loading file", n);
                m.onerror = o, "overrideMimeType" in m ? n.mimeType && m.overrideMimeType(n.mimeType) : j = !0;
                try {
                    b = b.replace(/#.*$/, ""), m.open("GET", b, !0);
                } catch (p) {
                    return o(p), m;
                }
                if (n.responseType) try {
                    m.responseType = n.responseType;
                } catch (p) {}
                n.timeout && (n.timeoutId = setTimeout(function () {
                    c(m), n.onerror("Timeout", b, m);
                }, n.timeout), m.onabort = function () {
                    clearTimeout(n.timeoutId);
                });
                try {
                    n.withCredentials && "withCredentials" in m && (m.withCredentials = !0), m.send();
                } catch (p) {
                    o(p);
                }
                return m;
            };
            return { ajax: l, crossdomain: k };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1)], e = function (a) {
            function b(a) {
                return function () {
                    return d(a);
                };
            }
            var c = {},
                d = a.memoize(function (a) {
                var b = navigator.userAgent.toLowerCase();
                return null !== b.match(a);
            }),
                e = c.isInt = function (a) {
                return parseFloat(a) % 1 === 0;
            };
            c.isFlashSupported = function () {
                var a = c.flashVersion();
                return a && a >= 11.2;
            }, c.isFF = b(/firefox/i), c.isIPod = b(/iP(hone|od)/i), c.isIPad = b(/iPad/i), c.isSafari602 = b(/Macintosh.*Mac OS X 10_8.*6\.0\.\d* Safari/i), c.isOSX = b(/Mac OS X/i), c.isEdge = b(/\sedge\/\d+/i);
            var f = c.isIETrident = function (a) {
                return !!c.isEdge() || (a ? (a = parseFloat(a).toFixed(1), d(new RegExp("trident/.+rv:\\s*" + a, "i"))) : d(/trident/i));
            },
                g = c.isMSIE = function (a) {
                return a ? (a = parseFloat(a).toFixed(1), d(new RegExp("msie\\s*" + a, "i"))) : d(/msie/i);
            },
                h = b(/chrome/i);
            c.isChrome = function () {
                return h() && !c.isEdge();
            }, c.isIE = function (a) {
                return a ? (a = parseFloat(a).toFixed(1), a >= 11 ? f(a) : g(a)) : g() || f();
            }, c.isSafari = function () {
                return d(/safari/i) && !d(/chrome/i) && !d(/chromium/i) && !d(/android/i);
            };
            var i = c.isIOS = function (a) {
                return d(a ? new RegExp("iP(hone|ad|od).+\\s(OS\\s" + a + "|.*\\sVersion/" + a + ")", "i") : /iP(hone|ad|od)/i);
            };
            c.isAndroidNative = function (a) {
                return j(a, !0);
            };
            var j = c.isAndroid = function (a, b) {
                return !(b && d(/chrome\/[123456789]/i) && !d(/chrome\/18/)) && (a ? (e(a) && !/\./.test(a) && (a = "" + a + "."), d(new RegExp("Android\\s*" + a, "i"))) : d(/Android/i));
            };
            return c.isMobile = function () {
                return i() || j();
            }, c.isIframe = function () {
                return window.frameElement && "IFRAME" === window.frameElement.nodeName;
            }, c.flashVersion = function () {
                if (c.isAndroid()) return 0;
                var a,
                    b = navigator.plugins;
                if (b && (a = b["Shockwave Flash"], a && a.description)) return parseFloat(a.description.replace(/\D+(\d+\.?\d*).*/, "$1"));
                if ("undefined" != typeof window.ActiveXObject) {
                    try {
                        if (a = new window.ActiveXObject("ShockwaveFlash.ShockwaveFlash")) return parseFloat(a.GetVariable("$version").split(" ")[1].replace(/\s*,\s*/, "."));
                    } catch (d) {
                        return 0;
                    }
                    return a;
                }
                return 0;
            }, c.getBrowserInfo = function () {
                var a = window.navigator.userAgent.toLowerCase(),
                    b = "";
                if (this.isIE()) b = a.match(/msie ([\d.]+)/) ? "IE-" + a.match(/msie ([\d.]+)/)[1] : "IE-unknown";else if (this.isChrome()) {
                    var c = a.match(/chrome\/([\d.]+)/);
                    b = c && c.length > 1 ? "Chrome-" + c[1] : "Chrome-unknown";
                } else b = this.isFF() ? "Firefox-" + a.match(/firefox\/([\d.]+)/)[1] : this.isSafari() ? "Safari-" + a.match(/version\/([\d.]+)/)[1] : i() ? "ios" : j() ? "android" : "other";
                return b;
            }, c.isPoorIE = function () {
                return this.isIE() && (g(8) || g(7) || g(6) || document.documentMode && document.documentMode <= 8);
            }, c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(3), c(1)], e = function (a, b) {
            function c() {}
            var d = function d(a, c) {
                var d,
                    e = this;
                d = a && b.has(a, "constructor") ? a.constructor : function () {
                    return e.apply(this, arguments);
                }, b.extend(d, e, c);
                var f = function f() {
                    this.constructor = d;
                };
                return f.prototype = e.prototype, d.prototype = new f(), a && b.extend(d.prototype, a), d.__super__ = e.prototype, d;
            };
            return c.extend = d, b.extend(c.prototype, a), c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1)], e = function (a) {
            var b = {},
                c = { TIT2: "title", TT2: "title", WXXX: "url", TPE1: "artist", TP1: "artist", TALB: "album", TAL: "album" };
            return b.utf8ArrayToStr = function (a, b) {
                var c, d, e, f, g, h;
                for (c = "", e = a.length, d = b || 0; d < e;) {
                    if (f = a[d++], 0 !== f && 3 !== f) switch (f >> 4) {
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                            c += String.fromCharCode(f);
                            break;
                        case 12:
                        case 13:
                            g = a[d++], c += String.fromCharCode((31 & f) << 6 | 63 & g);
                            break;
                        case 14:
                            g = a[d++], h = a[d++], c += String.fromCharCode((15 & f) << 12 | (63 & g) << 6 | (63 & h) << 0);}
                }return c;
            }, b.utf16BigEndianArrayToStr = function (a, b) {
                var c, d, e;
                for (c = "", e = a.length - 1, d = b || 0; d < e;) {
                    254 === a[d] && 255 === a[d + 1] || (c += String.fromCharCode((a[d] << 8) + a[d + 1])), d += 2;
                }return c;
            }, b.syncSafeInt = function (a) {
                var c = b.arrayToInt(a);
                return 127 & c | (32512 & c) >> 1 | (8323072 & c) >> 2 | (2130706432 & c) >> 3;
            }, b.arrayToInt = function (a) {
                for (var b = "0x", c = 0; c < a.length; c++) {
                    b += a[c].toString(16);
                }return parseInt(b);
            }, b.parseID3 = function (d) {
                return a.reduce(d, function (d, e) {
                    if (!("value" in e) && "data" in e && e.data instanceof ArrayBuffer) {
                        var f = e,
                            g = new Uint8Array(f.data),
                            h = g.length;
                        e = { value: { key: "", data: "" } };
                        for (var i = 10; i < 14 && i < g.length && 0 !== g[i];) {
                            e.value.key += String.fromCharCode(g[i]), i++;
                        }var j = 19,
                            k = g[j];
                        3 !== k && 0 !== k || (k = g[++j], h--);
                        var l = 0;
                        if (1 !== k && 2 !== k) for (var m = j + 1; m < h; m++) {
                            if (0 === g[m]) {
                                l = m - j;
                                break;
                            }
                        }if (l > 0) {
                            var n = b.utf8ArrayToStr(g.subarray(j, j += l), 0);
                            if ("PRIV" === e.value.key) {
                                if ("com.apple.streaming.transportStreamTimestamp" === n) {
                                    var o = 1 & b.syncSafeInt(g.subarray(j, j += 4)),
                                        p = b.syncSafeInt(g.subarray(j, j += 4));
                                    o && (p += 4294967296), e.value.data = p;
                                } else e.value.data = b.utf8ArrayToStr(g, j + 1);
                                e.value.info = n;
                            } else e.value.info = n, e.value.data = b.utf8ArrayToStr(g, j + 1);
                        } else {
                            var q = g[j];
                            1 === q || 2 === q ? e.value.data = b.utf16BigEndianArrayToStr(g, j + 1) : e.value.data = b.utf8ArrayToStr(g, j + 1);
                        }
                    }
                    if (c.hasOwnProperty(e.value.key) && (d[c[e.value.key]] = e.value.data), e.value.info) {
                        var r = d[e.value.key];
                        a.isObject(r) || (r = {}, d[e.value.key] = r), r[e.value.info] = e.value.data;
                    } else d[e.value.key] = e.value.data;
                    return d;
                }, {});
            }, b;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1)], e = function (a) {
            var b = function b() {
                var b = {},
                    c = {},
                    d = {},
                    e = {};
                return { start: function start(c) {
                        b[c] = a.now(), d[c] = d[c] + 1 || 1;
                    }, end: function end(d) {
                        if (b[d]) {
                            var e = a.now() - b[d];
                            c[d] = c[d] + e || e;
                        }
                    }, dump: function dump() {
                        return { counts: d, sums: c, events: e };
                    }, tick: function tick(b, c) {
                        e[b] = c || a.now();
                    }, between: function between(a, b) {
                        return e[b] && e[a] ? e[b] - e[a] : -1;
                    } };
            };
            return b;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        b = a.exports = c(51)(), b.push([a.id, ".jw-reset{color:inherit;background-color:transparent;padding:0;margin:0;float:none;font-family:Arial,Helvetica,sans-serif;font-size:1em;line-height:1em;list-style:none;text-align:left;text-transform:none;vertical-align:baseline;border:0;direction:ltr;font-variant:inherit;font-stretch:inherit;-webkit-tap-highlight-color:rgba(255,255,255,0)}@font-face{font-family:jw-icons;src:url(" + c(78) + ") format('woff'),url(" + c(79) + ') format(\'truetype\');font-weight:400;font-style:normal}.jw-controlbar .jw-menu .jw-option:before,.jw-icon-display,.jw-icon-inline,.jw-icon-tooltip{font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jw-icon-audio-tracks:before{content:"\\E600"}.jw-icon-buffer:before{content:"\\E601"}.jw-icon-cast:before{content:"\\E603"}.jw-icon-cast.jw-off:before{content:"\\E602"}.jw-icon-cc:before{content:"\\E605"}.jw-icon-cue:before,.jw-icon-menu-bullet:before{content:"\\E606"}.jw-icon-error:before{content:"\\E607"}.jw-icon-fullscreen:before{content:"\\E608"}.jw-icon-fullscreen.jw-off:before{content:"\\E613"}.jw-icon-hd:before{content:"\\E60A"}.jw-rightclick-logo:before,.jw-watermark:before{content:"\\E60B"}.jw-icon-next:before{content:"\\E60C"}.jw-icon-pause:before{content:"\\E60D"}.jw-icon-play:before{content:"\\E60E"}.jw-icon-prev:before{content:"\\E60F"}.jw-icon-replay:before{content:"\\E610"}.jw-icon-volume:before{content:"\\E612"}.jw-icon-volume.jw-off:before{content:"\\E611"}.jw-icon-more:before{content:"\\E614"}.jw-icon-close:before{content:"\\E615"}.jw-icon-playlist:before{content:"\\E616"}.jw-icon-barlogo:before{content:url("data:image/png;base64,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")}.jwplayer{width:100%;font-size:16px;position:relative;display:block;min-height:0;overflow:hidden;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;background-color:#000;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jwplayer *{box-sizing:inherit}.jwplayer.jw-flag-aspect-mode{height:auto!important}.jwplayer.jw-flag-aspect-mode .jw-aspect{display:block}.jwplayer .jw-aspect{display:none}.jwplayer.jw-no-focus:focus,.jwplayer .jw-swf{outline:none}.jwplayer.jw-ie:focus{outline:1px dotted #585858}.jwplayer:hover .jw-display-icon-container{background-color:#333;background:#333;background-size:#333}.jw-adv,.jw-controls,.jw-media,.jw-overlays,.jw-preview{position:absolute;width:100%;height:100%;top:0;left:0;bottom:0;right:0}.jwplayer .jw-adv{background-size:100% 100%;cursor:pointer}.jwplayer .jw-adv .adv-countdown{position:absolute;width:95px;padding-left:10px;height:30px;line-height:30px;background-color:#202020;opacity:.7;color:#ee6002;font-size:14px;top:0;right:0;display:none}.jwplayer .jw-adv .adv-close{position:absolute;height:22px;line-height:22px;color:#fff;font-weight:700;font-size:14px;width:20px;top:0;right:5px;display:none;text-align:center}.jw-media{overflow:hidden;cursor:pointer}.jw-overlays{cursor:auto}.jw-media.jw-media-show{visibility:visible;opacity:1}.jw-controls.jw-controls-disabled{display:none}.jw-controls .jw-controls-right{position:absolute;top:0;right:0;left:0;bottom:2em}.jw-warning{color:red;top:30px;right:10px;position:absolute;z-index:10000;width:320px;display:none}.jw-warning a{color:#108cee}.jw-marquee{opacity:0;color:#fff;width:110px;font-size:16px;font-weight:700;position:absolute}@-webkit-keyframes marquee1{0%{left:100%}to{left:-110px}}@keyframes marquee1{0%{left:100%}to{left:-110px}}@-webkit-keyframes marquee2{0%{left:100%}to{left:-110px}}@keyframes marquee2{0%{left:100%}to{left:-110px}}.jw-text{height:1em;font-family:Arial,Helvetica,sans-serif;font-size:.75em;font-style:normal;font-weight:400;color:#fff;text-align:center;font-variant:normal;font-stretch:normal}.jw-plugin{position:absolute;bottom:2.5em}.jw-plugin .jw-banner{max-width:100%;opacity:0;cursor:pointer;position:absolute;margin:auto auto 0;left:0;right:0;bottom:0;display:block}.jw-cast-screen{width:100%;height:100%}.jw-instream{position:absolute;top:0;right:0;bottom:0;left:0;display:none}.jw-icon-playback:before{content:"\\E60E"}.jw-captions,.jw-controls,.jw-overlays,.jw-preview,.jw-title{pointer-events:none}.jw-controlbar,.jw-display-icon-container,.jw-dock,.jw-logo,.jw-media,.jw-overlays>div,.jw-skip{pointer-events:all}.jwplayer video{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;margin:auto;background:transparent}.jwplayer video::-webkit-media-controls-start-playback-button{display:none}.jwplayer.jw-stretch-uniform video{-o-object-fit:contain;object-fit:contain}.jwplayer.jw-stretch-none video{-o-object-fit:none;object-fit:none}.jwplayer.jw-stretch-fill video{-o-object-fit:cover;object-fit:cover}.jwplayer.jw-stretch-exactfit video{-o-object-fit:fill;object-fit:fill}.jw-adv,.jw-click,.jw-preview{position:absolute;width:100%;height:100%}.jw-adv,.jw-preview{display:none;opacity:1;visibility:visible;background:#000 no-repeat 50% 50%}.jw-error .jw-preview,.jw-stretch-uniform .jw-preview,.jwplayer .jw-preview{background-size:100% 100%}.jw-stretch-none .jw-preview{background-size:auto auto}.jw-stretch-fill .jw-preview{background-size:cover}.jw-stretch-exactfit .jw-preview{background-size:100% 100%}.jw-display-icon-container{position:relative;top:50%;display:table;height:3.5em;width:3.5em;margin:-1.75em auto 0;cursor:pointer}.jw-display-icon-container .jw-icon-display{position:relative;display:table-cell;text-align:center;vertical-align:middle!important;background-position:50% 50%;background-repeat:no-repeat;font-size:2em}.jw-flag-audio-player .jw-display-icon-container,.jw-flag-dragging .jw-display-icon-container{display:none}.jw-icon{font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jw-controlbar{display:table;position:absolute;right:0;left:0;bottom:0;height:2em;padding:0 .25em}.jw-controlbar .jw-hidden{display:none}.jw-controlbar.jw-drawer-expanded .jw-controlbar-center-group,.jw-controlbar.jw-drawer-expanded .jw-controlbar-left-group{opacity:0}.jw-controlbar-textshow .jw-controlbar-center-group .jw-slider-time,.jw-controlbar-textshow .jw-controlbar-center-group .jw-text-duration,.jw-controlbar-textshow .jw-controlbar-center-group .jw-text-elapsed{display:none}.jw-controlbar-textshow .jw-controlbar-center-group .jw-text-alt{display:inline}.jw-background-color{background-color:#414040}.jw-group{display:table-cell}.jw-controlbar-center-group{width:100%;padding:0 .25em}.jw-controlbar-center-group .jw-slider-time,.jw-controlbar-center-group .jw-text-alt{padding:0}.jw-controlbar-center-group .jw-text-alt{display:none}.jw-controlbar-left-group,.jw-controlbar-right-group{white-space:nowrap}.jw-icon-display:hover,.jw-icon-inline:hover,.jw-icon-tooltip:hover,.jw-knob:hover,.jw-option:before:hover{color:#eee}.jw-icon-inline,.jw-icon-tooltip,.jw-slider-horizontal,.jw-text-duration,.jw-text-elapsed{display:inline-block;height:2em;position:relative;line-height:2em;vertical-align:middle;cursor:pointer}.jw-icon-inline,.jw-icon-tooltip{min-width:1.25em;text-align:center}.jw-icon-playback{min-width:2.25em}.jw-icon-barlogo{font-size:18px;min-width:1.75em}.jw-icon-volume{min-width:1.75em;text-align:left}.jw-time-tip{line-height:1em;pointer-events:none}.jw-icon-inline:after,.jw-icon-tooltip:after{width:100%;height:100%;font-size:1em}.jw-icon-cast,.jw-icon-inline.jw-icon-volume,.jw-slider-volume.jw-slider-horizontal{display:none}.jw-dock{margin:.75em;display:block;opacity:1;clear:right}.jw-dock:after{content:\'\';clear:both;display:block}.jw-dock-button{cursor:pointer;float:right;position:relative;width:2.5em;height:2.5em;margin:.5em}.jw-dock-button .jw-arrow{display:none;position:absolute;bottom:-.2em;width:.5em;height:.2em;left:50%;margin-left:-.25em}.jw-dock-button .jw-overlay{display:none;position:absolute;top:2.5em;right:0;margin-top:.25em;padding:.5em;white-space:nowrap}.jw-dock-button:hover .jw-arrow,.jw-dock-button:hover .jw-overlay{display:block}.jw-dock-image{width:100%;height:100%;background-position:50% 50%;background-repeat:no-repeat;opacity:.75}.jw-title{display:none;position:absolute;top:0;width:100%;font-size:.875em;height:8em;background:-webkit-linear-gradient(top,#000,#000 18%,transparent);background:linear-gradient(180deg,#000 0,#000 18%,transparent)}.jw-title-primary,.jw-title-secondary{padding:.75em 1.5em;min-height:2.5em;width:100%;color:#fff;white-space:nowrap;text-overflow:ellipsis;overflow-x:hidden}.jw-title-primary{font-weight:700}.jw-title-secondary{margin-top:-.5em}.jw-slider-container{display:inline-block;height:1em;position:relative;touch-action:none}.jw-buffer,.jw-progress,.jw-rail{position:absolute;cursor:pointer}.jw-progress{background-color:#fff}.jw-rail{background-color:#aaa}.jw-buffer{background-color:#202020}.jw-cue,.jw-knob{position:absolute;cursor:pointer}.jw-cue{background-color:#fff;width:.1em;height:.4em}.jw-knob{background-color:#aaa;width:.4em;height:.4em}.jw-slider-horizontal{width:4em;height:1em}.jw-slider-horizontal.jw-slider-volume{margin-right:5px}.jw-slider-horizontal .jw-buffer,.jw-slider-horizontal .jw-progress,.jw-slider-horizontal .jw-rail{width:100%;height:.4em}.jw-slider-horizontal .jw-buffer,.jw-slider-horizontal .jw-progress{width:0}.jw-slider-horizontal .jw-progress,.jw-slider-horizontal .jw-rail,.jw-slider-horizontal .jw-slider-container{width:100%}.jw-slider-horizontal .jw-knob{left:0;margin-left:-.325em}.jw-slider-vertical{width:.75em;height:4em;bottom:0;position:absolute;padding:1em}.jw-slider-vertical .jw-buffer,.jw-slider-vertical .jw-progress,.jw-slider-vertical .jw-rail{bottom:0;height:100%}.jw-slider-vertical .jw-buffer,.jw-slider-vertical .jw-progress{height:0}.jw-slider-vertical .jw-progress,.jw-slider-vertical .jw-rail,.jw-slider-vertical .jw-slider-container{bottom:0;width:.75em;height:100%;left:0;right:0;margin:0 auto}.jw-slider-vertical .jw-slider-container{height:4em;position:relative}.jw-slider-vertical .jw-knob{bottom:0;left:0;right:0;margin:0 auto}.jw-slider-time{right:0;left:0;width:100%}.jw-tooltip-time{position:absolute}.jw-slider-volume .jw-buffer{display:none}.jw-captions{position:absolute;display:none;margin:0 auto;width:100%;left:0;bottom:3em;right:0;max-width:90%;text-align:center}.jw-captions.jw-captions-enabled{display:block}.jw-captions-window{display:none;padding:.25em;border-radius:.25em}.jw-captions-text,.jw-captions-window.jw-captions-window-active{display:inline-block}.jw-captions-text{color:#fff;background-color:#000;word-wrap:break-word;white-space:pre-line;font-style:normal;font-weight:400;text-align:center;text-decoration:none;line-height:1.3em;padding:.1em .8em}.jwplayer video::-webkit-media-controls{-webkit-box-pack:start;justify-content:flex-start}.jwplayer video::-webkit-media-text-track-container{max-height:84.5%;line-height:1.3em}.jwplayer.jw-flag-compact-player video::-webkit-media-text-track-container{max-height:82%}.jwplayer .jw-rightclick{display:none;position:absolute;white-space:nowrap}.jwplayer .jw-rightclick.jw-open{display:block}.jwplayer .jw-rightclick ul{list-style:none;font-weight:700;border-radius:.15em;margin:0;border:1px solid #444;padding:0}.jwplayer .jw-rightclick ul li{background-color:#000;border-bottom:1px solid #444;margin:0}.jwplayer .jw-rightclick ul li .jw-rightclick-logo{font-size:2em;color:#ff0147;vertical-align:middle;padding-right:.3em;margin-right:.3em;border-right:1px solid #444}.jwplayer .jw-rightclick ul li a{color:#fff;text-decoration:none;padding:1em;display:block;font-size:.6875em;line-height:1em}.jwplayer .jw-rightclick ul li:last-child{border-bottom:none}.jwplayer .jw-rightclick ul li:hover{background-color:#1a1a1a;cursor:pointer}.jwplayer .jw-rightclick ul .jw-featured{background-color:#252525;vertical-align:middle}.jwplayer .jw-rightclick ul .jw-featured a{color:#777}.jw-logo{position:absolute;margin:.75em;cursor:pointer;pointer-events:all;background-repeat:no-repeat;background-size:contain;top:auto;right:auto;left:auto;bottom:auto}.jw-logo .jw-flag-audio-player{display:none}.jw-logo-top-right{top:0;right:0}.jw-logo-top-left{top:0;left:0}.jw-logo-bottom-left{bottom:0;left:0}.jw-logo-bottom-right,.jw-watermark{bottom:0;right:0}.jw-watermark{position:absolute;top:50%;left:0;text-align:center;font-size:14em;color:#eee;opacity:.33;pointer-events:none}.jw-icon-tooltip.jw-open .jw-overlay{opacity:1;visibility:visible}.jw-icon-tooltip.jw-hidden,.jw-icon-tooltip.jw-open-drawer:before,.jw-overlay-horizontal{display:none}.jw-icon-tooltip.jw-open-drawer .jw-overlay-horizontal{opacity:1;display:inline-block;vertical-align:top}.jw-overlay:before{position:absolute;top:0;bottom:0;left:-50%;width:100%;background-color:transparent;content:" "}.jw-slider-time .jw-overlay:before{height:1em;top:auto}.jw-menu,.jw-time-tip,.jw-volume-tip{position:relative;left:-50%;border:1px solid #000;margin:0}.jw-volume-value-tip{font-size:12px;position:absolute;top:-26px;right:20px;background-color:#000;line-height:20px;border-radius:3px;padding:0 3px;color:#fff}.jw-volume-tip{width:100%;height:100%;display:block}.jw-time-tip{text-align:center;font-family:inherit;color:#aaa;bottom:1em;border:4px solid #000}.jw-time-tip .jw-text{line-height:1em}.jw-controlbar .jw-overlay{margin:0;position:absolute;bottom:2em;left:50%;opacity:0;visibility:hidden}.jw-controlbar .jw-overlay .jw-contents{position:relative}.jw-controlbar .jw-option{position:relative;white-space:nowrap;cursor:pointer;list-style:none;height:1.5em;font-family:inherit;line-height:1.5em;color:#aaa;padding:0 .5em;font-size:.8em}.jw-controlbar .jw-option:before:hover,.jw-controlbar .jw-option:hover{color:#eee}.jw-controlbar .jw-option:before{padding-right:.125em}.jw-playlist-container ::-webkit-scrollbar-track{background-color:#333;border-radius:10px}.jw-playlist-container ::-webkit-scrollbar{width:5px;border:10px solid #000;border-bottom:0;border-top:0}.jw-playlist-container ::-webkit-scrollbar-thumb{background-color:#fff;border-radius:5px}.jw-tooltip-title{border-bottom:1px solid #444;text-align:left;padding-left:.7em}.jw-playlist{max-height:11em;min-height:4.5em;overflow-x:hidden;overflow-y:scroll;width:calc(100% - 4px)}.jw-playlist .jw-option{height:3em;margin-right:5px;color:#fff;padding-left:1em;font-size:.8em}.jw-playlist .jw-label,.jw-playlist .jw-name{display:inline-block;line-height:3em;text-align:left;overflow:hidden;white-space:nowrap}.jw-playlist .jw-label{width:1em}.jw-playlist .jw-name{width:11em}.jw-skip{cursor:default;position:absolute;float:right;display:inline-block;right:.75em;bottom:3em}.jw-skip.jw-skippable{cursor:pointer}.jw-skip.jw-hidden{visibility:hidden}.jw-skip .jw-skip-icon{display:none;margin-left:-.75em}.jw-skip .jw-skip-icon:before{content:"\\E60C"}.jw-skip .jw-skip-icon,.jw-skip .jw-text{color:#aaa;vertical-align:middle;line-height:1.5em;font-size:.7em}.jw-skip.jw-skippable:hover{cursor:pointer}.jw-skip.jw-skippable:hover .jw-skip-icon,.jw-skip.jw-skippable:hover .jw-text{color:#eee}.jw-skip.jw-skippable .jw-skip-icon{display:inline;margin:0}.jwplayer.jw-state-paused.jw-flag-casting .jw-display-icon-container,.jwplayer.jw-state-playing.jw-flag-casting .jw-display-icon-container{display:table}.jwplayer.jw-flag-casting .jw-display-icon-container{border-radius:0;border:1px solid #fff;position:absolute;top:auto;left:.5em;right:.5em;bottom:50%;margin-bottom:-12.5%;height:50%;width:50%;padding:0;background-repeat:no-repeat;background-position:50%}.jwplayer.jw-flag-casting .jw-display-icon-container .jw-icon{font-size:3em}.jwplayer.jw-flag-casting.jw-state-complete .jw-preview{display:none}.jw-cast{position:absolute;width:100%;height:100%;background-repeat:no-repeat;background-size:auto;background-position:50% 50%}.jw-cast-label{position:absolute;left:.5em;right:.5em;bottom:75%;margin-bottom:1.5em;text-align:center}.jw-cast-name{color:#ccc}.jw-state-idle .jw-preview{display:block}.jw-state-idle .jw-icon-display:before{content:"\\E60E"}.jw-state-idle .jw-captions,.jw-state-idle .jw-controlbar{display:none}.jw-state-idle .jw-title{display:block}.jwplayer.jw-state-playing .jw-display-icon-container{display:none}.jwplayer.jw-state-playing .jw-display-icon-container .jw-icon-display:before,.jwplayer.jw-state-playing .jw-icon-playback:before{content:"\\E60D"}.jwplayer.jw-state-paused .jw-display-icon-container{display:none}.jwplayer.jw-state-paused .jw-display-icon-container .jw-icon-display:before,.jwplayer.jw-state-paused .jw-icon-playback:before{content:"\\E60E"}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-icon-display{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-icon-display:before{content:"\\E601"}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn)}}@keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-text{display:none}.jwplayer.jw-state-buffering .jw-icon-playback:before{content:"\\E60D"}.jwplayer.jw-state-complete .jw-preview{display:block}.jwplayer.jw-state-complete .jw-display-icon-container{z-index:10}.jwplayer.jw-state-complete .jw-display-icon-container .jw-icon-display:before{content:"\\E610"}.jwplayer.jw-state-complete .jw-display-icon-container .jw-text{display:none}.jwplayer.jw-state-complete .jw-icon-playback:before{content:"\\E60E"}.jwplayer.jw-state-complete .jw-captions{display:none}.jwplayer.jw-state-error .jw-title,body .jw-error .jw-title{display:block;z-index:1}.jwplayer.jw-state-error .jw-title .jw-title-primary,body .jw-error .jw-title .jw-title-primary{white-space:normal}.jwplayer.jw-state-error .jw-title .jw-title-primary a,body .jw-error .jw-title .jw-title-primary a{cursor:pointer;color:#699f00;pointer-events:auto}.jwplayer.jw-state-error .jw-preview,body .jw-error .jw-preview{display:block}.jwplayer.jw-state-error .jw-captions,.jwplayer.jw-state-error .jw-controlbar,body .jw-error .jw-captions,body .jw-error .jw-controlbar{display:none}.jwplayer.jw-state-error:hover .jw-display-icon-container,body .jw-error:hover .jw-display-icon-container{cursor:default;color:#fff;background:#000}.jwplayer.jw-state-error .jw-icon-display,body .jw-error .jw-icon-display{cursor:default;font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jwplayer.jw-state-error .jw-icon-display:before,body .jw-error .jw-icon-display:before{content:"\\E607"}.jwplayer.jw-state-error .jw-icon-display:hover,body .jw-error .jw-icon-display:hover{color:#fff}body .jw-error{font-size:16px;background-color:#000;color:#eee;width:100%;height:100%;display:table;opacity:1;position:relative}body .jw-error .jw-icon-container{position:absolute;width:100%;height:100%;top:0;left:0;bottom:0;right:0}.jwplayer.jw-flag-cast-available .jw-controlbar{display:table}.jwplayer.jw-flag-cast-available .jw-icon-cast{display:inline-block}.jwplayer.jw-flag-skin-loading .jw-captions,.jwplayer.jw-flag-skin-loading .jw-controls,.jwplayer.jw-flag-skin-loading .jw-title{display:none}.jwplayer.jw-flag-fullscreen{width:100%!important;height:100%!important;top:0;right:0;bottom:0;left:0;z-index:1000;margin:0;position:fixed}.jwplayer.jw-flag-live .jw-controlbar .jw-slider-time,.jwplayer.jw-flag-live .jw-controlbar .jw-text-duration,.jwplayer.jw-flag-live .jw-controlbar .jw-text-elapsed{display:none}.jwplayer.jw-flag-live .jw-controlbar .jw-text-alt{display:inline}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-controlbar,.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-dock,.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-logo.jw-hide{display:none}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-captions,.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-plugin{bottom:.5em}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-media{cursor:none;-webkit-cursor-visibility:auto-hide}.jwplayer.jw-flag-user-inactive.jw-state-playing video::-webkit-media-text-track-container{max-height:none}.jwplayer.jw-flag-user-inactive.jw-state-buffering .jw-controlbar{display:none}.jwplayer.jw-flag-media-audio .jw-controlbar,.jwplayer.jw-flag-media-audio.jw-flag-user-inactive .jw-controlbar{display:table}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing .jw-captions,.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing .jw-plugin{bottom:3em}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing video::-webkit-media-text-track-container{max-height:84.5%}.jw-flag-media-audio .jw-preview{display:block}.jwplayer.jw-flag-ads .jw-captions.jw-captions-enabled,.jwplayer.jw-flag-ads .jw-dock,.jwplayer.jw-flag-ads .jw-logo,.jwplayer.jw-flag-ads .jw-preview{display:none}.jwplayer.jw-flag-ads video::-webkit-media-text-track-container{display:none}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-inline,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-tooltip,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-horizontal,.jwplayer.jw-flag-ads .jw-controlbar .jw-text{display:none}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-fullscreen,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-playback,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-volume,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-volume{display:inline-block}.jwplayer.jw-flag-ads .jw-controlbar .jw-text-alt{display:inline}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-inline.jw-icon-volume,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-volume.jw-slider-horizontal{display:inline-block}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-tooltip.jw-icon-volume{display:none}.jwplayer.jw-flag-ads-googleima .jw-controlbar{display:table;bottom:0}.jwplayer.jw-flag-ads-googleima.jw-flag-touch .jw-controlbar{font-size:1em}.jwplayer.jw-flag-ads-googleima.jw-flag-touch.jw-state-paused .jw-display-icon-container{display:none}.jwplayer.jw-flag-ads-googleima.jw-skin-seven .jw-controlbar{font-size:.9em}.jwplayer.jw-flag-ads-vpaid .jw-controlbar{display:none}.jwplayer.jw-flag-ads-hide-controls .jw-controls{display:none!important}.jwplayer.jw-flag-ads.jw-flag-touch .jw-controlbar{display:table}.jwplayer.jw-flag-overlay-open-related .jw-controls,.jwplayer.jw-flag-overlay-open-related .jw-title,.jwplayer.jw-flag-overlay-open-sharing .jw-controls,.jwplayer.jw-flag-overlay-open-sharing .jw-title,.jwplayer.jw-flag-overlay-open .jw-controls-right .jw-logo,.jwplayer.jw-flag-overlay-open .jw-title{display:none}.jwplayer.jw-flag-rightclick-open{overflow:visible}.jwplayer.jw-flag-rightclick-open .jw-rightclick{z-index:16777215}.jw-flag-controls-disabled .jw-controls{visibility:hidden}.jw-flag-controls-disabled .jw-logo{visibility:visible}.jw-flag-controls-disabled .jw-media{cursor:auto}body .jwplayer.jw-flag-flash-blocked .jw-title{display:block}body .jwplayer.jw-flag-flash-blocked .jw-controls,body .jwplayer.jw-flag-flash-blocked .jw-overlays,body .jwplayer.jw-flag-flash-blocked .jw-preview{display:none}.jw-flag-touch .jw-controlbar,.jw-flag-touch .jw-plugin,.jw-flag-touch .jw-skip{font-size:1.5em}.jw-flag-touch .jw-captions{bottom:4.25em}.jw-flag-touch video::-webkit-media-text-track-container{max-height:70%}.jw-flag-touch .jw-icon-tooltip.jw-open-drawer:before{display:inline;content:"\\E615"}.jw-flag-touch .jw-display-icon-container{pointer-events:none}.jw-flag-touch.jw-state-paused .jw-display-icon-container{display:table}.jw-flag-compact-player .jw-icon-playlist,.jw-flag-compact-player .jw-text-duration,.jw-flag-compact-player .jw-text-elapsed,.jw-flag-touch.jw-state-paused.jw-flag-dragging .jw-display-icon-container{display:none}.jwplayer.jw-flag-audio-player{background-color:transparent}.jwplayer.jw-flag-audio-player .jw-media{visibility:hidden}.jwplayer.jw-flag-audio-player .jw-media object{width:1px;height:1px}.jwplayer.jw-flag-audio-player .jw-display-icon-container,.jwplayer.jw-flag-audio-player .jw-preview{display:none}.jwplayer.jw-flag-audio-player .jw-controlbar{display:table;height:auto;left:0;bottom:0;margin:0;width:100%;min-width:100%;opacity:1}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-fullscreen,.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-tooltip{display:none}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-inline.jw-icon-volume,.jwplayer.jw-flag-audio-player .jw-controlbar .jw-slider-volume.jw-slider-horizontal{display:inline-block}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-tooltip.jw-icon-volume{display:none}.jwplayer.jw-flag-audio-player.jw-flag-user-inactive .jw-controlbar{display:table}.jw-skin-seven .jw-background-color{background:#000}.jw-skin-seven .jw-controlbar{border-top:1px solid #333;height:2.5em}.jw-skin-seven .jw-group{vertical-align:middle}.jw-skin-seven .jw-playlist{background-color:rgba(0,0,0,.5)}.jw-skin-seven .jw-playlist-container{left:-43%;background-color:rgba(0,0,0,.5)}.jw-skin-seven .jw-playlist-container .jw-option{border-bottom:1px solid #444}.jw-skin-seven .jw-playlist-container .jw-option.jw-active-option,.jw-skin-seven .jw-playlist-container .jw-option:hover{background-color:#000}.jw-skin-seven .jw-playlist-container .jw-option:hover .jw-label{color:#ff0046}.jw-skin-seven .jw-playlist-container .jw-icon-playlist{margin-left:0}.jw-skin-seven .jw-playlist-container .jw-label .jw-icon-play{color:#ff0046}.jw-skin-seven .jw-playlist-container .jw-label .jw-icon-play:before{padding-left:0}.jw-skin-seven .jw-tooltip-title{background-color:#000;color:#fff}.jw-skin-seven .jw-button-color,.jw-skin-seven .jw-text{color:#fff}.jw-skin-seven .jw-button-color:hover,.jw-skin-seven .jw-toggle{color:#ff0046}.jw-skin-seven .jw-toggle.jw-off{color:#fff}.jw-skin-seven .jw-controlbar .jw-icon:before,.jw-skin-seven .jw-text-duration,.jw-skin-seven .jw-text-elapsed{padding:0 .7em}.jw-skin-seven .jw-controlbar .jw-icon-prev:before{padding-right:.25em}.jw-skin-seven .jw-controlbar .jw-icon-playlist:before{padding:0 .45em}.jw-skin-seven .jw-controlbar .jw-icon-next:before{padding-left:.25em}.jw-skin-seven .jw-icon-next,.jw-skin-seven .jw-icon-prev{font-size:.7em}.jw-skin-seven .jw-icon-prev:before{border-left:1px solid #666}.jw-skin-seven .jw-icon-next:before{border-right:1px solid #666}.jw-skin-seven .jw-icon-display{color:#fff}.jw-skin-seven .jw-icon-display:before{padding-left:0}.jw-skin-seven .jw-display-icon-container{border-radius:50%;border:1px solid #333}.jw-skin-seven .jw-rail{background-color:#384154;box-shadow:none}.jw-skin-seven .jw-buffer{background-color:#666f82}.jw-skin-seven .jw-progress{background:#ff0046}.jw-skin-seven .jw-knob{width:.6em;height:.6em;background-color:#fff;box-shadow:0 0 0 1px #000;border-radius:1em}.jw-skin-seven .jw-slider-horizontal .jw-slider-container{height:.95em}.jw-skin-seven .jw-slider-horizontal .jw-buffer,.jw-skin-seven .jw-slider-horizontal .jw-progress,.jw-skin-seven .jw-slider-horizontal .jw-rail{height:.2em;border-radius:0}.jw-skin-seven .jw-slider-horizontal .jw-knob{top:-.2em}.jw-skin-seven .jw-slider-horizontal .jw-cue{top:-.05em;width:.3em;height:.3em;background-color:#fff;border-radius:50%}.jw-skin-seven .jw-slider-vertical .jw-buffer,.jw-skin-seven .jw-slider-vertical .jw-progress,.jw-skin-seven .jw-slider-vertical .jw-rail{width:.2em}.jw-skin-seven .jw-slider-vertical .jw-knob{margin-bottom:-.3em}.jw-skin-seven .jw-volume-tip{width:100%;left:-45%;padding-bottom:.7em}.jw-skin-seven .jw-text-duration{color:#666f82}.jw-skin-seven .jw-controlbar-right-group .jw-icon-inline:before,.jw-skin-seven .jw-controlbar-right-group .jw-icon-tooltip:before{border-left:1px solid #666}.jw-skin-seven .jw-controlbar-right-group .jw-icon-inline:first-child:before{border:none}.jw-skin-seven .jw-dock .jw-dock-button{border-radius:50%;border:1px solid #333}.jw-skin-seven .jw-dock .jw-overlay{border-radius:2.5em}.jw-skin-seven .jw-icon-tooltip .jw-active-option{background-color:#ff0046;color:#fff}.jw-skin-seven .jw-icon-volume{min-width:2.6em}.jw-skin-seven .jw-menu,.jw-skin-seven .jw-skip,.jw-skin-seven .jw-time-tip,.jw-skin-seven .jw-volume-tip{border:1px solid #333}.jw-skin-seven .jw-time-tip{padding:.2em;bottom:1.3em}.jw-skin-seven .jw-menu,.jw-skin-seven .jw-volume-tip{bottom:.24em}.jw-skin-seven .jw-skip{padding:.4em;border-radius:1.75em}.jw-skin-seven .jw-skip .jw-icon-inline,.jw-skin-seven .jw-skip .jw-text{color:#fff;line-height:1.75em}.jw-skin-seven .jw-skip.jw-skippable:hover .jw-icon-inline,.jw-skin-seven .jw-skip.jw-skippable:hover .jw-text{color:#ff0046}.jw-skin-seven.jw-flag-touch .jw-controlbar .jw-icon:before,.jw-skin-seven.jw-flag-touch .jw-text-duration,.jw-skin-seven.jw-flag-touch .jw-text-elapsed{padding:0 .35em}.jw-skin-seven.jw-flag-touch .jw-controlbar .jw-icon-prev:before{padding:0 .125em 0 .7em}.jw-skin-seven.jw-flag-touch .jw-controlbar .jw-icon-next:before{padding:0 .7em 0 .125em}.jw-skin-seven.jw-flag-touch .jw-controlbar .jw-icon-playlist:before{padding:0 .225em}', ""]);
    }, function (a, b) {
        a.exports = function () {
            var a = [];
            return a.toString = function () {
                for (var a = [], b = 0; b < this.length; b++) {
                    var c = this[b];
                    c[2] ? a.push("@media " + c[2] + "{" + c[1] + "}") : a.push(c[1]);
                }
                return a.join("");
            }, a.i = function (b, c) {
                "string" == typeof b && (b = [[null, b, ""]]);
                for (var d = {}, e = 0; e < this.length; e++) {
                    var f = this[e][0];"number" == typeof f && (d[f] = !0);
                }
                for (e = 0; e < b.length; e++) {
                    var g = b[e];"number" == typeof g[0] && d[g[0]] || (c && !g[2] ? g[2] = c : c && (g[2] = "(" + g[2] + ") and (" + c + ")"), a.push(g));
                }
            }, a;
        };
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                return '<div class="jw-adv jw-reset">\n    <div class="adv-countdown"></div>\n    <div class="adv-close">X</div>\n</div>';
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                return '<div class="jw-display-icon-container jw-background-color jw-reset">\n    <div class="jw-icon jw-icon-display jw-button-color jw-reset"></div>\n</div>\n';
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ 1: function _(a, b, c, d, e) {
                var f,
                    g,
                    h = null != b ? b : {};
                return '    <div class="jw-dock-button jw-background-color jw-reset' + (null != (f = c["if"].call(h, null != b ? b.btnClass : b, { name: "if", hash: {}, fn: a.program(2, e, 0), inverse: a.noop, data: e })) ? f : "") + '" button="' + a.escapeExpression((g = null != (g = c.id || (null != b ? b.id : b)) ? g : c.helperMissing, "function" == typeof g ? g.call(h, { name: "id", hash: {}, data: e }) : g)) + '">\n        <div class="jw-icon jw-dock-image jw-reset" ' + (null != (f = c["if"].call(h, null != b ? b.img : b, { name: "if", hash: {}, fn: a.program(4, e, 0), inverse: a.noop, data: e })) ? f : "") + '></div>\n        <div class="jw-arrow jw-reset"></div>\n' + (null != (f = c["if"].call(h, null != b ? b.tooltip : b, { name: "if", hash: {}, fn: a.program(6, e, 0), inverse: a.noop, data: e })) ? f : "") + "    </div>\n";
            }, 2: function _(a, b, c, d, e) {
                var f;
                return " " + a.escapeExpression((f = null != (f = c.btnClass || (null != b ? b.btnClass : b)) ? f : c.helperMissing, "function" == typeof f ? f.call(null != b ? b : {}, { name: "btnClass", hash: {}, data: e }) : f));
            }, 4: function _(a, b, c, d, e) {
                var f;
                return "style='background-image: url(\"" + a.escapeExpression((f = null != (f = c.img || (null != b ? b.img : b)) ? f : c.helperMissing, "function" == typeof f ? f.call(null != b ? b : {}, { name: "img", hash: {}, data: e }) : f)) + "\")'";
            }, 6: function _(a, b, c, d, e) {
                var f;
                return '        <div class="jw-overlay jw-background-color jw-reset">\n            <span class="jw-text jw-dock-text jw-reset">' + a.escapeExpression((f = null != (f = c.tooltip || (null != b ? b.tooltip : b)) ? f : c.helperMissing, "function" == typeof f ? f.call(null != b ? b : {}, { name: "tooltip", hash: {}, data: e }) : f)) + "</span>\n        </div>\n";
            }, compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                var f;
                return '<div class="jw-dock jw-reset">\n' + (null != (f = c.each.call(null != b ? b : {}, b, { name: "each", hash: {}, fn: a.program(1, e, 0), inverse: a.noop, data: e })) ? f : "") + "</div>";
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                var f,
                    g,
                    h = null != b ? b : {},
                    i = c.helperMissing,
                    j = "function",
                    k = a.escapeExpression;
                return '<div id="' + k((g = null != (g = c.id || (null != b ? b.id : b)) ? g : i, (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(g)) === j ? g.call(h, { name: "id", hash: {}, data: e }) : g)) + '"class="jw-skin-' + k((g = null != (g = c.skin || (null != b ? b.skin : b)) ? g : i, (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(g)) === j ? g.call(h, { name: "skin", hash: {}, data: e }) : g)) + ' jw-error jw-reset">\n    <div class="jw-title jw-reset">\n        <div class="jw-title-primary jw-reset">' + (null != (g = null != (g = c.title || (null != b ? b.title : b)) ? g : i, f = (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(g)) === j ? g.call(h, { name: "title", hash: {}, data: e }) : g) ? f : "") + '</div>\n        <div class="jw-title-secondary jw-reset">' + k((g = null != (g = c.body || (null != b ? b.body : b)) ? g : i, (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(g)) === j ? g.call(h, { name: "body", hash: {}, data: e }) : g)) + '</div>\n    </div>\n\n    <div class="jw-icon-container jw-reset">\n        <div class="jw-display-icon-container jw-background-color jw-reset">\n            <div class="jw-icon jw-icon-display jw-reset"></div>\n        </div>\n    </div>\n</div>\n';
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ 1: function _(a, b, c, d, e) {
                var f;
                return 'src="' + a.escapeExpression((f = null != (f = c.file || (null != b ? b.file : b)) ? f : c.helperMissing, "function" == typeof f ? f.call(null != b ? b : {}, { name: "file", hash: {}, data: e }) : f)) + '"';
            }, compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                var f;
                return '<div class="jw-logo jw-reset">\n    <img class="jw-logo-image" ' + (null != (f = c["if"].call(null != b ? b : {}, null != b ? b.file : b, { name: "if", hash: {}, fn: a.program(1, e, 0), inverse: a.noop, data: e })) ? f : "") + ">\n</div>";
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ 1: function _(a, b, c, d, e) {
                var f,
                    g = a.escapeExpression;
                return "        <li class='jw-text jw-option jw-item-" + g((f = null != (f = c.index || e && e.index) ? f : c.helperMissing, "function" == typeof f ? f.call(null != b ? b : {}, { name: "index", hash: {}, data: e }) : f)) + " jw-reset'>" + g(a.lambda(null != b ? b.label : b, b)) + "</li>\n";
            }, compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                var f;
                return '<ul class="jw-menu jw-background-color jw-reset">\n' + (null != (f = c.each.call(null != b ? b : {}, b, { name: "each", hash: {}, fn: a.program(1, e, 0), inverse: a.noop, data: e })) ? f : "") + "</ul>";
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                var f;
                return '<div id="' + a.escapeExpression((f = null != (f = c.id || (null != b ? b.id : b)) ? f : c.helperMissing, "function" == typeof f ? f.call(null != b ? b : {}, { name: "id", hash: {}, data: e }) : f)) + '" class="jwplayer jw-reset" tabindex="0">\n    <div class="jw-aspect jw-reset"></div>\n    <div class="jw-media jw-reset"></div>\n    <div class="jw-preview jw-reset"></div>\n    <div class="jw-title jw-reset">\n        <div class="jw-title-primary jw-reset"></div>\n        <div class="jw-title-secondary jw-reset"></div>\n    </div>\n    <div class="jw-overlays jw-reset"></div>\n    <div class="jw-controls jw-reset"></div>\n    <div class="jw-warning jw-reset">\n        用户鉴权失败，请先<a target="_blank" href="http://bce.baidu.com">注册</a>成为百度云用户\n    </div>\n    <div class="jw-marquee">百度云</div>\n</div>';
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ 1: function _(a, b, c, d, e) {
                var f;
                return null != (f = c["if"].call(null != b ? b : {}, null != b ? b.active : b, { name: "if", hash: {}, fn: a.program(2, e, 0), inverse: a.program(4, e, 0), data: e })) ? f : "";
            }, 2: function _(a, b, c, d, e) {
                var f,
                    g = a.escapeExpression;
                return "                <li class='jw-option jw-text jw-active-option jw-item-" + g((f = null != (f = c.index || e && e.index) ? f : c.helperMissing, "function" == typeof f ? f.call(null != b ? b : {}, { name: "index", hash: {}, data: e }) : f)) + ' jw-reset\'>\n                    <span class="jw-label jw-reset"><span class="jw-icon jw-icon-play jw-reset"></span></span>\n                    <span class="jw-name jw-reset">' + g(a.lambda(null != b ? b.title : b, b)) + "</span>\n                </li>\n";
            }, 4: function _(a, b, c, d, e) {
                var f,
                    g = a.escapeExpression,
                    h = a.lambda;
                return "                <li class='jw-option jw-text jw-item-" + g((f = null != (f = c.index || e && e.index) ? f : c.helperMissing, "function" == typeof f ? f.call(null != b ? b : {}, { name: "index", hash: {}, data: e }) : f)) + ' jw-reset\'>\n                    <span class="jw-label jw-reset">' + g(h(null != b ? b.label : b, b)) + '</span>\n                    <span class="jw-name jw-reset">' + g(h(null != b ? b.title : b, b)) + "</span>\n                </li>\n";
            }, compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                var f;
                return '<div class="jw-menu jw-playlist-container jw-background-color jw-reset">\n\n    <div class="jw-tooltip-title jw-reset">\n        <span class="jw-icon jw-icon-inline jw-icon-playlist jw-reset"></span>\n        <span class="jw-text jw-reset">PLAYLIST</span>\n    </div>\n\n    <ul class="jw-playlist jw-reset">\n' + (null != (f = c.each.call(null != b ? b : {}, b, { name: "each", hash: {}, fn: a.program(1, e, 0), inverse: a.noop, data: e })) ? f : "") + "    </ul>\n</div>";
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ 1: function _(a, b, c, d, e) {
                var f,
                    g,
                    h = null != b ? b : {},
                    i = c.helperMissing,
                    j = "function",
                    k = a.escapeExpression;
                return '        <li class="jw-reset' + (null != (f = c["if"].call(h, null != b ? b.featured : b, { name: "if", hash: {}, fn: a.program(2, e, 0), inverse: a.noop, data: e })) ? f : "") + '">\n            <a href="' + k((g = null != (g = c.link || (null != b ? b.link : b)) ? g : i, (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(g)) === j ? g.call(h, { name: "link", hash: {}, data: e }) : g)) + '" class="jw-reset" target="_blank">\n' + (null != (f = c["if"].call(h, null != b ? b.showLogo : b, { name: "if", hash: {}, fn: a.program(4, e, 0), inverse: a.noop, data: e })) ? f : "") + "                " + k((g = null != (g = c.title || (null != b ? b.title : b)) ? g : i, (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(g)) === j ? g.call(h, { name: "title", hash: {}, data: e }) : g)) + "\n            </a>\n        </li>\n";
            }, 2: function _(a, b, c, d, e) {
                return " jw-featured";
            }, 4: function _(a, b, c, d, e) {
                return '                <span class="jw-icon jw-rightclick-logo jw-reset"></span>\n';
            }, compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                var f;
                return '<div class="jw-rightclick jw-reset">\n    <ul class="jw-reset">\n' + (null != (f = c.each.call(null != b ? b : {}, null != b ? b.items : b, { name: "each", hash: {}, fn: a.program(1, e, 0), inverse: a.noop, data: e })) ? f : "") + "    </ul>\n</div>";
            }, useData: !0 });
    }, function (a, b, c) {
        var d = c(9);
        a.exports = (d["default"] || d).template({ compiler: [7, ">= 4.0.0"], main: function main(a, b, c, d, e) {
                var f,
                    g = null != b ? b : {},
                    h = c.helperMissing,
                    i = "function",
                    j = a.escapeExpression;
                return '<div class="' + j((f = null != (f = c.className || (null != b ? b.className : b)) ? f : h, (typeof f === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(f)) === i ? f.call(g, { name: "className", hash: {}, data: e }) : f)) + " " + j((f = null != (f = c.orientation || (null != b ? b.orientation : b)) ? f : h, (typeof f === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(f)) === i ? f.call(g, { name: "orientation", hash: {}, data: e }) : f)) + ' jw-reset">\n    <div class="jw-slider-container jw-reset">\n        <div class="jw-rail jw-reset"></div>\n        <div class="jw-buffer jw-reset"></div>\n        <div class="jw-progress jw-reset"></div>\n        <div class="jw-knob jw-reset"></div>\n    </div>\n</div>';
            }, useData: !0 });
    }, function (a, b, c) {
        "use strict";

        function d(a) {
            return a && a.__esModule ? a : { "default": a };
        }

        function e(a) {
            if (a && a.__esModule) return a;
            var b = {};
            if (null != a) for (var c in a) {
                Object.prototype.hasOwnProperty.call(a, c) && (b[c] = a[c]);
            }return b["default"] = a, b;
        }

        function f() {
            var a = new h.HandlebarsEnvironment();
            return n.extend(a, h), a.SafeString = j["default"], a.Exception = l["default"], a.Utils = n, a.escapeExpression = n.escapeExpression, a.VM = p, a.template = function (b) {
                return p.template(b, a);
            }, a;
        }
        b.__esModule = !0;
        var g = c(35),
            h = e(g),
            i = c(76),
            j = d(i),
            k = c(12),
            l = d(k),
            m = c(10),
            n = e(m),
            o = c(75),
            p = e(o),
            q = c(74),
            r = d(q),
            s = f();
        s.create = f, r["default"](s), s["default"] = s, b["default"] = s, a.exports = b["default"];
    }, function (a, b, c) {
        "use strict";

        function d(a) {
            return a && a.__esModule ? a : { "default": a };
        }

        function e(a) {
            g["default"](a);
        }
        b.__esModule = !0, b.registerDefaultDecorators = e;
        var f = c(64),
            g = d(f);
    }, function (a, b, c) {
        "use strict";

        b.__esModule = !0;
        var d = c(10);
        b["default"] = function (a) {
            a.registerDecorator("inline", function (a, b, c, e) {
                var f = a;
                return b.partials || (b.partials = {}, f = function f(e, _f2) {
                    var g = c.partials;
                    c.partials = d.extend({}, g, b.partials);
                    var h = a(e, _f2);
                    return c.partials = g, h;
                }), b.partials[e.args[0]] = e.fn, f;
            });
        }, a.exports = b["default"];
    }, function (a, b, c) {
        "use strict";

        function d(a) {
            return a && a.__esModule ? a : { "default": a };
        }

        function e(a) {
            g["default"](a), i["default"](a), k["default"](a), m["default"](a), o["default"](a), q["default"](a), s["default"](a);
        }
        b.__esModule = !0, b.registerDefaultHelpers = e;
        var f = c(66),
            g = d(f),
            h = c(67),
            i = d(h),
            j = c(68),
            k = d(j),
            l = c(69),
            m = d(l),
            n = c(70),
            o = d(n),
            p = c(71),
            q = d(p),
            r = c(72),
            s = d(r);
    }, function (a, b, c) {
        "use strict";

        b.__esModule = !0;
        var d = c(10);
        b["default"] = function (a) {
            a.registerHelper("blockHelperMissing", function (b, c) {
                var e = c.inverse,
                    f = c.fn;
                if (b === !0) return f(this);
                if (b === !1 || null == b) return e(this);
                if (d.isArray(b)) return b.length > 0 ? (c.ids && (c.ids = [c.name]), a.helpers.each(b, c)) : e(this);
                if (c.data && c.ids) {
                    var g = d.createFrame(c.data);
                    g.contextPath = d.appendContextPath(c.data.contextPath, c.name), c = { data: g };
                }
                return f(b, c);
            });
        }, a.exports = b["default"];
    }, function (a, b, c) {
        "use strict";

        function d(a) {
            return a && a.__esModule ? a : { "default": a };
        }
        b.__esModule = !0;
        var e = c(10),
            f = c(12),
            g = d(f);
        b["default"] = function (a) {
            a.registerHelper("each", function (a, b) {
                function c(b, c, f) {
                    j && (j.key = b, j.index = c, j.first = 0 === c, j.last = !!f, k && (j.contextPath = k + b)), i += d(a[b], { data: j, blockParams: e.blockParams([a[b], b], [k + b, null]) });
                }
                if (!b) throw new g["default"]("Must pass iterator to #each");
                var d = b.fn,
                    f = b.inverse,
                    h = 0,
                    i = "",
                    j = void 0,
                    k = void 0;
                if (b.data && b.ids && (k = e.appendContextPath(b.data.contextPath, b.ids[0]) + "."), e.isFunction(a) && (a = a.call(this)), b.data && (j = e.createFrame(b.data)), a && "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a))) if (e.isArray(a)) for (var l = a.length; h < l; h++) {
                    h in a && c(h, h, h === a.length - 1);
                } else {
                    var m = void 0;
                    for (var n in a) {
                        a.hasOwnProperty(n) && (void 0 !== m && c(m, h - 1), m = n, h++);
                    }void 0 !== m && c(m, h - 1, !0);
                }
                return 0 === h && (i = f(this)), i;
            });
        }, a.exports = b["default"];
    }, function (a, b, c) {
        "use strict";

        function d(a) {
            return a && a.__esModule ? a : { "default": a };
        }
        b.__esModule = !0;
        var e = c(12),
            f = d(e);
        b["default"] = function (a) {
            a.registerHelper("helperMissing", function () {
                if (1 !== arguments.length) throw new f["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"');
            });
        }, a.exports = b["default"];
    }, function (a, b, c) {
        "use strict";

        b.__esModule = !0;
        var d = c(10);
        b["default"] = function (a) {
            a.registerHelper("if", function (a, b) {
                return d.isFunction(a) && (a = a.call(this)), !b.hash.includeZero && !a || d.isEmpty(a) ? b.inverse(this) : b.fn(this);
            }), a.registerHelper("unless", function (b, c) {
                return a.helpers["if"].call(this, b, { fn: c.inverse, inverse: c.fn, hash: c.hash });
            });
        }, a.exports = b["default"];
    }, function (a, b) {
        "use strict";

        b.__esModule = !0, b["default"] = function (a) {
            a.registerHelper("log", function () {
                for (var b = [void 0], c = arguments[arguments.length - 1], d = 0; d < arguments.length - 1; d++) {
                    b.push(arguments[d]);
                }var e = 1;
                null != c.hash.level ? e = c.hash.level : c.data && null != c.data.level && (e = c.data.level), b[0] = e, a.log.apply(a, b);
            });
        }, a.exports = b["default"];
    }, function (a, b) {
        "use strict";

        b.__esModule = !0, b["default"] = function (a) {
            a.registerHelper("lookup", function (a, b) {
                return a && a[b];
            });
        }, a.exports = b["default"];
    }, function (a, b, c) {
        "use strict";

        b.__esModule = !0;
        var d = c(10);
        b["default"] = function (a) {
            a.registerHelper("with", function (a, b) {
                d.isFunction(a) && (a = a.call(this));
                var c = b.fn;
                if (d.isEmpty(a)) return b.inverse(this);
                var e = b.data;
                return b.data && b.ids && (e = d.createFrame(b.data), e.contextPath = d.appendContextPath(b.data.contextPath, b.ids[0])), c(a, { data: e, blockParams: d.blockParams([a], [e && e.contextPath]) });
            });
        }, a.exports = b["default"];
    }, function (a, b, c) {
        "use strict";

        b.__esModule = !0;
        var d = c(10),
            e = { methodMap: ["debug", "info", "warn", "error"], level: "info", lookupLevel: function lookupLevel(a) {
                if ("string" == typeof a) {
                    var b = d.indexOf(e.methodMap, a.toLowerCase());
                    a = b >= 0 ? b : parseInt(a, 10);
                }
                return a;
            }, log: function log(a) {
                if (a = e.lookupLevel(a), "undefined" != typeof console && e.lookupLevel(e.level) <= a) {
                    var b = e.methodMap[a];
                    console[b] || (b = "log");
                    for (var c = arguments.length, d = Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++) {
                        d[f - 1] = arguments[f];
                    }console[b].apply(console, d);
                }
            } };
        b["default"] = e, a.exports = b["default"];
    }, function (a, b) {
        (function (c) {
            "use strict";

            b.__esModule = !0, b["default"] = function (a) {
                var b = "undefined" != typeof c ? c : window,
                    d = b.Handlebars;
                a.noConflict = function () {
                    return b.Handlebars === a && (b.Handlebars = d), a;
                };
            }, a.exports = b["default"];
        }).call(b, function () {
            return this;
        }());
    }, function (a, b, c) {
        "use strict";

        function d(a) {
            return a && a.__esModule ? a : { "default": a };
        }

        function e(a) {
            if (a && a.__esModule) return a;
            var b = {};
            if (null != a) for (var c in a) {
                Object.prototype.hasOwnProperty.call(a, c) && (b[c] = a[c]);
            }return b["default"] = a, b;
        }

        function f(a) {
            var b = a && a[0] || 1,
                c = r.COMPILER_REVISION;
            if (b !== c) {
                if (b < c) {
                    var d = r.REVISION_CHANGES[c],
                        e = r.REVISION_CHANGES[b];
                    throw new q["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + d + ") or downgrade your runtime to an older version (" + e + ").");
                }
                throw new q["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + a[1] + ").");
            }
        }

        function g(a, b) {
            function c(c, d, e) {
                e.hash && (d = o.extend({}, d, e.hash), e.ids && (e.ids[0] = !0)), c = b.VM.resolvePartial.call(this, c, d, e);
                var f = b.VM.invokePartial.call(this, c, d, e);
                if (null == f && b.compile && (e.partials[e.name] = b.compile(c, a.compilerOptions, b), f = e.partials[e.name](d, e)), null != f) {
                    if (e.indent) {
                        for (var g = f.split("\n"), h = 0, i = g.length; h < i && (g[h] || h + 1 !== i); h++) {
                            g[h] = e.indent + g[h];
                        }f = g.join("\n");
                    }
                    return f;
                }
                throw new q["default"]("The partial " + e.name + " could not be compiled when running in runtime-only mode");
            }

            function d(b) {
                function c(b) {
                    return "" + a.main(e, b, e.helpers, e.partials, g, i, h);
                }
                var f = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                    g = f.data;
                d._setup(f), !f.partial && a.useData && (g = l(b, g));
                var h = void 0,
                    i = a.useBlockParams ? [] : void 0;
                return a.useDepths && (h = f.depths ? b !== f.depths[0] ? [b].concat(f.depths) : f.depths : [b]), (c = m(a.main, c, e, f.depths || [], g, i))(b, f);
            }
            if (!b) throw new q["default"]("No environment passed to template");
            if (!a || !a.main) throw new q["default"]("Unknown template object: " + (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a)));
            a.main.decorator = a.main_d, b.VM.checkRevision(a.compiler);
            var e = { strict: function strict(a, b) {
                    if (!(b in a)) throw new q["default"]('"' + b + '" not defined in ' + a);
                    return a[b];
                }, lookup: function lookup(a, b) {
                    for (var c = a.length, d = 0; d < c; d++) {
                        if (a[d] && null != a[d][b]) return a[d][b];
                    }
                }, lambda: function lambda(a, b) {
                    return "function" == typeof a ? a.call(b) : a;
                }, escapeExpression: o.escapeExpression, invokePartial: c, fn: function fn(b) {
                    var c = a[b];
                    return c.decorator = a[b + "_d"], c;
                }, programs: [], program: function program(a, b, c, d, e) {
                    var f = this.programs[a],
                        g = this.fn(a);
                    return b || e || d || c ? f = h(this, a, g, b, c, d, e) : f || (f = this.programs[a] = h(this, a, g)), f;
                }, data: function data(a, b) {
                    for (; a && b--;) {
                        a = a._parent;
                    }return a;
                }, merge: function merge(a, b) {
                    var c = a || b;
                    return a && b && a !== b && (c = o.extend({}, b, a)), c;
                }, noop: b.VM.noop, compilerInfo: a.compiler };
            return d.isTop = !0, d._setup = function (c) {
                c.partial ? (e.helpers = c.helpers, e.partials = c.partials, e.decorators = c.decorators) : (e.helpers = e.merge(c.helpers, b.helpers), a.usePartial && (e.partials = e.merge(c.partials, b.partials)), (a.usePartial || a.useDecorators) && (e.decorators = e.merge(c.decorators, b.decorators)));
            }, d._child = function (b, c, d, f) {
                if (a.useBlockParams && !d) throw new q["default"]("must pass block params");
                if (a.useDepths && !f) throw new q["default"]("must pass parent depths");
                return h(e, b, a[b], c, 0, d, f);
            }, d;
        }

        function h(a, b, c, d, e, f, g) {
            function h(b) {
                var e = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                    h = g;
                return g && b !== g[0] && (h = [b].concat(g)), c(a, b, a.helpers, a.partials, e.data || d, f && [e.blockParams].concat(f), h);
            }
            return h = m(c, h, a, g, d, f), h.program = b, h.depth = g ? g.length : 0, h.blockParams = e || 0, h;
        }

        function i(a, b, c) {
            return a ? a.call || c.name || (c.name = a, a = c.partials[a]) : a = "@partial-block" === c.name ? c.data["partial-block"] : c.partials[c.name], a;
        }

        function j(a, b, c) {
            c.partial = !0, c.ids && (c.data.contextPath = c.ids[0] || c.data.contextPath);
            var d = void 0;
            if (c.fn && c.fn !== k && (c.data = r.createFrame(c.data), d = c.data["partial-block"] = c.fn, d.partials && (c.partials = o.extend({}, c.partials, d.partials))), void 0 === a && d && (a = d), void 0 === a) throw new q["default"]("The partial " + c.name + " could not be found");
            if (a instanceof Function) return a(b, c);
        }

        function k() {
            return "";
        }

        function l(a, b) {
            return b && "root" in b || (b = b ? r.createFrame(b) : {}, b.root = a), b;
        }

        function m(a, b, c, d, e, f) {
            if (a.decorator) {
                var g = {};
                b = a.decorator(b, g, c, d && d[0], e, f, d), o.extend(b, g);
            }
            return b;
        }
        b.__esModule = !0, b.checkRevision = f, b.template = g, b.wrapProgram = h, b.resolvePartial = i, b.invokePartial = j, b.noop = k;
        var n = c(10),
            o = e(n),
            p = c(12),
            q = d(p),
            r = c(35);
    }, function (a, b) {
        "use strict";

        function c(a) {
            this.string = a;
        }
        b.__esModule = !0, c.prototype.toString = c.prototype.toHTML = function () {
            return "" + this.string;
        }, b["default"] = c, a.exports = b["default"];
    }, function (a, b, c) {
        var d = c(50);"string" == typeof d && (d = [["all-players", d, ""]]), c(37).style(d, "all-players"), d.locals && (a.exports = d.locals);
    }, function (a, b) {
        a.exports = "data:application/font-woff;base64,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";
    }, function (a, b) {
        a.exports = "data:application/octet-stream;base64,AAEAAAAMAIAAAwBARkZUTXZoZxYAABnsAAAAHE9TLzIPEwN/AAABSAAAAGBjbWFwGlfT9wAAAhwAAAFeZ2FzcAAAABAAABnkAAAACGdseWZNhURMAAADuAAAEyhoZWFkCb3BbgAAAMwAAAA2aGhlYQlBBZkAAAEEAAAAJGhtdHh2CwbXAAABqAAAAHRsb2NhOYA/MgAAA3wAAAA8bWF4cAAmAXMAAAEoAAAAIG5hbWWoyha4AAAW4AAAAddwb3N0Qi1hlQAAGLgAAAErAAEAAAABGZrB7kYIXw889QALBAAAAAAA0pAxnAAAAADSkDGc/77//wXAA6AAAAAIAAIAAAAAAAAAAQAAA8D/wAAABgD/vv+7BcAAAQAAAAAAAAAAAAAAAAAAAB0AAQAAAB0BcQAIAAAAAAACAAAAAAAAAAAAAAAAAAAAAAADBH0BkAAFAAACmQLMAAAAjwKZAswAAAHrADMBCQAAAAAAAAAAAAAAAAAAAAEQAAAAAAAAAAAAAAAAAAAAAAAAAeYXA8D/wABAA8AAQAAAAAEAAAAAAAAAAAAAACAAAQQAAAAAAAAAAVUAAAAAAAACAAAABgAAYAQAAEAFAABABQAAQAYAAEAGAABABAAA4ASAAEAEAABABgAAQAYAAD0D4ABDBIAARgQAAIAEAACABIAASgOAAEMEwABABMAAQAQAAEAGAABABAAAQgQAAEQCVf++AAAAAwAAAAMAAAAcAAEAAAAAAFgAAwABAAAAHAAEADwAAAAKAAgAAgACAAEAIOYX//3//wAAAAAAIOYA//3//wAA/+QaBQADAAEACgAAAAAAAAAAAAEAAwAAAQYAAAEDAAAAAAAAAQIAAAACAAAAAAAAAAAAAAAAAAAAAQAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAIABAAGACCALIA/gFaAn4DqgPMBAAEIgScBRwF3gX2Bg4GHgY2BnQGhgboBwoHRAd6B6wJlAABAAAAAAAAAAAAAgAAOQIAAQAAAAAAAAAAAAIAADkCAAEAAAAAAAAAAAACAAA5AgAEAGAAAAWgA4AAOgA/AEQASQAAJRUiLgI1NDY3LgE1ND4CMzIeAhUUBgceARUUDgIjETIWFz4BNTQuAiMiDgIVFBYXPgEzETEBFSE1IRcVITUhFxUhNSEBQC5SPSMKCgoKRnqjXV2jekYKCgoKIz1SLipKHgECOmaITU2IZjoBAh5KKgJVAgv99ZYBdf6LSgEr/tUeHiM9Ui4ZLhUfQyJdo3pGRnqjXSJDHxUuGS5SPSMBwB0ZDRsOTYhmOjpmiE0OGw0ZHf5eA2KVleCVleCVlQAAAAEAQAAAA8ADgAAhAAATFB4CMzI+AjUzFA4CIyIuAjU0PgIzFSIOAhUxizpmiE1NiGY6S0Z6o11do3pGRnqjXU2IZjoBwE2IZjo6ZohNXaN6RkZ6o11do3pGSzpmiE0AAAQAQAAABMADgAAOABwAKgAxAAAlLgEnIREhES4BJxEhESEHIy4DJzUeAxcxKwEuAyc1HgMXMSsBNR4BFzECfwMFBAIM/EYLKwsEPP2/U1oIRGuMT2Ksg1MItVsHJzpKKj1rUjUItoEvRgxCCygKAsH+6QMKAgFI/MJCTodoQghYCFCAp2ApSDkmB1gHNFFnPH0LRC4AAAAABQBAAAAEwAOAAA4AGQAnADUAPAAAJS4BJyERIREuAScRIREhATUhESEuAycxASMuAyc1HgMXMSsBLgMnNR4DFzErATUeARcxAoACBgUCDfxADCoKBED9wP6AA0D+IBhFWWw+AS1aCEVrjE9irYNSCbNaByc7Sio8alI2CbqAMEQMQAwoDALA/u0CCAMBRvzAAdDw/cA9Z1RBF/3wTYhoQgdaCFCAqGApSDgmB1oINVFnO30MQy4AAAQAQAAABcADgAAEAAkAZwDFAAAzESERIQEhESERBT4BNz4BMzIWFx4BFx4BFx4BFyMuAScuAScuAScuASMiBgcOAQcOAQcOARUUFhceARceARceATMyNjc+ATczDgEHDgEHDgEHDgEjIiYnLgEnLgEnLgE1NDY3PgE3MSE+ATc+ATMyFhceARceARceARcjLgEnLgEnLgEnLgEjIgYHDgEHDgEHDgEVFBYXHgEXHgEXHgEzMjY3PgE3Mw4BBw4BBw4BBw4BIyImJy4BJy4BJy4BNTQ2Nz4BNzFABYD6gAU2+xQE7PwjDiETFCwYEiEQDxwNDBQICAsCWwEFBQQKBgcOCAgQCRAaCwsSBwcKAwMDAwMDCgcHEgsLGhAWIQwMDwNaAgkHCBMNDBwRECQUGCwUEyEODRUHBwcHBwcVDQG6DSEUEywZESEQEBwMDBUICAoCWgIFBAQLBgYOCAgRCBAbCwsSBwcKAwMDAwMDCgcHEgsLGxAVIgwMDgNbAgkIBxQMDB0QESQTGSwTFCENDhQHBwgIBwcUDgOA/IADNf0WAurXEBgICQkFBQUPCgoYDw4hEwkOBwcMBQUIAwMCBgYGEQoKGA0NHA4NGg0NFwoKEQYGBg0NDiIWFCQREBwLCxIGBgYJCAkXDw8kFBQsFxgtFRQkDxAYCAkJBQUFDwoKGA8OIRMJDgcHDAUFCAMDAgYGBhEKChgNDRwODRoNDRcKChEGBgYNDQ4iFhQkERAcCwsSBgYGCQgJFw8PJBQULBcYLRUUJA8AAwBAAAAFwAOAABAAbwDOAAApASImNRE0NjMhMhYVERQGIwE+ATc+ATc+ATMyFhceARceARceARczLgEnLgEnLgEnLgEjIgYHDgEHDgEHDgEVFBYXHgEXHgEXHgEzMjY3PgE3PgE3PgE3Iw4BBw4BIyImJy4BJy4BJy4BNTQ2NzkBIT4BNz4BNz4BMzIWFx4BFx4BFx4BFzMuAScuAScuAScuASMiBgcOAQcOAQcOARUUFhceARceARceATMyNjc+ATc+ATc+ATcjDgEHDgEjIiYnLgEnLgEnLgE1NDY3OQEFLPuoPVdXPQRYPVdXPfyaAwoHBhILCxsQCRAICA4GBwoEBAYBWgIKCAgUDQwcEA8hEhgsFBMhDg0VBwcHBwcHFQ0OIRMUKxkUJBAQHQwMFAgHCQJaAw8MDCIVEBsLCxIGBwoDBAMDBAG5AwoHBxILCxsQCBEIBw8GBgsEBAUBWwIKCAgVDAwcEBAhERksExQhDQ4UBwcICAcHFA4NIRQTLBkTJBEQHQwMFAcICQJbAw4MDSEVEBsLCxIHBwoDAwMDA1c+AlY+V1c+/ao+VwH0DRgKCxAGBgYCAwMIBQUMBwcOCRMhDg8YCgoOBgUFCQkIGBAPJBQVLRgXLBQUJA8PFwkICQYGBhILCxwQESQUFiIODQ0GBgYRCgoXDQ0aDg4bDQ0YCgsQBgYGAgMDCAUFDAcHDgkTIQ4PGAoKDgYFBQkJCBgQDyQUFS0YFywUFCQPDxcJCAkGBgYSCwscEBEkFBYiDg0NBgYGEQoKFw0NGg4OGw0AAAAAAQDgAKADIALgABQAAAEUDgIjIi4CNTQ+AjMyHgIVAyAtTmk8PGlOLS1OaTw8aU4tAcA8aU4tLU5pPDxpTi0tTmk8AAADAEAAEARAA5AAAwAQAB8AADcJASElMjY1NCYjIgYVFBYzEzQmIyIGFREUFjMyNjURQAIAAgD8AAIADhUVDg4VFQ4jFQ4OFRUODhUQA4D8gHAWEA8YFhEQFgHmDxgWEf7XDxgWEQEpAAIAQAAAA8ADgAAHAA8AADMRFzcXBxchASERJwcnNydAgLCNsID+cwHzAY2AsI2wgAGNgLCNsIADgP5zgLCNsIAAAAAABQBAAAAFwAOAAAQACQAWADMATwAAMxEhESEBIREhEQEzNTMRIzUjFSMRMxUlHgEXHgEXHgEVFAYHDgEHDgEHDgErAREzHgEXMQcRMzI2Nz4BNz4BNz4BNTQmJy4BJy4BJy4BKwFABYD6gAU2+xQE7PxUtmBgtmRkAlwUHg4PFAcHCQYHBxMMDCETEywbsLAWKhOgRwkXCQoSCAcNBQUFBAMCDQcHEwwMIBE3A4D8gAM2/RcC6f7Arf5AwMABwK2dBxQODyIWFTAbGC4TFiIPDhgKCQcBwAIHB0P+5gQDAg0HBxcMDCETER0PDhgKCQ8EBQUAAAQAPQAABcADgAAQAB0AOwBZAAApASImNRE0NjMhMhYVERQGIwEjFSM1IxEzNTMVMxEFLgEnLgEnLgErAREzMjY3PgE3PgE3PgE1LgEnOQEHDgEHDgErAREzMhYXHgEXHgEXHgEVFAYHDgEHOQEFKvupPlhYPgRXPlhYPv2zYLNkZLNgAbAHFwwOHxMTJxawsBssExMeDwwTBwcGAggJdwgSCgkUDEc3Ex4MDBMHBwsEAwQFBQUNB1g+AlQ+WFg+/aw+WAKdra3+QMDAAcB9FiIODxQHBwb+QAkHCRgPDiUTFiwYHTAW4ggNAgMEAR8EBQUPCgoYDw4fERMfDwwXBwABAEP//wOgA34AjwAAExQiNScwJic0JicuAQcOARUcARUeARceATc+ATc+ATE2MhUwFAcUFhceARceATMyNjc+ATc+ATc+AzE2MhUwDgIVFBYXHgEXFjY3PgE3PgE3PgE3PgM3PAE1NCYnJgYHDgMxBiI1MDwCNTQmJyYGBw4BBw4DMQYiNTAmJy4BJyYGBw4BMRWQBgQIBAgCBQ4KBwkDFgcHIQ8QDwcHNgUEAwMHBQsJChcMBQ0FBwsHDBMICR8cFQUFAwQDCAUHFRERJBEMEwgJEgUOGQwGMjgvBAkHDBYEAz1IPAQFLyQRIhEQFgoGIiUcBQUEAgMYKCcmCgcsAboFBQwYDwUKBwUEAgMNBwcLBxRrDhENBwggDxOTCgqdMBM1EQwTCAcFBAIFCgcPIw4UQ0IxCgpTc3glEyMREBgIBwEKBxUKESUQJ00mE6/JrA8FBgIHDQMECAkGla2PCQk1VGYxNTsHAgUKChwQC2BqVQoKehYfTwUDRx8TkAMAAAAAAgBGAAAENgOAAAQACAAAIREzESMJAhEDxnBw/IADgPyAA4D8gAOA/kD+QAOAAAAAAgCAAAADgAOAAAQACQAAIREhESEBIREhEQKAAQD/AP4AAQD/AAOA/IADgPyAA4AAAQCAAAAEAAOAAAMAAAkBEQEEAPyAA4ABwP5AA4D+QAACAEoAAAQ6A4AABAAIAAAzESMRMwkCEbpwcAOA/IADgAOA/IADgP5A/kADgAAAAAABAEMAIANDA6AAKQAAAR4BFRQOAiMiLgI1ND4CMzUNATUiDgIVFB4CMzI+AjU0Jic3Aw0aHDxpjE9PjGg9PWiMTwFA/sA8aU4tLU5pPDxpTi0WE1MCYytjNU+MaD09aIxPT4xoPYCts4AtTmk8PGlOLS1OaTwpSx8wAAAAAQBAAGYCIAMTAAYAABMRMyURJSNAzQET/u3NATMBE839U80ABABAAAAEkAOAABcAKwA6AEEAACEnPgM1NC4CJzceAxUUDgIHMS8BPgE1NCYnNx4DFQ4DBzEnPgE1NCYnNx4BFRQGBycFETMlESUjA9oqJj4rFxcrPiYqKkMwGRkwQyqkKTlERDkpITQkFAEUJDMhwyIoKCIqJjAwJir9zc0BE/7tzSMoXmlyPDxxaV4pIytmcnxBQXxyZiuDIzWRVFSRNSMeSFBYLy9ZUUcdsxZIKStGFSMcXDQ1WR8pAwETzf1TzQAAAAIAQAAAA8MDgAAHAA8AAAEXIREXNxcHAQcnNychEScDKnD+qXCXeZn+JpZ6lnABV20Cc3ABV3CWepP+I5Z6lnD+qmwAAwBAARMFwAJgAAwAGQAmAAABFAYjIiY1NDYzMhYVIRQGIyImNTQ2MzIWFSEUBiMiJjU0NjMyFhUBjWJFRWFhRUViAhZhRUViYkVFYQIdYUVFYmJFRWEBukViYkVFYWFFRWJiRUVhYUVFYmJFRWFhRQAAAAABAEIAAgO+A34AIAAAARcWFAcGIi8BBwYiJyY0PwEnJjQ3NjIfATc2MhcWFA8BAqP3JCQkYx329iRjHSQk9/ckJCRjHfb2JGMdJCT3AcD2JGMdJCT39yQkJGMd9vYkYx0kJPf3JCQkYx32AAAGAEQABAO8A3wABAAJAA4AEwAYAB0AAAEhFSE1ESEVITURIRUhNQEzFSM1ETMVIzURMxUjNQGnAhX96wIV/esCFf3r/p2ysrKysrIDfFlZ/p1ZWf6dWVkCxrKy/p2ysv6dsrIACP++AGYCmgOXACkAUAB/AK8BKgE8AVkBcAAAEg4BIg4EFB4IPgouCSImEz4BNz4BNz4BNz4BNz4BJy4CNDUuAQcOAQcOAQcGFBUUFhceARcFJhYnLgEnJgYnLgEjJgYHIiYHDgEHFBYOAQcOAQcOAhQOAQcGFhceARc3PgE3IS4CNDUuAScqAScGNgcOAQcOAhQHDgEXHgEXHgEXMz4BNz4BNzY0PgI0PgE3JAYiBiIOBxQOFRQGFB4KMj4FMh4DMh4CMj4PNC4NIi4VIiYDDgEHBhYHDgEVBjIXHgEXNycXByMuAScuAS8BPgE3PgM3PgE3PgEzPgE/ATMXHgEXMz8BHwEHIyYWJyYiIy4BJzU3M8oGCQYYDQwHAgQDAhMPBwcFGwUNEwQFEwEEAgQCAgQCBQUCBQIIGAcI4hADAQYKBQcBBQEDAQ0NAgEDAgs5HwQbGwUKBAESEwQOBv7iCgoHBx0OCQMIAwUCCQcKAQQCCxYFAQIEAQICAQIDAQIDAQIPEAkSCjEUIQ0CJQYDAgYgDgMIHC0XCg4GCQEDAQEKAQEEAQUIERs2BwwHBQwCAQEEAQIDBv6DDwgLBQUGBQUJBgYODAUHJgkMCQgHBQYRCQQGBRAIBQEHBQUFAgMCBgoZDAMMFVYKBx0JFgw+DgoVCAkFGglCEgcPBQkMBQkEBQUIBQUBBQUBBQIGBBAJBQYKCgkFAw8nBQoGCAUFCQQFBwwGBAMNBAYFCAYJDIwHCgUHAgIBBAMDBAMJDjcBQAKHCxgJBAsIAQILEQMEBQgDAQECAwYDEiQSBDpUAwIHNwEDOwECkAkKCwIEAQ4KBwM6A5cBBhIQGRgYGB8ICiIPBQIFAgIBDAUDHgYFEAYwHQYODQYFBAcJEgX+/gYDAQMIAwYFCQEBAhM3GAIFBgUCHS8JAhQgCxcMCxULGCkPAwUCFQ4OFBEgCwcDAQEDAgQDAQEEFQsBAgMEAgUKBQMEBgcHCAQaNhUJCwcCCRsvGwIDBQIPIAUFBwMGBwoMAQEEBQIdLSUIEQgLEQoEBAQDDgQCAwQBAwUEBCE+BQUGAQUBBwUKDgQSBA0sBg8FBgsBBQ4KAgYIDxEFBwkRCQ4bDxAICg4RGwUFBAkBBAEFAgUBBgEFAQcEAgMCBQEMAQgGBwQUDgcPDDAKDQYIDQUVBQYHBQ0FBw8pCQgHDgYEEAYDDwkHAwcGBQIFAQQE/vYDAwUIAwoDBQQNBw4PBgFikwIGCgsFERY2CRoQAwYFAgICAwEBAQEDAUfXBwEFkwMCxAICAgYBCQ8MmgMAAAAADgCuAAEAAAAAAAEADAAaAAEAAAAAAAIABwA3AAEAAAAAAAMADABZAAEAAAAAAAQADACAAAEAAAAAAAUACwClAAEAAAAAAAYADADLAAEAAAAAAAoAGgEOAAMAAQQJAAEAGAAAAAMAAQQJAAIADgAnAAMAAQQJAAMAGAA/AAMAAQQJAAQAGABmAAMAAQQJAAUAFgCNAAMAAQQJAAYAGACxAAMAAQQJAAoANADYAGoAdwAtAHMAaQB4AC0AaQBjAG8AbgBzAABqdy1zaXgtaWNvbnMAAFIAZQBnAHUAbABhAHIAAFJlZ3VsYXIAAGoAdwAtAHMAaQB4AC0AaQBjAG8AbgBzAABqdy1zaXgtaWNvbnMAAGoAdwAtAHMAaQB4AC0AaQBjAG8AbgBzAABqdy1zaXgtaWNvbnMAAFYAZQByAHMAaQBvAG4AIAAxAC4AMQAAVmVyc2lvbiAxLjEAAGoAdwAtAHMAaQB4AC0AaQBjAG8AbgBzAABqdy1zaXgtaWNvbnMAAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAARm9udCBnZW5lcmF0ZWQgYnkgSWNvTW9vbi4AAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB0AAAECAAIBAwADAQQBBQEGAQcBCAEJAQoBCwEMAQ0BDgEPARABEQESARMBFAEVARYBFwEYARkBGgEbBmdseXBoMQd1bmkwMDAxB3VuaUU2MDAHdW5pRTYwMQd1bmlFNjAyB3VuaUU2MDMHdW5pRTYwNAd1bmlFNjA1B3VuaUU2MDYHdW5pRTYwNwd1bmlFNjA4B3VuaUU2MDkHdW5pRTYwQQd1bmlFNjBCB3VuaUU2MEMHdW5pRTYwRAd1bmlFNjBFB3VuaUU2MEYHdW5pRTYxMAd1bmlFNjExB3VuaUU2MTIHdW5pRTYxMwd1bmlFNjE0B3VuaUU2MTUHdW5pRTYxNgd1bmlFNjE3AAABAAH//wAPAAAAAQAAAADSBBQFAAAAANHUIisAAAAA0pAw5Q==";
    }, function (a, b, c) {
        var d, e;
        d = [c(23), c(1)], e = function (a, b) {
            return function (c, d) {
                var e = ["seek", "skipAd", "stop", "playlistNext", "playlistPrev", "playlistItem", "resize", "addButton", "removeButton", "registerPlugin", "attachMedia"];
                b.each(e, function (a) {
                    c[a] = function () {
                        return d[a].apply(d, arguments), c;
                    };
                }), c.registerPlugin = a.registerPlugin;
            };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1)], e = function (a) {
            return function (b, c) {
                var d = ["buffer", "controls", "position", "duration", "fullscreen", "volume", "mute", "item", "stretching", "playlist", "captions"];
                a.each(d, function (a) {
                    var d = a.slice(0, 1).toUpperCase() + a.slice(1);
                    b["get" + d] = function () {
                        return c._model.get(a);
                    };
                });
                var e = ["getAudioTracks", "getCaptionsList", "getWidth", "getHeight", "getCurrentAudioTrack", "setCurrentAudioTrack", "getCurrentCaptions", "setCurrentCaptions", "getCurrentQuality", "setCurrentQuality", "getQualityLevels", "getVisualQuality", "getConfig", "getState", "getSafeRegion", "isBeforeComplete", "isBeforePlay", "getProvider", "detachMedia"],
                    f = ["setControls", "setFullscreen", "setVolume", "enableGPU", "disableGPU", "setMute", "setCues", "setCaptions", "setToken"];
                a.each(e, function (a) {
                    b[a] = function () {
                        return c[a] ? c[a].apply(c, arguments) : null;
                    };
                }), a.each(f, function (a) {
                    b[a] = function () {
                        return c[a].apply(c, arguments), b;
                    };
                }), b.getPlaylistIndex = b.getItem;
            };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(4), c(6), c(3), c(2), c(49), c(1), c(89), c(80), c(81), c(83), c(86), c(17)], e = function (a, b, c, d, e, f, g, h, i, j, k, l) {
            var m = function m(_m, n) {
                var o,
                    p = this,
                    q = !1,
                    r = {};
                f.extend(this, c), this.utils = d, this._ = f, this.Events = c, this.version = l, this.trigger = function (a, b) {
                    return b = f.isObject(b) ? f.extend({}, b) : {}, b.type = a, window.jwplayer && window.jwplayer.debug ? c.trigger.call(p, a, b) : c.triggerSafe.call(p, a, b);
                }, this.dispatchEvent = this.trigger, this.removeEventListener = this.off.bind(this);
                var s = function s() {
                    o = new g(_m), h(p, o), i(p, o), o.on(a.JWPLAYER_PLAYLIST_ITEM, function () {
                        r = {};
                    }), o.on(a.JWPLAYER_MEDIA_META, function (a) {
                        f.extend(r, a.metadata);
                    }), o.on(a.JWPLAYER_READY, function (a) {
                        q = !0, t.tick("ready"), a.setupTime = t.between("setup", "ready");
                        var b = new k(p.getConfig(), p);
                        b.userCertify();
                    }), o.on("all", p.trigger);
                };
                s(), j(this), this.id = _m.id;
                var t = this._qoe = new e();
                t.tick("init");
                var u = function u() {
                    q = !1, r = {}, p.off(), o && o.off(), o && o.playerDestroy && o.playerDestroy();
                };
                return this.getPlugin = function (a) {
                    return p.plugins && p.plugins[a];
                }, this.addPlugin = function (a, b) {
                    this.plugins = this.plugins || {}, this.plugins[a] = b, this.onReady(b.addToPlayer), b.resize && this.onResize(b.resizeHandler);
                }, this.setup = function (a) {
                    return t.tick("setup"), u(), s(), d.foreach(a.events, function (a, b) {
                        var c = p[a];"function" == typeof c && c.call(p, b);
                    }), a.id = p.id, o.setup(a, this), p;
                }, this.qoe = function () {
                    var b = o.getItemQoe(),
                        c = t.between("setup", "ready"),
                        d = b.between(a.JWPLAYER_MEDIA_PLAY_ATTEMPT, a.JWPLAYER_MEDIA_FIRST_FRAME);
                    return { setupTime: c, firstFrame: d, player: t.dump(), item: b.dump() };
                }, this.getContainer = function () {
                    return o.getContainer ? o.getContainer() : _m;
                }, this.getMeta = this.getItemMeta = function () {
                    return r;
                }, this.getPlaylistItem = function (a) {
                    if (!d.exists(a)) return o._model.get("playlistItem");
                    var b = p.getPlaylist();
                    return b ? b[a] : null;
                }, this.getRenderingMode = function () {
                    return "html5";
                }, this.load = function (a) {
                    var b = this.getPlugin("vast") || this.getPlugin("googima");
                    return b && b.destroy(), o.load(a), p;
                }, this.play = function (a, c) {
                    if (f.isBoolean(a) || (c = a), c || (c = { reason: "external" }), a === !0) return o.play(c), p;
                    if (a === !1) return o.pause(), p;
                    switch (a = p.getState()) {
                        case b.PLAYING:
                            o.pause();
                            break;
                        default:
                            o.play(c);}
                    return p;
                }, this.pause = function (a) {
                    return f.isBoolean(a) ? this.play(!a) : this.play();
                }, this.createInstream = function () {
                    return o.createInstream();
                }, this.castToggle = function () {
                    o && o.castToggle && o.castToggle();
                }, this.playAd = this.pauseAd = d.noop, this.remove = function () {
                    return n(p), p.trigger("remove"), u(), p;
                }, this;
            };
            return m;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(4)], e = function (a, b) {
            return function (c) {
                var d = { onBufferChange: b.JWPLAYER_MEDIA_BUFFER, onBufferFull: b.JWPLAYER_MEDIA_BUFFER_FULL, onError: b.JWPLAYER_ERROR, onSetupError: b.JWPLAYER_SETUP_ERROR, onFullscreen: b.JWPLAYER_FULLSCREEN, onMeta: b.JWPLAYER_MEDIA_META, onMute: b.JWPLAYER_MEDIA_MUTE, onPlaylist: b.JWPLAYER_PLAYLIST_LOADED, onPlaylistItem: b.JWPLAYER_PLAYLIST_ITEM, onPlaylistComplete: b.JWPLAYER_PLAYLIST_COMPLETE, onReady: b.JWPLAYER_READY, onResize: b.JWPLAYER_RESIZE, onComplete: b.JWPLAYER_MEDIA_COMPLETE, onSeek: b.JWPLAYER_MEDIA_SEEK, onTime: b.JWPLAYER_MEDIA_TIME, onVolume: b.JWPLAYER_MEDIA_VOLUME, onBeforePlay: b.JWPLAYER_MEDIA_BEFOREPLAY, onBeforeComplete: b.JWPLAYER_MEDIA_BEFORECOMPLETE, onDisplayClick: b.JWPLAYER_DISPLAY_CLICK, onControls: b.JWPLAYER_CONTROLS, onQualityLevels: b.JWPLAYER_MEDIA_LEVELS, onQualityChange: b.JWPLAYER_MEDIA_LEVEL_CHANGED, onCaptionsList: b.JWPLAYER_CAPTIONS_LIST, onCaptionsChange: b.JWPLAYER_CAPTIONS_CHANGED, onAdError: b.JWPLAYER_AD_ERROR, onAdClick: b.JWPLAYER_AD_CLICK, onAdImpression: b.JWPLAYER_AD_IMPRESSION, onAdTime: b.JWPLAYER_AD_TIME, onAdComplete: b.JWPLAYER_AD_COMPLETE, onAdCompanions: b.JWPLAYER_AD_COMPANIONS, onAdSkipped: b.JWPLAYER_AD_SKIPPED, onAdPlay: b.JWPLAYER_AD_PLAY, onAdPause: b.JWPLAYER_AD_PAUSE, onAdMeta: b.JWPLAYER_AD_META, onCast: b.JWPLAYER_CAST_SESSION, onAudioTrackChange: b.JWPLAYER_AUDIO_TRACK_CHANGED, onAudioTracks: b.JWPLAYER_AUDIO_TRACKS, onCuepoint: b.JWPLAYER_CUEPOINT, onSeekForwardForbidden: b.JWPLAYER_SEEK_FORWARD_FORBIDDEN, onConnection: b.JWPLAYER_CONNECTING, onAlive: b.JWPLAYER_ALIVE, onNoLiveStream: b.JWPLAYER_NO_LIVE_STREAM, onLiveStop: b.JWPLAYER_LIVE_STOP },
                    e = { onBuffer: "buffer", onPause: "pause", onPlay: "play", onIdle: "idle", onStop: "stop" };
                a.each(e, function (b, d) {
                    c[d] = a.partial(c.on, b, a);
                }), a.each(d, function (b, d) {
                    c[d] = a.partial(c.on, b, a);
                });
            };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(1)], e = function (a, b) {
            function d(c) {
                b.each(c, function (b, d) {
                    c[d] = a.serialize(b);
                });
            }

            function e(a) {
                return a.slice && "px" === a.slice(-2) && (a = a.slice(0, -2)), a;
            }

            function f(a) {
                return a.controls = !1, a.controlbar.barLogo = !0, a.skin = "seven", a.startseek = !1, delete a.skinColorInactive, delete a.skinColorActive, delete a.skinColorBackground, a;
            }

            function g(b, c) {
                if (c.toString().indexOf("%") === -1) return 0;
                if ("string" != typeof b || !a.exists(b)) return 0;
                if (/^\d*\.?\d+%$/.test(b)) return b;
                var d = b.indexOf(":");
                if (d === -1) return 0;
                var e = parseFloat(b.substr(0, d)),
                    f = parseFloat(b.substr(d + 1));
                return e <= 0 || f <= 0 ? 0 : f / e * 100 + "%";
            }
            var h = { autostart: !1, controls: !0, displaytitle: !0, displaydescription: !0, mobilecontrols: !1, repeat: !1, castAvailable: !1, skin: "seven", stretching: "uniform", mute: !1, volume: 90, width: 480, height: 270, controlbar: { barLogo: !0 }, marquee: { show: !1, text: "百度云", fontSize: 12, color: "#FFF" }, startseek: !0 },
                i = function i(_i, j) {
                _i.autoStart && (_i.autostart = !0), "over" !== _i.controls && "none" !== _i.controls || (_i.controls = "over" === _i.controls), _i.startParam && (_i.startparam = _i.startParam);
                var k = j && j.getAllItems(),
                    l = b.extend({}, (window.jwplayer || {}).defaults, k, _i);
                d(l);
                var m = b.extend({}, h, l);
                if ("." === m.base && (m.base = a.getScriptPath("cyberplayer.js")), m.base = (m.base || a.loadFrom()).replace(/\/?$/, "/"), c.p = m.base, m.width = e(m.width), m.height = e(m.height), m.flashplayer = m.flashplayer || a.getScriptPath("cyberplayer.js") + "cyberplayer.flash.swf", "http:" === window.location.protocol && (m.flashplayer = m.flashplayer.replace("https", "http")), m.aspectratio = g(m.aspectratio, m.width), b.isObject(m.skin) && (m.skinUrl = m.skin.url, m.skinColorInactive = m.skin.inactive, m.skinColorActive = m.skin.active, m.skinColorBackground = m.skin.background, m.skin = b.isString(m.skin.name) ? m.skin.name : h.skin), b.isString(m.skin) && m.skin.indexOf(".xml") > 0 && (console.log("JW Player does not support XML skins, please update your config"), m.skin = m.skin.replace(".xml", "")), m.aspectratio || delete m.aspectratio, !m.playlist) {
                    var n = b.pick(m, ["title", "description", "type", "mediaid", "image", "file", "sources", "tracks", "preload", "fallbackfile"]);
                    m.playlist = [n];
                }
                return a.isPoorIE() && (m = f(m)), m;
            };
            return i;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (e, t, n) {
        var i, o;
        i = [n(38), n(1)], o = function (e, t) {
            function n(e) {
                for (var n = {}, i = e.substr(e.indexOf("?") + 1).split("&"), r = 0; r < i.length; r++) {
                    var a = i[r],
                        s = a.indexOf("=");
                    if (s > -1) {
                        var l = a.substr(0, s),
                            c = decodeURIComponent(a.substr(s + 1));
                        t.contains(o, l) && (c = c.replace(/'/g, '"'), c = "object" == (typeof JSON === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(JSON)) && "function" == typeof JSON.parse ? JSON.parse(c) : eval("(" + c + ")")), n[l] = c;
                    }
                }
                return n;
            }

            function i() {
                for (var a = document.getElementsByTagName("script"), b = a.length; b--;) {
                    var c = a[b],
                        d = c.src;
                    if (d.indexOf("cyberplayer.js") > -1) {
                        var f = n(d);
                        if (t.size(f) > 0 && "DIV" === c.parentNode.nodeName) return e.selectPlayer(c.parentNode).setup(f);
                    }
                }
            }
            var o = ["imageAdvs", "playlist", "listbar", "tracks", "captions", "controlbar", "logo", "skin", "marquee"];
            return i(), { getParams: n, loadPlayer: i };
        }.apply(t, i), !(void 0 !== o && (e.exports = o));
    }, function (a, b, c) {
        var d, e;
        d = [c(17), c(2)], e = function (a, b) {
            function c() {
                for (var a = b.getElementsByClassName("jw-warning"), c = 0; c < a.length; c++) {
                    var d = a[c];
                    d.style.display = "block";
                }
            }
            var d = "https://drm.media.baidubce.com/v1/playerAuth",
                e = function e(a) {
                !a.code || "UNAUTHORIZED" !== a.code && "BAD_REQUEST" !== a.code || c();
            },
                f = function f(a, b) {
                this.config = a, this.api = b;
            };
            return f.prototype = { userCertify: function userCertify() {
                    var e = this.config.ak ? this.config.ak : "";
                    if (!/^[a-zA-Z0-9]{32}$/.test(e)) return c(), !1;
                    var f = "web-html5-" + a,
                        g = b.getBrowserInfo(),
                        h = d + "?ak=" + e + "&player=" + f + "&platform=" + g + "&callback=" + this._getCallback();
                    h = encodeURI(h);
                    var i = document.createElement("script");
                    i.type = "text/javascript", i.src = h, document.getElementsByTagName("head")[0].appendChild(i);
                }, _getCallback: function _getCallback() {
                    var a = new Date().getTime(),
                        b = 1e9 * Math.random() >>> 0,
                        c = "jwplayer_" + a + "_" + b;
                    return window[c] = function (a) {
                        try {
                            e(a), delete window[c];
                        } catch (b) {
                            window[c] = null;
                        }
                    }, c;
                } }, f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(94), c(3), c(1), c(4)], e = function (a, b, c, d) {
            var e = function e(b, _e3, f, g) {
                function h() {
                    m("Setup Timeout Error", "Setup took longer than " + q + " seconds to complete.");
                }

                function i() {
                    c.each(p, function (a) {
                        a.complete !== !0 && a.running !== !0 && null !== b && k(a.depends) && (a.running = !0, j(a));
                    });
                }

                function j(a) {
                    var c = function c(b) {
                        b = b || {}, l(a, b);
                    };
                    a.method(c, _e3, b, f, g);
                }

                function k(a) {
                    return c.all(a, function (a) {
                        return p[a].complete;
                    });
                }

                function l(a, b) {
                    "error" === b.type ? m(b.msg, b.reason, b.code || "") : "complete" === b.type ? (clearTimeout(n), o.trigger(d.JWPLAYER_READY)) : (a.complete = !0, i());
                }

                function m(a, b, c) {
                    clearTimeout(n), o.trigger(d.JWPLAYER_SETUP_ERROR, { message: a + ": " + b, code: c }), o.destroy();
                }
                var n,
                    o = this,
                    p = a.getQueue(),
                    q = 30;
                this.start = function () {
                    n = setTimeout(h, 1e3 * q), i();
                }, this.destroy = function () {
                    clearTimeout(n), this.off(), p.length = 0, b = null, _e3 = null, f = null;
                };
            };
            return e.prototype = b, e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(13), c(22), c(96), c(2)], e = function (a, b, c, d) {
            var e = function e(_e4, f) {
                function g(a) {
                    if (a.tracks.length) {
                        f.mediaController.off("meta", h), u = [], v = {}, w = {}, x = 0;
                        for (var b = a.tracks || [], c = 0; c < b.length; c++) {
                            var d = b[c];
                            d.id = d.name, d.label = d.name || d.language, m(d);
                        }
                        var e = p();
                        this.setCaptionsList(e), q();
                    }
                }

                function h(a) {
                    var b = a.metadata;
                    if (b && "textdata" === b.type) {
                        if (!b.text) return;
                        var c = v[b.trackid];
                        if (!c) {
                            c = { kind: "captions", id: b.trackid, data: [] }, m(c);
                            var d = p();
                            this.setCaptionsList(d);
                        }
                        var e, g;
                        b.useDTS ? (c.source || (c.source = b.source || "mpegts"), e = b.begin, g = b.begin + "_" + b.text) : (e = a.position || f.get("position"), g = "" + Math.round(10 * e) + "_" + b.text);
                        var h = w[g];
                        h || (h = { begin: e, text: b.text }, b.end && (h.end = b.end), w[g] = h, c.data.push(h));
                    }
                }

                function i(a) {
                    d.log("CAPTIONS(" + a + ")");
                }

                function j(a, b) {
                    t = b, u = [], v = {}, w = {}, x = 0;
                }

                function k(a) {
                    j(f, a), f.mediaController.off("meta", h), f.mediaController.off("subtitlesTracks", g);
                    var b,
                        c,
                        e,
                        i,
                        k = a.tracks,
                        l = "flash" === f.get("provider").name,
                        o = d.isChrome() || d.isIOS() || d.isSafari();
                    for (i = 0; i < k.length; i++) {
                        b = k[i], e = b.file && /\.(?:web)?vtt(?:\?.*)?$/i.test(b.file), !l && e && !s && o || (c = b.kind.toLowerCase(), "captions" !== c && "subtitles" !== c || (b.file ? (m(b), n(b)) : b.data && m(b)));
                    }u.length || (f.mediaController.on("meta", h, this), f.mediaController.on("subtitlesTracks", g, this));
                    var r = p();
                    this.setCaptionsList(r), q();
                }

                function l(a, b) {
                    var c = null;
                    0 !== b && (c = u[b - 1]), a.set("captionsTrack", c);
                }

                function m(a) {
                    "number" != typeof a.id && (a.id = a.name || a.file || "cc" + u.length), a.data = a.data || [], a.label || (a.label = "Unknown CC", x++, x > 1 && (a.label += " (" + x + ")")), u.push(a), v[a.id] = a;
                }

                function n(a) {
                    d.ajax(a.file, function (b) {
                        o(b, a);
                    }, i);
                }

                function o(d, e) {
                    var f = d.responseXML ? d.responseXML.firstChild : null;
                    if (f) for ("xml" === a.localName(f) && (f = f.nextSibling); f.nodeType === f.COMMENT_NODE;) {
                        f = f.nextSibling;
                    }try {
                        f && "tt" === a.localName(f) ? e.data = c(d.responseXML) : e.data = b(d.responseText);
                    } catch (g) {
                        i(g.message + ": " + e.file);
                    }
                }

                function p() {
                    for (var a = [{ id: "off", label: "Off" }], b = 0; b < u.length; b++) {
                        a.push({ id: u[b].id, label: u[b].label || "Unknown CC" });
                    }return a;
                }

                function q() {
                    var a = 0,
                        b = f.get("captionLabel");
                    if ("Off" === b) return void f.set("captionsIndex", 0);
                    for (var c = 0; c < u.length; c++) {
                        var d = u[c];
                        if (b && b === d.label) {
                            a = c + 1;
                            break;
                        }
                        d["default"] || d.defaulttrack || "default" === d.id ? a = c + 1 : d.autoselect;
                    }
                    r(a);
                }

                function r(a) {
                    u.length ? f.setVideoSubtitleTrack(a, u) : f.set("captionsIndex", a);
                }
                f.on("change:playlistItem", j, this), f.on("change:captionsIndex", l, this), f.on("itemReady", k, this), f.mediaController.on("subtitlesTracks", g, this), f.mediaController.on("subtitlesTrackData", function (a) {
                    var b = v[a.name];
                    if (b) {
                        b.source = a.source;
                        for (var c = a.captions || [], d = !1, e = 0; e < c.length; e++) {
                            var f = c[e],
                                g = a.name + "_" + f.begin + "_" + f.end;
                            w[g] || (w[g] = f, b.data.push(f), d = !0);
                        }
                        d && b.data.sort(function (a, b) {
                            return a.begin - b.begin;
                        });
                    }
                }, this), f.mediaController.on("meta", h, this);
                var s = !!f.get("sdkplatform"),
                    t = {},
                    u = [],
                    v = {},
                    w = {},
                    x = 0;
                this.getCurrentIndex = function () {
                    return f.get("captionsIndex");
                }, this.getCaptionsList = function () {
                    return f.get("captionsList");
                }, this.setCaptionsList = function (a) {
                    f.set("captionsList", a);
                };
            };
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(84), c(90), c(1), c(87), c(88), c(20), c(39), c(100), c(41), c(2), c(133), c(14), c(3), c(21), c(6), c(4), c(127), c(103)], e = function (a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r) {
            function s(a) {
                return function () {
                    var b = Array.prototype.slice.call(arguments, 0);
                    this._model.getVideo() ? this["_" + a].apply(this, b) : this.eventsQueue.push([a, b]);
                };
            }

            function t(a) {
                return a === o.LOADING || a === o.STALLED ? o.BUFFERING : a;
            }
            var u = function u(a) {
                this.originalContainer = this.currentContainer = a, this.eventsQueue = [], c.extend(this, m), this._model = new f();
            };
            return u.prototype = { play: s("play"), pause: s("pause"), setVolume: s("setVolume"), enableGPU: s("enableGPU"), disableGPU: s("disableGPU"), setToken: s("setToken"), setMute: s("setMute"), seek: s("seek"), stop: s("stop"), load: s("load"), playlistNext: s("next"), playlistPrev: s("prev"), playlistItem: s("item"), setFullscreen: s("setFullscreen"), setCurrentCaptions: s("setCurrentCaptions"), setCurrentQuality: s("setCurrentQuality"), setup: function setup(f, m) {
                    function q() {
                        ca.mediaModel.on("change:state", function (a, b) {
                            var c = t(b);
                            ca.set("state", c);
                        });
                    }

                    function s() {
                        _ = null, G(ca.get("item")), ca.on("change:state", n, this), ca.on("change:castState", function (a, b) {
                            fa.trigger(p.JWPLAYER_CAST_SESSION, b);
                        }), ca.on("change:fullscreen", function (a, b) {
                            fa.trigger(p.JWPLAYER_FULLSCREEN, { fullscreen: b });
                        }), ca.on("itemReady", function () {
                            fa.trigger(p.JWPLAYER_PLAYLIST_ITEM, { index: ca.get("item"), item: ca.get("playlistItem") });
                        }), ca.on("change:playlist", function (a, b) {
                            b.length && fa.trigger(p.JWPLAYER_PLAYLIST_LOADED, { playlist: b });
                        }), ca.on("change:volume", function (a, b) {
                            fa.trigger(p.JWPLAYER_MEDIA_VOLUME, { volume: b });
                        }), ca.on("change:mute", function (a, b) {
                            fa.trigger(p.JWPLAYER_MEDIA_MUTE, { mute: b });
                        }), ca.on("change:controls", function (a, b) {
                            fa.trigger(p.JWPLAYER_CONTROLS, { controls: b });
                        }), ca.on("change:scrubbing", function (a, b) {
                            b ? B() : z();
                        }), ca.on("change:captionsList", function (a, b) {
                            fa.trigger(p.JWPLAYER_CAPTIONS_LIST, { tracks: b, track: T() });
                        }), ca.mediaModel.set("mediaType", null), ca.mediaController.on("all", fa.trigger.bind(fa)), Y.on("all", fa.trigger.bind(fa)), this.showView(Y.element()), c.defer(u);
                    }

                    function u() {
                        fa.trigger(p.JWPLAYER_READY, { setupTime: 0 }), fa.trigger(p.JWPLAYER_PLAYLIST_LOADED, { playlist: ca.get("playlist") }), fa.trigger(p.JWPLAYER_PLAYLIST_ITEM, { index: ca.get("item"), item: ca.get("playlistItem") }), fa.trigger(p.JWPLAYER_CAPTIONS_LIST, { tracks: ca.get("captionsList"), track: ca.get("captionsIndex") }), ca.get("autostart") && (!j.isPoorIE() && ca.get("imageAdvs") && ca.get("imageAdvs").start ? Y.beginStartAdv() : z({ reason: "autostart" })), v();
                    }

                    function v() {
                        for (; fa.eventsQueue.length > 0;) {
                            var a = fa.eventsQueue.shift(),
                                b = a[0],
                                c = a[1] || [];
                            fa["_" + b].apply(fa, c);
                        }
                    }

                    function w(a) {
                        switch (ca.get("state") === o.ERROR && ca.set("state", o.IDLE), A(!0), ca.get("autostart") && ca.once("itemReady", z), typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a)) {
                            case "string":
                                x(a);
                                break;
                            case "object":
                                var b = h(a),
                                    c = ca.get("edition"),
                                    d = ca.getProviders(),
                                    e = d.required(b, c);
                                l.load(e, c).then(function () {
                                    fa.getProvider() || (ca.setProvider(ca.get("playlistItem")), v());
                                });
                                var f = F(a);
                                f && G(0);
                                break;
                            case "number":
                                G(a);}
                    }

                    function x(a) {
                        var b = new i();
                        b.on(p.JWPLAYER_PLAYLIST_LOADED, function (a) {
                            w(a.playlist);
                        }), b.on(p.JWPLAYER_ERROR, function (a) {
                            a.message = "Error loading playlist: " + a.message, this.triggerError(a);
                        }, this), b.load(a);
                    }

                    function y() {
                        var a = fa._instreamAdapter && fa._instreamAdapter.getState();
                        return c.isString(a) ? a : ca.get("state");
                    }

                    function z(a) {
                        var b;
                        if (a && ca.set("playReason", a.reason), ca.get("state") !== o.ERROR) {
                            var d = fa._instreamAdapter && fa._instreamAdapter.getState();
                            if (c.isString(d)) return m.pauseAd(!1);
                            if (ca.get("state") === o.COMPLETE && (A(!0), G(0)), !da && (da = !0, fa.trigger(p.JWPLAYER_MEDIA_BEFOREPLAY, { file: ca.get("file") || ca.get("playlistItem").file }), da = !1, ba)) return ba = !1, void (aa = null);
                            if (C()) {
                                if (0 === ca.get("playlist").length) return !1;!j.isPoorIE() && ca.get("imageAdvs") && ca.get("imageAdvs").start ? Y.beginStartAdv() : b = j.tryCatch(function () {
                                    ca.loadVideo();
                                });
                            } else ca.get("state") === o.PAUSED && (b = j.tryCatch(function () {
                                ca.playVideo();
                            }));
                            return !(b instanceof j.Error && (fa.triggerError(b), aa = null, 1));
                        }
                    }

                    function A(a) {
                        ca.off("itemReady", z);
                        var b = !a;
                        aa = null;
                        var c = j.tryCatch(function () {
                            ca.stopVideo();
                        }, fa);
                        return c instanceof j.Error ? (fa.triggerError(c), !1) : (b && (ea = !0), da && (ba = !0), !0);
                    }

                    function B() {
                        aa = null;
                        var a = fa._instreamAdapter && fa._instreamAdapter.getState();
                        if (c.isString(a)) return m.pauseAd(!0);
                        switch (ca.get("state")) {
                            case o.ERROR:
                                return !1;
                            case o.PLAYING:
                            case o.BUFFERING:
                                var b = j.tryCatch(function () {
                                    ga().pause();
                                }, this);
                                if (b instanceof j.Error) return fa.triggerError(b), !1;
                                break;
                            default:
                                da && (ba = !0);}
                        return !0;
                    }

                    function C() {
                        var a = ca.get("state");
                        return a === o.IDLE || a === o.COMPLETE || a === o.ERROR;
                    }

                    function D(a) {
                        if (ca.get("state") !== o.ERROR) {
                            var b = this.getConfig();
                            if (b.disableSeekForward && a > this._model.get("position")) return void fa.trigger(p.JWPLAYER_SEEK_FORWARD_FORBIDDEN);
                            ca.get("scrubbing") || ca.get("state") === o.PLAYING || z(!0), ga().seek(a);
                        }
                    }

                    function E(a, b) {
                        A(!0), G(a), z(b);
                    }

                    function F(a) {
                        var b = h(a);
                        return b = h.filterPlaylist(b, ca.getProviders(), ca.get("androidhls"), ca.get("drm"), ca.get("preload"), ca.get("feedid"), ca.get("withCredentials")), ca.set("playlist", b), !(!c.isArray(b) || 0 === b.length);
                    }

                    function G(a) {
                        var b = ca.get("playlist");
                        a = parseInt(a, 10) || 0, a = (a + b.length) % b.length, ca.set("item", a), ca.set("playlistItem", b[a]), ca.setActiveItem(b[a]);
                    }

                    function H(a) {
                        E(ca.get("item") - 1, a || { reason: "external" });
                    }

                    function I(a) {
                        E(ca.get("item") + 1, a || { reason: "external" });
                    }

                    function J() {
                        if (C()) {
                            if (ea) return void (ea = !1);
                            aa = J;
                            var a = ca.get("item");
                            return a === ca.get("playlist").length - 1 ? void (ca.get("repeat") ? I({ reason: "repeat" }) : (ca.set("state", o.COMPLETE), fa.trigger(p.JWPLAYER_PLAYLIST_COMPLETE, {}))) : void I({ reason: "playlist" });
                        }
                    }

                    function K(a) {
                        ga() && (a = parseInt(a, 10) || 0, ga().setCurrentQuality(a));
                    }

                    function L() {
                        return ga() ? ga().getCurrentQuality() : -1;
                    }

                    function M() {
                        if (this._model) return this._model.getConfiguration();
                    }

                    function N() {
                        if (this._model.mediaModel) return this._model.mediaModel.get("visualQuality");
                        var a = O();
                        if (a) {
                            var b = L(),
                                d = a[b];
                            if (d) return { level: c.extend({ index: b }, d), mode: "", reason: "" };
                        }
                        return null;
                    }

                    function O() {
                        return ga() ? ga().getQualityLevels() : null;
                    }

                    function P(a) {
                        ga() && (a = parseInt(a, 10) || 0, ga().setCurrentAudioTrack(a));
                    }

                    function Q() {
                        return ga() ? ga().getCurrentAudioTrack() : -1;
                    }

                    function R() {
                        return ga() ? ga().getAudioTracks() : null;
                    }

                    function S(a) {
                        a = parseInt(a, 10) || 0, ca.persistVideoSubtitleTrack(a), fa.trigger(p.JWPLAYER_CAPTIONS_CHANGED, { tracks: U(), track: a });
                    }

                    function T() {
                        return $.getCurrentIndex();
                    }

                    function U() {
                        return $.getCaptionsList();
                    }

                    function V() {
                        var a = ca.getVideo();
                        if (a) {
                            var b = a.detachMedia();
                            if (b instanceof HTMLVideoElement) return b;
                        }
                        return null;
                    }

                    function W() {
                        var a = j.tryCatch(function () {
                            ca.getVideo().attachMedia();
                        });
                        return a instanceof j.Error ? void j.log("Error calling _attachMedia", a) : void ("function" == typeof aa && aa());
                    }

                    function X(a) {
                        c.isBoolean(a) || (a = !ca.get("fullscreen")), ca.set("fullscreen", a), this._instreamAdapter && this._instreamAdapter._adModel && this._instreamAdapter._adModel.set("fullscreen", a);
                    }
                    var Y,
                        Z,
                        $,
                        _,
                        aa,
                        ba,
                        ca = this._model,
                        da = !1,
                        ea = !1,
                        fa = this,
                        ga = function ga() {
                        return ca.getVideo();
                    },
                        ha = new g();
                    ha.track(ca);
                    var ia = new a(f, ha);
                    ca.setup(ia, ha), Y = this._view = new k(m, ca), Z = new r(m, ca), $ = new e(m, ca), _ = new d(m, ca, Y, F), _.on(p.JWPLAYER_READY, s, this), _.on(p.JWPLAYER_SETUP_ERROR, this.setupError, this), ca.mediaController.on(p.JWPLAYER_MEDIA_COMPLETE, function () {
                        c.defer(J);
                    }), ca.mediaController.on(p.JWPLAYER_MEDIA_ERROR, this.triggerError, this), ca.on("change:flashBlocked", function (a, b) {
                        if (!b) return void this._model.set("errorEvent", void 0);
                        var c = !!a.get("flashThrottle"),
                            d = { message: c ? "Click to run Flash" : "Flash plugin failed to load" };
                        c || this.trigger(p.JWPLAYER_ERROR, d), this._model.set("errorEvent", d);
                    }, this), q(), ca.on("change:mediaModel", q), this._play = z, this._pause = B, this._seek = D, this._stop = A, this._load = w, this._next = I, this._prev = H, this._item = E, this._setCurrentCaptions = S, this._setCurrentQuality = K, this._setFullscreen = X, this.detachMedia = V, this.attachMedia = W, this.getCurrentQuality = L, this.getQualityLevels = O, this.setCurrentAudioTrack = P, this.getCurrentAudioTrack = Q, this.getAudioTracks = R, this.getCurrentCaptions = T, this.getCaptionsList = U, this.getVisualQuality = N, this.getConfig = M, this.getState = y, this.setVolume = ca.setVolume.bind(ca), this.setMute = ca.setMute.bind(ca), this.enableGPU = ca.enableGPU, this.disableGPU = ca.disableGPU, this.setToken = ca.setToken, this.getProvider = function () {
                        return ca.get("provider");
                    }, this.getWidth = function () {
                        return ca.get("containerWidth");
                    }, this.getHeight = function () {
                        return ca.get("containerHeight");
                    }, this.getContainer = function () {
                        return this.currentContainer;
                    }, this.resize = Y.resize, this.getSafeRegion = Y.getSafeRegion, this.setCues = Y.addCues, this.setCaptions = Y.setCaptions, this.addButton = function (a, b, d, e, f) {
                        var g = { img: a, tooltip: b, callback: d, id: e, btnClass: f },
                            h = ca.get("dock");
                        h = h ? h.slice(0) : [], h = c.reject(h, c.matches({ id: g.id })), h.push(g), ca.set("dock", h);
                    }, this.removeButton = function (a) {
                        var b = ca.get("dock") || [];
                        b = c.reject(b, c.matches({ id: a })), ca.set("dock", b);
                    }, this.checkBeforePlay = function () {
                        return da;
                    }, this.getItemQoe = function () {
                        return ca._qoeItem;
                    }, this.setControls = function (a) {
                        c.isBoolean(a) || (a = !ca.get("controls")), ca.set("controls", a);
                        var b = ca.getVideo();
                        b && b.setControls(a);
                    }, this.playerDestroy = function () {
                        this.stop(), this.showView(this.originalContainer), Y && Y.destroy(), ca && ca.destroy(), _ && (_.destroy(), _ = null);
                    }, this.isBeforePlay = this.checkBeforePlay, this.isBeforeComplete = function () {
                        return ca.getVideo().checkComplete();
                    }, this.createInstream = function () {
                        return this.instreamDestroy(), this._instreamAdapter = new b(this, ca, Y), this._instreamAdapter;
                    }, this.skipAd = function () {
                        this._instreamAdapter && this._instreamAdapter.skipAd();
                    }, this.instreamDestroy = function () {
                        fa._instreamAdapter && fa._instreamAdapter.destroy();
                    }, _.start();
                }, showView: function showView(a) {
                    (document.documentElement.contains(this.currentContainer) || (this.currentContainer = document.getElementById(this._model.get("id")), this.currentContainer)) && (this.currentContainer.parentElement && this.currentContainer.parentElement.replaceChild(a, this.currentContainer), this.currentContainer = a);
                }, triggerError: function triggerError(a) {
                    this._model.set("errorEvent", a), this._model.set("state", o.ERROR), this._model.once("change:state", function () {
                        this._model.set("errorEvent", void 0);
                    }, this), this.trigger(p.JWPLAYER_ERROR, a);
                }, setupError: function setupError(a) {
                    var b = a.message,
                        d = j.createElement(q(this._model.get("id"), this._model.get("skin"), b)),
                        e = this._model.get("width"),
                        f = this._model.get("height");
                    j.style(d, { width: e.toString().indexOf("%") > 0 ? e : e + "px", height: f.toString().indexOf("%") > 0 ? f : f + "px" }), this.showView(d);
                    var g = this;
                    c.defer(function () {
                        g.trigger(p.JWPLAYER_SETUP_ERROR, { message: b, code: a.code });
                    });
                } }, u;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(92), c(91), c(4), c(6), c(2), c(3), c(1)], e = function (a, b, c, d, e, f, g) {
            function h(c) {
                var d = c.get("provider").name || "";
                return d.indexOf("flash") >= 0 ? b : a;
            }
            var i = { skipoffset: null, tag: null },
                j = function j(a, b, f) {
                function j(a, b) {
                    "complete" !== a && (b = b || {}, u.tag && !b.tag && (b.tag = u.tag), this.trigger(a, b));
                }

                function k(a) {
                    s._adModel.set("duration", a.duration), s._adModel.set("position", a.position);
                }

                function l(a) {
                    var d = {};
                    if (u.tag && (d.tag = u.tag), m && t + 1 < m.length) {
                        this.trigger(c.JWPLAYER_MEDIA_COMPLETE, d), s._adModel.set("state", "buffering"), b.set("skipButton", !1), t++;
                        var e,
                            f = m[t];
                        n && (e = n[t]), this.loadItem(f, e);
                    } else a.type === c.JWPLAYER_MEDIA_COMPLETE && (this.trigger(c.JWPLAYER_MEDIA_COMPLETE, d), this.trigger(c.JWPLAYER_PLAYLIST_COMPLETE, {})), this.destroy();
                }
                var m,
                    n,
                    o,
                    p,
                    q,
                    r = h(b),
                    s = new r(a, b),
                    t = 0,
                    u = {},
                    v = g.bind(function (a) {
                    a = a || {}, a.hasControls = !!b.get("controls"), this.trigger(c.JWPLAYER_INSTREAM_CLICK, a), s && s._adModel && (s._adModel.get("state") === d.PAUSED ? a.hasControls && s.instreamPlay() : s.instreamPause());
                }, this),
                    w = g.bind(function () {
                    s && s._adModel && s._adModel.get("state") === d.PAUSED && b.get("controls") && (a.setFullscreen(), a.play());
                }, this);
                this.type = "instream", this.init = function () {
                    o = b.getVideo(), p = b.get("position"), q = b.get("playlist")[b.get("item")], s.on("all", j, this), s.on(c.JWPLAYER_MEDIA_TIME, k, this), s.on(c.JWPLAYER_MEDIA_COMPLETE, l, this), s.init(), o.detachMedia(), b.mediaModel.set("state", d.BUFFERING), a.checkBeforePlay() || 0 === p && !o.checkComplete() ? (p = 0, b.set("preInstreamState", "instream-preroll")) : o && o.checkComplete() || b.get("state") === d.COMPLETE ? b.set("preInstreamState", "instream-postroll") : b.set("preInstreamState", "instream-midroll");
                    var g = b.get("state");
                    return g !== d.PLAYING && g !== d.BUFFERING || o.pause(), f.setupInstream(s._adModel), s._adModel.set("state", d.BUFFERING), f.clickHandler().setAlternateClickHandlers(e.noop, null), this.setText("Loading ad"), this;
                }, this.loadItem = function (a, d) {
                    if (e.isAndroid(2.3)) return void this.trigger({ type: c.JWPLAYER_ERROR, message: "Error loading instream: Cannot play instream on Android 2.3" });
                    g.isArray(a) && (m = a, n = d, a = m[t], n && (d = n[t])), this.trigger(c.JWPLAYER_PLAYLIST_ITEM, { index: t, item: a }), u = g.extend({}, i, d), s.load(a), this.addClickHandler();
                    var f = a.skipoffset || u.skipoffset;
                    f && (s._adModel.set("skipMessage", u.skipMessage), s._adModel.set("skipText", u.skipText), s._adModel.set("skipOffset", f), b.set("skipButton", !0));
                }, this.applyProviderListeners = function (a) {
                    s.applyProviderListeners(a), this.addClickHandler();
                }, this.play = function () {
                    s.instreamPlay();
                }, this.pause = function () {
                    s.instreamPause();
                }, this.hide = function () {
                    s.hide();
                }, this.addClickHandler = function () {
                    f.clickHandler().setAlternateClickHandlers(v, w), s.on(c.JWPLAYER_MEDIA_META, this.metaHandler, this);
                }, this.skipAd = function (a) {
                    var b = c.JWPLAYER_AD_SKIPPED;
                    this.trigger(b, a), l.call(this, { type: b });
                }, this.metaHandler = function (a) {
                    a.width && a.height && f.resizeMedia();
                }, this.destroy = function () {
                    if (this.off(), b.set("skipButton", !1), s) {
                        f.clickHandler() && f.clickHandler().revertAlternateClickHandlers(), s.instreamDestroy(), f.destroyInstream(), s = null, a.attachMedia();
                        var c = b.get("preInstreamState");
                        switch (c) {
                            case "instream-preroll":
                            case "instream-midroll":
                                var h = g.extend({}, q);
                                h.starttime = p, b.loadVideo(h), e.isMobile() && b.mediaModel.get("state") === d.BUFFERING && o.setState(d.BUFFERING), o.play();
                                break;
                            case "instream-postroll":
                            case "instream-idle":
                                o.stop();}
                    }
                }, this.getState = function () {
                    return !(!s || !s._adModel) && s._adModel.get("state");
                }, this.setText = function (a) {
                    f.setAltText(a ? a : "");
                }, this.hide = function () {
                    f.useExternalControls();
                };
            };
            return g.extend(j.prototype, f), j;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(3), c(20), c(21), c(4), c(6), c(2), c(1)], e = function (a, b, c, d, e, f, g) {
            var h = function h(a, d) {
                this.model = d, this._adModel = new b().setup({ id: d.get("id"), volume: d.get("volume"), fullscreen: d.get("fullscreen"), mute: d.get("mute") }), this._adModel.on("change:state", c, this);
                var e = a.getContainer();
                this.swf = e.querySelector("object");
            };
            return h.prototype = g.extend({ init: function init() {
                    if (f.isChrome()) {
                        var a = -1,
                            b = !1;
                        this.swf.on("throttle", function (c) {
                            if (clearTimeout(a), "resume" === c.state) b && (b = !1, this.instreamPlay());else {
                                var d = this;
                                a = setTimeout(function () {
                                    d._adModel.get("state") === e.PLAYING && (b = !0, d.instreamPause());
                                }, 250);
                            }
                        }, this);
                    }
                    this.swf.on("instream:state", function (a) {
                        switch (a.newstate) {
                            case e.PLAYING:
                                this._adModel.set("state", a.newstate);
                                break;
                            case e.PAUSED:
                                this._adModel.set("state", a.newstate);}
                    }, this).on("instream:time", function (a) {
                        this._adModel.set("position", a.position), this._adModel.set("duration", a.duration), this.trigger(d.JWPLAYER_MEDIA_TIME, a);
                    }, this).on("instream:complete", function (a) {
                        this.trigger(d.JWPLAYER_MEDIA_COMPLETE, a);
                    }, this).on("instream:error", function (a) {
                        this.trigger(d.JWPLAYER_MEDIA_ERROR, a);
                    }, this), this.swf.triggerFlash("instream:init"), this.applyProviderListeners = function (a) {
                        this.model.on("change:volume", function (b, c) {
                            a.volume(c);
                        }, this), this.model.on("change:mute", function (b, c) {
                            a.mute(c);
                        }, this);
                    };
                }, instreamDestroy: function instreamDestroy() {
                    this._adModel && (this.off(), this.swf.off(null, null, this), this.swf.triggerFlash("instream:destroy"), this.swf = null, this._adModel.off(), this._adModel = null, this.model = null);
                }, load: function load(a) {
                    this.swf.triggerFlash("instream:load", a);
                }, instreamPlay: function instreamPlay() {
                    this.swf.triggerFlash("instream:play");
                }, instreamPause: function instreamPause() {
                    this.swf.triggerFlash("instream:pause");
                } }, a), h;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(3), c(21), c(4), c(6), c(20)], e = function (a, b, c, d, e, f) {
            var g = function g(_g, h) {
                function i(b) {
                    var e = b || m.getVideo();
                    if (n !== e) {
                        if (n = e, !e) return;
                        e.off(), e.on("all", function (b, c) {
                            c = a.extend({}, c, { type: b }), this.trigger(b, c);
                        }, o), e.on(d.JWPLAYER_MEDIA_BUFFER_FULL, l), e.on(d.JWPLAYER_PLAYER_STATE, j), e.attachMedia(), e.volume(h.get("volume")), e.mute(h.get("mute")), m.on("change:state", c, o);
                    }
                }

                function j(a) {
                    switch (a.newstate) {
                        case e.PLAYING:
                            m.set("state", a.newstate);
                            break;
                        case e.PAUSED:
                            m.set("state", a.newstate);}
                }

                function k(a) {
                    h.trigger(a.type, a), o.trigger(d.JWPLAYER_FULLSCREEN, { fullscreen: a.jwstate });
                }

                function l() {
                    m.getVideo().play();
                }
                var m,
                    n,
                    o = a.extend(this, b);
                return _g.on(d.JWPLAYER_FULLSCREEN, function (a) {
                    this.trigger(d.JWPLAYER_FULLSCREEN, a);
                }, o), this.init = function () {
                    m = new f().setup({ id: h.get("id"), volume: h.get("volume"), fullscreen: h.get("fullscreen"), mute: h.get("mute") }), m.on("fullscreenchange", k), this._adModel = m;
                }, o.load = function (a) {
                    m.set("item", 0), m.set("playlistItem", a), m.setActiveItem(a), i(), m.off(d.JWPLAYER_ERROR), m.on(d.JWPLAYER_ERROR, function (a) {
                        this.trigger(d.JWPLAYER_ERROR, a);
                    }, o), m.loadVideo(a);
                }, o.applyProviderListeners = function (a) {
                    i(a), a.off(d.JWPLAYER_ERROR), a.on(d.JWPLAYER_ERROR, function (a) {
                        this.trigger(d.JWPLAYER_ERROR, a);
                    }, o), h.on("change:volume", function (a, b) {
                        n.volume(b);
                    }, o), h.on("change:mute", function (a, b) {
                        n.mute(b);
                    }, o);
                }, this.instreamDestroy = function () {
                    m && (m.off(), this.off(), n && (n.detachMedia(), n.off(), m.getVideo() && n.destroy()), m = null, _g.off(null, null, this), _g = null);
                }, o.instreamPlay = function () {
                    m.getVideo() && m.getVideo().play(!0);
                }, o.instreamPause = function () {
                    m.getVideo() && m.getVideo().pause(!0);
                }, o;
            };
            return g;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(49), c(4), c(1)], e = function (a, b, c) {
            function d(a) {
                a.mediaController.off(b.JWPLAYER_MEDIA_PLAY_ATTEMPT, a._onPlayAttempt), a.mediaController.off(b.JWPLAYER_PROVIDER_FIRST_FRAME, a._triggerFirstFrame), a.mediaController.off(b.JWPLAYER_MEDIA_TIME, a._onTime);
            }

            function e(a) {
                d(a), a._triggerFirstFrame = c.once(function () {
                    var c = a._qoeItem;
                    c.tick(b.JWPLAYER_MEDIA_FIRST_FRAME);
                    var e = c.between(b.JWPLAYER_MEDIA_PLAY_ATTEMPT, b.JWPLAYER_MEDIA_FIRST_FRAME);
                    a.mediaController.trigger(b.JWPLAYER_MEDIA_FIRST_FRAME, { loadTime: e }), d(a);
                }), a._onTime = g(a._triggerFirstFrame), a._onPlayAttempt = function () {
                    a._qoeItem.tick(b.JWPLAYER_MEDIA_PLAY_ATTEMPT);
                }, a.mediaController.on(b.JWPLAYER_MEDIA_PLAY_ATTEMPT, a._onPlayAttempt), a.mediaController.once(b.JWPLAYER_PROVIDER_FIRST_FRAME, a._triggerFirstFrame), a.mediaController.on(b.JWPLAYER_MEDIA_TIME, a._onTime);
            }

            function f(c) {
                function d(c, d, f) {
                    c._qoeItem && f && c._qoeItem.end(f.get("state")), c._qoeItem = new a(), c._qoeItem.tick(b.JWPLAYER_PLAYLIST_ITEM), c._qoeItem.start(d.get("state")), e(c), d.on("change:state", function (a, b, d) {
                        c._qoeItem.end(d), c._qoeItem.start(b);
                    });
                }
                c.on("change:mediaModel", d);
            }
            var g = function g(a) {
                var b = Number.MIN_VALUE;
                return function (c) {
                    c.position > b && a(), b = c.position;
                };
            };
            return { model: f };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(14), c(23), c(41), c(32), c(15), c(1), c(2), c(4), c(5)], e = function (a, b, d, e, f, g, h, i, j) {
            function k() {
                var a = { LOAD_PROMISE_POLYFILL: { method: l, depends: [] }, LOAD_BASE64_POLYFILL: { method: m, depends: [] }, LOAD_JSON2: { method: n, depends: [] }, LOADED_POLYFILLS: { method: o, depends: ["LOAD_PROMISE_POLYFILL", "LOAD_BASE64_POLYFILL", "LOAD_JSON2"] }, LOAD_PLUGINS: { method: p, depends: ["LOADED_POLYFILLS"] }, INIT_PLUGINS: { method: q, depends: ["LOAD_PLUGINS", "SETUP_VIEW"] }, LOAD_PROVIDERS: { method: B, depends: ["FILTER_PLAYLIST"] }, LOAD_SKIN: { method: A, depends: ["LOADED_POLYFILLS"] }, LOAD_PLAYLIST: { method: s, depends: ["LOADED_POLYFILLS"] }, FILTER_PLAYLIST: { method: t, depends: ["LOAD_PLAYLIST"] }, SETUP_VIEW: { method: C, depends: ["LOAD_SKIN"] }, SEND_READY: { method: D, depends: ["INIT_PLUGINS", "LOAD_PROVIDERS", "SETUP_VIEW"] } };
                return a;
            }

            function l(a) {
                window.Promise ? a() : !function (b) {
                    c(26), a();
                }(c);
            }

            function m(a) {
                window.btoa && window.atob ? a() : !function (b) {
                    c(24), a();
                }(c);
            }

            function n(a) {
                window.JSON ? a() : !function (b) {
                    c(25), a();
                }(c);
            }

            function o(a) {
                a();
            }

            function p(a, c) {
                F = b.loadPlugins(c.get("id"), c.get("plugins")), F.on(i.COMPLETE, a), F.on(i.ERROR, g.partial(r, a)), F.load();
            }

            function q(a, b, c) {
                F.setupPlugins(c, b), a();
            }

            function r(a, b) {
                E(a, "Could not load plugin", b.message);
            }

            function s(a, b) {
                var c = b.get("playlist");
                g.isString(c) ? (G = new d(), G.on(i.JWPLAYER_PLAYLIST_LOADED, function (c) {
                    b.set("playlist", c.playlist), b.set("feedid", c.feedid), a();
                }), G.on(i.JWPLAYER_ERROR, g.partial(x, a)), G.load(c)) : a();
            }

            function t(a, b, c, d, e) {
                var f = b.get("playlist"),
                    g = e(f);
                if (g) a();else {
                    var h = {},
                        i = u(f);
                    h.message = i.errorMessage, h.code = i.errorCode, "111" === h.code ? v(a, h) : w(a, h);
                }
            }

            function u(a) {
                var b = "",
                    c = "";
                return h.flashVersion() || h.isMobile() ? h.flashVersion() && h.flashVersion() < 11.2 ? (b = 'Flash Player version must be 11.2 or greater, <a href="http://www.adobe.com/go/getflashplayer" target="_blank">update Flash Player</a>', c = "102") : h.isMobile() && (h.isRtmp(a[0].file) || "flv" === j.extension(a[0].file)) && (b = "No playable sources found", c = "111") : (b = 'No Flash Player, please <a href="http://www.adobe.com/go/getflashplayer" target="_blank">install</a>', c = "101"), { errorMessage: b, errorCode: c };
            }

            function v(a, b) {
                b && b.message && E(a, "Error loading media", b.message, b.code || "");
            }

            function w(a, b) {
                b && b.message && E(a, "Error loading player", b.message, b.code || "");
            }

            function x(a, b) {
                b && b.message ? E(a, "Error loading playlist", b.message) : E(a, "Error loading player", "No playable sources found");
            }

            function y(a, b) {
                if (g.contains(f.SkinsLoadable, a)) return b + "skins/" + a + ".css";
            }

            function z(a) {
                for (var b = document.styleSheets, c = 0, d = b.length; c < d; c++) {
                    if (b[c].href === a) return !0;
                }return !1;
            }

            function A(a, b) {
                var c = b.get("skin"),
                    d = b.get("skinUrl");
                if (g.contains(f.SkinsIncluded, c)) return void a();
                if (d || (d = y(c, b.get("base"))), g.isString(d) && !z(d)) {
                    b.set("skin-loading", !0);
                    var h = !0,
                        j = new e(d, h);
                    j.addEventListener(i.COMPLETE, function () {
                        b.set("skin-loading", !1);
                    }), j.addEventListener(i.ERROR, function () {
                        b.set("skin", "seven"), b.set("skin-loading", !1);
                    }), j.load();
                }
                g.defer(function () {
                    a();
                });
            }

            function B(b, c) {
                var d = c.getProviders(),
                    e = c.get("playlist"),
                    f = d.required(e);
                a.load(f).then(b);
            }

            function C(a, b, c, d) {
                d.setup(), a();
            }

            function D(a) {
                a({ type: "complete" });
            }

            function E(a, b, c, d) {
                a({ type: "error", msg: b, reason: c, code: d || "" });
            }
            var F, G;
            return { getQueue: k, error: E };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(38), c(2), c(77), c(85)], e = function (a, b) {
            return c.p = b.loadFrom(), a.selectPlayer;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(5)], e = function (a) {
            function b(a) {
                a || c();
            }

            function c() {
                throw new Error("Invalid DFXP file");
            }
            var d = a.seconds;
            return function (e) {
                b(e);
                var f = [],
                    g = e.getElementsByTagName("p");
                b(g), g.length || (g = e.getElementsByTagName("tt:p"), g.length || (g = e.getElementsByTagName("tts:p")));
                for (var h = 0; h < g.length; h++) {
                    var i = g[h],
                        j = i.innerHTML || i.textContent || i.text || "",
                        k = a.trim(j).replace(/>\s+</g, "><").replace(/tts?:/g, "");
                    if (k) {
                        var l = i.getAttribute("begin"),
                            m = i.getAttribute("dur"),
                            n = i.getAttribute("end"),
                            o = { begin: d(l), text: k };
                        n ? o.end = d(n) : m && (o.end = o.begin + d(m)), f.push(o);
                    }
                }
                return f.length || c(), f;
            };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(13), c(5), c(2)], e = function (a, b, c) {
            var d = "jwplayer",
                e = function e(_e5, f) {
                for (var g = [], h = [], i = b.xmlAttribute, j = "default", k = "label", l = "file", m = "type", n = 0; n < _e5.childNodes.length; n++) {
                    var o = _e5.childNodes[n];
                    if (o.prefix === d) {
                        var p = a.localName(o);"source" === p ? (delete f.sources, g.push({ file: i(o, l), "default": i(o, j), label: i(o, k), type: i(o, m) })) : "track" === p ? (delete f.tracks, h.push({ file: i(o, l), "default": i(o, j), kind: i(o, "kind"), label: i(o, k) })) : (f[p] = c.serialize(a.textContent(o)), "file" === p && f.sources && delete f.sources);
                    }
                    f[l] || (f[l] = f.link);
                }
                if (g.length) for (f.sources = [], n = 0; n < g.length; n++) {
                    g[n].file.length > 0 && (g[n][j] = "true" === g[n][j], g[n].label.length || delete g[n].label, f.sources.push(g[n]));
                }if (h.length) for (f.tracks = [], n = 0; n < h.length; n++) {
                    h[n].file.length > 0 && (h[n][j] = "true" === h[n][j], h[n].kind = h[n].kind.length ? h[n].kind : "captions", h[n].label.length || delete h[n].label, f.tracks.push(h[n]));
                }return f;
            };
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(13), c(5), c(2)], e = function (a, b, c) {
            function d(a) {
                for (var b = [], c = 0; c < h(a); c++) {
                    var d = a.childNodes[c];"jwplayer" === d.prefix && "mediatypes" === f(d).toLowerCase() && b.push(g(d));
                }
                return b;
            }
            var e = b.xmlAttribute,
                f = a.localName,
                g = a.textContent,
                h = a.numChildren,
                i = "media",
                j = function j(a, b) {
                function k(a) {
                    var b = { zh: "Chinese", nl: "Dutch", en: "English", fr: "French", de: "German", it: "Italian", ja: "Japanese", pt: "Portuguese", ru: "Russian", es: "Spanish" };
                    return b[a] ? b[a] : a;
                }
                var l,
                    m,
                    n = "tracks",
                    o = [];
                for (m = 0; m < h(a); m++) {
                    if (l = a.childNodes[m], l.prefix === i) {
                        if (!f(l)) continue;
                        switch (f(l).toLowerCase()) {
                            case "content":
                                if (e(l, "duration") && (b.duration = c.seconds(e(l, "duration"))), e(l, "url")) {
                                    b.sources || (b.sources = []);
                                    var p = { file: e(l, "url"), type: e(l, "type"), width: e(l, "width"), label: e(l, "label") },
                                        q = d(l);
                                    q.length && (p.mediaTypes = q), b.sources.push(p);
                                }
                                h(l) > 0 && (b = j(l, b));
                                break;
                            case "title":
                                b.title = g(l);
                                break;
                            case "description":
                                b.description = g(l);
                                break;
                            case "guid":
                                b.mediaid = g(l);
                                break;
                            case "thumbnail":
                                b.image || (b.image = e(l, "url"));
                                break;
                            case "player":
                                break;
                            case "group":
                                j(l, b);
                                break;
                            case "subtitle":
                                var r = {};
                                r.file = e(l, "url"), r.kind = "captions", e(l, "lang").length > 0 && (r.label = k(e(l, "lang"))), o.push(r);}
                    }
                }for (b.hasOwnProperty(n) || (b[n] = []), m = 0; m < o.length; m++) {
                    b[n].push(o[m]);
                }return b;
            };
            return j;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(5), c(13), c(97), c(98), c(40)], e = function (a, b, c, d, e) {
            function f(b) {
                for (var f = {}, h = 0; h < b.childNodes.length; h++) {
                    var i = b.childNodes[h],
                        k = j(i);
                    if (k) switch (k.toLowerCase()) {
                        case "enclosure":
                            f.file = a.xmlAttribute(i, "url");
                            break;
                        case "title":
                            f.title = g(i);
                            break;
                        case "guid":
                            f.mediaid = g(i);
                            break;
                        case "pubdate":
                            f.date = g(i);
                            break;
                        case "description":
                            f.description = g(i);
                            break;
                        case "link":
                            f.link = g(i);
                            break;
                        case "category":
                            f.tags ? f.tags += g(i) : f.tags = g(i);}
                }
                return f = d(b, f), f = c(b, f), new e(f);
            }
            var g = b.textContent,
                h = b.getChildNode,
                i = b.numChildren,
                j = b.localName,
                k = {};
            return k.parse = function (a) {
                for (var b = [], c = 0; c < i(a); c++) {
                    var d = h(a, c),
                        e = j(d).toLowerCase();
                    if ("channel" === e) for (var g = 0; g < i(d); g++) {
                        var k = h(d, g);"item" === j(k).toLowerCase() && b.push(f(k));
                    }
                }
                return b;
            }, k;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(40), c(42), c(1), c(14)], e = function (a, b, c, d) {
            function e(a, b) {
                for (var c = 0; c < a.length; c++) {
                    var d = a[c],
                        e = b.choose(d);
                    if (e) return d.type;
                }
                return null;
            }

            function f(a, b) {
                return c.isUndefined(a) ? b : a;
            }
            var g = function g(b) {
                return b = c.isArray(b) ? b : [b], c.compact(c.map(b, a));
            };
            g.filterPlaylist = function (a, b, d, e, g, j, k) {
                var l = [];
                return c.each(a, function (a) {
                    a = c.extend({}, a), a.allSources = h(a.sources, d, a.drm || e, a.preload || g, f(a.withCredentials, k)), a.sources = i(a.allSources, b), a.sources.length && (a.file = a.sources[0].file, (a.preload || g) && (a.preload = a.preload || g), (a.feedid || j) && (a.feedid = a.feedid || j), l.push(a));
                }), l;
            };
            var h = function h(a, d, e, g, _h2) {
                return c.compact(c.map(a, function (a) {
                    if (c.isObject(a)) return void 0 !== d && null !== d && (a.androidhls = d), (a.drm || e) && (a.drm = a.drm || e), (a.preload || g) && (a.preload = a.preload || g), a.withCredentials = f(a.withCredentials, _h2), b(a);
                }));
            },
                i = function i(a, b) {
                b && b.choose || (b = new d({ primary: b ? "flash" : null }));
                var f = e(a, b);
                return c.where(a, { type: f });
            };
            return g;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1)], e = function (a) {
            var b = { kind: "captions", "default": !1 },
                c = function c(_c) {
                if (_c && _c.file) return a.extend({}, b, _c);
            };
            return c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(19), c(2), c(4), c(3), c(1), c(32)], e = function (a, b, c, d, e, f) {
            function g(a, c, d) {
                return function () {
                    var e = b.getElementsByClassName("jw-overlays", a.getContainer())[0];
                    e && (e.appendChild(d), d.left = e.style.left, d.top = e.style.top, c.displayArea = e);
                };
            }

            function h(a) {
                function b() {
                    var b = a.displayArea;
                    b && a.resize(b.clientWidth, b.clientHeight);
                }
                return function () {
                    b(), setTimeout(b, 400);
                };
            }
            var i = function i(_i2, j) {
                function k() {
                    q || (q = !0, p = f.loaderstatus.COMPLETE, o.trigger(c.COMPLETE));
                }

                function l() {
                    if (!s && (j && 0 !== e.keys(j).length || k(), !q)) {
                        var d = _i2.getPlugins();
                        n = e.after(r, k), e.each(j, function (e, g) {
                            var h = a.getPluginName(g),
                                i = d[h],
                                j = i.getJS(),
                                k = i.getTarget(),
                                l = i.getStatus();
                            l !== f.loaderstatus.LOADING && l !== f.loaderstatus.NEW && (j && !b.versionCheck(k) && o.trigger(c.ERROR, { message: "Incompatible player version" }), n());
                        });
                    }
                }

                function m(a) {
                    if (!s) {
                        var d = "File not found";
                        a.url && b.log(d, a.url), this.off(), this.trigger(c.ERROR, { message: d }), l();
                    }
                }
                var n,
                    o = e.extend(this, d),
                    p = f.loaderstatus.NEW,
                    q = !1,
                    r = e.size(j),
                    s = !1;
                this.setupPlugins = function (c, d) {
                    var f = [],
                        j = _i2.getPlugins(),
                        k = d.get("plugins");
                    e.each(k, function (d, i) {
                        var l = a.getPluginName(i),
                            m = j[l],
                            n = m.getFlashPath(),
                            o = m.getJS(),
                            p = m.getURL();
                        if (n) {
                            var q = e.extend({ name: l, swf: n, pluginmode: m.getPluginmode() }, d);
                            f.push(q);
                        }
                        var r = b.tryCatch(function () {
                            if (o && k[p]) {
                                var a = document.createElement("div");
                                a.id = c.id + "_" + l, a.className = "jw-plugin jw-reset";
                                var b = e.extend({}, k[p]),
                                    d = m.getNewInstance(c, b, a);
                                d.addToPlayer = g(c, d, a), d.resizeHandler = h(d), c.addPlugin(l, d, a);
                            }
                        });
                        r instanceof b.Error && b.log("ERROR: Failed to load " + l + ".");
                    }), d.set("flashPlugins", f);
                }, this.load = function () {
                    if (b.exists(j) && "object" !== b.typeOf(j)) return void l();
                    p = f.loaderstatus.LOADING, e.each(j, function (a, d) {
                        if (b.exists(d)) {
                            var e = _i2.addPlugin(d);
                            e.on(c.COMPLETE, l), e.on(c.ERROR, m);
                        }
                    });
                    var a = _i2.getPlugins();
                    e.each(a, function (a) {
                        a.load();
                    }), l();
                }, this.destroy = function () {
                    s = !0, this.off();
                }, this.getStatus = function () {
                    return p;
                };
            };
            return i;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(46), c(17), c(45)], e = function (a, b) {
            function c(a) {
                var b = new Date(),
                    c = b.getFullYear(),
                    d = b.getMonth() + 1,
                    e = b.getDate(),
                    f = b.getHours(),
                    g = b.getMinutes(),
                    h = b.getSeconds(),
                    i = b.getMilliseconds();
                d = d < 10 ? "0" + d : d, e = e < 10 ? "0" + e : e, f = f < 10 ? "0" + f : f, g = g < 10 ? "0" + g : g, h = h < 10 ? "0" + h : h;
                var j = c + "-" + d + "-" + e + " " + f + ":" + g + ":" + h;
                return a && (j = j + "." + i), j;
            }

            function d() {
                return { flashVersion: a.flashVersion(), cyberPlayerVersion: b, ak: h.ak || "", provider: g.get("provider") ? g.get("provider").name : "", config: "" };
            }

            function e(a) {
                var b = [];
                for (var c in a) {
                    "object" == __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a[c]) ? b.push(c + "=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(a[c]))) : b.push(c + "=" + a[c]);
                }return b.join("&");
            }

            function f(a) {
                if (!r) {
                    var b = a.action;
                    delete a.action, a.sendTime = c(), a = e(a), i && l.removeChild(i), i = document.createElement("script"), i.setAttribute("type", "text/javascript"), i.src = m + b + "?" + a, l.insertBefore(i, l.getElementsByTagName("script")[0]);
                }
            }
            var g,
                h,
                i,
                j,
                k = {},
                l = document.getElementsByTagName("script")[0].parentNode,
                m = "https://drm.media.baidubce.com:8888/v1/sdk-player",
                n = 0,
                o = 0,
                p = !1,
                q = new Date().getTime() + "",
                r = !1,
                s = function s(a, b) {
                var e,
                    i = {},
                    l = 0;
                g = b, h = g.getConfiguration(), a.on("meta", function (a) {
                    for (var b in a.metadata) {
                        k[b] = a.metadata[b];
                    }k.cdn_ip && (i = { action: "/user/web/cdn", url: g.get("file") || g.getCurrentItem().file, cdn: k.cdn_ip }, f(i));
                }), a.on("beforePlay", function () {
                    r = !1, p = !1, e = setInterval(function () {
                        l += 100;
                    }, 100);
                }), a.on("play", function () {
                    return p ? (clearInterval(e), void (e = null)) : (e && (i = { action: "/media/web/available", videoUrl: g.get("file") || g.getCurrentItem().file, type: "play", duration: l, time: c(!0), sessionTime: q, env: d() }, f(i), clearInterval(e), e = null), o = g.get("position"), i = { action: "/user/web/play", videoUrl: g.get("file") || g.getCurrentItem().file, videoHeight: k.height || "", videoWidth: k.width || "", playerHeight: h.height, playerWidth: h.width, duration: k.duration || "", size: k.filesize || "", startPosition: g.get("position"), service: this.getDuration() > 0 ? "vod" : "lss", time: c(!0), sessionTime: q, env: d() }, f(i), p = !0, void (j || (j = setInterval(function () {
                        i = { action: "/user/web/count", session: q, url: g.get("file") || g.getCurrentItem().file }, f(i);
                    }, 6e4), i = { action: "/user/web/count", session: q, url: g.get("file") || g.getCurrentItem().file }, f(i))));
                }), a.on("seek", function (a) {
                    n += a.position - o, o = a.offset, i = { action: "/user/web/seek", videoUrl: g.get("file") || g.getCurrentItem().file, from: a.position, to: a.offset, time: c(!0), sessionTime: q, env: d() }, f(i);
                }), a.on("pause", function () {
                    n += g.get("position") - o, i = { action: "/user/web/pause", videoUrl: g.get("file") || g.getCurrentItem().file, time: c(!0), sessionTime: q, env: d() }, f(i);
                }), a.on("idle", function (a) {
                    "complete" === a.reason && (n += g.get("duration") - o, i = { action: "/user/web/end", videoUrl: g.get("file") || g.getCurrentItem().file, playInterval: n, time: c(!0), sessionTime: q, env: d() }, f(i));
                }), a.on("stop", function () {
                    r = !0, clearInterval(e), e = null, clearInterval(j), j = null, k.duration && (n += g.get("position") - o, i = { action: "/user/web/end", videoUrl: g.get("file") || g.getCurrentItem().file, playInterval: n, time: c(!0), sessionTime: q, env: d() }, f(i));
                }), a.on("error", function (a) {
                    clearInterval(e), i = { action: "/core/web/error", videoUrl: g.get("file") || g.getCurrentItem().file, error: a.code, errorInfo: a.message, time: c(!0), sessionTime: q, env: d() }, f(i);
                }), a.on("setupError", function (a) {
                    i = { action: "/core/web/error", videoUrl: g.get("file") || g.getCurrentItem().file, error: a.code, errorInfo: a.message, time: c(!0), sessionTime: q, env: d() }, f(i);
                });
                var m, s;
                a.on("alive", function () {
                    m = new Date().getTime();
                }), a.on("liveStop", function () {
                    s = new Date().getTime(), i = { action: "/user/web/end", videoUrl: g.get("file") || g.getCurrentItem().file, playInterval: (s - m) / 1e3, time: c(!0), sessionTime: q, env: d() }, f(i);
                });
                var t,
                    u = !0,
                    v = !1,
                    w = 0,
                    x = 0;
                a.on("alive", function () {
                    return v = !0, u ? void (u = !1) : void (t && (w = new Date().getTime() - t, x++, i = { action: "/user/web/buffer", session: q, url: g.get("file") || g.getCurrentItem().file, bt: w, bc: x, env: d() }, f(i), t = null));
                }), a.on("noLiveStream", function () {
                    v && (t || (t = new Date().getTime()));
                });
            };
            return s;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(19), c(43)], e = function (a, b) {
            var c = function c(_c2) {
                this.addPlugin = function (d) {
                    var e = a.getPluginName(d);
                    return _c2[e] || (_c2[e] = new b(d)), _c2[e];
                }, this.getPlugins = function () {
                    return _c2;
                };
            };
            return c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(29), c(28)], e = function (a, b) {
            var c = { html5: a, flash: b };
            return c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(48), c(2), c(30)], e = function (a, b, c, d) {
            function e(c) {
                var d = c.currentTarget.activeCues;
                if (d && d.length) {
                    var e = d[d.length - 1].startTime,
                        f = [];
                    if (a.each(d, function (a) {
                        a.startTime < e || (a.data ? f.push(a) : a.text && this.trigger("meta", { metadataTime: e, metadata: JSON.parse(a.text) }));
                    }, this), f.length) {
                        var g = b.parseID3(f);
                        this.trigger("meta", { metadataTime: e, metadata: g });
                    }
                }
            }

            function f() {
                var a = this.video.textTracks;
                if (v = -1, a) {
                    if (t || k(), a.length) {
                        var b = 0,
                            c = a.length;
                        for (w = 0, b; b < c; b++) {
                            var d = a[b];
                            if (!u[b + d.kind]) if ("metadata" === d.kind) d.oncuechange = e.bind(this), d.mode = "showing", u[b + d.kind] = d, "ID3 Metadata" === d.label && w++;else if ("subtitles" === d.kind || "captions" === d.kind) {
                                var f = d.mode;
                                if (d.mode = "hidden", !d.cues.length && "caterpillar" === this.getName().name && "Unknown CC" === d.label) continue;
                                d.mode = f, t.push(d), u[b + d.kind] = d, "Unknown CC" === d.label && w++;
                            }
                        }
                    }
                    this.addTracksListener(a, "change", p), t && t.length && this.trigger("subtitlesTracks", { tracks: t });
                }
            }

            function g(a) {
                var b = c.isChrome() || c.isIOS() || c.isSafari();!this._isSDK && b && a && (h.call(this, a) || (r(), d.emptyElement(this.video), i(), this.itemTracks = a, j.call(this, a)));
            }

            function h(a) {
                return a === this.itemTracks && t && t.length === w + this.itemTracks.length;
            }

            function i() {
                if (t) {
                    var b = a.filter(t, function (a) {
                        return "Unknown CC" === a.label || "ID3 Metadata" === a.label;
                    });
                    k(), a.each(b, function (a, b) {
                        u[b + a] = a;
                    }), t = b;
                }
            }

            function j(a) {
                if (a) {
                    var b = !1;
                    t || k();
                    for (var d = 0; d < a.length; d++) {
                        var e = a[d];
                        if (/\.(?:web)?vtt(?:\?.*)?$/i.test(e.file)) {
                            if (/subtitles|captions|descriptions|chapters|metadata/i.test(e.kind)) {
                                b || !this.video.hasAttribute("crossorigin") && c.crossdomain(e.file) && (this.video.setAttribute("crossorigin", "anonymous"), b = !0);
                                var f = document.createElement("track");
                                f.src = e.file, f.kind = e.kind, f.srclang = e.language || "", f.label = e.label, f.mode = "disabled", f.id = e.defaulttrack ? "default" : "", this.video.appendChild(f);
                            }
                        } else t.push(e), u[d + e.kind] = f;
                    }
                }
            }

            function k() {
                t = [], u = {};
            }

            function l(b) {
                t && (0 === b && a.each(t, function (a) {
                    a.mode = "disabled";
                }), v !== b - 1 && (r(), v = b - 1, t[v] && (t[v].mode = "showing"), this.trigger("subtitlesTrackChanged", { currentTrack: v + 1, tracks: t })));
            }

            function m() {
                return v;
            }

            function n(a, b, c) {
                c = c.bind(this), a.addEventListener ? a.addEventListener(b, c) : a["on" + b] = c;
            }

            function o(a, b, c) {
                a && (a.removeEventListener ? a.removeEventListener(b, c) : a["on" + b] = null);
            }

            function p() {
                if (t) {
                    var a = -1,
                        b = 0;
                    for (b; b < t.length; b++) {
                        if ("showing" === t[b].mode) {
                            a = b;
                            break;
                        }
                    }this.setSubtitlesTrack(a + 1);
                } else this.setTextTracks();
            }

            function q() {
                t = null, u = null, w = 0;
            }

            function r() {
                t && t[v] && (t[v].mode = "disabled");
            }
            var s = { addTracksListener: n, clearTracks: q, disableTextTrack: r, getSubtitlesTrack: m, removeTracksListener: o, setTextTracks: f, setupSideloadedTracks: g, setSubtitlesTrack: l, textTrackChangeHandler: p },
                t = null,
                u = null,
                v = -1,
                w = 0;
            return s;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(3), c(1)], e = function (a, b, c) {
            function d(a, b, c) {
                var d = document.createElement("param");
                d.setAttribute("name", b), d.setAttribute("value", c), a.appendChild(d);
            }

            function e(e, f, i, j, k) {
                var l;
                if (j = j || "opaque", a.isMSIE() || a.isPoorIE()) {
                    var m = document.createElement("div");
                    f.appendChild(m);
                    var n = k.file;
                    m.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%" id="' + i + '" name="' + i + '" tabindex="0"><param name="movie" value="' + e + '"><param name="allowfullscreen" value="true"><param name="allowscriptaccess" value="always"><param name="wmode" value="' + j + '"><param name="bgcolor" value="' + h + '"><param name="menu" value="false">' + (a.isPoorIE() ? '<param name="flashVars" value="' + (n ? "file=" + n + "&" : "") + 'enableControlbar=true">' : "") + "</object>";
                    for (var o = f.getElementsByTagName("object"), p = o.length; p--;) {
                        o[p].id === i && (l = o[p]);
                    }
                } else l = document.createElement("object"), l.setAttribute("type", "application/x-shockwave-flash"), l.setAttribute("data", e), l.setAttribute("width", "100%"), l.setAttribute("height", "100%"), l.setAttribute("bgcolor", h), l.setAttribute("id", i), l.setAttribute("name", i), d(l, "allowfullscreen", "true"), d(l, "allowscriptaccess", "always"), d(l, "wmode", j), d(l, "menu", "false"), f.appendChild(l, f);
                return l.className = "jw-swf jw-reset", l.style.display = "block", l.style.position = "absolute", l.style.left = 0, l.style.right = 0, l.style.top = 0, l.style.bottom = 0, c.extend(l, b), l.queueCommands = !0, l.triggerFlash = function (b) {
                    var d = this;
                    if ("setup" !== b && d.queueCommands || !d.__externalCall) {
                        for (var e = d.__commandQueue, f = e.length; f--;) {
                            e[f][0] === b && e.splice(f, 1);
                        }return e.push(Array.prototype.slice.call(arguments)), d;
                    }
                    var h = Array.prototype.slice.call(arguments, 1),
                        i = a.tryCatch(function () {
                        if (h.length) {
                            for (var a = h.length; a--;) {
                                "object" == __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(h[a]) && c.each(h[a], g);
                            }var e = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(h);
                            d.__externalCall(b, e);
                        } else d.__externalCall(b);
                    });
                    return i instanceof a.Error && (console.error(b, i), "setup" === b) ? (i.name = "Failed to setup flash", i) : d;
                }, l.__commandQueue = [], l;
            }

            function f(a) {
                a && a.parentNode && (a.style.display = "none", a.parentNode.removeChild(a));
            }

            function g(b, c, d) {
                (a.isPoorIE() && b && b.childNodes || window.HTMLElement && b instanceof window.HTMLElement) && delete d[c];
            }
            var h = "#000000";
            return { embed: e, remove: f };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            return { hasClass: function hasClass(a, b) {
                    var c = " " + b + " ";
                    return 1 === a.nodeType && (" " + a.className + " ").replace(/[\t\r\n\f]/g, " ").indexOf(c) >= 0;
                } };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(15), c(1), c(33), c(31), c(17)], e = function (a, b, c, d, e) {
            var f = {};
            return f.repo = b.memoize(function () {
                var b = e.split("+")[0],
                    d = a.repo + b + "/";
                return c.isHTTPS() ? d.replace(/^http:/, "https:") : d;
            }), f.versionCheck = function (a) {
                var b = ("0" + a).split(/\W/),
                    c = e.split(/\W/),
                    d = parseFloat(b[0]),
                    f = parseFloat(c[0]);
                return !(d > f || d === f && parseFloat("0" + b[1]) > parseFloat(c[1]));
            }, f.loadFrom = function () {
                return f.repo();
            }, f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            var a = {};
            return a.getElementsByClassName = function (a, b, c) {
                if (b = b || document, c = c || "*", b.getElementsByClassName) return b.getElementsByClassName(a);
                for (var d = [], e = b.getElementsByTagName(c), f = e.length, g = new RegExp("(^|\\s)" + a + "(\\s|$)"), h = 0; h < f; h++) {
                    g.test(e[h].className) && d.push(e[h]);
                }return d;
            }, a.addEventListener = function (a, b, c, d) {
                a = a || document, d = d || !1, a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent("on" + b, c);
            }, a.removeEventListener = function (a, b, c, d) {
                a = a || document, d = d || !1, a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent("on" + b, c);
            }, a.arrayFilter = function () {
                Array.prototype.filter || (Array.prototype.filter = function (a) {
                    if (void 0 === this || null === this) throw TypeError();
                    var b = Object(this),
                        c = b.length >>> 0;
                    if ("function" != typeof a) throw TypeError();
                    var d,
                        e = [],
                        f = arguments[1];
                    for (d = 0; d < c; d++) {
                        if (d in b) {
                            var g = b[d];
                            a.call(f, g, d, b) && e.push(g);
                        }
                    }return e;
                });
            }, a.funcBind = function () {
                Function.prototype.bind || (Function.prototype.bind = function (a) {
                    if ("function" != typeof this) throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
                    var b = Array.prototype.slice.call(arguments, 1),
                        c = this,
                        d = function d() {},
                        e = function e() {
                        return c.apply(this instanceof d && a ? this : a || window, b.concat(Array.prototype.slice.call(arguments)));
                    };
                    return d.prototype = this.prototype, e.prototype = new d(), e;
                });
            }, a.arrayFilter(), a.funcBind(), a;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(3)], e = function (a, b) {
            var c = a.extend({ get: function get(a) {
                    return this.attributes = this.attributes || {}, this.attributes[a];
                }, set: function set(a, b) {
                    if (this.attributes = this.attributes || {}, this.attributes[a] !== b) {
                        var c = this.attributes[a];
                        this.attributes[a] = b, this.trigger("change:" + a, this, b, c);
                    }
                }, clone: function clone() {
                    return a.clone(this.attributes);
                } }, b);
            return c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            var a = function a(_a, c, d) {
                if (c = c || this, d = d || [], window.jwplayer && window.jwplayer.debug) return _a.apply(c, d);
                try {
                    return _a.apply(c, d);
                } catch (e) {
                    return new b(_a.name, e);
                }
            },
                b = function b(a, _b) {
                this.name = a, this.message = _b.message || _b.toString(), this.error = _b;
            };
            return { tryCatch: a, Error: b };
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [], e = function () {
            return document.createElement("video");
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(52), c(2), c(1), c(7), c(16)], e = function (a, b, c, d, e) {
            var f = function f(a, b) {
                this.model = a, this.api = b, this.imageUrl = "", this.setup(), this.isHide = !0, this.startAdvPlayed = !1;
            };
            return c.extend(f.prototype, { setup: function setup() {
                    var c = a();
                    this.el = b.createElement(c);
                    var d = this;
                    b.addEventListener(this.el, "click", function () {
                        window.open(d.imageUrl);
                    }, !1);
                }, loadAdv: function loadAdv(a) {
                    var d = this.model.get("imageAdvs");
                    if (d && d[a] && d[a].image) {
                        var f = d[a].image,
                            g = b.getElementsByClassName("jw-media", this.api.getContainer())[0],
                            h = this,
                            i = { display: "block", "z-index": 1e3, width: "100%", height: "100%", top: 0, left: 0 };
                        if (c.isString(f) ? (f = encodeURI(f), i.backgroundImage = 'url("' + f + '")') : i.backgroundImage = "", "end" === a && (i["z-index"] = 0), "pause" === a) {
                            var j = g ? g.clientHeight : this.model.get("height"),
                                k = g ? g.clientWidth : this.model.get("width");
                            i.width = "400px", i.height = "300px", i.top = (j - 300) / 2, i.left = (k - 400) / 2;
                        }
                        e.style(this.el, i);
                        var l = b.getElementsByClassName("adv-close", this.el)[0],
                            m = b.getElementsByClassName("adv-countdown", this.el)[0];
                        if (l.style.display = "none", m.style.display = "none", "start" === a) {
                            var n = d[a].time <= 60 ? d[a].time : 60;
                            m.style.display = "block", m.innerHTML = "广告: " + n + "秒";
                        }"pause" === a && (l.addEventListener("click", function (a) {
                            h.el.style.display = "none", a.stopPropagation();
                        }, !1), l.style.display = "block"), this.imageUrl = d[a].url, this.element() && this.api.getContainer().replaceChild(this.el, this.element()), this.isHide = !1;
                    }
                }, beginStartAdv: function beginStartAdv() {
                    if (this.startAdvPlayed) return void this.model.loadVideo();
                    var a = this.model.get("imageAdvs").start;
                    this.loadAdv("start");
                    var c = a.time <= 60 ? a.time : 60,
                        d = this.element(),
                        e = this,
                        f = setInterval(function () {
                        if (c--, c > 0) {
                            var a = "广告: " + c + "秒";
                            b.getElementsByClassName("adv-countdown", d)[0].innerHTML = a;
                        } else d.style.display = "none", clearInterval(f), e.isHide = !0, e.startAdvPlayed = !0, e.model.loadVideo();
                    }, 1e3);
                }, element: function element() {
                    var a = this.api.getContainer();
                    return b.getElementsByClassName("jw-adv", a).length > 0 ? b.getElementsByClassName("jw-adv", a)[0] : this.el;
                }, isHidden: function isHidden() {
                    return this.isHide;
                }, hide: function hide() {
                    this.isHide = !0, this.element().style.display = "none";
                }, resizePauseAdv: function resizePauseAdv(a, b) {
                    e.style(this.element(), { top: (b - 300) / 2, left: (a - 400) / 2 });
                } }), f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(16), c(6), c(1)], e = function (a, b, c, d) {
            var e = b.style,
                f = { back: !0, fontSize: 15, fontFamily: "Arial,sans-serif", fontOpacity: 100, color: "#FFF", backgroundColor: "#000", backgroundOpacity: 100, edgeStyle: null, windowColor: "#FFF", windowOpacity: 0, preprocessor: d.identity },
                g = function g(_g2) {
                function h(b) {
                    b = b || "";
                    var c = "jw-captions-window jw-reset";
                    b ? (t.innerHTML = b, s.className = c + " jw-captions-window-active") : (s.className = c, a.empty(t));
                }

                function i(a) {
                    q = a, k(o, q);
                }

                function j(a, b) {
                    var c = a.source,
                        e = b.metadata;
                    return c ? !(!e || !d.isNumber(e[c])) && e[c] : b.position;
                }

                function k(a, b) {
                    if (a && a.data && b) {
                        var c = j(a, b);
                        if (c !== !1) {
                            var d = a.data;
                            if (!(p >= 0 && l(d, p, c))) {
                                for (var e = -1, f = 0; f < d.length; f++) {
                                    if (l(d, f, c)) {
                                        e = f;
                                        break;
                                    }
                                }e === -1 ? h("") : e !== p && (p = e, h(u.preprocessor(d[p].text)));
                            }
                        }
                    }
                }

                function l(a, b, c) {
                    return a[b].begin <= c && (!a[b].end || a[b].end >= c) && (b === a.length - 1 || a[b + 1].begin >= c);
                }

                function m(a, c, d) {
                    if (b.css("#" + a + " .jw-video::-webkit-media-text-track-display", c, a), b.css("#" + a + " .jw-video::cue", d, a), d.backgroundColor) {
                        var e = "{background-color: " + d.backgroundColor + " !important;}";
                        b.css("#" + a + " .jw-video::-webkit-media-text-track-display-backdrop", e, a);
                    }
                }

                function n(a, c, d) {
                    var e = b.hexToRgba("#000000", d);"dropshadow" === a ? c.textShadow = "0 2px 1px " + e : "raised" === a ? c.textShadow = "0 0 5px " + e + ", 0 1px 5px " + e + ", 0 2px 5px " + e : "depressed" === a ? c.textShadow = "0 -2px 1px " + e : "uniform" === a && (c.textShadow = "-2px 0 1px " + e + ",2px 0 1px " + e + ",0 -2px 1px " + e + ",0 2px 1px " + e + ",-1px 1px 1px " + e + ",1px 1px 1px " + e + ",1px -1px 1px " + e + ",1px 1px 1px " + e);
                }
                var o,
                    p,
                    q,
                    r,
                    s,
                    t,
                    u = {};
                r = document.createElement("div"), r.className = "jw-captions jw-reset", this.show = function () {
                    r.className = "jw-captions jw-captions-enabled jw-reset";
                }, this.hide = function () {
                    r.className = "jw-captions jw-reset";
                }, this.populate = function (a) {
                    return p = -1, o = a, a ? void k(a, q) : void h("");
                }, this.resize = function () {
                    var a = r.clientWidth,
                        b = Math.pow(a / 400, .6);
                    if (b) {
                        var c = u.fontSize * b;
                        e(r, { fontSize: Math.round(c) + "px" });
                    }
                }, this.setup = function (a, c) {
                    if (s = document.createElement("div"), t = document.createElement("span"), s.className = "jw-captions-window jw-reset", t.className = "jw-captions-text jw-reset", u = d.extend({}, f, c), c) {
                        var h = u.fontOpacity,
                            i = u.windowOpacity,
                            j = u.edgeStyle,
                            k = u.backgroundColor,
                            l = {},
                            o = { color: b.hexToRgba(u.color, h), fontFamily: u.fontFamily, fontStyle: u.fontStyle, fontWeight: u.fontWeight, textDecoration: u.textDecoration };
                        i && (l.backgroundColor = b.hexToRgba(u.windowColor, i)), n(j, o, h), u.back ? o.backgroundColor = b.hexToRgba(k, u.backgroundOpacity) : null === j && n("uniform", o), e(s, l), e(t, o), m(a, l, o);
                    }
                    s.appendChild(t), r.appendChild(s), this.populate(_g2.get("captionsTrack")), _g2.set("captions", u);
                }, this.clear = function () {
                    a.empty(r);
                }, this.element = function () {
                    return r;
                }, _g2.on("change:playlistItem", function () {
                    q = null, p = -1, h("");
                }, this), _g2.on("change:captionsTrack", function (a, b) {
                    this.populate(b);
                }, this), _g2.mediaController.on("seek", function () {
                    p = -1;
                }, this), _g2.mediaController.on("time seek", i, this), _g2.mediaController.on("subtitlesTrackData", function () {
                    k(o, q);
                }, this), _g2.on("change:state", function (a, b) {
                    switch (b) {
                        case c.IDLE:
                        case c.ERROR:
                        case c.COMPLETE:
                            this.hide();
                            break;
                        default:
                            this.show();}
                }, this);
            };
            return g;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(7), c(4), c(3), c(1)], e = function (a, b, c, d) {
            var e = function e(_e6, f, g) {
                function h(a) {
                    if (!_e6.get("flashBlocked")) return k ? void k(a) : void o.trigger(a.type === b.touchEvents.CLICK ? "click" : "tap");
                }

                function i() {
                    return l ? void l() : void o.trigger("doubleClick");
                }
                var j,
                    k,
                    l,
                    m = { enableDoubleTap: !0, useMove: !0 };
                d.extend(this, c), j = f, this.element = function () {
                    return j;
                };
                var n = new a(j, d.extend(m, g));
                n.on("click tap", h), n.on("doubleClick doubleTap", i), n.on("move", function () {
                    o.trigger("move");
                }), n.on("over", function () {
                    o.trigger("over");
                }), n.on("out", function () {
                    o.trigger("out");
                }), this.clickHandler = h;
                var o = this;
                this.setAlternateClickHandlers = function (a, b) {
                    k = a, l = b || null;
                }, this.revertAlternateClickHandlers = function () {
                    k = null, l = null;
                };
            };
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(2), c(22)], e = function (a, b, c) {
            function d(a, b) {
                this.time = a, this.text = b, this.el = document.createElement("div"), this.el.className = "jw-cue jw-reset";
            }
            a.extend(d.prototype, { align: function align(a) {
                    if ("%" === this.time.toString().slice(-1)) this.pct = this.time;else {
                        var b = this.time / a * 100;
                        this.pct = b + "%";
                    }
                    this.el.style.left = this.pct;
                } });
            var e = { loadChapters: function loadChapters(a) {
                    b.ajax(a, this.chaptersLoaded.bind(this), this.chaptersFailed, { plainText: !0 });
                }, chaptersLoaded: function chaptersLoaded(b) {
                    var d = c(b.responseText);
                    a.isArray(d) && (a.each(d, this.addCue, this), this.drawCues());
                }, chaptersFailed: function chaptersFailed() {}, addCue: function addCue(a) {
                    this.cues.push(new d(a.begin, a.text));
                }, drawCues: function drawCues() {
                    var c = this._model.mediaModel.get("duration");
                    if (!c || c <= 0) return void this._model.mediaModel.once("change:duration", this.drawCues, this);
                    var d = this;
                    a.each(this.cues, function (a) {
                        a.align(c), b.addEventListener(a.el, "mouseover", function () {
                            d.activeCue = a;
                        }), b.addEventListener(a.el, "mouseout", function () {
                            d.activeCue = null;
                        }), d.elementRail.appendChild(a.el);
                    });
                }, resetChapters: function resetChapters() {
                    a.each(this.cues, function (a) {
                        a.el.parentNode && a.el.parentNode.removeChild(a.el);
                    }, this), this.cues = [];
                } };
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(18), c(2), c(1), c(7)], e = function (a, b, c, d) {
            var e = a.extend({ constructor: function constructor(b) {
                    a.call(this, b), this.container.className = "jw-overlay-horizontal jw-reset", this.openClass = "jw-open-drawer", this.componentType = "drawer";
                }, setup: function setup(a, e) {
                    this.iconUI || (this.iconUI = new d(this.el, { useHover: !0, directSelect: !0 }), this.toggleOpenStateListener = this.toggleOpenState.bind(this), this.openTooltipListener = this.openTooltip.bind(this), this.closeTooltipListener = this.closeTooltip.bind(this)), this.reset(), a = c.isArray(a) ? a : [], this.activeContents = c.filter(a, function (a) {
                        return a.isActive;
                    }), b.toggleClass(this.el, "jw-hidden", !e || this.activeContents.length < 2), e && this.activeContents.length > 1 && (b.removeClass(this.el, "jw-off"), this.iconUI.on("tap", this.toggleOpenStateListener).on("over", this.openTooltipListener).on("out", this.closeTooltipListener), c.each(a, function (a) {
                        this.container.appendChild(a.el);
                    }, this));
                }, reset: function reset() {
                    b.addClass(this.el, "jw-off"), this.iconUI.off(), this.contentUI && this.contentUI.off().destroy(), this.removeContent();
                } });
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(18), c(2), c(1), c(7), c(57)], e = function (a, b, c, d, e) {
            var f = a.extend({
                setup: function setup(a, f, g) {
                    this.iconUI || (this.iconUI = new d(this.el, { useHover: !0, directSelect: !0 }), this.toggleValueListener = this.toggleValue.bind(this), this.toggleOpenStateListener = this.toggleOpenState.bind(this), this.openTooltipListener = this.openTooltip.bind(this), this.closeTooltipListener = this.closeTooltip.bind(this), this.selectListener = this.select.bind(this)), this.reset(), a = c.isArray(a) ? a : [], b.toggleClass(this.el, "jw-hidden", a.length < 2);
                    var h = a.length > 2 || 2 === a.length && g && g.toggle === !1,
                        i = !h && 2 === a.length;
                    if (b.toggleClass(this.el, "jw-toggle", i), b.toggleClass(this.el, "jw-button-color", !i), this.isActive = h || i, h) {
                        b.removeClass(this.el, "jw-off"), this.iconUI.on("tap", this.toggleOpenStateListener).on("over", this.openTooltipListener).on("out", this.closeTooltipListener);
                        var j = e(a),
                            k = b.createElement(j);
                        this.addContent(k), this.contentUI = new d(this.content).on("click tap", this.selectListener);
                    } else i && this.iconUI.on("click tap", this.toggleValueListener);
                    this.selectItem(f);
                },
                toggleValue: function toggleValue() {
                    this.trigger("toggleValue");
                },
                select: function select(a) {
                    if (a.target.parentElement === this.content) {
                        var d = b.classList(a.target),
                            e = c.find(d, function (a) {
                            return 0 === a.indexOf("jw-item");
                        });
                        e && (this.trigger("select", parseInt(e.split("-")[2])), this.closeTooltipListener());
                    }
                },
                selectItem: function selectItem(a) {
                    if (this.content) for (var c = 0; c < this.content.children.length; c++) {
                        b.toggleClass(this.content.children[c], "jw-active-option", a === c);
                    } else b.toggleClass(this.el, "jw-off", 0 === a);
                },
                reset: function reset() {
                    b.addClass(this.el, "jw-off"), this.iconUI.off(), this.contentUI && this.contentUI.off().destroy(), this.removeContent();
                }
            });
            return f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(1), c(18), c(7), c(59)], e = function (a, b, c, d, e) {
            var f = c.extend({ setup: function setup(c, e) {
                    if (this.iconUI || (this.iconUI = new d(this.el, { useHover: !0 }), this.toggleOpenStateListener = this.toggleOpenState.bind(this), this.openTooltipListener = this.openTooltip.bind(this), this.closeTooltipListener = this.closeTooltip.bind(this), this.selectListener = this.onSelect.bind(this)), this.reset(), c = b.isArray(c) ? c : [], a.toggleClass(this.el, "jw-hidden", c.length < 2), c.length >= 2) {
                        this.iconUI = new d(this.el, { useHover: !0 }).on("tap", this.toggleOpenStateListener).on("over", this.openTooltipListener).on("out", this.closeTooltipListener);
                        var f = this.menuTemplate(c, e),
                            g = a.createElement(f);
                        this.addContent(g), this.contentUI = new d(this.content), this.contentUI.on("click tap", this.selectListener);
                    }
                    this.originalList = c;
                }, menuTemplate: function menuTemplate(c, d) {
                    var f = b.map(c, function (b, c) {
                        var e = b.title ? a.createElement(b.title).textContent : "";
                        return { active: c === d, label: c + 1 + ".", title: e };
                    });
                    return e(f);
                }, onSelect: function onSelect(c) {
                    var d = c.target;
                    if ("UL" !== d.tagName) {
                        "LI" !== d.tagName && (d = d.parentElement);
                        var e = a.classList(d),
                            f = b.find(e, function (a) {
                            return 0 === a.indexOf("jw-item");
                        });
                        f && (this.trigger("select", parseInt(f.split("-")[2])), this.closeTooltip());
                    }
                }, selectItem: function selectItem(a) {
                    this.setup(this.originalList, a);
                }, reset: function reset() {
                    this.iconUI.off(), this.contentUI && this.contentUI.off().destroy(), this.removeContent();
                } });
            return f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(2), c(22)], e = function (a, b, c) {
            function d(a) {
                this.begin = a.begin, this.end = a.end, this.img = a.text;
            }
            var e = { loadThumbnails: function loadThumbnails(a) {
                    a && (this.vttPath = a.split("?")[0].split("/").slice(0, -1).join("/"), this.individualImage = null, b.ajax(a, this.thumbnailsLoaded.bind(this), this.thumbnailsFailed.bind(this), { plainText: !0 }));
                }, thumbnailsLoaded: function thumbnailsLoaded(b) {
                    var e = c(b.responseText);
                    a.isArray(e) && (a.each(e, function (a) {
                        this.thumbnails.push(new d(a));
                    }, this), this.drawCues());
                }, thumbnailsFailed: function thumbnailsFailed() {}, chooseThumbnail: function chooseThumbnail(b) {
                    var c = a.sortedIndex(this.thumbnails, { end: b }, a.property("end"));
                    c >= this.thumbnails.length && (c = this.thumbnails.length - 1);
                    var d = this.thumbnails[c].img;
                    return d.indexOf("://") < 0 && (d = this.vttPath ? this.vttPath + "/" + d : d), d;
                }, loadThumbnail: function loadThumbnail(b) {
                    var c = this.chooseThumbnail(b),
                        d = { display: "block", margin: "0 auto", backgroundPosition: "0 0" },
                        e = c.indexOf("#xywh");
                    if (e > 0) try {
                        var f = /(.+)\#xywh=(\d+),(\d+),(\d+),(\d+)/.exec(c);
                        c = f[1], d.backgroundPosition = f[2] * -1 + "px " + f[3] * -1 + "px", d.width = f[4], d.height = f[5];
                    } catch (g) {
                        return;
                    } else this.individualImage || (this.individualImage = new Image(), this.individualImage.onload = a.bind(function () {
                        this.individualImage.onload = null, this.timeTip.image({ width: this.individualImage.width, height: this.individualImage.height });
                    }, this), this.individualImage.src = c);
                    return d.backgroundImage = 'url("' + c + '")', d;
                }, showThumbnail: function showThumbnail(a) {
                    this.thumbnails.length < 1 || this.timeTip.image(this.loadThumbnail(a));
                }, resetThumbnails: function resetThumbnails() {
                    this.timeTip.image({ backgroundImage: "", width: 0, height: 0 }), this.thumbnails = [];
                } };
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(2), c(15), c(34), c(18), c(117), c(121)], e = function (a, b, c, d, e, f, g) {
            var h = e.extend({ setup: function setup() {
                    this.text = document.createElement("span"), this.text.className = "jw-text jw-reset", this.img = document.createElement("div"), this.img.className = "jw-reset";
                    var a = document.createElement("div");
                    a.className = "jw-time-tip jw-background-color jw-reset", a.appendChild(this.img), a.appendChild(this.text), b.removeClass(this.el, "jw-hidden"), this.addContent(a);
                }, image: function image(a) {
                    b.style(this.img, a);
                }, update: function update(a) {
                    this.text.innerHTML = a;
                } }),
                i = d.extend({ constructor: function constructor(b, c) {
                    this._model = b, this._api = c, this.timeTip = new h("jw-tooltip-time"), this.timeTip.setup(), this.cues = [], this.seekThrottled = a.throttle(this.performSeek, 400), this._model.on("change:playlistItem", this.onPlaylistItem, this).on("change:position", this.onPosition, this).on("change:duration", this.onDuration, this).on("change:buffer", this.onBuffer, this), d.call(this, "jw-slider-time", "horizontal");
                }, setup: function setup() {
                    d.prototype.setup.apply(this, arguments), this._model.get("playlistItem") && this.onPlaylistItem(this._model, this._model.get("playlistItem")), this.elementRail.appendChild(this.timeTip.element()), b.addEventListener(this.el, "mousemove", this.showTimeTooltip.bind(this), !1), b.addEventListener(this.el, "mouseout", this.hideTimeTooltip.bind(this), !1);
                }, limit: function limit(d) {
                    if (this.activeCue && a.isNumber(this.activeCue.pct)) return this.activeCue.pct;
                    var e = this._model.get("duration"),
                        f = b.adaptiveType(e);
                    if ("DVR" === f) {
                        var g = (1 - d / 100) * e,
                            h = this._model.get("position"),
                            i = Math.min(g, Math.max(c.dvrSeekLimit, h)),
                            j = 100 * i / e;
                        return 100 - j;
                    }
                    return d;
                }, update: function update(a) {
                    this.seekTo = a, this.seekThrottled(), d.prototype.update.apply(this, arguments);
                }, dragStart: function dragStart() {
                    this._model.set("scrubbing", !0), d.prototype.dragStart.apply(this, arguments);
                }, dragEnd: function dragEnd() {
                    d.prototype.dragEnd.apply(this, arguments), this._model.set("scrubbing", !1);
                }, onSeeked: function onSeeked() {
                    this._model.get("scrubbing") && this.performSeek();
                }, onBuffer: function onBuffer(a, b) {
                    this.updateBuffer(b);
                }, onPosition: function onPosition(a, b) {
                    this.updateTime(b, a.get("duration"));
                }, onDuration: function onDuration(a, b) {
                    this.updateTime(a.get("position"), b);
                }, updateTime: function updateTime(a, c) {
                    var d = 0;
                    if (c) {
                        var e = b.adaptiveType(c);"DVR" === e ? d = (c - a) / c * 100 : "VOD" === e && (d = a / c * 100);
                    }
                    this.render(d);
                }, onPlaylistItem: function onPlaylistItem(b, c) {
                    this.reset(), b.mediaModel.on("seeked", this.onSeeked, this);
                    var d = c.tracks;
                    a.each(d, function (a) {
                        a && a.kind && "thumbnails" === a.kind.toLowerCase() ? this.loadThumbnails(a.file) : a && a.kind && "chapters" === a.kind.toLowerCase() && this.loadChapters(a.file);
                    }, this);
                }, performSeek: function performSeek() {
                    var a,
                        c = this.seekTo,
                        d = this._model.get("duration"),
                        e = b.adaptiveType(d);
                    0 === d ? this._api.play() : "DVR" === e ? (a = (100 - c) / 100 * d, this._api.seek(a)) : (a = c / 100 * d, this._api.seek(Math.min(a, d - .25)));
                }, showTimeTooltip: function showTimeTooltip(a) {
                    var d = this._model.get("duration");
                    if (0 !== d) {
                        var e = b.bounds(this.elementRail),
                            f = a.pageX ? a.pageX - e.left : a.x;
                        f = b.between(f, 0, e.width);
                        var g = f / e.width,
                            h = d * g;
                        d < 0 && (h = d - h);
                        var i;
                        if (this.activeCue) i = this.activeCue.text;else {
                            var j = !0;
                            i = b.timeFormat(h, j), d < 0 && h > c.dvrSeekLimit && (i = "Live");
                        }
                        this.timeTip.update(i), this.showThumbnail(h), b.addClass(this.timeTip.el, "jw-open"), this.timeTip.el.style.left = 100 * g + "%";
                    }
                }, hideTimeTooltip: function hideTimeTooltip() {
                    b.removeClass(this.timeTip.el, "jw-open");
                }, reset: function reset() {
                    this.resetChapters(), this.resetThumbnails();
                } });
            return a.extend(i.prototype, f, g), i;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(18), c(34), c(7), c(2)], e = function (a, b, c, d) {
            var e = a.extend({ constructor: function constructor(e, f) {
                    this._model = e, a.call(this, f), this.volumeSlider = new b("jw-slider-volume jw-volume-tip", "vertical"), this.addContent(this.volumeSlider.element()), this.addVolumeValueTip(), this.volumeSlider.on("update", function (a) {
                        this.trigger("update", a);
                    }, this), d.removeClass(this.el, "jw-hidden"), new c(this.el, { useHover: !0, directSelect: !0 }).on("click", this.toggleValue, this).on("tap", this.toggleOpenState, this).on("over", this.openTooltip, this).on("out", this.closeTooltip, this);
                }, toggleValue: function toggleValue() {
                    this.trigger("toggleValue");
                }, addVolumeValueTip: function addVolumeValueTip() {
                    var a = document.createElement("div");
                    a.className = "jw-volume-value-tip", d.getElementsByClassName("jw-overlay", this.el)[0].appendChild(a), this.valuetip = a;
                } });
            return e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(1), c(3), c(15), c(7), c(34), c(122), c(119), c(120), c(123), c(118)], e = function (a, b, c, d, e, f, g, h, i, j, k) {
            function l(a, b) {
                var c = document.createElement("div");
                return c.className = "jw-icon jw-icon-inline jw-button-color jw-reset " + a, c.style.display = "none", b && new e(c).on("click tap", function () {
                    b();
                }), { element: function element() {
                        return c;
                    }, toggle: function toggle(a) {
                        a ? this.show() : this.hide();
                    }, show: function show() {
                        c.style.display = "";
                    }, hide: function hide() {
                        c.style.display = "none";
                    } };
            }

            function m(a) {
                var b = document.createElement("span");
                return b.className = "jw-text jw-reset " + a, b;
            }

            function n(a) {
                var b = new h(a);
                return b;
            }

            function o(a, c) {
                var d = document.createElement("div");
                return d.className = "jw-group jw-controlbar-" + a + "-group jw-reset", b.each(c, function (a) {
                    a.element && (a = a.element()), d.appendChild(a);
                }), d;
            }

            function p(b, c) {
                this._api = b, this._model = c, this._isMobile = a.isMobile(), this._compactModeMaxSize = 400, this._maxCompactWidth = -1, this.setup();
            }
            return b.extend(p.prototype, c, { setup: function setup() {
                    this.build(), this.initialize();
                }, build: function build() {
                    var a,
                        c,
                        d,
                        e,
                        h = new g(this._model, this._api),
                        p = new k("jw-icon-more");
                    this._model.get("visualplaylist") !== !1 && (a = new i("jw-icon-playlist")), this._isMobile || (e = l("jw-icon-volume", this._api.setMute), c = new f("jw-slider-volume", "horizontal"), d = new j(this._model, "jw-icon-volume")), this.elements = { alt: m("jw-text-alt"), barLogo: l("jw-icon-barlogo", function () {
                            return;
                        }), play: l("jw-icon-playback", this._api.play.bind(this, { reason: "interaction" })), prev: l("jw-icon-prev", this._api.playlistPrev.bind(this, { reason: "interaction" })), next: l("jw-icon-next", this._api.playlistNext.bind(this, { reason: "interaction" })), playlist: a, elapsed: m("jw-text-elapsed"), time: h, duration: m("jw-text-duration"), drawer: p, hd: n("jw-icon-hd"), cc: n("jw-icon-cc"), audiotracks: n("jw-icon-audio-tracks"), mute: e, volume: c, volumetooltip: d, cast: l("jw-icon-cast jw-off", this._api.castToggle), fullscreen: l("jw-icon-fullscreen", this._api.setFullscreen) }, this.layout = { left: [this.elements.barLogo, this.elements.play, this.elements.prev, this.elements.playlist, this.elements.next, this.elements.elapsed], center: [this.elements.time, this.elements.alt], right: [this.elements.duration, this.elements.hd, this.elements.cc, this.elements.audiotracks, this.elements.drawer, this.elements.mute, this.elements.cast, this.elements.volume, this.elements.volumetooltip, this.elements.fullscreen], drawer: [this.elements.hd, this.elements.cc, this.elements.audiotracks] }, this.menus = b.compact([this.elements.playlist, this.elements.hd, this.elements.cc, this.elements.audiotracks, this.elements.volumetooltip]), this.layout.left = b.compact(this.layout.left), this.layout.center = b.compact(this.layout.center), this.layout.right = b.compact(this.layout.right), this.layout.drawer = b.compact(this.layout.drawer), this.el = document.createElement("div"), this.el.className = "jw-controlbar jw-background-color jw-reset", this.elements.left = o("left", this.layout.left), this.elements.center = o("center", this.layout.center), this.elements.right = o("right", this.layout.right), this.el.appendChild(this.elements.left), this.el.appendChild(this.elements.center), this.el.appendChild(this.elements.right);
                }, initialize: function initialize() {
                    this._model.get("controlbar").barLogo && this.elements.barLogo.show(), this.elements.play.show(), this.elements.fullscreen.show(), this.elements.mute && this.elements.mute.show(), this.onVolume(this._model, this._model.get("volume")), this.onPlaylist(this._model, this._model.get("playlist")), this.onPlaylistItem(this._model, this._model.get("playlistItem")), this.onMediaModel(this._model, this._model.get("mediaModel")), this.onCastAvailable(this._model, this._model.get("castAvailable")), this.onCastActive(this._model, this._model.get("castActive")), this.onCaptionsList(this._model, this._model.get("captionsList")), this._model.on("change:volume", this.onVolume, this), this._model.on("change:mute", this.onMute, this), this._model.on("change:playlist", this.onPlaylist, this), this._model.on("change:playlistItem", this.onPlaylistItem, this), this._model.on("change:mediaModel", this.onMediaModel, this), this._model.on("change:castAvailable", this.onCastAvailable, this), this._model.on("change:castActive", this.onCastActive, this), this._model.on("change:duration", this.onDuration, this), this._model.on("change:position", this.onElapsed, this), this._model.on("change:fullscreen", this.onFullscreen, this), this._model.on("change:captionsList", this.onCaptionsList, this), this._model.on("change:captionsIndex", this.onCaptionsIndex, this), this._model.on("change:compactUI", this.onCompactUI, this), this.elements.volume && this.elements.volume.on("update", function (a) {
                        var b = a.percentage;
                        this._api.setVolume(b);
                    }, this), this.elements.volumetooltip && (this.elements.volumetooltip.on("update", function (a) {
                        var b = a.percentage;
                        this._api.setVolume(b);
                    }, this), this.elements.volumetooltip.on("toggleValue", function () {
                        this._api.setMute();
                    }, this)), this.elements.playlist && this.elements.playlist.on("select", function (a) {
                        this._model.once("itemReady", function () {
                            this._api.play({ reason: "interaction" });
                        }, this), this._api.load(a);
                    }, this), this.elements.hd.on("select", function (a) {
                        this._model.setCurrentQuality(a);
                    }, this), this.elements.hd.on("toggleValue", function () {
                        this._model.getVideo().setCurrentQuality(0 === this._model.getVideo().getCurrentQuality() ? 1 : 0);
                    }, this), this.elements.cc.on("select", function (a) {
                        this._api.setCurrentCaptions(a);
                    }, this), this.elements.cc.on("toggleValue", function () {
                        var a = this._model.get("captionsIndex");
                        this._api.setCurrentCaptions(a ? 0 : 1);
                    }, this), this.elements.audiotracks.on("select", function (a) {
                        this._model.getVideo().setCurrentAudioTrack(a);
                    }, this), new e(this.elements.duration).on("click tap", function () {
                        if ("DVR" === a.adaptiveType(this._model.get("duration"))) {
                            var b = this._model.get("position");
                            this._api.seek(Math.max(d.dvrSeekLimit, b));
                        }
                    }, this), new e(this.el).on("click tap drag", function () {
                        this.trigger("userAction");
                    }, this), this.elements.drawer.on("open-drawer close-drawer", function (b, c) {
                        a.toggleClass(this.el, "jw-drawer-expanded", c.isOpen), c.isOpen || this.closeMenus();
                    }, this), b.each(this.menus, function (a) {
                        a.on("open-tooltip", this.closeMenus, this);
                    }, this);
                }, onCaptionsList: function onCaptionsList(a, b) {
                    var c = a.get("captionsIndex");
                    this.elements.cc.setup(b, c), this.clearCompactMode();
                }, onCaptionsIndex: function onCaptionsIndex(a, b) {
                    this.elements.cc.selectItem(b);
                }, onPlaylist: function onPlaylist(a, b) {
                    var c = b.length > 1;
                    this.elements.next.toggle(c), this.elements.prev.toggle(c), this.elements.playlist && this.elements.playlist.setup(b, a.get("item"));
                }, onPlaylistItem: function onPlaylistItem(a) {
                    this.elements.time.updateBuffer(0), this.elements.time.render(0), this.elements.duration.innerHTML = "00:00", this.elements.elapsed.innerHTML = "00:00", this.clearCompactMode();
                    var b = a.get("item");
                    this.elements.playlist && this.elements.playlist.selectItem(b), this.elements.audiotracks.setup();
                }, onMediaModel: function onMediaModel(c, d) {
                    d.on("change:levels", function (a, b) {
                        this.elements.hd.setup(b, a.get("currentLevel"), { toggle: !1 }), this.clearCompactMode();
                    }, this), d.on("change:currentLevel", function (a, b) {
                        this.elements.hd.selectItem(b);
                    }, this), d.on("change:audioTracks", function (a, c) {
                        var d = b.map(c, function (a) {
                            return { label: a.name };
                        });
                        this.elements.audiotracks.setup(d, a.get("currentAudioTrack"), { toggle: !1 }), this.clearCompactMode();
                    }, this), d.on("change:currentAudioTrack", function (a, b) {
                        this.elements.audiotracks.selectItem(b);
                    }, this), d.on("change:state", function (b, c) {
                        "complete" === c && (this.elements.drawer.closeTooltip(), a.removeClass(this.el, "jw-drawer-expanded"));
                    }, this);
                }, onVolume: function onVolume(a, b, c) {
                    this.renderVolume(a.get("mute"), b, c);
                }, onMute: function onMute(a, b) {
                    this.renderVolume(b, a.get("volume"));
                }, renderVolume: function renderVolume(b, c, d) {
                    var e;
                    d || (d = c), this.elements.mute && a.toggleClass(this.elements.mute.element(), "jw-off", b), this.elements.volume && this.elements.volume.render(b ? 0 : c), this.elements.volumetooltip && (this.elements.volumetooltip.volumeSlider.render(b ? 0 : c), a.toggleClass(this.elements.volumetooltip.element(), "jw-off", b)), this.elements.volumetooltip && this.elements.volumetooltip.valuetip && (e = this.elements.volumetooltip.valuetip, b ? e.innerHTML = "0%" : 100 === c && c > d && this._model.get("provider") && /^flash/.test(this._model.get("provider").name) ? e.innerHTML = "100%(按↑可以继续增大音量)" : e.innerHTML = c + "%");
                }, onCastAvailable: function onCastAvailable(a, b) {
                    this.elements.cast.toggle(b), this.clearCompactMode();
                }, onCastActive: function onCastActive(b, c) {
                    a.toggleClass(this.elements.cast.element(), "jw-off", !c);
                }, onElapsed: function onElapsed(b, c) {
                    var d,
                        e = b.get("duration");
                    d = "DVR" === a.adaptiveType(e) ? "-" + a.timeFormat(-e) : a.timeFormat(c), this.elements.elapsed.innerHTML = d;
                }, onDuration: function onDuration(b, c) {
                    var d;"DVR" === a.adaptiveType(c) ? (d = "Live", this.clearCompactMode()) : d = a.timeFormat(c), this.elements.duration.innerHTML = d;
                }, onFullscreen: function onFullscreen(b, c) {
                    a.toggleClass(this.elements.fullscreen.element(), "jw-off", c);
                }, element: function element() {
                    return this.el;
                }, getVisibleBounds: function getVisibleBounds() {
                    var b,
                        c = this.el,
                        d = getComputedStyle ? getComputedStyle(c) : c.currentStyle;
                    return "table" === d.display ? a.bounds(c) : (c.style.visibility = "hidden", c.style.display = "table", b = a.bounds(c), c.style.visibility = c.style.display = "", b);
                }, setAltText: function setAltText(a) {
                    this.elements.alt.innerHTML = a;
                }, addCues: function addCues(a) {
                    this.elements.time && (b.each(a, function (a) {
                        this.elements.time.addCue(a);
                    }, this), this.elements.time.drawCues());
                }, closeMenus: function closeMenus(a) {
                    b.each(this.menus, function (b) {
                        a && a.target === b.el || b.closeTooltip(a);
                    });
                }, hideComponents: function hideComponents() {
                    this.closeMenus(), this.elements.drawer.closeTooltip(), a.removeClass(this.el, "jw-drawer-expanded");
                }, clearCompactMode: function clearCompactMode() {
                    this._maxCompactWidth = -1, this._model.set("compactUI", !1), this._containerWidth && this.checkCompactMode(this._containerWidth);
                }, setCompactModeBounds: function setCompactModeBounds() {
                    if (this.element().offsetWidth > 0) {
                        var b = this.elements.left.offsetWidth + this.elements.right.offsetWidth;
                        if ("LIVE" === a.adaptiveType(this._model.get("duration"))) this._maxCompactWidth = b + this.elements.alt.offsetWidth;else {
                            var c = b + (this.elements.center.offsetWidth - this.elements.time.el.offsetWidth),
                                d = .2;
                            this._maxCompactWidth = c / (1 - d);
                        }
                    }
                }, checkCompactMode: function checkCompactMode(a) {
                    this.setCompactModeBounds(), this._containerWidth = a, this._maxCompactWidth !== -1 && (a >= this._compactModeMaxSize && a > this._maxCompactWidth ? this._model.set("compactUI", !1) : (a < this._compactModeMaxSize || a <= this._maxCompactWidth) && this._model.set("compactUI", !0));
                }, onCompactUI: function onCompactUI(c, d) {
                    a.removeClass(this.el, "jw-drawer-expanded"), this.elements.drawer.setup(this.layout.drawer, d), (!d || this.elements.drawer.activeContents.length < 2) && b.each(this.layout.drawer, function (a) {
                        this.elements.right.insertBefore(a.el, this.elements.drawer.el);
                    }, this);
                } }), p;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(3), c(7), c(53), c(1)], e = function (a, b, c, d, e) {
            var f = function f(_f3) {
                e.extend(this, b), this.model = _f3, this.el = a.createElement(d({}));
                var g = this;
                this.iconUI = new c(this.el).on("click tap", function (a) {
                    g.trigger(a.type);
                });
            };
            return e.extend(f.prototype, { element: function element() {
                    return this.el;
                } }), f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(54), c(2), c(1), c(7)], e = function (a, b, c, d) {
            var e = function e(a) {
                this.model = a, this.setup(), this.model.on("change:dock", this.render, this);
            };
            return c.extend(e.prototype, { setup: function setup() {
                    var c = this.model.get("dock"),
                        e = this.click.bind(this),
                        f = a(c);
                    this.el = b.createElement(f), new d(this.el).on("click tap", e);
                }, getDockButton: function getDockButton(a) {
                    return b.hasClass(a.target, "jw-dock-button") ? a.target : b.hasClass(a.target, "jw-dock-text") ? a.target.parentElement.parentElement : a.target.parentElement;
                }, click: function click(a) {
                    var b = this.getDockButton(a),
                        d = b.getAttribute("button"),
                        e = this.model.get("dock"),
                        f = c.findWhere(e, { id: d });
                    f && f.callback && f.callback(a);
                }, render: function render() {
                    var c = this.model.get("dock"),
                        d = a(c),
                        e = b.createElement(d);
                    this.el.innerHTML = e.innerHTML;
                }, element: function element() {
                    return this.el;
                } }), e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(55)], e = function (a) {
            function b(b, c, d, e) {
                return a({ id: b, skin: c, title: d, body: e });
            }
            return b;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(7), c(2), c(4), c(1), c(3), c(56)], e = function (a, b, c, d, e, f) {
            var g = b.style,
                h = { linktarget: "_blank", margin: 8, hide: !1, position: "top-right" },
                i = function i(_i3) {
                var j,
                    k,
                    l = new Image(),
                    m = d.extend({}, _i3.get("logo"));
                return d.extend(this, e), this.setup = function (e) {
                    if (k = d.extend({}, h, m), k.hide = "true" === k.hide.toString(), j = b.createElement(f()), k.file) {
                        k.hide && b.addClass(j, "jw-hide"), b.addClass(j, "jw-logo-" + (k.position || h.position)), "top-right" === k.position && (_i3.on("change:dock", this.topRight, this), _i3.on("change:controls", this.topRight, this), this.topRight(_i3)), _i3.set("logo", k), l.onload = function () {
                            var a = { backgroundImage: 'url("' + this.src + '")', width: this.width, height: this.height };
                            if (k.margin !== h.margin) {
                                var b = /(\w+)-(\w+)/.exec(k.position);
                                3 === b.length && (a["margin-" + b[1]] = k.margin, a["margin-" + b[2]] = k.margin);
                            }
                            g(j, a), _i3.set("logoWidth", a.width);
                        }, l.src = k.file;
                        var n = new a(j);
                        n.on("click tap", function (a) {
                            b.exists(a) && a.stopPropagation && a.stopPropagation(), this.trigger(c.JWPLAYER_LOGO_CLICK, { link: k.link, linktarget: k.linktarget });
                        }, this), e.appendChild(j);
                    }
                }, this.topRight = function (a) {
                    var b = a.get("controls"),
                        c = a.get("dock"),
                        d = b && (c && c.length || a.get("sharing") || a.get("related"));
                    g(j, { top: d ? "3.5em" : 0 });
                }, this.element = function () {
                    return j;
                }, this.position = function () {
                    return k.position;
                }, this.destroy = function () {
                    l.onload = null;
                }, this;
            };
            return i;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(1), c(16)], e = function (a, b, c) {
            function d(a) {
                return a > 100 ? 30 + Math.random() * (a - 100) : a / 2;
            }

            function e(a, b) {
                c.style(a, { top: d(b) });
            }
            var f = function f(a, b) {
                this.model = a, this.element = b, this.times = 0, this.init();
            };
            return b.extend(f.prototype, { init: function init() {
                    if (a.isMSIE(9)) return c.style(this.element, { display: "none" }), !1;
                    var b = this.model.get("marquee").text,
                        d = this.model.get("marquee").color,
                        e = this.model.get("marquee").fontSize;
                    b && (this.element.innerHTML = b), d && c.style(this.element, { color: d }), e && c.style(this.element, { fontSize: e, lineHeight: e + 8 }), this.reset();
                }, start: function start() {
                    return !a.isMSIE(9) && void c.style(this.element, { animationPlayState: "running", opacity: 1, display: "block" });
                }, stop: function stop() {
                    this.reset(), c.style(this.element, { animationPlayState: "paused", opacity: 0, display: "none" });
                }, pause: function pause() {
                    c.style(this.element, { animationPlayState: "paused", opacity: 0 });
                }, reset: function reset(b, d) {
                    b = b || this.model.get("width"), d = d || this.model.get("height");
                    var f = 18,
                        g = this.element,
                        h = this.times % 2 === 0 ? "marquee1" : "marquee2";
                    c.animation(g, h + " " + f + "s infinite"), e(g, d), a.addEventListener(g, "webkitAnimationIteration", function () {
                        e(g, d);
                    }, !1), a.addEventListener(g, "animationiteration", function () {
                        e(g, d);
                    }, !1), this.times++;
                } }), f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(2)], e = function (a, b) {
            function c(a, b) {
                b.off("change:mediaType", null, this), b.on("change:mediaType", function (b, c) {
                    "audio" === c && this.setImage(a.get("playlistItem").image);
                }, this);
            }

            function d(a, c) {
                var d = a.get("autostart") && !b.isMobile() || a.get("item") > 0;
                return d ? (this.setImage(null), a.off("change:state", null, this), void a.on("change:state", function (a, b) {
                    "complete" !== b && "idle" !== b && "error" !== b || this.setImage(c.image);
                }, this)) : void this.setImage(c.image);
            }
            var e = function e(a) {
                this.model = a, a.on("change:playlistItem", d, this), a.on("change:mediaModel", c, this);
            };
            return a.extend(e.prototype, { setup: function setup(a) {
                    this.el = a;
                    var b = this.model.get("playlistItem");
                    b && this.setImage(b.image);
                }, setImage: function setImage(c) {
                    var d = this.image;
                    d && (d.onload = null, this.image = null), this.model.off("change:state", null, this);
                    var e = "";
                    a.isString(c) && (e = 'url("' + c + '")', d = this.image = new Image(), d.src = c), b.style(this.el, { backgroundImage: e });
                }, resize: function resize(a, c, d) {
                    if ("uniform" === d) {
                        var e = a / c,
                            f = this.image,
                            g = null;
                        if (f) {
                            if (0 === f.width) {
                                var h = this;
                                return void (f.onload = function () {
                                    h.resize(a, c, d);
                                });
                            }
                            var i = f.width / f.height;
                            Math.abs(e - i) < .09 && (g = "cover");
                        }
                        b.style(this.el, { backgroundSize: g });
                    }
                }, element: function element() {
                    return this.el;
                } }), e;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(60), c(1), c(7), c(17)], e = function (a, b, c, d, e) {
            var f = function f() {};
            return c.extend(f.prototype, { buildArray: function buildArray() {
                    var b = e.split("+"),
                        c = b[0],
                        d = { items: [{ title: "About Cyber Player " + c, featured: !0, showLogo: !1, link: "https://bce.baidu.com/doc/MCT/Web-SDK.html#.E6.92.AD.E6.94.BE.E5.99.A8.20Web.20SDK.20.E7.AE.80.E4.BB.8B" }] },
                        f = this.model.get("provider");
                    if (f && f.name.indexOf("flash") >= 0) {
                        var g = "Flash Version " + a.flashVersion();
                        d.items.push({ title: g, link: "http://www.adobe.com/software/flash/about/" });
                    }
                    return d;
                }, buildMenu: function buildMenu() {
                    var c = this.buildArray();
                    return a.createElement(b(c));
                }, updateHtml: function updateHtml() {
                    this.el.innerHTML = this.buildMenu().innerHTML;
                }, rightClick: function rightClick(a) {
                    return this.lazySetup(), !this.mouseOverContext && (this.hideMenu(), this.showMenu(a), !1);
                }, getOffset: function getOffset(b) {
                    var c = b.target,
                        d = b.layerX || b.offsetX,
                        e = b.layerY || b.offsetY;
                    if (a.isIE() && (a.hasClass(c, "jw-video") || a.hasClass(c, "jw-warning"))) return { x: d, y: e + 40 };
                    for (; c !== this.playerElement;) {
                        d += c.offsetLeft, e += c.offsetTop, c = c.parentNode;
                    }return d = d <= this.playerElement.clientWidth ? d : this.playerElement.clientWidth, e = e <= this.playerElement.clientHeight ? e : this.playerElement.clientHeight, { x: d, y: e };
                }, showMenu: function showMenu(b) {
                    var c = this.getOffset(b);
                    return this.el.style.left = c.x + "px", this.el.style.top = c.y + "px", a.addClass(this.playerElement, "jw-flag-rightclick-open"), a.addClass(this.el, "jw-open"), !1;
                }, hideMenu: function hideMenu() {
                    this.mouseOverContext || (a.removeClass(this.playerElement, "jw-flag-rightclick-open"), a.removeClass(this.el, "jw-open"));
                }, lazySetup: function lazySetup() {
                    this.el || (this.el = this.buildMenu(), this.layer.appendChild(this.el), this.hideMenuHandler = this.hideMenu.bind(this), this.addOffListener(this.playerElement), this.addOffListener(document), this.model.on("change:provider", this.updateHtml, this), this.elementUI = new d(this.el, { useHover: !0 }).on("over", function () {
                        this.mouseOverContext = !0;
                    }, this).on("out", function () {
                        this.mouseOverContext = !1;
                    }, this));
                }, setup: function setup(b, c, d) {
                    this.playerElement = c, this.model = b, this.mouseOverContext = !1, this.layer = d, a.isPoorIE() || (c.oncontextmenu = this.rightClick.bind(this));
                }, addOffListener: function addOffListener(b) {
                    a.addEventListener(b, "mousedown", this.hideMenuHandler), a.addEventListener(b, "touchstart", this.hideMenuHandler), a.addEventListener(b, "pointerdown", this.hideMenuHandler);
                }, removeOffListener: function removeOffListener(b) {
                    a.removeEventListener(b, "mousedown", this.hideMenuHandler), a.removeEventListener(b, "touchstart", this.hideMenuHandler), a.removeEventListener(b, "pointerdown", this.hideMenuHandler);
                }, destroy: function destroy() {
                    this.el && (this.hideMenu(), this.elementUI.off(), this.removeOffListener(this.playerElement), this.removeOffListener(document), this.hideMenuHandler = null, this.el = null), this.playerElement && (this.playerElement.oncontextmenu = null, this.playerElement = null), this.model && (this.model.off("change:provider", this.updateHtml), this.model = null);
                } }), f;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(1), c(2)], e = function (a, b) {
            var c = function c(a) {
                this.model = a, this.model.on("change:playlistItem", this.playlistItem, this);
            };
            return a.extend(c.prototype, { hide: function hide() {
                    this.el.style.display = "none";
                }, show: function show() {
                    this.el.style.display = "";
                }, setup: function setup(a) {
                    this.el = a;
                    var b = this.el.getElementsByTagName("div");
                    this.title = b[0], this.description = b[1], this.model.get("playlistItem") && this.playlistItem(this.model, this.model.get("playlistItem")), this.model.on("change:logoWidth", this.update, this), this.model.on("change:dock", this.update, this);
                }, update: function update(a) {
                    var c = { paddingLeft: 0, paddingRight: 0 },
                        d = a.get("controls"),
                        e = a.get("dock"),
                        f = a.get("logo");
                    if (f) {
                        var g = 1 * ("" + f.margin).replace("px", ""),
                            h = a.get("logoWidth") + (isNaN(g) ? 0 : g);"top-left" === f.position ? c.paddingLeft = h : "top-right" === f.position && (c.paddingRight = h);
                    }
                    if (d && e && e.length) {
                        var i = 56 * e.length;
                        c.paddingRight = Math.max(c.paddingRight, i);
                    }
                    b.style(this.el, c);
                }, playlistItem: function playlistItem(a, b) {
                    if (a.get("displaytitle") || a.get("displaydescription")) {
                        var c = "",
                            d = "";
                        b.title && a.get("displaytitle") && (c = b.title), b.description && a.get("displaydescription") && (d = b.description), this.updateText(c, d);
                    } else this.hide();
                }, updateText: function updateText(a, b) {
                    this.title.innerHTML = a, this.description.innerHTML = b, this.title.firstChild || this.description.firstChild ? this.show() : this.hide();
                }, element: function element() {
                    return this.el;
                } }), c;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }, function (a, b, c) {
        var d, e;
        d = [c(2), c(4), c(3), c(15), c(6), c(115), c(116), c(125), c(126), c(128), c(124), c(130), c(114), c(129), c(131), c(132), c(1), c(58)], e = function (a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r) {
            var s = a.style,
                t = a.bounds,
                u = a.isMobile(),
                v = ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"],
                w = function w(_w, x) {
                function y(b) {
                    var c = 0,
                        e = x.get("duration"),
                        f = x.get("position");"DVR" === a.adaptiveType(e) && (c = e, e = Math.max(f, d.dvrSeekLimit));
                    var g = a.between(f + b, c, e);
                    _w.seek(g);
                }

                function z(b) {
                    var c,
                        d = x.get("volume");"-" === b ? c = d > 100 ? -50 : -10 : (c = d >= 100 ? 50 : 10, d < 100 && d + c > 100 && (c = 100 - d));
                    var e = a.between(x.get("volume") + c, 0, 500);
                    _w.setVolume(e);
                }

                function A(a) {
                    return !a.ctrlKey && !a.metaKey && !!x.get("controls");
                }

                function B(a) {
                    if (!A(a)) return !0;
                    switch (Ka || ca(), a.keyCode) {
                        case 27:
                            _w.setFullscreen(!1);
                            break;
                        case 13:
                        case 32:
                            _w.play({ reason: "interaction" });
                            break;
                        case 37:
                            Ka || y(-5);
                            break;
                        case 39:
                            Ka || y(5);
                            break;
                        case 38:
                            z("+");
                            break;
                        case 40:
                            z("-");
                            break;
                        case 67:
                            var b = _w.getCaptionsList(),
                                c = b.length;
                            if (c) {
                                var d = (_w.getCurrentCaptions() + 1) % c;
                                _w.setCurrentCaptions(d);
                            }
                            break;
                        case 77:
                            _w.setMute();
                            break;
                        case 70:
                            _w.setFullscreen();
                            break;
                        default:
                            if (a.keyCode >= 48 && a.keyCode <= 59) {
                                var e = a.keyCode - 48,
                                    f = e / 10 * x.get("duration");
                                _w.seek(f);
                            }}
                    return (/13|32|37|38|39|40/.test(a.keyCode) ? (a.preventDefault(), !1) : void 0
                    );
                }

                function C() {
                    Pa = !1, a.removeClass(la, "jw-no-focus");
                }

                function D() {
                    Pa = !0, a.addClass(la, "jw-no-focus");
                }

                function E() {
                    Pa || C(), Ka || ca();
                }

                function F() {
                    var c = t(la),
                        d = Math.round(c.width),
                        e = Math.round(c.height);
                    return document.body.contains(la) ? d && e && (d === oa && e === pa || (oa = d, pa = e, clearTimeout(Ma), Ma = setTimeout(Z, 50), x.set("containerWidth", d), x.set("containerHeight", e), Qa.trigger(b.JWPLAYER_RESIZE, { width: d, height: e }))) : (a.removeEventListener(window, "resize", F), u && a.removeEventListener(window, "orientationchange", F)), c;
                }

                function G(b, c) {
                    c = c || !1, a.toggleClass(la, "jw-flag-casting", c);
                }

                function H(b, c) {
                    a.toggleClass(la, "jw-flag-cast-available", c), a.toggleClass(ma, "jw-flag-cast-available", c);
                }

                function I(b, c) {
                    a.replaceClass(la, /jw-stretch-\S+/, "jw-stretch-" + c);
                }

                function J(b, c) {
                    a.toggleClass(la, "jw-flag-compact-player", c);
                }

                function K(b) {
                    b && !u && (a.addEventListener(b.element(), "mousemove", N, !1), a.addEventListener(b.element(), "mouseout", O, !1));
                }

                function L() {
                    x.get("state") !== e.IDLE && x.get("state") !== e.COMPLETE && x.get("state") !== e.PAUSED || !x.get("controls") || _w.play({ reason: "interaction" }), La ? ba() : ca();
                }

                function M(a) {
                    a.link ? (_w.pause(!0), _w.setFullscreen(!1), window.open(a.link, a.linktarget)) : x.get("controls") && _w.play({ reason: "interaction" });
                }

                function N() {
                    clearTimeout(Ha);
                }

                function O() {
                    ca();
                }

                function P(a) {
                    Qa.trigger(a.type, a);
                }

                function Q(b, c) {
                    c ? (Ca && Ca.destroy(), a.addClass(la, "jw-flag-flash-blocked")) : (Ca && Ca.setup(x, la, la), a.removeClass(la, "jw-flag-flash-blocked"));
                }

                function R() {
                    x.get("controls") && _w.setFullscreen();
                }

                function S() {
                    var c = a.getElementsByClassName("jw-overlays", la)[0];
                    a.addEventListener(c, "mousemove", ca), va = new g(x, na, { useHover: !0 }), va.on("click", function () {
                        P({ type: b.JWPLAYER_DISPLAY_CLICK }), x.get("controls") && _w.play({ reason: "interaction" });
                    }), va.on("tap", function () {
                        P({ type: b.JWPLAYER_DISPLAY_CLICK }), L();
                    }), va.on("doubleClick", R), va.on("move", ca), va.on("over", ca);
                    var d = new h(x);
                    d.on("click", function () {
                        P({ type: b.JWPLAYER_DISPLAY_CLICK }), _w.play({ reason: "interaction" });
                    }), d.on("tap", function () {
                        P({ type: b.JWPLAYER_DISPLAY_CLICK }), L();
                    }), a.isChrome() && d.el.addEventListener("mousedown", function () {
                        var a = x.getVideo(),
                            b = a && 0 === a.getName().name.indexOf("flash");
                        if (b) {
                            var c = function c() {
                                document.removeEventListener("mouseup", c), d.el.style.pointerEvents = "auto";
                            };
                            this.style.pointerEvents = "none", document.addEventListener("mouseup", c);
                        }
                    }), ma.appendChild(d.element()), xa = new i(x), ya = new j(x), ya.on(b.JWPLAYER_LOGO_CLICK, M);
                    var e = document.createElement("div");
                    e.className = "jw-controls-right jw-reset", ya.setup(e), e.appendChild(xa.element()), ma.appendChild(e), Aa = new f(x), Aa.setup(la.id, x.get("captions")), ma.parentNode.insertBefore(Aa.element(), za.element());
                    var l = x.get("height");
                    u && ("string" == typeof l || l >= 1.5 * Ja) ? a.addClass(la, "jw-flag-touch") : (Ca = new o(), Ca.setup(x, la, la)), ra = new k(_w, x), ra.on(b.JWPLAYER_USER_ACTION, ca), x.on("change:scrubbing", U), x.on("change:compactUI", J), ma.appendChild(ra.element()), a.addEventListener(la, "focus", E), a.addEventListener(la, "blur", C), a.addEventListener(la, "keydown", B), la.onmousedown = D;
                }

                function T(b) {
                    return b.get("state") === e.PAUSED ? void b.once("change:state", T) : void (b.get("scrubbing") === !1 && a.removeClass(la, "jw-flag-dragging"));
                }

                function U(b, c) {
                    b.off("change:state", T), c ? a.addClass(la, "jw-flag-dragging") : T(b);
                }

                function V(b, c, d) {
                    var e,
                        f = la.className;
                    d = !!d, d && (f = f.replace(/\s*aspectMode/, ""), la.className !== f && (la.className = f), a.style(la, { display: "block" }, d)), a.exists(b) && a.exists(c) && (x.set("width", b), x.set("height", c)), e = { width: b }, a.hasClass(la, "jw-flag-aspect-mode") || (e.height = c), s(la, e, !0), W(c), Z(b, c);
                }

                function W(b) {
                    if (Ba = X(b), ra && !Ba) {
                        var c = Ka ? qa : x;
                        ka(c, c.get("state"));
                    }
                    a.toggleClass(la, "jw-flag-audio-player", Ba);
                }

                function X(a) {
                    if (x.get("aspectratio")) return !1;
                    if (q.isString(a) && a.indexOf("%") > -1) return !1;
                    var b = q.isNumber(a) ? a : x.get("containerHeight");
                    return Y(b);
                }

                function Y(a) {
                    return a && a <= Ja * (u ? 1.75 : 1);
                }

                function Z(b, c) {
                    if (!b || isNaN(Number(b))) {
                        if (!na) return;
                        b = na.clientWidth;
                    }
                    if (!c || isNaN(Number(c))) {
                        if (!na) return;
                        c = na.clientHeight;
                    }
                    sa && sa.resize(b, c, x.get("stretching")), a.isMSIE(9) && document.all && !window.atob && (b = c = "100%");
                    var d = x.getVideo();
                    if (d) {
                        var f = d.resize(b, c, x.get("stretching"));
                        f && (clearTimeout(Ma), Ma = setTimeout(Z, 250)), Aa.resize(), ra.checkCompactMode(b), x.get("state") === e.PAUSED && x.get("imageAdvs") && x.get("imageAdvs").pause && ta && !ta.isHidden() && ta.resizePauseAdv(b, c);
                    }
                }

                function $() {
                    if (Oa) {
                        var a = document.fullscreenElement || document.webkitCurrentFullScreenElement || document.mozFullScreenElement || document.msFullscreenElement;
                        return !(!a || a.id !== x.get("id"));
                    }
                    return Ka ? qa.getVideo().getFullScreen() : x.getVideo().getFullScreen();
                }

                function _(a) {
                    var b = x.get("fullscreen"),
                        c = void 0 !== a.jwstate ? a.jwstate : $();
                    b !== c && x.set("fullscreen", c), clearTimeout(Ma), Ma = setTimeout(Z, 200);
                }

                function aa(b, c) {
                    c ? (a.addClass(b, "jw-flag-fullscreen"), s(document.body, { "overflow-y": "hidden" }), ca()) : (a.removeClass(b, "jw-flag-fullscreen"), s(document.body, { "overflow-y": "" })), Z();
                }

                function ba() {
                    La = !1, clearTimeout(Ha), ra.hideComponents(), a.addClass(la, "jw-flag-user-inactive");
                }

                function ca() {
                    La || (a.removeClass(la, "jw-flag-user-inactive"), ra.checkCompactMode(na.clientWidth)), La = !0, clearTimeout(Ha), Ha = setTimeout(ba, Ia);
                }

                function da() {
                    _w.setFullscreen(!1), x.get("imageAdvs") && x.get("imageAdvs").end && ta && ta.loadAdv("end");
                }

                function ea() {
                    wa && wa.setState(x.get("state")), fa(x, x.mediaModel.get("mediaType")), x.mediaModel.on("change:mediaType", fa, this);
                }

                function fa(b, c) {
                    var d = "audio" === c,
                        e = x.getVideo(),
                        f = e && 0 === e.getName().name.indexOf("flash");
                    a.toggleClass(la, "jw-flag-media-audio", d), d && !f ? la.insertBefore(sa.el, na) : la.insertBefore(sa.el, Aa.element());
                }

                function ga(b, c) {
                    var d = "LIVE" === a.adaptiveType(c);
                    a.toggleClass(la, "jw-flag-live", d), d || Qa.setAltText("");
                }

                function ha(b, c) {
                    return c ? void (a.isPoorIE() || (c.name ? za.updateText(c.name, c.message) : za.updateText(c.message, ""))) : void za.playlistItem(b, b.get("playlistItem"));
                }

                function ia() {
                    var a = x.getVideo();
                    return !!a && a.isCaster;
                }

                function ja() {
                    a.replaceClass(la, /jw-state-\S+/, "jw-state-" + Da);
                }

                function ka(b, c) {
                    if (Da = c, clearTimeout(Na), c === e.COMPLETE || c === e.IDLE ? Na = setTimeout(ja, 100) : ja(), ia()) return void a.addClass(na, "jw-media-show");
                    switch (c) {
                        case e.PLAYING:
                            ta && ta.hide(), Z(), ua && x.get("marquee").show && ua.start();
                            break;
                        case e.PAUSED:
                            ta && x.get("imageAdvs") && x.get("imageAdvs").pause && ta.loadAdv("pause"), ca(), ua && x.get("marquee").show && ua.pause();
                            break;
                        case e.IDLE:
                            ua && x.get("marquee").show && ua.pause();
                            break;
                        case e.COMPLETE:
                            ua && ua.stop();}
                }
                var la,
                    ma,
                    na,
                    oa,
                    pa,
                    qa,
                    ra,
                    sa,
                    ta,
                    ua,
                    va,
                    wa,
                    xa,
                    ya,
                    za,
                    Aa,
                    Ba,
                    Ca,
                    Da,
                    Ea,
                    Fa,
                    Ga,
                    Ha = -1,
                    Ia = u ? 4e3 : 2e3,
                    Ja = 40,
                    Ka = !1,
                    La = !1,
                    Ma = -1,
                    Na = -1,
                    Oa = !1,
                    Pa = !1,
                    Qa = q.extend(this, c);
                this.model = x, this.api = _w, la = a.createElement(r({ id: x.get("id") })), a.isIE() && a.addClass(la, "jw-ie");
                var Ra = x.get("width"),
                    Sa = x.get("height");
                s(la, { width: Ra.toString().indexOf("%") > 0 ? Ra : Ra + "px", height: Sa.toString().indexOf("%") > 0 ? Sa : Sa + "px" }), Fa = la.requestFullscreen || la.webkitRequestFullscreen || la.webkitRequestFullScreen || la.mozRequestFullScreen || la.msRequestFullscreen, Ga = document.exitFullscreen || document.webkitExitFullscreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || document.msExitFullscreen, Oa = Fa && Ga, this.onChangeSkin = function (b, c) {
                    a.replaceClass(la, /jw-skin-\S+/, c ? "jw-skin-" + c : "");
                }, this.handleColorOverrides = function () {
                    function b(b, d, e) {
                        if (e) {
                            b = a.prefix(b, "#" + c + " ");
                            var f = {};
                            f[d] = e, a.css(b.join(", "), f, c);
                        }
                    }
                    var c = x.get("id"),
                        d = x.get("skinColorActive"),
                        e = x.get("skinColorInactive"),
                        f = x.get("skinColorBackground");
                    b([".jw-toggle", ".jw-button-color:hover"], "color", d), b([".jw-active-option", ".jw-progress", ".jw-playlist-container .jw-option.jw-active-option", ".jw-playlist-container .jw-option:hover"], "background", d), b([".jw-text", ".jw-option", ".jw-button-color", ".jw-toggle.jw-off", ".jw-tooltip-title", ".jw-skip .jw-skip-icon", ".jw-playlist-container .jw-icon"], "color", e), b([".jw-cue", ".jw-knob"], "background", e), b([".jw-playlist-container .jw-option"], "border-bottom-color", e), b([".jw-background-color", ".jw-tooltip-title", ".jw-playlist", ".jw-playlist-container .jw-option"], "background", f), b([".jw-playlist-container ::-webkit-scrollbar"], "border-color", f);
                }, this.setup = function () {
                    this.handleColorOverrides(), x.get("skin-loading") === !0 && (a.addClass(la, "jw-flag-skin-loading"), x.once("change:skin-loading", function () {
                        a.removeClass(la, "jw-flag-skin-loading");
                    })), this.onChangeSkin(x, x.get("skin"), ""), x.on("change:skin", this.onChangeSkin, this), na = a.getElementsByClassName("jw-media", la)[0], ma = a.getElementsByClassName("jw-controls", la)[0];
                    var c = a.getElementsByClassName("jw-preview", la)[0];
                    sa = new l(x), sa.setup(c);
                    var d = a.getElementsByClassName("jw-title", la)[0];
                    if (za = new p(x), za.setup(d), a.isPoorIE()) a.style(a.getElementsByClassName("jw-marquee", la)[0], { display: "none" });else if (ta = new m(x, _w), x.get("imageAdvs") && la.appendChild(ta.element()), x.get("marquee").show) {
                        var f = a.getElementsByClassName("jw-marquee", la)[0];
                        ua = new n(x, f);
                    }
                    S(), ca(), x.set("mediaContainer", na), x.mediaController.on("fullscreenchange", _);
                    for (var g = v.length; g--;) {
                        a.addEventListener(document, v[g], _, !1);
                    }a.removeEventListener(window, "resize", F), a.addEventListener(window, "resize", F, !1), u && (a.removeEventListener(window, "orientationchange", F), a.addEventListener(window, "orientationchange", F, !1)), x.on("change:errorEvent", ha), x.on("change:controls", Ta), Ta(x, x.get("controls")), x.on("change:state", ka), x.on("change:duration", ga, this), x.on("change:flashBlocked", Q), Q(x, x.get("flashBlocked")), _w.onPlaylistComplete(da), _w.onPlaylistItem(ea), x.on("change:castAvailable", H), H(x, x.get("castAvailable")), x.on("change:castActive", G), G(x, x.get("castActive")), x.get("stretching") && I(x, x.get("stretching")), x.on("change:stretching", I), ka(x, e.IDLE), x.on("change:fullscreen", Ua), K(ra), K(ya);
                    var h = x.get("aspectratio");
                    if (h) {
                        a.addClass(la, "jw-flag-aspect-mode");
                        var i = a.getElementsByClassName("jw-aspect", la)[0];
                        s(i, { paddingTop: h });
                    }
                    _w.on(b.JWPLAYER_READY, function () {
                        F(), V(x.get("width"), x.get("height"));
                    }), x.on("connecting", function () {
                        Qa.setAltText("正在与服务器建立连接"), a.toggleClass(la, "jw-flag-live", !0);
                    }), x.on("connectFaild", function () {
                        _w.stop(), Qa.setAltText("连接已断开，请稍后重试"), a.toggleClass(la, "jw-flag-live", !0), a.getElementsByClassName("jw-controlbar", la)[0].style.display = "block";
                    }), x.on("alive", function () {
                        "idle" !== Qa.model.get("state") && (Qa.setAltText("直播中"), a.toggleClass(la, "jw-flag-live", !0), c.style.display = "none");
                    }), x.on("noLiveStream", function () {
                        "idle" !== Qa.model.get("state") && (Qa.setAltText("无直播流"), a.toggleClass(la, "jw-flag-live", !0), c.style.display = "block", a.getElementsByClassName("jw-controlbar", la)[0].style.display = "block");
                    }), x.on("liveStop", function () {
                        _w.stop(), Qa.setAltText("直播结束"), a.toggleClass(la, "jw-flag-live", !0), a.getElementsByClassName("jw-controlbar", la)[0].style.display = "block";
                    }), x.on("seekAfterLoadSuccess", function () {
                        Qa.setAltText("自动跳转到上次的播放时间..."), a.addClass(ra.element(), "jw-controlbar-textshow"), setTimeout(function () {
                            a.removeClass(ra.element(), "jw-controlbar-textshow");
                        }, 1e3);
                    });
                };
                var Ta = function Ta(b, c) {
                    if (c) {
                        var d = Ka ? qa.get("state") : x.get("state");
                        ka(b, d);
                    }
                    a.toggleClass(la, "jw-flag-controls-disabled", !c);
                },
                    Ua = function Ua(b, c) {
                    var d = x.getVideo();
                    Oa ? (c ? Fa.apply(la) : Ga.apply(document), aa(la, c)) : a.isIE() ? aa(la, c) : (qa && qa.getVideo() && qa.getVideo().setFullscreen(c), d.setFullscreen(c)), d && 0 === d.getName().name.indexOf("flash") && d.setFullscreen(c), ua && x.get("marquee").show && ua.reset(la.clientWidth, la.clientHeight);
                };
                this.resize = function (a, b) {
                    var c = !0;
                    V(a, b, c), F();
                }, this.resizeMedia = Z, this.reset = function () {
                    document.contains(la) && la.parentNode.replaceChild(Ea, la), a.emptyElement(la);
                }, this.setupInstream = function (b) {
                    this.instreamModel = qa = b, qa.on("change:controls", Ta, this), qa.on("change:state", ka, this), Ka = !0, a.addClass(la, "jw-flag-ads"), ca();
                }, this.setAltText = function (a) {
                    ra.setAltText(a);
                }, this.useExternalControls = function () {
                    a.addClass(la, "jw-flag-ads-hide-controls");
                }, this.destroyInstream = function () {
                    if (Ka = !1, qa && (qa.off(null, null, this), qa = null), this.setAltText(""), a.removeClass(la, "jw-flag-ads"), a.removeClass(la, "jw-flag-ads-hide-controls"), x.getVideo) {
                        var b = x.getVideo();
                        b.setContainer(na);
                    }
                    ga(x, x.get("duration")), va.revertAlternateClickHandlers();
                }, this.addCues = function (a) {
                    ra && ra.addCues(a);
                }, this.clickHandler = function () {
                    return va;
                }, this.controlsContainer = function () {
                    return ma;
                }, this.getContainer = this.element = function () {
                    return la;
                }, this.getSafeRegion = function (b) {
                    var c = { x: 0, y: 0, width: x.get("containerWidth") || 0, height: x.get("containerHeight") || 0 },
                        d = x.get("dock");
                    return d && d.length && x.get("controls") && (c.y = xa.element().clientHeight, c.height -= c.y), b = b || !a.exists(b), b && x.get("controls") && (c.height -= ra.element().clientHeight), c;
                }, this.setCaptions = function (a) {
                    Aa.clear(), Aa.setup(x.get("id"), a), Aa.resize();
                }, this.destroy = function () {
                    a.removeEventListener(window, "resize", F), a.removeEventListener(window, "orientationchange", F);
                    for (var b = v.length; b--;) {
                        a.removeEventListener(document, v[b], _, _, !1);
                    }x.mediaController && x.mediaController.off("fullscreenchange", _), a.removeEventListener(la, "keydown", B), Ca && Ca.destroy(), wa && (x.off("change:state", wa.statusDelegate), wa.destroy(), wa = null), Ka && this.destroyInstream(), ya && ya.destroy(), a.clearCss(x.get("id"));
                }, this.showAdv = function (a) {
                    ta && ta.loadAdv(a);
                }, this.beginStartAdv = function () {
                    ta && ta.beginStartAdv();
                };
            };
            return w;
        }.apply(b, d), !(void 0 !== e && (a.exports = e));
    }]);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "fFU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fTZF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "fzkm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "gXi2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTIgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjEgKDQ3MjUwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT7nuqLniYxpY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPHJlY3QgaWQ9InBhdGgtMSIgeD0iMCIgeT0iMCIgd2lkdGg9IjEyIiBoZWlnaHQ9IjE0IiByeD0iMiI+PC9yZWN0PgogICAgPC9kZWZzPgogICAgPGcgaWQ9IuWQhOWcsOWMuummlumhtS3mr5TotZvor6bmg4XvvIjmr5TotZvnu5PmnpzvvIkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzAuMDAwMDAwLCAtNDUyLjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJHcm91cC01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMzIwLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0i57qi54mMIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzAuMDAwMDAwLCAxMzIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iUmVjdGFuZ2xlLTE0Ij4KICAgICAgICAgICAgICAgICAgICA8dXNlIGZpbGw9IiNGRTI3NTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICAgICAgPHJlY3Qgc3Ryb2tlPSIjRkUyNzU0IiBzdHJva2Utd2lkdGg9IjEiIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTEiIGhlaWdodD0iMTMiIHJ4PSIyIj48L3JlY3Q+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8dGV4dCBpZD0i57qiIiBmb250LWZhbWlseT0iUGluZ0ZhbmdTQy1TZW1pYm9sZCwgUGluZ0ZhbmcgU0MiIGZvbnQtc2l6ZT0iOCIgZm9udC13ZWlnaHQ9IjUwMCIgZmlsbD0iI0ZGRkZGRiI+CiAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjIiIHk9IjEwIj7nuqI8L3RzcGFuPgogICAgICAgICAgICAgICAgPC90ZXh0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "hH+7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hK2L":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "hWR6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/own-goal.e2e18ad.svg";

/***/ }),

/***/ "hcFw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AdvertisementBackGroundImg.3861cbc.svg";

/***/ }),

/***/ "hoel":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "i50b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZkhM");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./video-js.css", function() {
			var newContent = require("!!../../css-loader/index.js!./video-js.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jFSQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jNsc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.fa27723.woff";

/***/ }),

/***/ "kAA/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lbSq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "lgsr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ltKL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lvdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mBSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mCmD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo3.b377603.png";

/***/ }),

/***/ "mq5u":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT7lub/lkYrkvY3lhbPpl61pY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IuWQhOWcsOWMuummlumhtS3otZvkuovliJfooagt6LWb5LqL5Li76aG177yI5q+U6LWb5Lit77yJ6LWb56iL5bey57uT5p2fIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzQ1LjAwMDAwMCwgLTk1LjAwMDAwMCkiIG9wYWNpdHk9IjAuNzAwMDExMzIyIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDc1LjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiI+CiAgICAgICAgICAgIDxnIGlkPSLlhbPpl60iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM0NS4wMDAwMDAsIDIwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC0yIiBzdHJva2Utd2lkdGg9IjEuMTY2NjY2NjciIGZpbGwtb3BhY2l0eT0iMC42MDAwMDAwMjQiIGZpbGw9IiNGRkZGRkYiIGN4PSI4IiBjeT0iOCIgcj0iNyI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNC41LDQuNSBMMTEuNSwxMS41IiBpZD0iTGluZSIgc3Ryb2tlLXdpZHRoPSIwLjg3NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNC41LDQuNSBMMTEuNSwxMS41IiBpZD0iTGluZS1Db3B5IiBzdHJva2Utd2lkdGg9IjAuODc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguMDAwMDAwLCA4LjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtOC4wMDAwMDAsIC04LjAwMDAwMCkgIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "nPaY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nUYS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "o7Oz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);




/*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
!function (a, b) {
  "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(module)) && "object" == __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(module.exports) ? module.exports = a.document ? b(a, !0) : function (a) {
    if (!a.document) throw new Error("jQuery requires a window with a document");return b(a);
  } : b(a);
}("undefined" != typeof window ? window : this, function (a, b) {
  var c = [],
      d = a.document,
      e = c.slice,
      f = c.concat,
      g = c.push,
      h = c.indexOf,
      i = {},
      j = i.toString,
      k = i.hasOwnProperty,
      l = {},
      m = "2.2.3",
      n = function n(a, b) {
    return new n.fn.init(a, b);
  },
      o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      p = /^-ms-/,
      q = /-([\da-z])/gi,
      r = function r(a, b) {
    return b.toUpperCase();
  };n.fn = n.prototype = { jquery: m, constructor: n, selector: "", length: 0, toArray: function toArray() {
      return e.call(this);
    }, get: function get(a) {
      return null != a ? 0 > a ? this[a + this.length] : this[a] : e.call(this);
    }, pushStack: function pushStack(a) {
      var b = n.merge(this.constructor(), a);return b.prevObject = this, b.context = this.context, b;
    }, each: function each(a) {
      return n.each(this, a);
    }, map: function map(a) {
      return this.pushStack(n.map(this, function (b, c) {
        return a.call(b, c, b);
      }));
    }, slice: function slice() {
      return this.pushStack(e.apply(this, arguments));
    }, first: function first() {
      return this.eq(0);
    }, last: function last() {
      return this.eq(-1);
    }, eq: function eq(a) {
      var b = this.length,
          c = +a + (0 > a ? b : 0);return this.pushStack(c >= 0 && b > c ? [this[c]] : []);
    }, end: function end() {
      return this.prevObject || this.constructor();
    }, push: g, sort: c.sort, splice: c.splice }, n.extend = n.fn.extend = function () {
    var a,
        b,
        c,
        d,
        e,
        f,
        g = arguments[0] || {},
        h = 1,
        i = arguments.length,
        j = !1;for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(g)) || n.isFunction(g) || (g = {}), h === i && (g = this, h--); i > h; h++) {
      if (null != (a = arguments[h])) for (b in a) {
        c = g[b], d = a[b], g !== d && (j && d && (n.isPlainObject(d) || (e = n.isArray(d))) ? (e ? (e = !1, f = c && n.isArray(c) ? c : []) : f = c && n.isPlainObject(c) ? c : {}, g[b] = n.extend(j, f, d)) : void 0 !== d && (g[b] = d));
      }
    }return g;
  }, n.extend({ expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""), isReady: !0, error: function error(a) {
      throw new Error(a);
    }, noop: function noop() {}, isFunction: function isFunction(a) {
      return "function" === n.type(a);
    }, isArray: Array.isArray, isWindow: function isWindow(a) {
      return null != a && a === a.window;
    }, isNumeric: function isNumeric(a) {
      var b = a && a.toString();return !n.isArray(a) && b - parseFloat(b) + 1 >= 0;
    }, isPlainObject: function isPlainObject(a) {
      var b;if ("object" !== n.type(a) || a.nodeType || n.isWindow(a)) return !1;if (a.constructor && !k.call(a, "constructor") && !k.call(a.constructor.prototype || {}, "isPrototypeOf")) return !1;for (b in a) {}return void 0 === b || k.call(a, b);
    }, isEmptyObject: function isEmptyObject(a) {
      var b;for (b in a) {
        return !1;
      }return !0;
    }, type: function type(a) {
      return null == a ? a + "" : "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a)) || "function" == typeof a ? i[j.call(a)] || "object" : typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a);
    }, globalEval: function globalEval(a) {
      var b,
          c = eval;a = n.trim(a), a && (1 === a.indexOf("use strict") ? (b = d.createElement("script"), b.text = a, d.head.appendChild(b).parentNode.removeChild(b)) : c(a));
    }, camelCase: function camelCase(a) {
      return a.replace(p, "ms-").replace(q, r);
    }, nodeName: function nodeName(a, b) {
      return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
    }, each: function each(a, b) {
      var c,
          d = 0;if (s(a)) {
        for (c = a.length; c > d; d++) {
          if (b.call(a[d], d, a[d]) === !1) break;
        }
      } else for (d in a) {
        if (b.call(a[d], d, a[d]) === !1) break;
      }return a;
    }, trim: function trim(a) {
      return null == a ? "" : (a + "").replace(o, "");
    }, makeArray: function makeArray(a, b) {
      var c = b || [];return null != a && (s(Object(a)) ? n.merge(c, "string" == typeof a ? [a] : a) : g.call(c, a)), c;
    }, inArray: function inArray(a, b, c) {
      return null == b ? -1 : h.call(b, a, c);
    }, merge: function merge(a, b) {
      for (var c = +b.length, d = 0, e = a.length; c > d; d++) {
        a[e++] = b[d];
      }return a.length = e, a;
    }, grep: function grep(a, b, c) {
      for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++) {
        d = !b(a[f], f), d !== h && e.push(a[f]);
      }return e;
    }, map: function map(a, b, c) {
      var d,
          e,
          g = 0,
          h = [];if (s(a)) for (d = a.length; d > g; g++) {
        e = b(a[g], g, c), null != e && h.push(e);
      } else for (g in a) {
        e = b(a[g], g, c), null != e && h.push(e);
      }return f.apply([], h);
    }, guid: 1, proxy: function proxy(a, b) {
      var c, d, f;return "string" == typeof b && (c = a[b], b = a, a = c), n.isFunction(a) ? (d = e.call(arguments, 2), f = function f() {
        return a.apply(b || this, d.concat(e.call(arguments)));
      }, f.guid = a.guid = a.guid || n.guid++, f) : void 0;
    }, now: Date.now, support: l }), "function" == typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && (n.fn[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a] = c[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a]), n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (a, b) {
    i["[object " + b + "]"] = b.toLowerCase();
  });function s(a) {
    var b = !!a && "length" in a && a.length,
        c = n.type(a);return "function" === c || n.isWindow(a) ? !1 : "array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a;
  }var t = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t,
        u = "sizzle" + 1 * new Date(),
        v = a.document,
        w = 0,
        x = 0,
        y = ga(),
        z = ga(),
        A = ga(),
        B = function B(a, b) {
      return a === b && (l = !0), 0;
    },
        C = 1 << 31,
        D = {}.hasOwnProperty,
        E = [],
        F = E.pop,
        G = E.push,
        H = E.push,
        I = E.slice,
        J = function J(a, b) {
      for (var c = 0, d = a.length; d > c; c++) {
        if (a[c] === b) return c;
      }return -1;
    },
        K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        L = "[\\x20\\t\\r\\n\\f]",
        M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        N = "\\[" + L + "*(" + M + ")(?:" + L + "*([*^$|!~]?=)" + L + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + M + "))|)" + L + "*\\]",
        O = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + N + ")*)|.*)\\)|)",
        P = new RegExp(L + "+", "g"),
        Q = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"),
        R = new RegExp("^" + L + "*," + L + "*"),
        S = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"),
        T = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]", "g"),
        U = new RegExp(O),
        V = new RegExp("^" + M + "$"),
        W = { ID: new RegExp("^#(" + M + ")"), CLASS: new RegExp("^\\.(" + M + ")"), TAG: new RegExp("^(" + M + "|[*])"), ATTR: new RegExp("^" + N), PSEUDO: new RegExp("^" + O), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + L + "*(even|odd|(([+-]|)(\\d*)n|)" + L + "*(?:([+-]|)" + L + "*(\\d+)|))" + L + "*\\)|)", "i"), bool: new RegExp("^(?:" + K + ")$", "i"), needsContext: new RegExp("^" + L + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + L + "*((?:-\\d)?\\d*)" + L + "*\\)|)(?=[^-]|$)", "i") },
        X = /^(?:input|select|textarea|button)$/i,
        Y = /^h\d$/i,
        Z = /^[^{]+\{\s*\[native \w/,
        $ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        _ = /[+~]/,
        aa = /'|\\/g,
        ba = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"),
        ca = function ca(a, b, c) {
      var d = "0x" + b - 65536;return d !== d || c ? b : 0 > d ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320);
    },
        da = function da() {
      m();
    };try {
      H.apply(E = I.call(v.childNodes), v.childNodes), E[v.childNodes.length].nodeType;
    } catch (ea) {
      H = { apply: E.length ? function (a, b) {
          G.apply(a, I.call(b));
        } : function (a, b) {
          var c = a.length,
              d = 0;while (a[c++] = b[d++]) {}a.length = c - 1;
        } };
    }function fa(a, b, d, e) {
      var f,
          h,
          j,
          k,
          l,
          o,
          r,
          s,
          w = b && b.ownerDocument,
          x = b ? b.nodeType : 9;if (d = d || [], "string" != typeof a || !a || 1 !== x && 9 !== x && 11 !== x) return d;if (!e && ((b ? b.ownerDocument || b : v) !== n && m(b), b = b || n, p)) {
        if (11 !== x && (o = $.exec(a))) if (f = o[1]) {
          if (9 === x) {
            if (!(j = b.getElementById(f))) return d;if (j.id === f) return d.push(j), d;
          } else if (w && (j = w.getElementById(f)) && t(b, j) && j.id === f) return d.push(j), d;
        } else {
          if (o[2]) return H.apply(d, b.getElementsByTagName(a)), d;if ((f = o[3]) && c.getElementsByClassName && b.getElementsByClassName) return H.apply(d, b.getElementsByClassName(f)), d;
        }if (c.qsa && !A[a + " "] && (!q || !q.test(a))) {
          if (1 !== x) w = b, s = a;else if ("object" !== b.nodeName.toLowerCase()) {
            (k = b.getAttribute("id")) ? k = k.replace(aa, "\\$&") : b.setAttribute("id", k = u), r = g(a), h = r.length, l = V.test(k) ? "#" + k : "[id='" + k + "']";while (h--) {
              r[h] = l + " " + qa(r[h]);
            }s = r.join(","), w = _.test(a) && oa(b.parentNode) || b;
          }if (s) try {
            return H.apply(d, w.querySelectorAll(s)), d;
          } catch (y) {} finally {
            k === u && b.removeAttribute("id");
          }
        }
      }return i(a.replace(Q, "$1"), b, d, e);
    }function ga() {
      var a = [];function b(c, e) {
        return a.push(c + " ") > d.cacheLength && delete b[a.shift()], b[c + " "] = e;
      }return b;
    }function ha(a) {
      return a[u] = !0, a;
    }function ia(a) {
      var b = n.createElement("div");try {
        return !!a(b);
      } catch (c) {
        return !1;
      } finally {
        b.parentNode && b.parentNode.removeChild(b), b = null;
      }
    }function ja(a, b) {
      var c = a.split("|"),
          e = c.length;while (e--) {
        d.attrHandle[c[e]] = b;
      }
    }function ka(a, b) {
      var c = b && a,
          d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || C) - (~a.sourceIndex || C);if (d) return d;if (c) while (c = c.nextSibling) {
        if (c === b) return -1;
      }return a ? 1 : -1;
    }function la(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();return "input" === c && b.type === a;
      };
    }function ma(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();return ("input" === c || "button" === c) && b.type === a;
      };
    }function na(a) {
      return ha(function (b) {
        return b = +b, ha(function (c, d) {
          var e,
              f = a([], c.length, b),
              g = f.length;while (g--) {
            c[e = f[g]] && (c[e] = !(d[e] = c[e]));
          }
        });
      });
    }function oa(a) {
      return a && "undefined" != typeof a.getElementsByTagName && a;
    }c = fa.support = {}, f = fa.isXML = function (a) {
      var b = a && (a.ownerDocument || a).documentElement;return b ? "HTML" !== b.nodeName : !1;
    }, m = fa.setDocument = function (a) {
      var b,
          e,
          g = a ? a.ownerDocument || a : v;return g !== n && 9 === g.nodeType && g.documentElement ? (n = g, o = n.documentElement, p = !f(n), (e = n.defaultView) && e.top !== e && (e.addEventListener ? e.addEventListener("unload", da, !1) : e.attachEvent && e.attachEvent("onunload", da)), c.attributes = ia(function (a) {
        return a.className = "i", !a.getAttribute("className");
      }), c.getElementsByTagName = ia(function (a) {
        return a.appendChild(n.createComment("")), !a.getElementsByTagName("*").length;
      }), c.getElementsByClassName = Z.test(n.getElementsByClassName), c.getById = ia(function (a) {
        return o.appendChild(a).id = u, !n.getElementsByName || !n.getElementsByName(u).length;
      }), c.getById ? (d.find.ID = function (a, b) {
        if ("undefined" != typeof b.getElementById && p) {
          var c = b.getElementById(a);return c ? [c] : [];
        }
      }, d.filter.ID = function (a) {
        var b = a.replace(ba, ca);return function (a) {
          return a.getAttribute("id") === b;
        };
      }) : (delete d.find.ID, d.filter.ID = function (a) {
        var b = a.replace(ba, ca);return function (a) {
          var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");return c && c.value === b;
        };
      }), d.find.TAG = c.getElementsByTagName ? function (a, b) {
        return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : c.qsa ? b.querySelectorAll(a) : void 0;
      } : function (a, b) {
        var c,
            d = [],
            e = 0,
            f = b.getElementsByTagName(a);if ("*" === a) {
          while (c = f[e++]) {
            1 === c.nodeType && d.push(c);
          }return d;
        }return f;
      }, d.find.CLASS = c.getElementsByClassName && function (a, b) {
        return "undefined" != typeof b.getElementsByClassName && p ? b.getElementsByClassName(a) : void 0;
      }, r = [], q = [], (c.qsa = Z.test(n.querySelectorAll)) && (ia(function (a) {
        o.appendChild(a).innerHTML = "<a id='" + u + "'></a><select id='" + u + "-\r\\' msallowcapture=''><option selected=''></option></select>", a.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + L + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || q.push("\\[" + L + "*(?:value|" + K + ")"), a.querySelectorAll("[id~=" + u + "-]").length || q.push("~="), a.querySelectorAll(":checked").length || q.push(":checked"), a.querySelectorAll("a#" + u + "+*").length || q.push(".#.+[+~]");
      }), ia(function (a) {
        var b = n.createElement("input");b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && q.push("name" + L + "*[*^$|!~]?="), a.querySelectorAll(":enabled").length || q.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), q.push(",.*:");
      })), (c.matchesSelector = Z.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ia(function (a) {
        c.disconnectedMatch = s.call(a, "div"), s.call(a, "[s!='']:x"), r.push("!=", O);
      }), q = q.length && new RegExp(q.join("|")), r = r.length && new RegExp(r.join("|")), b = Z.test(o.compareDocumentPosition), t = b || Z.test(o.contains) ? function (a, b) {
        var c = 9 === a.nodeType ? a.documentElement : a,
            d = b && b.parentNode;return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)));
      } : function (a, b) {
        if (b) while (b = b.parentNode) {
          if (b === a) return !0;
        }return !1;
      }, B = b ? function (a, b) {
        if (a === b) return l = !0, 0;var d = !a.compareDocumentPosition - !b.compareDocumentPosition;return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === n || a.ownerDocument === v && t(v, a) ? -1 : b === n || b.ownerDocument === v && t(v, b) ? 1 : k ? J(k, a) - J(k, b) : 0 : 4 & d ? -1 : 1);
      } : function (a, b) {
        if (a === b) return l = !0, 0;var c,
            d = 0,
            e = a.parentNode,
            f = b.parentNode,
            g = [a],
            h = [b];if (!e || !f) return a === n ? -1 : b === n ? 1 : e ? -1 : f ? 1 : k ? J(k, a) - J(k, b) : 0;if (e === f) return ka(a, b);c = a;while (c = c.parentNode) {
          g.unshift(c);
        }c = b;while (c = c.parentNode) {
          h.unshift(c);
        }while (g[d] === h[d]) {
          d++;
        }return d ? ka(g[d], h[d]) : g[d] === v ? -1 : h[d] === v ? 1 : 0;
      }, n) : n;
    }, fa.matches = function (a, b) {
      return fa(a, null, null, b);
    }, fa.matchesSelector = function (a, b) {
      if ((a.ownerDocument || a) !== n && m(a), b = b.replace(T, "='$1']"), c.matchesSelector && p && !A[b + " "] && (!r || !r.test(b)) && (!q || !q.test(b))) try {
        var d = s.call(a, b);if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d;
      } catch (e) {}return fa(b, n, null, [a]).length > 0;
    }, fa.contains = function (a, b) {
      return (a.ownerDocument || a) !== n && m(a), t(a, b);
    }, fa.attr = function (a, b) {
      (a.ownerDocument || a) !== n && m(a);var e = d.attrHandle[b.toLowerCase()],
          f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null;
    }, fa.error = function (a) {
      throw new Error("Syntax error, unrecognized expression: " + a);
    }, fa.uniqueSort = function (a) {
      var b,
          d = [],
          e = 0,
          f = 0;if (l = !c.detectDuplicates, k = !c.sortStable && a.slice(0), a.sort(B), l) {
        while (b = a[f++]) {
          b === a[f] && (e = d.push(f));
        }while (e--) {
          a.splice(d[e], 1);
        }
      }return k = null, a;
    }, e = fa.getText = function (a) {
      var b,
          c = "",
          d = 0,
          f = a.nodeType;if (f) {
        if (1 === f || 9 === f || 11 === f) {
          if ("string" == typeof a.textContent) return a.textContent;for (a = a.firstChild; a; a = a.nextSibling) {
            c += e(a);
          }
        } else if (3 === f || 4 === f) return a.nodeValue;
      } else while (b = a[d++]) {
        c += e(b);
      }return c;
    }, d = fa.selectors = { cacheLength: 50, createPseudo: ha, match: W, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(a) {
          return a[1] = a[1].replace(ba, ca), a[3] = (a[3] || a[4] || a[5] || "").replace(ba, ca), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4);
        }, CHILD: function CHILD(a) {
          return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || fa.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && fa.error(a[0]), a;
        }, PSEUDO: function PSEUDO(a) {
          var b,
              c = !a[6] && a[2];return W.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && U.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3));
        } }, filter: { TAG: function TAG(a) {
          var b = a.replace(ba, ca).toLowerCase();return "*" === a ? function () {
            return !0;
          } : function (a) {
            return a.nodeName && a.nodeName.toLowerCase() === b;
          };
        }, CLASS: function CLASS(a) {
          var b = y[a + " "];return b || (b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)")) && y(a, function (a) {
            return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "");
          });
        }, ATTR: function ATTR(a, b, c) {
          return function (d) {
            var e = fa.attr(d, a);return null == e ? "!=" === b : b ? (e += "", "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e.replace(P, " ") + " ").indexOf(c) > -1 : "|=" === b ? e === c || e.slice(0, c.length + 1) === c + "-" : !1) : !0;
          };
        }, CHILD: function CHILD(a, b, c, d, e) {
          var f = "nth" !== a.slice(0, 3),
              g = "last" !== a.slice(-4),
              h = "of-type" === b;return 1 === d && 0 === e ? function (a) {
            return !!a.parentNode;
          } : function (b, c, i) {
            var j,
                k,
                l,
                m,
                n,
                o,
                p = f !== g ? "nextSibling" : "previousSibling",
                q = b.parentNode,
                r = h && b.nodeName.toLowerCase(),
                s = !i && !h,
                t = !1;if (q) {
              if (f) {
                while (p) {
                  m = b;while (m = m[p]) {
                    if (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) return !1;
                  }o = p = "only" === a && !o && "nextSibling";
                }return !0;
              }if (o = [g ? q.firstChild : q.lastChild], g && s) {
                m = q, l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === w && j[1], t = n && j[2], m = n && q.childNodes[n];while (m = ++n && m && m[p] || (t = n = 0) || o.pop()) {
                  if (1 === m.nodeType && ++t && m === b) {
                    k[a] = [w, n, t];break;
                  }
                }
              } else if (s && (m = b, l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === w && j[1], t = n), t === !1) while (m = ++n && m && m[p] || (t = n = 0) || o.pop()) {
                if ((h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) && ++t && (s && (l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), k[a] = [w, t]), m === b)) break;
              }return t -= e, t === d || t % d === 0 && t / d >= 0;
            }
          };
        }, PSEUDO: function PSEUDO(a, b) {
          var c,
              e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || fa.error("unsupported pseudo: " + a);return e[u] ? e(b) : e.length > 1 ? (c = [a, a, "", b], d.setFilters.hasOwnProperty(a.toLowerCase()) ? ha(function (a, c) {
            var d,
                f = e(a, b),
                g = f.length;while (g--) {
              d = J(a, f[g]), a[d] = !(c[d] = f[g]);
            }
          }) : function (a) {
            return e(a, 0, c);
          }) : e;
        } }, pseudos: { not: ha(function (a) {
          var b = [],
              c = [],
              d = h(a.replace(Q, "$1"));return d[u] ? ha(function (a, b, c, e) {
            var f,
                g = d(a, null, e, []),
                h = a.length;while (h--) {
              (f = g[h]) && (a[h] = !(b[h] = f));
            }
          }) : function (a, e, f) {
            return b[0] = a, d(b, null, f, c), b[0] = null, !c.pop();
          };
        }), has: ha(function (a) {
          return function (b) {
            return fa(a, b).length > 0;
          };
        }), contains: ha(function (a) {
          return a = a.replace(ba, ca), function (b) {
            return (b.textContent || b.innerText || e(b)).indexOf(a) > -1;
          };
        }), lang: ha(function (a) {
          return V.test(a || "") || fa.error("unsupported lang: " + a), a = a.replace(ba, ca).toLowerCase(), function (b) {
            var c;do {
              if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-");
            } while ((b = b.parentNode) && 1 === b.nodeType);return !1;
          };
        }), target: function target(b) {
          var c = a.location && a.location.hash;return c && c.slice(1) === b.id;
        }, root: function root(a) {
          return a === o;
        }, focus: function focus(a) {
          return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex);
        }, enabled: function enabled(a) {
          return a.disabled === !1;
        }, disabled: function disabled(a) {
          return a.disabled === !0;
        }, checked: function checked(a) {
          var b = a.nodeName.toLowerCase();return "input" === b && !!a.checked || "option" === b && !!a.selected;
        }, selected: function selected(a) {
          return a.parentNode && a.parentNode.selectedIndex, a.selected === !0;
        }, empty: function empty(a) {
          for (a = a.firstChild; a; a = a.nextSibling) {
            if (a.nodeType < 6) return !1;
          }return !0;
        }, parent: function parent(a) {
          return !d.pseudos.empty(a);
        }, header: function header(a) {
          return Y.test(a.nodeName);
        }, input: function input(a) {
          return X.test(a.nodeName);
        }, button: function button(a) {
          var b = a.nodeName.toLowerCase();return "input" === b && "button" === a.type || "button" === b;
        }, text: function text(a) {
          var b;return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase());
        }, first: na(function () {
          return [0];
        }), last: na(function (a, b) {
          return [b - 1];
        }), eq: na(function (a, b, c) {
          return [0 > c ? c + b : c];
        }), even: na(function (a, b) {
          for (var c = 0; b > c; c += 2) {
            a.push(c);
          }return a;
        }), odd: na(function (a, b) {
          for (var c = 1; b > c; c += 2) {
            a.push(c);
          }return a;
        }), lt: na(function (a, b, c) {
          for (var d = 0 > c ? c + b : c; --d >= 0;) {
            a.push(d);
          }return a;
        }), gt: na(function (a, b, c) {
          for (var d = 0 > c ? c + b : c; ++d < b;) {
            a.push(d);
          }return a;
        }) } }, d.pseudos.nth = d.pseudos.eq;for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) {
      d.pseudos[b] = la(b);
    }for (b in { submit: !0, reset: !0 }) {
      d.pseudos[b] = ma(b);
    }function pa() {}pa.prototype = d.filters = d.pseudos, d.setFilters = new pa(), g = fa.tokenize = function (a, b) {
      var c,
          e,
          f,
          g,
          h,
          i,
          j,
          k = z[a + " "];if (k) return b ? 0 : k.slice(0);h = a, i = [], j = d.preFilter;while (h) {
        c && !(e = R.exec(h)) || (e && (h = h.slice(e[0].length) || h), i.push(f = [])), c = !1, (e = S.exec(h)) && (c = e.shift(), f.push({ value: c, type: e[0].replace(Q, " ") }), h = h.slice(c.length));for (g in d.filter) {
          !(e = W[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(), f.push({ value: c, type: g, matches: e }), h = h.slice(c.length));
        }if (!c) break;
      }return b ? h.length : h ? fa.error(a) : z(a, i).slice(0);
    };function qa(a) {
      for (var b = 0, c = a.length, d = ""; c > b; b++) {
        d += a[b].value;
      }return d;
    }function ra(a, b, c) {
      var d = b.dir,
          e = c && "parentNode" === d,
          f = x++;return b.first ? function (b, c, f) {
        while (b = b[d]) {
          if (1 === b.nodeType || e) return a(b, c, f);
        }
      } : function (b, c, g) {
        var h,
            i,
            j,
            k = [w, f];if (g) {
          while (b = b[d]) {
            if ((1 === b.nodeType || e) && a(b, c, g)) return !0;
          }
        } else while (b = b[d]) {
          if (1 === b.nodeType || e) {
            if (j = b[u] || (b[u] = {}), i = j[b.uniqueID] || (j[b.uniqueID] = {}), (h = i[d]) && h[0] === w && h[1] === f) return k[2] = h[2];if (i[d] = k, k[2] = a(b, c, g)) return !0;
          }
        }
      };
    }function sa(a) {
      return a.length > 1 ? function (b, c, d) {
        var e = a.length;while (e--) {
          if (!a[e](b, c, d)) return !1;
        }return !0;
      } : a[0];
    }function ta(a, b, c) {
      for (var d = 0, e = b.length; e > d; d++) {
        fa(a, b[d], c);
      }return c;
    }function ua(a, b, c, d, e) {
      for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++) {
        (f = a[h]) && (c && !c(f, d, e) || (g.push(f), j && b.push(h)));
      }return g;
    }function va(a, b, c, d, e, f) {
      return d && !d[u] && (d = va(d)), e && !e[u] && (e = va(e, f)), ha(function (f, g, h, i) {
        var j,
            k,
            l,
            m = [],
            n = [],
            o = g.length,
            p = f || ta(b || "*", h.nodeType ? [h] : h, []),
            q = !a || !f && b ? p : ua(p, m, a, h, i),
            r = c ? e || (f ? a : o || d) ? [] : g : q;if (c && c(q, r, h, i), d) {
          j = ua(r, n), d(j, [], h, i), k = j.length;while (k--) {
            (l = j[k]) && (r[n[k]] = !(q[n[k]] = l));
          }
        }if (f) {
          if (e || a) {
            if (e) {
              j = [], k = r.length;while (k--) {
                (l = r[k]) && j.push(q[k] = l);
              }e(null, r = [], j, i);
            }k = r.length;while (k--) {
              (l = r[k]) && (j = e ? J(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l));
            }
          }
        } else r = ua(r === g ? r.splice(o, r.length) : r), e ? e(null, g, r, i) : H.apply(g, r);
      });
    }function wa(a) {
      for (var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = ra(function (a) {
        return a === b;
      }, h, !0), l = ra(function (a) {
        return J(b, a) > -1;
      }, h, !0), m = [function (a, c, d) {
        var e = !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d));return b = null, e;
      }]; f > i; i++) {
        if (c = d.relative[a[i].type]) m = [ra(sa(m), c)];else {
          if (c = d.filter[a[i].type].apply(null, a[i].matches), c[u]) {
            for (e = ++i; f > e; e++) {
              if (d.relative[a[e].type]) break;
            }return va(i > 1 && sa(m), i > 1 && qa(a.slice(0, i - 1).concat({ value: " " === a[i - 2].type ? "*" : "" })).replace(Q, "$1"), c, e > i && wa(a.slice(i, e)), f > e && wa(a = a.slice(e)), f > e && qa(a));
          }m.push(c);
        }
      }return sa(m);
    }function xa(a, b) {
      var c = b.length > 0,
          e = a.length > 0,
          f = function f(_f, g, h, i, k) {
        var l,
            o,
            q,
            r = 0,
            s = "0",
            t = _f && [],
            u = [],
            v = j,
            x = _f || e && d.find.TAG("*", k),
            y = w += null == v ? 1 : Math.random() || .1,
            z = x.length;for (k && (j = g === n || g || k); s !== z && null != (l = x[s]); s++) {
          if (e && l) {
            o = 0, g || l.ownerDocument === n || (m(l), h = !p);while (q = a[o++]) {
              if (q(l, g || n, h)) {
                i.push(l);break;
              }
            }k && (w = y);
          }c && ((l = !q && l) && r--, _f && t.push(l));
        }if (r += s, c && s !== r) {
          o = 0;while (q = b[o++]) {
            q(t, u, g, h);
          }if (_f) {
            if (r > 0) while (s--) {
              t[s] || u[s] || (u[s] = F.call(i));
            }u = ua(u);
          }H.apply(i, u), k && !_f && u.length > 0 && r + b.length > 1 && fa.uniqueSort(i);
        }return k && (w = y, j = v), t;
      };return c ? ha(f) : f;
    }return h = fa.compile = function (a, b) {
      var c,
          d = [],
          e = [],
          f = A[a + " "];if (!f) {
        b || (b = g(a)), c = b.length;while (c--) {
          f = wa(b[c]), f[u] ? d.push(f) : e.push(f);
        }f = A(a, xa(e, d)), f.selector = a;
      }return f;
    }, i = fa.select = function (a, b, e, f) {
      var i,
          j,
          k,
          l,
          m,
          n = "function" == typeof a && a,
          o = !f && g(a = n.selector || a);if (e = e || [], 1 === o.length) {
        if (j = o[0] = o[0].slice(0), j.length > 2 && "ID" === (k = j[0]).type && c.getById && 9 === b.nodeType && p && d.relative[j[1].type]) {
          if (b = (d.find.ID(k.matches[0].replace(ba, ca), b) || [])[0], !b) return e;n && (b = b.parentNode), a = a.slice(j.shift().value.length);
        }i = W.needsContext.test(a) ? 0 : j.length;while (i--) {
          if (k = j[i], d.relative[l = k.type]) break;if ((m = d.find[l]) && (f = m(k.matches[0].replace(ba, ca), _.test(j[0].type) && oa(b.parentNode) || b))) {
            if (j.splice(i, 1), a = f.length && qa(j), !a) return H.apply(e, f), e;break;
          }
        }
      }return (n || h(a, o))(f, b, !p, e, !b || _.test(a) && oa(b.parentNode) || b), e;
    }, c.sortStable = u.split("").sort(B).join("") === u, c.detectDuplicates = !!l, m(), c.sortDetached = ia(function (a) {
      return 1 & a.compareDocumentPosition(n.createElement("div"));
    }), ia(function (a) {
      return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href");
    }) || ja("type|href|height|width", function (a, b, c) {
      return c ? void 0 : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
    }), c.attributes && ia(function (a) {
      return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value");
    }) || ja("value", function (a, b, c) {
      return c || "input" !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue;
    }), ia(function (a) {
      return null == a.getAttribute("disabled");
    }) || ja(K, function (a, b, c) {
      var d;return c ? void 0 : a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null;
    }), fa;
  }(a);n.find = t, n.expr = t.selectors, n.expr[":"] = n.expr.pseudos, n.uniqueSort = n.unique = t.uniqueSort, n.text = t.getText, n.isXMLDoc = t.isXML, n.contains = t.contains;var u = function u(a, b, c) {
    var d = [],
        e = void 0 !== c;while ((a = a[b]) && 9 !== a.nodeType) {
      if (1 === a.nodeType) {
        if (e && n(a).is(c)) break;d.push(a);
      }
    }return d;
  },
      v = function v(a, b) {
    for (var c = []; a; a = a.nextSibling) {
      1 === a.nodeType && a !== b && c.push(a);
    }return c;
  },
      w = n.expr.match.needsContext,
      x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
      y = /^.[^:#\[\.,]*$/;function z(a, b, c) {
    if (n.isFunction(b)) return n.grep(a, function (a, d) {
      return !!b.call(a, d, a) !== c;
    });if (b.nodeType) return n.grep(a, function (a) {
      return a === b !== c;
    });if ("string" == typeof b) {
      if (y.test(b)) return n.filter(b, a, c);b = n.filter(b, a);
    }return n.grep(a, function (a) {
      return h.call(b, a) > -1 !== c;
    });
  }n.filter = function (a, b, c) {
    var d = b[0];return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? n.find.matchesSelector(d, a) ? [d] : [] : n.find.matches(a, n.grep(b, function (a) {
      return 1 === a.nodeType;
    }));
  }, n.fn.extend({ find: function find(a) {
      var b,
          c = this.length,
          d = [],
          e = this;if ("string" != typeof a) return this.pushStack(n(a).filter(function () {
        for (b = 0; c > b; b++) {
          if (n.contains(e[b], this)) return !0;
        }
      }));for (b = 0; c > b; b++) {
        n.find(a, e[b], d);
      }return d = this.pushStack(c > 1 ? n.unique(d) : d), d.selector = this.selector ? this.selector + " " + a : a, d;
    }, filter: function filter(a) {
      return this.pushStack(z(this, a || [], !1));
    }, not: function not(a) {
      return this.pushStack(z(this, a || [], !0));
    }, is: function is(a) {
      return !!z(this, "string" == typeof a && w.test(a) ? n(a) : a || [], !1).length;
    } });var A,
      B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      C = n.fn.init = function (a, b, c) {
    var e, f;if (!a) return this;if (c = c || A, "string" == typeof a) {
      if (e = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : B.exec(a), !e || !e[1] && b) return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a);if (e[1]) {
        if (b = b instanceof n ? b[0] : b, n.merge(this, n.parseHTML(e[1], b && b.nodeType ? b.ownerDocument || b : d, !0)), x.test(e[1]) && n.isPlainObject(b)) for (e in b) {
          n.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e]);
        }return this;
      }return f = d.getElementById(e[2]), f && f.parentNode && (this.length = 1, this[0] = f), this.context = d, this.selector = a, this;
    }return a.nodeType ? (this.context = this[0] = a, this.length = 1, this) : n.isFunction(a) ? void 0 !== c.ready ? c.ready(a) : a(n) : (void 0 !== a.selector && (this.selector = a.selector, this.context = a.context), n.makeArray(a, this));
  };C.prototype = n.fn, A = n(d);var D = /^(?:parents|prev(?:Until|All))/,
      E = { children: !0, contents: !0, next: !0, prev: !0 };n.fn.extend({ has: function has(a) {
      var b = n(a, this),
          c = b.length;return this.filter(function () {
        for (var a = 0; c > a; a++) {
          if (n.contains(this, b[a])) return !0;
        }
      });
    }, closest: function closest(a, b) {
      for (var c, d = 0, e = this.length, f = [], g = w.test(a) || "string" != typeof a ? n(a, b || this.context) : 0; e > d; d++) {
        for (c = this[d]; c && c !== b; c = c.parentNode) {
          if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && n.find.matchesSelector(c, a))) {
            f.push(c);break;
          }
        }
      }return this.pushStack(f.length > 1 ? n.uniqueSort(f) : f);
    }, index: function index(a) {
      return a ? "string" == typeof a ? h.call(n(a), this[0]) : h.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function add(a, b) {
      return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a, b))));
    }, addBack: function addBack(a) {
      return this.add(null == a ? this.prevObject : this.prevObject.filter(a));
    } });function F(a, b) {
    while ((a = a[b]) && 1 !== a.nodeType) {}return a;
  }n.each({ parent: function parent(a) {
      var b = a.parentNode;return b && 11 !== b.nodeType ? b : null;
    }, parents: function parents(a) {
      return u(a, "parentNode");
    }, parentsUntil: function parentsUntil(a, b, c) {
      return u(a, "parentNode", c);
    }, next: function next(a) {
      return F(a, "nextSibling");
    }, prev: function prev(a) {
      return F(a, "previousSibling");
    }, nextAll: function nextAll(a) {
      return u(a, "nextSibling");
    }, prevAll: function prevAll(a) {
      return u(a, "previousSibling");
    }, nextUntil: function nextUntil(a, b, c) {
      return u(a, "nextSibling", c);
    }, prevUntil: function prevUntil(a, b, c) {
      return u(a, "previousSibling", c);
    }, siblings: function siblings(a) {
      return v((a.parentNode || {}).firstChild, a);
    }, children: function children(a) {
      return v(a.firstChild);
    }, contents: function contents(a) {
      return a.contentDocument || n.merge([], a.childNodes);
    } }, function (a, b) {
    n.fn[a] = function (c, d) {
      var e = n.map(this, b, c);return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = n.filter(d, e)), this.length > 1 && (E[a] || n.uniqueSort(e), D.test(a) && e.reverse()), this.pushStack(e);
    };
  });var G = /\S+/g;function H(a) {
    var b = {};return n.each(a.match(G) || [], function (a, c) {
      b[c] = !0;
    }), b;
  }n.Callbacks = function (a) {
    a = "string" == typeof a ? H(a) : n.extend({}, a);var b,
        c,
        d,
        e,
        f = [],
        g = [],
        h = -1,
        i = function i() {
      for (e = a.once, d = b = !0; g.length; h = -1) {
        c = g.shift();while (++h < f.length) {
          f[h].apply(c[0], c[1]) === !1 && a.stopOnFalse && (h = f.length, c = !1);
        }
      }a.memory || (c = !1), b = !1, e && (f = c ? [] : "");
    },
        j = { add: function add() {
        return f && (c && !b && (h = f.length - 1, g.push(c)), function d(b) {
          n.each(b, function (b, c) {
            n.isFunction(c) ? a.unique && j.has(c) || f.push(c) : c && c.length && "string" !== n.type(c) && d(c);
          });
        }(arguments), c && !b && i()), this;
      }, remove: function remove() {
        return n.each(arguments, function (a, b) {
          var c;while ((c = n.inArray(b, f, c)) > -1) {
            f.splice(c, 1), h >= c && h--;
          }
        }), this;
      }, has: function has(a) {
        return a ? n.inArray(a, f) > -1 : f.length > 0;
      }, empty: function empty() {
        return f && (f = []), this;
      }, disable: function disable() {
        return e = g = [], f = c = "", this;
      }, disabled: function disabled() {
        return !f;
      }, lock: function lock() {
        return e = g = [], c || (f = c = ""), this;
      }, locked: function locked() {
        return !!e;
      }, fireWith: function fireWith(a, c) {
        return e || (c = c || [], c = [a, c.slice ? c.slice() : c], g.push(c), b || i()), this;
      }, fire: function fire() {
        return j.fireWith(this, arguments), this;
      }, fired: function fired() {
        return !!d;
      } };return j;
  }, n.extend({ Deferred: function Deferred(a) {
      var b = [["resolve", "done", n.Callbacks("once memory"), "resolved"], ["reject", "fail", n.Callbacks("once memory"), "rejected"], ["notify", "progress", n.Callbacks("memory")]],
          c = "pending",
          d = { state: function state() {
          return c;
        }, always: function always() {
          return e.done(arguments).fail(arguments), this;
        }, then: function then() {
          var a = arguments;return n.Deferred(function (c) {
            n.each(b, function (b, f) {
              var g = n.isFunction(a[b]) && a[b];e[f[1]](function () {
                var a = g && g.apply(this, arguments);a && n.isFunction(a.promise) ? a.promise().progress(c.notify).done(c.resolve).fail(c.reject) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [a] : arguments);
              });
            }), a = null;
          }).promise();
        }, promise: function promise(a) {
          return null != a ? n.extend(a, d) : d;
        } },
          e = {};return d.pipe = d.then, n.each(b, function (a, f) {
        var g = f[2],
            h = f[3];d[f[1]] = g.add, h && g.add(function () {
          c = h;
        }, b[1 ^ a][2].disable, b[2][2].lock), e[f[0]] = function () {
          return e[f[0] + "With"](this === e ? d : this, arguments), this;
        }, e[f[0] + "With"] = g.fireWith;
      }), d.promise(e), a && a.call(e, e), e;
    }, when: function when(a) {
      var b = 0,
          c = e.call(arguments),
          d = c.length,
          f = 1 !== d || a && n.isFunction(a.promise) ? d : 0,
          g = 1 === f ? a : n.Deferred(),
          h = function h(a, b, c) {
        return function (d) {
          b[a] = this, c[a] = arguments.length > 1 ? e.call(arguments) : d, c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c);
        };
      },
          i,
          j,
          k;if (d > 1) for (i = new Array(d), j = new Array(d), k = new Array(d); d > b; b++) {
        c[b] && n.isFunction(c[b].promise) ? c[b].promise().progress(h(b, j, i)).done(h(b, k, c)).fail(g.reject) : --f;
      }return f || g.resolveWith(k, c), g.promise();
    } });var I;n.fn.ready = function (a) {
    return n.ready.promise().done(a), this;
  }, n.extend({ isReady: !1, readyWait: 1, holdReady: function holdReady(a) {
      a ? n.readyWait++ : n.ready(!0);
    }, ready: function ready(a) {
      (a === !0 ? --n.readyWait : n.isReady) || (n.isReady = !0, a !== !0 && --n.readyWait > 0 || (I.resolveWith(d, [n]), n.fn.triggerHandler && (n(d).triggerHandler("ready"), n(d).off("ready"))));
    } });function J() {
    d.removeEventListener("DOMContentLoaded", J), a.removeEventListener("load", J), n.ready();
  }n.ready.promise = function (b) {
    return I || (I = n.Deferred(), "complete" === d.readyState || "loading" !== d.readyState && !d.documentElement.doScroll ? a.setTimeout(n.ready) : (d.addEventListener("DOMContentLoaded", J), a.addEventListener("load", J))), I.promise(b);
  }, n.ready.promise();var K = function K(a, b, c, d, e, f, g) {
    var h = 0,
        i = a.length,
        j = null == c;if ("object" === n.type(c)) {
      e = !0;for (h in c) {
        K(a, b, h, c[h], !0, f, g);
      }
    } else if (void 0 !== d && (e = !0, n.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function b(a, _b, c) {
      return j.call(n(a), c);
    })), b)) for (; i > h; h++) {
      b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
    }return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
  },
      L = function L(a) {
    return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType;
  };function M() {
    this.expando = n.expando + M.uid++;
  }M.uid = 1, M.prototype = { register: function register(a, b) {
      var c = b || {};return a.nodeType ? a[this.expando] = c : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(a, this.expando, { value: c, writable: !0, configurable: !0 }), a[this.expando];
    }, cache: function cache(a) {
      if (!L(a)) return {};var b = a[this.expando];return b || (b = {}, L(a) && (a.nodeType ? a[this.expando] = b : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(a, this.expando, { value: b, configurable: !0 }))), b;
    }, set: function set(a, b, c) {
      var d,
          e = this.cache(a);if ("string" == typeof b) e[b] = c;else for (d in b) {
        e[d] = b[d];
      }return e;
    }, get: function get(a, b) {
      return void 0 === b ? this.cache(a) : a[this.expando] && a[this.expando][b];
    }, access: function access(a, b, c) {
      var d;return void 0 === b || b && "string" == typeof b && void 0 === c ? (d = this.get(a, b), void 0 !== d ? d : this.get(a, n.camelCase(b))) : (this.set(a, b, c), void 0 !== c ? c : b);
    }, remove: function remove(a, b) {
      var c,
          d,
          e,
          f = a[this.expando];if (void 0 !== f) {
        if (void 0 === b) this.register(a);else {
          n.isArray(b) ? d = b.concat(b.map(n.camelCase)) : (e = n.camelCase(b), b in f ? d = [b, e] : (d = e, d = d in f ? [d] : d.match(G) || [])), c = d.length;while (c--) {
            delete f[d[c]];
          }
        }(void 0 === b || n.isEmptyObject(f)) && (a.nodeType ? a[this.expando] = void 0 : delete a[this.expando]);
      }
    }, hasData: function hasData(a) {
      var b = a[this.expando];return void 0 !== b && !n.isEmptyObject(b);
    } };var N = new M(),
      O = new M(),
      P = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      Q = /[A-Z]/g;function R(a, b, c) {
    var d;if (void 0 === c && 1 === a.nodeType) if (d = "data-" + b.replace(Q, "-$&").toLowerCase(), c = a.getAttribute(d), "string" == typeof c) {
      try {
        c = "true" === c ? !0 : "false" === c ? !1 : "null" === c ? null : +c + "" === c ? +c : P.test(c) ? n.parseJSON(c) : c;
      } catch (e) {}O.set(a, b, c);
    } else c = void 0;return c;
  }n.extend({ hasData: function hasData(a) {
      return O.hasData(a) || N.hasData(a);
    }, data: function data(a, b, c) {
      return O.access(a, b, c);
    }, removeData: function removeData(a, b) {
      O.remove(a, b);
    }, _data: function _data(a, b, c) {
      return N.access(a, b, c);
    }, _removeData: function _removeData(a, b) {
      N.remove(a, b);
    } }), n.fn.extend({ data: function data(a, b) {
      var c,
          d,
          e,
          f = this[0],
          g = f && f.attributes;if (void 0 === a) {
        if (this.length && (e = O.get(f), 1 === f.nodeType && !N.get(f, "hasDataAttrs"))) {
          c = g.length;while (c--) {
            g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = n.camelCase(d.slice(5)), R(f, d, e[d])));
          }N.set(f, "hasDataAttrs", !0);
        }return e;
      }return "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a)) ? this.each(function () {
        O.set(this, a);
      }) : K(this, function (b) {
        var c, d;if (f && void 0 === b) {
          if (c = O.get(f, a) || O.get(f, a.replace(Q, "-$&").toLowerCase()), void 0 !== c) return c;if (d = n.camelCase(a), c = O.get(f, d), void 0 !== c) return c;if (c = R(f, d, void 0), void 0 !== c) return c;
        } else d = n.camelCase(a), this.each(function () {
          var c = O.get(this, d);O.set(this, d, b), a.indexOf("-") > -1 && void 0 !== c && O.set(this, a, b);
        });
      }, null, b, arguments.length > 1, null, !0);
    }, removeData: function removeData(a) {
      return this.each(function () {
        O.remove(this, a);
      });
    } }), n.extend({ queue: function queue(a, b, c) {
      var d;return a ? (b = (b || "fx") + "queue", d = N.get(a, b), c && (!d || n.isArray(c) ? d = N.access(a, b, n.makeArray(c)) : d.push(c)), d || []) : void 0;
    }, dequeue: function dequeue(a, b) {
      b = b || "fx";var c = n.queue(a, b),
          d = c.length,
          e = c.shift(),
          f = n._queueHooks(a, b),
          g = function g() {
        n.dequeue(a, b);
      };"inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire();
    }, _queueHooks: function _queueHooks(a, b) {
      var c = b + "queueHooks";return N.get(a, c) || N.access(a, c, { empty: n.Callbacks("once memory").add(function () {
          N.remove(a, [b + "queue", c]);
        }) });
    } }), n.fn.extend({ queue: function queue(a, b) {
      var c = 2;return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? n.queue(this[0], a) : void 0 === b ? this : this.each(function () {
        var c = n.queue(this, a, b);n._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a);
      });
    }, dequeue: function dequeue(a) {
      return this.each(function () {
        n.dequeue(this, a);
      });
    }, clearQueue: function clearQueue(a) {
      return this.queue(a || "fx", []);
    }, promise: function promise(a, b) {
      var c,
          d = 1,
          e = n.Deferred(),
          f = this,
          g = this.length,
          h = function h() {
        --d || e.resolveWith(f, [f]);
      };"string" != typeof a && (b = a, a = void 0), a = a || "fx";while (g--) {
        c = N.get(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));
      }return h(), e.promise(b);
    } });var S = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      T = new RegExp("^(?:([+-])=|)(" + S + ")([a-z%]*)$", "i"),
      U = ["Top", "Right", "Bottom", "Left"],
      V = function V(a, b) {
    return a = b || a, "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a);
  };function W(a, b, c, d) {
    var e,
        f = 1,
        g = 20,
        h = d ? function () {
      return d.cur();
    } : function () {
      return n.css(a, b, "");
    },
        i = h(),
        j = c && c[3] || (n.cssNumber[b] ? "" : "px"),
        k = (n.cssNumber[b] || "px" !== j && +i) && T.exec(n.css(a, b));if (k && k[3] !== j) {
      j = j || k[3], c = c || [], k = +i || 1;do {
        f = f || ".5", k /= f, n.style(a, b, k + j);
      } while (f !== (f = h() / i) && 1 !== f && --g);
    }return c && (k = +k || +i || 0, e = c[1] ? k + (c[1] + 1) * c[2] : +c[2], d && (d.unit = j, d.start = k, d.end = e)), e;
  }var X = /^(?:checkbox|radio)$/i,
      Y = /<([\w:-]+)/,
      Z = /^$|\/(?:java|ecma)script/i,
      $ = { option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };$.optgroup = $.option, $.tbody = $.tfoot = $.colgroup = $.caption = $.thead, $.th = $.td;function _(a, b) {
    var c = "undefined" != typeof a.getElementsByTagName ? a.getElementsByTagName(b || "*") : "undefined" != typeof a.querySelectorAll ? a.querySelectorAll(b || "*") : [];return void 0 === b || b && n.nodeName(a, b) ? n.merge([a], c) : c;
  }function aa(a, b) {
    for (var c = 0, d = a.length; d > c; c++) {
      N.set(a[c], "globalEval", !b || N.get(b[c], "globalEval"));
    }
  }var ba = /<|&#?\w+;/;function ca(a, b, c, d, e) {
    for (var f, g, h, i, j, k, l = b.createDocumentFragment(), m = [], o = 0, p = a.length; p > o; o++) {
      if (f = a[o], f || 0 === f) if ("object" === n.type(f)) n.merge(m, f.nodeType ? [f] : f);else if (ba.test(f)) {
        g = g || l.appendChild(b.createElement("div")), h = (Y.exec(f) || ["", ""])[1].toLowerCase(), i = $[h] || $._default, g.innerHTML = i[1] + n.htmlPrefilter(f) + i[2], k = i[0];while (k--) {
          g = g.lastChild;
        }n.merge(m, g.childNodes), g = l.firstChild, g.textContent = "";
      } else m.push(b.createTextNode(f));
    }l.textContent = "", o = 0;while (f = m[o++]) {
      if (d && n.inArray(f, d) > -1) e && e.push(f);else if (j = n.contains(f.ownerDocument, f), g = _(l.appendChild(f), "script"), j && aa(g), c) {
        k = 0;while (f = g[k++]) {
          Z.test(f.type || "") && c.push(f);
        }
      }
    }return l;
  }!function () {
    var a = d.createDocumentFragment(),
        b = a.appendChild(d.createElement("div")),
        c = d.createElement("input");c.setAttribute("type", "radio"), c.setAttribute("checked", "checked"), c.setAttribute("name", "t"), b.appendChild(c), l.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked, b.innerHTML = "<textarea>x</textarea>", l.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue;
  }();var da = /^key/,
      ea = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      fa = /^([^.]*)(?:\.(.+)|)/;function ga() {
    return !0;
  }function ha() {
    return !1;
  }function ia() {
    try {
      return d.activeElement;
    } catch (a) {}
  }function ja(a, b, c, d, e, f) {
    var g, h;if ("object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(b))) {
      "string" != typeof c && (d = d || c, c = void 0);for (h in b) {
        ja(a, h, c, d, b[h], f);
      }return a;
    }if (null == d && null == e ? (e = c, d = c = void 0) : null == e && ("string" == typeof c ? (e = d, d = void 0) : (e = d, d = c, c = void 0)), e === !1) e = ha;else if (!e) return a;return 1 === f && (g = e, e = function e(a) {
      return n().off(a), g.apply(this, arguments);
    }, e.guid = g.guid || (g.guid = n.guid++)), a.each(function () {
      n.event.add(this, b, e, d, c);
    });
  }n.event = { global: {}, add: function add(a, b, c, d, e) {
      var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          o,
          p,
          q,
          r = N.get(a);if (r) {
        c.handler && (f = c, c = f.handler, e = f.selector), c.guid || (c.guid = n.guid++), (i = r.events) || (i = r.events = {}), (g = r.handle) || (g = r.handle = function (b) {
          return "undefined" != typeof n && n.event.triggered !== b.type ? n.event.dispatch.apply(a, arguments) : void 0;
        }), b = (b || "").match(G) || [""], j = b.length;while (j--) {
          h = fa.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o && (l = n.event.special[o] || {}, o = (e ? l.delegateType : l.bindType) || o, l = n.event.special[o] || {}, k = n.extend({ type: o, origType: q, data: d, handler: c, guid: c.guid, selector: e, needsContext: e && n.expr.match.needsContext.test(e), namespace: p.join(".") }, f), (m = i[o]) || (m = i[o] = [], m.delegateCount = 0, l.setup && l.setup.call(a, d, p, g) !== !1 || a.addEventListener && a.addEventListener(o, g)), l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, k) : m.push(k), n.event.global[o] = !0);
        }
      }
    }, remove: function remove(a, b, c, d, e) {
      var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          o,
          p,
          q,
          r = N.hasData(a) && N.get(a);if (r && (i = r.events)) {
        b = (b || "").match(G) || [""], j = b.length;while (j--) {
          if (h = fa.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o) {
            l = n.event.special[o] || {}, o = (d ? l.delegateType : l.bindType) || o, m = i[o] || [], h = h[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), g = f = m.length;while (f--) {
              k = m[f], !e && q !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k));
            }g && !m.length && (l.teardown && l.teardown.call(a, p, r.handle) !== !1 || n.removeEvent(a, o, r.handle), delete i[o]);
          } else for (o in i) {
            n.event.remove(a, o + b[j], c, d, !0);
          }
        }n.isEmptyObject(i) && N.remove(a, "handle events");
      }
    }, dispatch: function dispatch(a) {
      a = n.event.fix(a);var b,
          c,
          d,
          f,
          g,
          h = [],
          i = e.call(arguments),
          j = (N.get(this, "events") || {})[a.type] || [],
          k = n.event.special[a.type] || {};if (i[0] = a, a.delegateTarget = this, !k.preDispatch || k.preDispatch.call(this, a) !== !1) {
        h = n.event.handlers.call(this, a, j), b = 0;while ((f = h[b++]) && !a.isPropagationStopped()) {
          a.currentTarget = f.elem, c = 0;while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped()) {
            a.rnamespace && !a.rnamespace.test(g.namespace) || (a.handleObj = g, a.data = g.data, d = ((n.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i), void 0 !== d && (a.result = d) === !1 && (a.preventDefault(), a.stopPropagation()));
          }
        }return k.postDispatch && k.postDispatch.call(this, a), a.result;
      }
    }, handlers: function handlers(a, b) {
      var c,
          d,
          e,
          f,
          g = [],
          h = b.delegateCount,
          i = a.target;if (h && i.nodeType && ("click" !== a.type || isNaN(a.button) || a.button < 1)) for (; i !== this; i = i.parentNode || this) {
        if (1 === i.nodeType && (i.disabled !== !0 || "click" !== a.type)) {
          for (d = [], c = 0; h > c; c++) {
            f = b[c], e = f.selector + " ", void 0 === d[e] && (d[e] = f.needsContext ? n(e, this).index(i) > -1 : n.find(e, this, null, [i]).length), d[e] && d.push(f);
          }d.length && g.push({ elem: i, handlers: d });
        }
      }return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g;
    }, props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "), fixHooks: {}, keyHooks: { props: "char charCode key keyCode".split(" "), filter: function filter(a, b) {
        return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a;
      } }, mouseHooks: { props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "), filter: function filter(a, b) {
        var c,
            e,
            f,
            g = b.button;return null == a.pageX && null != b.clientX && (c = a.target.ownerDocument || d, e = c.documentElement, f = c.body, a.pageX = b.clientX + (e && e.scrollLeft || f && f.scrollLeft || 0) - (e && e.clientLeft || f && f.clientLeft || 0), a.pageY = b.clientY + (e && e.scrollTop || f && f.scrollTop || 0) - (e && e.clientTop || f && f.clientTop || 0)), a.which || void 0 === g || (a.which = 1 & g ? 1 : 2 & g ? 3 : 4 & g ? 2 : 0), a;
      } }, fix: function fix(a) {
      if (a[n.expando]) return a;var b,
          c,
          e,
          f = a.type,
          g = a,
          h = this.fixHooks[f];h || (this.fixHooks[f] = h = ea.test(f) ? this.mouseHooks : da.test(f) ? this.keyHooks : {}), e = h.props ? this.props.concat(h.props) : this.props, a = new n.Event(g), b = e.length;while (b--) {
        c = e[b], a[c] = g[c];
      }return a.target || (a.target = d), 3 === a.target.nodeType && (a.target = a.target.parentNode), h.filter ? h.filter(a, g) : a;
    }, special: { load: { noBubble: !0 }, focus: { trigger: function trigger() {
          return this !== ia() && this.focus ? (this.focus(), !1) : void 0;
        }, delegateType: "focusin" }, blur: { trigger: function trigger() {
          return this === ia() && this.blur ? (this.blur(), !1) : void 0;
        }, delegateType: "focusout" }, click: { trigger: function trigger() {
          return "checkbox" === this.type && this.click && n.nodeName(this, "input") ? (this.click(), !1) : void 0;
        }, _default: function _default(a) {
          return n.nodeName(a.target, "a");
        } }, beforeunload: { postDispatch: function postDispatch(a) {
          void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result);
        } } } }, n.removeEvent = function (a, b, c) {
    a.removeEventListener && a.removeEventListener(b, c);
  }, n.Event = function (a, b) {
    return this instanceof n.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? ga : ha) : this.type = a, b && n.extend(this, b), this.timeStamp = a && a.timeStamp || n.now(), void (this[n.expando] = !0)) : new n.Event(a, b);
  }, n.Event.prototype = { constructor: n.Event, isDefaultPrevented: ha, isPropagationStopped: ha, isImmediatePropagationStopped: ha, preventDefault: function preventDefault() {
      var a = this.originalEvent;this.isDefaultPrevented = ga, a && a.preventDefault();
    }, stopPropagation: function stopPropagation() {
      var a = this.originalEvent;this.isPropagationStopped = ga, a && a.stopPropagation();
    }, stopImmediatePropagation: function stopImmediatePropagation() {
      var a = this.originalEvent;this.isImmediatePropagationStopped = ga, a && a.stopImmediatePropagation(), this.stopPropagation();
    } }, n.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (a, b) {
    n.event.special[a] = { delegateType: b, bindType: b, handle: function handle(a) {
        var c,
            d = this,
            e = a.relatedTarget,
            f = a.handleObj;return e && (e === d || n.contains(d, e)) || (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c;
      } };
  }), n.fn.extend({ on: function on(a, b, c, d) {
      return ja(this, a, b, c, d);
    }, one: function one(a, b, c, d) {
      return ja(this, a, b, c, d, 1);
    }, off: function off(a, b, c) {
      var d, e;if (a && a.preventDefault && a.handleObj) return d = a.handleObj, n(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this;if ("object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a))) {
        for (e in a) {
          this.off(e, b, a[e]);
        }return this;
      }return b !== !1 && "function" != typeof b || (c = b, b = void 0), c === !1 && (c = ha), this.each(function () {
        n.event.remove(this, a, c, b);
      });
    } });var ka = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
      la = /<script|<style|<link/i,
      ma = /checked\s*(?:[^=]|=\s*.checked.)/i,
      na = /^true\/(.*)/,
      oa = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function pa(a, b) {
    return n.nodeName(a, "table") && n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr") ? a.getElementsByTagName("tbody")[0] || a.appendChild(a.ownerDocument.createElement("tbody")) : a;
  }function qa(a) {
    return a.type = (null !== a.getAttribute("type")) + "/" + a.type, a;
  }function ra(a) {
    var b = na.exec(a.type);return b ? a.type = b[1] : a.removeAttribute("type"), a;
  }function sa(a, b) {
    var c, d, e, f, g, h, i, j;if (1 === b.nodeType) {
      if (N.hasData(a) && (f = N.access(a), g = N.set(b, f), j = f.events)) {
        delete g.handle, g.events = {};for (e in j) {
          for (c = 0, d = j[e].length; d > c; c++) {
            n.event.add(b, e, j[e][c]);
          }
        }
      }O.hasData(a) && (h = O.access(a), i = n.extend({}, h), O.set(b, i));
    }
  }function ta(a, b) {
    var c = b.nodeName.toLowerCase();"input" === c && X.test(a.type) ? b.checked = a.checked : "input" !== c && "textarea" !== c || (b.defaultValue = a.defaultValue);
  }function ua(a, b, c, d) {
    b = f.apply([], b);var e,
        g,
        h,
        i,
        j,
        k,
        m = 0,
        o = a.length,
        p = o - 1,
        q = b[0],
        r = n.isFunction(q);if (r || o > 1 && "string" == typeof q && !l.checkClone && ma.test(q)) return a.each(function (e) {
      var f = a.eq(e);r && (b[0] = q.call(this, e, f.html())), ua(f, b, c, d);
    });if (o && (e = ca(b, a[0].ownerDocument, !1, a, d), g = e.firstChild, 1 === e.childNodes.length && (e = g), g || d)) {
      for (h = n.map(_(e, "script"), qa), i = h.length; o > m; m++) {
        j = e, m !== p && (j = n.clone(j, !0, !0), i && n.merge(h, _(j, "script"))), c.call(a[m], j, m);
      }if (i) for (k = h[h.length - 1].ownerDocument, n.map(h, ra), m = 0; i > m; m++) {
        j = h[m], Z.test(j.type || "") && !N.access(j, "globalEval") && n.contains(k, j) && (j.src ? n._evalUrl && n._evalUrl(j.src) : n.globalEval(j.textContent.replace(oa, "")));
      }
    }return a;
  }function va(a, b, c) {
    for (var d, e = b ? n.filter(b, a) : a, f = 0; null != (d = e[f]); f++) {
      c || 1 !== d.nodeType || n.cleanData(_(d)), d.parentNode && (c && n.contains(d.ownerDocument, d) && aa(_(d, "script")), d.parentNode.removeChild(d));
    }return a;
  }n.extend({ htmlPrefilter: function htmlPrefilter(a) {
      return a.replace(ka, "<$1></$2>");
    }, clone: function clone(a, b, c) {
      var d,
          e,
          f,
          g,
          h = a.cloneNode(!0),
          i = n.contains(a.ownerDocument, a);if (!(l.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || n.isXMLDoc(a))) for (g = _(h), f = _(a), d = 0, e = f.length; e > d; d++) {
        ta(f[d], g[d]);
      }if (b) if (c) for (f = f || _(a), g = g || _(h), d = 0, e = f.length; e > d; d++) {
        sa(f[d], g[d]);
      } else sa(a, h);return g = _(h, "script"), g.length > 0 && aa(g, !i && _(a, "script")), h;
    }, cleanData: function cleanData(a) {
      for (var b, c, d, e = n.event.special, f = 0; void 0 !== (c = a[f]); f++) {
        if (L(c)) {
          if (b = c[N.expando]) {
            if (b.events) for (d in b.events) {
              e[d] ? n.event.remove(c, d) : n.removeEvent(c, d, b.handle);
            }c[N.expando] = void 0;
          }c[O.expando] && (c[O.expando] = void 0);
        }
      }
    } }), n.fn.extend({ domManip: ua, detach: function detach(a) {
      return va(this, a, !0);
    }, remove: function remove(a) {
      return va(this, a);
    }, text: function text(a) {
      return K(this, function (a) {
        return void 0 === a ? n.text(this) : this.empty().each(function () {
          1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = a);
        });
      }, null, a, arguments.length);
    }, append: function append() {
      return ua(this, arguments, function (a) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var b = pa(this, a);b.appendChild(a);
        }
      });
    }, prepend: function prepend() {
      return ua(this, arguments, function (a) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var b = pa(this, a);b.insertBefore(a, b.firstChild);
        }
      });
    }, before: function before() {
      return ua(this, arguments, function (a) {
        this.parentNode && this.parentNode.insertBefore(a, this);
      });
    }, after: function after() {
      return ua(this, arguments, function (a) {
        this.parentNode && this.parentNode.insertBefore(a, this.nextSibling);
      });
    }, empty: function empty() {
      for (var a, b = 0; null != (a = this[b]); b++) {
        1 === a.nodeType && (n.cleanData(_(a, !1)), a.textContent = "");
      }return this;
    }, clone: function clone(a, b) {
      return a = null == a ? !1 : a, b = null == b ? a : b, this.map(function () {
        return n.clone(this, a, b);
      });
    }, html: function html(a) {
      return K(this, function (a) {
        var b = this[0] || {},
            c = 0,
            d = this.length;if (void 0 === a && 1 === b.nodeType) return b.innerHTML;if ("string" == typeof a && !la.test(a) && !$[(Y.exec(a) || ["", ""])[1].toLowerCase()]) {
          a = n.htmlPrefilter(a);try {
            for (; d > c; c++) {
              b = this[c] || {}, 1 === b.nodeType && (n.cleanData(_(b, !1)), b.innerHTML = a);
            }b = 0;
          } catch (e) {}
        }b && this.empty().append(a);
      }, null, a, arguments.length);
    }, replaceWith: function replaceWith() {
      var a = [];return ua(this, arguments, function (b) {
        var c = this.parentNode;n.inArray(this, a) < 0 && (n.cleanData(_(this)), c && c.replaceChild(b, this));
      }, a);
    } }), n.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (a, b) {
    n.fn[a] = function (a) {
      for (var c, d = [], e = n(a), f = e.length - 1, h = 0; f >= h; h++) {
        c = h === f ? this : this.clone(!0), n(e[h])[b](c), g.apply(d, c.get());
      }return this.pushStack(d);
    };
  });var wa,
      xa = { HTML: "block", BODY: "block" };function ya(a, b) {
    var c = n(b.createElement(a)).appendTo(b.body),
        d = n.css(c[0], "display");return c.detach(), d;
  }function za(a) {
    var b = d,
        c = xa[a];return c || (c = ya(a, b), "none" !== c && c || (wa = (wa || n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement), b = wa[0].contentDocument, b.write(), b.close(), c = ya(a, b), wa.detach()), xa[a] = c), c;
  }var Aa = /^margin/,
      Ba = new RegExp("^(" + S + ")(?!px)[a-z%]+$", "i"),
      Ca = function Ca(b) {
    var c = b.ownerDocument.defaultView;return c && c.opener || (c = a), c.getComputedStyle(b);
  },
      Da = function Da(a, b, c, d) {
    var e,
        f,
        g = {};for (f in b) {
      g[f] = a.style[f], a.style[f] = b[f];
    }e = c.apply(a, d || []);for (f in b) {
      a.style[f] = g[f];
    }return e;
  },
      Ea = d.documentElement;!function () {
    var b,
        c,
        e,
        f,
        g = d.createElement("div"),
        h = d.createElement("div");if (h.style) {
      var _i = function _i() {
        h.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", h.innerHTML = "", Ea.appendChild(g);var d = a.getComputedStyle(h);b = "1%" !== d.top, f = "2px" === d.marginLeft, c = "4px" === d.width, h.style.marginRight = "50%", e = "4px" === d.marginRight, Ea.removeChild(g);
      };

      h.style.backgroundClip = "content-box", h.cloneNode(!0).style.backgroundClip = "", l.clearCloneStyle = "content-box" === h.style.backgroundClip, g.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", g.appendChild(h);n.extend(l, { pixelPosition: function pixelPosition() {
          return _i(), b;
        }, boxSizingReliable: function boxSizingReliable() {
          return null == c && _i(), c;
        }, pixelMarginRight: function pixelMarginRight() {
          return null == c && _i(), e;
        }, reliableMarginLeft: function reliableMarginLeft() {
          return null == c && _i(), f;
        }, reliableMarginRight: function reliableMarginRight() {
          var b,
              c = h.appendChild(d.createElement("div"));return c.style.cssText = h.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", c.style.marginRight = c.style.width = "0", h.style.width = "1px", Ea.appendChild(g), b = !parseFloat(a.getComputedStyle(c).marginRight), Ea.removeChild(g), h.removeChild(c), b;
        } });
    }
  }();function Fa(a, b, c) {
    var d,
        e,
        f,
        g,
        h = a.style;return c = c || Ca(a), g = c ? c.getPropertyValue(b) || c[b] : void 0, "" !== g && void 0 !== g || n.contains(a.ownerDocument, a) || (g = n.style(a, b)), c && !l.pixelMarginRight() && Ba.test(g) && Aa.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f), void 0 !== g ? g + "" : g;
  }function Ga(a, b) {
    return { get: function get() {
        return a() ? void delete this.get : (this.get = b).apply(this, arguments);
      } };
  }var Ha = /^(none|table(?!-c[ea]).+)/,
      Ia = { position: "absolute", visibility: "hidden", display: "block" },
      Ja = { letterSpacing: "0", fontWeight: "400" },
      Ka = ["Webkit", "O", "Moz", "ms"],
      La = d.createElement("div").style;function Ma(a) {
    if (a in La) return a;var b = a[0].toUpperCase() + a.slice(1),
        c = Ka.length;while (c--) {
      if (a = Ka[c] + b, a in La) return a;
    }
  }function Na(a, b, c) {
    var d = T.exec(b);return d ? Math.max(0, d[2] - (c || 0)) + (d[3] || "px") : b;
  }function Oa(a, b, c, d, e) {
    for (var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0, g = 0; 4 > f; f += 2) {
      "margin" === c && (g += n.css(a, c + U[f], !0, e)), d ? ("content" === c && (g -= n.css(a, "padding" + U[f], !0, e)), "margin" !== c && (g -= n.css(a, "border" + U[f] + "Width", !0, e))) : (g += n.css(a, "padding" + U[f], !0, e), "padding" !== c && (g += n.css(a, "border" + U[f] + "Width", !0, e)));
    }return g;
  }function Pa(b, c, e) {
    var f = !0,
        g = "width" === c ? b.offsetWidth : b.offsetHeight,
        h = Ca(b),
        i = "border-box" === n.css(b, "boxSizing", !1, h);if (d.msFullscreenElement && a.top !== a && b.getClientRects().length && (g = Math.round(100 * b.getBoundingClientRect()[c])), 0 >= g || null == g) {
      if (g = Fa(b, c, h), (0 > g || null == g) && (g = b.style[c]), Ba.test(g)) return g;f = i && (l.boxSizingReliable() || g === b.style[c]), g = parseFloat(g) || 0;
    }return g + Oa(b, c, e || (i ? "border" : "content"), f, h) + "px";
  }function Qa(a, b) {
    for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++) {
      d = a[g], d.style && (f[g] = N.get(d, "olddisplay"), c = d.style.display, b ? (f[g] || "none" !== c || (d.style.display = ""), "" === d.style.display && V(d) && (f[g] = N.access(d, "olddisplay", za(d.nodeName)))) : (e = V(d), "none" === c && e || N.set(d, "olddisplay", e ? c : n.css(d, "display"))));
    }for (g = 0; h > g; g++) {
      d = a[g], d.style && (b && "none" !== d.style.display && "" !== d.style.display || (d.style.display = b ? f[g] || "" : "none"));
    }return a;
  }n.extend({ cssHooks: { opacity: { get: function get(a, b) {
          if (b) {
            var c = Fa(a, "opacity");return "" === c ? "1" : c;
          }
        } } }, cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: { "float": "cssFloat" }, style: function style(a, b, c, d) {
      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
        var e,
            f,
            g,
            h = n.camelCase(b),
            i = a.style;return b = n.cssProps[h] || (n.cssProps[h] = Ma(h) || h), g = n.cssHooks[b] || n.cssHooks[h], void 0 === c ? g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b] : (f = typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(c), "string" === f && (e = T.exec(c)) && e[1] && (c = W(a, b, e), f = "number"), null != c && c === c && ("number" === f && (c += e && e[3] || (n.cssNumber[h] ? "" : "px")), l.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (i[b] = "inherit"), g && "set" in g && void 0 === (c = g.set(a, c, d)) || (i[b] = c)), void 0);
      }
    }, css: function css(a, b, c, d) {
      var e,
          f,
          g,
          h = n.camelCase(b);return b = n.cssProps[h] || (n.cssProps[h] = Ma(h) || h), g = n.cssHooks[b] || n.cssHooks[h], g && "get" in g && (e = g.get(a, !0, c)), void 0 === e && (e = Fa(a, b, d)), "normal" === e && b in Ja && (e = Ja[b]), "" === c || c ? (f = parseFloat(e), c === !0 || isFinite(f) ? f || 0 : e) : e;
    } }), n.each(["height", "width"], function (a, b) {
    n.cssHooks[b] = { get: function get(a, c, d) {
        return c ? Ha.test(n.css(a, "display")) && 0 === a.offsetWidth ? Da(a, Ia, function () {
          return Pa(a, b, d);
        }) : Pa(a, b, d) : void 0;
      }, set: function set(a, c, d) {
        var e,
            f = d && Ca(a),
            g = d && Oa(a, b, d, "border-box" === n.css(a, "boxSizing", !1, f), f);return g && (e = T.exec(c)) && "px" !== (e[3] || "px") && (a.style[b] = c, c = n.css(a, b)), Na(a, c, g);
      } };
  }), n.cssHooks.marginLeft = Ga(l.reliableMarginLeft, function (a, b) {
    return b ? (parseFloat(Fa(a, "marginLeft")) || a.getBoundingClientRect().left - Da(a, { marginLeft: 0 }, function () {
      return a.getBoundingClientRect().left;
    })) + "px" : void 0;
  }), n.cssHooks.marginRight = Ga(l.reliableMarginRight, function (a, b) {
    return b ? Da(a, { display: "inline-block" }, Fa, [a, "marginRight"]) : void 0;
  }), n.each({ margin: "", padding: "", border: "Width" }, function (a, b) {
    n.cssHooks[a + b] = { expand: function expand(c) {
        for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; 4 > d; d++) {
          e[a + U[d] + b] = f[d] || f[d - 2] || f[0];
        }return e;
      } }, Aa.test(a) || (n.cssHooks[a + b].set = Na);
  }), n.fn.extend({ css: function css(a, b) {
      return K(this, function (a, b, c) {
        var d,
            e,
            f = {},
            g = 0;if (n.isArray(b)) {
          for (d = Ca(a), e = b.length; e > g; g++) {
            f[b[g]] = n.css(a, b[g], !1, d);
          }return f;
        }return void 0 !== c ? n.style(a, b, c) : n.css(a, b);
      }, a, b, arguments.length > 1);
    }, show: function show() {
      return Qa(this, !0);
    }, hide: function hide() {
      return Qa(this);
    }, toggle: function toggle(a) {
      return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function () {
        V(this) ? n(this).show() : n(this).hide();
      });
    } });function Ra(a, b, c, d, e) {
    return new Ra.prototype.init(a, b, c, d, e);
  }n.Tween = Ra, Ra.prototype = { constructor: Ra, init: function init(a, b, c, d, e, f) {
      this.elem = a, this.prop = c, this.easing = e || n.easing._default, this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (n.cssNumber[c] ? "" : "px");
    }, cur: function cur() {
      var a = Ra.propHooks[this.prop];return a && a.get ? a.get(this) : Ra.propHooks._default.get(this);
    }, run: function run(a) {
      var b,
          c = Ra.propHooks[this.prop];return this.options.duration ? this.pos = b = n.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : Ra.propHooks._default.set(this), this;
    } }, Ra.prototype.init.prototype = Ra.prototype, Ra.propHooks = { _default: { get: function get(a) {
        var b;return 1 !== a.elem.nodeType || null != a.elem[a.prop] && null == a.elem.style[a.prop] ? a.elem[a.prop] : (b = n.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0);
      }, set: function set(a) {
        n.fx.step[a.prop] ? n.fx.step[a.prop](a) : 1 !== a.elem.nodeType || null == a.elem.style[n.cssProps[a.prop]] && !n.cssHooks[a.prop] ? a.elem[a.prop] = a.now : n.style(a.elem, a.prop, a.now + a.unit);
      } } }, Ra.propHooks.scrollTop = Ra.propHooks.scrollLeft = { set: function set(a) {
      a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
    } }, n.easing = { linear: function linear(a) {
      return a;
    }, swing: function swing(a) {
      return .5 - Math.cos(a * Math.PI) / 2;
    }, _default: "swing" }, n.fx = Ra.prototype.init, n.fx.step = {};var Sa,
      Ta,
      Ua = /^(?:toggle|show|hide)$/,
      Va = /queueHooks$/;function Wa() {
    return a.setTimeout(function () {
      Sa = void 0;
    }), Sa = n.now();
  }function Xa(a, b) {
    var c,
        d = 0,
        e = { height: a };for (b = b ? 1 : 0; 4 > d; d += 2 - b) {
      c = U[d], e["margin" + c] = e["padding" + c] = a;
    }return b && (e.opacity = e.width = a), e;
  }function Ya(a, b, c) {
    for (var d, e = (_a.tweeners[b] || []).concat(_a.tweeners["*"]), f = 0, g = e.length; g > f; f++) {
      if (d = e[f].call(c, b, a)) return d;
    }
  }function Za(a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l = this,
        m = {},
        o = a.style,
        p = a.nodeType && V(a),
        q = N.get(a, "fxshow");c.queue || (h = n._queueHooks(a, "fx"), null == h.unqueued && (h.unqueued = 0, i = h.empty.fire, h.empty.fire = function () {
      h.unqueued || i();
    }), h.unqueued++, l.always(function () {
      l.always(function () {
        h.unqueued--, n.queue(a, "fx").length || h.empty.fire();
      });
    })), 1 === a.nodeType && ("height" in b || "width" in b) && (c.overflow = [o.overflow, o.overflowX, o.overflowY], j = n.css(a, "display"), k = "none" === j ? N.get(a, "olddisplay") || za(a.nodeName) : j, "inline" === k && "none" === n.css(a, "float") && (o.display = "inline-block")), c.overflow && (o.overflow = "hidden", l.always(function () {
      o.overflow = c.overflow[0], o.overflowX = c.overflow[1], o.overflowY = c.overflow[2];
    }));for (d in b) {
      if (e = b[d], Ua.exec(e)) {
        if (delete b[d], f = f || "toggle" === e, e === (p ? "hide" : "show")) {
          if ("show" !== e || !q || void 0 === q[d]) continue;p = !0;
        }m[d] = q && q[d] || n.style(a, d);
      } else j = void 0;
    }if (n.isEmptyObject(m)) "inline" === ("none" === j ? za(a.nodeName) : j) && (o.display = j);else {
      q ? "hidden" in q && (p = q.hidden) : q = N.access(a, "fxshow", {}), f && (q.hidden = !p), p ? n(a).show() : l.done(function () {
        n(a).hide();
      }), l.done(function () {
        var b;N.remove(a, "fxshow");for (b in m) {
          n.style(a, b, m[b]);
        }
      });for (d in m) {
        g = Ya(p ? q[d] : 0, d, l), d in q || (q[d] = g.start, p && (g.end = g.start, g.start = "width" === d || "height" === d ? 1 : 0));
      }
    }
  }function $a(a, b) {
    var c, d, e, f, g;for (c in a) {
      if (d = n.camelCase(c), e = b[d], f = a[c], n.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = n.cssHooks[d], g && "expand" in g) {
        f = g.expand(f), delete a[d];for (c in f) {
          c in a || (a[c] = f[c], b[c] = e);
        }
      } else b[d] = e;
    }
  }function _a(a, b, c) {
    var d,
        e,
        f = 0,
        g = _a.prefilters.length,
        h = n.Deferred().always(function () {
      delete i.elem;
    }),
        i = function i() {
      if (e) return !1;for (var b = Sa || Wa(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; i > g; g++) {
        j.tweens[g].run(f);
      }return h.notifyWith(a, [j, f, c]), 1 > f && i ? c : (h.resolveWith(a, [j]), !1);
    },
        j = h.promise({ elem: a, props: n.extend({}, b), opts: n.extend(!0, { specialEasing: {}, easing: n.easing._default }, c), originalProperties: b, originalOptions: c, startTime: Sa || Wa(), duration: c.duration, tweens: [], createTween: function createTween(b, c) {
        var d = n.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);return j.tweens.push(d), d;
      }, stop: function stop(b) {
        var c = 0,
            d = b ? j.tweens.length : 0;if (e) return this;for (e = !0; d > c; c++) {
          j.tweens[c].run(1);
        }return b ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b])) : h.rejectWith(a, [j, b]), this;
      } }),
        k = j.props;for ($a(k, j.opts.specialEasing); g > f; f++) {
      if (d = _a.prefilters[f].call(j, a, k, j.opts)) return n.isFunction(d.stop) && (n._queueHooks(j.elem, j.opts.queue).stop = n.proxy(d.stop, d)), d;
    }return n.map(k, Ya, j), n.isFunction(j.opts.start) && j.opts.start.call(a, j), n.fx.timer(n.extend(i, { elem: a, anim: j, queue: j.opts.queue })), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always);
  }n.Animation = n.extend(_a, { tweeners: { "*": [function (a, b) {
        var c = this.createTween(a, b);return W(c.elem, a, T.exec(b), c), c;
      }] }, tweener: function tweener(a, b) {
      n.isFunction(a) ? (b = a, a = ["*"]) : a = a.match(G);for (var c, d = 0, e = a.length; e > d; d++) {
        c = a[d], _a.tweeners[c] = _a.tweeners[c] || [], _a.tweeners[c].unshift(b);
      }
    }, prefilters: [Za], prefilter: function prefilter(a, b) {
      b ? _a.prefilters.unshift(a) : _a.prefilters.push(a);
    } }), n.speed = function (a, b, c) {
    var d = a && "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a)) ? n.extend({}, a) : { complete: c || !c && b || n.isFunction(a) && a, duration: a, easing: c && b || b && !n.isFunction(b) && b };return d.duration = n.fx.off ? 0 : "number" == typeof d.duration ? d.duration : d.duration in n.fx.speeds ? n.fx.speeds[d.duration] : n.fx.speeds._default, null != d.queue && d.queue !== !0 || (d.queue = "fx"), d.old = d.complete, d.complete = function () {
      n.isFunction(d.old) && d.old.call(this), d.queue && n.dequeue(this, d.queue);
    }, d;
  }, n.fn.extend({ fadeTo: function fadeTo(a, b, c, d) {
      return this.filter(V).css("opacity", 0).show().end().animate({ opacity: b }, a, c, d);
    }, animate: function animate(a, b, c, d) {
      var e = n.isEmptyObject(a),
          f = n.speed(b, c, d),
          g = function g() {
        var b = _a(this, n.extend({}, a), f);(e || N.get(this, "finish")) && b.stop(!0);
      };return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g);
    }, stop: function stop(a, b, c) {
      var d = function d(a) {
        var b = a.stop;delete a.stop, b(c);
      };return "string" != typeof a && (c = b, b = a, a = void 0), b && a !== !1 && this.queue(a || "fx", []), this.each(function () {
        var b = !0,
            e = null != a && a + "queueHooks",
            f = n.timers,
            g = N.get(this);if (e) g[e] && g[e].stop && d(g[e]);else for (e in g) {
          g[e] && g[e].stop && Va.test(e) && d(g[e]);
        }for (e = f.length; e--;) {
          f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));
        }!b && c || n.dequeue(this, a);
      });
    }, finish: function finish(a) {
      return a !== !1 && (a = a || "fx"), this.each(function () {
        var b,
            c = N.get(this),
            d = c[a + "queue"],
            e = c[a + "queueHooks"],
            f = n.timers,
            g = d ? d.length : 0;for (c.finish = !0, n.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;) {
          f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));
        }for (b = 0; g > b; b++) {
          d[b] && d[b].finish && d[b].finish.call(this);
        }delete c.finish;
      });
    } }), n.each(["toggle", "show", "hide"], function (a, b) {
    var c = n.fn[b];n.fn[b] = function (a, d, e) {
      return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(Xa(b, !0), a, d, e);
    };
  }), n.each({ slideDown: Xa("show"), slideUp: Xa("hide"), slideToggle: Xa("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (a, b) {
    n.fn[a] = function (a, c, d) {
      return this.animate(b, a, c, d);
    };
  }), n.timers = [], n.fx.tick = function () {
    var a,
        b = 0,
        c = n.timers;for (Sa = n.now(); b < c.length; b++) {
      a = c[b], a() || c[b] !== a || c.splice(b--, 1);
    }c.length || n.fx.stop(), Sa = void 0;
  }, n.fx.timer = function (a) {
    n.timers.push(a), a() ? n.fx.start() : n.timers.pop();
  }, n.fx.interval = 13, n.fx.start = function () {
    Ta || (Ta = a.setInterval(n.fx.tick, n.fx.interval));
  }, n.fx.stop = function () {
    a.clearInterval(Ta), Ta = null;
  }, n.fx.speeds = { slow: 600, fast: 200, _default: 400 }, n.fn.delay = function (b, c) {
    return b = n.fx ? n.fx.speeds[b] || b : b, c = c || "fx", this.queue(c, function (c, d) {
      var e = a.setTimeout(c, b);d.stop = function () {
        a.clearTimeout(e);
      };
    });
  }, function () {
    var a = d.createElement("input"),
        b = d.createElement("select"),
        c = b.appendChild(d.createElement("option"));a.type = "checkbox", l.checkOn = "" !== a.value, l.optSelected = c.selected, b.disabled = !0, l.optDisabled = !c.disabled, a = d.createElement("input"), a.value = "t", a.type = "radio", l.radioValue = "t" === a.value;
  }();var ab,
      bb = n.expr.attrHandle;n.fn.extend({ attr: function attr(a, b) {
      return K(this, n.attr, a, b, arguments.length > 1);
    }, removeAttr: function removeAttr(a) {
      return this.each(function () {
        n.removeAttr(this, a);
      });
    } }), n.extend({ attr: function attr(a, b, c) {
      var d,
          e,
          f = a.nodeType;if (3 !== f && 8 !== f && 2 !== f) return "undefined" == typeof a.getAttribute ? n.prop(a, b, c) : (1 === f && n.isXMLDoc(a) || (b = b.toLowerCase(), e = n.attrHooks[b] || (n.expr.match.bool.test(b) ? ab : void 0)), void 0 !== c ? null === c ? void n.removeAttr(a, b) : e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : (a.setAttribute(b, c + ""), c) : e && "get" in e && null !== (d = e.get(a, b)) ? d : (d = n.find.attr(a, b), null == d ? void 0 : d));
    }, attrHooks: { type: { set: function set(a, b) {
          if (!l.radioValue && "radio" === b && n.nodeName(a, "input")) {
            var c = a.value;return a.setAttribute("type", b), c && (a.value = c), b;
          }
        } } }, removeAttr: function removeAttr(a, b) {
      var c,
          d,
          e = 0,
          f = b && b.match(G);if (f && 1 === a.nodeType) while (c = f[e++]) {
        d = n.propFix[c] || c, n.expr.match.bool.test(c) && (a[d] = !1), a.removeAttribute(c);
      }
    } }), ab = { set: function set(a, b, c) {
      return b === !1 ? n.removeAttr(a, c) : a.setAttribute(c, c), c;
    } }, n.each(n.expr.match.bool.source.match(/\w+/g), function (a, b) {
    var c = bb[b] || n.find.attr;bb[b] = function (a, b, d) {
      var e, f;return d || (f = bb[b], bb[b] = e, e = null != c(a, b, d) ? b.toLowerCase() : null, bb[b] = f), e;
    };
  });var cb = /^(?:input|select|textarea|button)$/i,
      db = /^(?:a|area)$/i;n.fn.extend({ prop: function prop(a, b) {
      return K(this, n.prop, a, b, arguments.length > 1);
    }, removeProp: function removeProp(a) {
      return this.each(function () {
        delete this[n.propFix[a] || a];
      });
    } }), n.extend({ prop: function prop(a, b, c) {
      var d,
          e,
          f = a.nodeType;if (3 !== f && 8 !== f && 2 !== f) return 1 === f && n.isXMLDoc(a) || (b = n.propFix[b] || b, e = n.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b];
    }, propHooks: { tabIndex: { get: function get(a) {
          var b = n.find.attr(a, "tabindex");return b ? parseInt(b, 10) : cb.test(a.nodeName) || db.test(a.nodeName) && a.href ? 0 : -1;
        } } }, propFix: { "for": "htmlFor", "class": "className" } }), l.optSelected || (n.propHooks.selected = { get: function get(a) {
      var b = a.parentNode;return b && b.parentNode && b.parentNode.selectedIndex, null;
    }, set: function set(a) {
      var b = a.parentNode;b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex);
    } }), n.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    n.propFix[this.toLowerCase()] = this;
  });var eb = /[\t\r\n\f]/g;function fb(a) {
    return a.getAttribute && a.getAttribute("class") || "";
  }n.fn.extend({ addClass: function addClass(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i = 0;if (n.isFunction(a)) return this.each(function (b) {
        n(this).addClass(a.call(this, b, fb(this)));
      });if ("string" == typeof a && a) {
        b = a.match(G) || [];while (c = this[i++]) {
          if (e = fb(c), d = 1 === c.nodeType && (" " + e + " ").replace(eb, " ")) {
            g = 0;while (f = b[g++]) {
              d.indexOf(" " + f + " ") < 0 && (d += f + " ");
            }h = n.trim(d), e !== h && c.setAttribute("class", h);
          }
        }
      }return this;
    }, removeClass: function removeClass(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i = 0;if (n.isFunction(a)) return this.each(function (b) {
        n(this).removeClass(a.call(this, b, fb(this)));
      });if (!arguments.length) return this.attr("class", "");if ("string" == typeof a && a) {
        b = a.match(G) || [];while (c = this[i++]) {
          if (e = fb(c), d = 1 === c.nodeType && (" " + e + " ").replace(eb, " ")) {
            g = 0;while (f = b[g++]) {
              while (d.indexOf(" " + f + " ") > -1) {
                d = d.replace(" " + f + " ", " ");
              }
            }h = n.trim(d), e !== h && c.setAttribute("class", h);
          }
        }
      }return this;
    }, toggleClass: function toggleClass(a, b) {
      var c = typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(a);return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : n.isFunction(a) ? this.each(function (c) {
        n(this).toggleClass(a.call(this, c, fb(this), b), b);
      }) : this.each(function () {
        var b, d, e, f;if ("string" === c) {
          d = 0, e = n(this), f = a.match(G) || [];while (b = f[d++]) {
            e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
          }
        } else void 0 !== a && "boolean" !== c || (b = fb(this), b && N.set(this, "__className__", b), this.setAttribute && this.setAttribute("class", b || a === !1 ? "" : N.get(this, "__className__") || ""));
      });
    }, hasClass: function hasClass(a) {
      var b,
          c,
          d = 0;b = " " + a + " ";while (c = this[d++]) {
        if (1 === c.nodeType && (" " + fb(c) + " ").replace(eb, " ").indexOf(b) > -1) return !0;
      }return !1;
    } });var gb = /\r/g,
      hb = /[\x20\t\r\n\f]+/g;n.fn.extend({ val: function val(a) {
      var b,
          c,
          d,
          e = this[0];{
        if (arguments.length) return d = n.isFunction(a), this.each(function (c) {
          var e;1 === this.nodeType && (e = d ? a.call(this, c, n(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : n.isArray(e) && (e = n.map(e, function (a) {
            return null == a ? "" : a + "";
          })), b = n.valHooks[this.type] || n.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e));
        });if (e) return b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(gb, "") : null == c ? "" : c);
      }
    } }), n.extend({ valHooks: { option: { get: function get(a) {
          var b = n.find.attr(a, "value");return null != b ? b : n.trim(n.text(a)).replace(hb, " ");
        } }, select: { get: function get(a) {
          for (var b, c, d = a.options, e = a.selectedIndex, f = "select-one" === a.type || 0 > e, g = f ? null : [], h = f ? e + 1 : d.length, i = 0 > e ? h : f ? e : 0; h > i; i++) {
            if (c = d[i], (c.selected || i === e) && (l.optDisabled ? !c.disabled : null === c.getAttribute("disabled")) && (!c.parentNode.disabled || !n.nodeName(c.parentNode, "optgroup"))) {
              if (b = n(c).val(), f) return b;g.push(b);
            }
          }return g;
        }, set: function set(a, b) {
          var c,
              d,
              e = a.options,
              f = n.makeArray(b),
              g = e.length;while (g--) {
            d = e[g], (d.selected = n.inArray(n.valHooks.option.get(d), f) > -1) && (c = !0);
          }return c || (a.selectedIndex = -1), f;
        } } } }), n.each(["radio", "checkbox"], function () {
    n.valHooks[this] = { set: function set(a, b) {
        return n.isArray(b) ? a.checked = n.inArray(n(a).val(), b) > -1 : void 0;
      } }, l.checkOn || (n.valHooks[this].get = function (a) {
      return null === a.getAttribute("value") ? "on" : a.value;
    });
  });var ib = /^(?:focusinfocus|focusoutblur)$/;n.extend(n.event, { trigger: function trigger(b, c, e, f) {
      var g,
          h,
          i,
          j,
          l,
          m,
          o,
          p = [e || d],
          q = k.call(b, "type") ? b.type : b,
          r = k.call(b, "namespace") ? b.namespace.split(".") : [];if (h = i = e = e || d, 3 !== e.nodeType && 8 !== e.nodeType && !ib.test(q + n.event.triggered) && (q.indexOf(".") > -1 && (r = q.split("."), q = r.shift(), r.sort()), l = q.indexOf(":") < 0 && "on" + q, b = b[n.expando] ? b : new n.Event(q, "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(b)) && b), b.isTrigger = f ? 2 : 3, b.namespace = r.join("."), b.rnamespace = b.namespace ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = e), c = null == c ? [b] : n.makeArray(c, [b]), o = n.event.special[q] || {}, f || !o.trigger || o.trigger.apply(e, c) !== !1)) {
        if (!f && !o.noBubble && !n.isWindow(e)) {
          for (j = o.delegateType || q, ib.test(j + q) || (h = h.parentNode); h; h = h.parentNode) {
            p.push(h), i = h;
          }i === (e.ownerDocument || d) && p.push(i.defaultView || i.parentWindow || a);
        }g = 0;while ((h = p[g++]) && !b.isPropagationStopped()) {
          b.type = g > 1 ? j : o.bindType || q, m = (N.get(h, "events") || {})[b.type] && N.get(h, "handle"), m && m.apply(h, c), m = l && h[l], m && m.apply && L(h) && (b.result = m.apply(h, c), b.result === !1 && b.preventDefault());
        }return b.type = q, f || b.isDefaultPrevented() || o._default && o._default.apply(p.pop(), c) !== !1 || !L(e) || l && n.isFunction(e[q]) && !n.isWindow(e) && (i = e[l], i && (e[l] = null), n.event.triggered = q, e[q](), n.event.triggered = void 0, i && (e[l] = i)), b.result;
      }
    }, simulate: function simulate(a, b, c) {
      var d = n.extend(new n.Event(), c, { type: a, isSimulated: !0 });n.event.trigger(d, null, b), d.isDefaultPrevented() && c.preventDefault();
    } }), n.fn.extend({ trigger: function trigger(a, b) {
      return this.each(function () {
        n.event.trigger(a, b, this);
      });
    }, triggerHandler: function triggerHandler(a, b) {
      var c = this[0];return c ? n.event.trigger(a, b, c, !0) : void 0;
    } }), n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (a, b) {
    n.fn[b] = function (a, c) {
      return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b);
    };
  }), n.fn.extend({ hover: function hover(a, b) {
      return this.mouseenter(a).mouseleave(b || a);
    } }), l.focusin = "onfocusin" in a, l.focusin || n.each({ focus: "focusin", blur: "focusout" }, function (a, b) {
    var c = function c(a) {
      n.event.simulate(b, a.target, n.event.fix(a));
    };n.event.special[b] = { setup: function setup() {
        var d = this.ownerDocument || this,
            e = N.access(d, b);e || d.addEventListener(a, c, !0), N.access(d, b, (e || 0) + 1);
      }, teardown: function teardown() {
        var d = this.ownerDocument || this,
            e = N.access(d, b) - 1;e ? N.access(d, b, e) : (d.removeEventListener(a, c, !0), N.remove(d, b));
      } };
  });var jb = a.location,
      kb = n.now(),
      lb = /\?/;n.parseJSON = function (a) {
    return JSON.parse(a + "");
  }, n.parseXML = function (b) {
    var c;if (!b || "string" != typeof b) return null;try {
      c = new a.DOMParser().parseFromString(b, "text/xml");
    } catch (d) {
      c = void 0;
    }return c && !c.getElementsByTagName("parsererror").length || n.error("Invalid XML: " + b), c;
  };var mb = /#.*$/,
      nb = /([?&])_=[^&]*/,
      ob = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      pb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      qb = /^(?:GET|HEAD)$/,
      rb = /^\/\//,
      sb = {},
      tb = {},
      ub = "*/".concat("*"),
      vb = d.createElement("a");vb.href = jb.href;function wb(a) {
    return function (b, c) {
      "string" != typeof b && (c = b, b = "*");var d,
          e = 0,
          f = b.toLowerCase().match(G) || [];if (n.isFunction(c)) while (d = f[e++]) {
        "+" === d[0] ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c);
      }
    };
  }function xb(a, b, c, d) {
    var e = {},
        f = a === tb;function g(h) {
      var i;return e[h] = !0, n.each(a[h] || [], function (a, h) {
        var j = h(b, c, d);return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j), g(j), !1);
      }), i;
    }return g(b.dataTypes[0]) || !e["*"] && g("*");
  }function yb(a, b) {
    var c,
        d,
        e = n.ajaxSettings.flatOptions || {};for (c in b) {
      void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
    }return d && n.extend(!0, a, d), a;
  }function zb(a, b, c) {
    var d,
        e,
        f,
        g,
        h = a.contents,
        i = a.dataTypes;while ("*" === i[0]) {
      i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
    }if (d) for (e in h) {
      if (h[e] && h[e].test(d)) {
        i.unshift(e);break;
      }
    }if (i[0] in c) f = i[0];else {
      for (e in c) {
        if (!i[0] || a.converters[e + " " + i[0]]) {
          f = e;break;
        }g || (g = e);
      }f = f || g;
    }return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0;
  }function Ab(a, b, c, d) {
    var e,
        f,
        g,
        h,
        i,
        j = {},
        k = a.dataTypes.slice();if (k[1]) for (g in a.converters) {
      j[g.toLowerCase()] = a.converters[g];
    }f = k.shift();while (f) {
      if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift()) if ("*" === f) f = i;else if ("*" !== i && i !== f) {
        if (g = j[i + " " + f] || j["* " + f], !g) for (e in j) {
          if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
            g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1]));break;
          }
        }if (g !== !0) if (g && a["throws"]) b = g(b);else try {
          b = g(b);
        } catch (l) {
          return { state: "parsererror", error: g ? l : "No conversion from " + i + " to " + f };
        }
      }
    }return { state: "success", data: b };
  }n.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: jb.href, type: "GET", isLocal: pb.test(jb.protocol), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": ub, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": n.parseJSON, "text xml": n.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function ajaxSetup(a, b) {
      return b ? yb(yb(a, n.ajaxSettings), b) : yb(n.ajaxSettings, a);
    }, ajaxPrefilter: wb(sb), ajaxTransport: wb(tb), ajax: function ajax(b, c) {
      "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(b)) && (c = b, b = void 0), c = c || {};var e,
          f,
          g,
          h,
          i,
          j,
          k,
          l,
          m = n.ajaxSetup({}, c),
          o = m.context || m,
          p = m.context && (o.nodeType || o.jquery) ? n(o) : n.event,
          q = n.Deferred(),
          r = n.Callbacks("once memory"),
          s = m.statusCode || {},
          t = {},
          u = {},
          v = 0,
          w = "canceled",
          x = { readyState: 0, getResponseHeader: function getResponseHeader(a) {
          var b;if (2 === v) {
            if (!h) {
              h = {};while (b = ob.exec(g)) {
                h[b[1].toLowerCase()] = b[2];
              }
            }b = h[a.toLowerCase()];
          }return null == b ? null : b;
        }, getAllResponseHeaders: function getAllResponseHeaders() {
          return 2 === v ? g : null;
        }, setRequestHeader: function setRequestHeader(a, b) {
          var c = a.toLowerCase();return v || (a = u[c] = u[c] || a, t[a] = b), this;
        }, overrideMimeType: function overrideMimeType(a) {
          return v || (m.mimeType = a), this;
        }, statusCode: function statusCode(a) {
          var b;if (a) if (2 > v) for (b in a) {
            s[b] = [s[b], a[b]];
          } else x.always(a[x.status]);return this;
        }, abort: function abort(a) {
          var b = a || w;return e && e.abort(b), z(0, b), this;
        } };if (q.promise(x).complete = r.add, x.success = x.done, x.error = x.fail, m.url = ((b || m.url || jb.href) + "").replace(mb, "").replace(rb, jb.protocol + "//"), m.type = c.method || c.type || m.method || m.type, m.dataTypes = n.trim(m.dataType || "*").toLowerCase().match(G) || [""], null == m.crossDomain) {
        j = d.createElement("a");try {
          j.href = m.url, j.href = j.href, m.crossDomain = vb.protocol + "//" + vb.host != j.protocol + "//" + j.host;
        } catch (y) {
          m.crossDomain = !0;
        }
      }if (m.data && m.processData && "string" != typeof m.data && (m.data = n.param(m.data, m.traditional)), xb(sb, m, c, x), 2 === v) return x;k = n.event && m.global, k && 0 === n.active++ && n.event.trigger("ajaxStart"), m.type = m.type.toUpperCase(), m.hasContent = !qb.test(m.type), f = m.url, m.hasContent || (m.data && (f = m.url += (lb.test(f) ? "&" : "?") + m.data, delete m.data), m.cache === !1 && (m.url = nb.test(f) ? f.replace(nb, "$1_=" + kb++) : f + (lb.test(f) ? "&" : "?") + "_=" + kb++)), m.ifModified && (n.lastModified[f] && x.setRequestHeader("If-Modified-Since", n.lastModified[f]), n.etag[f] && x.setRequestHeader("If-None-Match", n.etag[f])), (m.data && m.hasContent && m.contentType !== !1 || c.contentType) && x.setRequestHeader("Content-Type", m.contentType), x.setRequestHeader("Accept", m.dataTypes[0] && m.accepts[m.dataTypes[0]] ? m.accepts[m.dataTypes[0]] + ("*" !== m.dataTypes[0] ? ", " + ub + "; q=0.01" : "") : m.accepts["*"]);for (l in m.headers) {
        x.setRequestHeader(l, m.headers[l]);
      }if (m.beforeSend && (m.beforeSend.call(o, x, m) === !1 || 2 === v)) return x.abort();w = "abort";for (l in { success: 1, error: 1, complete: 1 }) {
        x[l](m[l]);
      }if (e = xb(tb, m, c, x)) {
        if (x.readyState = 1, k && p.trigger("ajaxSend", [x, m]), 2 === v) return x;m.async && m.timeout > 0 && (i = a.setTimeout(function () {
          x.abort("timeout");
        }, m.timeout));try {
          v = 1, e.send(t, z);
        } catch (y) {
          if (!(2 > v)) throw y;z(-1, y);
        }
      } else z(-1, "No Transport");function z(b, c, d, h) {
        var j,
            l,
            t,
            u,
            w,
            y = c;2 !== v && (v = 2, i && a.clearTimeout(i), e = void 0, g = h || "", x.readyState = b > 0 ? 4 : 0, j = b >= 200 && 300 > b || 304 === b, d && (u = zb(m, x, d)), u = Ab(m, u, x, j), j ? (m.ifModified && (w = x.getResponseHeader("Last-Modified"), w && (n.lastModified[f] = w), w = x.getResponseHeader("etag"), w && (n.etag[f] = w)), 204 === b || "HEAD" === m.type ? y = "nocontent" : 304 === b ? y = "notmodified" : (y = u.state, l = u.data, t = u.error, j = !t)) : (t = y, !b && y || (y = "error", 0 > b && (b = 0))), x.status = b, x.statusText = (c || y) + "", j ? q.resolveWith(o, [l, y, x]) : q.rejectWith(o, [x, y, t]), x.statusCode(s), s = void 0, k && p.trigger(j ? "ajaxSuccess" : "ajaxError", [x, m, j ? l : t]), r.fireWith(o, [x, y]), k && (p.trigger("ajaxComplete", [x, m]), --n.active || n.event.trigger("ajaxStop")));
      }return x;
    }, getJSON: function getJSON(a, b, c) {
      return n.get(a, b, c, "json");
    }, getScript: function getScript(a, b) {
      return n.get(a, void 0, b, "script");
    } }), n.each(["get", "post"], function (a, b) {
    n[b] = function (a, c, d, e) {
      return n.isFunction(c) && (e = e || d, d = c, c = void 0), n.ajax(n.extend({ url: a, type: b, dataType: e, data: c, success: d }, n.isPlainObject(a) && a));
    };
  }), n._evalUrl = function (a) {
    return n.ajax({ url: a, type: "GET", dataType: "script", async: !1, global: !1, "throws": !0 });
  }, n.fn.extend({ wrapAll: function wrapAll(a) {
      var b;return n.isFunction(a) ? this.each(function (b) {
        n(this).wrapAll(a.call(this, b));
      }) : (this[0] && (b = n(a, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && b.insertBefore(this[0]), b.map(function () {
        var a = this;while (a.firstElementChild) {
          a = a.firstElementChild;
        }return a;
      }).append(this)), this);
    }, wrapInner: function wrapInner(a) {
      return n.isFunction(a) ? this.each(function (b) {
        n(this).wrapInner(a.call(this, b));
      }) : this.each(function () {
        var b = n(this),
            c = b.contents();c.length ? c.wrapAll(a) : b.append(a);
      });
    }, wrap: function wrap(a) {
      var b = n.isFunction(a);return this.each(function (c) {
        n(this).wrapAll(b ? a.call(this, c) : a);
      });
    }, unwrap: function unwrap() {
      return this.parent().each(function () {
        n.nodeName(this, "body") || n(this).replaceWith(this.childNodes);
      }).end();
    } }), n.expr.filters.hidden = function (a) {
    return !n.expr.filters.visible(a);
  }, n.expr.filters.visible = function (a) {
    return a.offsetWidth > 0 || a.offsetHeight > 0 || a.getClientRects().length > 0;
  };var Bb = /%20/g,
      Cb = /\[\]$/,
      Db = /\r?\n/g,
      Eb = /^(?:submit|button|image|reset|file)$/i,
      Fb = /^(?:input|select|textarea|keygen)/i;function Gb(a, b, c, d) {
    var e;if (n.isArray(b)) n.each(b, function (b, e) {
      c || Cb.test(a) ? d(a, e) : Gb(a + "[" + ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(e)) && null != e ? b : "") + "]", e, c, d);
    });else if (c || "object" !== n.type(b)) d(a, b);else for (e in b) {
      Gb(a + "[" + e + "]", b[e], c, d);
    }
  }n.param = function (a, b) {
    var c,
        d = [],
        e = function e(a, b) {
      b = n.isFunction(b) ? b() : null == b ? "" : b, d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b);
    };if (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional), n.isArray(a) || a.jquery && !n.isPlainObject(a)) n.each(a, function () {
      e(this.name, this.value);
    });else for (c in a) {
      Gb(c, a[c], b, e);
    }return d.join("&").replace(Bb, "+");
  }, n.fn.extend({ serialize: function serialize() {
      return n.param(this.serializeArray());
    }, serializeArray: function serializeArray() {
      return this.map(function () {
        var a = n.prop(this, "elements");return a ? n.makeArray(a) : this;
      }).filter(function () {
        var a = this.type;return this.name && !n(this).is(":disabled") && Fb.test(this.nodeName) && !Eb.test(a) && (this.checked || !X.test(a));
      }).map(function (a, b) {
        var c = n(this).val();return null == c ? null : n.isArray(c) ? n.map(c, function (a) {
          return { name: b.name, value: a.replace(Db, "\r\n") };
        }) : { name: b.name, value: c.replace(Db, "\r\n") };
      }).get();
    } }), n.ajaxSettings.xhr = function () {
    try {
      return new a.XMLHttpRequest();
    } catch (b) {}
  };var Hb = { 0: 200, 1223: 204 },
      Ib = n.ajaxSettings.xhr();l.cors = !!Ib && "withCredentials" in Ib, l.ajax = Ib = !!Ib, n.ajaxTransport(function (b) {
    var _c, d;return l.cors || Ib && !b.crossDomain ? { send: function send(e, f) {
        var g,
            h = b.xhr();if (h.open(b.type, b.url, b.async, b.username, b.password), b.xhrFields) for (g in b.xhrFields) {
          h[g] = b.xhrFields[g];
        }b.mimeType && h.overrideMimeType && h.overrideMimeType(b.mimeType), b.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest");for (g in e) {
          h.setRequestHeader(g, e[g]);
        }_c = function c(a) {
          return function () {
            _c && (_c = d = h.onload = h.onerror = h.onabort = h.onreadystatechange = null, "abort" === a ? h.abort() : "error" === a ? "number" != typeof h.status ? f(0, "error") : f(h.status, h.statusText) : f(Hb[h.status] || h.status, h.statusText, "text" !== (h.responseType || "text") || "string" != typeof h.responseText ? { binary: h.response } : { text: h.responseText }, h.getAllResponseHeaders()));
          };
        }, h.onload = _c(), d = h.onerror = _c("error"), void 0 !== h.onabort ? h.onabort = d : h.onreadystatechange = function () {
          4 === h.readyState && a.setTimeout(function () {
            _c && d();
          });
        }, _c = _c("abort");try {
          h.send(b.hasContent && b.data || null);
        } catch (i) {
          if (_c) throw i;
        }
      }, abort: function abort() {
        _c && _c();
      } } : void 0;
  }), n.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /\b(?:java|ecma)script\b/ }, converters: { "text script": function textScript(a) {
        return n.globalEval(a), a;
      } } }), n.ajaxPrefilter("script", function (a) {
    void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET");
  }), n.ajaxTransport("script", function (a) {
    if (a.crossDomain) {
      var b, _c2;return { send: function send(e, f) {
          b = n("<script>").prop({ charset: a.scriptCharset, src: a.url }).on("load error", _c2 = function c(a) {
            b.remove(), _c2 = null, a && f("error" === a.type ? 404 : 200, a.type);
          }), d.head.appendChild(b[0]);
        }, abort: function abort() {
          _c2 && _c2();
        } };
    }
  });var Jb = [],
      Kb = /(=)\?(?=&|$)|\?\?/;n.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
      var a = Jb.pop() || n.expando + "_" + kb++;return this[a] = !0, a;
    } }), n.ajaxPrefilter("json jsonp", function (b, c, d) {
    var e,
        f,
        g,
        h = b.jsonp !== !1 && (Kb.test(b.url) ? "url" : "string" == typeof b.data && 0 === (b.contentType || "").indexOf("application/x-www-form-urlencoded") && Kb.test(b.data) && "data");return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = n.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(Kb, "$1" + e) : b.jsonp !== !1 && (b.url += (lb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function () {
      return g || n.error(e + " was not called"), g[0];
    }, b.dataTypes[0] = "json", f = a[e], a[e] = function () {
      g = arguments;
    }, d.always(function () {
      void 0 === f ? n(a).removeProp(e) : a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, Jb.push(e)), g && n.isFunction(f) && f(g[0]), g = f = void 0;
    }), "script") : void 0;
  }), n.parseHTML = function (a, b, c) {
    if (!a || "string" != typeof a) return null;"boolean" == typeof b && (c = b, b = !1), b = b || d;var e = x.exec(a),
        f = !c && [];return e ? [b.createElement(e[1])] : (e = ca([a], b, f), f && f.length && n(f).remove(), n.merge([], e.childNodes));
  };var Lb = n.fn.load;n.fn.load = function (a, b, c) {
    if ("string" != typeof a && Lb) return Lb.apply(this, arguments);var d,
        e,
        f,
        g = this,
        h = a.indexOf(" ");return h > -1 && (d = n.trim(a.slice(h)), a = a.slice(0, h)), n.isFunction(b) ? (c = b, b = void 0) : b && "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(b)) && (e = "POST"), g.length > 0 && n.ajax({ url: a, type: e || "GET", dataType: "html", data: b }).done(function (a) {
      f = arguments, g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a);
    }).always(c && function (a, b) {
      g.each(function () {
        c.apply(this, f || [a.responseText, b, a]);
      });
    }), this;
  }, n.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (a, b) {
    n.fn[b] = function (a) {
      return this.on(b, a);
    };
  }), n.expr.filters.animated = function (a) {
    return n.grep(n.timers, function (b) {
      return a === b.elem;
    }).length;
  };function Mb(a) {
    return n.isWindow(a) ? a : 9 === a.nodeType && a.defaultView;
  }n.offset = { setOffset: function setOffset(a, b, c) {
      var d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = n.css(a, "position"),
          l = n(a),
          m = {};"static" === k && (a.style.position = "relative"), h = l.offset(), f = n.css(a, "top"), i = n.css(a, "left"), j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), n.isFunction(b) && (b = b.call(a, c, n.extend({}, h))), null != b.top && (m.top = b.top - h.top + g), null != b.left && (m.left = b.left - h.left + e), "using" in b ? b.using.call(a, m) : l.css(m);
    } }, n.fn.extend({ offset: function offset(a) {
      if (arguments.length) return void 0 === a ? this : this.each(function (b) {
        n.offset.setOffset(this, a, b);
      });var b,
          c,
          d = this[0],
          e = { top: 0, left: 0 },
          f = d && d.ownerDocument;if (f) return b = f.documentElement, n.contains(b, d) ? (e = d.getBoundingClientRect(), c = Mb(f), { top: e.top + c.pageYOffset - b.clientTop, left: e.left + c.pageXOffset - b.clientLeft }) : e;
    }, position: function position() {
      if (this[0]) {
        var a,
            b,
            c = this[0],
            d = { top: 0, left: 0 };return "fixed" === n.css(c, "position") ? b = c.getBoundingClientRect() : (a = this.offsetParent(), b = this.offset(), n.nodeName(a[0], "html") || (d = a.offset()), d.top += n.css(a[0], "borderTopWidth", !0), d.left += n.css(a[0], "borderLeftWidth", !0)), { top: b.top - d.top - n.css(c, "marginTop", !0), left: b.left - d.left - n.css(c, "marginLeft", !0) };
      }
    }, offsetParent: function offsetParent() {
      return this.map(function () {
        var a = this.offsetParent;while (a && "static" === n.css(a, "position")) {
          a = a.offsetParent;
        }return a || Ea;
      });
    } }), n.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (a, b) {
    var c = "pageYOffset" === b;n.fn[a] = function (d) {
      return K(this, function (a, d, e) {
        var f = Mb(a);return void 0 === e ? f ? f[b] : a[d] : void (f ? f.scrollTo(c ? f.pageXOffset : e, c ? e : f.pageYOffset) : a[d] = e);
      }, a, d, arguments.length);
    };
  }), n.each(["top", "left"], function (a, b) {
    n.cssHooks[b] = Ga(l.pixelPosition, function (a, c) {
      return c ? (c = Fa(a, b), Ba.test(c) ? n(a).position()[b] + "px" : c) : void 0;
    });
  }), n.each({ Height: "height", Width: "width" }, function (a, b) {
    n.each({ padding: "inner" + a, content: b, "": "outer" + a }, function (c, d) {
      n.fn[d] = function (d, e) {
        var f = arguments.length && (c || "boolean" != typeof d),
            g = c || (d === !0 || e === !0 ? "margin" : "border");return K(this, function (b, c, d) {
          var e;return n.isWindow(b) ? b.document.documentElement["client" + a] : 9 === b.nodeType ? (e = b.documentElement, Math.max(b.body["scroll" + a], e["scroll" + a], b.body["offset" + a], e["offset" + a], e["client" + a])) : void 0 === d ? n.css(b, c, g) : n.style(b, c, d, g);
        }, b, f ? d : void 0, f, null);
      };
    });
  }), n.fn.extend({ bind: function bind(a, b, c) {
      return this.on(a, null, b, c);
    }, unbind: function unbind(a, b) {
      return this.off(a, null, b);
    }, delegate: function delegate(a, b, c, d) {
      return this.on(b, a, c, d);
    }, undelegate: function undelegate(a, b, c) {
      return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c);
    }, size: function size() {
      return this.length;
    } }), n.fn.andSelf = n.fn.addBack, "function" == typeof define && __webpack_require__("nErl") && define("jquery", [], function () {
    return n;
  });var Nb = a.jQuery,
      Ob = a.$;return n.noConflict = function (b) {
    return a.$ === n && (a.$ = Ob), b && a.jQuery === n && (a.jQuery = Nb), n;
  }, b || (a.jQuery = a.$ = n), n;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "oE0z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/ArialBlack.cd5be9b.ttf";

/***/ }),

/***/ "pJng":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pnX2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qqWH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "rZTe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy1jb3B5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTEzLjU0MTc2MjEsNy44MTE5MTM5OCBMMTEuOTE4NjQzMiw4Ljk5ODQ0NzI3IEMxMS4zMDkwMzA4LDkuNDQ2NzkwNDcgMTAuMzA5MjM4OSwxMC4xNzcwOTk1IDkuNjk4OTQwNzUsMTAuNjIxOTQgTDguMDc1ODIxOTMsMTEuODA5MzQ5IEM3LjQ2NDgzODAzLDEyLjI1NTk0MDggNi45NjYzMTM1NywxMS44OTA3ODYzIDYuOTY2MzEzNTcsMTAuOTk3NjAyNiBMNi45NjYzMTM1Nyw5LjUwODk2MzA2IEwwLjI3MDE3NjkyLDkuNTA4OTYzMDYgQzAuMTIxMzczODksOS41MDg5NjMwNiAtMS45ODExMjAyNWUtMDgsOS4zNTc0NzIxIC0xLjk4MTEyMDI1ZS0wOCw5LjE2NzQ1MTY0IEwtMS45ODExMjAyNWUtMDgsNC44MzIwMDc4OCBDLTEuOTgxMTIwMjVlLTA4LDQuNjQzNzM4NzYgMC4xMjEzNzM4OSw0LjQ5MDQ5NjQ2IDAuMjcwMTc2OTIsNC40OTA0OTY0NiBMNi45NjYzMTM1Nyw0LjQ5MDQ5NjQ2IEw2Ljk2NjMxMzU3LDMuMDAxODU2OTIgQzYuOTY2MzEzNTcsMi4xMDk1NDg4NSA3LjQ2NDgzODAzLDEuNzQ0Mzk0MzMgOC4wNzU4MjE5MywyLjE5MDExMDUzIEw5LjY5ODk0MDc1LDMuMzc3NTE5NDggQzEwLjMwOTIzODksMy44MjQxMTEzNCAxMS4zMDkwMzA4LDQuNTU0NDIwMzkgMTEuOTE4NjQzMiw1LjAwMDEzNjU4IEwxMy41NDE3NjIxLDYuMTg4NDIxMjEgQzE0LjE1Mjc0Niw2LjYzNTAxMzA3IDE0LjE1Mjc0Niw3LjM2NTMyMjExIDEzLjU0MTc2MjEsNy44MTE5MTM5OCBaIiBpZD0iYXJyb3ctY29weSIgZmlsbD0iIzI3RkU2MyIgZmlsbC1ydWxlPSJub256ZXJvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjAwMDAwMCwgNy4wMDAwMDApIHJvdGF0ZSgtOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTcuMDAwMDAwLCAtNy4wMDAwMDApICI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "ra3e":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTTUxNy42ODg4ODkgNzk2LjQ0NDQ0NGMtNDUuNTExMTExIDAtODUuMzMzMzMzLTE3LjA2NjY2Ny0xMTkuNDY2NjY3LTUxLjJMNzMuOTU1NTU2IDM4MS4xNTU1NTZjLTIyLjc1NTU1Ni0yMi43NTU1NTYtMTcuMDY2NjY3LTU2Ljg4ODg4OSA1LjY4ODg4OC03OS42NDQ0NDUgMjIuNzU1NTU2LTIyLjc1NTU1NiA1Ni44ODg4ODktMTcuMDY2NjY3IDc5LjY0NDQ0NSA1LjY4ODg4OWwzMjkuOTU1NTU1IDM2NC4wODg4ODljNS42ODg4ODkgNS42ODg4ODkgMTcuMDY2NjY3IDExLjM3Nzc3OCAyOC40NDQ0NDUgMTEuMzc3Nzc4czIyLjc1NTU1Ni01LjY4ODg4OSAzNC4xMzMzMzMtMTcuMDY2NjY3bDMxMi44ODg4ODktMzY0LjA4ODg4OWMyMi43NTU1NTYtMjIuNzU1NTU2IDU2Ljg4ODg4OS0yOC40NDQ0NDQgNzkuNjQ0NDQ1LTUuNjg4ODg5IDIyLjc1NTU1NiAyMi43NTU1NTYgMjguNDQ0NDQ0IDU2Ljg4ODg4OSA1LjY4ODg4OCA3OS42NDQ0NDVMNjM3LjE1NTU1NiA3MzkuNTU1NTU2Yy0yOC40NDQ0NDQgMzkuODIyMjIyLTY4LjI2NjY2NyA1Ni44ODg4ODktMTE5LjQ2NjY2NyA1Ni44ODg4ODggNS42ODg4ODkgMCAwIDAgMCAweiIgLz48L3N2Zz4="

/***/ }),

/***/ "s8XF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "sEqb":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v3.3.6 (http://getbootstrap.com)\n * Copyright 2011-2015 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\nhtml {\n  font-family: sans-serif;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n[hidden],\ntemplate {\n  display: none;\n}\na {\n  background-color: transparent;\n}\na:active,\na:hover {\n  outline: 0;\n}\nabbr[title] {\n  border-bottom: 1px dotted;\n}\nb,\nstrong {\n  font-weight: bold;\n}\ndfn {\n  font-style: italic;\n}\nh1 {\n  margin: .67em 0;\n  font-size: 2em;\n}\nmark {\n  color: #000;\n  background: #ff0;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsup {\n  top: -.5em;\n}\nsub {\n  bottom: -.25em;\n}\nimg {\n  border: 0;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\nfigure {\n  margin: 1em 40px;\n}\nhr {\n  height: 0;\n  -webkit-box-sizing: content-box;\n     -moz-box-sizing: content-box;\n          box-sizing: content-box;\n}\npre {\n  overflow: auto;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  margin: 0;\n  font: inherit;\n  color: inherit;\n}\nbutton {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\ninput {\n  line-height: normal;\n}\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\ninput[type=\"search\"] {\n  -webkit-box-sizing: content-box;\n     -moz-box-sizing: content-box;\n          box-sizing: content-box;\n  -webkit-appearance: textfield;\n}\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\nfieldset {\n  padding: .35em .625em .75em;\n  margin: 0 2px;\n  border: 1px solid #c0c0c0;\n}\nlegend {\n  padding: 0;\n  border: 0;\n}\ntextarea {\n  overflow: auto;\n}\noptgroup {\n  font-weight: bold;\n}\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\ntd,\nth {\n  padding: 0;\n}\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */\n@media print {\n  *,\n  *:before,\n  *:after {\n    color: #000 !important;\n    text-shadow: none !important;\n    background: transparent !important;\n    -webkit-box-shadow: none !important;\n            box-shadow: none !important;\n  }\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n  a[href^=\"#\"]:after,\n  a[href^=\"javascript:\"]:after {\n    content: \"\";\n  }\n  pre,\n  blockquote {\n    border: 1px solid #999;\n\n    page-break-inside: avoid;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  img {\n    max-width: 100% !important;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  .navbar {\n    display: none;\n  }\n  .btn > .caret,\n  .dropup > .btn > .caret {\n    border-top-color: #000 !important;\n  }\n  .label {\n    border: 1px solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important;\n  }\n}\n@font-face {\n  font-family: 'Glyphicons Halflings';\n\n  src: url(" + escape(__webpack_require__("x8aS")) + ");\n  src: url(" + escape(__webpack_require__("x8aS")) + "?#iefix) format('embedded-opentype'), url(" + escape(__webpack_require__("PPGu")) + ") format('woff2'), url(" + escape(__webpack_require__("jNsc")) + ") format('woff'), url(" + escape(__webpack_require__("sJTC")) + ") format('truetype'), url(" + escape(__webpack_require__("breY")) + "#glyphicons_halflingsregular) format('svg');\n}\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.glyphicon-asterisk:before {\n  content: \"*\";\n}\n.glyphicon-plus:before {\n  content: \"+\";\n}\n.glyphicon-euro:before,\n.glyphicon-eur:before {\n  content: \"\\20AC\";\n}\n.glyphicon-minus:before {\n  content: \"\\2212\";\n}\n.glyphicon-cloud:before {\n  content: \"\\2601\";\n}\n.glyphicon-envelope:before {\n  content: \"\\2709\";\n}\n.glyphicon-pencil:before {\n  content: \"\\270F\";\n}\n.glyphicon-glass:before {\n  content: \"\\E001\";\n}\n.glyphicon-music:before {\n  content: \"\\E002\";\n}\n.glyphicon-search:before {\n  content: \"\\E003\";\n}\n.glyphicon-heart:before {\n  content: \"\\E005\";\n}\n.glyphicon-star:before {\n  content: \"\\E006\";\n}\n.glyphicon-star-empty:before {\n  content: \"\\E007\";\n}\n.glyphicon-user:before {\n  content: \"\\E008\";\n}\n.glyphicon-film:before {\n  content: \"\\E009\";\n}\n.glyphicon-th-large:before {\n  content: \"\\E010\";\n}\n.glyphicon-th:before {\n  content: \"\\E011\";\n}\n.glyphicon-th-list:before {\n  content: \"\\E012\";\n}\n.glyphicon-ok:before {\n  content: \"\\E013\";\n}\n.glyphicon-remove:before {\n  content: \"\\E014\";\n}\n.glyphicon-zoom-in:before {\n  content: \"\\E015\";\n}\n.glyphicon-zoom-out:before {\n  content: \"\\E016\";\n}\n.glyphicon-off:before {\n  content: \"\\E017\";\n}\n.glyphicon-signal:before {\n  content: \"\\E018\";\n}\n.glyphicon-cog:before {\n  content: \"\\E019\";\n}\n.glyphicon-trash:before {\n  content: \"\\E020\";\n}\n.glyphicon-home:before {\n  content: \"\\E021\";\n}\n.glyphicon-file:before {\n  content: \"\\E022\";\n}\n.glyphicon-time:before {\n  content: \"\\E023\";\n}\n.glyphicon-road:before {\n  content: \"\\E024\";\n}\n.glyphicon-download-alt:before {\n  content: \"\\E025\";\n}\n.glyphicon-download:before {\n  content: \"\\E026\";\n}\n.glyphicon-upload:before {\n  content: \"\\E027\";\n}\n.glyphicon-inbox:before {\n  content: \"\\E028\";\n}\n.glyphicon-play-circle:before {\n  content: \"\\E029\";\n}\n.glyphicon-repeat:before {\n  content: \"\\E030\";\n}\n.glyphicon-refresh:before {\n  content: \"\\E031\";\n}\n.glyphicon-list-alt:before {\n  content: \"\\E032\";\n}\n.glyphicon-lock:before {\n  content: \"\\E033\";\n}\n.glyphicon-flag:before {\n  content: \"\\E034\";\n}\n.glyphicon-headphones:before {\n  content: \"\\E035\";\n}\n.glyphicon-volume-off:before {\n  content: \"\\E036\";\n}\n.glyphicon-volume-down:before {\n  content: \"\\E037\";\n}\n.glyphicon-volume-up:before {\n  content: \"\\E038\";\n}\n.glyphicon-qrcode:before {\n  content: \"\\E039\";\n}\n.glyphicon-barcode:before {\n  content: \"\\E040\";\n}\n.glyphicon-tag:before {\n  content: \"\\E041\";\n}\n.glyphicon-tags:before {\n  content: \"\\E042\";\n}\n.glyphicon-book:before {\n  content: \"\\E043\";\n}\n.glyphicon-bookmark:before {\n  content: \"\\E044\";\n}\n.glyphicon-print:before {\n  content: \"\\E045\";\n}\n.glyphicon-camera:before {\n  content: \"\\E046\";\n}\n.glyphicon-font:before {\n  content: \"\\E047\";\n}\n.glyphicon-bold:before {\n  content: \"\\E048\";\n}\n.glyphicon-italic:before {\n  content: \"\\E049\";\n}\n.glyphicon-text-height:before {\n  content: \"\\E050\";\n}\n.glyphicon-text-width:before {\n  content: \"\\E051\";\n}\n.glyphicon-align-left:before {\n  content: \"\\E052\";\n}\n.glyphicon-align-center:before {\n  content: \"\\E053\";\n}\n.glyphicon-align-right:before {\n  content: \"\\E054\";\n}\n.glyphicon-align-justify:before {\n  content: \"\\E055\";\n}\n.glyphicon-list:before {\n  content: \"\\E056\";\n}\n.glyphicon-indent-left:before {\n  content: \"\\E057\";\n}\n.glyphicon-indent-right:before {\n  content: \"\\E058\";\n}\n.glyphicon-facetime-video:before {\n  content: \"\\E059\";\n}\n.glyphicon-picture:before {\n  content: \"\\E060\";\n}\n.glyphicon-map-marker:before {\n  content: \"\\E062\";\n}\n.glyphicon-adjust:before {\n  content: \"\\E063\";\n}\n.glyphicon-tint:before {\n  content: \"\\E064\";\n}\n.glyphicon-edit:before {\n  content: \"\\E065\";\n}\n.glyphicon-share:before {\n  content: \"\\E066\";\n}\n.glyphicon-check:before {\n  content: \"\\E067\";\n}\n.glyphicon-move:before {\n  content: \"\\E068\";\n}\n.glyphicon-step-backward:before {\n  content: \"\\E069\";\n}\n.glyphicon-fast-backward:before {\n  content: \"\\E070\";\n}\n.glyphicon-backward:before {\n  content: \"\\E071\";\n}\n.glyphicon-play:before {\n  content: \"\\E072\";\n}\n.glyphicon-pause:before {\n  content: \"\\E073\";\n}\n.glyphicon-stop:before {\n  content: \"\\E074\";\n}\n.glyphicon-forward:before {\n  content: \"\\E075\";\n}\n.glyphicon-fast-forward:before {\n  content: \"\\E076\";\n}\n.glyphicon-step-forward:before {\n  content: \"\\E077\";\n}\n.glyphicon-eject:before {\n  content: \"\\E078\";\n}\n.glyphicon-chevron-left:before {\n  content: \"\\E079\";\n}\n.glyphicon-chevron-right:before {\n  content: \"\\E080\";\n}\n.glyphicon-plus-sign:before {\n  content: \"\\E081\";\n}\n.glyphicon-minus-sign:before {\n  content: \"\\E082\";\n}\n.glyphicon-remove-sign:before {\n  content: \"\\E083\";\n}\n.glyphicon-ok-sign:before {\n  content: \"\\E084\";\n}\n.glyphicon-question-sign:before {\n  content: \"\\E085\";\n}\n.glyphicon-info-sign:before {\n  content: \"\\E086\";\n}\n.glyphicon-screenshot:before {\n  content: \"\\E087\";\n}\n.glyphicon-remove-circle:before {\n  content: \"\\E088\";\n}\n.glyphicon-ok-circle:before {\n  content: \"\\E089\";\n}\n.glyphicon-ban-circle:before {\n  content: \"\\E090\";\n}\n.glyphicon-arrow-left:before {\n  content: \"\\E091\";\n}\n.glyphicon-arrow-right:before {\n  content: \"\\E092\";\n}\n.glyphicon-arrow-up:before {\n  content: \"\\E093\";\n}\n.glyphicon-arrow-down:before {\n  content: \"\\E094\";\n}\n.glyphicon-share-alt:before {\n  content: \"\\E095\";\n}\n.glyphicon-resize-full:before {\n  content: \"\\E096\";\n}\n.glyphicon-resize-small:before {\n  content: \"\\E097\";\n}\n.glyphicon-exclamation-sign:before {\n  content: \"\\E101\";\n}\n.glyphicon-gift:before {\n  content: \"\\E102\";\n}\n.glyphicon-leaf:before {\n  content: \"\\E103\";\n}\n.glyphicon-fire:before {\n  content: \"\\E104\";\n}\n.glyphicon-eye-open:before {\n  content: \"\\E105\";\n}\n.glyphicon-eye-close:before {\n  content: \"\\E106\";\n}\n.glyphicon-warning-sign:before {\n  content: \"\\E107\";\n}\n.glyphicon-plane:before {\n  content: \"\\E108\";\n}\n.glyphicon-calendar:before {\n  content: \"\\E109\";\n}\n.glyphicon-random:before {\n  content: \"\\E110\";\n}\n.glyphicon-comment:before {\n  content: \"\\E111\";\n}\n.glyphicon-magnet:before {\n  content: \"\\E112\";\n}\n.glyphicon-chevron-up:before {\n  content: \"\\E113\";\n}\n.glyphicon-chevron-down:before {\n  content: \"\\E114\";\n}\n.glyphicon-retweet:before {\n  content: \"\\E115\";\n}\n.glyphicon-shopping-cart:before {\n  content: \"\\E116\";\n}\n.glyphicon-folder-close:before {\n  content: \"\\E117\";\n}\n.glyphicon-folder-open:before {\n  content: \"\\E118\";\n}\n.glyphicon-resize-vertical:before {\n  content: \"\\E119\";\n}\n.glyphicon-resize-horizontal:before {\n  content: \"\\E120\";\n}\n.glyphicon-hdd:before {\n  content: \"\\E121\";\n}\n.glyphicon-bullhorn:before {\n  content: \"\\E122\";\n}\n.glyphicon-bell:before {\n  content: \"\\E123\";\n}\n.glyphicon-certificate:before {\n  content: \"\\E124\";\n}\n.glyphicon-thumbs-up:before {\n  content: \"\\E125\";\n}\n.glyphicon-thumbs-down:before {\n  content: \"\\E126\";\n}\n.glyphicon-hand-right:before {\n  content: \"\\E127\";\n}\n.glyphicon-hand-left:before {\n  content: \"\\E128\";\n}\n.glyphicon-hand-up:before {\n  content: \"\\E129\";\n}\n.glyphicon-hand-down:before {\n  content: \"\\E130\";\n}\n.glyphicon-circle-arrow-right:before {\n  content: \"\\E131\";\n}\n.glyphicon-circle-arrow-left:before {\n  content: \"\\E132\";\n}\n.glyphicon-circle-arrow-up:before {\n  content: \"\\E133\";\n}\n.glyphicon-circle-arrow-down:before {\n  content: \"\\E134\";\n}\n.glyphicon-globe:before {\n  content: \"\\E135\";\n}\n.glyphicon-wrench:before {\n  content: \"\\E136\";\n}\n.glyphicon-tasks:before {\n  content: \"\\E137\";\n}\n.glyphicon-filter:before {\n  content: \"\\E138\";\n}\n.glyphicon-briefcase:before {\n  content: \"\\E139\";\n}\n.glyphicon-fullscreen:before {\n  content: \"\\E140\";\n}\n.glyphicon-dashboard:before {\n  content: \"\\E141\";\n}\n.glyphicon-paperclip:before {\n  content: \"\\E142\";\n}\n.glyphicon-heart-empty:before {\n  content: \"\\E143\";\n}\n.glyphicon-link:before {\n  content: \"\\E144\";\n}\n.glyphicon-phone:before {\n  content: \"\\E145\";\n}\n.glyphicon-pushpin:before {\n  content: \"\\E146\";\n}\n.glyphicon-usd:before {\n  content: \"\\E148\";\n}\n.glyphicon-gbp:before {\n  content: \"\\E149\";\n}\n.glyphicon-sort:before {\n  content: \"\\E150\";\n}\n.glyphicon-sort-by-alphabet:before {\n  content: \"\\E151\";\n}\n.glyphicon-sort-by-alphabet-alt:before {\n  content: \"\\E152\";\n}\n.glyphicon-sort-by-order:before {\n  content: \"\\E153\";\n}\n.glyphicon-sort-by-order-alt:before {\n  content: \"\\E154\";\n}\n.glyphicon-sort-by-attributes:before {\n  content: \"\\E155\";\n}\n.glyphicon-sort-by-attributes-alt:before {\n  content: \"\\E156\";\n}\n.glyphicon-unchecked:before {\n  content: \"\\E157\";\n}\n.glyphicon-expand:before {\n  content: \"\\E158\";\n}\n.glyphicon-collapse-down:before {\n  content: \"\\E159\";\n}\n.glyphicon-collapse-up:before {\n  content: \"\\E160\";\n}\n.glyphicon-log-in:before {\n  content: \"\\E161\";\n}\n.glyphicon-flash:before {\n  content: \"\\E162\";\n}\n.glyphicon-log-out:before {\n  content: \"\\E163\";\n}\n.glyphicon-new-window:before {\n  content: \"\\E164\";\n}\n.glyphicon-record:before {\n  content: \"\\E165\";\n}\n.glyphicon-save:before {\n  content: \"\\E166\";\n}\n.glyphicon-open:before {\n  content: \"\\E167\";\n}\n.glyphicon-saved:before {\n  content: \"\\E168\";\n}\n.glyphicon-import:before {\n  content: \"\\E169\";\n}\n.glyphicon-export:before {\n  content: \"\\E170\";\n}\n.glyphicon-send:before {\n  content: \"\\E171\";\n}\n.glyphicon-floppy-disk:before {\n  content: \"\\E172\";\n}\n.glyphicon-floppy-saved:before {\n  content: \"\\E173\";\n}\n.glyphicon-floppy-remove:before {\n  content: \"\\E174\";\n}\n.glyphicon-floppy-save:before {\n  content: \"\\E175\";\n}\n.glyphicon-floppy-open:before {\n  content: \"\\E176\";\n}\n.glyphicon-credit-card:before {\n  content: \"\\E177\";\n}\n.glyphicon-transfer:before {\n  content: \"\\E178\";\n}\n.glyphicon-cutlery:before {\n  content: \"\\E179\";\n}\n.glyphicon-header:before {\n  content: \"\\E180\";\n}\n.glyphicon-compressed:before {\n  content: \"\\E181\";\n}\n.glyphicon-earphone:before {\n  content: \"\\E182\";\n}\n.glyphicon-phone-alt:before {\n  content: \"\\E183\";\n}\n.glyphicon-tower:before {\n  content: \"\\E184\";\n}\n.glyphicon-stats:before {\n  content: \"\\E185\";\n}\n.glyphicon-sd-video:before {\n  content: \"\\E186\";\n}\n.glyphicon-hd-video:before {\n  content: \"\\E187\";\n}\n.glyphicon-subtitles:before {\n  content: \"\\E188\";\n}\n.glyphicon-sound-stereo:before {\n  content: \"\\E189\";\n}\n.glyphicon-sound-dolby:before {\n  content: \"\\E190\";\n}\n.glyphicon-sound-5-1:before {\n  content: \"\\E191\";\n}\n.glyphicon-sound-6-1:before {\n  content: \"\\E192\";\n}\n.glyphicon-sound-7-1:before {\n  content: \"\\E193\";\n}\n.glyphicon-copyright-mark:before {\n  content: \"\\E194\";\n}\n.glyphicon-registration-mark:before {\n  content: \"\\E195\";\n}\n.glyphicon-cloud-download:before {\n  content: \"\\E197\";\n}\n.glyphicon-cloud-upload:before {\n  content: \"\\E198\";\n}\n.glyphicon-tree-conifer:before {\n  content: \"\\E199\";\n}\n.glyphicon-tree-deciduous:before {\n  content: \"\\E200\";\n}\n.glyphicon-cd:before {\n  content: \"\\E201\";\n}\n.glyphicon-save-file:before {\n  content: \"\\E202\";\n}\n.glyphicon-open-file:before {\n  content: \"\\E203\";\n}\n.glyphicon-level-up:before {\n  content: \"\\E204\";\n}\n.glyphicon-copy:before {\n  content: \"\\E205\";\n}\n.glyphicon-paste:before {\n  content: \"\\E206\";\n}\n.glyphicon-alert:before {\n  content: \"\\E209\";\n}\n.glyphicon-equalizer:before {\n  content: \"\\E210\";\n}\n.glyphicon-king:before {\n  content: \"\\E211\";\n}\n.glyphicon-queen:before {\n  content: \"\\E212\";\n}\n.glyphicon-pawn:before {\n  content: \"\\E213\";\n}\n.glyphicon-bishop:before {\n  content: \"\\E214\";\n}\n.glyphicon-knight:before {\n  content: \"\\E215\";\n}\n.glyphicon-baby-formula:before {\n  content: \"\\E216\";\n}\n.glyphicon-tent:before {\n  content: \"\\26FA\";\n}\n.glyphicon-blackboard:before {\n  content: \"\\E218\";\n}\n.glyphicon-bed:before {\n  content: \"\\E219\";\n}\n.glyphicon-apple:before {\n  content: \"\\F8FF\";\n}\n.glyphicon-erase:before {\n  content: \"\\E221\";\n}\n.glyphicon-hourglass:before {\n  content: \"\\231B\";\n}\n.glyphicon-lamp:before {\n  content: \"\\E223\";\n}\n.glyphicon-duplicate:before {\n  content: \"\\E224\";\n}\n.glyphicon-piggy-bank:before {\n  content: \"\\E225\";\n}\n.glyphicon-scissors:before {\n  content: \"\\E226\";\n}\n.glyphicon-bitcoin:before {\n  content: \"\\E227\";\n}\n.glyphicon-btc:before {\n  content: \"\\E227\";\n}\n.glyphicon-xbt:before {\n  content: \"\\E227\";\n}\n.glyphicon-yen:before {\n  content: \"\\A5\";\n}\n.glyphicon-jpy:before {\n  content: \"\\A5\";\n}\n.glyphicon-ruble:before {\n  content: \"\\20BD\";\n}\n.glyphicon-rub:before {\n  content: \"\\20BD\";\n}\n.glyphicon-scale:before {\n  content: \"\\E230\";\n}\n.glyphicon-ice-lolly:before {\n  content: \"\\E231\";\n}\n.glyphicon-ice-lolly-tasted:before {\n  content: \"\\E232\";\n}\n.glyphicon-education:before {\n  content: \"\\E233\";\n}\n.glyphicon-option-horizontal:before {\n  content: \"\\E234\";\n}\n.glyphicon-option-vertical:before {\n  content: \"\\E235\";\n}\n.glyphicon-menu-hamburger:before {\n  content: \"\\E236\";\n}\n.glyphicon-modal-window:before {\n  content: \"\\E237\";\n}\n.glyphicon-oil:before {\n  content: \"\\E238\";\n}\n.glyphicon-grain:before {\n  content: \"\\E239\";\n}\n.glyphicon-sunglasses:before {\n  content: \"\\E240\";\n}\n.glyphicon-text-size:before {\n  content: \"\\E241\";\n}\n.glyphicon-text-color:before {\n  content: \"\\E242\";\n}\n.glyphicon-text-background:before {\n  content: \"\\E243\";\n}\n.glyphicon-object-align-top:before {\n  content: \"\\E244\";\n}\n.glyphicon-object-align-bottom:before {\n  content: \"\\E245\";\n}\n.glyphicon-object-align-horizontal:before {\n  content: \"\\E246\";\n}\n.glyphicon-object-align-left:before {\n  content: \"\\E247\";\n}\n.glyphicon-object-align-vertical:before {\n  content: \"\\E248\";\n}\n.glyphicon-object-align-right:before {\n  content: \"\\E249\";\n}\n.glyphicon-triangle-right:before {\n  content: \"\\E250\";\n}\n.glyphicon-triangle-left:before {\n  content: \"\\E251\";\n}\n.glyphicon-triangle-bottom:before {\n  content: \"\\E252\";\n}\n.glyphicon-triangle-top:before {\n  content: \"\\E253\";\n}\n.glyphicon-console:before {\n  content: \"\\E254\";\n}\n.glyphicon-superscript:before {\n  content: \"\\E255\";\n}\n.glyphicon-subscript:before {\n  content: \"\\E256\";\n}\n.glyphicon-menu-left:before {\n  content: \"\\E257\";\n}\n.glyphicon-menu-right:before {\n  content: \"\\E258\";\n}\n.glyphicon-menu-down:before {\n  content: \"\\E259\";\n}\n.glyphicon-menu-up:before {\n  content: \"\\E260\";\n}\n* {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\nhtml {\n  font-size: 10px;\n\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nbody {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #333;\n  background-color: #fff;\n}\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\na:hover,\na:focus {\n  color: #23527c;\n  text-decoration: underline;\n}\na:focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\nfigure {\n  margin: 0;\n}\nimg {\n  vertical-align: middle;\n}\n.img-responsive,\n.thumbnail > img,\n.thumbnail a > img,\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.img-rounded {\n  border-radius: 6px;\n}\n.img-thumbnail {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n  padding: 4px;\n  line-height: 1.42857143;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: all .2s ease-in-out;\n       -o-transition: all .2s ease-in-out;\n          transition: all .2s ease-in-out;\n}\n.img-circle {\n  border-radius: 50%;\n}\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eee;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n[role=\"button\"] {\n  cursor: pointer;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\nh1 small,\nh2 small,\nh3 small,\nh4 small,\nh5 small,\nh6 small,\n.h1 small,\n.h2 small,\n.h3 small,\n.h4 small,\n.h5 small,\n.h6 small,\nh1 .small,\nh2 .small,\nh3 .small,\nh4 .small,\nh5 .small,\nh6 .small,\n.h1 .small,\n.h2 .small,\n.h3 .small,\n.h4 .small,\n.h5 .small,\n.h6 .small {\n  font-weight: normal;\n  line-height: 1;\n  color: #777;\n}\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\nh1 small,\n.h1 small,\nh2 small,\n.h2 small,\nh3 small,\n.h3 small,\nh1 .small,\n.h1 .small,\nh2 .small,\n.h2 .small,\nh3 .small,\n.h3 .small {\n  font-size: 65%;\n}\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\nh4 small,\n.h4 small,\nh5 small,\n.h5 small,\nh6 small,\n.h6 small,\nh4 .small,\n.h4 .small,\nh5 .small,\n.h5 .small,\nh6 .small,\n.h6 .small {\n  font-size: 75%;\n}\nh1,\n.h1 {\n  font-size: 36px;\n}\nh2,\n.h2 {\n  font-size: 30px;\n}\nh3,\n.h3 {\n  font-size: 24px;\n}\nh4,\n.h4 {\n  font-size: 18px;\n}\nh5,\n.h5 {\n  font-size: 14px;\n}\nh6,\n.h6 {\n  font-size: 12px;\n}\np {\n  margin: 0 0 10px;\n}\n.lead {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.4;\n}\n@media (min-width: 768px) {\n  .lead {\n    font-size: 21px;\n  }\n}\nsmall,\n.small {\n  font-size: 85%;\n}\nmark,\n.mark {\n  padding: .2em;\n  background-color: #fcf8e3;\n}\n.text-left {\n  text-align: left;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-justify {\n  text-align: justify;\n}\n.text-nowrap {\n  white-space: nowrap;\n}\n.text-lowercase {\n  text-transform: lowercase;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n.text-capitalize {\n  text-transform: capitalize;\n}\n.text-muted {\n  color: #777;\n}\n.text-primary {\n  color: #337ab7;\n}\na.text-primary:hover,\na.text-primary:focus {\n  color: #286090;\n}\n.text-success {\n  color: #3c763d;\n}\na.text-success:hover,\na.text-success:focus {\n  color: #2b542c;\n}\n.text-info {\n  color: #31708f;\n}\na.text-info:hover,\na.text-info:focus {\n  color: #245269;\n}\n.text-warning {\n  color: #8a6d3b;\n}\na.text-warning:hover,\na.text-warning:focus {\n  color: #66512c;\n}\n.text-danger {\n  color: #a94442;\n}\na.text-danger:hover,\na.text-danger:focus {\n  color: #843534;\n}\n.bg-primary {\n  color: #fff;\n  background-color: #337ab7;\n}\na.bg-primary:hover,\na.bg-primary:focus {\n  background-color: #286090;\n}\n.bg-success {\n  background-color: #dff0d8;\n}\na.bg-success:hover,\na.bg-success:focus {\n  background-color: #c1e2b3;\n}\n.bg-info {\n  background-color: #d9edf7;\n}\na.bg-info:hover,\na.bg-info:focus {\n  background-color: #afd9ee;\n}\n.bg-warning {\n  background-color: #fcf8e3;\n}\na.bg-warning:hover,\na.bg-warning:focus {\n  background-color: #f7ecb5;\n}\n.bg-danger {\n  background-color: #f2dede;\n}\na.bg-danger:hover,\na.bg-danger:focus {\n  background-color: #e4b9b9;\n}\n.page-header {\n  padding-bottom: 9px;\n  margin: 40px 0 20px;\n  border-bottom: 1px solid #eee;\n}\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\nul ul,\nol ul,\nul ol,\nol ol {\n  margin-bottom: 0;\n}\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline {\n  padding-left: 0;\n  margin-left: -5px;\n  list-style: none;\n}\n.list-inline > li {\n  display: inline-block;\n  padding-right: 5px;\n  padding-left: 5px;\n}\ndl {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\ndt,\ndd {\n  line-height: 1.42857143;\n}\ndt {\n  font-weight: bold;\n}\ndd {\n  margin-left: 0;\n}\n@media (min-width: 768px) {\n  .dl-horizontal dt {\n    float: left;\n    width: 160px;\n    overflow: hidden;\n    clear: left;\n    text-align: right;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .dl-horizontal dd {\n    margin-left: 180px;\n  }\n}\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n  border-bottom: 1px dotted #777;\n}\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\nblockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  font-size: 17.5px;\n  border-left: 5px solid #eee;\n}\nblockquote p:last-child,\nblockquote ul:last-child,\nblockquote ol:last-child {\n  margin-bottom: 0;\n}\nblockquote footer,\nblockquote small,\nblockquote .small {\n  display: block;\n  font-size: 80%;\n  line-height: 1.42857143;\n  color: #777;\n}\nblockquote footer:before,\nblockquote small:before,\nblockquote .small:before {\n  content: '\\2014   \\A0';\n}\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  text-align: right;\n  border-right: 5px solid #eee;\n  border-left: 0;\n}\n.blockquote-reverse footer:before,\nblockquote.pull-right footer:before,\n.blockquote-reverse small:before,\nblockquote.pull-right small:before,\n.blockquote-reverse .small:before,\nblockquote.pull-right .small:before {\n  content: '';\n}\n.blockquote-reverse footer:after,\nblockquote.pull-right footer:after,\n.blockquote-reverse small:after,\nblockquote.pull-right small:after,\n.blockquote-reverse .small:after,\nblockquote.pull-right .small:after {\n  content: '\\A0   \\2014';\n}\naddress {\n  margin-bottom: 20px;\n  font-style: normal;\n  line-height: 1.42857143;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 4px;\n}\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #fff;\n  background-color: #333;\n  border-radius: 3px;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n}\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: bold;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\npre code {\n  padding: 0;\n  font-size: inherit;\n  color: inherit;\n  white-space: pre-wrap;\n  background-color: transparent;\n  border-radius: 0;\n}\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n.container {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 768px) {\n  .container {\n    width: 750px;\n  }\n}\n@media (min-width: 992px) {\n  .container {\n    width: 970px;\n  }\n}\n@media (min-width: 1200px) {\n  .container {\n    width: 1170px;\n  }\n}\n.container-fluid {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {\n  float: left;\n}\n.col-xs-12 {\n  width: 100%;\n}\n.col-xs-11 {\n  width: 91.66666667%;\n}\n.col-xs-10 {\n  width: 83.33333333%;\n}\n.col-xs-9 {\n  width: 75%;\n}\n.col-xs-8 {\n  width: 66.66666667%;\n}\n.col-xs-7 {\n  width: 58.33333333%;\n}\n.col-xs-6 {\n  width: 50%;\n}\n.col-xs-5 {\n  width: 41.66666667%;\n}\n.col-xs-4 {\n  width: 33.33333333%;\n}\n.col-xs-3 {\n  width: 25%;\n}\n.col-xs-2 {\n  width: 16.66666667%;\n}\n.col-xs-1 {\n  width: 8.33333333%;\n}\n.col-xs-pull-12 {\n  right: 100%;\n}\n.col-xs-pull-11 {\n  right: 91.66666667%;\n}\n.col-xs-pull-10 {\n  right: 83.33333333%;\n}\n.col-xs-pull-9 {\n  right: 75%;\n}\n.col-xs-pull-8 {\n  right: 66.66666667%;\n}\n.col-xs-pull-7 {\n  right: 58.33333333%;\n}\n.col-xs-pull-6 {\n  right: 50%;\n}\n.col-xs-pull-5 {\n  right: 41.66666667%;\n}\n.col-xs-pull-4 {\n  right: 33.33333333%;\n}\n.col-xs-pull-3 {\n  right: 25%;\n}\n.col-xs-pull-2 {\n  right: 16.66666667%;\n}\n.col-xs-pull-1 {\n  right: 8.33333333%;\n}\n.col-xs-pull-0 {\n  right: auto;\n}\n.col-xs-push-12 {\n  left: 100%;\n}\n.col-xs-push-11 {\n  left: 91.66666667%;\n}\n.col-xs-push-10 {\n  left: 83.33333333%;\n}\n.col-xs-push-9 {\n  left: 75%;\n}\n.col-xs-push-8 {\n  left: 66.66666667%;\n}\n.col-xs-push-7 {\n  left: 58.33333333%;\n}\n.col-xs-push-6 {\n  left: 50%;\n}\n.col-xs-push-5 {\n  left: 41.66666667%;\n}\n.col-xs-push-4 {\n  left: 33.33333333%;\n}\n.col-xs-push-3 {\n  left: 25%;\n}\n.col-xs-push-2 {\n  left: 16.66666667%;\n}\n.col-xs-push-1 {\n  left: 8.33333333%;\n}\n.col-xs-push-0 {\n  left: auto;\n}\n.col-xs-offset-12 {\n  margin-left: 100%;\n}\n.col-xs-offset-11 {\n  margin-left: 91.66666667%;\n}\n.col-xs-offset-10 {\n  margin-left: 83.33333333%;\n}\n.col-xs-offset-9 {\n  margin-left: 75%;\n}\n.col-xs-offset-8 {\n  margin-left: 66.66666667%;\n}\n.col-xs-offset-7 {\n  margin-left: 58.33333333%;\n}\n.col-xs-offset-6 {\n  margin-left: 50%;\n}\n.col-xs-offset-5 {\n  margin-left: 41.66666667%;\n}\n.col-xs-offset-4 {\n  margin-left: 33.33333333%;\n}\n.col-xs-offset-3 {\n  margin-left: 25%;\n}\n.col-xs-offset-2 {\n  margin-left: 16.66666667%;\n}\n.col-xs-offset-1 {\n  margin-left: 8.33333333%;\n}\n.col-xs-offset-0 {\n  margin-left: 0;\n}\n@media (min-width: 768px) {\n  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {\n    float: left;\n  }\n  .col-sm-12 {\n    width: 100%;\n  }\n  .col-sm-11 {\n    width: 91.66666667%;\n  }\n  .col-sm-10 {\n    width: 83.33333333%;\n  }\n  .col-sm-9 {\n    width: 75%;\n  }\n  .col-sm-8 {\n    width: 66.66666667%;\n  }\n  .col-sm-7 {\n    width: 58.33333333%;\n  }\n  .col-sm-6 {\n    width: 50%;\n  }\n  .col-sm-5 {\n    width: 41.66666667%;\n  }\n  .col-sm-4 {\n    width: 33.33333333%;\n  }\n  .col-sm-3 {\n    width: 25%;\n  }\n  .col-sm-2 {\n    width: 16.66666667%;\n  }\n  .col-sm-1 {\n    width: 8.33333333%;\n  }\n  .col-sm-pull-12 {\n    right: 100%;\n  }\n  .col-sm-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-sm-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-sm-pull-9 {\n    right: 75%;\n  }\n  .col-sm-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-sm-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-sm-pull-6 {\n    right: 50%;\n  }\n  .col-sm-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-sm-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-sm-pull-3 {\n    right: 25%;\n  }\n  .col-sm-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-sm-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-sm-pull-0 {\n    right: auto;\n  }\n  .col-sm-push-12 {\n    left: 100%;\n  }\n  .col-sm-push-11 {\n    left: 91.66666667%;\n  }\n  .col-sm-push-10 {\n    left: 83.33333333%;\n  }\n  .col-sm-push-9 {\n    left: 75%;\n  }\n  .col-sm-push-8 {\n    left: 66.66666667%;\n  }\n  .col-sm-push-7 {\n    left: 58.33333333%;\n  }\n  .col-sm-push-6 {\n    left: 50%;\n  }\n  .col-sm-push-5 {\n    left: 41.66666667%;\n  }\n  .col-sm-push-4 {\n    left: 33.33333333%;\n  }\n  .col-sm-push-3 {\n    left: 25%;\n  }\n  .col-sm-push-2 {\n    left: 16.66666667%;\n  }\n  .col-sm-push-1 {\n    left: 8.33333333%;\n  }\n  .col-sm-push-0 {\n    left: auto;\n  }\n  .col-sm-offset-12 {\n    margin-left: 100%;\n  }\n  .col-sm-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-sm-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-sm-offset-9 {\n    margin-left: 75%;\n  }\n  .col-sm-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-sm-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-sm-offset-6 {\n    margin-left: 50%;\n  }\n  .col-sm-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-sm-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-sm-offset-3 {\n    margin-left: 25%;\n  }\n  .col-sm-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-sm-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-sm-offset-0 {\n    margin-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {\n    float: left;\n  }\n  .col-md-12 {\n    width: 100%;\n  }\n  .col-md-11 {\n    width: 91.66666667%;\n  }\n  .col-md-10 {\n    width: 83.33333333%;\n  }\n  .col-md-9 {\n    width: 75%;\n  }\n  .col-md-8 {\n    width: 66.66666667%;\n  }\n  .col-md-7 {\n    width: 58.33333333%;\n  }\n  .col-md-6 {\n    width: 50%;\n  }\n  .col-md-5 {\n    width: 41.66666667%;\n  }\n  .col-md-4 {\n    width: 33.33333333%;\n  }\n  .col-md-3 {\n    width: 25%;\n  }\n  .col-md-2 {\n    width: 16.66666667%;\n  }\n  .col-md-1 {\n    width: 8.33333333%;\n  }\n  .col-md-pull-12 {\n    right: 100%;\n  }\n  .col-md-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-md-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-md-pull-9 {\n    right: 75%;\n  }\n  .col-md-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-md-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-md-pull-6 {\n    right: 50%;\n  }\n  .col-md-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-md-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-md-pull-3 {\n    right: 25%;\n  }\n  .col-md-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-md-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-md-pull-0 {\n    right: auto;\n  }\n  .col-md-push-12 {\n    left: 100%;\n  }\n  .col-md-push-11 {\n    left: 91.66666667%;\n  }\n  .col-md-push-10 {\n    left: 83.33333333%;\n  }\n  .col-md-push-9 {\n    left: 75%;\n  }\n  .col-md-push-8 {\n    left: 66.66666667%;\n  }\n  .col-md-push-7 {\n    left: 58.33333333%;\n  }\n  .col-md-push-6 {\n    left: 50%;\n  }\n  .col-md-push-5 {\n    left: 41.66666667%;\n  }\n  .col-md-push-4 {\n    left: 33.33333333%;\n  }\n  .col-md-push-3 {\n    left: 25%;\n  }\n  .col-md-push-2 {\n    left: 16.66666667%;\n  }\n  .col-md-push-1 {\n    left: 8.33333333%;\n  }\n  .col-md-push-0 {\n    left: auto;\n  }\n  .col-md-offset-12 {\n    margin-left: 100%;\n  }\n  .col-md-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-md-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-md-offset-9 {\n    margin-left: 75%;\n  }\n  .col-md-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-md-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-md-offset-6 {\n    margin-left: 50%;\n  }\n  .col-md-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-md-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-md-offset-3 {\n    margin-left: 25%;\n  }\n  .col-md-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-md-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-md-offset-0 {\n    margin-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {\n    float: left;\n  }\n  .col-lg-12 {\n    width: 100%;\n  }\n  .col-lg-11 {\n    width: 91.66666667%;\n  }\n  .col-lg-10 {\n    width: 83.33333333%;\n  }\n  .col-lg-9 {\n    width: 75%;\n  }\n  .col-lg-8 {\n    width: 66.66666667%;\n  }\n  .col-lg-7 {\n    width: 58.33333333%;\n  }\n  .col-lg-6 {\n    width: 50%;\n  }\n  .col-lg-5 {\n    width: 41.66666667%;\n  }\n  .col-lg-4 {\n    width: 33.33333333%;\n  }\n  .col-lg-3 {\n    width: 25%;\n  }\n  .col-lg-2 {\n    width: 16.66666667%;\n  }\n  .col-lg-1 {\n    width: 8.33333333%;\n  }\n  .col-lg-pull-12 {\n    right: 100%;\n  }\n  .col-lg-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-lg-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-lg-pull-9 {\n    right: 75%;\n  }\n  .col-lg-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-lg-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-lg-pull-6 {\n    right: 50%;\n  }\n  .col-lg-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-lg-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-lg-pull-3 {\n    right: 25%;\n  }\n  .col-lg-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-lg-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-lg-pull-0 {\n    right: auto;\n  }\n  .col-lg-push-12 {\n    left: 100%;\n  }\n  .col-lg-push-11 {\n    left: 91.66666667%;\n  }\n  .col-lg-push-10 {\n    left: 83.33333333%;\n  }\n  .col-lg-push-9 {\n    left: 75%;\n  }\n  .col-lg-push-8 {\n    left: 66.66666667%;\n  }\n  .col-lg-push-7 {\n    left: 58.33333333%;\n  }\n  .col-lg-push-6 {\n    left: 50%;\n  }\n  .col-lg-push-5 {\n    left: 41.66666667%;\n  }\n  .col-lg-push-4 {\n    left: 33.33333333%;\n  }\n  .col-lg-push-3 {\n    left: 25%;\n  }\n  .col-lg-push-2 {\n    left: 16.66666667%;\n  }\n  .col-lg-push-1 {\n    left: 8.33333333%;\n  }\n  .col-lg-push-0 {\n    left: auto;\n  }\n  .col-lg-offset-12 {\n    margin-left: 100%;\n  }\n  .col-lg-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-lg-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-lg-offset-9 {\n    margin-left: 75%;\n  }\n  .col-lg-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-lg-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-lg-offset-6 {\n    margin-left: 50%;\n  }\n  .col-lg-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-lg-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-lg-offset-3 {\n    margin-left: 25%;\n  }\n  .col-lg-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-lg-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-lg-offset-0 {\n    margin-left: 0;\n  }\n}\ntable {\n  background-color: transparent;\n}\ncaption {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: #777;\n  text-align: left;\n}\nth {\n  text-align: left;\n}\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  padding: 8px;\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n.table > thead > tr > th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #ddd;\n}\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > th,\n.table > caption + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > td,\n.table > thead:first-child > tr:first-child > td {\n  border-top: 0;\n}\n.table > tbody + tbody {\n  border-top: 2px solid #ddd;\n}\n.table .table {\n  background-color: #fff;\n}\n.table-condensed > thead > tr > th,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > tbody > tr > td,\n.table-condensed > tfoot > tr > td {\n  padding: 5px;\n}\n.table-bordered {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n.table-bordered > tbody > tr > th,\n.table-bordered > tfoot > tr > th,\n.table-bordered > thead > tr > td,\n.table-bordered > tbody > tr > td,\n.table-bordered > tfoot > tr > td {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n.table-bordered > thead > tr > td {\n  border-bottom-width: 2px;\n}\n.table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: #f9f9f9;\n}\n.table-hover > tbody > tr:hover {\n  background-color: #f5f5f5;\n}\ntable col[class*=\"col-\"] {\n  position: static;\n  display: table-column;\n  float: none;\n}\ntable td[class*=\"col-\"],\ntable th[class*=\"col-\"] {\n  position: static;\n  display: table-cell;\n  float: none;\n}\n.table > thead > tr > td.active,\n.table > tbody > tr > td.active,\n.table > tfoot > tr > td.active,\n.table > thead > tr > th.active,\n.table > tbody > tr > th.active,\n.table > tfoot > tr > th.active,\n.table > thead > tr.active > td,\n.table > tbody > tr.active > td,\n.table > tfoot > tr.active > td,\n.table > thead > tr.active > th,\n.table > tbody > tr.active > th,\n.table > tfoot > tr.active > th {\n  background-color: #f5f5f5;\n}\n.table-hover > tbody > tr > td.active:hover,\n.table-hover > tbody > tr > th.active:hover,\n.table-hover > tbody > tr.active:hover > td,\n.table-hover > tbody > tr:hover > .active,\n.table-hover > tbody > tr.active:hover > th {\n  background-color: #e8e8e8;\n}\n.table > thead > tr > td.success,\n.table > tbody > tr > td.success,\n.table > tfoot > tr > td.success,\n.table > thead > tr > th.success,\n.table > tbody > tr > th.success,\n.table > tfoot > tr > th.success,\n.table > thead > tr.success > td,\n.table > tbody > tr.success > td,\n.table > tfoot > tr.success > td,\n.table > thead > tr.success > th,\n.table > tbody > tr.success > th,\n.table > tfoot > tr.success > th {\n  background-color: #dff0d8;\n}\n.table-hover > tbody > tr > td.success:hover,\n.table-hover > tbody > tr > th.success:hover,\n.table-hover > tbody > tr.success:hover > td,\n.table-hover > tbody > tr:hover > .success,\n.table-hover > tbody > tr.success:hover > th {\n  background-color: #d0e9c6;\n}\n.table > thead > tr > td.info,\n.table > tbody > tr > td.info,\n.table > tfoot > tr > td.info,\n.table > thead > tr > th.info,\n.table > tbody > tr > th.info,\n.table > tfoot > tr > th.info,\n.table > thead > tr.info > td,\n.table > tbody > tr.info > td,\n.table > tfoot > tr.info > td,\n.table > thead > tr.info > th,\n.table > tbody > tr.info > th,\n.table > tfoot > tr.info > th {\n  background-color: #d9edf7;\n}\n.table-hover > tbody > tr > td.info:hover,\n.table-hover > tbody > tr > th.info:hover,\n.table-hover > tbody > tr.info:hover > td,\n.table-hover > tbody > tr:hover > .info,\n.table-hover > tbody > tr.info:hover > th {\n  background-color: #c4e3f3;\n}\n.table > thead > tr > td.warning,\n.table > tbody > tr > td.warning,\n.table > tfoot > tr > td.warning,\n.table > thead > tr > th.warning,\n.table > tbody > tr > th.warning,\n.table > tfoot > tr > th.warning,\n.table > thead > tr.warning > td,\n.table > tbody > tr.warning > td,\n.table > tfoot > tr.warning > td,\n.table > thead > tr.warning > th,\n.table > tbody > tr.warning > th,\n.table > tfoot > tr.warning > th {\n  background-color: #fcf8e3;\n}\n.table-hover > tbody > tr > td.warning:hover,\n.table-hover > tbody > tr > th.warning:hover,\n.table-hover > tbody > tr.warning:hover > td,\n.table-hover > tbody > tr:hover > .warning,\n.table-hover > tbody > tr.warning:hover > th {\n  background-color: #faf2cc;\n}\n.table > thead > tr > td.danger,\n.table > tbody > tr > td.danger,\n.table > tfoot > tr > td.danger,\n.table > thead > tr > th.danger,\n.table > tbody > tr > th.danger,\n.table > tfoot > tr > th.danger,\n.table > thead > tr.danger > td,\n.table > tbody > tr.danger > td,\n.table > tfoot > tr.danger > td,\n.table > thead > tr.danger > th,\n.table > tbody > tr.danger > th,\n.table > tfoot > tr.danger > th {\n  background-color: #f2dede;\n}\n.table-hover > tbody > tr > td.danger:hover,\n.table-hover > tbody > tr > th.danger:hover,\n.table-hover > tbody > tr.danger:hover > td,\n.table-hover > tbody > tr:hover > .danger,\n.table-hover > tbody > tr.danger:hover > th {\n  background-color: #ebcccc;\n}\n.table-responsive {\n  min-height: .01%;\n  overflow-x: auto;\n}\n@media screen and (max-width: 767px) {\n  .table-responsive {\n    width: 100%;\n    margin-bottom: 15px;\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid #ddd;\n  }\n  .table-responsive > .table {\n    margin-bottom: 0;\n  }\n  .table-responsive > .table > thead > tr > th,\n  .table-responsive > .table > tbody > tr > th,\n  .table-responsive > .table > tfoot > tr > th,\n  .table-responsive > .table > thead > tr > td,\n  .table-responsive > .table > tbody > tr > td,\n  .table-responsive > .table > tfoot > tr > td {\n    white-space: nowrap;\n  }\n  .table-responsive > .table-bordered {\n    border: 0;\n  }\n  .table-responsive > .table-bordered > thead > tr > th:first-child,\n  .table-responsive > .table-bordered > tbody > tr > th:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n  .table-responsive > .table-bordered > thead > tr > td:first-child,\n  .table-responsive > .table-bordered > tbody > tr > td:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n    border-left: 0;\n  }\n  .table-responsive > .table-bordered > thead > tr > th:last-child,\n  .table-responsive > .table-bordered > tbody > tr > th:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n  .table-responsive > .table-bordered > thead > tr > td:last-child,\n  .table-responsive > .table-bordered > tbody > tr > td:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n    border-right: 0;\n  }\n  .table-responsive > .table-bordered > tbody > tr:last-child > th,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n  .table-responsive > .table-bordered > tbody > tr:last-child > td,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n    border-bottom: 0;\n  }\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 21px;\n  line-height: inherit;\n  color: #333;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\ninput[type=\"search\"] {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal;\n}\ninput[type=\"file\"] {\n  display: block;\n}\ninput[type=\"range\"] {\n  display: block;\n  width: 100%;\n}\nselect[multiple],\nselect[size] {\n  height: auto;\n}\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\noutput {\n  display: block;\n  padding-top: 7px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n       -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n          transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);\n          box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);\n}\n.form-control::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.form-control:-ms-input-placeholder {\n  color: #999;\n}\n.form-control::-webkit-input-placeholder {\n  color: #999;\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: #eee;\n  opacity: 1;\n}\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: not-allowed;\n}\ntextarea.form-control {\n  height: auto;\n}\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  input[type=\"date\"].form-control,\n  input[type=\"time\"].form-control,\n  input[type=\"datetime-local\"].form-control,\n  input[type=\"month\"].form-control {\n    line-height: 34px;\n  }\n  input[type=\"date\"].input-sm,\n  input[type=\"time\"].input-sm,\n  input[type=\"datetime-local\"].input-sm,\n  input[type=\"month\"].input-sm,\n  .input-group-sm input[type=\"date\"],\n  .input-group-sm input[type=\"time\"],\n  .input-group-sm input[type=\"datetime-local\"],\n  .input-group-sm input[type=\"month\"] {\n    line-height: 30px;\n  }\n  input[type=\"date\"].input-lg,\n  input[type=\"time\"].input-lg,\n  input[type=\"datetime-local\"].input-lg,\n  input[type=\"month\"].input-lg,\n  .input-group-lg input[type=\"date\"],\n  .input-group-lg input[type=\"time\"],\n  .input-group-lg input[type=\"datetime-local\"],\n  .input-group-lg input[type=\"month\"] {\n    line-height: 46px;\n  }\n}\n.form-group {\n  margin-bottom: 15px;\n}\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.radio label,\n.checkbox label {\n  min-height: 20px;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: normal;\n  cursor: pointer;\n}\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px;\n}\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px;\n}\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: normal;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px;\n}\ninput[type=\"radio\"][disabled],\ninput[type=\"checkbox\"][disabled],\ninput[type=\"radio\"].disabled,\ninput[type=\"checkbox\"].disabled,\nfieldset[disabled] input[type=\"radio\"],\nfieldset[disabled] input[type=\"checkbox\"] {\n  cursor: not-allowed;\n}\n.radio-inline.disabled,\n.checkbox-inline.disabled,\nfieldset[disabled] .radio-inline,\nfieldset[disabled] .checkbox-inline {\n  cursor: not-allowed;\n}\n.radio.disabled label,\n.checkbox.disabled label,\nfieldset[disabled] .radio label,\nfieldset[disabled] .checkbox label {\n  cursor: not-allowed;\n}\n.form-control-static {\n  min-height: 34px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0;\n}\n.form-control-static.input-lg,\n.form-control-static.input-sm {\n  padding-right: 0;\n  padding-left: 0;\n}\n.input-sm {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.input-sm {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-sm,\nselect[multiple].input-sm {\n  height: auto;\n}\n.form-group-sm .form-control {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.form-group-sm select.form-control {\n  height: 30px;\n  line-height: 30px;\n}\n.form-group-sm textarea.form-control,\n.form-group-sm select[multiple].form-control {\n  height: auto;\n}\n.form-group-sm .form-control-static {\n  height: 30px;\n  min-height: 32px;\n  padding: 6px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.input-lg {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\nselect.input-lg {\n  height: 46px;\n  line-height: 46px;\n}\ntextarea.input-lg,\nselect[multiple].input-lg {\n  height: auto;\n}\n.form-group-lg .form-control {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\n.form-group-lg select.form-control {\n  height: 46px;\n  line-height: 46px;\n}\n.form-group-lg textarea.form-control,\n.form-group-lg select[multiple].form-control {\n  height: auto;\n}\n.form-group-lg .form-control-static {\n  height: 46px;\n  min-height: 38px;\n  padding: 11px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n}\n.has-feedback {\n  position: relative;\n}\n.has-feedback .form-control {\n  padding-right: 42.5px;\n}\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  pointer-events: none;\n}\n.input-lg + .form-control-feedback,\n.input-group-lg + .form-control-feedback,\n.form-group-lg .form-control + .form-control-feedback {\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n}\n.input-sm + .form-control-feedback,\n.input-group-sm + .form-control-feedback,\n.form-group-sm .form-control + .form-control-feedback {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n.has-success .help-block,\n.has-success .control-label,\n.has-success .radio,\n.has-success .checkbox,\n.has-success .radio-inline,\n.has-success .checkbox-inline,\n.has-success.radio label,\n.has-success.checkbox label,\n.has-success.radio-inline label,\n.has-success.checkbox-inline label {\n  color: #3c763d;\n}\n.has-success .form-control {\n  border-color: #3c763d;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-success .form-control:focus {\n  border-color: #2b542c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #67b168;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #67b168;\n}\n.has-success .input-group-addon {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #3c763d;\n}\n.has-success .form-control-feedback {\n  color: #3c763d;\n}\n.has-warning .help-block,\n.has-warning .control-label,\n.has-warning .radio,\n.has-warning .checkbox,\n.has-warning .radio-inline,\n.has-warning .checkbox-inline,\n.has-warning.radio label,\n.has-warning.checkbox label,\n.has-warning.radio-inline label,\n.has-warning.checkbox-inline label {\n  color: #8a6d3b;\n}\n.has-warning .form-control {\n  border-color: #8a6d3b;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-warning .form-control:focus {\n  border-color: #66512c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #c0a16b;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #c0a16b;\n}\n.has-warning .input-group-addon {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #8a6d3b;\n}\n.has-warning .form-control-feedback {\n  color: #8a6d3b;\n}\n.has-error .help-block,\n.has-error .control-label,\n.has-error .radio,\n.has-error .checkbox,\n.has-error .radio-inline,\n.has-error .checkbox-inline,\n.has-error.radio label,\n.has-error.checkbox label,\n.has-error.radio-inline label,\n.has-error.checkbox-inline label {\n  color: #a94442;\n}\n.has-error .form-control {\n  border-color: #a94442;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n.has-error .form-control:focus {\n  border-color: #843534;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;\n}\n.has-error .input-group-addon {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #a94442;\n}\n.has-error .form-control-feedback {\n  color: #a94442;\n}\n.has-feedback label ~ .form-control-feedback {\n  top: 25px;\n}\n.has-feedback label.sr-only ~ .form-control-feedback {\n  top: 0;\n}\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #737373;\n}\n@media (min-width: 768px) {\n  .form-inline .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-static {\n    display: inline-block;\n  }\n  .form-inline .input-group {\n    display: inline-table;\n    vertical-align: middle;\n  }\n  .form-inline .input-group .input-group-addon,\n  .form-inline .input-group .input-group-btn,\n  .form-inline .input-group .form-control {\n    width: auto;\n  }\n  .form-inline .input-group > .form-control {\n    width: 100%;\n  }\n  .form-inline .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .radio,\n  .form-inline .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .radio label,\n  .form-inline .checkbox label {\n    padding-left: 0;\n  }\n  .form-inline .radio input[type=\"radio\"],\n  .form-inline .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0;\n  }\n  .form-inline .has-feedback .form-control-feedback {\n    top: 0;\n  }\n}\n.form-horizontal .radio,\n.form-horizontal .checkbox,\n.form-horizontal .radio-inline,\n.form-horizontal .checkbox-inline {\n  padding-top: 7px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.form-horizontal .radio,\n.form-horizontal .checkbox {\n  min-height: 27px;\n}\n.form-horizontal .form-group {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  .form-horizontal .control-label {\n    padding-top: 7px;\n    margin-bottom: 0;\n    text-align: right;\n  }\n}\n.form-horizontal .has-feedback .form-control-feedback {\n  right: 15px;\n}\n@media (min-width: 768px) {\n  .form-horizontal .form-group-lg .control-label {\n    padding-top: 11px;\n    font-size: 18px;\n  }\n}\n@media (min-width: 768px) {\n  .form-horizontal .form-group-sm .control-label {\n    padding-top: 6px;\n    font-size: 12px;\n  }\n}\n.btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.btn:focus,\n.btn:active:focus,\n.btn.active:focus,\n.btn.focus,\n.btn:active.focus,\n.btn.active.focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n.btn:hover,\n.btn:focus,\n.btn.focus {\n  color: #333;\n  text-decoration: none;\n}\n.btn:active,\n.btn.active {\n  background-image: none;\n  outline: 0;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n          box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n.btn.disabled,\n.btn[disabled],\nfieldset[disabled] .btn {\n  cursor: not-allowed;\n  filter: alpha(opacity=65);\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  opacity: .65;\n}\na.btn.disabled,\nfieldset[disabled] a.btn {\n  pointer-events: none;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default:focus,\n.btn-default.focus {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #8c8c8c;\n}\n.btn-default:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.btn-default:active,\n.btn-default.active,\n.open > .dropdown-toggle.btn-default {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.btn-default:active:hover,\n.btn-default.active:hover,\n.open > .dropdown-toggle.btn-default:hover,\n.btn-default:active:focus,\n.btn-default.active:focus,\n.open > .dropdown-toggle.btn-default:focus,\n.btn-default:active.focus,\n.btn-default.active.focus,\n.open > .dropdown-toggle.btn-default.focus {\n  color: #333;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.btn-default:active,\n.btn-default.active,\n.open > .dropdown-toggle.btn-default {\n  background-image: none;\n}\n.btn-default.disabled:hover,\n.btn-default[disabled]:hover,\nfieldset[disabled] .btn-default:hover,\n.btn-default.disabled:focus,\n.btn-default[disabled]:focus,\nfieldset[disabled] .btn-default:focus,\n.btn-default.disabled.focus,\n.btn-default[disabled].focus,\nfieldset[disabled] .btn-default.focus {\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default .badge {\n  color: #fff;\n  background-color: #333;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-primary:focus,\n.btn-primary.focus {\n  color: #fff;\n  background-color: #286090;\n  border-color: #122b40;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n.btn-primary:active,\n.btn-primary.active,\n.open > .dropdown-toggle.btn-primary {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n.btn-primary:active:hover,\n.btn-primary.active:hover,\n.open > .dropdown-toggle.btn-primary:hover,\n.btn-primary:active:focus,\n.btn-primary.active:focus,\n.open > .dropdown-toggle.btn-primary:focus,\n.btn-primary:active.focus,\n.btn-primary.active.focus,\n.open > .dropdown-toggle.btn-primary.focus {\n  color: #fff;\n  background-color: #204d74;\n  border-color: #122b40;\n}\n.btn-primary:active,\n.btn-primary.active,\n.open > .dropdown-toggle.btn-primary {\n  background-image: none;\n}\n.btn-primary.disabled:hover,\n.btn-primary[disabled]:hover,\nfieldset[disabled] .btn-primary:hover,\n.btn-primary.disabled:focus,\n.btn-primary[disabled]:focus,\nfieldset[disabled] .btn-primary:focus,\n.btn-primary.disabled.focus,\n.btn-primary[disabled].focus,\nfieldset[disabled] .btn-primary.focus {\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-primary .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n.btn-success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success:focus,\n.btn-success.focus {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #255625;\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.btn-success:active,\n.btn-success.active,\n.open > .dropdown-toggle.btn-success {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.btn-success:active:hover,\n.btn-success.active:hover,\n.open > .dropdown-toggle.btn-success:hover,\n.btn-success:active:focus,\n.btn-success.active:focus,\n.open > .dropdown-toggle.btn-success:focus,\n.btn-success:active.focus,\n.btn-success.active.focus,\n.open > .dropdown-toggle.btn-success.focus {\n  color: #fff;\n  background-color: #398439;\n  border-color: #255625;\n}\n.btn-success:active,\n.btn-success.active,\n.open > .dropdown-toggle.btn-success {\n  background-image: none;\n}\n.btn-success.disabled:hover,\n.btn-success[disabled]:hover,\nfieldset[disabled] .btn-success:hover,\n.btn-success.disabled:focus,\n.btn-success[disabled]:focus,\nfieldset[disabled] .btn-success:focus,\n.btn-success.disabled.focus,\n.btn-success[disabled].focus,\nfieldset[disabled] .btn-success.focus {\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.btn-success .badge {\n  color: #5cb85c;\n  background-color: #fff;\n}\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info:focus,\n.btn-info.focus {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #1b6d85;\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n.btn-info:active,\n.btn-info.active,\n.open > .dropdown-toggle.btn-info {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n.btn-info:active:hover,\n.btn-info.active:hover,\n.open > .dropdown-toggle.btn-info:hover,\n.btn-info:active:focus,\n.btn-info.active:focus,\n.open > .dropdown-toggle.btn-info:focus,\n.btn-info:active.focus,\n.btn-info.active.focus,\n.open > .dropdown-toggle.btn-info.focus {\n  color: #fff;\n  background-color: #269abc;\n  border-color: #1b6d85;\n}\n.btn-info:active,\n.btn-info.active,\n.open > .dropdown-toggle.btn-info {\n  background-image: none;\n}\n.btn-info.disabled:hover,\n.btn-info[disabled]:hover,\nfieldset[disabled] .btn-info:hover,\n.btn-info.disabled:focus,\n.btn-info[disabled]:focus,\nfieldset[disabled] .btn-info:focus,\n.btn-info.disabled.focus,\n.btn-info[disabled].focus,\nfieldset[disabled] .btn-info.focus {\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n.btn-info .badge {\n  color: #5bc0de;\n  background-color: #fff;\n}\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning:focus,\n.btn-warning.focus {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #985f0d;\n}\n.btn-warning:hover {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n.btn-warning:active,\n.btn-warning.active,\n.open > .dropdown-toggle.btn-warning {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n.btn-warning:active:hover,\n.btn-warning.active:hover,\n.open > .dropdown-toggle.btn-warning:hover,\n.btn-warning:active:focus,\n.btn-warning.active:focus,\n.open > .dropdown-toggle.btn-warning:focus,\n.btn-warning:active.focus,\n.btn-warning.active.focus,\n.open > .dropdown-toggle.btn-warning.focus {\n  color: #fff;\n  background-color: #d58512;\n  border-color: #985f0d;\n}\n.btn-warning:active,\n.btn-warning.active,\n.open > .dropdown-toggle.btn-warning {\n  background-image: none;\n}\n.btn-warning.disabled:hover,\n.btn-warning[disabled]:hover,\nfieldset[disabled] .btn-warning:hover,\n.btn-warning.disabled:focus,\n.btn-warning[disabled]:focus,\nfieldset[disabled] .btn-warning:focus,\n.btn-warning.disabled.focus,\n.btn-warning[disabled].focus,\nfieldset[disabled] .btn-warning.focus {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning .badge {\n  color: #f0ad4e;\n  background-color: #fff;\n}\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger:focus,\n.btn-danger.focus {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #761c19;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n.btn-danger:active,\n.btn-danger.active,\n.open > .dropdown-toggle.btn-danger {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n.btn-danger:active:hover,\n.btn-danger.active:hover,\n.open > .dropdown-toggle.btn-danger:hover,\n.btn-danger:active:focus,\n.btn-danger.active:focus,\n.open > .dropdown-toggle.btn-danger:focus,\n.btn-danger:active.focus,\n.btn-danger.active.focus,\n.open > .dropdown-toggle.btn-danger.focus {\n  color: #fff;\n  background-color: #ac2925;\n  border-color: #761c19;\n}\n.btn-danger:active,\n.btn-danger.active,\n.open > .dropdown-toggle.btn-danger {\n  background-image: none;\n}\n.btn-danger.disabled:hover,\n.btn-danger[disabled]:hover,\nfieldset[disabled] .btn-danger:hover,\n.btn-danger.disabled:focus,\n.btn-danger[disabled]:focus,\nfieldset[disabled] .btn-danger:focus,\n.btn-danger.disabled.focus,\n.btn-danger[disabled].focus,\nfieldset[disabled] .btn-danger.focus {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-danger .badge {\n  color: #d9534f;\n  background-color: #fff;\n}\n.btn-link {\n  font-weight: normal;\n  color: #337ab7;\n  border-radius: 0;\n}\n.btn-link,\n.btn-link:active,\n.btn-link.active,\n.btn-link[disabled],\nfieldset[disabled] .btn-link {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.btn-link,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link:active {\n  border-color: transparent;\n}\n.btn-link:hover,\n.btn-link:focus {\n  color: #23527c;\n  text-decoration: underline;\n  background-color: transparent;\n}\n.btn-link[disabled]:hover,\nfieldset[disabled] .btn-link:hover,\n.btn-link[disabled]:focus,\nfieldset[disabled] .btn-link:focus {\n  color: #777;\n  text-decoration: none;\n}\n.btn-lg,\n.btn-group-lg > .btn {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\n.btn-sm,\n.btn-group-sm > .btn {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.btn-xs,\n.btn-group-xs > .btn {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity .15s linear;\n       -o-transition: opacity .15s linear;\n          transition: opacity .15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\n.collapse {\n  display: none;\n}\n.collapse.in {\n  display: block;\n}\ntr.collapse.in {\n  display: table-row;\n}\ntbody.collapse.in {\n  display: table-row-group;\n}\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition-timing-function: ease;\n       -o-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .35s;\n       -o-transition-duration: .35s;\n          transition-duration: .35s;\n  -webkit-transition-property: height, visibility;\n       -o-transition-property: height, visibility;\n          transition-property: height, visibility;\n}\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n.dropup,\n.dropdown {\n  position: relative;\n}\n.dropdown-toggle:focus {\n  outline: 0;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  font-size: 14px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, .15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n          box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n}\n.dropdown-menu.pull-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu .divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.dropdown-menu > li > a {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.42857143;\n  color: #333;\n  white-space: nowrap;\n}\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus {\n  color: #262626;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\n.dropdown-menu > .active > a,\n.dropdown-menu > .active > a:hover,\n.dropdown-menu > .active > a:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #337ab7;\n  outline: 0;\n}\n.dropdown-menu > .disabled > a,\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  color: #777;\n}\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n}\n.open > .dropdown-menu {\n  display: block;\n}\n.open > a {\n  outline: 0;\n}\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857143;\n  color: #777;\n  white-space: nowrap;\n}\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 990;\n}\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n.dropup .caret,\n.navbar-fixed-bottom .dropdown .caret {\n  content: \"\";\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid \\9;\n}\n.dropup .dropdown-menu,\n.navbar-fixed-bottom .dropdown .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 2px;\n}\n@media (min-width: 768px) {\n  .navbar-right .dropdown-menu {\n    right: 0;\n    left: auto;\n  }\n  .navbar-right .dropdown-menu-left {\n    right: auto;\n    left: 0;\n  }\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  float: left;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group-vertical > .btn:focus,\n.btn-group > .btn:active,\n.btn-group-vertical > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn.active {\n  z-index: 2;\n}\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px;\n}\n.btn-toolbar {\n  margin-left: -5px;\n}\n.btn-toolbar .btn,\n.btn-toolbar .btn-group,\n.btn-toolbar .input-group {\n  float: left;\n}\n.btn-toolbar > .btn,\n.btn-toolbar > .btn-group,\n.btn-toolbar > .input-group {\n  margin-left: 5px;\n}\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n.btn-group > .btn + .dropdown-toggle {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.btn-group > .btn-lg + .dropdown-toggle {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n.btn-group.open .dropdown-toggle {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n          box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n.btn-group.open .dropdown-toggle.btn-link {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.btn .caret {\n  margin-left: 0;\n}\n.btn-lg .caret {\n  border-width: 5px 5px 0;\n  border-bottom-width: 0;\n}\n.dropup .btn-lg .caret {\n  border-width: 0 5px 5px;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group,\n.btn-group-vertical > .btn-group > .btn {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n}\n.btn-group-vertical > .btn-group > .btn {\n  float: none;\n}\n.btn-group-vertical > .btn + .btn,\n.btn-group-vertical > .btn + .btn-group,\n.btn-group-vertical > .btn-group + .btn,\n.btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0;\n}\n.btn-group-vertical > .btn:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn:first-child:not(:last-child) {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.btn-group-justified > .btn,\n.btn-group-justified > .btn-group {\n  display: table-cell;\n  float: none;\n  width: 1%;\n}\n.btn-group-justified > .btn-group .btn {\n  width: 100%;\n}\n.btn-group-justified > .btn-group .dropdown-menu {\n  left: auto;\n}\n[data-toggle=\"buttons\"] > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn input[type=\"checkbox\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"checkbox\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.input-group[class*=\"col-\"] {\n  float: none;\n  padding-right: 0;\n  padding-left: 0;\n}\n.input-group .form-control {\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.input-group .form-control:focus {\n  z-index: 3;\n}\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\nselect.input-group-lg > .form-control,\nselect.input-group-lg > .input-group-addon,\nselect.input-group-lg > .input-group-btn > .btn {\n  height: 46px;\n  line-height: 46px;\n}\ntextarea.input-group-lg > .form-control,\ntextarea.input-group-lg > .input-group-addon,\ntextarea.input-group-lg > .input-group-btn > .btn,\nselect[multiple].input-group-lg > .form-control,\nselect[multiple].input-group-lg > .input-group-addon,\nselect[multiple].input-group-lg > .input-group-btn > .btn {\n  height: auto;\n}\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.input-group-sm > .form-control,\nselect.input-group-sm > .input-group-addon,\nselect.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-group-sm > .form-control,\ntextarea.input-group-sm > .input-group-addon,\ntextarea.input-group-sm > .input-group-btn > .btn,\nselect[multiple].input-group-sm > .form-control,\nselect[multiple].input-group-sm > .input-group-addon,\nselect[multiple].input-group-sm > .input-group-btn > .btn {\n  height: auto;\n}\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n}\n.input-group-addon:not(:first-child):not(:last-child),\n.input-group-btn:not(:first-child):not(:last-child),\n.input-group .form-control:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1;\n  color: #555;\n  text-align: center;\n  background-color: #eee;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.input-group-addon.input-sm {\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n}\n.input-group-addon.input-lg {\n  padding: 10px 16px;\n  font-size: 18px;\n  border-radius: 6px;\n}\n.input-group-addon input[type=\"radio\"],\n.input-group-addon input[type=\"checkbox\"] {\n  margin-top: 0;\n}\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group-addon:first-child {\n  border-right: 0;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child),\n.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group-addon:last-child {\n  border-left: 0;\n}\n.input-group-btn {\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.input-group-btn > .btn {\n  position: relative;\n}\n.input-group-btn > .btn + .btn {\n  margin-left: -1px;\n}\n.input-group-btn > .btn:hover,\n.input-group-btn > .btn:focus,\n.input-group-btn > .btn:active {\n  z-index: 2;\n}\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group {\n  margin-right: -1px;\n}\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group {\n  z-index: 2;\n  margin-left: -1px;\n}\n.nav {\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.nav > li {\n  position: relative;\n  display: block;\n}\n.nav > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n.nav > li > a:hover,\n.nav > li > a:focus {\n  text-decoration: none;\n  background-color: #eee;\n}\n.nav > li.disabled > a {\n  color: #777;\n}\n.nav > li.disabled > a:hover,\n.nav > li.disabled > a:focus {\n  color: #777;\n  text-decoration: none;\n  cursor: not-allowed;\n  background-color: transparent;\n}\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n  background-color: #eee;\n  border-color: #337ab7;\n}\n.nav .nav-divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.nav > li > a > img {\n  max-width: none;\n}\n.nav-tabs {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs > li {\n  float: left;\n  margin-bottom: -1px;\n}\n.nav-tabs > li > a {\n  margin-right: 2px;\n  line-height: 1.42857143;\n  border: 1px solid transparent;\n  border-radius: 4px 4px 0 0;\n}\n.nav-tabs > li > a:hover {\n  border-color: #eee #eee #ddd;\n}\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:hover,\n.nav-tabs > li.active > a:focus {\n  color: #555;\n  cursor: default;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-bottom-color: transparent;\n}\n.nav-tabs.nav-justified {\n  width: 100%;\n  border-bottom: 0;\n}\n.nav-tabs.nav-justified > li {\n  float: none;\n}\n.nav-tabs.nav-justified > li > a {\n  margin-bottom: 5px;\n  text-align: center;\n}\n.nav-tabs.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-tabs.nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs.nav-justified > li > a {\n  margin-right: 0;\n  border-radius: 4px;\n}\n.nav-tabs.nav-justified > .active > a,\n.nav-tabs.nav-justified > .active > a:hover,\n.nav-tabs.nav-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-tabs.nav-justified > .active > a,\n  .nav-tabs.nav-justified > .active > a:hover,\n  .nav-tabs.nav-justified > .active > a:focus {\n    border-bottom-color: #fff;\n  }\n}\n.nav-pills > li {\n  float: left;\n}\n.nav-pills > li > a {\n  border-radius: 4px;\n}\n.nav-pills > li + li {\n  margin-left: 2px;\n}\n.nav-pills > li.active > a,\n.nav-pills > li.active > a:hover,\n.nav-pills > li.active > a:focus {\n  color: #fff;\n  background-color: #337ab7;\n}\n.nav-stacked > li {\n  float: none;\n}\n.nav-stacked > li + li {\n  margin-top: 2px;\n  margin-left: 0;\n}\n.nav-justified {\n  width: 100%;\n}\n.nav-justified > li {\n  float: none;\n}\n.nav-justified > li > a {\n  margin-bottom: 5px;\n  text-align: center;\n}\n.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs-justified {\n  border-bottom: 0;\n}\n.nav-tabs-justified > li > a {\n  margin-right: 0;\n  border-radius: 4px;\n}\n.nav-tabs-justified > .active > a,\n.nav-tabs-justified > .active > a:hover,\n.nav-tabs-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-tabs-justified > .active > a,\n  .nav-tabs-justified > .active > a:hover,\n  .nav-tabs-justified > .active > a:focus {\n    border-bottom-color: #fff;\n  }\n}\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar {\n  position: relative;\n  min-height: 50px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n}\n@media (min-width: 768px) {\n  .navbar {\n    border-radius: 4px;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-header {\n    float: left;\n  }\n}\n.navbar-collapse {\n  padding-right: 15px;\n  padding-left: 15px;\n  overflow-x: visible;\n  -webkit-overflow-scrolling: touch;\n  border-top: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\n          box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\n}\n.navbar-collapse.in {\n  overflow-y: auto;\n}\n@media (min-width: 768px) {\n  .navbar-collapse {\n    width: auto;\n    border-top: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n  .navbar-collapse.collapse {\n    display: block !important;\n    height: auto !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n  .navbar-collapse.in {\n    overflow-y: visible;\n  }\n  .navbar-fixed-top .navbar-collapse,\n  .navbar-static-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n  max-height: 340px;\n}\n@media (max-device-width: 480px) and (orientation: landscape) {\n  .navbar-fixed-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    max-height: 200px;\n  }\n}\n.container > .navbar-header,\n.container-fluid > .navbar-header,\n.container > .navbar-collapse,\n.container-fluid > .navbar-collapse {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  .container > .navbar-header,\n  .container-fluid > .navbar-header,\n  .container > .navbar-collapse,\n  .container-fluid > .navbar-collapse {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n.navbar-static-top {\n  z-index: 1000;\n  border-width: 0 0 1px;\n}\n@media (min-width: 768px) {\n  .navbar-static-top {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n@media (min-width: 768px) {\n  .navbar-fixed-top,\n  .navbar-fixed-bottom {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0;\n  border-width: 1px 0 0;\n}\n.navbar-brand {\n  float: left;\n  height: 50px;\n  padding: 15px 15px;\n  font-size: 18px;\n  line-height: 20px;\n}\n.navbar-brand:hover,\n.navbar-brand:focus {\n  text-decoration: none;\n}\n.navbar-brand > img {\n  display: block;\n}\n@media (min-width: 768px) {\n  .navbar > .container .navbar-brand,\n  .navbar > .container-fluid .navbar-brand {\n    margin-left: -15px;\n  }\n}\n.navbar-toggle {\n  position: relative;\n  float: right;\n  padding: 9px 10px;\n  margin-top: 8px;\n  margin-right: 15px;\n  margin-bottom: 8px;\n  background-color: transparent;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.navbar-toggle:focus {\n  outline: 0;\n}\n.navbar-toggle .icon-bar {\n  display: block;\n  width: 22px;\n  height: 2px;\n  border-radius: 1px;\n}\n.navbar-toggle .icon-bar + .icon-bar {\n  margin-top: 4px;\n}\n@media (min-width: 768px) {\n  .navbar-toggle {\n    display: none;\n  }\n}\n.navbar-nav {\n  margin: 7.5px -15px;\n}\n.navbar-nav > li > a {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 20px;\n}\n@media (max-width: 767px) {\n  .navbar-nav .open .dropdown-menu {\n    position: static;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: transparent;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n  .navbar-nav .open .dropdown-menu > li > a,\n  .navbar-nav .open .dropdown-menu .dropdown-header {\n    padding: 5px 15px 5px 25px;\n  }\n  .navbar-nav .open .dropdown-menu > li > a {\n    line-height: 20px;\n  }\n  .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-nav .open .dropdown-menu > li > a:focus {\n    background-image: none;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-nav {\n    float: left;\n    margin: 0;\n  }\n  .navbar-nav > li {\n    float: left;\n  }\n  .navbar-nav > li > a {\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n}\n.navbar-form {\n  padding: 10px 15px;\n  margin-top: 8px;\n  margin-right: -15px;\n  margin-bottom: 8px;\n  margin-left: -15px;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\n          box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\n}\n@media (min-width: 768px) {\n  .navbar-form .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .navbar-form .form-control-static {\n    display: inline-block;\n  }\n  .navbar-form .input-group {\n    display: inline-table;\n    vertical-align: middle;\n  }\n  .navbar-form .input-group .input-group-addon,\n  .navbar-form .input-group .input-group-btn,\n  .navbar-form .input-group .form-control {\n    width: auto;\n  }\n  .navbar-form .input-group > .form-control {\n    width: 100%;\n  }\n  .navbar-form .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .radio,\n  .navbar-form .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .radio label,\n  .navbar-form .checkbox label {\n    padding-left: 0;\n  }\n  .navbar-form .radio input[type=\"radio\"],\n  .navbar-form .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0;\n  }\n  .navbar-form .has-feedback .form-control-feedback {\n    top: 0;\n  }\n}\n@media (max-width: 767px) {\n  .navbar-form .form-group {\n    margin-bottom: 5px;\n  }\n  .navbar-form .form-group:last-child {\n    margin-bottom: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-form {\n    width: auto;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-right: 0;\n    margin-left: 0;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n}\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  margin-bottom: 0;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.navbar-btn {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.navbar-btn.btn-sm {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.navbar-btn.btn-xs {\n  margin-top: 14px;\n  margin-bottom: 14px;\n}\n.navbar-text {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n@media (min-width: 768px) {\n  .navbar-text {\n    float: left;\n    margin-right: 15px;\n    margin-left: 15px;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-left {\n    float: left !important;\n  }\n  .navbar-right {\n    float: right !important;\n    margin-right: -15px;\n  }\n  .navbar-right ~ .navbar-right {\n    margin-right: 0;\n  }\n}\n.navbar-default {\n  background-color: #f8f8f8;\n  border-color: #e7e7e7;\n}\n.navbar-default .navbar-brand {\n  color: #777;\n}\n.navbar-default .navbar-brand:hover,\n.navbar-default .navbar-brand:focus {\n  color: #5e5e5e;\n  background-color: transparent;\n}\n.navbar-default .navbar-text {\n  color: #777;\n}\n.navbar-default .navbar-nav > li > a {\n  color: #777;\n}\n.navbar-default .navbar-nav > li > a:hover,\n.navbar-default .navbar-nav > li > a:focus {\n  color: #333;\n  background-color: transparent;\n}\n.navbar-default .navbar-nav > .active > a,\n.navbar-default .navbar-nav > .active > a:hover,\n.navbar-default .navbar-nav > .active > a:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n.navbar-default .navbar-nav > .disabled > a,\n.navbar-default .navbar-nav > .disabled > a:hover,\n.navbar-default .navbar-nav > .disabled > a:focus {\n  color: #ccc;\n  background-color: transparent;\n}\n.navbar-default .navbar-toggle {\n  border-color: #ddd;\n}\n.navbar-default .navbar-toggle:hover,\n.navbar-default .navbar-toggle:focus {\n  background-color: #ddd;\n}\n.navbar-default .navbar-toggle .icon-bar {\n  background-color: #888;\n}\n.navbar-default .navbar-collapse,\n.navbar-default .navbar-form {\n  border-color: #e7e7e7;\n}\n.navbar-default .navbar-nav > .open > a,\n.navbar-default .navbar-nav > .open > a:hover,\n.navbar-default .navbar-nav > .open > a:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n@media (max-width: 767px) {\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a {\n    color: #777;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #333;\n    background-color: transparent;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #555;\n    background-color: #e7e7e7;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #ccc;\n    background-color: transparent;\n  }\n}\n.navbar-default .navbar-link {\n  color: #777;\n}\n.navbar-default .navbar-link:hover {\n  color: #333;\n}\n.navbar-default .btn-link {\n  color: #777;\n}\n.navbar-default .btn-link:hover,\n.navbar-default .btn-link:focus {\n  color: #333;\n}\n.navbar-default .btn-link[disabled]:hover,\nfieldset[disabled] .navbar-default .btn-link:hover,\n.navbar-default .btn-link[disabled]:focus,\nfieldset[disabled] .navbar-default .btn-link:focus {\n  color: #ccc;\n}\n.navbar-inverse {\n  background-color: #222;\n  border-color: #080808;\n}\n.navbar-inverse .navbar-brand {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-brand:hover,\n.navbar-inverse .navbar-brand:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-text {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav > li > a {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-nav > li > a:hover,\n.navbar-inverse .navbar-nav > li > a:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-nav > .active > a,\n.navbar-inverse .navbar-nav > .active > a:hover,\n.navbar-inverse .navbar-nav > .active > a:focus {\n  color: #fff;\n  background-color: #080808;\n}\n.navbar-inverse .navbar-nav > .disabled > a,\n.navbar-inverse .navbar-nav > .disabled > a:hover,\n.navbar-inverse .navbar-nav > .disabled > a:focus {\n  color: #444;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-toggle {\n  border-color: #333;\n}\n.navbar-inverse .navbar-toggle:hover,\n.navbar-inverse .navbar-toggle:focus {\n  background-color: #333;\n}\n.navbar-inverse .navbar-toggle .icon-bar {\n  background-color: #fff;\n}\n.navbar-inverse .navbar-collapse,\n.navbar-inverse .navbar-form {\n  border-color: #101010;\n}\n.navbar-inverse .navbar-nav > .open > a,\n.navbar-inverse .navbar-nav > .open > a:hover,\n.navbar-inverse .navbar-nav > .open > a:focus {\n  color: #fff;\n  background-color: #080808;\n}\n@media (max-width: 767px) {\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {\n    border-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu .divider {\n    background-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {\n    color: #9d9d9d;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #fff;\n    background-color: transparent;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #fff;\n    background-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #444;\n    background-color: transparent;\n  }\n}\n.navbar-inverse .navbar-link {\n  color: #9d9d9d;\n}\n.navbar-inverse .navbar-link:hover {\n  color: #fff;\n}\n.navbar-inverse .btn-link {\n  color: #9d9d9d;\n}\n.navbar-inverse .btn-link:hover,\n.navbar-inverse .btn-link:focus {\n  color: #fff;\n}\n.navbar-inverse .btn-link[disabled]:hover,\nfieldset[disabled] .navbar-inverse .btn-link:hover,\n.navbar-inverse .btn-link[disabled]:focus,\nfieldset[disabled] .navbar-inverse .btn-link:focus {\n  color: #444;\n}\n.breadcrumb {\n  padding: 8px 15px;\n  margin-bottom: 20px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n.breadcrumb > li {\n  display: inline-block;\n}\n.breadcrumb > li + li:before {\n  padding: 0 5px;\n  color: #ccc;\n  content: \"/\\A0\";\n}\n.breadcrumb > .active {\n  color: #777;\n}\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px;\n}\n.pagination > li {\n  display: inline;\n}\n.pagination > li > a,\n.pagination > li > span {\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  margin-left: -1px;\n  line-height: 1.42857143;\n  color: #337ab7;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.pagination > li:first-child > a,\n.pagination > li:first-child > span {\n  margin-left: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.pagination > li:last-child > a,\n.pagination > li:last-child > span {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.pagination > li > a:hover,\n.pagination > li > span:hover,\n.pagination > li > a:focus,\n.pagination > li > span:focus {\n  z-index: 2;\n  color: #23527c;\n  background-color: #eee;\n  border-color: #ddd;\n}\n.pagination > .active > a,\n.pagination > .active > span,\n.pagination > .active > a:hover,\n.pagination > .active > span:hover,\n.pagination > .active > a:focus,\n.pagination > .active > span:focus {\n  z-index: 3;\n  color: #fff;\n  cursor: default;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.pagination > .disabled > span,\n.pagination > .disabled > span:hover,\n.pagination > .disabled > span:focus,\n.pagination > .disabled > a,\n.pagination > .disabled > a:hover,\n.pagination > .disabled > a:focus {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #fff;\n  border-color: #ddd;\n}\n.pagination-lg > li > a,\n.pagination-lg > li > span {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.3333333;\n}\n.pagination-lg > li:first-child > a,\n.pagination-lg > li:first-child > span {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.pagination-lg > li:last-child > a,\n.pagination-lg > li:last-child > span {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.pagination-sm > li > a,\n.pagination-sm > li > span {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.pagination-sm > li:first-child > a,\n.pagination-sm > li:first-child > span {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.pagination-sm > li:last-child > a,\n.pagination-sm > li:last-child > span {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.pager {\n  padding-left: 0;\n  margin: 20px 0;\n  text-align: center;\n  list-style: none;\n}\n.pager li {\n  display: inline;\n}\n.pager li > a,\n.pager li > span {\n  display: inline-block;\n  padding: 5px 14px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n}\n.pager li > a:hover,\n.pager li > a:focus {\n  text-decoration: none;\n  background-color: #eee;\n}\n.pager .next > a,\n.pager .next > span {\n  float: right;\n}\n.pager .previous > a,\n.pager .previous > span {\n  float: left;\n}\n.pager .disabled > a,\n.pager .disabled > a:hover,\n.pager .disabled > a:focus,\n.pager .disabled > span {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #fff;\n}\n.label {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n}\na.label:hover,\na.label:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.label:empty {\n  display: none;\n}\n.btn .label {\n  position: relative;\n  top: -1px;\n}\n.label-default {\n  background-color: #777;\n}\n.label-default[href]:hover,\n.label-default[href]:focus {\n  background-color: #5e5e5e;\n}\n.label-primary {\n  background-color: #337ab7;\n}\n.label-primary[href]:hover,\n.label-primary[href]:focus {\n  background-color: #286090;\n}\n.label-success {\n  background-color: #5cb85c;\n}\n.label-success[href]:hover,\n.label-success[href]:focus {\n  background-color: #449d44;\n}\n.label-info {\n  background-color: #5bc0de;\n}\n.label-info[href]:hover,\n.label-info[href]:focus {\n  background-color: #31b0d5;\n}\n.label-warning {\n  background-color: #f0ad4e;\n}\n.label-warning[href]:hover,\n.label-warning[href]:focus {\n  background-color: #ec971f;\n}\n.label-danger {\n  background-color: #d9534f;\n}\n.label-danger[href]:hover,\n.label-danger[href]:focus {\n  background-color: #c9302c;\n}\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: #777;\n  border-radius: 10px;\n}\n.badge:empty {\n  display: none;\n}\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n.btn-xs .badge,\n.btn-group-xs > .btn .badge {\n  top: 0;\n  padding: 1px 5px;\n}\na.badge:hover,\na.badge:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.list-group-item.active > .badge,\n.nav-pills > .active > a > .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n.list-group-item > .badge {\n  float: right;\n}\n.list-group-item > .badge + .badge {\n  margin-right: 5px;\n}\n.nav-pills > li > a > .badge {\n  margin-left: 3px;\n}\n.jumbotron {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n  color: inherit;\n  background-color: #eee;\n}\n.jumbotron h1,\n.jumbotron .h1 {\n  color: inherit;\n}\n.jumbotron p {\n  margin-bottom: 15px;\n  font-size: 21px;\n  font-weight: 200;\n}\n.jumbotron > hr {\n  border-top-color: #d5d5d5;\n}\n.container .jumbotron,\n.container-fluid .jumbotron {\n  padding-right: 15px;\n  padding-left: 15px;\n  border-radius: 6px;\n}\n.jumbotron .container {\n  max-width: 100%;\n}\n@media screen and (min-width: 768px) {\n  .jumbotron {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n  .container .jumbotron,\n  .container-fluid .jumbotron {\n    padding-right: 60px;\n    padding-left: 60px;\n  }\n  .jumbotron h1,\n  .jumbotron .h1 {\n    font-size: 63px;\n  }\n}\n.thumbnail {\n  display: block;\n  padding: 4px;\n  margin-bottom: 20px;\n  line-height: 1.42857143;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: border .2s ease-in-out;\n       -o-transition: border .2s ease-in-out;\n          transition: border .2s ease-in-out;\n}\n.thumbnail > img,\n.thumbnail a > img {\n  margin-right: auto;\n  margin-left: auto;\n}\na.thumbnail:hover,\na.thumbnail:focus,\na.thumbnail.active {\n  border-color: #337ab7;\n}\n.thumbnail .caption {\n  padding: 9px;\n  color: #333;\n}\n.alert {\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.alert h4 {\n  margin-top: 0;\n  color: inherit;\n}\n.alert .alert-link {\n  font-weight: bold;\n}\n.alert > p,\n.alert > ul {\n  margin-bottom: 0;\n}\n.alert > p + p {\n  margin-top: 5px;\n}\n.alert-dismissable,\n.alert-dismissible {\n  padding-right: 35px;\n}\n.alert-dismissable .close,\n.alert-dismissible .close {\n  position: relative;\n  top: -2px;\n  right: -21px;\n  color: inherit;\n}\n.alert-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.alert-success hr {\n  border-top-color: #c9e2b3;\n}\n.alert-success .alert-link {\n  color: #2b542c;\n}\n.alert-info {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.alert-info hr {\n  border-top-color: #a6e1ec;\n}\n.alert-info .alert-link {\n  color: #245269;\n}\n.alert-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.alert-warning hr {\n  border-top-color: #f7e1b5;\n}\n.alert-warning .alert-link {\n  color: #66512c;\n}\n.alert-danger {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.alert-danger hr {\n  border-top-color: #e4b9c0;\n}\n.alert-danger .alert-link {\n  color: #843534;\n}\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@-o-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  height: 20px;\n  margin-bottom: 20px;\n  overflow: hidden;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n          box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\n}\n.progress-bar {\n  float: left;\n  width: 0;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #337ab7;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);\n          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);\n  -webkit-transition: width .6s ease;\n       -o-transition: width .6s ease;\n          transition: width .6s ease;\n}\n.progress-striped .progress-bar,\n.progress-bar-striped {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  -webkit-background-size: 40px 40px;\n          background-size: 40px 40px;\n}\n.progress.active .progress-bar,\n.progress-bar.active {\n  -webkit-animation: progress-bar-stripes 2s linear infinite;\n       -o-animation: progress-bar-stripes 2s linear infinite;\n          animation: progress-bar-stripes 2s linear infinite;\n}\n.progress-bar-success {\n  background-color: #5cb85c;\n}\n.progress-striped .progress-bar-success {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-info {\n  background-color: #5bc0de;\n}\n.progress-striped .progress-bar-info {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-warning {\n  background-color: #f0ad4e;\n}\n.progress-striped .progress-bar-warning {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.progress-bar-danger {\n  background-color: #d9534f;\n}\n.progress-striped .progress-bar-danger {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n  background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n}\n.media {\n  margin-top: 15px;\n}\n.media:first-child {\n  margin-top: 0;\n}\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1;\n}\n.media-body {\n  width: 10000px;\n}\n.media-object {\n  display: block;\n}\n.media-object.img-thumbnail {\n  max-width: none;\n}\n.media-right,\n.media > .pull-right {\n  padding-left: 10px;\n}\n.media-left,\n.media > .pull-left {\n  padding-right: 10px;\n}\n.media-left,\n.media-right,\n.media-body {\n  display: table-cell;\n  vertical-align: top;\n}\n.media-middle {\n  vertical-align: middle;\n}\n.media-bottom {\n  vertical-align: bottom;\n}\n.media-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n.list-group {\n  padding-left: 0;\n  margin-bottom: 20px;\n}\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.list-group-item:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\na.list-group-item,\nbutton.list-group-item {\n  color: #555;\n}\na.list-group-item .list-group-item-heading,\nbutton.list-group-item .list-group-item-heading {\n  color: #333;\n}\na.list-group-item:hover,\nbutton.list-group-item:hover,\na.list-group-item:focus,\nbutton.list-group-item:focus {\n  color: #555;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\nbutton.list-group-item {\n  width: 100%;\n  text-align: left;\n}\n.list-group-item.disabled,\n.list-group-item.disabled:hover,\n.list-group-item.disabled:focus {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #eee;\n}\n.list-group-item.disabled .list-group-item-heading,\n.list-group-item.disabled:hover .list-group-item-heading,\n.list-group-item.disabled:focus .list-group-item-heading {\n  color: inherit;\n}\n.list-group-item.disabled .list-group-item-text,\n.list-group-item.disabled:hover .list-group-item-text,\n.list-group-item.disabled:focus .list-group-item-text {\n  color: #777;\n}\n.list-group-item.active,\n.list-group-item.active:hover,\n.list-group-item.active:focus {\n  z-index: 2;\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.list-group-item.active .list-group-item-heading,\n.list-group-item.active:hover .list-group-item-heading,\n.list-group-item.active:focus .list-group-item-heading,\n.list-group-item.active .list-group-item-heading > small,\n.list-group-item.active:hover .list-group-item-heading > small,\n.list-group-item.active:focus .list-group-item-heading > small,\n.list-group-item.active .list-group-item-heading > .small,\n.list-group-item.active:hover .list-group-item-heading > .small,\n.list-group-item.active:focus .list-group-item-heading > .small {\n  color: inherit;\n}\n.list-group-item.active .list-group-item-text,\n.list-group-item.active:hover .list-group-item-text,\n.list-group-item.active:focus .list-group-item-text {\n  color: #c7ddef;\n}\n.list-group-item-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n}\na.list-group-item-success,\nbutton.list-group-item-success {\n  color: #3c763d;\n}\na.list-group-item-success .list-group-item-heading,\nbutton.list-group-item-success .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-success:hover,\nbutton.list-group-item-success:hover,\na.list-group-item-success:focus,\nbutton.list-group-item-success:focus {\n  color: #3c763d;\n  background-color: #d0e9c6;\n}\na.list-group-item-success.active,\nbutton.list-group-item-success.active,\na.list-group-item-success.active:hover,\nbutton.list-group-item-success.active:hover,\na.list-group-item-success.active:focus,\nbutton.list-group-item-success.active:focus {\n  color: #fff;\n  background-color: #3c763d;\n  border-color: #3c763d;\n}\n.list-group-item-info {\n  color: #31708f;\n  background-color: #d9edf7;\n}\na.list-group-item-info,\nbutton.list-group-item-info {\n  color: #31708f;\n}\na.list-group-item-info .list-group-item-heading,\nbutton.list-group-item-info .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-info:hover,\nbutton.list-group-item-info:hover,\na.list-group-item-info:focus,\nbutton.list-group-item-info:focus {\n  color: #31708f;\n  background-color: #c4e3f3;\n}\na.list-group-item-info.active,\nbutton.list-group-item-info.active,\na.list-group-item-info.active:hover,\nbutton.list-group-item-info.active:hover,\na.list-group-item-info.active:focus,\nbutton.list-group-item-info.active:focus {\n  color: #fff;\n  background-color: #31708f;\n  border-color: #31708f;\n}\n.list-group-item-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n}\na.list-group-item-warning,\nbutton.list-group-item-warning {\n  color: #8a6d3b;\n}\na.list-group-item-warning .list-group-item-heading,\nbutton.list-group-item-warning .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-warning:hover,\nbutton.list-group-item-warning:hover,\na.list-group-item-warning:focus,\nbutton.list-group-item-warning:focus {\n  color: #8a6d3b;\n  background-color: #faf2cc;\n}\na.list-group-item-warning.active,\nbutton.list-group-item-warning.active,\na.list-group-item-warning.active:hover,\nbutton.list-group-item-warning.active:hover,\na.list-group-item-warning.active:focus,\nbutton.list-group-item-warning.active:focus {\n  color: #fff;\n  background-color: #8a6d3b;\n  border-color: #8a6d3b;\n}\n.list-group-item-danger {\n  color: #a94442;\n  background-color: #f2dede;\n}\na.list-group-item-danger,\nbutton.list-group-item-danger {\n  color: #a94442;\n}\na.list-group-item-danger .list-group-item-heading,\nbutton.list-group-item-danger .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item-danger:hover,\nbutton.list-group-item-danger:hover,\na.list-group-item-danger:focus,\nbutton.list-group-item-danger:focus {\n  color: #a94442;\n  background-color: #ebcccc;\n}\na.list-group-item-danger.active,\nbutton.list-group-item-danger.active,\na.list-group-item-danger.active:hover,\nbutton.list-group-item-danger.active:hover,\na.list-group-item-danger.active:focus,\nbutton.list-group-item-danger.active:focus {\n  color: #fff;\n  background-color: #a94442;\n  border-color: #a94442;\n}\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n.panel {\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\n          box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\n}\n.panel-body {\n  padding: 15px;\n}\n.panel-heading {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel-heading > .dropdown .dropdown-toggle {\n  color: inherit;\n}\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: inherit;\n}\n.panel-title > a,\n.panel-title > small,\n.panel-title > .small,\n.panel-title > small > a,\n.panel-title > .small > a {\n  color: inherit;\n}\n.panel-footer {\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #ddd;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .list-group,\n.panel > .panel-collapse > .list-group {\n  margin-bottom: 0;\n}\n.panel > .list-group .list-group-item,\n.panel > .panel-collapse > .list-group .list-group-item {\n  border-width: 1px 0;\n  border-radius: 0;\n}\n.panel > .list-group:first-child .list-group-item:first-child,\n.panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {\n  border-top: 0;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel > .list-group:last-child .list-group-item:last-child,\n.panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {\n  border-bottom: 0;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .panel-heading + .panel-collapse > .list-group .list-group-item:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.panel-heading + .list-group .list-group-item:first-child {\n  border-top-width: 0;\n}\n.list-group + .panel-footer {\n  border-top-width: 0;\n}\n.panel > .table,\n.panel > .table-responsive > .table,\n.panel > .panel-collapse > .table {\n  margin-bottom: 0;\n}\n.panel > .table caption,\n.panel > .table-responsive > .table caption,\n.panel > .panel-collapse > .table caption {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.panel > .table:first-child,\n.panel > .table-responsive:first-child > .table:first-child {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child td:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n.panel > .table:first-child > thead:first-child > tr:first-child th:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {\n  border-top-left-radius: 3px;\n}\n.panel > .table:first-child > thead:first-child > tr:first-child td:last-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n.panel > .table:first-child > thead:first-child > tr:first-child th:last-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {\n  border-top-right-radius: 3px;\n}\n.panel > .table:last-child,\n.panel > .table-responsive:last-child > .table:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n.panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {\n  border-bottom-left-radius: 3px;\n}\n.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n.panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {\n  border-bottom-right-radius: 3px;\n}\n.panel > .panel-body + .table,\n.panel > .panel-body + .table-responsive,\n.panel > .table + .panel-body,\n.panel > .table-responsive + .panel-body {\n  border-top: 1px solid #ddd;\n}\n.panel > .table > tbody:first-child > tr:first-child th,\n.panel > .table > tbody:first-child > tr:first-child td {\n  border-top: 0;\n}\n.panel > .table-bordered,\n.panel > .table-responsive > .table-bordered {\n  border: 0;\n}\n.panel > .table-bordered > thead > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\n.panel > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-bordered > thead > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\n.panel > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-bordered > tfoot > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n  border-left: 0;\n}\n.panel > .table-bordered > thead > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\n.panel > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-bordered > thead > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\n.panel > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-bordered > tfoot > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n  border-right: 0;\n}\n.panel > .table-bordered > thead > tr:first-child > td,\n.panel > .table-responsive > .table-bordered > thead > tr:first-child > td,\n.panel > .table-bordered > tbody > tr:first-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,\n.panel > .table-bordered > thead > tr:first-child > th,\n.panel > .table-responsive > .table-bordered > thead > tr:first-child > th,\n.panel > .table-bordered > tbody > tr:first-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {\n  border-bottom: 0;\n}\n.panel > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-bordered > tfoot > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {\n  border-bottom: 0;\n}\n.panel > .table-responsive {\n  margin-bottom: 0;\n  border: 0;\n}\n.panel-group {\n  margin-bottom: 20px;\n}\n.panel-group .panel {\n  margin-bottom: 0;\n  border-radius: 4px;\n}\n.panel-group .panel + .panel {\n  margin-top: 5px;\n}\n.panel-group .panel-heading {\n  border-bottom: 0;\n}\n.panel-group .panel-heading + .panel-collapse > .panel-body,\n.panel-group .panel-heading + .panel-collapse > .list-group {\n  border-top: 1px solid #ddd;\n}\n.panel-group .panel-footer {\n  border-top: 0;\n}\n.panel-group .panel-footer + .panel-collapse .panel-body {\n  border-bottom: 1px solid #ddd;\n}\n.panel-default {\n  border-color: #ddd;\n}\n.panel-default > .panel-heading {\n  color: #333;\n  background-color: #f5f5f5;\n  border-color: #ddd;\n}\n.panel-default > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #ddd;\n}\n.panel-default > .panel-heading .badge {\n  color: #f5f5f5;\n  background-color: #333;\n}\n.panel-default > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #ddd;\n}\n.panel-primary {\n  border-color: #337ab7;\n}\n.panel-primary > .panel-heading {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n.panel-primary > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #337ab7;\n}\n.panel-primary > .panel-heading .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n.panel-primary > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #337ab7;\n}\n.panel-success {\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #d6e9c6;\n}\n.panel-success > .panel-heading .badge {\n  color: #dff0d8;\n  background-color: #3c763d;\n}\n.panel-success > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #d6e9c6;\n}\n.panel-info {\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #bce8f1;\n}\n.panel-info > .panel-heading .badge {\n  color: #d9edf7;\n  background-color: #31708f;\n}\n.panel-info > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #bce8f1;\n}\n.panel-warning {\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #faebcc;\n}\n.panel-warning > .panel-heading .badge {\n  color: #fcf8e3;\n  background-color: #8a6d3b;\n}\n.panel-warning > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #faebcc;\n}\n.panel-danger {\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #ebccd1;\n}\n.panel-danger > .panel-heading .badge {\n  color: #f2dede;\n  background-color: #a94442;\n}\n.panel-danger > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #ebccd1;\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n.embed-responsive-4by3 {\n  padding-bottom: 75%;\n}\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);\n}\n.well blockquote {\n  border-color: #ddd;\n  border-color: rgba(0, 0, 0, .15);\n}\n.well-lg {\n  padding: 24px;\n  border-radius: 6px;\n}\n.well-sm {\n  padding: 9px;\n  border-radius: 3px;\n}\n.close {\n  float: right;\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  filter: alpha(opacity=20);\n  opacity: .2;\n}\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\nbutton.close {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n}\n.modal-open {\n  overflow: hidden;\n}\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal.fade .modal-dialog {\n  -webkit-transition: -webkit-transform .3s ease-out;\n       -o-transition:      -o-transform .3s ease-out;\n          transition:         transform .3s ease-out;\n  -webkit-transform: translate(0, -25%);\n      -ms-transform: translate(0, -25%);\n       -o-transform: translate(0, -25%);\n          transform: translate(0, -25%);\n}\n.modal.in .modal-dialog {\n  -webkit-transform: translate(0, 0);\n      -ms-transform: translate(0, 0);\n       -o-transform: translate(0, 0);\n          transform: translate(0, 0);\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #999;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 6px;\n  outline: 0;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5);\n          box-shadow: 0 3px 9px rgba(0, 0, 0, .5);\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n.modal-backdrop.in {\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.modal-header .close {\n  margin-top: -2px;\n}\n.modal-title {\n  margin: 0;\n  line-height: 1.42857143;\n}\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n}\n.modal-footer .btn + .btn {\n  margin-bottom: 0;\n  margin-left: 5px;\n}\n.modal-footer .btn-group .btn + .btn {\n  margin-left: -1px;\n}\n.modal-footer .btn-block + .btn-block {\n  margin-left: 0;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n  }\n  .modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\n            box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\n  }\n  .modal-sm {\n    width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg {\n    width: 900px;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  filter: alpha(opacity=0);\n  opacity: 0;\n\n  line-break: auto;\n}\n.tooltip.in {\n  filter: alpha(opacity=90);\n  opacity: .9;\n}\n.tooltip.top {\n  padding: 5px 0;\n  margin-top: -3px;\n}\n.tooltip.right {\n  padding: 0 5px;\n  margin-left: 3px;\n}\n.tooltip.bottom {\n  padding: 5px 0;\n  margin-top: 3px;\n}\n.tooltip.left {\n  padding: 0 5px;\n  margin-left: -3px;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-left .tooltip-arrow {\n  right: 5px;\n  bottom: 0;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-right .tooltip-arrow {\n  bottom: 0;\n  left: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000;\n}\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-left .tooltip-arrow {\n  top: 0;\n  right: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-right .tooltip-arrow {\n  top: 0;\n  left: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  max-width: 276px;\n  padding: 1px;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n          background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\n          box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\n\n  line-break: auto;\n}\n.popover.top {\n  margin-top: -10px;\n}\n.popover.right {\n  margin-left: 10px;\n}\n.popover.bottom {\n  margin-top: 10px;\n}\n.popover.left {\n  margin-left: -10px;\n}\n.popover-title {\n  padding: 8px 14px;\n  margin: 0;\n  font-size: 14px;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 5px 5px 0 0;\n}\n.popover-content {\n  padding: 9px 14px;\n}\n.popover > .arrow,\n.popover > .arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.popover > .arrow {\n  border-width: 11px;\n}\n.popover > .arrow:after {\n  content: \"\";\n  border-width: 10px;\n}\n.popover.top > .arrow {\n  bottom: -11px;\n  left: 50%;\n  margin-left: -11px;\n  border-top-color: #999;\n  border-top-color: rgba(0, 0, 0, .25);\n  border-bottom-width: 0;\n}\n.popover.top > .arrow:after {\n  bottom: 1px;\n  margin-left: -10px;\n  content: \" \";\n  border-top-color: #fff;\n  border-bottom-width: 0;\n}\n.popover.right > .arrow {\n  top: 50%;\n  left: -11px;\n  margin-top: -11px;\n  border-right-color: #999;\n  border-right-color: rgba(0, 0, 0, .25);\n  border-left-width: 0;\n}\n.popover.right > .arrow:after {\n  bottom: -10px;\n  left: 1px;\n  content: \" \";\n  border-right-color: #fff;\n  border-left-width: 0;\n}\n.popover.bottom > .arrow {\n  top: -11px;\n  left: 50%;\n  margin-left: -11px;\n  border-top-width: 0;\n  border-bottom-color: #999;\n  border-bottom-color: rgba(0, 0, 0, .25);\n}\n.popover.bottom > .arrow:after {\n  top: 1px;\n  margin-left: -10px;\n  content: \" \";\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.popover.left > .arrow {\n  top: 50%;\n  right: -11px;\n  margin-top: -11px;\n  border-right-width: 0;\n  border-left-color: #999;\n  border-left-color: rgba(0, 0, 0, .25);\n}\n.popover.left > .arrow:after {\n  right: 1px;\n  bottom: -10px;\n  content: \" \";\n  border-right-width: 0;\n  border-left-color: #fff;\n}\n.carousel {\n  position: relative;\n}\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner > .item {\n  position: relative;\n  display: none;\n  -webkit-transition: .6s ease-in-out left;\n       -o-transition: .6s ease-in-out left;\n          transition: .6s ease-in-out left;\n}\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n  line-height: 1;\n}\n@media all and (transform-3d), (-webkit-transform-3d) {\n  .carousel-inner > .item {\n    -webkit-transition: -webkit-transform .6s ease-in-out;\n         -o-transition:      -o-transform .6s ease-in-out;\n            transition:         transform .6s ease-in-out;\n\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n    -webkit-perspective: 1000px;\n            perspective: 1000px;\n  }\n  .carousel-inner > .item.next,\n  .carousel-inner > .item.active.right {\n    left: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n            transform: translate3d(100%, 0, 0);\n  }\n  .carousel-inner > .item.prev,\n  .carousel-inner > .item.active.left {\n    left: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n            transform: translate3d(-100%, 0, 0);\n  }\n  .carousel-inner > .item.next.left,\n  .carousel-inner > .item.prev.right,\n  .carousel-inner > .item.active {\n    left: 0;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n.carousel-inner > .active,\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  display: block;\n}\n.carousel-inner > .active {\n  left: 0;\n}\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.carousel-inner > .next {\n  left: 100%;\n}\n.carousel-inner > .prev {\n  left: -100%;\n}\n.carousel-inner > .next.left,\n.carousel-inner > .prev.right {\n  left: 0;\n}\n.carousel-inner > .active.left {\n  left: -100%;\n}\n.carousel-inner > .active.right {\n  left: 100%;\n}\n.carousel-control {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 15%;\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, .6);\n  background-color: rgba(0, 0, 0, 0);\n  filter: alpha(opacity=50);\n  opacity: .5;\n}\n.carousel-control.left {\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  background-image:      -o-linear-gradient(left, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, .5)), to(rgba(0, 0, 0, .0001)));\n  background-image:         linear-gradient(to right, rgba(0, 0, 0, .5) 0%, rgba(0, 0, 0, .0001) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);\n  background-repeat: repeat-x;\n}\n.carousel-control.right {\n  right: 0;\n  left: auto;\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  background-image:      -o-linear-gradient(left, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, .0001)), to(rgba(0, 0, 0, .5)));\n  background-image:         linear-gradient(to right, rgba(0, 0, 0, .0001) 0%, rgba(0, 0, 0, .5) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);\n  background-repeat: repeat-x;\n}\n.carousel-control:hover,\n.carousel-control:focus {\n  color: #fff;\n  text-decoration: none;\n  filter: alpha(opacity=90);\n  outline: 0;\n  opacity: .9;\n}\n.carousel-control .icon-prev,\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-left,\n.carousel-control .glyphicon-chevron-right {\n  position: absolute;\n  top: 50%;\n  z-index: 5;\n  display: inline-block;\n  margin-top: -10px;\n}\n.carousel-control .icon-prev,\n.carousel-control .glyphicon-chevron-left {\n  left: 50%;\n  margin-left: -10px;\n}\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-right {\n  right: 50%;\n  margin-right: -10px;\n}\n.carousel-control .icon-prev,\n.carousel-control .icon-next {\n  width: 20px;\n  height: 20px;\n  font-family: serif;\n  line-height: 1;\n}\n.carousel-control .icon-prev:before {\n  content: '\\2039';\n}\n.carousel-control .icon-next:before {\n  content: '\\203A';\n}\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  padding-left: 0;\n  margin-left: -30%;\n  text-align: center;\n  list-style: none;\n}\n.carousel-indicators li {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 1px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #000 \\9;\n  background-color: rgba(0, 0, 0, 0);\n  border: 1px solid #fff;\n  border-radius: 10px;\n}\n.carousel-indicators .active {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  background-color: #fff;\n}\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, .6);\n}\n.carousel-caption .btn {\n  text-shadow: none;\n}\n@media screen and (min-width: 768px) {\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 30px;\n    height: 30px;\n    margin-top: -10px;\n    font-size: 30px;\n  }\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .icon-prev {\n    margin-left: -10px;\n  }\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-next {\n    margin-right: -10px;\n  }\n  .carousel-caption {\n    right: 20%;\n    left: 20%;\n    padding-bottom: 30px;\n  }\n  .carousel-indicators {\n    bottom: 20px;\n  }\n}\n.clearfix:before,\n.clearfix:after,\n.dl-horizontal dd:before,\n.dl-horizontal dd:after,\n.container:before,\n.container:after,\n.container-fluid:before,\n.container-fluid:after,\n.row:before,\n.row:after,\n.form-horizontal .form-group:before,\n.form-horizontal .form-group:after,\n.btn-toolbar:before,\n.btn-toolbar:after,\n.btn-group-vertical > .btn-group:before,\n.btn-group-vertical > .btn-group:after,\n.nav:before,\n.nav:after,\n.navbar:before,\n.navbar:after,\n.navbar-header:before,\n.navbar-header:after,\n.navbar-collapse:before,\n.navbar-collapse:after,\n.pager:before,\n.pager:after,\n.panel-body:before,\n.panel-body:after,\n.modal-header:before,\n.modal-header:after,\n.modal-footer:before,\n.modal-footer:after {\n  display: table;\n  content: \" \";\n}\n.clearfix:after,\n.dl-horizontal dd:after,\n.container:after,\n.container-fluid:after,\n.row:after,\n.form-horizontal .form-group:after,\n.btn-toolbar:after,\n.btn-group-vertical > .btn-group:after,\n.nav:after,\n.navbar:after,\n.navbar-header:after,\n.navbar-collapse:after,\n.pager:after,\n.panel-body:after,\n.modal-header:after,\n.modal-footer:after {\n  clear: both;\n}\n.center-block {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n.pull-right {\n  float: right !important;\n}\n.pull-left {\n  float: left !important;\n}\n.hide {\n  display: none !important;\n}\n.show {\n  display: block !important;\n}\n.invisible {\n  visibility: hidden;\n}\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.hidden {\n  display: none !important;\n}\n.affix {\n  position: fixed;\n}\n@-ms-viewport {\n  width: device-width;\n}\n.visible-xs,\n.visible-sm,\n.visible-md,\n.visible-lg {\n  display: none !important;\n}\n.visible-xs-block,\n.visible-xs-inline,\n.visible-xs-inline-block,\n.visible-sm-block,\n.visible-sm-inline,\n.visible-sm-inline-block,\n.visible-md-block,\n.visible-md-inline,\n.visible-md-inline-block,\n.visible-lg-block,\n.visible-lg-inline,\n.visible-lg-inline-block {\n  display: none !important;\n}\n@media (max-width: 767px) {\n  .visible-xs {\n    display: block !important;\n  }\n  table.visible-xs {\n    display: table !important;\n  }\n  tr.visible-xs {\n    display: table-row !important;\n  }\n  th.visible-xs,\n  td.visible-xs {\n    display: table-cell !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-block {\n    display: block !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-inline {\n    display: inline !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-xs-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm {\n    display: block !important;\n  }\n  table.visible-sm {\n    display: table !important;\n  }\n  tr.visible-sm {\n    display: table-row !important;\n  }\n  th.visible-sm,\n  td.visible-sm {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-block {\n    display: block !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md {\n    display: block !important;\n  }\n  table.visible-md {\n    display: table !important;\n  }\n  tr.visible-md {\n    display: table-row !important;\n  }\n  th.visible-md,\n  td.visible-md {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-block {\n    display: block !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg {\n    display: block !important;\n  }\n  table.visible-lg {\n    display: table !important;\n  }\n  tr.visible-lg {\n    display: table-row !important;\n  }\n  th.visible-lg,\n  td.visible-lg {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-block {\n    display: block !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-inline {\n    display: inline !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg-inline-block {\n    display: inline-block !important;\n  }\n}\n@media (max-width: 767px) {\n  .hidden-xs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-lg {\n    display: none !important;\n  }\n}\n.visible-print {\n  display: none !important;\n}\n@media print {\n  .visible-print {\n    display: block !important;\n  }\n  table.visible-print {\n    display: table !important;\n  }\n  tr.visible-print {\n    display: table-row !important;\n  }\n  th.visible-print,\n  td.visible-print {\n    display: table-cell !important;\n  }\n}\n.visible-print-block {\n  display: none !important;\n}\n@media print {\n  .visible-print-block {\n    display: block !important;\n  }\n}\n.visible-print-inline {\n  display: none !important;\n}\n@media print {\n  .visible-print-inline {\n    display: inline !important;\n  }\n}\n.visible-print-inline-block {\n  display: none !important;\n}\n@media print {\n  .visible-print-inline-block {\n    display: inline-block !important;\n  }\n}\n@media print {\n  .hidden-print {\n    display: none !important;\n  }\n}\n", ""]);

// exports


/***/ }),

/***/ "sJTC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";

/***/ }),

/***/ "tXU6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "thfS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uJDh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uPo7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/*!
 * Bootstrap v3.3.6 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under the MIT license
 */
if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");+function (a) {
  "use strict";
  var b = a.fn.jquery.split(" ")[0].split(".");if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1 || b[0] > 2) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3");
}(jQuery), +function (a) {
  "use strict";
  function b() {
    var a = document.createElement("bootstrap"),
        b = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" };for (var c in b) {
      if (void 0 !== a.style[c]) return { end: b[c] };
    }return !1;
  }a.fn.emulateTransitionEnd = function (b) {
    var c = !1,
        d = this;a(this).one("bsTransitionEnd", function () {
      c = !0;
    });var e = function e() {
      c || a(d).trigger(a.support.transition.end);
    };return setTimeout(e, b), this;
  }, a(function () {
    a.support.transition = b(), a.support.transition && (a.event.special.bsTransitionEnd = { bindType: a.support.transition.end, delegateType: a.support.transition.end, handle: function handle(b) {
        return a(b.target).is(this) ? b.handleObj.handler.apply(this, arguments) : void 0;
      } });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var c = a(this),
          e = c.data("bs.alert");e || c.data("bs.alert", e = new d(this)), "string" == typeof b && e[b].call(c);
    });
  }var c = '[data-dismiss="alert"]',
      d = function d(b) {
    a(b).on("click", c, this.close);
  };d.VERSION = "3.3.6", d.TRANSITION_DURATION = 150, d.prototype.close = function (b) {
    function c() {
      g.detach().trigger("closed.bs.alert").remove();
    }var e = a(this),
        f = e.attr("data-target");f || (f = e.attr("href"), f = f && f.replace(/.*(?=#[^\s]*$)/, ""));var g = a(f);b && b.preventDefault(), g.length || (g = e.closest(".alert")), g.trigger(b = a.Event("close.bs.alert")), b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c());
  };var e = a.fn.alert;a.fn.alert = b, a.fn.alert.Constructor = d, a.fn.alert.noConflict = function () {
    return a.fn.alert = e, this;
  }, a(document).on("click.bs.alert.data-api", c, d.prototype.close);
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.button"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;e || d.data("bs.button", e = new c(this, f)), "toggle" == b ? e.toggle() : b && e.setState(b);
    });
  }var c = function c(b, d) {
    this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, d), this.isLoading = !1;
  };c.VERSION = "3.3.6", c.DEFAULTS = { loadingText: "loading..." }, c.prototype.setState = function (b) {
    var c = "disabled",
        d = this.$element,
        e = d.is("input") ? "val" : "html",
        f = d.data();b += "Text", null == f.resetText && d.data("resetText", d[e]()), setTimeout(a.proxy(function () {
      d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? (this.isLoading = !0, d.addClass(c).attr(c, c)) : this.isLoading && (this.isLoading = !1, d.removeClass(c).removeAttr(c));
    }, this), 0);
  }, c.prototype.toggle = function () {
    var a = !0,
        b = this.$element.closest('[data-toggle="buttons"]');if (b.length) {
      var c = this.$element.find("input");"radio" == c.prop("type") ? (c.prop("checked") && (a = !1), b.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == c.prop("type") && (c.prop("checked") !== this.$element.hasClass("active") && (a = !1), this.$element.toggleClass("active")), c.prop("checked", this.$element.hasClass("active")), a && c.trigger("change");
    } else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active");
  };var d = a.fn.button;a.fn.button = b, a.fn.button.Constructor = c, a.fn.button.noConflict = function () {
    return a.fn.button = d, this;
  }, a(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function (c) {
    var d = a(c.target);d.hasClass("btn") || (d = d.closest(".btn")), b.call(d, "toggle"), a(c.target).is('input[type="radio"]') || a(c.target).is('input[type="checkbox"]') || c.preventDefault();
  }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function (b) {
    a(b.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(b.type));
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.carousel"),
          f = a.extend({}, c.DEFAULTS, d.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b),
          g = "string" == typeof b ? b : f.slide;e || d.data("bs.carousel", e = new c(this, f)), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle();
    });
  }var c = function c(b, _c) {
    this.$element = a(b), this.$indicators = this.$element.find(".carousel-indicators"), this.options = _c, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
  };c.VERSION = "3.3.6", c.TRANSITION_DURATION = 600, c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }, c.prototype.keydown = function (a) {
    if (!/input|textarea/i.test(a.target.tagName)) {
      switch (a.which) {case 37:
          this.prev();break;case 39:
          this.next();break;default:
          return;}a.preventDefault();
    }
  }, c.prototype.cycle = function (b) {
    return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this;
  }, c.prototype.getItemIndex = function (a) {
    return this.$items = a.parent().children(".item"), this.$items.index(a || this.$active);
  }, c.prototype.getItemForDirection = function (a, b) {
    var c = this.getItemIndex(b),
        d = "prev" == a && 0 === c || "next" == a && c == this.$items.length - 1;if (d && !this.options.wrap) return b;var e = "prev" == a ? -1 : 1,
        f = (c + e) % this.$items.length;return this.$items.eq(f);
  }, c.prototype.to = function (a) {
    var b = this,
        c = this.getItemIndex(this.$active = this.$element.find(".item.active"));return a > this.$items.length - 1 || 0 > a ? void 0 : this.sliding ? this.$element.one("slid.bs.carousel", function () {
      b.to(a);
    }) : c == a ? this.pause().cycle() : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
  }, c.prototype.pause = function (b) {
    return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this;
  }, c.prototype.next = function () {
    return this.sliding ? void 0 : this.slide("next");
  }, c.prototype.prev = function () {
    return this.sliding ? void 0 : this.slide("prev");
  }, c.prototype.slide = function (b, d) {
    var e = this.$element.find(".item.active"),
        f = d || this.getItemForDirection(b, e),
        g = this.interval,
        h = "next" == b ? "left" : "right",
        i = this;if (f.hasClass("active")) return this.sliding = !1;var j = f[0],
        k = a.Event("slide.bs.carousel", { relatedTarget: j, direction: h });if (this.$element.trigger(k), !k.isDefaultPrevented()) {
      if (this.sliding = !0, g && this.pause(), this.$indicators.length) {
        this.$indicators.find(".active").removeClass("active");var l = a(this.$indicators.children()[this.getItemIndex(f)]);l && l.addClass("active");
      }var m = a.Event("slid.bs.carousel", { relatedTarget: j, direction: h });return a.support.transition && this.$element.hasClass("slide") ? (f.addClass(b), f[0].offsetWidth, e.addClass(h), f.addClass(h), e.one("bsTransitionEnd", function () {
        f.removeClass([b, h].join(" ")).addClass("active"), e.removeClass(["active", h].join(" ")), i.sliding = !1, setTimeout(function () {
          i.$element.trigger(m);
        }, 0);
      }).emulateTransitionEnd(c.TRANSITION_DURATION)) : (e.removeClass("active"), f.addClass("active"), this.sliding = !1, this.$element.trigger(m)), g && this.cycle(), this;
    }
  };var d = a.fn.carousel;a.fn.carousel = b, a.fn.carousel.Constructor = c, a.fn.carousel.noConflict = function () {
    return a.fn.carousel = d, this;
  };var e = function e(c) {
    var d,
        e = a(this),
        f = a(e.attr("data-target") || (d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""));if (f.hasClass("carousel")) {
      var g = a.extend({}, f.data(), e.data()),
          h = e.attr("data-slide-to");h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault();
    }
  };a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), a(window).on("load", function () {
    a('[data-ride="carousel"]').each(function () {
      var c = a(this);b.call(c, c.data());
    });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    var c,
        d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");return a(d);
  }function c(b) {
    return this.each(function () {
      var c = a(this),
          e = c.data("bs.collapse"),
          f = a.extend({}, d.DEFAULTS, c.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b);!e && f.toggle && /show|hide/.test(b) && (f.toggle = !1), e || c.data("bs.collapse", e = new d(this, f)), "string" == typeof b && e[b]();
    });
  }var d = function d(b, c) {
    this.$element = a(b), this.options = a.extend({}, d.DEFAULTS, c), this.$trigger = a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle();
  };d.VERSION = "3.3.6", d.TRANSITION_DURATION = 350, d.DEFAULTS = { toggle: !0 }, d.prototype.dimension = function () {
    var a = this.$element.hasClass("width");return a ? "width" : "height";
  }, d.prototype.show = function () {
    if (!this.transitioning && !this.$element.hasClass("in")) {
      var b,
          e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");if (!(e && e.length && (b = e.data("bs.collapse"), b && b.transitioning))) {
        var f = a.Event("show.bs.collapse");if (this.$element.trigger(f), !f.isDefaultPrevented()) {
          e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));var g = this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;var h = function h() {
            this.$element.removeClass("collapsing").addClass("collapse in")[g](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse");
          };if (!a.support.transition) return h.call(this);var i = a.camelCase(["scroll", g].join("-"));this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i]);
        }
      }
    }
  }, d.prototype.hide = function () {
    if (!this.transitioning && this.$element.hasClass("in")) {
      var b = a.Event("hide.bs.collapse");if (this.$element.trigger(b), !b.isDefaultPrevented()) {
        var c = this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;var e = function e() {
          this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
        };return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this);
      }
    }
  }, d.prototype.toggle = function () {
    this[this.$element.hasClass("in") ? "hide" : "show"]();
  }, d.prototype.getParent = function () {
    return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function (c, d) {
      var e = a(d);this.addAriaAndCollapsedClass(b(e), e);
    }, this)).end();
  }, d.prototype.addAriaAndCollapsedClass = function (a, b) {
    var c = a.hasClass("in");a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c);
  };var e = a.fn.collapse;a.fn.collapse = c, a.fn.collapse.Constructor = d, a.fn.collapse.noConflict = function () {
    return a.fn.collapse = e, this;
  }, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function (d) {
    var e = a(this);e.attr("data-target") || d.preventDefault();var f = b(e),
        g = f.data("bs.collapse"),
        h = g ? "toggle" : e.data();c.call(f, h);
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    var c = b.attr("data-target");c || (c = b.attr("href"), c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, ""));var d = c && a(c);return d && d.length ? d : b.parent();
  }function c(c) {
    c && 3 === c.which || (a(e).remove(), a(f).each(function () {
      var d = a(this),
          e = b(d),
          f = { relatedTarget: this };e.hasClass("open") && (c && "click" == c.type && /input|textarea/i.test(c.target.tagName) && a.contains(e[0], c.target) || (e.trigger(c = a.Event("hide.bs.dropdown", f)), c.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger(a.Event("hidden.bs.dropdown", f)))));
    }));
  }function d(b) {
    return this.each(function () {
      var c = a(this),
          d = c.data("bs.dropdown");d || c.data("bs.dropdown", d = new g(this)), "string" == typeof b && d[b].call(c);
    });
  }var e = ".dropdown-backdrop",
      f = '[data-toggle="dropdown"]',
      g = function g(b) {
    a(b).on("click.bs.dropdown", this.toggle);
  };g.VERSION = "3.3.6", g.prototype.toggle = function (d) {
    var e = a(this);if (!e.is(".disabled, :disabled")) {
      var f = b(e),
          g = f.hasClass("open");if (c(), !g) {
        "ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click", c);var h = { relatedTarget: this };if (f.trigger(d = a.Event("show.bs.dropdown", h)), d.isDefaultPrevented()) return;e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
      }return !1;
    }
  }, g.prototype.keydown = function (c) {
    if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName)) {
      var d = a(this);if (c.preventDefault(), c.stopPropagation(), !d.is(".disabled, :disabled")) {
        var e = b(d),
            g = e.hasClass("open");if (!g && 27 != c.which || g && 27 == c.which) return 27 == c.which && e.find(f).trigger("focus"), d.trigger("click");var h = " li:not(.disabled):visible a",
            i = e.find(".dropdown-menu" + h);if (i.length) {
          var j = i.index(c.target);38 == c.which && j > 0 && j--, 40 == c.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus");
        }
      }
    }
  };var h = a.fn.dropdown;a.fn.dropdown = d, a.fn.dropdown.Constructor = g, a.fn.dropdown.noConflict = function () {
    return a.fn.dropdown = h, this;
  }, a(document).on("click.bs.dropdown.data-api", c).on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
    a.stopPropagation();
  }).on("click.bs.dropdown.data-api", f, g.prototype.toggle).on("keydown.bs.dropdown.data-api", f, g.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", g.prototype.keydown);
}(jQuery), +function (a) {
  "use strict";
  function b(b, d) {
    return this.each(function () {
      var e = a(this),
          f = e.data("bs.modal"),
          g = a.extend({}, c.DEFAULTS, e.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b);f || e.data("bs.modal", f = new c(this, g)), "string" == typeof b ? f[b](d) : g.show && f.show(d);
    });
  }var c = function c(b, _c2) {
    this.options = _c2, this.$body = a(document.body), this.$element = a(b), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function () {
      this.$element.trigger("loaded.bs.modal");
    }, this));
  };c.VERSION = "3.3.6", c.TRANSITION_DURATION = 300, c.BACKDROP_TRANSITION_DURATION = 150, c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }, c.prototype.toggle = function (a) {
    return this.isShown ? this.hide() : this.show(a);
  }, c.prototype.show = function (b) {
    var d = this,
        e = a.Event("show.bs.modal", { relatedTarget: b });this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function () {
      d.$element.one("mouseup.dismiss.bs.modal", function (b) {
        a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
      });
    }), this.backdrop(function () {
      var e = a.support.transition && d.$element.hasClass("fade");d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in"), d.enforceFocus();var f = a.Event("shown.bs.modal", { relatedTarget: b });e ? d.$dialog.one("bsTransitionEnd", function () {
        d.$element.trigger("focus").trigger(f);
      }).emulateTransitionEnd(c.TRANSITION_DURATION) : d.$element.trigger("focus").trigger(f);
    }));
  }, c.prototype.hide = function (b) {
    b && b.preventDefault(), b = a.Event("hide.bs.modal"), this.$element.trigger(b), this.isShown && !b.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal());
  }, c.prototype.enforceFocus = function () {
    a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function (a) {
      this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus");
    }, this));
  }, c.prototype.escape = function () {
    this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function (a) {
      27 == a.which && this.hide();
    }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
  }, c.prototype.resize = function () {
    this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal");
  }, c.prototype.hideModal = function () {
    var a = this;this.$element.hide(), this.backdrop(function () {
      a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal");
    });
  }, c.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove(), this.$backdrop = null;
  }, c.prototype.backdrop = function (b) {
    var d = this,
        e = this.$element.hasClass("fade") ? "fade" : "";if (this.isShown && this.options.backdrop) {
      var f = a.support.transition && e;if (this.$backdrop = a(document.createElement("div")).addClass("modal-backdrop " + e).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", a.proxy(function (a) {
        return this.ignoreBackdropClick ? void (this.ignoreBackdropClick = !1) : void (a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()));
      }, this)), f && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !b) return;f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b();
    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass("in");var g = function g() {
        d.removeBackdrop(), b && b();
      };a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g();
    } else b && b();
  }, c.prototype.handleUpdate = function () {
    this.adjustDialog();
  }, c.prototype.adjustDialog = function () {
    var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;this.$element.css({ paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "", paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "" });
  }, c.prototype.resetAdjustments = function () {
    this.$element.css({ paddingLeft: "", paddingRight: "" });
  }, c.prototype.checkScrollbar = function () {
    var a = window.innerWidth;if (!a) {
      var b = document.documentElement.getBoundingClientRect();a = b.right - Math.abs(b.left);
    }this.bodyIsOverflowing = document.body.clientWidth < a, this.scrollbarWidth = this.measureScrollbar();
  }, c.prototype.setScrollbar = function () {
    var a = parseInt(this.$body.css("padding-right") || 0, 10);this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth);
  }, c.prototype.resetScrollbar = function () {
    this.$body.css("padding-right", this.originalBodyPad);
  }, c.prototype.measureScrollbar = function () {
    var a = document.createElement("div");a.className = "modal-scrollbar-measure", this.$body.append(a);var b = a.offsetWidth - a.clientWidth;return this.$body[0].removeChild(a), b;
  };var d = a.fn.modal;a.fn.modal = b, a.fn.modal.Constructor = c, a.fn.modal.noConflict = function () {
    return a.fn.modal = d, this;
  }, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (c) {
    var d = a(this),
        e = d.attr("href"),
        f = a(d.attr("data-target") || e && e.replace(/.*(?=#[^\s]+$)/, "")),
        g = f.data("bs.modal") ? "toggle" : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());d.is("a") && c.preventDefault(), f.one("show.bs.modal", function (a) {
      a.isDefaultPrevented() || f.one("hidden.bs.modal", function () {
        d.is(":visible") && d.trigger("focus");
      });
    }), b.call(f, g, this);
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.tooltip"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;(e || !/destroy|hide/.test(b)) && (e || d.data("bs.tooltip", e = new c(this, f)), "string" == typeof b && e[b]());
    });
  }var c = function c(a, b) {
    this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", a, b);
  };c.VERSION = "3.3.6", c.TRANSITION_DURATION = 150, c.DEFAULTS = { animation: !0, placement: "top", selector: !1, template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', trigger: "hover focus", title: "", delay: 0, html: !1, container: !1, viewport: { selector: "body", padding: 0 } }, c.prototype.init = function (b, c, d) {
    if (this.enabled = !0, this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.$viewport = this.options.viewport && a(a.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = { click: !1, hover: !1, focus: !1 }, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");for (var e = this.options.trigger.split(" "), f = e.length; f--;) {
      var g = e[f];if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));else if ("manual" != g) {
        var h = "hover" == g ? "mouseenter" : "focusin",
            i = "hover" == g ? "mouseleave" : "focusout";this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this));
      }
    }this.options.selector ? this._options = a.extend({}, this.options, { trigger: "manual", selector: "" }) : this.fixTitle();
  }, c.prototype.getDefaults = function () {
    return c.DEFAULTS;
  }, c.prototype.getOptions = function (b) {
    return b = a.extend({}, this.getDefaults(), this.$element.data(), b), b.delay && "number" == typeof b.delay && (b.delay = { show: b.delay, hide: b.delay }), b;
  }, c.prototype.getDelegateOptions = function () {
    var b = {},
        c = this.getDefaults();return this._options && a.each(this._options, function (a, d) {
      c[a] != d && (b[a] = d);
    }), b;
  }, c.prototype.enter = function (b) {
    var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusin" == b.type ? "focus" : "hover"] = !0), c.tip().hasClass("in") || "in" == c.hoverState ? void (c.hoverState = "in") : (clearTimeout(c.timeout), c.hoverState = "in", c.options.delay && c.options.delay.show ? void (c.timeout = setTimeout(function () {
      "in" == c.hoverState && c.show();
    }, c.options.delay.show)) : c.show());
  }, c.prototype.isInStateTrue = function () {
    for (var a in this.inState) {
      if (this.inState[a]) return !0;
    }return !1;
  }, c.prototype.leave = function (b) {
    var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusout" == b.type ? "focus" : "hover"] = !1), c.isInStateTrue() ? void 0 : (clearTimeout(c.timeout), c.hoverState = "out", c.options.delay && c.options.delay.hide ? void (c.timeout = setTimeout(function () {
      "out" == c.hoverState && c.hide();
    }, c.options.delay.hide)) : c.hide());
  }, c.prototype.show = function () {
    var b = a.Event("show.bs." + this.type);if (this.hasContent() && this.enabled) {
      this.$element.trigger(b);var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);if (b.isDefaultPrevented() || !d) return;var e = this,
          f = this.tip(),
          g = this.getUID(this.type);this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
          i = /\s?auto?\s?/i,
          j = i.test(h);j && (h = h.replace(i, "") || "top"), f.detach().css({ top: 0, left: 0, display: "block" }).addClass(h).data("bs." + this.type, this), this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);var k = this.getPosition(),
          l = f[0].offsetWidth,
          m = f[0].offsetHeight;if (j) {
        var n = h,
            o = this.getPosition(this.$viewport);h = "bottom" == h && k.bottom + m > o.bottom ? "top" : "top" == h && k.top - m < o.top ? "bottom" : "right" == h && k.right + l > o.width ? "left" : "left" == h && k.left - l < o.left ? "right" : h, f.removeClass(n).addClass(h);
      }var p = this.getCalculatedOffset(h, k, l, m);this.applyPlacement(p, h);var q = function q() {
        var a = e.hoverState;e.$element.trigger("shown.bs." + e.type), e.hoverState = null, "out" == a && e.leave(e);
      };a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", q).emulateTransitionEnd(c.TRANSITION_DURATION) : q();
    }
  }, c.prototype.applyPlacement = function (b, c) {
    var d = this.tip(),
        e = d[0].offsetWidth,
        f = d[0].offsetHeight,
        g = parseInt(d.css("margin-top"), 10),
        h = parseInt(d.css("margin-left"), 10);isNaN(g) && (g = 0), isNaN(h) && (h = 0), b.top += g, b.left += h, a.offset.setOffset(d[0], a.extend({ using: function using(a) {
        d.css({ top: Math.round(a.top), left: Math.round(a.left) });
      } }, b), 0), d.addClass("in");var i = d[0].offsetWidth,
        j = d[0].offsetHeight;"top" == c && j != f && (b.top = b.top + f - j);var k = this.getViewportAdjustedDelta(c, b, i, j);k.left ? b.left += k.left : b.top += k.top;var l = /top|bottom/.test(c),
        m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
        n = l ? "offsetWidth" : "offsetHeight";d.offset(b), this.replaceArrow(m, d[0][n], l);
  }, c.prototype.replaceArrow = function (a, b, c) {
    this.arrow().css(c ? "left" : "top", 50 * (1 - a / b) + "%").css(c ? "top" : "left", "");
  }, c.prototype.setContent = function () {
    var a = this.tip(),
        b = this.getTitle();a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right");
  }, c.prototype.hide = function (b) {
    function d() {
      "in" != e.hoverState && f.detach(), e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b();
    }var e = this,
        f = a(this.$tip),
        g = a.Event("hide.bs." + this.type);return this.$element.trigger(g), g.isDefaultPrevented() ? void 0 : (f.removeClass("in"), a.support.transition && f.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), this.hoverState = null, this);
  }, c.prototype.fixTitle = function () {
    var a = this.$element;(a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "");
  }, c.prototype.hasContent = function () {
    return this.getTitle();
  }, c.prototype.getPosition = function (b) {
    b = b || this.$element;var c = b[0],
        d = "BODY" == c.tagName,
        e = c.getBoundingClientRect();null == e.width && (e = a.extend({}, e, { width: e.right - e.left, height: e.bottom - e.top }));var f = d ? { top: 0, left: 0 } : b.offset(),
        g = { scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop() },
        h = d ? { width: a(window).width(), height: a(window).height() } : null;return a.extend({}, e, g, h, f);
  }, c.prototype.getCalculatedOffset = function (a, b, c, d) {
    return "bottom" == a ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 } : "top" == a ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 } : "left" == a ? { top: b.top + b.height / 2 - d / 2, left: b.left - c } : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
  }, c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
    var e = { top: 0, left: 0 };if (!this.$viewport) return e;var f = this.options.viewport && this.options.viewport.padding || 0,
        g = this.getPosition(this.$viewport);if (/right|left/.test(a)) {
      var h = b.top - f - g.scroll,
          i = b.top + f - g.scroll + d;h < g.top ? e.top = g.top - h : i > g.top + g.height && (e.top = g.top + g.height - i);
    } else {
      var j = b.left - f,
          k = b.left + f + c;j < g.left ? e.left = g.left - j : k > g.right && (e.left = g.left + g.width - k);
    }return e;
  }, c.prototype.getTitle = function () {
    var a,
        b = this.$element,
        c = this.options;return a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title);
  }, c.prototype.getUID = function (a) {
    do {
      a += ~~(1e6 * Math.random());
    } while (document.getElementById(a));return a;
  }, c.prototype.tip = function () {
    if (!this.$tip && (this.$tip = a(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");return this.$tip;
  }, c.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
  }, c.prototype.enable = function () {
    this.enabled = !0;
  }, c.prototype.disable = function () {
    this.enabled = !1;
  }, c.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  }, c.prototype.toggle = function (b) {
    var c = this;b && (c = a(b.currentTarget).data("bs." + this.type), c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c))), b ? (c.inState.click = !c.inState.click, c.isInStateTrue() ? c.enter(c) : c.leave(c)) : c.tip().hasClass("in") ? c.leave(c) : c.enter(c);
  }, c.prototype.destroy = function () {
    var a = this;clearTimeout(this.timeout), this.hide(function () {
      a.$element.off("." + a.type).removeData("bs." + a.type), a.$tip && a.$tip.detach(), a.$tip = null, a.$arrow = null, a.$viewport = null;
    });
  };var d = a.fn.tooltip;a.fn.tooltip = b, a.fn.tooltip.Constructor = c, a.fn.tooltip.noConflict = function () {
    return a.fn.tooltip = d, this;
  };
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.popover"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;(e || !/destroy|hide/.test(b)) && (e || d.data("bs.popover", e = new c(this, f)), "string" == typeof b && e[b]());
    });
  }var c = function c(a, b) {
    this.init("popover", a, b);
  };if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");c.VERSION = "3.3.6", c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, { placement: "right", trigger: "click", content: "", template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>' }), c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype), c.prototype.constructor = c, c.prototype.getDefaults = function () {
    return c.DEFAULTS;
  }, c.prototype.setContent = function () {
    var a = this.tip(),
        b = this.getTitle(),
        c = this.getContent();a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof c ? "html" : "append" : "text"](c), a.removeClass("fade top bottom left right in"), a.find(".popover-title").html() || a.find(".popover-title").hide();
  }, c.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  }, c.prototype.getContent = function () {
    var a = this.$element,
        b = this.options;return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content);
  }, c.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".arrow");
  };var d = a.fn.popover;a.fn.popover = b, a.fn.popover.Constructor = c, a.fn.popover.noConflict = function () {
    return a.fn.popover = d, this;
  };
}(jQuery), +function (a) {
  "use strict";
  function b(c, d) {
    this.$body = a(document.body), this.$scrollElement = a(a(c).is(document.body) ? window : c), this.options = a.extend({}, b.DEFAULTS, d), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)), this.refresh(), this.process();
  }function c(c) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.scrollspy"),
          f = "object" == (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(c)) && c;e || d.data("bs.scrollspy", e = new b(this, f)), "string" == typeof c && e[c]();
    });
  }b.VERSION = "3.3.6", b.DEFAULTS = { offset: 10 }, b.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
  }, b.prototype.refresh = function () {
    var b = this,
        c = "offset",
        d = 0;this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), a.isWindow(this.$scrollElement[0]) || (c = "position", d = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function () {
      var b = a(this),
          e = b.data("target") || b.attr("href"),
          f = /^#./.test(e) && a(e);return f && f.length && f.is(":visible") && [[f[c]().top + d, e]] || null;
    }).sort(function (a, b) {
      return a[0] - b[0];
    }).each(function () {
      b.offsets.push(this[0]), b.targets.push(this[1]);
    });
  }, b.prototype.process = function () {
    var a,
        b = this.$scrollElement.scrollTop() + this.options.offset,
        c = this.getScrollHeight(),
        d = this.options.offset + c - this.$scrollElement.height(),
        e = this.offsets,
        f = this.targets,
        g = this.activeTarget;if (this.scrollHeight != c && this.refresh(), b >= d) return g != (a = f[f.length - 1]) && this.activate(a);if (g && b < e[0]) return this.activeTarget = null, this.clear();for (a = e.length; a--;) {
      g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a]);
    }
  }, b.prototype.activate = function (b) {
    this.activeTarget = b, this.clear();var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
        d = a(c).parents("li").addClass("active");
    d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy");
  }, b.prototype.clear = function () {
    a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
  };var d = a.fn.scrollspy;a.fn.scrollspy = c, a.fn.scrollspy.Constructor = b, a.fn.scrollspy.noConflict = function () {
    return a.fn.scrollspy = d, this;
  }, a(window).on("load.bs.scrollspy.data-api", function () {
    a('[data-spy="scroll"]').each(function () {
      var b = a(this);c.call(b, b.data());
    });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.tab");e || d.data("bs.tab", e = new c(this)), "string" == typeof b && e[b]();
    });
  }var c = function c(b) {
    this.element = a(b);
  };c.VERSION = "3.3.6", c.TRANSITION_DURATION = 150, c.prototype.show = function () {
    var b = this.element,
        c = b.closest("ul:not(.dropdown-menu)"),
        d = b.data("target");if (d || (d = b.attr("href"), d = d && d.replace(/.*(?=#[^\s]*$)/, "")), !b.parent("li").hasClass("active")) {
      var e = c.find(".active:last a"),
          f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
          g = a.Event("show.bs.tab", { relatedTarget: e[0] });if (e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented()) {
        var h = a(d);this.activate(b.closest("li"), c), this.activate(h, h.parent(), function () {
          e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }), b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
        });
      }
    }
  }, c.prototype.activate = function (b, d, e) {
    function f() {
      g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"), b.parent(".dropdown-menu").length && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), e && e();
    }var g = d.find("> .active"),
        h = e && a.support.transition && (g.length && g.hasClass("fade") || !!d.find("> .fade").length);g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in");
  };var d = a.fn.tab;a.fn.tab = b, a.fn.tab.Constructor = c, a.fn.tab.noConflict = function () {
    return a.fn.tab = d, this;
  };var e = function e(c) {
    c.preventDefault(), b.call(a(this), "show");
  };a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.affix"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;e || d.data("bs.affix", e = new c(this, f)), "string" == typeof b && e[b]();
    });
  }var c = function c(b, d) {
    this.options = a.extend({}, c.DEFAULTS, d), this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this)), this.$element = a(b), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition();
  };c.VERSION = "3.3.6", c.RESET = "affix affix-top affix-bottom", c.DEFAULTS = { offset: 0, target: window }, c.prototype.getState = function (a, b, c, d) {
    var e = this.$target.scrollTop(),
        f = this.$element.offset(),
        g = this.$target.height();if (null != c && "top" == this.affixed) return c > e ? "top" : !1;if ("bottom" == this.affixed) return null != c ? e + this.unpin <= f.top ? !1 : "bottom" : a - d >= e + g ? !1 : "bottom";var h = null == this.affixed,
        i = h ? e : f.top,
        j = h ? g : b;return null != c && c >= e ? "top" : null != d && i + j >= a - d ? "bottom" : !1;
  }, c.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a = this.$target.scrollTop(),
        b = this.$element.offset();return this.pinnedOffset = b.top - a;
  }, c.prototype.checkPositionWithEventLoop = function () {
    setTimeout(a.proxy(this.checkPosition, this), 1);
  }, c.prototype.checkPosition = function () {
    if (this.$element.is(":visible")) {
      var b = this.$element.height(),
          d = this.options.offset,
          e = d.top,
          f = d.bottom,
          g = Math.max(a(document).height(), a(document.body).height());"object" != (typeof d === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(d)) && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));var h = this.getState(g, b, e, f);if (this.affixed != h) {
        null != this.unpin && this.$element.css("top", "");var i = "affix" + (h ? "-" + h : ""),
            j = a.Event(i + ".bs.affix");if (this.$element.trigger(j), j.isDefaultPrevented()) return;this.affixed = h, this.unpin = "bottom" == h ? this.getPinnedOffset() : null, this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix", "affixed") + ".bs.affix");
      }"bottom" == h && this.$element.offset({ top: g - b - f });
    }
  };var d = a.fn.affix;a.fn.affix = b, a.fn.affix.Constructor = c, a.fn.affix.noConflict = function () {
    return a.fn.affix = d, this;
  }, a(window).on("load", function () {
    a('[data-spy="affix"]').each(function () {
      var c = a(this),
          d = c.data();d.offset = d.offset || {}, null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d);
    });
  });
}(jQuery);

/***/ }),

/***/ "uWE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v58/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v94h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vfw/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vjAb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT7mgLvov5vnkINAM3g8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0i5ZCE5Zyw5Yy66aaW6aG1LeavlOi1m+ivpuaDhe+8iOavlOi1m+mihOWRiu+8iS0tY29weS0zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTU0LjAwMDAwMCwgLTYzNy4wMDAwMDApIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDU3Ni4wMDAwMDApIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMC41Ij4KICAgICAgICAgICAgPGcgaWQ9IjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjAwMDAwMCwgNTcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0i6aaW5Y+RIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNiI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNDYuOTg3MjE3LDkuNzg4MzgwOTIgTDE0Ni45ODczMTcsOS43ODgzODA5NiBDMTQ2Ljk1NzM5MSw5Ljc4ODM4MDk2IDE0Ni45MDg4ODUsOS44NDg2ODg1NSAxNDYuOTA4ODg1LDkuOTQ2NjY0MDIgTDE0Ni45MDg4ODUsMTQuMDE3MzAzIEMxNDYuOTA4ODg1LDE0LjExNTM2MDkgMTQ2Ljk1NzM5LDE0LjE3NTY3NjQgMTQ2Ljk4NzMxNywxNC4xNzU2NzY0IEwxNDguMjQ5OTI3LDE0LjE3NTY3NjQgTDE0OC4yNDk5MjcsMTYuNTQ4MzY5IEMxNDguMjQ5OTI3LDE2LjkyNTM2MTMgMTQ3Ljk4ODg1NCwxNy4yNDk5MDk3IDE0Ny42MzY2OTgsMTcuMjQ5OTA5NyBMMTQxLjg0ODk4LDE3LjI0OTkwOTcgTDE0MS44NDg5OCwxNC44MzAwNTIyIEwxNDIuMDc2ODU3LDE0LjgwOTgwNzUgQzE0My4yMjA2MDMsMTQuNzA4MTk2NyAxNDQuMTM4MzQsMTMuNDg4NDE2OSAxNDQuMTM4MzQsMTIgQzE0NC4xMzgzNCwxMC41MTE2NTEzIDE0My4yMjA1MTQsOS4yOTE4MDY5NCAxNDIuMDc2ODU0LDkuMTkwMTkyMjkgTDE0MS44NDg5OCw5LjE2OTk0NTUzIEwxNDEuODQ4OTgsNi43NSBMMTQ3LjYzNjc3MSw2Ljc1IEMxNDcuOTg4ODU0LDYuNzUgMTQ4LjI1LDcuMDc0NjM4NyAxNDguMjUsNy40NTE1NDA2NiBMMTQ4LjI1LDkuNzg5Mzk0NDYgTDE0Ni45ODcyMTcsOS43ODgzODA5NiBaIE0xMzUuNzUsMTQuMTc1Njc2NCBMMTM3LjAxMjYxLDE0LjE3NTY3NjQgQzEzNy4wNDI1MzQsMTQuMTc1Njc2NCAxMzcuMDkxMTE1LDE0LjExNTI5NDMgMTM3LjA5MTExNSwxNC4wMTczMDMgTDEzNy4wOTExMTUsOS45NDY2NjQwMiBDMTM3LjA5MTExNSw5Ljg0ODc1NTE3IDEzNy4wNDI1MzMsOS43ODgzODA5NiAxMzcuMDEyNjEsOS43ODgzODA5NiBMMTM1Ljc1LDkuNzg4MzgwOTYgTDEzNS43NSw3LjQ1MTU0MDY2IEMxMzUuNzUsNy4wNzQ2MTMgMTM2LjAxMTA5LDYuNzUgMTM2LjM2MzIyOSw2Ljc1IEwxNDEuOTkzODg3LDYuNzUgTDE0MS45OTM4ODcsOS4xNjk5NDg5OCBMMTQxLjc2NjAwOSw5LjE5MDE5MjYyIEMxNDAuNjIyMTc1LDkuMjkxODA1NDQgMTM5LjcwNDQ1NCwxMC41MTE1MTEzIDEzOS43MDQ0NTQsMTIgQzEzOS43MDQ0NTQsMTMuNDg4MzYyNCAxNDAuNjIyMjkxLDE0LjcwODE5MzMgMTQxLjc2NjAxMSwxNC44MDk4MDc2IEwxNDEuOTkzODg3LDE0LjgzMDA1MzMgTDE0MS45OTM4ODcsMTcuMjUgTDEzNi4zNjMyMjksMTcuMjUgQzEzNi4wMTEwNzQsMTcuMjUgMTM1Ljc1LDE2LjkyNTQ1MTYgMTM1Ljc1LDE2LjU0ODQ1OTMgTDEzNS43NSwxNC4xNzU2NzY0IFogTTE0OC4yNDk5MjcsOS43Mjk3MTY3OSBMMTQ4LjI0OTkyNywxNC4yMzQ0MzA5IEwxNDcuMjMxNzcsMTQuMjM0NDMwOSBDMTQ2Ljk1OTg5OSwxNC4yMzQ0MzA5IDE0Ni43NjM4MzMsMTMuOTkwNjQgMTQ2Ljc2MzgzMywxMy43MTM1MDY1IEwxNDYuNzYzODMzLDEwLjI1MDY0MTIgQzE0Ni43NjM4MzMsOS45NzM0Mzk0MSAxNDYuOTU5ODg5LDkuNzI5NzE2NzkgMTQ3LjIzMTc3LDkuNzI5NzE2NzkgTDE0OC4yNDk5MjcsOS43Mjk3MTY3OSBaIE0xMzUuNzUsOS43Mjk3MTY3OSBMMTM2Ljc2ODIzLDkuNzI5NzE2NzkgQzEzNy4wNDAxMTEsOS43Mjk3MTY3OSAxMzcuMjM2MTY3LDkuOTczNDM5NDEgMTM3LjIzNjE2NywxMC4yNTA2NDEyIEwxMzcuMjM2MTY3LDEzLjcxMzUwNjUgQzEzNy4yMzYxNjcsMTMuOTkwNjQgMTM3LjA0MDEwMSwxNC4yMzQ0MzA5IDEzNi43NjgyMywxNC4yMzQ0MzA5IEwxMzUuNzUsMTQuMjM0NDMwOSBMMTM1Ljc1LDkuNzI5NzE2NzkgWiBNMTQxLjcxODExNywxNC44NjQ3MDY3IEMxNDAuNDkxMzU1LDE0LjczNzIxMTcgMTM5LjU1OTQ3NCwxMy40ODQ2NDcxIDEzOS41NTk0NzQsMTIgQzEzOS41NTk0NzQsMTAuNTE1NDYyMyAxNDAuNDkxNDExLDkuMjYyNzkyIDE0MS43MTgwNDEsOS4xMzUyOTM3IEwxNDEuOTkzODg3LDkuMTA2NjIxNyBMMTQxLjk5Mzg4Nyw5LjM4Mzk1NDA1IEwxNDEuOTkzOTYsMTQuNjE2MDQ1OSBMMTQxLjk5Mzk2LDE0Ljg5MzM3NDQgTDE0MS43MTgxMTcsMTQuODY0NzA2NyBaIE0xNDIuMTI0ODI0LDkuMTM1MjkzNTIgQzE0My4zNTE0OSw5LjI2Mjc4Njk2IDE0NC4yODMzMiwxMC41MTU0MTIxIDE0NC4yODMzMiwxMiBDMTQ0LjI4MzMyLDEzLjQ4NDYxNDUgMTQzLjM1MTQ2OCwxNC43MzcyMDY4IDE0Mi4xMjQ4MjYsMTQuODY0NzA2MyBMMTQxLjg0ODk4LDE0Ljg5MzM3ODMgTDE0MS44NDg5OCw5LjEwNjYyMzYzIEwxNDIuMTI0ODI0LDkuMTM1MjkzNTIgWiIgaWQ9IkZpbGwtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQyLjAwMDAwMCwgMTIuMDAwMDAwKSByb3RhdGUoOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTE0Mi4wMDAwMDAsIC0xMi4wMDAwMDApICI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "wKp8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/BIGJOHN.aa3a008.otf";

/***/ }),

/***/ "x8aS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";

/***/ }),

/***/ "xhby":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xiEX":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "xxCs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABlUlEQVRYhe2X0bWCMAyGHeGOwgZ2BDa5bmA3gA2um8gGsAFsABt898HkGE+LtBV9Mo9pkv9vEtJwOHwlUYAKaIAr0HOXXnQNUO0N+gOcgZl0mYHzHuA1MJrAE9ACzt5UMuPkbDL2I1CXgnsTqANchq8TH5W8bAAX43zKJW/inEycv1QnvfmSc+sn8ZzEAvBbxrVhvAkODECfSEIl3hPcul0bLintGjHRVssxrhlo6ruUgLkExF4b08cOtU7ujQS0FPPawZQarISA+OicqKyyFWX7AQIhlqmN+wABzXZnlUOQlvcRqMStt8rsQNZvQ4I5EeC9QGCIQj7KkEKgqAQlYkowWGVRExYSiDZh0WdYSCD6GWpa4nN6XwLhIJKD7FFcAK7pX2KH+hhd30hAm92vGWh6iregJ+D6HE/PjLIWkgzw7YXEGGsp5j1ICLiu9D7VyS6lvy+A26X0kuts1/JrTjbk1vbPyedRvweqCX80GuBI+GNylLPR2E+bNU8k4rnPiRRZim+9QaTiNko7Hl/CQXQtBQ/aP2aiD/sNs/LYAAAAAElFTkSuQmCC"

/***/ }),

/***/ "yGzZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ys0m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z/9y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zEvL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "zJQy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zQrT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "zn2l":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a308b851b6fe7a354db1.js